
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire612a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire612a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h1pc7", function(module, exports) {
"use strict";

var $aBTpJ = parcelRequire("aBTpJ");

var $3Q4g0 = parcelRequire("3Q4g0");

var $7r2jV = parcelRequire("7r2jV");

var $dPjqw = parcelRequire("dPjqw");

var $g5GGl = parcelRequire("g5GGl");
// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $c64612c1836128f9$var$RegExp = $aBTpJ.RegExp;
var $c64612c1836128f9$var$RegExpPrototype = $c64612c1836128f9$var$RegExp.prototype;
var $c64612c1836128f9$var$FORCED = $3Q4g0 && $g5GGl(function() {
    var INDICES_SUPPORT = true;
    try {
        $c64612c1836128f9$var$RegExp(".", "d");
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = "";
    var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: "s",
        global: "g",
        ignoreCase: "i",
        multiline: "m",
        sticky: "y"
    };
    if (INDICES_SUPPORT) pairs.hasIndices = "d";
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($c64612c1836128f9$var$RegExpPrototype, "flags").get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($c64612c1836128f9$var$FORCED) $7r2jV($c64612c1836128f9$var$RegExpPrototype, "flags", {
    configurable: true,
    get: $dPjqw
});

});
parcelRegister("aBTpJ", function(module, exports) {
"use strict";
var $01fe54008fd836fb$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$01fe54008fd836fb$var$check(typeof globalThis == "object" && globalThis) || $01fe54008fd836fb$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$01fe54008fd836fb$var$check(typeof self == "object" && self) || $01fe54008fd836fb$var$check(typeof $parcel$global == "object" && $parcel$global) || $01fe54008fd836fb$var$check(typeof module.exports == "object" && module.exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();

});

parcelRegister("3Q4g0", function(module, exports) {
"use strict";

var $g5GGl = parcelRequire("g5GGl");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$g5GGl(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});

});
parcelRegister("g5GGl", function(module, exports) {
"use strict";
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});


parcelRegister("7r2jV", function(module, exports) {
"use strict";

var $5F2kR = parcelRequire("5F2kR");

var $jMcDQ = parcelRequire("jMcDQ");
module.exports = function(target, name, descriptor) {
    if (descriptor.get) $5F2kR(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $5F2kR(descriptor.set, name, {
        setter: true
    });
    return $jMcDQ.f(target, name, descriptor);
};

});
parcelRegister("5F2kR", function(module, exports) {
"use strict";

var $7jouy = parcelRequire("7jouy");

var $g5GGl = parcelRequire("g5GGl");

var $7RG6r = parcelRequire("7RG6r");

var $9uICC = parcelRequire("9uICC");

var $3Q4g0 = parcelRequire("3Q4g0");

var $iS0c8 = parcelRequire("iS0c8");
var $41f297df44b2fdbd$require$CONFIGURABLE_FUNCTION_NAME = $iS0c8.CONFIGURABLE;

var $6E9Au = parcelRequire("6E9Au");

var $b09uL = parcelRequire("b09uL");
var $41f297df44b2fdbd$var$enforceInternalState = $b09uL.enforce;
var $41f297df44b2fdbd$var$getInternalState = $b09uL.get;
var $41f297df44b2fdbd$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $41f297df44b2fdbd$var$defineProperty = Object.defineProperty;
var $41f297df44b2fdbd$var$stringSlice = $7jouy("".slice);
var $41f297df44b2fdbd$var$replace = $7jouy("".replace);
var $41f297df44b2fdbd$var$join = $7jouy([].join);
var $41f297df44b2fdbd$var$CONFIGURABLE_LENGTH = $3Q4g0 && !$g5GGl(function() {
    return $41f297df44b2fdbd$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $41f297df44b2fdbd$var$TEMPLATE = String(String).split("String");
var $41f297df44b2fdbd$var$makeBuiltIn = module.exports = function(value, name, options) {
    if ($41f297df44b2fdbd$var$stringSlice($41f297df44b2fdbd$var$$String(name), 0, 7) === "Symbol(") name = "[" + $41f297df44b2fdbd$var$replace($41f297df44b2fdbd$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$9uICC(value, "name") || $41f297df44b2fdbd$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($3Q4g0) $41f297df44b2fdbd$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($41f297df44b2fdbd$var$CONFIGURABLE_LENGTH && options && $9uICC(options, "arity") && value.length !== options.arity) $41f297df44b2fdbd$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $9uICC(options, "constructor") && options.constructor) {
            if ($3Q4g0) $41f297df44b2fdbd$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $41f297df44b2fdbd$var$enforceInternalState(value);
    if (!$9uICC(state, "source")) state.source = $41f297df44b2fdbd$var$join($41f297df44b2fdbd$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $41f297df44b2fdbd$var$makeBuiltIn(function toString() {
    return $7RG6r(this) && $41f297df44b2fdbd$var$getInternalState(this).source || $6E9Au(this);
}, "toString");

});
parcelRegister("7jouy", function(module, exports) {
"use strict";

var $EFffH = parcelRequire("EFffH");
var $552d4e5168093a19$var$FunctionPrototype = Function.prototype;
var $552d4e5168093a19$var$call = $552d4e5168093a19$var$FunctionPrototype.call;
var $552d4e5168093a19$var$uncurryThisWithBind = $EFffH && $552d4e5168093a19$var$FunctionPrototype.bind.bind($552d4e5168093a19$var$call, $552d4e5168093a19$var$call);
module.exports = $EFffH ? $552d4e5168093a19$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $552d4e5168093a19$var$call.apply(fn, arguments);
    };
};

});
parcelRegister("EFffH", function(module, exports) {
"use strict";

var $g5GGl = parcelRequire("g5GGl");
module.exports = !$g5GGl(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});

});


parcelRegister("7RG6r", function(module, exports) {
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $5b9e24606338ade6$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof $5b9e24606338ade6$var$documentAll == "undefined" && $5b9e24606338ade6$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $5b9e24606338ade6$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};

});

parcelRegister("9uICC", function(module, exports) {
"use strict";

var $7jouy = parcelRequire("7jouy");

var $glgeP = parcelRequire("glgeP");
var $6e9987608a6a031b$var$hasOwnProperty = $7jouy({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $6e9987608a6a031b$var$hasOwnProperty($glgeP(it), key);
};

});
parcelRegister("glgeP", function(module, exports) {
"use strict";

var $3SCbw = parcelRequire("3SCbw");
var $be5b3411e65c1ad1$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $be5b3411e65c1ad1$var$$Object($3SCbw(argument));
};

});
parcelRegister("3SCbw", function(module, exports) {
"use strict";

var $7aBv2 = parcelRequire("7aBv2");
var $2d3408f4d7ffdc89$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if ($7aBv2(it)) throw new $2d3408f4d7ffdc89$var$$TypeError("Can't call method on " + it);
    return it;
};

});
parcelRegister("7aBv2", function(module, exports) {
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

});




parcelRegister("iS0c8", function(module, exports) {
"use strict";

var $3Q4g0 = parcelRequire("3Q4g0");

var $9uICC = parcelRequire("9uICC");
var $dbcd6bce0a7468f7$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $dbcd6bce0a7468f7$var$getDescriptor = $3Q4g0 && Object.getOwnPropertyDescriptor;
var $dbcd6bce0a7468f7$var$EXISTS = $9uICC($dbcd6bce0a7468f7$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $dbcd6bce0a7468f7$var$PROPER = $dbcd6bce0a7468f7$var$EXISTS && (function something() {}).name === "something";
var $dbcd6bce0a7468f7$var$CONFIGURABLE = $dbcd6bce0a7468f7$var$EXISTS && (!$3Q4g0 || $3Q4g0 && $dbcd6bce0a7468f7$var$getDescriptor($dbcd6bce0a7468f7$var$FunctionPrototype, "name").configurable);
module.exports = {
    EXISTS: $dbcd6bce0a7468f7$var$EXISTS,
    PROPER: $dbcd6bce0a7468f7$var$PROPER,
    CONFIGURABLE: $dbcd6bce0a7468f7$var$CONFIGURABLE
};

});

parcelRegister("6E9Au", function(module, exports) {
"use strict";

var $7jouy = parcelRequire("7jouy");

var $7RG6r = parcelRequire("7RG6r");

var $dP4il = parcelRequire("dP4il");
var $4d6dea600b6a00a1$var$functionToString = $7jouy(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$7RG6r($dP4il.inspectSource)) $dP4il.inspectSource = function(it) {
    return $4d6dea600b6a00a1$var$functionToString(it);
};
module.exports = $dP4il.inspectSource;

});
parcelRegister("dP4il", function(module, exports) {
"use strict";

var $aBTpJ = parcelRequire("aBTpJ");

var $1pEwV = parcelRequire("1pEwV");
var $a1035ea9db8186b2$var$SHARED = "__core-js_shared__";
var $a1035ea9db8186b2$var$store = $aBTpJ[$a1035ea9db8186b2$var$SHARED] || $1pEwV($a1035ea9db8186b2$var$SHARED, {});
module.exports = $a1035ea9db8186b2$var$store;

});
parcelRegister("1pEwV", function(module, exports) {
"use strict";

var $aBTpJ = parcelRequire("aBTpJ");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $107790a4bd2da425$var$defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        $107790a4bd2da425$var$defineProperty($aBTpJ, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $aBTpJ[key] = value;
    }
    return value;
};

});



parcelRegister("b09uL", function(module, exports) {
"use strict";

var $dUpZC = parcelRequire("dUpZC");

var $aBTpJ = parcelRequire("aBTpJ");

var $fEHsR = parcelRequire("fEHsR");

var $1jjE8 = parcelRequire("1jjE8");

var $9uICC = parcelRequire("9uICC");

var $dP4il = parcelRequire("dP4il");

var $6RtAp = parcelRequire("6RtAp");

var $iG3lT = parcelRequire("iG3lT");
var $80270f52a8b33072$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $80270f52a8b33072$var$TypeError = $aBTpJ.TypeError;
var $80270f52a8b33072$var$WeakMap = $aBTpJ.WeakMap;
var $80270f52a8b33072$var$set, $80270f52a8b33072$var$get, $80270f52a8b33072$var$has;
var $80270f52a8b33072$var$enforce = function(it) {
    return $80270f52a8b33072$var$has(it) ? $80270f52a8b33072$var$get(it) : $80270f52a8b33072$var$set(it, {});
};
var $80270f52a8b33072$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$fEHsR(it) || (state = $80270f52a8b33072$var$get(it)).type !== TYPE) throw new $80270f52a8b33072$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($dUpZC || $dP4il.state) {
    var $80270f52a8b33072$var$store = $dP4il.state || ($dP4il.state = new $80270f52a8b33072$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $80270f52a8b33072$var$store.get = $80270f52a8b33072$var$store.get;
    $80270f52a8b33072$var$store.has = $80270f52a8b33072$var$store.has;
    $80270f52a8b33072$var$store.set = $80270f52a8b33072$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $80270f52a8b33072$var$set = function(it, metadata) {
        if ($80270f52a8b33072$var$store.has(it)) throw new $80270f52a8b33072$var$TypeError($80270f52a8b33072$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $80270f52a8b33072$var$store.set(it, metadata);
        return metadata;
    };
    $80270f52a8b33072$var$get = function(it) {
        return $80270f52a8b33072$var$store.get(it) || {};
    };
    $80270f52a8b33072$var$has = function(it) {
        return $80270f52a8b33072$var$store.has(it);
    };
} else {
    var $80270f52a8b33072$var$STATE = $6RtAp("state");
    $iG3lT[$80270f52a8b33072$var$STATE] = true;
    $80270f52a8b33072$var$set = function(it, metadata) {
        if ($9uICC(it, $80270f52a8b33072$var$STATE)) throw new $80270f52a8b33072$var$TypeError($80270f52a8b33072$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $1jjE8(it, $80270f52a8b33072$var$STATE, metadata);
        return metadata;
    };
    $80270f52a8b33072$var$get = function(it) {
        return $9uICC(it, $80270f52a8b33072$var$STATE) ? it[$80270f52a8b33072$var$STATE] : {};
    };
    $80270f52a8b33072$var$has = function(it) {
        return $9uICC(it, $80270f52a8b33072$var$STATE);
    };
}
module.exports = {
    set: $80270f52a8b33072$var$set,
    get: $80270f52a8b33072$var$get,
    has: $80270f52a8b33072$var$has,
    enforce: $80270f52a8b33072$var$enforce,
    getterFor: $80270f52a8b33072$var$getterFor
};

});
parcelRegister("dUpZC", function(module, exports) {
"use strict";

var $aBTpJ = parcelRequire("aBTpJ");

var $7RG6r = parcelRequire("7RG6r");
var $a204aaf7e53d12e8$var$WeakMap = $aBTpJ.WeakMap;
module.exports = $7RG6r($a204aaf7e53d12e8$var$WeakMap) && /native code/.test(String($a204aaf7e53d12e8$var$WeakMap));

});

parcelRegister("fEHsR", function(module, exports) {
"use strict";

var $7RG6r = parcelRequire("7RG6r");
module.exports = function(it) {
    return typeof it == "object" ? it !== null : $7RG6r(it);
};

});

parcelRegister("1jjE8", function(module, exports) {
"use strict";

var $3Q4g0 = parcelRequire("3Q4g0");

var $jMcDQ = parcelRequire("jMcDQ");

var $fvjie = parcelRequire("fvjie");
module.exports = $3Q4g0 ? function(object, key, value) {
    return $jMcDQ.f(object, key, $fvjie(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("jMcDQ", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $e65c4e6744f77479$export$2d1720544b23b823; }, function (v) { return $e65c4e6744f77479$export$2d1720544b23b823 = v; });
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $e65c4e6744f77479$export$2d1720544b23b823;
"use strict";

var $3Q4g0 = parcelRequire("3Q4g0");

var $kdd3L = parcelRequire("kdd3L");

var $d54Ps = parcelRequire("d54Ps");

var $4wtgF = parcelRequire("4wtgF");

var $heolV = parcelRequire("heolV");
var $e65c4e6744f77479$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $e65c4e6744f77479$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $e65c4e6744f77479$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $e65c4e6744f77479$var$ENUMERABLE = "enumerable";
var $e65c4e6744f77479$var$CONFIGURABLE = "configurable";
var $e65c4e6744f77479$var$WRITABLE = "writable";
$e65c4e6744f77479$export$2d1720544b23b823 = $3Q4g0 ? $d54Ps ? function defineProperty(O, P, Attributes) {
    $4wtgF(O);
    P = $heolV(P);
    $4wtgF(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $e65c4e6744f77479$var$WRITABLE in Attributes && !Attributes[$e65c4e6744f77479$var$WRITABLE]) {
        var current = $e65c4e6744f77479$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$e65c4e6744f77479$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $e65c4e6744f77479$var$CONFIGURABLE in Attributes ? Attributes[$e65c4e6744f77479$var$CONFIGURABLE] : current[$e65c4e6744f77479$var$CONFIGURABLE],
                enumerable: $e65c4e6744f77479$var$ENUMERABLE in Attributes ? Attributes[$e65c4e6744f77479$var$ENUMERABLE] : current[$e65c4e6744f77479$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $e65c4e6744f77479$var$$defineProperty(O, P, Attributes);
} : $e65c4e6744f77479$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $4wtgF(O);
    P = $heolV(P);
    $4wtgF(Attributes);
    if ($kdd3L) try {
        return $e65c4e6744f77479$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $e65c4e6744f77479$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("kdd3L", function(module, exports) {
"use strict";

var $3Q4g0 = parcelRequire("3Q4g0");

var $g5GGl = parcelRequire("g5GGl");

var $TVgC9 = parcelRequire("TVgC9");
// Thanks to IE8 for its funny defineProperty
module.exports = !$3Q4g0 && !$g5GGl(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($TVgC9("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});

});
parcelRegister("TVgC9", function(module, exports) {
"use strict";

var $aBTpJ = parcelRequire("aBTpJ");

var $fEHsR = parcelRequire("fEHsR");
var $0a818f32808a39ac$var$document = $aBTpJ.document;
// typeof document.createElement is 'object' in old IE
var $0a818f32808a39ac$var$EXISTS = $fEHsR($0a818f32808a39ac$var$document) && $fEHsR($0a818f32808a39ac$var$document.createElement);
module.exports = function(it) {
    return $0a818f32808a39ac$var$EXISTS ? $0a818f32808a39ac$var$document.createElement(it) : {};
};

});


parcelRegister("d54Ps", function(module, exports) {
"use strict";

var $3Q4g0 = parcelRequire("3Q4g0");

var $g5GGl = parcelRequire("g5GGl");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = $3Q4g0 && $g5GGl(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});

});

parcelRegister("4wtgF", function(module, exports) {
"use strict";

var $fEHsR = parcelRequire("fEHsR");
var $34b0da8dbf83d03a$var$$String = String;
var $34b0da8dbf83d03a$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($fEHsR(argument)) return argument;
    throw new $34b0da8dbf83d03a$var$$TypeError($34b0da8dbf83d03a$var$$String(argument) + " is not an object");
};

});

parcelRegister("heolV", function(module, exports) {
"use strict";

var $dtzj4 = parcelRequire("dtzj4");

var $7SPrU = parcelRequire("7SPrU");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $dtzj4(argument, "string");
    return $7SPrU(key) ? key : key + "";
};

});
parcelRegister("dtzj4", function(module, exports) {
"use strict";

var $e3SjX = parcelRequire("e3SjX");

var $fEHsR = parcelRequire("fEHsR");

var $7SPrU = parcelRequire("7SPrU");

var $9yeVW = parcelRequire("9yeVW");

var $gFjiA = parcelRequire("gFjiA");

var $9wHgE = parcelRequire("9wHgE");
var $9cf95ef534c722bb$var$$TypeError = TypeError;
var $9cf95ef534c722bb$var$TO_PRIMITIVE = $9wHgE("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$fEHsR(input) || $7SPrU(input)) return input;
    var exoticToPrim = $9yeVW(input, $9cf95ef534c722bb$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $e3SjX(exoticToPrim, input, pref);
        if (!$fEHsR(result) || $7SPrU(result)) return result;
        throw new $9cf95ef534c722bb$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $gFjiA(input, pref);
};

});
parcelRegister("e3SjX", function(module, exports) {
"use strict";

var $EFffH = parcelRequire("EFffH");
var $a3cb7b80b3d3b473$var$call = Function.prototype.call;
module.exports = $EFffH ? $a3cb7b80b3d3b473$var$call.bind($a3cb7b80b3d3b473$var$call) : function() {
    return $a3cb7b80b3d3b473$var$call.apply($a3cb7b80b3d3b473$var$call, arguments);
};

});

parcelRegister("7SPrU", function(module, exports) {
"use strict";

var $iU5AL = parcelRequire("iU5AL");

var $7RG6r = parcelRequire("7RG6r");

var $gEMJd = parcelRequire("gEMJd");

var $47MW2 = parcelRequire("47MW2");
var $5bd57c40ef5aea12$var$$Object = Object;
module.exports = $47MW2 ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $iU5AL("Symbol");
    return $7RG6r($Symbol) && $gEMJd($Symbol.prototype, $5bd57c40ef5aea12$var$$Object(it));
};

});
parcelRegister("iU5AL", function(module, exports) {
"use strict";

var $aBTpJ = parcelRequire("aBTpJ");

var $7RG6r = parcelRequire("7RG6r");
var $dc31cb6223960193$var$aFunction = function(argument) {
    return $7RG6r(argument) ? argument : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $dc31cb6223960193$var$aFunction($aBTpJ[namespace]) : $aBTpJ[namespace] && $aBTpJ[namespace][method];
};

});

parcelRegister("gEMJd", function(module, exports) {
"use strict";

var $7jouy = parcelRequire("7jouy");
module.exports = $7jouy({}.isPrototypeOf);

});

parcelRegister("47MW2", function(module, exports) {
"use strict";

var $kDl1O = parcelRequire("kDl1O");
module.exports = $kDl1O && !Symbol.sham && typeof Symbol.iterator == "symbol";

});
parcelRegister("kDl1O", function(module, exports) {
"use strict";

var $g3i0I = parcelRequire("g3i0I");

var $g5GGl = parcelRequire("g5GGl");

var $aBTpJ = parcelRequire("aBTpJ");
var $f057c2e9ea973862$var$$String = $aBTpJ.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$g5GGl(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$f057c2e9ea973862$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $g3i0I && $g3i0I < 41;
});

});
parcelRegister("g3i0I", function(module, exports) {
"use strict";

var $aBTpJ = parcelRequire("aBTpJ");

var $9kLUR = parcelRequire("9kLUR");
var $bafae5b0b8883074$var$process = $aBTpJ.process;
var $bafae5b0b8883074$var$Deno = $aBTpJ.Deno;
var $bafae5b0b8883074$var$versions = $bafae5b0b8883074$var$process && $bafae5b0b8883074$var$process.versions || $bafae5b0b8883074$var$Deno && $bafae5b0b8883074$var$Deno.version;
var $bafae5b0b8883074$var$v8 = $bafae5b0b8883074$var$versions && $bafae5b0b8883074$var$versions.v8;
var $bafae5b0b8883074$var$match, $bafae5b0b8883074$var$version;
if ($bafae5b0b8883074$var$v8) {
    $bafae5b0b8883074$var$match = $bafae5b0b8883074$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $bafae5b0b8883074$var$version = $bafae5b0b8883074$var$match[0] > 0 && $bafae5b0b8883074$var$match[0] < 4 ? 1 : +($bafae5b0b8883074$var$match[0] + $bafae5b0b8883074$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$bafae5b0b8883074$var$version && $9kLUR) {
    $bafae5b0b8883074$var$match = $9kLUR.match(/Edge\/(\d+)/);
    if (!$bafae5b0b8883074$var$match || $bafae5b0b8883074$var$match[1] >= 74) {
        $bafae5b0b8883074$var$match = $9kLUR.match(/Chrome\/(\d+)/);
        if ($bafae5b0b8883074$var$match) $bafae5b0b8883074$var$version = +$bafae5b0b8883074$var$match[1];
    }
}
module.exports = $bafae5b0b8883074$var$version;

});
parcelRegister("9kLUR", function(module, exports) {
"use strict";
module.exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";

});





parcelRegister("9yeVW", function(module, exports) {
"use strict";

var $6Xexh = parcelRequire("6Xexh");

var $7aBv2 = parcelRequire("7aBv2");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return $7aBv2(func) ? undefined : $6Xexh(func);
};

});
parcelRegister("6Xexh", function(module, exports) {
"use strict";

var $7RG6r = parcelRequire("7RG6r");

var $7b7PZ = parcelRequire("7b7PZ");
var $5103874af7c75a03$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($7RG6r(argument)) return argument;
    throw new $5103874af7c75a03$var$$TypeError($7b7PZ(argument) + " is not a function");
};

});
parcelRegister("7b7PZ", function(module, exports) {
"use strict";
var $539fa3d8170e1d12$var$$String = String;
module.exports = function(argument) {
    try {
        return $539fa3d8170e1d12$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};

});



parcelRegister("gFjiA", function(module, exports) {
"use strict";

var $e3SjX = parcelRequire("e3SjX");

var $7RG6r = parcelRequire("7RG6r");

var $fEHsR = parcelRequire("fEHsR");
var $c21f71fdfa2ba2a8$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $7RG6r(fn = input.toString) && !$fEHsR(val = $e3SjX(fn, input))) return val;
    if ($7RG6r(fn = input.valueOf) && !$fEHsR(val = $e3SjX(fn, input))) return val;
    if (pref !== "string" && $7RG6r(fn = input.toString) && !$fEHsR(val = $e3SjX(fn, input))) return val;
    throw new $c21f71fdfa2ba2a8$var$$TypeError("Can't convert object to primitive value");
};

});

parcelRegister("9wHgE", function(module, exports) {
"use strict";

var $aBTpJ = parcelRequire("aBTpJ");

var $91Vz2 = parcelRequire("91Vz2");

var $9uICC = parcelRequire("9uICC");

var $bOyPm = parcelRequire("bOyPm");

var $kDl1O = parcelRequire("kDl1O");

var $47MW2 = parcelRequire("47MW2");
var $6ef8aa3af0e6a9a4$var$Symbol = $aBTpJ.Symbol;
var $6ef8aa3af0e6a9a4$var$WellKnownSymbolsStore = $91Vz2("wks");
var $6ef8aa3af0e6a9a4$var$createWellKnownSymbol = $47MW2 ? $6ef8aa3af0e6a9a4$var$Symbol["for"] || $6ef8aa3af0e6a9a4$var$Symbol : $6ef8aa3af0e6a9a4$var$Symbol && $6ef8aa3af0e6a9a4$var$Symbol.withoutSetter || $bOyPm;
module.exports = function(name) {
    if (!$9uICC($6ef8aa3af0e6a9a4$var$WellKnownSymbolsStore, name)) $6ef8aa3af0e6a9a4$var$WellKnownSymbolsStore[name] = $kDl1O && $9uICC($6ef8aa3af0e6a9a4$var$Symbol, name) ? $6ef8aa3af0e6a9a4$var$Symbol[name] : $6ef8aa3af0e6a9a4$var$createWellKnownSymbol("Symbol." + name);
    return $6ef8aa3af0e6a9a4$var$WellKnownSymbolsStore[name];
};

});
parcelRegister("91Vz2", function(module, exports) {
"use strict";

var $QE07s = parcelRequire("QE07s");

var $dP4il = parcelRequire("dP4il");
(module.exports = function(key, value) {
    return $dP4il[key] || ($dP4il[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.35.0",
    mode: $QE07s ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.35.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});

});
parcelRegister("QE07s", function(module, exports) {
"use strict";
module.exports = false;

});


parcelRegister("bOyPm", function(module, exports) {
"use strict";

var $7jouy = parcelRequire("7jouy");
var $899f61353041c8b6$var$id = 0;
var $899f61353041c8b6$var$postfix = Math.random();
var $899f61353041c8b6$var$toString = $7jouy(1.0.toString);
module.exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $899f61353041c8b6$var$toString(++$899f61353041c8b6$var$id + $899f61353041c8b6$var$postfix, 36);
};

});





parcelRegister("fvjie", function(module, exports) {
"use strict";
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("6RtAp", function(module, exports) {
"use strict";

var $91Vz2 = parcelRequire("91Vz2");

var $bOyPm = parcelRequire("bOyPm");
var $4feea48bc45d487a$var$keys = $91Vz2("keys");
module.exports = function(key) {
    return $4feea48bc45d487a$var$keys[key] || ($4feea48bc45d487a$var$keys[key] = $bOyPm(key));
};

});

parcelRegister("iG3lT", function(module, exports) {
"use strict";
module.exports = {};

});




parcelRegister("dPjqw", function(module, exports) {
"use strict";

var $4wtgF = parcelRequire("4wtgF");
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function() {
    var that = $4wtgF(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};

});


parcelRegister("jclte", function(module, exports) {
"use strict";
parcelRequire("k9Jik");
parcelRequire("llTZz");

});
parcelRegister("k9Jik", function(module, exports) {
"use strict";

var $lT4Pa = parcelRequire("lT4Pa");

var $aBTpJ = parcelRequire("aBTpJ");

var $aTVRU = parcelRequire("aTVRU");
var $eac7c8809c954c01$require$clearImmediate = $aTVRU.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$lT4Pa({
    global: true,
    bind: true,
    enumerable: true,
    forced: $aBTpJ.clearImmediate !== $eac7c8809c954c01$require$clearImmediate
}, {
    clearImmediate: $eac7c8809c954c01$require$clearImmediate
});

});
parcelRegister("lT4Pa", function(module, exports) {
"use strict";

var $aBTpJ = parcelRequire("aBTpJ");

var $bu6zr = parcelRequire("bu6zr");
var $fef27a038a0265b7$require$getOwnPropertyDescriptor = $bu6zr.f;

var $1jjE8 = parcelRequire("1jjE8");

var $hXUI0 = parcelRequire("hXUI0");

var $1pEwV = parcelRequire("1pEwV");

var $52F1z = parcelRequire("52F1z");

var $eQHyL = parcelRequire("eQHyL");
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $aBTpJ;
    else if (STATIC) target = $aBTpJ[TARGET] || $1pEwV(TARGET, {});
    else target = ($aBTpJ[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $fef27a038a0265b7$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $eQHyL(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $52F1z(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $1jjE8(sourceProperty, "sham", true);
        $hXUI0(target, key, sourceProperty, options);
    }
};

});
parcelRegister("bu6zr", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $85c797d506de5d38$export$2d1720544b23b823; }, function (v) { return $85c797d506de5d38$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $85c797d506de5d38$export$2d1720544b23b823;
"use strict";

var $3Q4g0 = parcelRequire("3Q4g0");

var $e3SjX = parcelRequire("e3SjX");

var $cVGW1 = parcelRequire("cVGW1");

var $fvjie = parcelRequire("fvjie");

var $dScX3 = parcelRequire("dScX3");

var $heolV = parcelRequire("heolV");

var $9uICC = parcelRequire("9uICC");

var $kdd3L = parcelRequire("kdd3L");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $85c797d506de5d38$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$85c797d506de5d38$export$2d1720544b23b823 = $3Q4g0 ? $85c797d506de5d38$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $dScX3(O);
    P = $heolV(P);
    if ($kdd3L) try {
        return $85c797d506de5d38$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($9uICC(O, P)) return $fvjie(!$e3SjX($cVGW1.f, O, P), O[P]);
};

});
parcelRegister("cVGW1", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $969c1cdf7c77ff6c$export$2d1720544b23b823; }, function (v) { return $969c1cdf7c77ff6c$export$2d1720544b23b823 = v; });
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $969c1cdf7c77ff6c$export$2d1720544b23b823;
"use strict";
var $969c1cdf7c77ff6c$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $969c1cdf7c77ff6c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $969c1cdf7c77ff6c$var$NASHORN_BUG = $969c1cdf7c77ff6c$var$getOwnPropertyDescriptor && !$969c1cdf7c77ff6c$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$969c1cdf7c77ff6c$export$2d1720544b23b823 = $969c1cdf7c77ff6c$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $969c1cdf7c77ff6c$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $969c1cdf7c77ff6c$var$$propertyIsEnumerable;

});

parcelRegister("dScX3", function(module, exports) {
"use strict";

var $4jPzQ = parcelRequire("4jPzQ");

var $3SCbw = parcelRequire("3SCbw");
module.exports = function(it) {
    return $4jPzQ($3SCbw(it));
};

});
parcelRegister("4jPzQ", function(module, exports) {
"use strict";

var $7jouy = parcelRequire("7jouy");

var $g5GGl = parcelRequire("g5GGl");

var $kyNYM = parcelRequire("kyNYM");
var $3250f1ed9db2d24d$var$$Object = Object;
var $3250f1ed9db2d24d$var$split = $7jouy("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $g5GGl(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$3250f1ed9db2d24d$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $kyNYM(it) === "String" ? $3250f1ed9db2d24d$var$split(it, "") : $3250f1ed9db2d24d$var$$Object(it);
} : $3250f1ed9db2d24d$var$$Object;

});
parcelRegister("kyNYM", function(module, exports) {
"use strict";

var $7jouy = parcelRequire("7jouy");
var $ef7dc0780e71afbd$var$toString = $7jouy({}.toString);
var $ef7dc0780e71afbd$var$stringSlice = $7jouy("".slice);
module.exports = function(it) {
    return $ef7dc0780e71afbd$var$stringSlice($ef7dc0780e71afbd$var$toString(it), 8, -1);
};

});




parcelRegister("hXUI0", function(module, exports) {
"use strict";

var $7RG6r = parcelRequire("7RG6r");

var $jMcDQ = parcelRequire("jMcDQ");

var $5F2kR = parcelRequire("5F2kR");

var $1pEwV = parcelRequire("1pEwV");
module.exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($7RG6r(value)) $5F2kR(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $1pEwV(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $jMcDQ.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};

});

parcelRegister("52F1z", function(module, exports) {
"use strict";

var $9uICC = parcelRequire("9uICC");

var $hnzaU = parcelRequire("hnzaU");

var $bu6zr = parcelRequire("bu6zr");

var $jMcDQ = parcelRequire("jMcDQ");
module.exports = function(target, source, exceptions) {
    var keys = $hnzaU(source);
    var defineProperty = $jMcDQ.f;
    var getOwnPropertyDescriptor = $bu6zr.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$9uICC(target, key) && !(exceptions && $9uICC(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRegister("hnzaU", function(module, exports) {
"use strict";

var $iU5AL = parcelRequire("iU5AL");

var $7jouy = parcelRequire("7jouy");

var $jE3TG = parcelRequire("jE3TG");

var $8OyRG = parcelRequire("8OyRG");

var $4wtgF = parcelRequire("4wtgF");
var $ca6fdea701c52e63$var$concat = $7jouy([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = $iU5AL("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $jE3TG.f($4wtgF(it));
    var getOwnPropertySymbols = $8OyRG.f;
    return getOwnPropertySymbols ? $ca6fdea701c52e63$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};

});
parcelRegister("jE3TG", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $e4d4c6a0d88179a1$export$2d1720544b23b823; }, function (v) { return $e4d4c6a0d88179a1$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $e4d4c6a0d88179a1$export$2d1720544b23b823;
"use strict";

var $koR9d = parcelRequire("koR9d");

var $6HqNJ = parcelRequire("6HqNJ");
var $e4d4c6a0d88179a1$var$hiddenKeys = $6HqNJ.concat("length", "prototype");
$e4d4c6a0d88179a1$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $koR9d(O, $e4d4c6a0d88179a1$var$hiddenKeys);
};

});
parcelRegister("koR9d", function(module, exports) {
"use strict";

var $7jouy = parcelRequire("7jouy");

var $9uICC = parcelRequire("9uICC");

var $dScX3 = parcelRequire("dScX3");

var $7KQSF = parcelRequire("7KQSF");
var $ed9f46907adc2552$require$indexOf = $7KQSF.indexOf;

var $iG3lT = parcelRequire("iG3lT");
var $ed9f46907adc2552$var$push = $7jouy([].push);
module.exports = function(object, names) {
    var O = $dScX3(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$9uICC($iG3lT, key) && $9uICC(O, key) && $ed9f46907adc2552$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($9uICC(O, key = names[i++])) ~$ed9f46907adc2552$require$indexOf(result, key) || $ed9f46907adc2552$var$push(result, key);
    return result;
};

});
parcelRegister("7KQSF", function(module, exports) {
"use strict";

var $dScX3 = parcelRequire("dScX3");

var $92DWs = parcelRequire("92DWs");

var $8Ke8d = parcelRequire("8Ke8d");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $5a55d946d4b173ee$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $dScX3($this);
        var length = $8Ke8d(O);
        var index = $92DWs(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $5a55d946d4b173ee$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $5a55d946d4b173ee$var$createMethod(false)
};

});
parcelRegister("92DWs", function(module, exports) {
"use strict";

var $kE6hz = parcelRequire("kE6hz");
var $69534895c0f6df6e$var$max = Math.max;
var $69534895c0f6df6e$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $kE6hz(index);
    return integer < 0 ? $69534895c0f6df6e$var$max(integer + length, 0) : $69534895c0f6df6e$var$min(integer, length);
};

});
parcelRegister("kE6hz", function(module, exports) {
"use strict";

var $9wAoV = parcelRequire("9wAoV");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $9wAoV(number);
};

});
parcelRegister("9wAoV", function(module, exports) {
"use strict";
var $6ef356b4819c055f$var$ceil = Math.ceil;
var $6ef356b4819c055f$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $6ef356b4819c055f$var$floor : $6ef356b4819c055f$var$ceil)(n);
};

});



parcelRegister("8Ke8d", function(module, exports) {
"use strict";

var $aSFrr = parcelRequire("aSFrr");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $aSFrr(obj.length);
};

});
parcelRegister("aSFrr", function(module, exports) {
"use strict";

var $kE6hz = parcelRequire("kE6hz");
var $7ebf17faeecb99f6$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    return argument > 0 ? $7ebf17faeecb99f6$var$min($kE6hz(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});




parcelRegister("6HqNJ", function(module, exports) {
"use strict";
// IE8- don't enum bug keys
module.exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];

});


parcelRegister("8OyRG", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $66ae09addbf07920$export$2d1720544b23b823; }, function (v) { return $66ae09addbf07920$export$2d1720544b23b823 = v; });
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $66ae09addbf07920$export$2d1720544b23b823;
"use strict";
$66ae09addbf07920$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});



parcelRegister("eQHyL", function(module, exports) {
"use strict";

var $g5GGl = parcelRequire("g5GGl");

var $7RG6r = parcelRequire("7RG6r");
var $acf7b616f4f0af4f$var$replacement = /#|\.prototype\./;
var $acf7b616f4f0af4f$var$isForced = function(feature, detection) {
    var value = $acf7b616f4f0af4f$var$data[$acf7b616f4f0af4f$var$normalize(feature)];
    return value === $acf7b616f4f0af4f$var$POLYFILL ? true : value === $acf7b616f4f0af4f$var$NATIVE ? false : $7RG6r(detection) ? $g5GGl(detection) : !!detection;
};
var $acf7b616f4f0af4f$var$normalize = $acf7b616f4f0af4f$var$isForced.normalize = function(string) {
    return String(string).replace($acf7b616f4f0af4f$var$replacement, ".").toLowerCase();
};
var $acf7b616f4f0af4f$var$data = $acf7b616f4f0af4f$var$isForced.data = {};
var $acf7b616f4f0af4f$var$NATIVE = $acf7b616f4f0af4f$var$isForced.NATIVE = "N";
var $acf7b616f4f0af4f$var$POLYFILL = $acf7b616f4f0af4f$var$isForced.POLYFILL = "P";
module.exports = $acf7b616f4f0af4f$var$isForced;

});


parcelRegister("aTVRU", function(module, exports) {
"use strict";

var $aBTpJ = parcelRequire("aBTpJ");

var $1j1T5 = parcelRequire("1j1T5");

var $dcrXM = parcelRequire("dcrXM");

var $7RG6r = parcelRequire("7RG6r");

var $9uICC = parcelRequire("9uICC");

var $g5GGl = parcelRequire("g5GGl");

var $auDKy = parcelRequire("auDKy");

var $fg6A2 = parcelRequire("fg6A2");

var $TVgC9 = parcelRequire("TVgC9");

var $9TYtg = parcelRequire("9TYtg");

var $05ERq = parcelRequire("05ERq");

var $im1ko = parcelRequire("im1ko");
var $7efbede49188373b$var$set = $aBTpJ.setImmediate;
var $7efbede49188373b$var$clear = $aBTpJ.clearImmediate;
var $7efbede49188373b$var$process = $aBTpJ.process;
var $7efbede49188373b$var$Dispatch = $aBTpJ.Dispatch;
var $7efbede49188373b$var$Function = $aBTpJ.Function;
var $7efbede49188373b$var$MessageChannel = $aBTpJ.MessageChannel;
var $7efbede49188373b$var$String = $aBTpJ.String;
var $7efbede49188373b$var$counter = 0;
var $7efbede49188373b$var$queue = {};
var $7efbede49188373b$var$ONREADYSTATECHANGE = "onreadystatechange";
var $7efbede49188373b$var$$location, $7efbede49188373b$var$defer, $7efbede49188373b$var$channel, $7efbede49188373b$var$port;
$g5GGl(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $7efbede49188373b$var$$location = $aBTpJ.location;
});
var $7efbede49188373b$var$run = function(id) {
    if ($9uICC($7efbede49188373b$var$queue, id)) {
        var fn = $7efbede49188373b$var$queue[id];
        delete $7efbede49188373b$var$queue[id];
        fn();
    }
};
var $7efbede49188373b$var$runner = function(id) {
    return function() {
        $7efbede49188373b$var$run(id);
    };
};
var $7efbede49188373b$var$eventListener = function(event) {
    $7efbede49188373b$var$run(event.data);
};
var $7efbede49188373b$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $aBTpJ.postMessage($7efbede49188373b$var$String(id), $7efbede49188373b$var$$location.protocol + "//" + $7efbede49188373b$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$7efbede49188373b$var$set || !$7efbede49188373b$var$clear) {
    $7efbede49188373b$var$set = function setImmediate(handler) {
        $9TYtg(arguments.length, 1);
        var fn = $7RG6r(handler) ? handler : $7efbede49188373b$var$Function(handler);
        var args = $fg6A2(arguments, 1);
        $7efbede49188373b$var$queue[++$7efbede49188373b$var$counter] = function() {
            $1j1T5(fn, undefined, args);
        };
        $7efbede49188373b$var$defer($7efbede49188373b$var$counter);
        return $7efbede49188373b$var$counter;
    };
    $7efbede49188373b$var$clear = function clearImmediate(id) {
        delete $7efbede49188373b$var$queue[id];
    };
    // Node.js 0.8-
    if ($im1ko) $7efbede49188373b$var$defer = function(id) {
        $7efbede49188373b$var$process.nextTick($7efbede49188373b$var$runner(id));
    };
    else if ($7efbede49188373b$var$Dispatch && $7efbede49188373b$var$Dispatch.now) $7efbede49188373b$var$defer = function(id) {
        $7efbede49188373b$var$Dispatch.now($7efbede49188373b$var$runner(id));
    };
    else if ($7efbede49188373b$var$MessageChannel && !$05ERq) {
        $7efbede49188373b$var$channel = new $7efbede49188373b$var$MessageChannel();
        $7efbede49188373b$var$port = $7efbede49188373b$var$channel.port2;
        $7efbede49188373b$var$channel.port1.onmessage = $7efbede49188373b$var$eventListener;
        $7efbede49188373b$var$defer = $dcrXM($7efbede49188373b$var$port.postMessage, $7efbede49188373b$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($aBTpJ.addEventListener && $7RG6r($aBTpJ.postMessage) && !$aBTpJ.importScripts && $7efbede49188373b$var$$location && $7efbede49188373b$var$$location.protocol !== "file:" && !$g5GGl($7efbede49188373b$var$globalPostMessageDefer)) {
        $7efbede49188373b$var$defer = $7efbede49188373b$var$globalPostMessageDefer;
        $aBTpJ.addEventListener("message", $7efbede49188373b$var$eventListener, false);
    // IE8-
    } else if ($7efbede49188373b$var$ONREADYSTATECHANGE in $TVgC9("script")) $7efbede49188373b$var$defer = function(id) {
        $auDKy.appendChild($TVgC9("script"))[$7efbede49188373b$var$ONREADYSTATECHANGE] = function() {
            $auDKy.removeChild(this);
            $7efbede49188373b$var$run(id);
        };
    };
    else $7efbede49188373b$var$defer = function(id) {
        setTimeout($7efbede49188373b$var$runner(id), 0);
    };
}
module.exports = {
    set: $7efbede49188373b$var$set,
    clear: $7efbede49188373b$var$clear
};

});
parcelRegister("1j1T5", function(module, exports) {
"use strict";

var $EFffH = parcelRequire("EFffH");
var $0f39079cdb6dbc3b$var$FunctionPrototype = Function.prototype;
var $0f39079cdb6dbc3b$var$apply = $0f39079cdb6dbc3b$var$FunctionPrototype.apply;
var $0f39079cdb6dbc3b$var$call = $0f39079cdb6dbc3b$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == "object" && Reflect.apply || ($EFffH ? $0f39079cdb6dbc3b$var$call.bind($0f39079cdb6dbc3b$var$apply) : function() {
    return $0f39079cdb6dbc3b$var$call.apply($0f39079cdb6dbc3b$var$apply, arguments);
});

});

parcelRegister("dcrXM", function(module, exports) {
"use strict";

var $i8e3n = parcelRequire("i8e3n");

var $6Xexh = parcelRequire("6Xexh");

var $EFffH = parcelRequire("EFffH");
var $99c2164269b3fe2e$var$bind = $i8e3n($i8e3n.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    $6Xexh(fn);
    return that === undefined ? fn : $EFffH ? $99c2164269b3fe2e$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("i8e3n", function(module, exports) {
"use strict";

var $kyNYM = parcelRequire("kyNYM");

var $7jouy = parcelRequire("7jouy");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($kyNYM(fn) === "Function") return $7jouy(fn);
};

});


parcelRegister("auDKy", function(module, exports) {
"use strict";

var $iU5AL = parcelRequire("iU5AL");
module.exports = $iU5AL("document", "documentElement");

});

parcelRegister("fg6A2", function(module, exports) {
"use strict";

var $7jouy = parcelRequire("7jouy");
module.exports = $7jouy([].slice);

});

parcelRegister("9TYtg", function(module, exports) {
"use strict";
var $7358285da5bc2196$var$$TypeError = TypeError;
module.exports = function(passed, required) {
    if (passed < required) throw new $7358285da5bc2196$var$$TypeError("Not enough arguments");
    return passed;
};

});

parcelRegister("05ERq", function(module, exports) {
"use strict";

var $9kLUR = parcelRequire("9kLUR");
// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($9kLUR);

});

parcelRegister("im1ko", function(module, exports) {
"use strict";

var $aBTpJ = parcelRequire("aBTpJ");

var $kyNYM = parcelRequire("kyNYM");
module.exports = $kyNYM($aBTpJ.process) === "process";

});



parcelRegister("llTZz", function(module, exports) {
"use strict";

var $lT4Pa = parcelRequire("lT4Pa");

var $aBTpJ = parcelRequire("aBTpJ");

var $aTVRU = parcelRequire("aTVRU");
var $f8b6fdfdc014d832$require$setTask = $aTVRU.set;

var $3UxIX = parcelRequire("3UxIX");
// https://github.com/oven-sh/bun/issues/1633
var $f8b6fdfdc014d832$var$setImmediate = $aBTpJ.setImmediate ? $3UxIX($f8b6fdfdc014d832$require$setTask, false) : $f8b6fdfdc014d832$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$lT4Pa({
    global: true,
    bind: true,
    enumerable: true,
    forced: $aBTpJ.setImmediate !== $f8b6fdfdc014d832$var$setImmediate
}, {
    setImmediate: $f8b6fdfdc014d832$var$setImmediate
});

});
parcelRegister("3UxIX", function(module, exports) {
"use strict";

var $aBTpJ = parcelRequire("aBTpJ");

var $1j1T5 = parcelRequire("1j1T5");

var $7RG6r = parcelRequire("7RG6r");

var $bvwD4 = parcelRequire("bvwD4");

var $9kLUR = parcelRequire("9kLUR");

var $fg6A2 = parcelRequire("fg6A2");

var $9TYtg = parcelRequire("9TYtg");
var $2d90c2fe23c0379b$var$Function = $aBTpJ.Function;
// dirty IE9- and Bun 0.3.0- checks
var $2d90c2fe23c0379b$var$WRAP = /MSIE .\./.test($9kLUR) || $bvwD4 && function() {
    var version = $aBTpJ.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $2d90c2fe23c0379b$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $9TYtg(arguments.length, 1) > firstParamIndex;
        var fn = $7RG6r(handler) ? handler : $2d90c2fe23c0379b$var$Function(handler);
        var params = boundArgs ? $fg6A2(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $1j1T5(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};

});
parcelRegister("bvwD4", function(module, exports) {
"use strict";
/* global Bun -- Bun case */ module.exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";

});




parcelRegister("cWUZS", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $96d71d37eed76577$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = $96d71d37eed76577$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $96d71d37eed76577$var$runtime;
    else Function("r", "regeneratorRuntime = r")($96d71d37eed76577$var$runtime);
}

});

parcelRegister("54dlf", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ffT4D"));

});
parcelRegister("ffT4D", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $b1b2fa3983f387be$export$ffb0004e005737fa; }, function (v) { return $b1b2fa3983f387be$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $b1b2fa3983f387be$export$34b9dba7ce09269b; }, function (v) { return $b1b2fa3983f387be$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $b1b2fa3983f387be$export$25062201e9e25d76; }, function (v) { return $b1b2fa3983f387be$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b1b2fa3983f387be$export$ffb0004e005737fa;
var $b1b2fa3983f387be$export$34b9dba7ce09269b;
var $b1b2fa3983f387be$export$25062201e9e25d76;
"use strict";
parcelRequire("kkn34");

var $ca3MY = parcelRequire("ca3MY");
var $b1b2fa3983f387be$var$g = 60103;
$b1b2fa3983f387be$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $b1b2fa3983f387be$var$h = Symbol.for;
    $b1b2fa3983f387be$var$g = $b1b2fa3983f387be$var$h("react.element");
    $b1b2fa3983f387be$export$ffb0004e005737fa = $b1b2fa3983f387be$var$h("react.fragment");
}
var $b1b2fa3983f387be$var$m = $ca3MY.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $b1b2fa3983f387be$var$n = Object.prototype.hasOwnProperty, $b1b2fa3983f387be$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b1b2fa3983f387be$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$b1b2fa3983f387be$var$n.call(a, b) && !$b1b2fa3983f387be$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $b1b2fa3983f387be$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $b1b2fa3983f387be$var$m.current
    };
}
$b1b2fa3983f387be$export$34b9dba7ce09269b = $b1b2fa3983f387be$var$q;
$b1b2fa3983f387be$export$25062201e9e25d76 = $b1b2fa3983f387be$var$q;

});
parcelRegister("kkn34", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $ecc78dd88c7fefe6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $ecc78dd88c7fefe6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $ecc78dd88c7fefe6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $ecc78dd88c7fefe6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $ecc78dd88c7fefe6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $ecc78dd88c7fefe6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $ecc78dd88c7fefe6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($ecc78dd88c7fefe6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($ecc78dd88c7fefe6$var$getOwnPropertySymbols) {
            symbols = $ecc78dd88c7fefe6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($ecc78dd88c7fefe6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("ca3MY", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bBnFo"));

});
parcelRegister("bBnFo", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8725822276295aef$export$ffb0004e005737fa; }, function (v) { return $8725822276295aef$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8725822276295aef$export$5f8d39834fd61797; }, function (v) { return $8725822276295aef$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $8725822276295aef$export$e2c29f18771995cb; }, function (v) { return $8725822276295aef$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $8725822276295aef$export$74bf444e3cd11ea5; }, function (v) { return $8725822276295aef$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $8725822276295aef$export$dca3b0875bd9a954; }, function (v) { return $8725822276295aef$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $8725822276295aef$export$16fa2f45be04daa8; }, function (v) { return $8725822276295aef$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $8725822276295aef$export$221d75b3f55bb0bd; }, function (v) { return $8725822276295aef$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $8725822276295aef$export$ae55be85d98224ed; }, function (v) { return $8725822276295aef$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $8725822276295aef$export$e530037191fcd5d7; }, function (v) { return $8725822276295aef$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $8725822276295aef$export$fd42f52fd3ae1109; }, function (v) { return $8725822276295aef$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $8725822276295aef$export$c8a8987d4410bf2d; }, function (v) { return $8725822276295aef$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $8725822276295aef$export$d38cd72104c1f0e9; }, function (v) { return $8725822276295aef$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $8725822276295aef$export$7d1e3a5e95ceca43; }, function (v) { return $8725822276295aef$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $8725822276295aef$export$257a8862b851cb5b; }, function (v) { return $8725822276295aef$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $8725822276295aef$export$a8257692ac88316c; }, function (v) { return $8725822276295aef$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $8725822276295aef$export$488013bae63b21da; }, function (v) { return $8725822276295aef$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $8725822276295aef$export$7c73462e0d25e514; }, function (v) { return $8725822276295aef$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $8725822276295aef$export$35808ee640e87ca7; }, function (v) { return $8725822276295aef$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $8725822276295aef$export$fae74005e78b1a27; }, function (v) { return $8725822276295aef$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $8725822276295aef$export$dc8fbce3eb94dc1e; }, function (v) { return $8725822276295aef$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $8725822276295aef$export$6d9c69b0de29b591; }, function (v) { return $8725822276295aef$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $8725822276295aef$export$d5a552a76deda3c2; }, function (v) { return $8725822276295aef$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $8725822276295aef$export$e5c5a5f917a5871c; }, function (v) { return $8725822276295aef$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $8725822276295aef$export$1538c33de8887b59; }, function (v) { return $8725822276295aef$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $8725822276295aef$export$13e3392192263954; }, function (v) { return $8725822276295aef$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $8725822276295aef$export$b8f5890fc79d6aca; }, function (v) { return $8725822276295aef$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $8725822276295aef$export$60241385465d0a34; }, function (v) { return $8725822276295aef$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $8725822276295aef$export$83d89fbfd8236492; }, function (v) { return $8725822276295aef$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8725822276295aef$export$ffb0004e005737fa;
var $8725822276295aef$export$5f8d39834fd61797;
var $8725822276295aef$export$e2c29f18771995cb;
var $8725822276295aef$export$74bf444e3cd11ea5;
var $8725822276295aef$export$dca3b0875bd9a954;
var $8725822276295aef$export$16fa2f45be04daa8;
var $8725822276295aef$export$221d75b3f55bb0bd;
var $8725822276295aef$export$ae55be85d98224ed;
var $8725822276295aef$export$e530037191fcd5d7;
var $8725822276295aef$export$fd42f52fd3ae1109;
var $8725822276295aef$export$c8a8987d4410bf2d;
var $8725822276295aef$export$d38cd72104c1f0e9;
var $8725822276295aef$export$7d1e3a5e95ceca43;
var $8725822276295aef$export$257a8862b851cb5b;
var $8725822276295aef$export$a8257692ac88316c;
var $8725822276295aef$export$488013bae63b21da;
var $8725822276295aef$export$7c73462e0d25e514;
var $8725822276295aef$export$35808ee640e87ca7;
var $8725822276295aef$export$fae74005e78b1a27;
var $8725822276295aef$export$dc8fbce3eb94dc1e;
var $8725822276295aef$export$6d9c69b0de29b591;
var $8725822276295aef$export$d5a552a76deda3c2;
var $8725822276295aef$export$e5c5a5f917a5871c;
var $8725822276295aef$export$1538c33de8887b59;
var $8725822276295aef$export$13e3392192263954;
var $8725822276295aef$export$b8f5890fc79d6aca;
var $8725822276295aef$export$60241385465d0a34;
var $8725822276295aef$export$83d89fbfd8236492;
"use strict";

var $kkn34 = parcelRequire("kkn34");
var $8725822276295aef$var$n = 60103, $8725822276295aef$var$p = 60106;
$8725822276295aef$export$ffb0004e005737fa = 60107;
$8725822276295aef$export$5f8d39834fd61797 = 60108;
$8725822276295aef$export$e2c29f18771995cb = 60114;
var $8725822276295aef$var$q = 60109, $8725822276295aef$var$r = 60110, $8725822276295aef$var$t = 60112;
$8725822276295aef$export$74bf444e3cd11ea5 = 60113;
var $8725822276295aef$var$u = 60115, $8725822276295aef$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $8725822276295aef$var$w = Symbol.for;
    $8725822276295aef$var$n = $8725822276295aef$var$w("react.element");
    $8725822276295aef$var$p = $8725822276295aef$var$w("react.portal");
    $8725822276295aef$export$ffb0004e005737fa = $8725822276295aef$var$w("react.fragment");
    $8725822276295aef$export$5f8d39834fd61797 = $8725822276295aef$var$w("react.strict_mode");
    $8725822276295aef$export$e2c29f18771995cb = $8725822276295aef$var$w("react.profiler");
    $8725822276295aef$var$q = $8725822276295aef$var$w("react.provider");
    $8725822276295aef$var$r = $8725822276295aef$var$w("react.context");
    $8725822276295aef$var$t = $8725822276295aef$var$w("react.forward_ref");
    $8725822276295aef$export$74bf444e3cd11ea5 = $8725822276295aef$var$w("react.suspense");
    $8725822276295aef$var$u = $8725822276295aef$var$w("react.memo");
    $8725822276295aef$var$v = $8725822276295aef$var$w("react.lazy");
}
var $8725822276295aef$var$x = "function" === typeof Symbol && Symbol.iterator;
function $8725822276295aef$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8725822276295aef$var$x && a[$8725822276295aef$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $8725822276295aef$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $8725822276295aef$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8725822276295aef$var$B = {};
function $8725822276295aef$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $8725822276295aef$var$B;
    this.updater = c || $8725822276295aef$var$A;
}
$8725822276295aef$var$C.prototype.isReactComponent = {};
$8725822276295aef$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($8725822276295aef$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$8725822276295aef$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $8725822276295aef$var$D() {}
$8725822276295aef$var$D.prototype = $8725822276295aef$var$C.prototype;
function $8725822276295aef$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $8725822276295aef$var$B;
    this.updater = c || $8725822276295aef$var$A;
}
var $8725822276295aef$var$F = $8725822276295aef$var$E.prototype = new $8725822276295aef$var$D;
$8725822276295aef$var$F.constructor = $8725822276295aef$var$E;
$kkn34($8725822276295aef$var$F, $8725822276295aef$var$C.prototype);
$8725822276295aef$var$F.isPureReactComponent = !0;
var $8725822276295aef$var$G = {
    current: null
}, $8725822276295aef$var$H = Object.prototype.hasOwnProperty, $8725822276295aef$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8725822276295aef$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$8725822276295aef$var$H.call(b, e) && !$8725822276295aef$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $8725822276295aef$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $8725822276295aef$var$G.current
    };
}
function $8725822276295aef$var$K(a, b) {
    return {
        $$typeof: $8725822276295aef$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $8725822276295aef$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8725822276295aef$var$n;
}
function $8725822276295aef$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $8725822276295aef$var$M = /\/+/g;
function $8725822276295aef$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $8725822276295aef$var$escape("" + a.key) : b.toString(36);
}
function $8725822276295aef$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $8725822276295aef$var$n:
                case $8725822276295aef$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $8725822276295aef$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($8725822276295aef$var$M, "$&/") + "/"), $8725822276295aef$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($8725822276295aef$var$L(d) && (d = $8725822276295aef$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($8725822276295aef$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $8725822276295aef$var$N(k, g);
        h += $8725822276295aef$var$O(k, b, c, f, d);
    }
    else if (f = $8725822276295aef$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $8725822276295aef$var$N(k, g++), h += $8725822276295aef$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($8725822276295aef$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $8725822276295aef$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $8725822276295aef$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $8725822276295aef$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $8725822276295aef$var$R = {
    current: null
};
function $8725822276295aef$var$S() {
    var a = $8725822276295aef$var$R.current;
    if (null === a) throw Error($8725822276295aef$var$z(321));
    return a;
}
var $8725822276295aef$var$T = {
    ReactCurrentDispatcher: $8725822276295aef$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $8725822276295aef$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $kkn34
};
$8725822276295aef$export$dca3b0875bd9a954 = {
    map: $8725822276295aef$var$P,
    forEach: function(a, b, c) {
        $8725822276295aef$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $8725822276295aef$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $8725822276295aef$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$8725822276295aef$var$L(a)) throw Error($8725822276295aef$var$z(143));
        return a;
    }
};
$8725822276295aef$export$16fa2f45be04daa8 = $8725822276295aef$var$C;
$8725822276295aef$export$221d75b3f55bb0bd = $8725822276295aef$var$E;
$8725822276295aef$export$ae55be85d98224ed = $8725822276295aef$var$T;
$8725822276295aef$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($8725822276295aef$var$z(267, a));
    var e = $kkn34({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $8725822276295aef$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$8725822276295aef$var$H.call(b, f) && !$8725822276295aef$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $8725822276295aef$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$8725822276295aef$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $8725822276295aef$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $8725822276295aef$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$8725822276295aef$export$c8a8987d4410bf2d = $8725822276295aef$var$J;
$8725822276295aef$export$d38cd72104c1f0e9 = function(a) {
    var b = $8725822276295aef$var$J.bind(null, a);
    b.type = a;
    return b;
};
$8725822276295aef$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8725822276295aef$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $8725822276295aef$var$t,
        render: a
    };
};
$8725822276295aef$export$a8257692ac88316c = $8725822276295aef$var$L;
$8725822276295aef$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $8725822276295aef$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $8725822276295aef$var$Q
    };
};
$8725822276295aef$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $8725822276295aef$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$8725822276295aef$export$35808ee640e87ca7 = function(a, b) {
    return $8725822276295aef$var$S().useCallback(a, b);
};
$8725822276295aef$export$fae74005e78b1a27 = function(a, b) {
    return $8725822276295aef$var$S().useContext(a, b);
};
$8725822276295aef$export$dc8fbce3eb94dc1e = function() {};
$8725822276295aef$export$6d9c69b0de29b591 = function(a, b) {
    return $8725822276295aef$var$S().useEffect(a, b);
};
$8725822276295aef$export$d5a552a76deda3c2 = function(a, b, c) {
    return $8725822276295aef$var$S().useImperativeHandle(a, b, c);
};
$8725822276295aef$export$e5c5a5f917a5871c = function(a, b) {
    return $8725822276295aef$var$S().useLayoutEffect(a, b);
};
$8725822276295aef$export$1538c33de8887b59 = function(a, b) {
    return $8725822276295aef$var$S().useMemo(a, b);
};
$8725822276295aef$export$13e3392192263954 = function(a, b, c) {
    return $8725822276295aef$var$S().useReducer(a, b, c);
};
$8725822276295aef$export$b8f5890fc79d6aca = function(a) {
    return $8725822276295aef$var$S().useRef(a);
};
$8725822276295aef$export$60241385465d0a34 = function(a) {
    return $8725822276295aef$var$S().useState(a);
};
$8725822276295aef$export$83d89fbfd8236492 = "17.0.2";

});




parcelRegister("jQtCH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e729da2f411ec937$export$2e2bcd8739ae039; });
const $e729da2f411ec937$var$ctrls = {};
function $e729da2f411ec937$var$parseDom(dom) {
    const pageElements = dom.querySelectorAll("[data-controller]");
    if (pageElements.length) Array.prototype.forEach.call(pageElements, (singleElement)=>{
        const attr = singleElement.getAttribute("data-controller");
        if (!attr) return false;
        if ($e729da2f411ec937$var$ctrls.hasOwnProperty(attr)) {
            if (!$e729da2f411ec937$var$ctrls[attr]) return false;
            const instance = $e729da2f411ec937$var$ctrls[attr](singleElement);
            if (instance && "init" in instance) instance.init();
        }
    });
}
function $e729da2f411ec937$var$addController(name, constructor) {
    if (!$e729da2f411ec937$var$ctrls.hasOwnProperty(name)) $e729da2f411ec937$var$ctrls[name] = constructor;
}
function $e729da2f411ec937$var$removeController(name) {
    if (!$e729da2f411ec937$var$ctrls.hasOwnProperty(name)) delete $e729da2f411ec937$var$ctrls[name];
}
function $e729da2f411ec937$var$getXconfigFromController(context) {
    const scriptTag = context.querySelector('script[type="text/x-config"]');
    if (!scriptTag) return {};
    const scriptTextContent = scriptTag.innerText.replace(/(\r\n|\n|\r)/gm, "").replace(/(\t)/gm, "").replace(/&quot;/g, "\\&quot;").replace(/,}/g, "}").replace(/, }/g, "}");
    if (scriptTextContent.length > 0) try {
        return JSON.parse($e729da2f411ec937$var$decodeEntities(scriptTextContent));
    } catch  {
        return {};
    }
    else return {};
}
const $e729da2f411ec937$var$decodeEntities = (()=>{
    var element = document.createElement("div");
    const decodeHTMLEntities = (str)=>{
        if (str && typeof str === "string") {
            str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, "");
            str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, "");
            element.innerHTML = str;
            str = element.textContent;
            element.textContent = "";
        }
        return str;
    };
    return decodeHTMLEntities;
})();
var $e729da2f411ec937$export$2e2bcd8739ae039 = {
    add: $e729da2f411ec937$var$addController,
    remove: $e729da2f411ec937$var$removeController,
    parse: $e729da2f411ec937$var$parseDom,
    getConfig: $e729da2f411ec937$var$getXconfigFromController
};
document.addEventListener("DOMContentLoaded", (e)=>{
    $e729da2f411ec937$var$parseDom(e.target);
});
document.addEventListener("newDom", (e)=>{
    $e729da2f411ec937$var$parseDom(e.target);
});

});

parcelRegister("bUNms", function(module, exports) {
"use strict";
function $8acb36c5f3a95420$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($8acb36c5f3a95420$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$8acb36c5f3a95420$var$checkDCE();

module.exports = (parcelRequire("4w6Om"));

});
parcelRegister("4w6Om", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $ca3MY = parcelRequire("ca3MY");

var $kkn34 = parcelRequire("kkn34");

var $ex05X = parcelRequire("ex05X");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$ca3MY) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $ca3MY.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $kkn34({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $ca3MY.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $kkn34({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $kkn34({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $kkn34({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $ex05X.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $ex05X.unstable_scheduleCallback($ex05X.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $ex05X.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $ex05X.unstable_UserBlockingPriority, ed = $ex05X.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $kkn34(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $kkn34({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $kkn34({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $kkn34({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $kkn34({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $kkn34({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $kkn34({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $kkn34({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $kkn34({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $kkn34({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $kkn34({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $kkn34({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $kkn34({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $kkn34({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $ex05X.unstable_runWithPriority, Of = $ex05X.unstable_scheduleCallback, Pf = $ex05X.unstable_cancelCallback, Qf = $ex05X.unstable_shouldYield, Rf = $ex05X.unstable_requestPaint, Sf = $ex05X.unstable_now, Tf = $ex05X.unstable_getCurrentPriorityLevel, Uf = $ex05X.unstable_ImmediatePriority, Vf = $ex05X.unstable_UserBlockingPriority, Wf = $ex05X.unstable_NormalPriority, Xf = $ex05X.unstable_LowPriority, Yf = $ex05X.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $kkn34({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $kkn34({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $ca3MY.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $kkn34({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $kkn34({}, e, {
                    value: void 0
                });
                d = $kkn34({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $kkn34({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("ex05X", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7IgjC"));

});
parcelRegister("7IgjC", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $59d94c59925707e9$export$c4744153514ff05d; }, function (v) { return $59d94c59925707e9$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $59d94c59925707e9$export$b5836b71941fa3ed; }, function (v) { return $59d94c59925707e9$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $59d94c59925707e9$export$d66a1c1c77bd778b; }, function (v) { return $59d94c59925707e9$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $59d94c59925707e9$export$3e506c1ccc9cc1a7; }, function (v) { return $59d94c59925707e9$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $59d94c59925707e9$export$e26fe2ed2fa76875; }, function (v) { return $59d94c59925707e9$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $59d94c59925707e9$export$502329bbf4b505b1; }, function (v) { return $59d94c59925707e9$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $59d94c59925707e9$export$6e3807111c4874c4; }, function (v) { return $59d94c59925707e9$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $59d94c59925707e9$export$c27134553091fb3a; }, function (v) { return $59d94c59925707e9$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $59d94c59925707e9$export$33ee1acdc04fd2a2; }, function (v) { return $59d94c59925707e9$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $59d94c59925707e9$export$b00a404bbd5edef2; }, function (v) { return $59d94c59925707e9$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $59d94c59925707e9$export$8352ce38b91d0c62; }, function (v) { return $59d94c59925707e9$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $59d94c59925707e9$export$d3dfb8e4810cb555; }, function (v) { return $59d94c59925707e9$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $59d94c59925707e9$export$839f9183b0465a69; }, function (v) { return $59d94c59925707e9$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $59d94c59925707e9$export$72fdf0e06517287b; }, function (v) { return $59d94c59925707e9$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $59d94c59925707e9$export$4b844e58a3e414b4; }, function (v) { return $59d94c59925707e9$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $59d94c59925707e9$export$816d2913ae6b83b1; }, function (v) { return $59d94c59925707e9$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $59d94c59925707e9$export$61bcfe829111a1d0; }, function (v) { return $59d94c59925707e9$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $59d94c59925707e9$export$7ee8c9beb337bc3f; }, function (v) { return $59d94c59925707e9$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $59d94c59925707e9$export$cf845f2c119da08a; }, function (v) { return $59d94c59925707e9$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $59d94c59925707e9$export$c4744153514ff05d;
var $59d94c59925707e9$export$b5836b71941fa3ed;
var $59d94c59925707e9$export$d66a1c1c77bd778b;
var $59d94c59925707e9$export$3e506c1ccc9cc1a7;
var $59d94c59925707e9$export$e26fe2ed2fa76875;
var $59d94c59925707e9$export$502329bbf4b505b1;
var $59d94c59925707e9$export$6e3807111c4874c4;
var $59d94c59925707e9$export$c27134553091fb3a;
var $59d94c59925707e9$export$33ee1acdc04fd2a2;
var $59d94c59925707e9$export$b00a404bbd5edef2;
var $59d94c59925707e9$export$8352ce38b91d0c62;
var $59d94c59925707e9$export$d3dfb8e4810cb555;
var $59d94c59925707e9$export$839f9183b0465a69;
var $59d94c59925707e9$export$72fdf0e06517287b;
var $59d94c59925707e9$export$4b844e58a3e414b4;
var $59d94c59925707e9$export$816d2913ae6b83b1;
var $59d94c59925707e9$export$61bcfe829111a1d0;
var $59d94c59925707e9$export$7ee8c9beb337bc3f;
var $59d94c59925707e9$export$cf845f2c119da08a;
"use strict";
var $59d94c59925707e9$var$f, $59d94c59925707e9$var$g, $59d94c59925707e9$var$h, $59d94c59925707e9$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $59d94c59925707e9$var$l = performance;
    $59d94c59925707e9$export$c4744153514ff05d = function() {
        return $59d94c59925707e9$var$l.now();
    };
} else {
    var $59d94c59925707e9$var$p = Date, $59d94c59925707e9$var$q = $59d94c59925707e9$var$p.now();
    $59d94c59925707e9$export$c4744153514ff05d = function() {
        return $59d94c59925707e9$var$p.now() - $59d94c59925707e9$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $59d94c59925707e9$var$t = null, $59d94c59925707e9$var$u = null, $59d94c59925707e9$var$w = function() {
        if (null !== $59d94c59925707e9$var$t) try {
            var a = $59d94c59925707e9$export$c4744153514ff05d();
            $59d94c59925707e9$var$t(!0, a);
            $59d94c59925707e9$var$t = null;
        } catch (b) {
            throw setTimeout($59d94c59925707e9$var$w, 0), b;
        }
    };
    $59d94c59925707e9$var$f = function(a) {
        null !== $59d94c59925707e9$var$t ? setTimeout($59d94c59925707e9$var$f, 0, a) : ($59d94c59925707e9$var$t = a, setTimeout($59d94c59925707e9$var$w, 0));
    };
    $59d94c59925707e9$var$g = function(a, b) {
        $59d94c59925707e9$var$u = setTimeout(a, b);
    };
    $59d94c59925707e9$var$h = function() {
        clearTimeout($59d94c59925707e9$var$u);
    };
    $59d94c59925707e9$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $59d94c59925707e9$var$k = $59d94c59925707e9$export$d66a1c1c77bd778b = function() {};
} else {
    var $59d94c59925707e9$var$x = window.setTimeout, $59d94c59925707e9$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $59d94c59925707e9$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $59d94c59925707e9$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $59d94c59925707e9$var$A = !1, $59d94c59925707e9$var$B = null, $59d94c59925707e9$var$C = -1, $59d94c59925707e9$var$D = 5, $59d94c59925707e9$var$E = 0;
    $59d94c59925707e9$export$b5836b71941fa3ed = function() {
        return $59d94c59925707e9$export$c4744153514ff05d() >= $59d94c59925707e9$var$E;
    };
    $59d94c59925707e9$var$k = function() {};
    $59d94c59925707e9$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $59d94c59925707e9$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $59d94c59925707e9$var$F = new MessageChannel, $59d94c59925707e9$var$G = $59d94c59925707e9$var$F.port2;
    $59d94c59925707e9$var$F.port1.onmessage = function() {
        if (null !== $59d94c59925707e9$var$B) {
            var a = $59d94c59925707e9$export$c4744153514ff05d();
            $59d94c59925707e9$var$E = a + $59d94c59925707e9$var$D;
            try {
                $59d94c59925707e9$var$B(!0, a) ? $59d94c59925707e9$var$G.postMessage(null) : ($59d94c59925707e9$var$A = !1, $59d94c59925707e9$var$B = null);
            } catch (b) {
                throw $59d94c59925707e9$var$G.postMessage(null), b;
            }
        } else $59d94c59925707e9$var$A = !1;
    };
    $59d94c59925707e9$var$f = function(a) {
        $59d94c59925707e9$var$B = a;
        $59d94c59925707e9$var$A || ($59d94c59925707e9$var$A = !0, $59d94c59925707e9$var$G.postMessage(null));
    };
    $59d94c59925707e9$var$g = function(a, b) {
        $59d94c59925707e9$var$C = $59d94c59925707e9$var$x(function() {
            a($59d94c59925707e9$export$c4744153514ff05d());
        }, b);
    };
    $59d94c59925707e9$var$h = function() {
        $59d94c59925707e9$var$y($59d94c59925707e9$var$C);
        $59d94c59925707e9$var$C = -1;
    };
}
function $59d94c59925707e9$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $59d94c59925707e9$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $59d94c59925707e9$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $59d94c59925707e9$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $59d94c59925707e9$var$I(n, c)) void 0 !== r && 0 > $59d94c59925707e9$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $59d94c59925707e9$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $59d94c59925707e9$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $59d94c59925707e9$var$L = [], $59d94c59925707e9$var$M = [], $59d94c59925707e9$var$N = 1, $59d94c59925707e9$var$O = null, $59d94c59925707e9$var$P = 3, $59d94c59925707e9$var$Q = !1, $59d94c59925707e9$var$R = !1, $59d94c59925707e9$var$S = !1;
function $59d94c59925707e9$var$T(a) {
    for(var b = $59d94c59925707e9$var$J($59d94c59925707e9$var$M); null !== b;){
        if (null === b.callback) $59d94c59925707e9$var$K($59d94c59925707e9$var$M);
        else if (b.startTime <= a) $59d94c59925707e9$var$K($59d94c59925707e9$var$M), b.sortIndex = b.expirationTime, $59d94c59925707e9$var$H($59d94c59925707e9$var$L, b);
        else break;
        b = $59d94c59925707e9$var$J($59d94c59925707e9$var$M);
    }
}
function $59d94c59925707e9$var$U(a) {
    $59d94c59925707e9$var$S = !1;
    $59d94c59925707e9$var$T(a);
    if (!$59d94c59925707e9$var$R) {
        if (null !== $59d94c59925707e9$var$J($59d94c59925707e9$var$L)) $59d94c59925707e9$var$R = !0, $59d94c59925707e9$var$f($59d94c59925707e9$var$V);
        else {
            var b = $59d94c59925707e9$var$J($59d94c59925707e9$var$M);
            null !== b && $59d94c59925707e9$var$g($59d94c59925707e9$var$U, b.startTime - a);
        }
    }
}
function $59d94c59925707e9$var$V(a, b) {
    $59d94c59925707e9$var$R = !1;
    $59d94c59925707e9$var$S && ($59d94c59925707e9$var$S = !1, $59d94c59925707e9$var$h());
    $59d94c59925707e9$var$Q = !0;
    var c = $59d94c59925707e9$var$P;
    try {
        $59d94c59925707e9$var$T(b);
        for($59d94c59925707e9$var$O = $59d94c59925707e9$var$J($59d94c59925707e9$var$L); null !== $59d94c59925707e9$var$O && (!($59d94c59925707e9$var$O.expirationTime > b) || a && !$59d94c59925707e9$export$b5836b71941fa3ed());){
            var d = $59d94c59925707e9$var$O.callback;
            if ("function" === typeof d) {
                $59d94c59925707e9$var$O.callback = null;
                $59d94c59925707e9$var$P = $59d94c59925707e9$var$O.priorityLevel;
                var e = d($59d94c59925707e9$var$O.expirationTime <= b);
                b = $59d94c59925707e9$export$c4744153514ff05d();
                "function" === typeof e ? $59d94c59925707e9$var$O.callback = e : $59d94c59925707e9$var$O === $59d94c59925707e9$var$J($59d94c59925707e9$var$L) && $59d94c59925707e9$var$K($59d94c59925707e9$var$L);
                $59d94c59925707e9$var$T(b);
            } else $59d94c59925707e9$var$K($59d94c59925707e9$var$L);
            $59d94c59925707e9$var$O = $59d94c59925707e9$var$J($59d94c59925707e9$var$L);
        }
        if (null !== $59d94c59925707e9$var$O) var m = !0;
        else {
            var n = $59d94c59925707e9$var$J($59d94c59925707e9$var$M);
            null !== n && $59d94c59925707e9$var$g($59d94c59925707e9$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $59d94c59925707e9$var$O = null, $59d94c59925707e9$var$P = c, $59d94c59925707e9$var$Q = !1;
    }
}
var $59d94c59925707e9$var$W = $59d94c59925707e9$var$k;
$59d94c59925707e9$export$3e506c1ccc9cc1a7 = 5;
$59d94c59925707e9$export$e26fe2ed2fa76875 = 1;
$59d94c59925707e9$export$502329bbf4b505b1 = 4;
$59d94c59925707e9$export$6e3807111c4874c4 = 3;
$59d94c59925707e9$export$c27134553091fb3a = null;
$59d94c59925707e9$export$33ee1acdc04fd2a2 = 2;
$59d94c59925707e9$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$59d94c59925707e9$export$8352ce38b91d0c62 = function() {
    $59d94c59925707e9$var$R || $59d94c59925707e9$var$Q || ($59d94c59925707e9$var$R = !0, $59d94c59925707e9$var$f($59d94c59925707e9$var$V));
};
$59d94c59925707e9$export$d3dfb8e4810cb555 = function() {
    return $59d94c59925707e9$var$P;
};
$59d94c59925707e9$export$839f9183b0465a69 = function() {
    return $59d94c59925707e9$var$J($59d94c59925707e9$var$L);
};
$59d94c59925707e9$export$72fdf0e06517287b = function(a) {
    switch($59d94c59925707e9$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $59d94c59925707e9$var$P;
    }
    var c = $59d94c59925707e9$var$P;
    $59d94c59925707e9$var$P = b;
    try {
        return a();
    } finally{
        $59d94c59925707e9$var$P = c;
    }
};
$59d94c59925707e9$export$4b844e58a3e414b4 = function() {};
$59d94c59925707e9$export$816d2913ae6b83b1 = $59d94c59925707e9$var$W;
$59d94c59925707e9$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $59d94c59925707e9$var$P;
    $59d94c59925707e9$var$P = a;
    try {
        return b();
    } finally{
        $59d94c59925707e9$var$P = c;
    }
};
$59d94c59925707e9$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $59d94c59925707e9$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $59d94c59925707e9$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $59d94c59925707e9$var$H($59d94c59925707e9$var$M, a), null === $59d94c59925707e9$var$J($59d94c59925707e9$var$L) && a === $59d94c59925707e9$var$J($59d94c59925707e9$var$M) && ($59d94c59925707e9$var$S ? $59d94c59925707e9$var$h() : $59d94c59925707e9$var$S = !0, $59d94c59925707e9$var$g($59d94c59925707e9$var$U, c - d))) : (a.sortIndex = e, $59d94c59925707e9$var$H($59d94c59925707e9$var$L, a), $59d94c59925707e9$var$R || $59d94c59925707e9$var$Q || ($59d94c59925707e9$var$R = !0, $59d94c59925707e9$var$f($59d94c59925707e9$var$V)));
    return a;
};
$59d94c59925707e9$export$cf845f2c119da08a = function(a) {
    var b = $59d94c59925707e9$var$P;
    return function() {
        var c = $59d94c59925707e9$var$P;
        $59d94c59925707e9$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $59d94c59925707e9$var$P = c;
        }
    };
};

});




parcelRegister("8OcmI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $669c95b9fa73b158$export$2e2bcd8739ae039; });
/*! (c) Andrea Giammarchi - ISC */ var $669c95b9fa73b158$var$self = {};
try {
    (function(URLSearchParams1, plus) {
        if (new URLSearchParams1("q=%2B").get("q") !== plus || new URLSearchParams1({
            q: plus
        }).get("q") !== plus || new URLSearchParams1([
            [
                "q",
                plus
            ]
        ]).get("q") !== plus || new URLSearchParams1("q=\n").toString() !== "q=%0A" || new URLSearchParams1({
            q: " &"
        }).toString() !== "q=+%26" || new URLSearchParams1({
            q: "%zx"
        }).toString() !== "q=%25zx") throw URLSearchParams1;
        $669c95b9fa73b158$var$self.URLSearchParams = URLSearchParams1;
    })(URLSearchParams, "+");
} catch (URLSearchParams1) {
    (function(Object1, String1, isArray) {
        "use strict";
        var create = Object1.create;
        var defineProperty = Object1.defineProperty;
        var find = /[!'\(\)~]|%20|%00/g;
        var findPercentSign = /%(?![0-9a-fA-F]{2})/g;
        var plus = /\+/g;
        var replace = {
            "!": "%21",
            "'": "%27",
            "(": "%28",
            ")": "%29",
            "~": "%7E",
            "%20": "+",
            "%00": "\x00"
        };
        var proto = {
            append: function(key, value) {
                appendTo(this._ungap, key, value);
            },
            delete: function(key) {
                delete this._ungap[key];
            },
            get: function(key) {
                return this.has(key) ? this._ungap[key][0] : null;
            },
            getAll: function(key) {
                return this.has(key) ? this._ungap[key].slice(0) : [];
            },
            has: function(key) {
                return key in this._ungap;
            },
            set: function(key, value) {
                this._ungap[key] = [
                    String1(value)
                ];
            },
            forEach: function(callback, thisArg) {
                var self = this;
                for(var key in self._ungap)self._ungap[key].forEach(invoke, key);
                function invoke(value) {
                    callback.call(thisArg, value, String1(key), self);
                }
            },
            toJSON: function() {
                return {};
            },
            toString: function() {
                var query = [];
                for(var key in this._ungap){
                    var encoded = encode(key);
                    for(var i = 0, value = this._ungap[key]; i < value.length; i++)query.push(encoded + "=" + encode(value[i]));
                }
                return query.join("&");
            }
        };
        for(var key in proto)defineProperty(URLSearchParams1.prototype, key, {
            configurable: true,
            writable: true,
            value: proto[key]
        });
        $669c95b9fa73b158$var$self.URLSearchParams = URLSearchParams1;
        function URLSearchParams1(query) {
            var dict = create(null);
            defineProperty(this, "_ungap", {
                value: dict
            });
            switch(true){
                case !query:
                    break;
                case typeof query === "string":
                    if (query.charAt(0) === "?") query = query.slice(1);
                    for(var pairs = query.split("&"), i = 0, length = pairs.length; i < length; i++){
                        var value = pairs[i];
                        var index = value.indexOf("=");
                        if (-1 < index) appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));
                        else if (value.length) appendTo(dict, decode(value), "");
                    }
                    break;
                case isArray(query):
                    for(var i = 0, length = query.length; i < length; i++){
                        var value = query[i];
                        appendTo(dict, value[0], value[1]);
                    }
                    break;
                case "forEach" in query:
                    query.forEach(addEach, dict);
                    break;
                default:
                    for(var key in query)appendTo(dict, key, query[key]);
            }
        }
        function addEach(value, key) {
            appendTo(this, key, value);
        }
        function appendTo(dict, key, value) {
            var res = isArray(value) ? value.join(",") : value;
            if (key in dict) dict[key].push(res);
            else dict[key] = [
                res
            ];
        }
        function decode(str) {
            return decodeURIComponent(str.replace(findPercentSign, "%25").replace(plus, " "));
        }
        function encode(str) {
            return encodeURIComponent(str).replace(find, replacer);
        }
        function replacer(match) {
            return replace[match];
        }
    })(Object, String, Array.isArray);
}
(function(URLSearchParamsProto) {
    var iterable = false;
    try {
        iterable = !!Symbol.iterator;
    } catch (o_O) {}
    /* istanbul ignore else */ if (!("forEach" in URLSearchParamsProto)) URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
        var self = this;
        var names = Object.create(null);
        this.toString().replace(/=[\s\S]*?(?:&|$)/g, "=").split("=").forEach(function(name) {
            if (!name.length || name in names) return;
            (names[name] = self.getAll(name)).forEach(function(value) {
                callback.call(thisArg, value, name, self);
            });
        });
    };
    /* istanbul ignore else */ if (!("keys" in URLSearchParamsProto)) URLSearchParamsProto.keys = function keys() {
        return iterator(this, function(value, key) {
            this.push(key);
        });
    };
    /* istanbul ignore else */ if (!("values" in URLSearchParamsProto)) URLSearchParamsProto.values = function values() {
        return iterator(this, function(value, key) {
            this.push(value);
        });
    };
    /* istanbul ignore else */ if (!("entries" in URLSearchParamsProto)) URLSearchParamsProto.entries = function entries() {
        return iterator(this, function(value, key) {
            this.push([
                key,
                value
            ]);
        });
    };
    /* istanbul ignore else */ if (iterable && !(Symbol.iterator in URLSearchParamsProto)) URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
    /* istanbul ignore else */ if (!("sort" in URLSearchParamsProto)) URLSearchParamsProto.sort = function sort() {
        var entries = this.entries(), entry = entries.next(), done = entry.done, keys = [], values = Object.create(null), i, key, value;
        while(!done){
            value = entry.value;
            key = value[0];
            keys.push(key);
            if (!(key in values)) values[key] = [];
            values[key].push(value[1]);
            entry = entries.next();
            done = entry.done;
        }
        // not the champion in efficiency
        // but these two bits just do the job
        keys.sort();
        for(i = 0; i < keys.length; i++)this.delete(keys[i]);
        for(i = 0; i < keys.length; i++){
            key = keys[i];
            this.append(key, values[key].shift());
        }
    };
    function iterator(self, callback) {
        var items = [];
        self.forEach(callback, items);
        /* istanbul ignore next */ return iterable ? items[Symbol.iterator]() : {
            next: function() {
                var value = items.shift();
                return {
                    done: value === void 0,
                    value: value
                };
            }
        };
    }
    /* istanbul ignore next */ (function(Object1) {
        var dP = Object1.defineProperty, gOPD = Object1.getOwnPropertyDescriptor, createSearchParamsPollute = function(search) {
            function append(name, value) {
                URLSearchParamsProto.append.call(this, name, value);
                name = this.toString();
                search.set.call(this._usp, name ? "?" + name : "");
            }
            function del(name) {
                URLSearchParamsProto.delete.call(this, name);
                name = this.toString();
                search.set.call(this._usp, name ? "?" + name : "");
            }
            function set(name, value) {
                URLSearchParamsProto.set.call(this, name, value);
                name = this.toString();
                search.set.call(this._usp, name ? "?" + name : "");
            }
            return function(sp, value) {
                sp.append = append;
                sp.delete = del;
                sp.set = set;
                return dP(sp, "_usp", {
                    configurable: true,
                    writable: true,
                    value: value
                });
            };
        }, createSearchParamsCreate = function(polluteSearchParams) {
            return function(obj, sp) {
                dP(obj, "_searchParams", {
                    configurable: true,
                    writable: true,
                    value: polluteSearchParams(sp, obj)
                });
                return sp;
            };
        }, updateSearchParams = function(sp) {
            var append = sp.append;
            sp.append = URLSearchParamsProto.append;
            URLSearchParams.call(sp, sp._usp.search.slice(1));
            sp.append = append;
        }, verifySearchParams = function(obj, Class) {
            if (!(obj instanceof Class)) throw new TypeError("'searchParams' accessed on an object that does not implement interface " + Class.name);
        }, upgradeClass = function(Class) {
            var ClassProto = Class.prototype, searchParams = gOPD(ClassProto, "searchParams"), href = gOPD(ClassProto, "href"), search = gOPD(ClassProto, "search"), createSearchParams;
            if (!searchParams && search && search.set) {
                createSearchParams = createSearchParamsCreate(createSearchParamsPollute(search));
                Object1.defineProperties(ClassProto, {
                    href: {
                        get: function() {
                            return href.get.call(this);
                        },
                        set: function(value) {
                            var sp = this._searchParams;
                            href.set.call(this, value);
                            if (sp) updateSearchParams(sp);
                        }
                    },
                    search: {
                        get: function() {
                            return search.get.call(this);
                        },
                        set: function(value) {
                            var sp = this._searchParams;
                            search.set.call(this, value);
                            if (sp) updateSearchParams(sp);
                        }
                    },
                    searchParams: {
                        get: function() {
                            verifySearchParams(this, Class);
                            return this._searchParams || createSearchParams(this, new URLSearchParams(this.search.slice(1)));
                        },
                        set: function(sp) {
                            verifySearchParams(this, Class);
                            createSearchParams(this, sp);
                        }
                    }
                });
            }
        };
        try {
            upgradeClass(HTMLAnchorElement);
            if (/^function|object$/.test(typeof URL) && URL.prototype) upgradeClass(URL);
        } catch (meh) {}
    })(Object);
})($669c95b9fa73b158$var$self.URLSearchParams.prototype, Object);
var $669c95b9fa73b158$export$2e2bcd8739ae039 = $669c95b9fa73b158$var$self.URLSearchParams;

});

parcelRegister("iSxgd", function(module, exports) {

$parcel$export(module.exports, "pushToDataLayer", function () { return $dbe712012fc7ccbb$export$3c27964bdf7ca185; });
const $dbe712012fc7ccbb$var$debounce = (func, wait, immediate)=>{
    var timeout;
    return ()=>{
        var context = undefined, args = arguments;
        var later = ()=>{
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};
const $dbe712012fc7ccbb$export$3c27964bdf7ca185 = (object, debounceTime)=>{
    window.dataLayer = window.dataLayer ? window.dataLayer : [];
    if (debounceTime) $dbe712012fc7ccbb$var$debounce(function() {
        window.dataLayer.push(object);
    //console.log('dataLayer', object);
    //console.table(window.dataLayer);
    }, debounceTime);
    else window.dataLayer.push(object);
};

});

parcelRegister("8oRQh", function(module, exports) {

$parcel$export(module.exports, "BookingFlowContext", function () { return $61da548b080f1d26$export$b2c51d17d715ff5; });
$parcel$export(module.exports, "BookingFlowContextProvider", function () { return $61da548b080f1d26$export$84d414b6805d5b02; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");
const $61da548b080f1d26$export$909472870379947f = {
    activeStep: 0,
    availableSteps: {
        onlineBooking: {
            index: 0
        },
        login: {
            index: 1
        },
        createAccount: {
            index: 2
        },
        addVehicle: {
            index: 3
        },
        documentUpload: {
            index: 4
        },
        orderOverview: {
            index: 5
        },
        orderConfirmation: {
            index: 6
        }
    }
};
const $61da548b080f1d26$export$b2c51d17d715ff5 = /*#__PURE__*/ (0, $ca3MY.createContext)(null);
const $61da548b080f1d26$export$84d414b6805d5b02 = (props)=>{
    const config = props.appConfig ?? {};
    const urlParams = new URLSearchParams(window.location.search);
    const fId = urlParams.get("fId") ?? urlParams.get("fid");
    const type = urlParams.get("T") ?? urlParams.get("t") ?? "1";
    const sessionName = `__aimo-booking-flow__${fId}__${type}`;
    const expiry = 3600000;
    const getWithExpiry = (key)=>{
        const itemStr = sessionStorage.getItem(key);
        if (itemStr) {
            const item = JSON.parse(itemStr);
            const now = new Date();
            if (item.expiry && item.expiry > now.getTime()) {
                delete item.expiry;
                return item;
            }
            if (!item.expiry) return item;
        }
        Object.keys(sessionStorage).forEach((key)=>{
            if (key.includes("__aimo-booking-flow")) sessionStorage.removeItem(key);
        });
        return null;
    };
    const browserBookingFlowState = getWithExpiry(sessionName);
    const [bookingFlowContext, setBookingFlowContextTmp] = (0, $ca3MY.useState)(()=>{
        const expectedStepKeys = Object.keys($61da548b080f1d26$export$909472870379947f.availableSteps);
        const persistedIsCompatible = browserBookingFlowState && browserBookingFlowState.availableSteps && expectedStepKeys.every((k)=>browserBookingFlowState.availableSteps[k] !== undefined);
        const currentState = persistedIsCompatible ? {
            ...browserBookingFlowState,
            ...config
        } : {
            ...$61da548b080f1d26$export$909472870379947f,
            ...config
        };
        return currentState;
    });
    const setBookingFlowContext = (state)=>{
        const now = new Date();
        const item = {
            ...state,
            expiry: now.getTime() + expiry
        };
        sessionStorage.setItem(sessionName, JSON.stringify(item));
        // clean the local Storage at the Order Overview step
        if (state.activeStep == state.availableSteps.orderOverview.index) {
            localStorage.removeItem("validUnlockCode");
            localStorage.removeItem("validUnlockPmcId");
        }
        if (state.activeStep > bookingFlowContext.activeStep) history.pushState({
            activeStep: state.activeStep
        }, document.title);
        setBookingFlowContextTmp(state);
    };
    const bookingFlowState = (0, $ca3MY.useMemo)(()=>({
            bookingFlowContext: bookingFlowContext,
            setBookingFlowContext: setBookingFlowContext
        }), [
        bookingFlowContext,
        setBookingFlowContext
    ]);
    return /*#__PURE__*/ (0, $54dlf.jsx)($61da548b080f1d26$export$b2c51d17d715ff5.Provider, {
        value: bookingFlowState,
        children: props.children
    });
};

});

parcelRegister("axmXn", function(module, exports) {

$parcel$export(module.exports, "facility", function () { return $7abecb2894dde2ba$export$a4ca3e5a2bdfe213; });
$parcel$export(module.exports, "products", function () { return $7abecb2894dde2ba$export$b6aad051bad07f12; });
$parcel$export(module.exports, "account", function () { return $7abecb2894dde2ba$export$6b501c78a3684162; });
$parcel$export(module.exports, "vehicles", function () { return $7abecb2894dde2ba$export$f227cb3279b11c6; });
$parcel$export(module.exports, "tempLock", function () { return $7abecb2894dde2ba$export$ac37114f3704cec7; });
$parcel$export(module.exports, "payment", function () { return $7abecb2894dde2ba$export$18f430e15f133060; });

var $lA5kC = parcelRequire("lA5kC");

var $5TEB1 = parcelRequire("5TEB1");
const $7abecb2894dde2ba$export$a4ca3e5a2bdfe213 = {
    getNearbyFacilities: async (data1)=>(0, $lA5kC.apiPromise)("/booking/getnearbyfacilities", data1).catch((err)=>err),
    getConfirmationPageOffers: async (data1)=>(0, $lA5kC.htmlPromise)("/facilitypage/getconfirmationpageoffer", data1).catch((err)=>err),
    getFacility: async (data1, mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/products`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data1.bookingController}getfacilitysummary`, data1).catch((err)=>err)
};
const $7abecb2894dde2ba$export$b6aad051bad07f12 = {
    getProducts: async (data1, mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/products`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data1.bookingController}getfacilitysummary`, data1).catch((err)=>err),
    getAvailability: async (data1, mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/availability`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data1.bookingController}getavailableslots`, data1).catch((err)=>err),
    getParkingSpaceAvailability: async (data1, mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/parkingpaceavailability`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data1.bookingController}getparkingspaceavailability`, data1).catch((err)=>err),
    getAccessDeviceAvailability: async (data1, mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/accessdeviceavailability`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/booking/getaccessdeviceavailability`, data1, "POST").catch((err)=>err),
    createSalesOrderDraft: async (data1, mocked, lang)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/createsalesorderdraft`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/booking/createsalesorderdraft`, data1, lang, "POST").catch((err)=>err),
    updateSalesOrder: async (data1, mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/updatesalesorder`, data1).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data1.bookingflowPage}updatesalesorder`, data1.form, "POST").catch((err)=>err),
    confirmSalesOrder: async (data1, mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/confirmsalesorder`, data1).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data1.bookingflowPage}confirmsalesorder`, data1.form, "POST").catch((err)=>err),
    prepareSalesOrderAttachmentUpload: async (data1)=>(0, $lA5kC.apiPromise)(`/booking/preparesalesorderattachmentupload`, data1, null, "POST").catch((err)=>err),
    linkSalesOrderAttachments: async (data1)=>(0, $lA5kC.apiPromise)(`/booking/linksalesorderattachments`, data1, null, "POST").catch((err)=>err),
    getPaymentOptions: async (mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/paymentoptions`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data.bookingflowPage}paymentoptions`).catch((err)=>err),
    getFlexbookingPrice: async (data1, mocked, lang)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/getflexbookingprice`, data1).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data1.bookingController}getflexbookingprice`, data1, lang).catch((err)=>err)
};
const $7abecb2894dde2ba$export$6b501c78a3684162 = {
    getLoggedInUser: async (mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/loggedincustomer`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data.bookingflowPage}loggedincustomer`).catch((err)=>err),
    createOrEditCustomer: async (data1, mocked, lang)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/createoreditcustomer`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data1.bookingController}createoreditcustomer`, data1.form, lang, "POST").catch((err)=>err),
    updateAccount: async (data1, mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/updatecustomer`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data1.bookingflowPage}updatecustomer`, data1.form, "POST").catch((err)=>err)
};
const $7abecb2894dde2ba$export$f227cb3279b11c6 = {
    getCustomerVehicles: async (data1, mocked, lang)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/getvehicles`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data1.bookingController}getvehicles`, null, lang).catch((err)=>err),
    createCustomerVehicle: async (data1, mocked, lang)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/createvehicle`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data1.bookingController}createvehicle`, data1.form, lang, "POST").catch((err)=>err)
};
const $7abecb2894dde2ba$export$ac37114f3704cec7 = {
    createTempLock: async (data1, mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/createtempLock`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/booking/createtemplock`, data1, "POST").catch((err)=>err),
    removeTempLock: async (data1, mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/removetempLock`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/booking/removetempLock`, data1, "POST").catch((err)=>err),
    updateTempLock: async (data1, mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedPromise(`/bookingflow/updatetempLock`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/booking/updatetempLock`, data1, "POST").catch((err)=>err)
};
const $7abecb2894dde2ba$export$18f430e15f133060 = {
    getCreditcardPaymentUrl: async (data1, mocked)=>mocked ? $7abecb2894dde2ba$var$apiMockedHtmlPromise(`/bookingflow/registerpayment`).catch((err)=>err) : (0, $lA5kC.htmlPromise)(`${data1.bookingflowPage}registerpayment`, data1.form, "POST").catch((err)=>err)
};
const $7abecb2894dde2ba$export$e0969da9b8fb378d = {
    getTestCall: async (data1, returnTime = 3000)=>{
        return new Promise((resolve)=>{
            console.log(`Test call (${returnTime}ms). Data: `, data1);
            setTimeout(()=>{
                resolve({
                    status: 200,
                    info: "OK",
                    body: "Test call (3000ms)"
                });
            }, returnTime);
        });
    }
};
const $7abecb2894dde2ba$var$apiMockedPromise = (url, data1 = {}, returnTime = 0)=>{
    return new Promise((resolve)=>{
        let returnData;
        let status = 200;
        let info = "OK";
        //let returnTime = 3000; //Milliseconds
        if (url.lastIndexOf("/bookingflow/facility", 0) === 0) returnData = (0, $5TEB1.mockedData).facility;
        else if (url.lastIndexOf("/bookingflow/products", 0) === 0) returnData = (0, $5TEB1.mockedData).products;
        else if (url.lastIndexOf("/bookingflow/availability", 0) === 0) returnData = {
            Availability: Math.floor(Math.random() * 6) + 1
        }, returnTime = 2000;
        else if (url.lastIndexOf("/bookingflow/parkingpaceavailability", 0) === 0) //const mockedReturnData = [[], mockedData.parkingSpaceAvailability];
        returnData = (0, $5TEB1.mockedData).parkingSpaceAvailability, returnTime = 2000; //mockedReturnData[Math.floor(Math.random() * mockedReturnData.length)], returnTime = 2000;
        else if (url.lastIndexOf("/bookingflow/getflexbookingprice", 0) === 0) {
            var date1 = new Date(data1.startDate);
            var date2 = new Date(data1.endDate);
            var Difference_In_Time = date2.getTime() - date1.getTime();
            var Difference_In_Days = Difference_In_Time / 86400000;
            returnData = new Intl.NumberFormat({
                maximumFractionDigits: 2,
                style: "currency"
            }).format(Difference_In_Days * 100) + " SEK", returnTime = 2000;
        } else if (url.lastIndexOf("/bookingflow/paymentoptions", 0) === 0) returnData = (0, $5TEB1.mockedData).paymentoptions;
        else if (url.lastIndexOf("/bookingflow/getvehicles", 0) === 0) returnData = (0, $5TEB1.mockedData).userVehicleList;
        else if (url.lastIndexOf("/bookingflow/createcustomer", 0) === 0) returnData = (0, $5TEB1.mockedData).userInformation, returnTime = 3000;
        else returnData = "No mocked api endpoint match!";
        console.log(`Mocked data: ${url}, data: `, data1, {
            status: 200,
            info: "OK",
            body: returnData
        });
        setTimeout(()=>{
            resolve({
                status: status,
                info: info,
                body: returnData
            });
        }, returnTime === 0 ? Math.floor(Math.random() * 5) * 1000 : returnTime);
    });
};
const $7abecb2894dde2ba$var$apiMockedHtmlPromise = (url, data1 = {}, returnTime = 0)=>{
    return new Promise((resolve)=>{
        let returnData;
        let status = 200;
        let info = "OK";
        //let returnTime = 3000; //Milliseconds
        if (url.lastIndexOf("/bookingflow/registerpayment", 0) === 0) returnData = '"https://test.epayment.nets.eu/Terminal/default.aspx?merchantId=12003812&transactionId="';
        else returnData = "No mocked api endpoint match!";
        console.log(`Mocked data: ${url}, data: `, data1, {
            status: 200,
            info: "OK",
            body: returnData
        });
        setTimeout(()=>{
            resolve({
                status: status,
                info: info,
                body: returnData
            });
        }, returnTime === 0 ? Math.floor(Math.random() * 5) * 1000 : returnTime);
    });
};

});
parcelRegister("lA5kC", function(module, exports) {

$parcel$export(module.exports, "apiPromise", function () { return $fb6118876dec745b$export$778a6b8517409d2; });
$parcel$export(module.exports, "htmlPromise", function () { return $fb6118876dec745b$export$bf020756f50b64a3; });
parcelRequire("f83fa");
parcelRequire("8RjC9");

var $8OcmI = parcelRequire("8OcmI");

var $fUL3Y = parcelRequire("fUL3Y");
const $fb6118876dec745b$export$778a6b8517409d2 = (url, data, lang = null, requestMethod = "GET")=>{
    if (lang && lang.length > 2) {
        requestMethod = lang;
        lang = null;
    }
    const apiHeaders = new Headers();
    if (lang) apiHeaders.append("Override-Language", lang);
    const userHash = (0, $fUL3Y.getCookie)("__aimopark-user-hash");
    if (userHash) apiHeaders.append("Authorization", "Bearer " + userHash);
    const isFormData = data instanceof FormData;
    if (!isFormData) apiHeaders.set("Content-Type", "application/json");
    if (data && (requestMethod === "GET" || requestMethod === "HEAD")) url += (url.indexOf("?") === -1 ? "?" : "&") + new (0, $8OcmI.default)(data).toString();
    return new Promise((resolve, reject)=>{
        const apiRequest = new Request(url, {
            method: requestMethod,
            cache: "no-cache",
            headers: apiHeaders,
            body: requestMethod !== "GET" && requestMethod !== "HEAD" ? isFormData ? data : JSON.stringify(data) : null
        });
        fetch(apiRequest).then((response)=>{
            if (!response) return;
            if (response.status === 401 || response.status === 403 || response.StatusCode === 401 || response.StatusCode === 403) reject({
                status: response.StatusCode ?? response.status,
                info: "Authentication error.",
                body: response
            });
            else if (response.status === 404 || response.StatusCode === 404) reject({
                status: response.StatusCode ?? response.status,
                info: "Endpoint not found.",
                body: "Requested URL: " + url
            });
            else if (response.status >= 500 && response.status < 600 || response.StatusCode >= 500 && response.StatusCode < 600) reject({
                status: response.StatusCode ?? response.status,
                info: "Internal server error.",
                body: "Requested URL: " + url
            });
            else return response.json();
        }).then((response)=>{
            if (!response) return;
            resolve({
                status: response.StatusCode ?? 200,
                info: "OK",
                body: response.Data ?? response,
                errorMessage: response.ErrorMessage
            });
        }).catch((error)=>{
            reject({
                status: 400,
                info: "Error.",
                body: error
            });
        });
    });
};
const $fb6118876dec745b$export$bf020756f50b64a3 = (url, data, lang = null, requestMethod = "GET")=>{
    if (lang && lang.length > 2) {
        requestMethod = lang;
        lang = null;
    }
    const apiHeaders = new Headers();
    apiHeaders.append("Content-Type", "application/json");
    if (lang) apiHeaders.append("Override-Language", lang);
    if (data && (requestMethod === "GET" || requestMethod === "HEAD")) url += (url.indexOf("?") === -1 ? "?" : "&") + new (0, $8OcmI.default)(data).toString();
    return new Promise((resolve, reject)=>{
        const apiRequest = new Request(url, {
            method: requestMethod,
            cache: "no-cache",
            headers: apiHeaders,
            body: requestMethod !== "GET" && requestMethod !== "HEAD" ? JSON.stringify(data) : null
        });
        fetch(apiRequest).then((response)=>{
            if (response) return response.text();
            else reject({
                status: 500,
                info: "Internal server error.",
                body: ""
            });
        }).then((html)=>{
            if (html && html.length > 0) resolve({
                status: 200,
                body: html
            });
            else reject({
                status: 500,
                info: "Internal server error.",
                body: ""
            });
        }).catch((error)=>{
            reject({
                status: 500,
                info: "Internal server error.",
                body: ""
            });
        });
    });
};

});
parcelRegister("f83fa", function(module, exports) {

var $93WE8 = parcelRequire("93WE8");

var $i6SxA = parcelRequire("i6SxA");

var $aQ1iF = parcelRequire("aQ1iF");

var $7tZ9z = parcelRequire("7tZ9z");
/** @suppress {undefinedVars} */ var $b03a1e7a173aa7ad$var$globalNS = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}();
// Expose the polyfill if Promise is undefined or set to a
// non-function value. The latter can be due to a named HTMLElement
// being exposed by browsers for legacy reasons.
// https://github.com/taylorhakes/promise-polyfill/issues/114
if (typeof $b03a1e7a173aa7ad$var$globalNS["Promise"] !== "function") $b03a1e7a173aa7ad$var$globalNS["Promise"] = (0, $93WE8.default);
else {
    if (!$b03a1e7a173aa7ad$var$globalNS.Promise.prototype["finally"]) $b03a1e7a173aa7ad$var$globalNS.Promise.prototype["finally"] = (0, $i6SxA.default);
    if (!$b03a1e7a173aa7ad$var$globalNS.Promise.allSettled) $b03a1e7a173aa7ad$var$globalNS.Promise.allSettled = (0, $aQ1iF.default);
    if (!$b03a1e7a173aa7ad$var$globalNS.Promise.any) $b03a1e7a173aa7ad$var$globalNS.Promise.any = (0, $7tZ9z.default);
}

});
parcelRegister("93WE8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6991e2caa2f14613$export$2e2bcd8739ae039; });

var $i6SxA = parcelRequire("i6SxA");

var $aQ1iF = parcelRequire("aQ1iF");

var $7tZ9z = parcelRequire("7tZ9z");
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $6991e2caa2f14613$var$setTimeoutFunc = setTimeout;
function $6991e2caa2f14613$var$isArray(x) {
    return Boolean(x && typeof x.length !== "undefined");
}
function $6991e2caa2f14613$var$noop() {}
// Polyfill for Function.prototype.bind
function $6991e2caa2f14613$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $6991e2caa2f14613$var$Promise(fn) {
    if (!(this instanceof $6991e2caa2f14613$var$Promise)) throw new TypeError("Promises must be constructed via new");
    if (typeof fn !== "function") throw new TypeError("not a function");
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $6991e2caa2f14613$var$doResolve(fn, this);
}
function $6991e2caa2f14613$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $6991e2caa2f14613$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $6991e2caa2f14613$var$resolve : $6991e2caa2f14613$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $6991e2caa2f14613$var$reject(deferred.promise, e);
            return;
        }
        $6991e2caa2f14613$var$resolve(deferred.promise, ret);
    });
}
function $6991e2caa2f14613$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError("A promise cannot be resolved with itself.");
        if (newValue && (typeof newValue === "object" || typeof newValue === "function")) {
            var then = newValue.then;
            if (newValue instanceof $6991e2caa2f14613$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $6991e2caa2f14613$var$finale(self);
                return;
            } else if (typeof then === "function") {
                $6991e2caa2f14613$var$doResolve($6991e2caa2f14613$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $6991e2caa2f14613$var$finale(self);
    } catch (e) {
        $6991e2caa2f14613$var$reject(self, e);
    }
}
function $6991e2caa2f14613$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $6991e2caa2f14613$var$finale(self);
}
function $6991e2caa2f14613$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $6991e2caa2f14613$var$Promise._immediateFn(function() {
        if (!self._handled) $6991e2caa2f14613$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$6991e2caa2f14613$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $6991e2caa2f14613$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $6991e2caa2f14613$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $6991e2caa2f14613$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $6991e2caa2f14613$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $6991e2caa2f14613$var$reject(self, ex);
    }
}
$6991e2caa2f14613$var$Promise.prototype["catch"] = function(onRejected) {
    return this.then(null, onRejected);
};
$6991e2caa2f14613$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($6991e2caa2f14613$var$noop);
    $6991e2caa2f14613$var$handle(this, new $6991e2caa2f14613$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$6991e2caa2f14613$var$Promise.prototype["finally"] = (0, $i6SxA.default);
$6991e2caa2f14613$var$Promise.all = function(arr) {
    return new $6991e2caa2f14613$var$Promise(function(resolve, reject) {
        if (!$6991e2caa2f14613$var$isArray(arr)) return reject(new TypeError("Promise.all accepts an array"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === "object" || typeof val === "function")) {
                    var then = val.then;
                    if (typeof then === "function") {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$6991e2caa2f14613$var$Promise.any = (0, $7tZ9z.default);
$6991e2caa2f14613$var$Promise.allSettled = (0, $aQ1iF.default);
$6991e2caa2f14613$var$Promise.resolve = function(value) {
    if (value && typeof value === "object" && value.constructor === $6991e2caa2f14613$var$Promise) return value;
    return new $6991e2caa2f14613$var$Promise(function(resolve) {
        resolve(value);
    });
};
$6991e2caa2f14613$var$Promise.reject = function(value) {
    return new $6991e2caa2f14613$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$6991e2caa2f14613$var$Promise.race = function(arr) {
    return new $6991e2caa2f14613$var$Promise(function(resolve, reject) {
        if (!$6991e2caa2f14613$var$isArray(arr)) return reject(new TypeError("Promise.race accepts an array"));
        for(var i = 0, len = arr.length; i < len; i++)$6991e2caa2f14613$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$6991e2caa2f14613$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === "function" && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $6991e2caa2f14613$var$setTimeoutFunc(fn, 0);
};
$6991e2caa2f14613$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== "undefined" && console) console.warn("Possible Unhandled Promise Rejection:", err); // eslint-disable-line no-console
};
var $6991e2caa2f14613$export$2e2bcd8739ae039 = $6991e2caa2f14613$var$Promise;

});
parcelRegister("i6SxA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2f31831a9dae2a8$export$2e2bcd8739ae039; });
/**
 * @this {Promise}
 */ function $d2f31831a9dae2a8$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $d2f31831a9dae2a8$export$2e2bcd8739ae039 = $d2f31831a9dae2a8$var$finallyConstructor;

});

parcelRegister("aQ1iF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e3fc4dc87ed26ae$export$2e2bcd8739ae039; });
function $7e3fc4dc87ed26ae$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== "undefined")) return reject(new TypeError(typeof arr + " " + arr + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === "object" || typeof val === "function")) {
                var then = val.then;
                if (typeof then === "function") {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: "rejected",
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: "fulfilled",
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $7e3fc4dc87ed26ae$export$2e2bcd8739ae039 = $7e3fc4dc87ed26ae$var$allSettled;

});

parcelRegister("7tZ9z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $572aada0f42721c7$export$2e2bcd8739ae039; });
/**
 * @constructor
 */ function $572aada0f42721c7$var$AggregateError(errors, message) {
    this.name = "AggregateError", this.errors = errors;
    this.message = message || "";
}
$572aada0f42721c7$var$AggregateError.prototype = Error.prototype;
function $572aada0f42721c7$var$any(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== "undefined")) return reject(new TypeError("Promise.any accepts an array"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return reject();
        var rejectionReasons = [];
        for(var i = 0; i < args.length; i++)try {
            P.resolve(args[i]).then(resolve).catch(function(error) {
                rejectionReasons.push(error);
                if (rejectionReasons.length === args.length) reject(new $572aada0f42721c7$var$AggregateError(rejectionReasons, "All promises were rejected"));
            });
        } catch (ex) {
            reject(ex);
        }
    });
}
var $572aada0f42721c7$export$2e2bcd8739ae039 = $572aada0f42721c7$var$any;

});



parcelRegister("8RjC9", function(module, exports) {
// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
parcelRequire("fVco5");
module.exports = self.fetch.bind(self);

});
parcelRegister("fVco5", function(module, exports) {
/* eslint-disable no-prototype-builtins */ var $b975c9c64fa05e56$var$g = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== "undefined" && $parcel$global || {};
var $b975c9c64fa05e56$var$support = {
    searchParams: "URLSearchParams" in $b975c9c64fa05e56$var$g,
    iterable: "Symbol" in $b975c9c64fa05e56$var$g && "iterator" in Symbol,
    blob: "FileReader" in $b975c9c64fa05e56$var$g && "Blob" in $b975c9c64fa05e56$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: "FormData" in $b975c9c64fa05e56$var$g,
    arrayBuffer: "ArrayBuffer" in $b975c9c64fa05e56$var$g
};
function $b975c9c64fa05e56$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($b975c9c64fa05e56$var$support.arrayBuffer) {
    var $b975c9c64fa05e56$var$viewClasses = [
        "[object Int8Array]",
        "[object Uint8Array]",
        "[object Uint8ClampedArray]",
        "[object Int16Array]",
        "[object Uint16Array]",
        "[object Int32Array]",
        "[object Uint32Array]",
        "[object Float32Array]",
        "[object Float64Array]"
    ];
    var $b975c9c64fa05e56$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $b975c9c64fa05e56$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $b975c9c64fa05e56$var$normalizeName(name) {
    if (typeof name !== "string") name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $b975c9c64fa05e56$var$normalizeValue(value) {
    if (typeof value !== "string") value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $b975c9c64fa05e56$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($b975c9c64fa05e56$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $b975c9c64fa05e56$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $b975c9c64fa05e56$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$b975c9c64fa05e56$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $b975c9c64fa05e56$var$normalizeName(name);
    value = $b975c9c64fa05e56$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ", " + value : value;
};
$b975c9c64fa05e56$export$79b704688b15c0f4.prototype["delete"] = function(name) {
    delete this.map[$b975c9c64fa05e56$var$normalizeName(name)];
};
$b975c9c64fa05e56$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $b975c9c64fa05e56$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$b975c9c64fa05e56$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($b975c9c64fa05e56$var$normalizeName(name));
};
$b975c9c64fa05e56$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$b975c9c64fa05e56$var$normalizeName(name)] = $b975c9c64fa05e56$var$normalizeValue(value);
};
$b975c9c64fa05e56$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$b975c9c64fa05e56$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $b975c9c64fa05e56$var$iteratorFor(items);
};
$b975c9c64fa05e56$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $b975c9c64fa05e56$var$iteratorFor(items);
};
$b975c9c64fa05e56$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $b975c9c64fa05e56$var$iteratorFor(items);
};
if ($b975c9c64fa05e56$var$support.iterable) $b975c9c64fa05e56$export$79b704688b15c0f4.prototype[Symbol.iterator] = $b975c9c64fa05e56$export$79b704688b15c0f4.prototype.entries;
function $b975c9c64fa05e56$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
    body.bodyUsed = true;
}
function $b975c9c64fa05e56$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $b975c9c64fa05e56$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $b975c9c64fa05e56$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $b975c9c64fa05e56$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $b975c9c64fa05e56$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : "utf-8";
    reader.readAsText(blob, encoding);
    return promise;
}
function $b975c9c64fa05e56$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join("");
}
function $b975c9c64fa05e56$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $b975c9c64fa05e56$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = "";
        } else if (typeof body === "string") this._bodyText = body;
        else if ($b975c9c64fa05e56$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($b975c9c64fa05e56$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($b975c9c64fa05e56$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($b975c9c64fa05e56$var$support.arrayBuffer && $b975c9c64fa05e56$var$support.blob && $b975c9c64fa05e56$var$isDataView(body)) {
            this._bodyArrayBuffer = $b975c9c64fa05e56$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($b975c9c64fa05e56$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $b975c9c64fa05e56$var$isArrayBufferView(body))) this._bodyArrayBuffer = $b975c9c64fa05e56$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get("content-type")) {
            if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
            else if ($b975c9c64fa05e56$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
        }
    };
    if ($b975c9c64fa05e56$var$support.blob) this.blob = function() {
        var rejected = $b975c9c64fa05e56$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $b975c9c64fa05e56$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($b975c9c64fa05e56$var$support.blob) return this.blob().then($b975c9c64fa05e56$var$readBlobAsArrayBuffer);
        else throw new Error("could not read as ArrayBuffer");
    };
    this.text = function() {
        var rejected = $b975c9c64fa05e56$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $b975c9c64fa05e56$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($b975c9c64fa05e56$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error("could not read FormData body as text");
        else return Promise.resolve(this._bodyText);
    };
    if ($b975c9c64fa05e56$var$support.formData) this.formData = function() {
        return this.text().then($b975c9c64fa05e56$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $b975c9c64fa05e56$var$methods = [
    "CONNECT",
    "DELETE",
    "GET",
    "HEAD",
    "OPTIONS",
    "PATCH",
    "POST",
    "PUT",
    "TRACE"
];
function $b975c9c64fa05e56$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $b975c9c64fa05e56$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $b975c9c64fa05e56$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $b975c9c64fa05e56$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $b975c9c64fa05e56$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError("Already read");
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $b975c9c64fa05e56$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || "same-origin";
    if (options.headers || !this.headers) this.headers = new $b975c9c64fa05e56$export$79b704688b15c0f4(options.headers);
    this.method = $b975c9c64fa05e56$var$normalizeMethod(options.method || this.method || "GET");
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ("AbortController" in $b975c9c64fa05e56$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
    this._initBody(body);
    if (this.method === "GET" || this.method === "HEAD") {
        if (options.cache === "no-store" || options.cache === "no-cache") {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
            }
        }
    }
}
$b975c9c64fa05e56$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $b975c9c64fa05e56$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $b975c9c64fa05e56$var$decode(body) {
    var form = new FormData();
    body.trim().split("&").forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split("=");
            var name = split.shift().replace(/\+/g, " ");
            var value = split.join("=").replace(/\+/g, " ");
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $b975c9c64fa05e56$var$parseHeaders(rawHeaders) {
    var headers = new $b975c9c64fa05e56$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split("\r").map(function(header) {
        return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(":");
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(":").trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn("Response " + error.message);
            }
        }
    });
    return headers;
}
$b975c9c64fa05e56$var$Body.call($b975c9c64fa05e56$export$7fa6c5b6f8193917.prototype);
function $b975c9c64fa05e56$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $b975c9c64fa05e56$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = "default";
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
    this.headers = new $b975c9c64fa05e56$export$79b704688b15c0f4(options.headers);
    this.url = options.url || "";
    this._initBody(bodyInit);
}
$b975c9c64fa05e56$var$Body.call($b975c9c64fa05e56$export$9f633d56d7ec90d3.prototype);
$b975c9c64fa05e56$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $b975c9c64fa05e56$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $b975c9c64fa05e56$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$b975c9c64fa05e56$export$9f633d56d7ec90d3.error = function() {
    var response = new $b975c9c64fa05e56$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ""
    });
    response.ok = false;
    response.status = 0;
    response.type = "error";
    return response;
};
var $b975c9c64fa05e56$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$b975c9c64fa05e56$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($b975c9c64fa05e56$var$redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
    return new $b975c9c64fa05e56$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $b975c9c64fa05e56$export$fe58bcf938607f6a = $b975c9c64fa05e56$var$g.DOMException;
try {
    new $b975c9c64fa05e56$export$fe58bcf938607f6a();
} catch (err) {
    $b975c9c64fa05e56$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $b975c9c64fa05e56$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $b975c9c64fa05e56$export$fe58bcf938607f6a.prototype.constructor = $b975c9c64fa05e56$export$fe58bcf938607f6a;
}
function $b975c9c64fa05e56$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $b975c9c64fa05e56$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $b975c9c64fa05e56$export$fe58bcf938607f6a("Aborted", "AbortError"));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $b975c9c64fa05e56$var$parseHeaders(xhr.getAllResponseHeaders() || "")
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf("file://") === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
            var body = "response" in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $b975c9c64fa05e56$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError("Network request failed"));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError("Network request timed out"));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $b975c9c64fa05e56$export$fe58bcf938607f6a("Aborted", "AbortError"));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === "" && $b975c9c64fa05e56$var$g.location.href ? $b975c9c64fa05e56$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === "include") xhr.withCredentials = true;
        else if (request.credentials === "omit") xhr.withCredentials = false;
        if ("responseType" in xhr) {
            if ($b975c9c64fa05e56$var$support.blob) xhr.responseType = "blob";
            else if ($b975c9c64fa05e56$var$support.arrayBuffer) xhr.responseType = "arraybuffer";
        }
        if (init && typeof init.headers === "object" && !(init.headers instanceof $b975c9c64fa05e56$export$79b704688b15c0f4 || $b975c9c64fa05e56$var$g.Headers && init.headers instanceof $b975c9c64fa05e56$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($b975c9c64fa05e56$var$normalizeName(name));
                xhr.setRequestHeader(name, $b975c9c64fa05e56$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener("abort", abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
    });
}
$b975c9c64fa05e56$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$b975c9c64fa05e56$var$g.fetch) {
    $b975c9c64fa05e56$var$g.fetch = $b975c9c64fa05e56$export$e7aa7bc5c1b3cfb3;
    $b975c9c64fa05e56$var$g.Headers = $b975c9c64fa05e56$export$79b704688b15c0f4;
    $b975c9c64fa05e56$var$g.Request = $b975c9c64fa05e56$export$7fa6c5b6f8193917;
    $b975c9c64fa05e56$var$g.Response = $b975c9c64fa05e56$export$9f633d56d7ec90d3;
}

});


parcelRegister("fUL3Y", function(module, exports) {

$parcel$export(module.exports, "getCookie", function () { return $b96097be8dcb5564$export$4be65e66cfa2648a; });
const $b96097be8dcb5564$var$cookieTime = (minutes)=>{
    var now = new Date();
    var time = now.getTime();
    time += minutes * 60000;
    now.setTime(time);
    return now;
};
const $b96097be8dcb5564$export$110700823644f4a6 = (name, value, minutes = 60)=>{
    document.cookie = `${name}=${value}; expires=${$b96097be8dcb5564$var$cookieTime(minutes)}; path=/`;
};
const $b96097be8dcb5564$export$4be65e66cfa2648a = (name)=>{
    var cookieName = name + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1);
        if (c.indexOf(cookieName) == 0) return c.substring(cookieName.length, c.length);
    }
    return "";
};
const $b96097be8dcb5564$export$6a874b7a74007875 = (name)=>{
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
};

});


parcelRegister("5TEB1", function(module, exports) {

$parcel$export(module.exports, "mockedData", function () { return $44b1945d6691bf89$export$c8de751bd7a46f3d; });
const $44b1945d6691bf89$export$c8de751bd7a46f3d = {
    facility: {
        "Uid": "SE-12345",
        "Name": "Mockat testgarage",
        "Address": {
            "City": "Karlstad"
        }
    },
    products: [
        {
            "AccessDevices": [],
            "Zone": "Mockat testgarage",
            "ZoneId": "SE-8500112",
            "Text": "Pre-booking",
            "OverviewText": "Weekend - Citygaraget",
            "Id": "9451",
            "Type": "Unreserved",
            "ZoneAndProduct": "SE-8500112-9451",
            "MonthlyPrice": null,
            "QuarterlyPrice": null,
            "HalfYearlyPrice": null,
            "AnnualPrice": null,
            "WeekdayPrices": [
                null,
                null,
                null,
                null,
                900,
                900,
                900
            ],
            "SundayPrice": null,
            "Currency": "SEK",
            "ExtraFee": null,
            "Description": null,
            "PhysicalZoneId": "SE-8500112",
            "MaxSalesAmount": "50",
            "ProductSubType": "PreBooking",
            "IsFlexbookingProduct": false,
            "ProcessType": "Pre-booking"
        },
        {
            "Zone": "Mockat testgarage",
            "ZoneId": "SE-8500112",
            "Text": "Flexbooking",
            "OverviewText": "F\xf6rboka parkering - Citygaraget",
            "Id": "9355",
            "Type": "Unreserved",
            "ZoneAndProduct": "SE-8500112-9355",
            "MonthlyPrice": null,
            "QuarterlyPrice": null,
            "HalfYearlyPrice": null,
            "AnnualPrice": null,
            "WeekdayPrices": [
                null,
                null,
                null,
                null,
                null,
                null,
                null
            ],
            "SundayPrice": null,
            "Currency": "SEK",
            "ExtraFee": null,
            "Description": null,
            "PhysicalZoneId": "SE-8500112",
            "MaxSalesAmount": "20",
            "ProductSubType": "PreBooking",
            "IsFlexbookingProduct": false,
            "ProcessType": "Flexbooking"
        },
        {
            "AccessDevices": [],
            "ZoneId": "1111",
            "Zone": "Mockat testgarage",
            "Text": "SeasonTicket, Reserverad",
            "OverviewText": "EN- 7x24 Parkering dygnet runt",
            "Id": "999999",
            "Type": "Reserved",
            "ZoneAndProduct": "SE-8500112-9357",
            "MonthlyPrice": "1640.345443534535",
            "QuarterlyPrice": "4920.3454354",
            "HalfYearlyPrice": "9840.00",
            "AnnualPrice": "19680.00",
            "Currency": "SEK",
            "ExtraFee": null,
            "ProcessType": "SeasonTicket"
        },
        {
            "AccessDevices": [],
            "ZoneId": "2222",
            "Zone": "Mockat testgarage",
            "Text": "SeasonTicket, UNreserverad",
            "OverviewText": "EN- 7x24 Reserverad carport med el",
            "Id": "999998",
            "Type": "Unreserved",
            "ZoneAndProduct": "SE-8500112-9359",
            "MonthlyPrice": "1640.00",
            "QuarterlyPrice": "4920.00",
            "HalfYearlyPrice": "9840.00",
            "AnnualPrice": "19680.00",
            "Currency": "SEK",
            "ExtraFee": null,
            "ProcessType": "SeasonTicket"
        }
    ],
    parkingSpaceAvailability: [
        {
            "PmcIdRef": "1836",
            "LastBookingEnds": "/Date(-62135596800000)/",
            "ParkingSpaceStatus": "NOT_AVAILABLE",
            "ParkingSpace": {
                "Uid": "SE-10142-018-2174",
                "ParkingZoneUid": "SE-1014201",
                "Name": "018",
                "DateCreated": "/Date(1475988359000)/",
                "CreatedBy": "C2C.migration",
                "LastUpdated": "/Date(1475988359000)/",
                "UpdatedBy": "C2C.migration",
                "Type": "Reserverad plats",
                "Reserved": true,
                "InternalNote": null,
                "ExternalNote": null,
                "Blocked": "false",
                "AccessDeviceExternalNote": null
            }
        },
        {
            "PmcIdRef": "1836",
            "LastBookingEnds": "/Date(-62135596800000)/",
            "ParkingSpaceStatus": "NOT_AVAILABLE",
            "ParkingSpace": {
                "Uid": "SE-10142-032-2175",
                "ParkingZoneUid": "SE-1014201",
                "Name": "032",
                "DateCreated": "/Date(1475988359000)/",
                "CreatedBy": "C2C.migration",
                "LastUpdated": "/Date(1475988359000)/",
                "UpdatedBy": "C2C.migration",
                "Type": "Reserverad plats",
                "Reserved": true,
                "InternalNote": null,
                "ExternalNote": null,
                "Blocked": "false",
                "AccessDeviceExternalNote": null
            }
        },
        {
            "PmcIdRef": "1836",
            "LastBookingEnds": "/Date(-62135596800000)/",
            "ParkingSpaceStatus": "NOT_AVAILABLE",
            "ParkingSpace": {
                "Uid": "SE-10142-033-2176",
                "ParkingZoneUid": "SE-1014201",
                "Name": "033",
                "DateCreated": "/Date(1475988359000)/",
                "CreatedBy": "C2C.migration",
                "LastUpdated": "/Date(1475988359000)/",
                "UpdatedBy": "C2C.migration",
                "Type": "Reserverad plats",
                "Reserved": true,
                "InternalNote": null,
                "ExternalNote": null,
                "Blocked": "false",
                "AccessDeviceExternalNote": null
            }
        }
    ],
    paymentoptions: [
        {
            text: "Monthly",
            currency: "SEK",
            optionPrice: 5725,
            id: "8bca584c-3125-49eb-9727-a99de7302281"
        },
        {
            text: "Quarterly",
            currency: "SEK",
            optionPrice: 17175,
            id: "a942b646-0fbe-4180-aea4-fdc196b3e321"
        },
        {
            text: "Yearly",
            currency: "SEK",
            optionPrice: 68700,
            id: "a942b646-0fbe-4180-aea4-fdc196b3e322"
        }
    ],
    userVehicleList: {
        VehicleList: [
            {
                Id: "1",
                LicensePlate: "ABC 123",
                Description: "Black SUV"
            },
            {
                Id: "2",
                LicensePlate: "DEF 456",
                Description: "White sedan"
            }
        ]
    },
    userInformation: {
        RecordId: "4ffbaf9b-e70d-4651-8feb-10dffc95671b",
        name: "Demo Demosson"
    }
};

});


parcelRegister("gXJP5", function(module, exports) {

$parcel$export(module.exports, "Error", function () { return $c595b388c77971d2$export$edf27be85e5f6da0; });

var $54dlf = parcelRequire("54dlf");
parcelRequire("ca3MY");

var $jl9cc = parcelRequire("jl9cc");
const $c595b388c77971d2$export$edf27be85e5f6da0 = (props)=>{
    const wrappingClass = [
        "single-step__section",
        "single-step__section--error"
    ];
    if (props.modifierClass) wrappingClass.push("single-step__section--" + props.modifierClass);
    if (props.children) wrappingClass.push("single-step__section--flex");
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: wrappingClass.join(" "),
        children: [
            props.text && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                children: /*#__PURE__*/ (0, $54dlf.jsx)((0, $jl9cc.HtmlOutput), {
                    html: props.text
                })
            }),
            props.children
        ]
    });
};

});
parcelRegister("jl9cc", function(module, exports) {

$parcel$export(module.exports, "HtmlOutput", function () { return $e1471c98e8fb03a9$export$adc82f868587f494; });

var $54dlf = parcelRequire("54dlf");
parcelRequire("ca3MY");
const $e1471c98e8fb03a9$export$6cb344a21ca18aec = (()=>{
    var element = document.createElement("div");
    const decodeHTMLEntities = (str)=>{
        if (str && typeof str === "string") {
            str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, "");
            str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, "");
            element.innerHTML = str;
            str = element.textContent;
            element.textContent = "";
        }
        return str;
    };
    return decodeHTMLEntities;
})();
const $e1471c98e8fb03a9$export$adc82f868587f494 = ({ html: html })=>{
    return /*#__PURE__*/ (0, $54dlf.jsx)("span", {
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};

});


parcelRegister("leuhm", function(module, exports) {

$parcel$export(module.exports, "Heading", function () { return $f75264953e7afb7f$export$a8a3e93435678ff9; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $8oRQh = parcelRequire("8oRQh");
const $f75264953e7afb7f$export$a8a3e93435678ff9 = (props)=>{
    const { bookingFlowContext: bookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    let headingText = "";
    if (props.text) headingText = props.text;
    else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.orderOverview.index) headingText = bookingFlowContext.localization.orderOverview.heading;
    else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.orderConfirmation.index) headingText = "";
    else headingText = bookingFlowContext.facility.name;
    if (headingText.length === 0) return null;
    return /*#__PURE__*/ (0, $54dlf.jsx)("h1", {
        className: "bookingflowpage__heading",
        children: headingText
    });
};

});

parcelRegister("cJ5lq", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("g6ndF", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("8BTjt", function(module, exports) {

$parcel$export(module.exports, "usePrevious", function () { return $644caf78e25ad1d1$export$5cae361ad82dce8b; });

var $ca3MY = parcelRequire("ca3MY");
const $644caf78e25ad1d1$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $ca3MY.useRef)();
    (0, $ca3MY.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};

});

parcelRegister("iFvPA", function(module, exports) {

$parcel$export(module.exports, "parseDate", function () { return $d974bf53dc110753$export$6b862160d295c8e; });
//Convert any nb, en, sv, fi date to string date in selected locale 

var $g6ndF = parcelRequire("g6ndF");
const $d974bf53dc110753$export$6b862160d295c8e = (date, locale, format)=>{
    if (!date) return;
    if (date._isAMomentObject || date.includes("Date")) date = (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(date).format("L");
    let dateFormat;
    if (date.includes("/")) dateFormat = "MM/DD/YYYY HH:mm:ss";
    if (date.includes(".")) dateFormat = "DD.MM.YYYY HH:mm:ss";
    if (date.includes("-")) dateFormat = "YYYY-MM-DD HH:mm:ss";
    return locale && format ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(date, dateFormat).locale(locale).format(format) : (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(date, dateFormat);
};

});

parcelRegister("se1IJ", function(module, exports) {

$parcel$export(module.exports, "ssnValidation", function () { return $054d7f0f6c03983f$export$4efbc020b8c6c20f; });
$parcel$export(module.exports, "organisationValidation", function () { return $054d7f0f6c03983f$export$9a96b7281e50aab2; });
$parcel$export(module.exports, "emailValidation", function () { return $054d7f0f6c03983f$export$b436214556bf9a87; });
$parcel$export(module.exports, "zipcodeValidation", function () { return $054d7f0f6c03983f$export$a08d7ae88efc5f2a; });
$parcel$export(module.exports, "phoneNumberValidation", function () { return $054d7f0f6c03983f$export$a6b7a3cb4a04329f; });
$parcel$export(module.exports, "validateFormObject", function () { return $054d7f0f6c03983f$export$d0487f67a781100d; });
$parcel$export(module.exports, "validateFormObjectAlt", function () { return $054d7f0f6c03983f$export$cb7dee1ee6558c32; });
const $054d7f0f6c03983f$export$4efbc020b8c6c20f = (ssn, country)=>{
    if (country === "sv" || country === "se") //YYYYMMDD-XXXX
    return /^(19|20)[0-9]{6}-[0-9]{4}$/.test(ssn);
    else if (country === "fi") //xxxxxx-zzzz (11 chars)
    //xxxxxxAzzzz (11 chars)
    //x = only digits
    //z = digits or letters
    return /^[0-9]{6}[-A][0-9a-zA-Z]{4}$/.test(ssn);
    else if (country === "no" || country === "nb") //xxxxxxxxxx (11 chars)
    //x = only digits
    return /^\d{11}$/.test(ssn);
    else return true;
};
const $054d7f0f6c03983f$export$9a96b7281e50aab2 = (organisationNumber, country)=>{
    if (organisationNumber.length === 0) return true;
    if (country === "sv" || country === "se") //XXXXXX-YYYY
    return /^[\d]{6}-[\d]{4}$/.test(organisationNumber);
    else if (country === "fi") //XXXXXXX-Y
    return /^[\d]{7}-[\d]{1}$/.test(organisationNumber);
    else if (country === "no" || country === "nb") //XXXXXXXXX
    return /^[\d]{9}$/.test(organisationNumber);
    else return true;
};
const $054d7f0f6c03983f$export$b436214556bf9a87 = (email)=>{
    if (/\S+@\S+\.\S+/.test(email)) return true;
    return false;
};
const $054d7f0f6c03983f$export$a08d7ae88efc5f2a = (zipcode, country)=>{
    const onlyNumbers = zipcode.replace(/\D/g, "");
    const allButNumbers = zipcode.replace(/[0-9]/g, "");
    //We used to check number of digits in postal code, 4 for norway, 5 for sweden/finland.
    //But I think we used the country of the account, instead of the country selected in the address, for the validation.
    //And now that we added all the countries of the world we dont see the point in checking the formating only for the nordic ones.
    //So rather than fixing what country gets sent in I just change the validation to check that the field is not empty.
    //Country is no longer used in this validation
    /*if(country === 'no' || country === 'nb')
    return (onlyNumbers.length === 4 && allButNumbers.length === 0);*/ return onlyNumbers.length > 0 || allButNumbers.length > 0;
};
const $054d7f0f6c03983f$export$d2ef0846be50186d = (licensePlate, countryCode)=>{
    const lp = licensePlate.replace(/\s+/g, "");
    if (countryCode && countryCode.toUpperCase() === "S") return lp.length > 1 && lp.length < 8 && /^[A-Za-z0-9åÅäÄöÖ ]+$/.test(licensePlate);
    else if (countryCode && countryCode.toUpperCase() === "FIN") return lp.length > 1 && lp.length < 8 && /^[A-Za-z0-9åÅäÄöÖ-]+$/.test(licensePlate);
    else if (countryCode && countryCode.toUpperCase() === "N") return lp.length > 1 && lp.length < 8 && /^[A-Za-z0-9åÅäÄöÖüÜæÆøØ ]+$/.test(licensePlate);
    else return lp.length > 1 && /^[A-Za-z0-9åÅäÄöÖüÜæÆøØ ]+$/.test(licensePlate);
    return false;
};
const $054d7f0f6c03983f$export$a6b7a3cb4a04329f = (phonenumber)=>{
    if (/^\+(?:[0-9] ?){6,14}[0-9]$/.test(phonenumber)) return true;
    return false;
};
const $054d7f0f6c03983f$var$formObjectValue = (item)=>{
    if (!item.value) return item;
    if (!item.value.elementType || item.value.elementType === "text" || item.value.elementType === "phone" || item.value.elementType === "ssn" || item.value.elementType === "email" || item.value.elementType === "password" || item.value.elementType === "zipcode" || item.value.elementType === "organisation" || item.value.elementType === "time" || item.value.elementType === "licenseplate") return item.value.text ?? item.value.Text ?? "";
    else if (item.value.elementType === "date") return item.value.date ?? item.value.Date ?? null;
    else if (item.value.elementType === "number") return item.value.number ?? item.value.Number ?? null;
    else if (item.value.elementType === "select" && item.optionIdentifier) return item.value.item[item.optionIdentifier] ?? null;
    else if (item.value.elementType === "select" && !item.optionIdentifier) return item.value.item.id ?? item.value.item.Id ?? null;
    else if (item.value.elementType === "radio") return item.value.item.id ?? item.value.item.Id ?? null;
    else if (item.value.elementType === "checkbox") return item.value.selected ?? item.value.Selected ?? false;
};
const $054d7f0f6c03983f$export$d0487f67a781100d = (form, errorMessages, country = "sv")=>{
    let formValidationError = false;
    let cleanFormData = {};
    let flatCleanFormData = {};
    Object.keys(form).forEach((key)=>{
        let item = form[key];
        if (item.value.required && !item.value.elementType && item.value.text.length === 0 || item.value.required && item.value.elementType === "text" && item.value.text.length === 0 || item.value.required && item.value.elementType === "phone" && !item.value.skipValidation && item.value.text.length === 0 || item.value.required && item.value.elementType === "licenseplate" && !item.value.skipValidation && item.value.text.length === 0 || item.value.required && item.value.elementType === "date" && !item.value.date || item.value.required && item.value.elementType === "number" && !item.value.number && (item.value.text?.length ?? 0) === 0 || item.value.required && item.value.elementType === "ssn" && item.value.text.length === 0 || item.value.required && item.value.elementType === "organisation" && item.value.text.length === 0 || item.value.required && item.value.elementType === "zipcode" && item.value.text.length === 0 || item.value.required && item.value.elementType === "email" && item.value.text.length === 0 || item.value.required && item.value.elementType === "checkbox" && !item.value.selected) {
            //Required
            item.setValue({
                ...item.value,
                error: errorMessages.required
            });
            if (!formValidationError) formValidationError = true;
        } else if (item.value.required && item.value.elementType === "time" && item.value.text.length === 0) {
            //Required short
            item.setValue({
                ...item.value,
                error: errorMessages.requiredShort ?? errorMessages.required
            });
            if (!formValidationError) formValidationError = true;
        } else if (!item.value.skipValidation && item.value.elementType && item.value.elementType === "select" && item.value.required && !(item.value.item && item.value.item.Id) && (!(item.optionIdentifier ? item.value.item[item.optionIdentifier] : item.value.id) || (item.optionIdentifier ? item.value.item[item.optionIdentifier] : item.value.item.id) === "00000000-0000-0000-0000-000000000000")) {
            //Not selected
            item.setValue({
                ...item.value,
                error: errorMessages.notSelected ?? "Not Selected"
            });
            if (!formValidationError) formValidationError = true;
        } else if (!item.value.skipValidation && item.value.elementType && item.value.elementType === "phone" && item.value.required && !$054d7f0f6c03983f$export$a6b7a3cb4a04329f(item.value.text) || item.value.elementType && item.value.elementType === "phone" && item.value.text.length > 0 && !$054d7f0f6c03983f$export$a6b7a3cb4a04329f(item.value.text)) {
            //Phone number
            item.setValue({
                ...item.value,
                error: errorMessages.phoneMalformed ?? "Phone Malformed"
            });
            if (!formValidationError) formValidationError = true;
        } else if (!item.value.skipValidation && item.value.elementType && item.value.elementType === "licenseplate" && item.value.required && !$054d7f0f6c03983f$export$d2ef0846be50186d(item.value.text, item.value.countryCode) || item.value.elementType && item.value.elementType === "licenseplate" && item.value.text && item.value.text.length > 0 && !$054d7f0f6c03983f$export$d2ef0846be50186d(item.value.text, item.value.countryCode)) {
            //License plate
            if (item.value.multiple) item.value = {
                ...item.value,
                error: errorMessages.lpMalformed ?? "License Plate Malformed"
            };
            else item.setValue({
                ...item.value,
                error: errorMessages.lpMalformed ?? "License Plate Malformed"
            });
            if (!formValidationError) formValidationError = true;
        } else if (!item.value.skipValidation && item.value.elementType && item.value.elementType === "ssn" && item.value.required && !$054d7f0f6c03983f$export$4efbc020b8c6c20f(item.value.text, country) || item.value.elementType && item.value.elementType === "ssn" && item.value.text.length > 0 && !$054d7f0f6c03983f$export$4efbc020b8c6c20f(item.value.text, country)) {
            //Social security number
            item.setValue({
                ...item.value,
                error: errorMessages.ssnMalformed ?? "SSN Malformed"
            });
            if (!formValidationError) formValidationError = true;
        } else if (!item.value.skipValidation && item.value.elementType && item.value.elementType === "organisation" && item.value.required && !$054d7f0f6c03983f$export$9a96b7281e50aab2(item.value.text, country) || item.value.elementType && item.value.elementType === "organisation" && item.value.text.length > 0 && !$054d7f0f6c03983f$export$9a96b7281e50aab2(item.value.text, country)) {
            //Organisation number
            item.setValue({
                ...item.value,
                error: errorMessages.organisationNumberMalformed ?? "Organisation Number Malformed"
            });
            if (!formValidationError) formValidationError = true;
        } else if (!item.value.skipValidation && item.value.elementType && item.value.elementType === "zipcode" && item.value.required && !$054d7f0f6c03983f$export$a08d7ae88efc5f2a(item.value.text, country) || item.value.elementType && item.value.elementType === "zipcode" && item.value.text.length > 0 && !$054d7f0f6c03983f$export$a08d7ae88efc5f2a(item.value.text, country)) {
            //Zipcode
            item.setValue({
                ...item.value,
                error: errorMessages.zipcodeMalformed ?? "Zipcode Malformed"
            });
            if (!formValidationError) formValidationError = true;
        } else if (!item.value.skipValidation && item.value.elementType && item.value.elementType === "email" && item.value.required && !$054d7f0f6c03983f$export$b436214556bf9a87(item.value.text) || item.value.elementType && item.value.elementType === "email" && item.value.text.length > 0 && !$054d7f0f6c03983f$export$b436214556bf9a87(item.value.text)) {
            //Email address
            item.setValue({
                ...item.value,
                error: errorMessages.emailMalformed ?? "Email Malformed"
            });
            if (!formValidationError) formValidationError = true;
        } else if (item.value.elementType === "licenseplate") {
            if (item.value.multiple) item.value = {
                ...item.value,
                error: null
            };
            else item.setValue({
                ...item.value,
                error: null
            });
        } else item.setValue({
            ...item.value,
            error: null
        });
        cleanFormData[key] = item.value;
        flatCleanFormData[key] = $054d7f0f6c03983f$var$formObjectValue(item);
    });
    return [
        formValidationError,
        cleanFormData,
        flatCleanFormData
    ];
};
const $054d7f0f6c03983f$var$formObjectValueAlt = (item)=>{
    if (!item) return null;
    if (!item.elementType || item.elementType === "text" || item.elementType === "ssn" || item.elementType === "email" || item.elementType === "password" || item.elementType === "zipcode") return item.text ?? item.Text ?? "";
    else if (item.elementType === "date") return item.date ?? item.Date ?? null;
    else if (item.elementType === "number") return item.number ?? item.Number ?? item.text ?? null;
    else if (item.elementType === "select") return item.item.id ?? item.item.Id ?? null;
    else if (item.elementType === "radio") return item.item.id ?? item.item.Id ?? null;
    else if (item.elementType === "checkbox") return item.selected ?? item.Selected ?? false;
};
const $054d7f0f6c03983f$export$cb7dee1ee6558c32 = (form, errorMessages, language = "sv")=>{
    let formValidationError = false;
    let cleanFormData = {};
    let flatCleanFormData = {};
    let updatedForm = form;
    Object.keys(form).forEach((key)=>{
        let item = form[key];
        if (!item) return;
        if (item.required && !item.elementType && item.text.length === 0 || item.required && item.elementType === "text" && item.text.length === 0 || item.required && item.elementType === "date" && !item.date || item.required && item.elementType === "number" && !item.number || item.required && item.elementType === "ssn" && item.text.length === 0 || item.required && item.elementType === "zipcode" && item.text.length === 0 || item.required && item.elementType === "email" && item.text.length === 0 || item.required && item.elementType === "checkbox" && !item.selected) {
            //Required
            updatedForm[key] = {
                ...item,
                error: errorMessages.required
            };
            if (!formValidationError) formValidationError = true;
        } else if (!item.skipValidation && item.elementType && item.elementType === "select" && item.required && item.id === 0) {
            //Not selected
            updatedForm[key] = {
                ...item,
                error: errorMessages.notSelected
            };
            if (!formValidationError) formValidationError = true;
        } else if (!item.skipValidation && item.elementType && item.elementType === "ssn" && item.required && !$054d7f0f6c03983f$export$4efbc020b8c6c20f(item.text, language) || item.elementType && item.elementType === "ssn" && item.text.length > 0 && !$054d7f0f6c03983f$export$4efbc020b8c6c20f(item.text, language)) {
            //Social security number
            updatedForm[key] = {
                ...item,
                error: errorMessages.ssnMalformed
            };
            if (!formValidationError) formValidationError = true;
        } else if (!item.skipValidation && item.elementType && item.elementType === "zipcode" && item.required && !$054d7f0f6c03983f$export$a08d7ae88efc5f2a(item.text, language) || item.elementType && item.elementType === "zipcode" && item.text.length > 0 && !$054d7f0f6c03983f$export$a08d7ae88efc5f2a(item.text, language)) {
            //Zipcode
            updatedForm[key] = {
                ...item,
                error: errorMessages.zipcodeMalformed
            };
            if (!formValidationError) formValidationError = true;
        } else if (!item.skipValidation && item.elementType && item.elementType === "email" && item.required && !$054d7f0f6c03983f$export$b436214556bf9a87(item.text) || item.elementType && item.elementType === "email" && item.text.length > 0 && !$054d7f0f6c03983f$export$b436214556bf9a87(item.text)) {
            //Email address
            updatedForm[key] = {
                ...item,
                error: errorMessages.emailMalformed
            };
            if (!formValidationError) formValidationError = true;
        } else // No errors
        updatedForm[key] = {
            ...item,
            error: null
        };
        cleanFormData[key] = item;
        flatCleanFormData[key] = $054d7f0f6c03983f$var$formObjectValueAlt(item);
    });
    return [
        updatedForm,
        formValidationError,
        cleanFormData,
        flatCleanFormData
    ];
};

});

parcelRegister("2sdqj", function(module, exports) {

$parcel$export(module.exports, "TwoColumnWrapper", function () { return $1c989be870262038$export$e217b4a6bca02c6e; });

var $54dlf = parcelRequire("54dlf");
parcelRequire("ca3MY");
const $1c989be870262038$export$e217b4a6bca02c6e = (props)=>{
    let wrappingClass = "single-step__section-wrapper";
    if (props.modifier) wrappingClass += " " + wrappingClass + "--" + props.modifier;
    return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
        className: wrappingClass,
        children: props.children
    });
};
const $1c989be870262038$export$7b5886e8e035f1f8 = (props)=>{
    const wrappingClass = "single-step__section-wrapper-three";
    return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
        className: wrappingClass,
        children: props.children
    });
};

});

parcelRegister("i4bvp", function(module, exports) {

$parcel$export(module.exports, "DateSelectionWithLabel", function () { return $d271867f98e93045$export$e7896640e3f537e9; });

var $54dlf = parcelRequire("54dlf");

var $FchUB = parcelRequire("FchUB");

var $23Qu9 = parcelRequire("23Qu9");

var $g6ndF = parcelRequire("g6ndF");

var $iFvPA = parcelRequire("iFvPA");

var $iSxgd = parcelRequire("iSxgd");

parcelRequire("9HTXl");
const $d271867f98e93045$export$e7896640e3f537e9 = (props)=>{
    const wrappingClass = `single-step__section single-step__section--date ${props.extraClass}`;
    const selectedLocale = props.locale === "no" ? "nb" : props.locale === "se" ? "sv" : props.locale;
    const format = props.country === "no" || props.country === "fi" ? "DD.MM.YYYY" : "YYYY-MM-DD";
    const addDays = props.flexDays !== null ? props.flexDays : props.country === "no" ? 3 : 7;
    const todaysDate = (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))().locale(selectedLocale).format("L");
    const startDate = (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))().add(addDays, "days").toDate();
    const endDate = props.endDate ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(props.endDate)).toDate() : (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))().add(1, "year").toDate();
    //const selectedDate = props.value && props.value.date ? moment(new Date(props.value.date)).locale(selectedLocale).format('L') : null;
    const selectedDate = props.value && props.value.date ? (0, $iFvPA.parseDate)(props.value.date, selectedLocale, "L") : null;
    const startSellingDate = props.startSellingDate ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(startDate).isBefore((0, $iFvPA.parseDate)(props.startSellingDate), "day") ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(props.startSellingDate)).toDate() : null : null;
    const settings = {
        firstDayOfWeek: 1,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))().toDate(),
        fromMonth: (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))().toDate(),
        modifiers: {
            disabled: [
                {
                    before: startSellingDate || (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))().toDate()
                }
            ]
        }
    };
    if (!props.showAllDates) {
        settings.month = startDate;
        settings.fromMonth = startDate;
        settings.toMonth = endDate;
        settings.modifiers = {
            disabled: [
                {
                    before: startSellingDate || startDate,
                    after: endDate
                }
            ]
        };
    }
    if (props.selectedDays) settings.selectedDays = props.selectedDays;
    if (props.disabledDays) settings.disabledDays = props.disabledDays;
    if (props.toMonth) settings.toMonth = props.toMonth;
    if (props.fromMonth) settings.fromMonth = props.fromMonth;
    if (props.month) settings.month = props.month;
    const handleChange = (day)=>{
        const dayIsUndefined = !props.value.required && props.extraClass ? document.querySelector(`.${props.extraClass} input`)?.value?.length > 0 && day === undefined : !!!day;
        const disabledBefore = settings.disabledDays?.before || settings.modifiers?.disabled[0]?.before;
        const disabledAfter = settings.disabledDays?.after || settings.modifiers?.disabled[0]?.after;
        if (day && (!props.showAllDates && (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(day).isBefore(startDate, "day") || disabledBefore && (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(day).isBefore(disabledBefore, "day") || disabledAfter && (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(day).isAfter(disabledAfter, "day")) || dayIsUndefined) {
            props.setValue({
                ...props.value,
                date: null,
                dayOfWeek: null,
                error: props.error || true
            });
            return;
        }
        (0, $iSxgd.pushToDataLayer)({
            event: "dateselection_change",
            label: props.text,
            value: day ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(day).locale(selectedLocale).format("L") : null
        });
        const selectedDay = day ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(day) : null;
        const dayOfWeek = day ? selectedDay.isoWeekday() - 1 : null;
        props.setValue({
            ...props.value,
            error: null,
            date: day ? selectedDay.locale(selectedLocale).format("L") : null,
            dayOfWeek: dayOfWeek
        });
    };
    const handleKeyDown = (e)=>{
        if (e.key != "Enter") return;
        document.querySelector(".DayPickerInput input").blur();
    };
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: wrappingClass,
        "aria-invalid": props.value.error ? true : null,
        children: [
            /*#__PURE__*/ (0, $54dlf.jsxs)("label", {
                children: [
                    props.text && /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                        className: "single-step__section__label",
                        children: [
                            props.text,
                            props.extraText && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                children: props.extraText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($FchUB))), {
                        format: format,
                        formatDate: (0, $23Qu9.formatDate),
                        parseDate: (0, $23Qu9.parseDate),
                        placeholder: props.placeholder ?? todaysDate,
                        onDayChange: handleChange,
                        value: selectedDate,
                        dayPickerProps: {
                            locale: props.language,
                            localeUtils: (0, (/*@__PURE__*/$parcel$interopDefault($23Qu9))),
                            ...settings
                        },
                        type: "date",
                        hideOnDayClick: true,
                        inputProps: {
                            onBlur: props.onBlur,
                            disabled: props.disabled,
                            locale: selectedLocale,
                            onKeyDown: handleKeyDown
                        }
                    }),
                    props.value.error && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                        className: "validation-error",
                        children: props.value.error
                    })
                ]
            }),
            props.children ? props.children : null,
            !props.disabled && props.startDateExplanation && addDays > 1 && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                children: props.startDateExplanation.replaceAll("{0}", addDays)
            }),
            !props.disabled && props.startDateInfo && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                children: props.startDateInfo
            })
        ]
    });
};

});
parcelRegister("FchUB", function(module, exports) {

module.exports = (parcelRequire("bVZi9"));

});
parcelRegister("bVZi9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HIDE_TIMEOUT = undefined;
var $8b048fdba32f3ef4$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $8b048fdba32f3ef4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports.OverlayComponent = $8b048fdba32f3ef4$var$OverlayComponent;
module.exports.defaultFormat = $8b048fdba32f3ef4$var$defaultFormat;
module.exports.defaultParse = $8b048fdba32f3ef4$var$defaultParse;

var $ca3MY = parcelRequire("ca3MY");
var $8b048fdba32f3ef4$var$_react2 = $8b048fdba32f3ef4$var$_interopRequireDefault($ca3MY);

var $aSRPr = parcelRequire("aSRPr");
var $8b048fdba32f3ef4$var$_DayPicker2 = $8b048fdba32f3ef4$var$_interopRequireDefault($aSRPr);

var $7zY9I = parcelRequire("7zY9I");

var $40ahm = parcelRequire("40ahm");

var $6s8b9 = parcelRequire("6s8b9");
function $8b048fdba32f3ef4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8b048fdba32f3ef4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8b048fdba32f3ef4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8b048fdba32f3ef4$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8b048fdba32f3ef4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8b048fdba32f3ef4$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
// When clicking on a day cell, overlay will be hidden after this timeout
var $8b048fdba32f3ef4$var$HIDE_TIMEOUT = module.exports.HIDE_TIMEOUT = 100;
/**
 * The default component used as Overlay.
 *
 * @param {Object} props
 */ function $8b048fdba32f3ef4$var$OverlayComponent(_ref) {
    var input = _ref.input, selectedDay = _ref.selectedDay, month = _ref.month, children = _ref.children, classNames = _ref.classNames, props = $8b048fdba32f3ef4$var$_objectWithoutProperties(_ref, [
        "input",
        "selectedDay",
        "month",
        "children",
        "classNames"
    ]);
    return $8b048fdba32f3ef4$var$_react2.default.createElement("div", $8b048fdba32f3ef4$var$_extends({
        className: classNames.overlayWrapper
    }, props), $8b048fdba32f3ef4$var$_react2.default.createElement("div", {
        className: classNames.overlay
    }, children));
}
/**
 * The default function used to format a Date to String, passed to the `format`
 * prop.
 * @param {Date} d
 * @return {String}
 */ function $8b048fdba32f3ef4$var$defaultFormat(d) {
    if ((0, $7zY9I.isDate)(d)) {
        var year = d.getFullYear();
        var month = "" + (d.getMonth() + 1);
        var day = "" + d.getDate();
        return year + "-" + month + "-" + day;
    }
    return "";
}
/**
 * The default function used to parse a String as Date, passed to the `parse`
 * prop.
 * @param {String} str
 * @return {Date}
 */ function $8b048fdba32f3ef4$var$defaultParse(str) {
    if (typeof str !== "string") return undefined;
    var split = str.split("-");
    if (split.length !== 3) return undefined;
    var year = parseInt(split[0], 10);
    var month = parseInt(split[1], 10) - 1;
    var day = parseInt(split[2], 10);
    if (isNaN(year) || String(year).length > 4 || isNaN(month) || isNaN(day) || day <= 0 || day > 31 || month < 0 || month >= 12) return undefined;
    return new Date(year, month, day, 12, 0, 0, 0); // always set noon to avoid time zone issues
}
var $8b048fdba32f3ef4$var$DayPickerInput = function(_React$Component) {
    $8b048fdba32f3ef4$var$_inherits(DayPickerInput, _React$Component);
    function DayPickerInput(props) {
        $8b048fdba32f3ef4$var$_classCallCheck(this, DayPickerInput);
        var _this = $8b048fdba32f3ef4$var$_possibleConstructorReturn(this, (DayPickerInput.__proto__ || Object.getPrototypeOf(DayPickerInput)).call(this, props));
        _this.input = null;
        _this.daypicker = null;
        _this.clickTimeout = null;
        _this.hideTimeout = null;
        _this.inputBlurTimeout = null;
        _this.inputFocusTimeout = null;
        _this.state = _this.getInitialStateFromProps(props);
        _this.state.showOverlay = props.showOverlay;
        _this.hideAfterDayClick = _this.hideAfterDayClick.bind(_this);
        _this.handleInputClick = _this.handleInputClick.bind(_this);
        _this.handleInputFocus = _this.handleInputFocus.bind(_this);
        _this.handleInputBlur = _this.handleInputBlur.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
        _this.handleInputKeyUp = _this.handleInputKeyUp.bind(_this);
        _this.handleDayClick = _this.handleDayClick.bind(_this);
        _this.handleMonthChange = _this.handleMonthChange.bind(_this);
        _this.handleOverlayFocus = _this.handleOverlayFocus.bind(_this);
        _this.handleOverlayBlur = _this.handleOverlayBlur.bind(_this);
        return _this;
    }
    $8b048fdba32f3ef4$var$_createClass(DayPickerInput, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var newState = {};
                // Current props
                var _props = this.props, value = _props.value, formatDate = _props.formatDate, format = _props.format, dayPickerProps = _props.dayPickerProps;
                // Update the input value if `value`, `dayPickerProps.locale` or `format`
                // props have changed
                if (value !== prevProps.value || dayPickerProps.locale !== prevProps.dayPickerProps.locale || format !== prevProps.format) {
                    if ((0, $7zY9I.isDate)(value)) newState.value = formatDate(value, format, dayPickerProps.locale);
                    else newState.value = value;
                }
                // Update the month if the months from props changed
                var prevMonth = prevProps.dayPickerProps.month;
                if (dayPickerProps.month && dayPickerProps.month !== prevMonth && !(0, $7zY9I.isSameMonth)(dayPickerProps.month, prevMonth)) newState.month = dayPickerProps.month;
                // Updated the selected days from props if they changed
                if (prevProps.dayPickerProps.selectedDays !== dayPickerProps.selectedDays) newState.selectedDays = dayPickerProps.selectedDays;
                if (Object.keys(newState).length > 0) // eslint-disable-next-line react/no-did-update-set-state
                this.setState(newState);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearTimeout(this.clickTimeout);
                clearTimeout(this.hideTimeout);
                clearTimeout(this.inputFocusTimeout);
                clearTimeout(this.inputBlurTimeout);
                clearTimeout(this.overlayBlurTimeout);
            }
        },
        {
            key: "getInitialMonthFromProps",
            value: function getInitialMonthFromProps(props) {
                var dayPickerProps = props.dayPickerProps, format = props.format;
                var day = void 0;
                if (props.value) {
                    if ((0, $7zY9I.isDate)(props.value)) day = props.value;
                    else day = props.parseDate(props.value, format, dayPickerProps.locale);
                }
                return dayPickerProps.initialMonth || dayPickerProps.month || day || new Date();
            }
        },
        {
            key: "getInitialStateFromProps",
            value: function getInitialStateFromProps(props) {
                var dayPickerProps = props.dayPickerProps, formatDate = props.formatDate, format = props.format, typedValue = props.typedValue;
                var value = props.value;
                if (props.value && (0, $7zY9I.isDate)(props.value)) value = formatDate(props.value, format, dayPickerProps.locale);
                return {
                    value: value,
                    typedValue: typedValue,
                    month: this.getInitialMonthFromProps(props),
                    selectedDays: dayPickerProps.selectedDays
                };
            }
        },
        {
            key: "getInput",
            value: function getInput() {
                return this.input;
            }
        },
        {
            key: "getDayPicker",
            value: function getDayPicker() {
                return this.daypicker;
            }
        },
        {
            key: "updateState",
            value: function updateState(day, value, callback) {
                var _this2 = this;
                var _props2 = this.props, dayPickerProps = _props2.dayPickerProps, onDayChange = _props2.onDayChange;
                this.setState({
                    month: day,
                    value: value,
                    typedValue: ""
                }, function() {
                    if (callback) callback();
                    if (!onDayChange) return;
                    var modifiersObj = $8b048fdba32f3ef4$var$_extends({
                        disabled: dayPickerProps.disabledDays,
                        selected: dayPickerProps.selectedDays
                    }, dayPickerProps.modifiers);
                    var modifiers = (0, $40ahm.getModifiersForDay)(day, modifiersObj).reduce(function(obj, modifier) {
                        return $8b048fdba32f3ef4$var$_extends({}, obj, $8b048fdba32f3ef4$var$_defineProperty({}, modifier, true));
                    }, {});
                    onDayChange(day, modifiers, _this2);
                });
            }
        },
        {
            key: "showDayPicker",
            value: function showDayPicker() {
                var _this3 = this;
                var _props3 = this.props, parseDate = _props3.parseDate, format = _props3.format, dayPickerProps = _props3.dayPickerProps;
                var _state = this.state, value = _state.value, showOverlay = _state.showOverlay;
                if (showOverlay) return;
                // Reset the current displayed month when showing the overlay
                var month = value ? parseDate(value, format, dayPickerProps.locale) // Use the month in the input field
                 : this.getInitialMonthFromProps(this.props); // Restore the month from the props
                this.setState(function(state) {
                    return {
                        showOverlay: true,
                        month: month || state.month
                    };
                }, function() {
                    if (_this3.props.onDayPickerShow) _this3.props.onDayPickerShow();
                });
            }
        },
        {
            key: "hideDayPicker",
            value: function hideDayPicker() {
                var _this4 = this;
                if (this.state.showOverlay === false) return;
                this.setState({
                    showOverlay: false
                }, function() {
                    if (_this4.props.onDayPickerHide) _this4.props.onDayPickerHide();
                });
            }
        },
        {
            key: "hideAfterDayClick",
            value: function hideAfterDayClick() {
                var _this5 = this;
                if (!this.props.hideOnDayClick) return;
                this.hideTimeout = setTimeout(function() {
                    _this5.overlayHasFocus = false;
                    _this5.hideDayPicker();
                }, $8b048fdba32f3ef4$var$HIDE_TIMEOUT);
            }
        },
        {
            key: "handleInputClick",
            value: function handleInputClick(e) {
                this.showDayPicker();
                if (this.props.inputProps.onClick) {
                    e.persist();
                    this.props.inputProps.onClick(e);
                }
            }
        },
        {
            key: "handleInputFocus",
            value: function handleInputFocus(e) {
                var _this6 = this;
                this.showDayPicker();
                // Set `overlayHasFocus` after a timeout so the overlay can be hidden when
                // the input is blurred
                this.inputFocusTimeout = setTimeout(function() {
                    _this6.overlayHasFocus = false;
                }, 2);
                if (this.props.inputProps.onFocus) {
                    e.persist();
                    this.props.inputProps.onFocus(e);
                }
            }
        },
        {
            key: "handleInputBlur",
            value: function handleInputBlur(e) {
                var _this7 = this;
                this.inputBlurTimeout = setTimeout(function() {
                    if (!_this7.overlayHasFocus) _this7.hideDayPicker();
                }, 1);
                if (this.props.inputProps.onBlur) {
                    e.persist();
                    this.props.inputProps.onBlur(e);
                }
            }
        },
        {
            key: "handleOverlayFocus",
            value: function handleOverlayFocus(e) {
                e.preventDefault();
                this.overlayHasFocus = true;
                if (!this.props.keepFocus || !this.input || typeof this.input.focus !== "function") return;
                this.input.focus();
            }
        },
        {
            key: "handleOverlayBlur",
            value: function handleOverlayBlur() {
                var _this8 = this;
                // We need to set a timeout otherwise IE11 will hide the overlay when
                // focusing it
                this.overlayBlurTimeout = setTimeout(function() {
                    _this8.overlayHasFocus = false;
                }, 3);
            }
        },
        {
            key: "handleInputChange",
            value: function handleInputChange(e) {
                var _props4 = this.props, dayPickerProps = _props4.dayPickerProps, format = _props4.format, inputProps = _props4.inputProps, onDayChange = _props4.onDayChange, parseDate = _props4.parseDate;
                if (inputProps.onChange) {
                    e.persist();
                    inputProps.onChange(e);
                }
                var value = e.target.value;
                if (value.trim() === "") {
                    this.setState({
                        value: value,
                        typedValue: ""
                    });
                    if (onDayChange) onDayChange(undefined, {}, this);
                    return;
                }
                var day = parseDate(value, format, dayPickerProps.locale);
                if (!day) {
                    // Day is invalid: we save the value in the typedValue state
                    this.setState({
                        value: value,
                        typedValue: value
                    });
                    if (onDayChange) onDayChange(undefined, {}, this);
                    return;
                }
                this.updateState(day, value);
            }
        },
        {
            key: "handleInputKeyDown",
            value: function handleInputKeyDown(e) {
                if (e.keyCode === $6s8b9.TAB) this.hideDayPicker();
                else this.showDayPicker();
                if (this.props.inputProps.onKeyDown) {
                    e.persist();
                    this.props.inputProps.onKeyDown(e);
                }
            }
        },
        {
            key: "handleInputKeyUp",
            value: function handleInputKeyUp(e) {
                if (e.keyCode === $6s8b9.ESC) this.hideDayPicker();
                else this.showDayPicker();
                if (this.props.inputProps.onKeyUp) {
                    e.persist();
                    this.props.inputProps.onKeyUp(e);
                }
            }
        },
        {
            key: "handleMonthChange",
            value: function handleMonthChange(month) {
                var _this9 = this;
                this.setState({
                    month: month
                }, function() {
                    if (_this9.props.dayPickerProps && _this9.props.dayPickerProps.onMonthChange) _this9.props.dayPickerProps.onMonthChange(month);
                });
            }
        },
        {
            key: "handleDayClick",
            value: function handleDayClick(day, modifiers, e) {
                var _this10 = this;
                var _props5 = this.props, clickUnselectsDay = _props5.clickUnselectsDay, dayPickerProps = _props5.dayPickerProps, onDayChange = _props5.onDayChange, formatDate = _props5.formatDate, format = _props5.format;
                if (dayPickerProps.onDayClick) dayPickerProps.onDayClick(day, modifiers, e);
                // Do nothing if the day is disabled
                if (modifiers.disabled || dayPickerProps && dayPickerProps.classNames && modifiers[dayPickerProps.classNames.disabled]) return;
                // If the clicked day is already selected, remove the clicked day
                // from the selected days and empty the field value
                if (modifiers.selected && clickUnselectsDay) {
                    var selectedDays = this.state.selectedDays;
                    if (Array.isArray(selectedDays)) {
                        selectedDays = selectedDays.slice(0);
                        var selectedDayIdx = selectedDays.indexOf(day);
                        selectedDays.splice(selectedDayIdx, 1);
                    } else if (selectedDays) selectedDays = null;
                    this.setState({
                        value: "",
                        typedValue: "",
                        selectedDays: selectedDays
                    }, this.hideAfterDayClick);
                    if (onDayChange) onDayChange(undefined, modifiers, this);
                    return;
                }
                var value = formatDate(day, format, dayPickerProps.locale);
                this.setState({
                    value: value,
                    typedValue: "",
                    month: day
                }, function() {
                    if (onDayChange) onDayChange(day, modifiers, _this10);
                    _this10.hideAfterDayClick();
                });
            }
        },
        {
            key: "renderOverlay",
            value: function renderOverlay() {
                var _this11 = this;
                var _props6 = this.props, classNames = _props6.classNames, dayPickerProps = _props6.dayPickerProps, parseDate = _props6.parseDate, formatDate = _props6.formatDate, format = _props6.format;
                var _state2 = this.state, selectedDays = _state2.selectedDays, value = _state2.value;
                var selectedDay = void 0;
                if (!selectedDays && value) {
                    var day = parseDate(value, format, dayPickerProps.locale);
                    if (day) selectedDay = day;
                } else if (selectedDays) selectedDay = selectedDays;
                var onTodayButtonClick = void 0;
                if (dayPickerProps.todayButton) // Set the current day when clicking the today button
                onTodayButtonClick = function onTodayButtonClick() {
                    return _this11.updateState(new Date(), formatDate(new Date(), format, dayPickerProps.locale), _this11.hideAfterDayClick);
                };
                var Overlay = this.props.overlayComponent;
                return $8b048fdba32f3ef4$var$_react2.default.createElement(Overlay, {
                    classNames: classNames,
                    month: this.state.month,
                    selectedDay: selectedDay,
                    input: this.input,
                    tabIndex: 0 // tabIndex is necessary to catch focus/blur events on Safari
                    ,
                    onFocus: this.handleOverlayFocus,
                    onBlur: this.handleOverlayBlur
                }, $8b048fdba32f3ef4$var$_react2.default.createElement($8b048fdba32f3ef4$var$_DayPicker2.default, $8b048fdba32f3ef4$var$_extends({
                    ref: function ref(el) {
                        return _this11.daypicker = el;
                    },
                    onTodayButtonClick: onTodayButtonClick
                }, dayPickerProps, {
                    month: this.state.month,
                    selectedDays: selectedDay,
                    onDayClick: this.handleDayClick,
                    onMonthChange: this.handleMonthChange
                })));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this12 = this;
                var Input = this.props.component;
                var inputProps = this.props.inputProps;
                return $8b048fdba32f3ef4$var$_react2.default.createElement("div", {
                    className: this.props.classNames.container,
                    style: this.props.style
                }, $8b048fdba32f3ef4$var$_react2.default.createElement(Input, $8b048fdba32f3ef4$var$_extends({
                    ref: function ref(el) {
                        return _this12.input = el;
                    },
                    placeholder: this.props.placeholder
                }, inputProps, {
                    value: this.state.value || this.state.typedValue,
                    onChange: this.handleInputChange,
                    onFocus: this.handleInputFocus,
                    onBlur: this.handleInputBlur,
                    onKeyDown: this.handleInputKeyDown,
                    onKeyUp: this.handleInputKeyUp,
                    onClick: !inputProps.disabled ? this.handleInputClick : undefined
                })), this.state.showOverlay && this.renderOverlay());
            }
        }
    ]);
    return DayPickerInput;
}($8b048fdba32f3ef4$var$_react2.default.Component);
$8b048fdba32f3ef4$var$DayPickerInput.defaultProps = {
    dayPickerProps: {},
    value: "",
    typedValue: "",
    placeholder: "YYYY-M-D",
    format: "L",
    formatDate: $8b048fdba32f3ef4$var$defaultFormat,
    parseDate: $8b048fdba32f3ef4$var$defaultParse,
    showOverlay: false,
    hideOnDayClick: true,
    clickUnselectsDay: false,
    keepFocus: true,
    component: "input",
    inputProps: {},
    overlayComponent: $8b048fdba32f3ef4$var$OverlayComponent,
    classNames: {
        container: "DayPickerInput",
        overlayWrapper: "DayPickerInput-OverlayWrapper",
        overlay: "DayPickerInput-Overlay"
    }
};
module.exports.default = $8b048fdba32f3ef4$var$DayPickerInput;

});
parcelRegister("aSRPr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModifiersUtils = module.exports.LocaleUtils = module.exports.DateUtils = module.exports.DayPicker = undefined;
var $7ec8b3cc021ae65c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7ec8b3cc021ae65c$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $ca3MY = parcelRequire("ca3MY");
var $7ec8b3cc021ae65c$var$_react2 = $7ec8b3cc021ae65c$var$_interopRequireDefault($ca3MY);

var $8GZNb = parcelRequire("8GZNb");
var $7ec8b3cc021ae65c$var$_Caption2 = $7ec8b3cc021ae65c$var$_interopRequireDefault($8GZNb);

var $deygy = parcelRequire("deygy");
var $7ec8b3cc021ae65c$var$_Navbar2 = $7ec8b3cc021ae65c$var$_interopRequireDefault($deygy);

var $bAcxO = parcelRequire("bAcxO");
var $7ec8b3cc021ae65c$var$_Month2 = $7ec8b3cc021ae65c$var$_interopRequireDefault($bAcxO);

var $b4bsz = parcelRequire("b4bsz");
var $7ec8b3cc021ae65c$var$_Weekday2 = $7ec8b3cc021ae65c$var$_interopRequireDefault($b4bsz);

var $5UjR8 = parcelRequire("5UjR8");
var $7ec8b3cc021ae65c$var$Helpers = $7ec8b3cc021ae65c$var$_interopRequireWildcard($5UjR8);

var $7zY9I = parcelRequire("7zY9I");
var $7ec8b3cc021ae65c$var$DateUtils = $7ec8b3cc021ae65c$var$_interopRequireWildcard($7zY9I);

var $kMjnI = parcelRequire("kMjnI");
var $7ec8b3cc021ae65c$var$LocaleUtils = $7ec8b3cc021ae65c$var$_interopRequireWildcard($kMjnI);

var $40ahm = parcelRequire("40ahm");
var $7ec8b3cc021ae65c$var$ModifiersUtils = $7ec8b3cc021ae65c$var$_interopRequireWildcard($40ahm);

var $ijsL0 = parcelRequire("ijsL0");
var $7ec8b3cc021ae65c$var$_classNames2 = $7ec8b3cc021ae65c$var$_interopRequireDefault($ijsL0);

var $6s8b9 = parcelRequire("6s8b9");
function $7ec8b3cc021ae65c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $7ec8b3cc021ae65c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7ec8b3cc021ae65c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $7ec8b3cc021ae65c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7ec8b3cc021ae65c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7ec8b3cc021ae65c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $7ec8b3cc021ae65c$var$DayPicker = module.exports.DayPicker = function(_Component) {
    $7ec8b3cc021ae65c$var$_inherits(DayPicker, _Component);
    function DayPicker(props) {
        $7ec8b3cc021ae65c$var$_classCallCheck(this, DayPicker);
        var _this = $7ec8b3cc021ae65c$var$_possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));
        _this.dayPicker = null;
        _this.showNextMonth = function(callback) {
            if (!_this.allowNextMonth()) return;
            var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
            var nextMonth = $7ec8b3cc021ae65c$var$DateUtils.addMonths(_this.state.currentMonth, deltaMonths);
            _this.showMonth(nextMonth, callback);
        };
        _this.showPreviousMonth = function(callback) {
            if (!_this.allowPreviousMonth()) return;
            var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
            var previousMonth = $7ec8b3cc021ae65c$var$DateUtils.addMonths(_this.state.currentMonth, -deltaMonths);
            _this.showMonth(previousMonth, callback);
        };
        _this.handleKeyDown = function(e) {
            e.persist();
            switch(e.keyCode){
                case $6s8b9.LEFT:
                    if (_this.props.dir === "rtl") _this.showNextMonth();
                    else _this.showPreviousMonth();
                    $7ec8b3cc021ae65c$var$Helpers.cancelEvent(e);
                    break;
                case $6s8b9.RIGHT:
                    if (_this.props.dir === "rtl") _this.showPreviousMonth();
                    else _this.showNextMonth();
                    $7ec8b3cc021ae65c$var$Helpers.cancelEvent(e);
                    break;
                case $6s8b9.UP:
                    _this.showPreviousYear();
                    $7ec8b3cc021ae65c$var$Helpers.cancelEvent(e);
                    break;
                case $6s8b9.DOWN:
                    _this.showNextYear();
                    $7ec8b3cc021ae65c$var$Helpers.cancelEvent(e);
                    break;
                default:
                    break;
            }
            if (_this.props.onKeyDown) _this.props.onKeyDown(e);
        };
        _this.handleDayKeyDown = function(day, modifiers, e) {
            e.persist();
            switch(e.keyCode){
                case $6s8b9.LEFT:
                    $7ec8b3cc021ae65c$var$Helpers.cancelEvent(e);
                    if (_this.props.dir === "rtl") _this.focusNextDay(e.target);
                    else _this.focusPreviousDay(e.target);
                    break;
                case $6s8b9.RIGHT:
                    $7ec8b3cc021ae65c$var$Helpers.cancelEvent(e);
                    if (_this.props.dir === "rtl") _this.focusPreviousDay(e.target);
                    else _this.focusNextDay(e.target);
                    break;
                case $6s8b9.UP:
                    $7ec8b3cc021ae65c$var$Helpers.cancelEvent(e);
                    _this.focusPreviousWeek(e.target);
                    break;
                case $6s8b9.DOWN:
                    $7ec8b3cc021ae65c$var$Helpers.cancelEvent(e);
                    _this.focusNextWeek(e.target);
                    break;
                case $6s8b9.ENTER:
                case $6s8b9.SPACE:
                    $7ec8b3cc021ae65c$var$Helpers.cancelEvent(e);
                    if (_this.props.onDayClick) _this.handleDayClick(day, modifiers, e);
                    break;
                default:
                    break;
            }
            if (_this.props.onDayKeyDown) _this.props.onDayKeyDown(day, modifiers, e);
        };
        _this.handleDayClick = function(day, modifiers, e) {
            e.persist();
            if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) _this.handleOutsideDayClick(day);
            if (_this.props.onDayClick) _this.props.onDayClick(day, modifiers, e);
        };
        _this.handleTodayButtonClick = function(e) {
            var today = new Date();
            var month = new Date(today.getFullYear(), today.getMonth());
            _this.showMonth(month);
            e.target.blur();
            if (_this.props.onTodayButtonClick) {
                e.persist();
                _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), $7ec8b3cc021ae65c$var$ModifiersUtils.getModifiersForDay(today, _this.props.modifiers), e);
            }
        };
        var currentMonth = _this.getCurrentMonthFromProps(props);
        _this.state = {
            currentMonth: currentMonth
        };
        return _this;
    }
    $7ec8b3cc021ae65c$var$_createClass(DayPicker, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                // Changing the `month` props means changing the current displayed month
                if (prevProps.month !== this.props.month && !$7ec8b3cc021ae65c$var$DateUtils.isSameMonth(prevProps.month, this.props.month)) {
                    var currentMonth = this.getCurrentMonthFromProps(this.props);
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        currentMonth: currentMonth
                    });
                }
            }
        },
        {
            key: "getCurrentMonthFromProps",
            /**
     * Return the month to be shown in the calendar based on the component props.
     *
     * @param {Object} props
     * @returns Date
     * @memberof DayPicker
     * @private
     */ value: function getCurrentMonthFromProps(props) {
                var initialMonth = $7ec8b3cc021ae65c$var$Helpers.startOfMonth(props.month || props.initialMonth || new Date());
                var currentMonth = initialMonth;
                if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
                    var fromMonth = $7ec8b3cc021ae65c$var$Helpers.startOfMonth(props.fromMonth);
                    var diffInMonths = $7ec8b3cc021ae65c$var$Helpers.getMonthsDiff(fromMonth, currentMonth);
                    currentMonth = $7ec8b3cc021ae65c$var$DateUtils.addMonths(fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
                } else if (props.toMonth && props.numberOfMonths > 1 && $7ec8b3cc021ae65c$var$Helpers.getMonthsDiff(currentMonth, props.toMonth) <= 0) currentMonth = $7ec8b3cc021ae65c$var$DateUtils.addMonths($7ec8b3cc021ae65c$var$Helpers.startOfMonth(props.toMonth), 1 - this.props.numberOfMonths);
                return currentMonth;
            }
        },
        {
            key: "getNextNavigableMonth",
            value: function getNextNavigableMonth() {
                return $7ec8b3cc021ae65c$var$DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
            }
        },
        {
            key: "getPreviousNavigableMonth",
            value: function getPreviousNavigableMonth() {
                return $7ec8b3cc021ae65c$var$DateUtils.addMonths(this.state.currentMonth, -1);
            }
        },
        {
            key: "allowPreviousMonth",
            value: function allowPreviousMonth() {
                var previousMonth = $7ec8b3cc021ae65c$var$DateUtils.addMonths(this.state.currentMonth, -1);
                return this.allowMonth(previousMonth);
            }
        },
        {
            key: "allowNextMonth",
            value: function allowNextMonth() {
                var nextMonth = $7ec8b3cc021ae65c$var$DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
                return this.allowMonth(nextMonth);
            }
        },
        {
            key: "allowMonth",
            value: function allowMonth(d) {
                var _props = this.props, fromMonth = _props.fromMonth, toMonth = _props.toMonth, canChangeMonth = _props.canChangeMonth;
                if (!canChangeMonth || fromMonth && $7ec8b3cc021ae65c$var$Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && $7ec8b3cc021ae65c$var$Helpers.getMonthsDiff(toMonth, d) > 0) return false;
                return true;
            }
        },
        {
            key: "allowYearChange",
            value: function allowYearChange() {
                return this.props.canChangeMonth;
            }
        },
        {
            key: "showMonth",
            value: function showMonth(d, callback) {
                var _this2 = this;
                if (!this.allowMonth(d)) return;
                this.setState({
                    currentMonth: $7ec8b3cc021ae65c$var$Helpers.startOfMonth(d)
                }, function() {
                    if (callback) callback();
                    if (_this2.props.onMonthChange) _this2.props.onMonthChange(_this2.state.currentMonth);
                });
            }
        },
        {
            key: "showNextYear",
            value: function showNextYear() {
                if (!this.allowYearChange()) return;
                var nextMonth = $7ec8b3cc021ae65c$var$DateUtils.addMonths(this.state.currentMonth, 12);
                this.showMonth(nextMonth);
            }
        },
        {
            key: "showPreviousYear",
            value: function showPreviousYear() {
                if (!this.allowYearChange()) return;
                var nextMonth = $7ec8b3cc021ae65c$var$DateUtils.addMonths(this.state.currentMonth, -12);
                this.showMonth(nextMonth);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.wrapper.focus();
            }
        },
        {
            key: "focusFirstDayOfMonth",
            value: function focusFirstDayOfMonth() {
                $7ec8b3cc021ae65c$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
            }
        },
        {
            key: "focusLastDayOfMonth",
            value: function focusLastDayOfMonth() {
                var dayNodes = $7ec8b3cc021ae65c$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                dayNodes[dayNodes.length - 1].focus();
            }
        },
        {
            key: "focusPreviousDay",
            value: function focusPreviousDay(dayNode) {
                var _this3 = this;
                var dayNodes = $7ec8b3cc021ae65c$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                var dayNodeIndex = $7ec8b3cc021ae65c$var$Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
                if (dayNodeIndex === -1) return;
                if (dayNodeIndex === 0) this.showPreviousMonth(function() {
                    return _this3.focusLastDayOfMonth();
                });
                else dayNodes[dayNodeIndex - 1].focus();
            }
        },
        {
            key: "focusNextDay",
            value: function focusNextDay(dayNode) {
                var _this4 = this;
                var dayNodes = $7ec8b3cc021ae65c$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                var dayNodeIndex = $7ec8b3cc021ae65c$var$Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
                if (dayNodeIndex === -1) return;
                if (dayNodeIndex === dayNodes.length - 1) this.showNextMonth(function() {
                    return _this4.focusFirstDayOfMonth();
                });
                else dayNodes[dayNodeIndex + 1].focus();
            }
        },
        {
            key: "focusNextWeek",
            value: function focusNextWeek(dayNode) {
                var _this5 = this;
                var dayNodes = $7ec8b3cc021ae65c$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                var dayNodeIndex = $7ec8b3cc021ae65c$var$Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
                var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;
                if (isInLastWeekOfMonth) this.showNextMonth(function() {
                    var daysAfterIndex = dayNodes.length - dayNodeIndex;
                    var nextMonthDayNodeIndex = 7 - daysAfterIndex;
                    $7ec8b3cc021ae65c$var$Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
                });
                else dayNodes[dayNodeIndex + 7].focus();
            }
        },
        {
            key: "focusPreviousWeek",
            value: function focusPreviousWeek(dayNode) {
                var _this6 = this;
                var dayNodes = $7ec8b3cc021ae65c$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                var dayNodeIndex = $7ec8b3cc021ae65c$var$Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
                var isInFirstWeekOfMonth = dayNodeIndex <= 6;
                if (isInFirstWeekOfMonth) this.showPreviousMonth(function() {
                    var previousMonthDayNodes = $7ec8b3cc021ae65c$var$Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
                    var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
                    var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
                    previousMonthDayNodes[previousMonthDayNodeIndex].focus();
                });
                else dayNodes[dayNodeIndex - 7].focus();
            }
        },
        {
            key: "handleOutsideDayClick",
            value: function handleOutsideDayClick(day) {
                var currentMonth = this.state.currentMonth;
                var numberOfMonths = this.props.numberOfMonths;
                var diffInMonths = $7ec8b3cc021ae65c$var$Helpers.getMonthsDiff(currentMonth, day);
                if (diffInMonths > 0 && diffInMonths >= numberOfMonths) this.showNextMonth();
                else if (diffInMonths < 0) this.showPreviousMonth();
            }
        },
        {
            key: "renderNavbar",
            value: function renderNavbar() {
                var _props2 = this.props, labels = _props2.labels, locale = _props2.locale, localeUtils = _props2.localeUtils, canChangeMonth = _props2.canChangeMonth, navbarElement = _props2.navbarElement, attributes = $7ec8b3cc021ae65c$var$_objectWithoutProperties(_props2, [
                    "labels",
                    "locale",
                    "localeUtils",
                    "canChangeMonth",
                    "navbarElement"
                ]);
                if (!canChangeMonth) return null;
                var props = {
                    month: this.state.currentMonth,
                    classNames: this.props.classNames,
                    className: this.props.classNames.navBar,
                    nextMonth: this.getNextNavigableMonth(),
                    previousMonth: this.getPreviousNavigableMonth(),
                    showPreviousButton: this.allowPreviousMonth(),
                    showNextButton: this.allowNextMonth(),
                    onNextClick: this.showNextMonth,
                    onPreviousClick: this.showPreviousMonth,
                    dir: attributes.dir,
                    labels: labels,
                    locale: locale,
                    localeUtils: localeUtils
                };
                return $7ec8b3cc021ae65c$var$_react2.default.isValidElement(navbarElement) ? $7ec8b3cc021ae65c$var$_react2.default.cloneElement(navbarElement, props) : $7ec8b3cc021ae65c$var$_react2.default.createElement(navbarElement, props);
            }
        },
        {
            key: "renderMonths",
            value: function renderMonths() {
                var months = [];
                var firstDayOfWeek = $7ec8b3cc021ae65c$var$Helpers.getFirstDayOfWeekFromProps(this.props);
                for(var i = 0; i < this.props.numberOfMonths; i += 1){
                    var month = $7ec8b3cc021ae65c$var$DateUtils.addMonths(this.state.currentMonth, i);
                    months.push($7ec8b3cc021ae65c$var$_react2.default.createElement($7ec8b3cc021ae65c$var$_Month2.default, $7ec8b3cc021ae65c$var$_extends({
                        key: i
                    }, this.props, {
                        month: month,
                        firstDayOfWeek: firstDayOfWeek,
                        onDayKeyDown: this.handleDayKeyDown,
                        onDayClick: this.handleDayClick
                    })));
                }
                if (this.props.reverseMonths) months.reverse();
                return months;
            }
        },
        {
            key: "renderFooter",
            value: function renderFooter() {
                if (this.props.todayButton) return $7ec8b3cc021ae65c$var$_react2.default.createElement("div", {
                    className: this.props.classNames.footer
                }, this.renderTodayButton());
                return null;
            }
        },
        {
            key: "renderTodayButton",
            value: function renderTodayButton() {
                return $7ec8b3cc021ae65c$var$_react2.default.createElement("button", {
                    type: "button",
                    tabIndex: 0,
                    className: this.props.classNames.todayButton,
                    "aria-label": this.props.todayButton,
                    onClick: this.handleTodayButtonClick
                }, this.props.todayButton);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this7 = this;
                var className = this.props.classNames.container;
                if (!this.props.onDayClick) className = className + " " + this.props.classNames.interactionDisabled;
                if (this.props.className) className = className + " " + this.props.className;
                return $7ec8b3cc021ae65c$var$_react2.default.createElement("div", $7ec8b3cc021ae65c$var$_extends({}, this.props.containerProps, {
                    className: className,
                    ref: function ref(el) {
                        return _this7.dayPicker = el;
                    },
                    lang: this.props.locale
                }), $7ec8b3cc021ae65c$var$_react2.default.createElement("div", {
                    className: this.props.classNames.wrapper,
                    ref: function ref(el) {
                        return _this7.wrapper = el;
                    },
                    tabIndex: this.props.canChangeMonth && typeof this.props.tabIndex !== "undefined" ? this.props.tabIndex : -1,
                    onKeyDown: this.handleKeyDown,
                    onFocus: this.props.onFocus,
                    onBlur: this.props.onBlur
                }, this.renderNavbar(), $7ec8b3cc021ae65c$var$_react2.default.createElement("div", {
                    className: this.props.classNames.months
                }, this.renderMonths()), this.renderFooter()));
            }
        }
    ]);
    return DayPicker;
}($ca3MY.Component);
$7ec8b3cc021ae65c$var$DayPicker.defaultProps = {
    classNames: $7ec8b3cc021ae65c$var$_classNames2.default,
    tabIndex: 0,
    numberOfMonths: 1,
    labels: {
        previousMonth: "Previous Month",
        nextMonth: "Next Month"
    },
    locale: "en",
    localeUtils: $7ec8b3cc021ae65c$var$LocaleUtils,
    showOutsideDays: false,
    enableOutsideDaysClick: true,
    fixedWeeks: false,
    canChangeMonth: true,
    reverseMonths: false,
    pagedNavigation: false,
    showWeekNumbers: false,
    showWeekDays: true,
    renderDay: function renderDay(day) {
        return day.getDate();
    },
    renderWeek: function renderWeek(weekNumber) {
        return weekNumber;
    },
    weekdayElement: $7ec8b3cc021ae65c$var$_react2.default.createElement($7ec8b3cc021ae65c$var$_Weekday2.default, null),
    navbarElement: $7ec8b3cc021ae65c$var$_react2.default.createElement($7ec8b3cc021ae65c$var$_Navbar2.default, {
        classNames: $7ec8b3cc021ae65c$var$_classNames2.default
    }),
    captionElement: $7ec8b3cc021ae65c$var$_react2.default.createElement($7ec8b3cc021ae65c$var$_Caption2.default, {
        classNames: $7ec8b3cc021ae65c$var$_classNames2.default
    })
};
$7ec8b3cc021ae65c$var$DayPicker.VERSION = "7.4.10";
$7ec8b3cc021ae65c$var$DayPicker.DateUtils = $7ec8b3cc021ae65c$var$DateUtils;
$7ec8b3cc021ae65c$var$DayPicker.LocaleUtils = $7ec8b3cc021ae65c$var$LocaleUtils;
$7ec8b3cc021ae65c$var$DayPicker.ModifiersUtils = $7ec8b3cc021ae65c$var$ModifiersUtils;
module.exports.DateUtils = $7ec8b3cc021ae65c$var$DateUtils;
module.exports.LocaleUtils = $7ec8b3cc021ae65c$var$LocaleUtils;
module.exports.ModifiersUtils = $7ec8b3cc021ae65c$var$ModifiersUtils;
module.exports.default = $7ec8b3cc021ae65c$var$DayPicker;

});
parcelRegister("8GZNb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $65422da14175f410$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $ca3MY = parcelRequire("ca3MY");
var $65422da14175f410$var$_react2 = $65422da14175f410$var$_interopRequireDefault($ca3MY);

var $kMjnI = parcelRequire("kMjnI");
var $65422da14175f410$var$_LocaleUtils2 = $65422da14175f410$var$_interopRequireDefault($kMjnI);

var $6s8b9 = parcelRequire("6s8b9");
function $65422da14175f410$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $65422da14175f410$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $65422da14175f410$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $65422da14175f410$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $65422da14175f410$var$Caption = function(_Component) {
    $65422da14175f410$var$_inherits(Caption, _Component);
    function Caption(props) {
        $65422da14175f410$var$_classCallCheck(this, Caption);
        var _this = $65422da14175f410$var$_possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));
        _this.handleKeyUp = _this.handleKeyUp.bind(_this);
        return _this;
    }
    $65422da14175f410$var$_createClass(Caption, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
            }
        },
        {
            key: "handleKeyUp",
            value: function handleKeyUp(e) {
                if (e.keyCode === $6s8b9.ENTER) this.props.onClick(e);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, classNames = _props.classNames, date = _props.date, months = _props.months, locale = _props.locale, localeUtils = _props.localeUtils, onClick = _props.onClick;
                return $65422da14175f410$var$_react2.default.createElement("div", {
                    className: classNames.caption,
                    role: "heading",
                    "aria-live": "polite"
                }, $65422da14175f410$var$_react2.default.createElement("div", {
                    onClick: onClick,
                    onKeyUp: this.handleKeyUp
                }, months ? months[date.getMonth()] + " " + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)));
            }
        }
    ]);
    return Caption;
}($ca3MY.Component);
$65422da14175f410$var$Caption.defaultProps = {
    localeUtils: $65422da14175f410$var$_LocaleUtils2.default
};
module.exports.default = $65422da14175f410$var$Caption;

});
parcelRegister("kMjnI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatDay = $f207531a37e2a342$var$formatDay;
module.exports.formatMonthTitle = $f207531a37e2a342$var$formatMonthTitle;
module.exports.formatWeekdayShort = $f207531a37e2a342$var$formatWeekdayShort;
module.exports.formatWeekdayLong = $f207531a37e2a342$var$formatWeekdayLong;
module.exports.getFirstDayOfWeek = $f207531a37e2a342$var$getFirstDayOfWeek;
module.exports.getMonths = $f207531a37e2a342$var$getMonths;
var $f207531a37e2a342$var$WEEKDAYS_LONG = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var $f207531a37e2a342$var$WEEKDAYS_SHORT = [
    "Su",
    "Mo",
    "Tu",
    "We",
    "Th",
    "Fr",
    "Sa"
];
var $f207531a37e2a342$var$MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
function $f207531a37e2a342$var$formatDay(day) {
    return day.toDateString();
}
function $f207531a37e2a342$var$formatMonthTitle(d) {
    return $f207531a37e2a342$var$MONTHS[d.getMonth()] + " " + d.getFullYear();
}
function $f207531a37e2a342$var$formatWeekdayShort(i) {
    return $f207531a37e2a342$var$WEEKDAYS_SHORT[i];
}
function $f207531a37e2a342$var$formatWeekdayLong(i) {
    return $f207531a37e2a342$var$WEEKDAYS_LONG[i];
}
function $f207531a37e2a342$var$getFirstDayOfWeek() {
    return 0;
}
function $f207531a37e2a342$var$getMonths() {
    return $f207531a37e2a342$var$MONTHS;
}
module.exports.default = {
    formatDay: $f207531a37e2a342$var$formatDay,
    formatMonthTitle: $f207531a37e2a342$var$formatMonthTitle,
    formatWeekdayShort: $f207531a37e2a342$var$formatWeekdayShort,
    formatWeekdayLong: $f207531a37e2a342$var$formatWeekdayLong,
    getFirstDayOfWeek: $f207531a37e2a342$var$getFirstDayOfWeek,
    getMonths: $f207531a37e2a342$var$getMonths
};

});

parcelRegister("6s8b9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4b2bb3bd9daa8c1d$var$LEFT = module.exports.LEFT = 37;
var $4b2bb3bd9daa8c1d$var$UP = module.exports.UP = 38;
var $4b2bb3bd9daa8c1d$var$RIGHT = module.exports.RIGHT = 39;
var $4b2bb3bd9daa8c1d$var$DOWN = module.exports.DOWN = 40;
var $4b2bb3bd9daa8c1d$var$ENTER = module.exports.ENTER = 13;
var $4b2bb3bd9daa8c1d$var$SPACE = module.exports.SPACE = 32;
var $4b2bb3bd9daa8c1d$var$ESC = module.exports.ESC = 27;
var $4b2bb3bd9daa8c1d$var$TAB = module.exports.TAB = 9;

});


parcelRegister("deygy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9a2729ab3f4c6a55$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $ca3MY = parcelRequire("ca3MY");
var $9a2729ab3f4c6a55$var$_react2 = $9a2729ab3f4c6a55$var$_interopRequireDefault($ca3MY);

var $ijsL0 = parcelRequire("ijsL0");
var $9a2729ab3f4c6a55$var$_classNames2 = $9a2729ab3f4c6a55$var$_interopRequireDefault($ijsL0);

var $6s8b9 = parcelRequire("6s8b9");
function $9a2729ab3f4c6a55$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9a2729ab3f4c6a55$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9a2729ab3f4c6a55$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9a2729ab3f4c6a55$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9a2729ab3f4c6a55$var$Navbar = function(_Component) {
    $9a2729ab3f4c6a55$var$_inherits(Navbar, _Component);
    function Navbar() {
        var _ref;
        var _temp, _this, _ret;
        $9a2729ab3f4c6a55$var$_classCallCheck(this, Navbar);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $9a2729ab3f4c6a55$var$_possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.handleNextClick = function() {
            if (_this.props.onNextClick) _this.props.onNextClick();
        }, _this.handlePreviousClick = function() {
            if (_this.props.onPreviousClick) _this.props.onPreviousClick();
        }, _this.handleNextKeyDown = function(e) {
            if (e.keyCode !== $6s8b9.ENTER && e.keyCode !== $6s8b9.SPACE) return;
            e.preventDefault();
            _this.handleNextClick();
        }, _this.handlePreviousKeyDown = function(e) {
            if (e.keyCode !== $6s8b9.ENTER && e.keyCode !== $6s8b9.SPACE) return;
            e.preventDefault();
            _this.handlePreviousClick();
        }, _temp), $9a2729ab3f4c6a55$var$_possibleConstructorReturn(_this, _ret);
    }
    $9a2729ab3f4c6a55$var$_createClass(Navbar, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, classNames = _props.classNames, className = _props.className, showPreviousButton = _props.showPreviousButton, showNextButton = _props.showNextButton, labels = _props.labels, dir = _props.dir;
                var previousClickHandler = void 0;
                var nextClickHandler = void 0;
                var previousKeyDownHandler = void 0;
                var nextKeyDownHandler = void 0;
                var shouldShowPrevious = void 0;
                var shouldShowNext = void 0;
                if (dir === "rtl") {
                    previousClickHandler = this.handleNextClick;
                    nextClickHandler = this.handlePreviousClick;
                    previousKeyDownHandler = this.handleNextKeyDown;
                    nextKeyDownHandler = this.handlePreviousKeyDown;
                    shouldShowNext = showPreviousButton;
                    shouldShowPrevious = showNextButton;
                } else {
                    previousClickHandler = this.handlePreviousClick;
                    nextClickHandler = this.handleNextClick;
                    previousKeyDownHandler = this.handlePreviousKeyDown;
                    nextKeyDownHandler = this.handleNextKeyDown;
                    shouldShowNext = showNextButton;
                    shouldShowPrevious = showPreviousButton;
                }
                var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + " " + classNames.navButtonInteractionDisabled;
                var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + " " + classNames.navButtonInteractionDisabled;
                var previousButton = $9a2729ab3f4c6a55$var$_react2.default.createElement("span", {
                    tabIndex: "0",
                    role: "button",
                    "aria-label": labels.previousMonth,
                    key: "previous",
                    className: previousClassName,
                    onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
                    onClick: shouldShowPrevious ? previousClickHandler : undefined
                });
                var nextButton = $9a2729ab3f4c6a55$var$_react2.default.createElement("span", {
                    tabIndex: "0",
                    role: "button",
                    "aria-label": labels.nextMonth,
                    key: "right",
                    className: nextClassName,
                    onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
                    onClick: shouldShowNext ? nextClickHandler : undefined
                });
                return $9a2729ab3f4c6a55$var$_react2.default.createElement("div", {
                    className: className || classNames.navBar
                }, dir === "rtl" ? [
                    nextButton,
                    previousButton
                ] : [
                    previousButton,
                    nextButton
                ]);
            }
        }
    ]);
    return Navbar;
}($ca3MY.Component);
$9a2729ab3f4c6a55$var$Navbar.defaultProps = {
    classNames: $9a2729ab3f4c6a55$var$_classNames2.default,
    dir: "ltr",
    labels: {
        previousMonth: "Previous Month",
        nextMonth: "Next Month"
    },
    showPreviousButton: true,
    showNextButton: true
};
module.exports.default = $9a2729ab3f4c6a55$var$Navbar;

});
parcelRegister("ijsL0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Proxy object to map classnames when css modules are not used
module.exports.default = {
    container: "DayPicker",
    wrapper: "DayPicker-wrapper",
    interactionDisabled: "DayPicker--interactionDisabled",
    months: "DayPicker-Months",
    month: "DayPicker-Month",
    navBar: "DayPicker-NavBar",
    navButtonPrev: "DayPicker-NavButton DayPicker-NavButton--prev",
    navButtonNext: "DayPicker-NavButton DayPicker-NavButton--next",
    navButtonInteractionDisabled: "DayPicker-NavButton--interactionDisabled",
    caption: "DayPicker-Caption",
    weekdays: "DayPicker-Weekdays",
    weekdaysRow: "DayPicker-WeekdaysRow",
    weekday: "DayPicker-Weekday",
    body: "DayPicker-Body",
    week: "DayPicker-Week",
    weekNumber: "DayPicker-WeekNumber",
    day: "DayPicker-Day",
    footer: "DayPicker-Footer",
    todayButton: "DayPicker-TodayButton",
    // default modifiers
    today: "today",
    selected: "selected",
    disabled: "disabled",
    outside: "outside"
};

});


parcelRegister("bAcxO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $86ecc989f6a54b35$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $ca3MY = parcelRequire("ca3MY");
var $86ecc989f6a54b35$var$_react2 = $86ecc989f6a54b35$var$_interopRequireDefault($ca3MY);

var $gPZtF = parcelRequire("gPZtF");
var $86ecc989f6a54b35$var$_Weekdays2 = $86ecc989f6a54b35$var$_interopRequireDefault($gPZtF);

var $22R5a = parcelRequire("22R5a");
var $86ecc989f6a54b35$var$_Day2 = $86ecc989f6a54b35$var$_interopRequireDefault($22R5a);

var $6s8b9 = parcelRequire("6s8b9");

var $40ahm = parcelRequire("40ahm");
var $86ecc989f6a54b35$var$ModifiersUtils = $86ecc989f6a54b35$var$_interopRequireWildcard($40ahm);

var $5UjR8 = parcelRequire("5UjR8");
var $86ecc989f6a54b35$var$Helpers = $86ecc989f6a54b35$var$_interopRequireWildcard($5UjR8);

var $7zY9I = parcelRequire("7zY9I");
var $86ecc989f6a54b35$var$DateUtils = $86ecc989f6a54b35$var$_interopRequireWildcard($7zY9I);
function $86ecc989f6a54b35$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $86ecc989f6a54b35$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $86ecc989f6a54b35$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $86ecc989f6a54b35$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $86ecc989f6a54b35$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $86ecc989f6a54b35$var$Month = function(_Component) {
    $86ecc989f6a54b35$var$_inherits(Month, _Component);
    function Month() {
        var _ref;
        var _temp, _this, _ret;
        $86ecc989f6a54b35$var$_classCallCheck(this, Month);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $86ecc989f6a54b35$var$_possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.renderDay = function(day) {
            var monthNumber = _this.props.month.getMonth();
            var propModifiers = $86ecc989f6a54b35$var$Helpers.getModifiersFromProps(_this.props);
            var dayModifiers = $86ecc989f6a54b35$var$ModifiersUtils.getModifiersForDay(day, propModifiers);
            if ($86ecc989f6a54b35$var$DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) dayModifiers.push(_this.props.classNames.today);
            if (day.getMonth() !== monthNumber) dayModifiers.push(_this.props.classNames.outside);
            var isOutside = day.getMonth() !== monthNumber;
            var tabIndex = -1;
            // Focus on the first day of the month
            if (_this.props.onDayClick && !isOutside && day.getDate() === 1) tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
            var key = "" + day.getFullYear() + day.getMonth() + day.getDate();
            var modifiers = {};
            dayModifiers.forEach(function(modifier) {
                modifiers[modifier] = true;
            });
            return $86ecc989f6a54b35$var$_react2.default.createElement($86ecc989f6a54b35$var$_Day2.default, {
                key: "" + (isOutside ? "outside-" : "") + key,
                classNames: _this.props.classNames,
                day: day,
                modifiers: modifiers,
                modifiersStyles: _this.props.modifiersStyles,
                empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
                tabIndex: tabIndex,
                ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
                ariaDisabled: isOutside || dayModifiers.indexOf(_this.props.classNames.disabled) > -1,
                ariaSelected: dayModifiers.indexOf(_this.props.classNames.selected) > -1,
                onClick: _this.props.onDayClick,
                onFocus: _this.props.onDayFocus,
                onKeyDown: _this.props.onDayKeyDown,
                onMouseEnter: _this.props.onDayMouseEnter,
                onMouseLeave: _this.props.onDayMouseLeave,
                onMouseDown: _this.props.onDayMouseDown,
                onMouseUp: _this.props.onDayMouseUp,
                onTouchEnd: _this.props.onDayTouchEnd,
                onTouchStart: _this.props.onDayTouchStart
            }, _this.props.renderDay(day, modifiers));
        }, _temp), $86ecc989f6a54b35$var$_possibleConstructorReturn(_this, _ret);
    }
    $86ecc989f6a54b35$var$_createClass(Month, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props = this.props, classNames = _props.classNames, month = _props.month, months = _props.months, fixedWeeks = _props.fixedWeeks, captionElement = _props.captionElement, weekdayElement = _props.weekdayElement, locale = _props.locale, localeUtils = _props.localeUtils, weekdaysLong = _props.weekdaysLong, weekdaysShort = _props.weekdaysShort, firstDayOfWeek = _props.firstDayOfWeek, onCaptionClick = _props.onCaptionClick, showWeekNumbers = _props.showWeekNumbers, showWeekDays = _props.showWeekDays, onWeekClick = _props.onWeekClick;
                var captionProps = {
                    date: month,
                    classNames: classNames,
                    months: months,
                    localeUtils: localeUtils,
                    locale: locale,
                    onClick: onCaptionClick ? function(e) {
                        return onCaptionClick(month, e);
                    } : undefined
                };
                var caption = $86ecc989f6a54b35$var$_react2.default.isValidElement(captionElement) ? $86ecc989f6a54b35$var$_react2.default.cloneElement(captionElement, captionProps) : $86ecc989f6a54b35$var$_react2.default.createElement(captionElement, captionProps);
                var weeks = $86ecc989f6a54b35$var$Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
                return $86ecc989f6a54b35$var$_react2.default.createElement("div", {
                    className: classNames.month,
                    role: "grid"
                }, caption, showWeekDays && $86ecc989f6a54b35$var$_react2.default.createElement($86ecc989f6a54b35$var$_Weekdays2.default, {
                    classNames: classNames,
                    weekdaysShort: weekdaysShort,
                    weekdaysLong: weekdaysLong,
                    firstDayOfWeek: firstDayOfWeek,
                    showWeekNumbers: showWeekNumbers,
                    locale: locale,
                    localeUtils: localeUtils,
                    weekdayElement: weekdayElement
                }), $86ecc989f6a54b35$var$_react2.default.createElement("div", {
                    className: classNames.body,
                    role: "rowgroup"
                }, weeks.map(function(week) {
                    var weekNumber = void 0;
                    if (showWeekNumbers) weekNumber = $86ecc989f6a54b35$var$DateUtils.getWeekNumber(week[6]);
                    return $86ecc989f6a54b35$var$_react2.default.createElement("div", {
                        key: week[0].getTime(),
                        className: classNames.week,
                        role: "row"
                    }, showWeekNumbers && $86ecc989f6a54b35$var$_react2.default.createElement("div", {
                        className: classNames.weekNumber,
                        tabIndex: onWeekClick ? 0 : -1,
                        role: "gridcell",
                        onClick: onWeekClick ? function(e) {
                            return onWeekClick(weekNumber, week, e);
                        } : undefined,
                        onKeyUp: onWeekClick ? function(e) {
                            return e.keyCode === $6s8b9.ENTER && onWeekClick(weekNumber, week, e);
                        } : undefined
                    }, _this2.props.renderWeek(weekNumber, week, month)), week.map(_this2.renderDay));
                })));
            }
        }
    ]);
    return Month;
}($ca3MY.Component);
module.exports.default = $86ecc989f6a54b35$var$Month;

});
parcelRegister("gPZtF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c42118ed06f6a342$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $ca3MY = parcelRequire("ca3MY");
var $c42118ed06f6a342$var$_react2 = $c42118ed06f6a342$var$_interopRequireDefault($ca3MY);
function $c42118ed06f6a342$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c42118ed06f6a342$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c42118ed06f6a342$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c42118ed06f6a342$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $c42118ed06f6a342$var$Weekdays = function(_Component) {
    $c42118ed06f6a342$var$_inherits(Weekdays, _Component);
    function Weekdays() {
        $c42118ed06f6a342$var$_classCallCheck(this, Weekdays);
        return $c42118ed06f6a342$var$_possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
    }
    $c42118ed06f6a342$var$_createClass(Weekdays, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return this.props !== nextProps;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, classNames = _props.classNames, firstDayOfWeek = _props.firstDayOfWeek, showWeekNumbers = _props.showWeekNumbers, weekdaysLong = _props.weekdaysLong, weekdaysShort = _props.weekdaysShort, locale = _props.locale, localeUtils = _props.localeUtils, weekdayElement = _props.weekdayElement;
                var days = [];
                for(var i = 0; i < 7; i += 1){
                    var weekday = (i + firstDayOfWeek) % 7;
                    var elementProps = {
                        key: i,
                        className: classNames.weekday,
                        weekday: weekday,
                        weekdaysLong: weekdaysLong,
                        weekdaysShort: weekdaysShort,
                        localeUtils: localeUtils,
                        locale: locale
                    };
                    var element = $c42118ed06f6a342$var$_react2.default.isValidElement(weekdayElement) ? $c42118ed06f6a342$var$_react2.default.cloneElement(weekdayElement, elementProps) : $c42118ed06f6a342$var$_react2.default.createElement(weekdayElement, elementProps);
                    days.push(element);
                }
                return $c42118ed06f6a342$var$_react2.default.createElement("div", {
                    className: classNames.weekdays,
                    role: "rowgroup"
                }, $c42118ed06f6a342$var$_react2.default.createElement("div", {
                    className: classNames.weekdaysRow,
                    role: "row"
                }, showWeekNumbers && $c42118ed06f6a342$var$_react2.default.createElement("div", {
                    className: classNames.weekday
                }), days));
            }
        }
    ]);
    return Weekdays;
}($ca3MY.Component);
module.exports.default = $c42118ed06f6a342$var$Weekdays;

});

parcelRegister("22R5a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $17d4f1b6e8d6a4a8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $17d4f1b6e8d6a4a8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $ca3MY = parcelRequire("ca3MY");
var $17d4f1b6e8d6a4a8$var$_react2 = $17d4f1b6e8d6a4a8$var$_interopRequireDefault($ca3MY);

var $7zY9I = parcelRequire("7zY9I");

var $5UjR8 = parcelRequire("5UjR8");

var $ijsL0 = parcelRequire("ijsL0");
var $17d4f1b6e8d6a4a8$var$_classNames2 = $17d4f1b6e8d6a4a8$var$_interopRequireDefault($ijsL0);
function $17d4f1b6e8d6a4a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $17d4f1b6e8d6a4a8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $17d4f1b6e8d6a4a8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $17d4f1b6e8d6a4a8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */ 
function $17d4f1b6e8d6a4a8$var$handleEvent(handler, day, modifiers) {
    if (!handler) return undefined;
    return function(e) {
        e.persist();
        handler(day, modifiers, e);
    };
}
var $17d4f1b6e8d6a4a8$var$Day = function(_Component) {
    $17d4f1b6e8d6a4a8$var$_inherits(Day, _Component);
    function Day() {
        $17d4f1b6e8d6a4a8$var$_classCallCheck(this, Day);
        return $17d4f1b6e8d6a4a8$var$_possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
    }
    $17d4f1b6e8d6a4a8$var$_createClass(Day, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this2 = this;
                var propNames = Object.keys(this.props);
                var nextPropNames = Object.keys(nextProps);
                if (propNames.length !== nextPropNames.length) return true;
                return propNames.some(function(name) {
                    if (name === "modifiers" || name === "modifiersStyles" || name === "classNames") {
                        var prop = _this2.props[name];
                        var nextProp = nextProps[name];
                        var modifiers = Object.keys(prop);
                        var nextModifiers = Object.keys(nextProp);
                        if (modifiers.length !== nextModifiers.length) return true;
                        return modifiers.some(function(mod) {
                            return !(0, $5UjR8.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
                        });
                    }
                    if (name === "day") return !(0, $7zY9I.isSameDay)(_this2.props[name], nextProps[name]);
                    return !(0, $5UjR8.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, classNames = _props.classNames, modifiersStyles = _props.modifiersStyles, day = _props.day, tabIndex = _props.tabIndex, empty = _props.empty, modifiers = _props.modifiers, onMouseEnter = _props.onMouseEnter, onMouseLeave = _props.onMouseLeave, onMouseUp = _props.onMouseUp, onMouseDown = _props.onMouseDown, onClick = _props.onClick, onKeyDown = _props.onKeyDown, onTouchStart = _props.onTouchStart, onTouchEnd = _props.onTouchEnd, onFocus = _props.onFocus, ariaLabel = _props.ariaLabel, ariaDisabled = _props.ariaDisabled, ariaSelected = _props.ariaSelected, children = _props.children;
                var className = classNames.day;
                if (classNames !== $17d4f1b6e8d6a4a8$var$_classNames2.default) // When using CSS modules prefix the modifier as required by the BEM syntax
                className += " " + Object.keys(modifiers).join(" ");
                else className += Object.keys(modifiers).map(function(modifier) {
                    return " " + className + "--" + modifier;
                }).join("");
                var style = void 0;
                if (modifiersStyles) Object.keys(modifiers).filter(function(modifier) {
                    return !!modifiersStyles[modifier];
                }).forEach(function(modifier) {
                    style = $17d4f1b6e8d6a4a8$var$_extends({}, style, modifiersStyles[modifier]);
                });
                if (empty) return $17d4f1b6e8d6a4a8$var$_react2.default.createElement("div", {
                    "aria-disabled": true,
                    className: className,
                    style: style
                });
                return $17d4f1b6e8d6a4a8$var$_react2.default.createElement("div", {
                    className: className,
                    tabIndex: tabIndex,
                    style: style,
                    role: "gridcell",
                    "aria-label": ariaLabel,
                    "aria-disabled": ariaDisabled,
                    "aria-selected": ariaSelected,
                    onClick: $17d4f1b6e8d6a4a8$var$handleEvent(onClick, day, modifiers),
                    onKeyDown: $17d4f1b6e8d6a4a8$var$handleEvent(onKeyDown, day, modifiers),
                    onMouseEnter: $17d4f1b6e8d6a4a8$var$handleEvent(onMouseEnter, day, modifiers),
                    onMouseLeave: $17d4f1b6e8d6a4a8$var$handleEvent(onMouseLeave, day, modifiers),
                    onMouseUp: $17d4f1b6e8d6a4a8$var$handleEvent(onMouseUp, day, modifiers),
                    onMouseDown: $17d4f1b6e8d6a4a8$var$handleEvent(onMouseDown, day, modifiers),
                    onTouchEnd: $17d4f1b6e8d6a4a8$var$handleEvent(onTouchEnd, day, modifiers),
                    onTouchStart: $17d4f1b6e8d6a4a8$var$handleEvent(onTouchStart, day, modifiers),
                    onFocus: $17d4f1b6e8d6a4a8$var$handleEvent(onFocus, day, modifiers)
                }, children);
            }
        }
    ]);
    return Day;
}($ca3MY.Component);
$17d4f1b6e8d6a4a8$var$Day.defaultProps = {
    tabIndex: -1
};
$17d4f1b6e8d6a4a8$var$Day.defaultProps = {
    modifiers: {},
    modifiersStyles: {},
    empty: false
};
module.exports.default = $17d4f1b6e8d6a4a8$var$Day;

});
parcelRegister("7zY9I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clone = $584a76f0fdded5bb$var$clone;
module.exports.isDate = $584a76f0fdded5bb$var$isDate;
module.exports.addMonths = $584a76f0fdded5bb$var$addMonths;
module.exports.isSameDay = $584a76f0fdded5bb$var$isSameDay;
module.exports.isSameMonth = $584a76f0fdded5bb$var$isSameMonth;
module.exports.isDayBefore = $584a76f0fdded5bb$var$isDayBefore;
module.exports.isDayAfter = $584a76f0fdded5bb$var$isDayAfter;
module.exports.isPastDay = $584a76f0fdded5bb$var$isPastDay;
module.exports.isFutureDay = $584a76f0fdded5bb$var$isFutureDay;
module.exports.isDayBetween = $584a76f0fdded5bb$var$isDayBetween;
module.exports.addDayToRange = $584a76f0fdded5bb$var$addDayToRange;
module.exports.isDayInRange = $584a76f0fdded5bb$var$isDayInRange;
module.exports.getWeekNumber = $584a76f0fdded5bb$var$getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */ function $584a76f0fdded5bb$var$clone(d) {
    return new Date(d.getTime());
}
/**
 * Return `true` if the passed value is a valid JavaScript Date object.
 *
 * @export
 * @param {any} value
 * @returns {Boolean}
 */ function $584a76f0fdded5bb$var$isDate(value) {
    return value instanceof Date && !isNaN(value.valueOf());
}
/**
 * Return `d` as a new date with `n` months added.
 *
 * @export
 * @param {Date} d
 * @param {number} n
 */ function $584a76f0fdded5bb$var$addMonths(d, n) {
    var newDate = $584a76f0fdded5bb$var$clone(d);
    newDate.setMonth(d.getMonth() + n);
    return newDate;
}
/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */ function $584a76f0fdded5bb$var$isSameDay(d1, d2) {
    if (!d1 || !d2) return false;
    return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}
/**
 * Return `true` if two dates fall in the same month.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */ function $584a76f0fdded5bb$var$isSameMonth(d1, d2) {
    if (!d1 || !d2) return false;
    return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}
/**
 * Returns `true` if the first day is before the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */ function $584a76f0fdded5bb$var$isDayBefore(d1, d2) {
    var day1 = $584a76f0fdded5bb$var$clone(d1).setHours(0, 0, 0, 0);
    var day2 = $584a76f0fdded5bb$var$clone(d2).setHours(0, 0, 0, 0);
    return day1 < day2;
}
/**
 * Returns `true` if the first day is after the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */ function $584a76f0fdded5bb$var$isDayAfter(d1, d2) {
    var day1 = $584a76f0fdded5bb$var$clone(d1).setHours(0, 0, 0, 0);
    var day2 = $584a76f0fdded5bb$var$clone(d2).setHours(0, 0, 0, 0);
    return day1 > day2;
}
/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */ function $584a76f0fdded5bb$var$isPastDay(d) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return $584a76f0fdded5bb$var$isDayBefore(d, today);
}
/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */ function $584a76f0fdded5bb$var$isFutureDay(d) {
    var tomorrow = new Date(new Date().getTime() + 86400000);
    tomorrow.setHours(0, 0, 0, 0);
    return d >= tomorrow;
}
/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */ function $584a76f0fdded5bb$var$isDayBetween(d, d1, d2) {
    var date = $584a76f0fdded5bb$var$clone(d);
    date.setHours(0, 0, 0, 0);
    return $584a76f0fdded5bb$var$isDayAfter(date, d1) && $584a76f0fdded5bb$var$isDayBefore(date, d2) || $584a76f0fdded5bb$var$isDayAfter(date, d2) && $584a76f0fdded5bb$var$isDayBefore(date, d1);
}
/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */ function $584a76f0fdded5bb$var$addDayToRange(day) {
    var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        from: null,
        to: null
    };
    var from = range.from, to = range.to;
    if (!from) from = day;
    else if (from && to && $584a76f0fdded5bb$var$isSameDay(from, to) && $584a76f0fdded5bb$var$isSameDay(day, from)) {
        from = null;
        to = null;
    } else if (to && $584a76f0fdded5bb$var$isDayBefore(day, from)) from = day;
    else if (to && $584a76f0fdded5bb$var$isSameDay(day, to)) {
        from = day;
        to = day;
    } else {
        to = day;
        if ($584a76f0fdded5bb$var$isDayBefore(to, from)) {
            to = from;
            from = day;
        }
    }
    return {
        from: from,
        to: to
    };
}
/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */ function $584a76f0fdded5bb$var$isDayInRange(day, range) {
    var from = range.from, to = range.to;
    return from && $584a76f0fdded5bb$var$isSameDay(day, from) || to && $584a76f0fdded5bb$var$isSameDay(day, to) || from && to && $584a76f0fdded5bb$var$isDayBetween(day, from, to);
}
/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 *
 * @export
 * @param {Date} day
 * @returns {Number}
 */ function $584a76f0fdded5bb$var$getWeekNumber(day) {
    var date = $584a76f0fdded5bb$var$clone(day);
    date.setHours(0, 0, 0);
    date.setDate(date.getDate() + 4 - (date.getDay() || 7));
    return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}
module.exports.default = {
    addDayToRange: $584a76f0fdded5bb$var$addDayToRange,
    addMonths: $584a76f0fdded5bb$var$addMonths,
    clone: $584a76f0fdded5bb$var$clone,
    getWeekNumber: $584a76f0fdded5bb$var$getWeekNumber,
    isDate: $584a76f0fdded5bb$var$isDate,
    isDayAfter: $584a76f0fdded5bb$var$isDayAfter,
    isDayBefore: $584a76f0fdded5bb$var$isDayBefore,
    isDayBetween: $584a76f0fdded5bb$var$isDayBetween,
    isDayInRange: $584a76f0fdded5bb$var$isDayInRange,
    isFutureDay: $584a76f0fdded5bb$var$isFutureDay,
    isPastDay: $584a76f0fdded5bb$var$isPastDay,
    isSameDay: $584a76f0fdded5bb$var$isSameDay,
    isSameMonth: $584a76f0fdded5bb$var$isSameMonth
};

});

parcelRegister("5UjR8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $44d195b2f0788f84$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports.cancelEvent = $44d195b2f0788f84$var$cancelEvent;
module.exports.getFirstDayOfMonth = $44d195b2f0788f84$var$getFirstDayOfMonth;
module.exports.getDaysInMonth = $44d195b2f0788f84$var$getDaysInMonth;
module.exports.getModifiersFromProps = $44d195b2f0788f84$var$getModifiersFromProps;
module.exports.getFirstDayOfWeekFromProps = $44d195b2f0788f84$var$getFirstDayOfWeekFromProps;
module.exports.isRangeOfDates = $44d195b2f0788f84$var$isRangeOfDates;
module.exports.getMonthsDiff = $44d195b2f0788f84$var$getMonthsDiff;
module.exports.getWeekArray = $44d195b2f0788f84$var$getWeekArray;
module.exports.startOfMonth = $44d195b2f0788f84$var$startOfMonth;
module.exports.getDayNodes = $44d195b2f0788f84$var$getDayNodes;
module.exports.nodeListToArray = $44d195b2f0788f84$var$nodeListToArray;
module.exports.hasOwnProp = $44d195b2f0788f84$var$hasOwnProp;

var $7zY9I = parcelRequire("7zY9I");

var $kMjnI = parcelRequire("kMjnI");

var $ijsL0 = parcelRequire("ijsL0");
var $44d195b2f0788f84$var$_classNames2 = $44d195b2f0788f84$var$_interopRequireDefault($ijsL0);
function $44d195b2f0788f84$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $44d195b2f0788f84$var$cancelEvent(e) {
    e.preventDefault();
    e.stopPropagation();
}
function $44d195b2f0788f84$var$getFirstDayOfMonth(d) {
    return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}
function $44d195b2f0788f84$var$getDaysInMonth(d) {
    var resultDate = $44d195b2f0788f84$var$getFirstDayOfMonth(d);
    resultDate.setMonth(resultDate.getMonth() + 1);
    resultDate.setDate(resultDate.getDate() - 1);
    return resultDate.getDate();
}
function $44d195b2f0788f84$var$getModifiersFromProps(props) {
    var modifiers = $44d195b2f0788f84$var$_extends({}, props.modifiers);
    if (props.selectedDays) modifiers[props.classNames.selected] = props.selectedDays;
    if (props.disabledDays) modifiers[props.classNames.disabled] = props.disabledDays;
    return modifiers;
}
function $44d195b2f0788f84$var$getFirstDayOfWeekFromProps(props) {
    var firstDayOfWeek = props.firstDayOfWeek, _props$locale = props.locale, locale = _props$locale === undefined ? "en" : _props$locale, _props$localeUtils = props.localeUtils, localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;
    if (!isNaN(firstDayOfWeek)) return firstDayOfWeek;
    if (localeUtils.getFirstDayOfWeek) return localeUtils.getFirstDayOfWeek(locale);
    return 0;
}
function $44d195b2f0788f84$var$isRangeOfDates(value) {
    return !!(value && value.from && value.to);
}
function $44d195b2f0788f84$var$getMonthsDiff(d1, d2) {
    return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}
function $44d195b2f0788f84$var$getWeekArray(d) {
    var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $kMjnI.getFirstDayOfWeek)();
    var fixedWeeks = arguments[2];
    var daysInMonth = $44d195b2f0788f84$var$getDaysInMonth(d);
    var dayArray = [];
    var week = [];
    var weekArray = [];
    for(var i = 1; i <= daysInMonth; i += 1)dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
    dayArray.forEach(function(day) {
        if (week.length > 0 && day.getDay() === firstDayOfWeek) {
            weekArray.push(week);
            week = [];
        }
        week.push(day);
        if (dayArray.indexOf(day) === dayArray.length - 1) weekArray.push(week);
    });
    // unshift days to start the first week
    var firstWeek = weekArray[0];
    for(var _i = 7 - firstWeek.length; _i > 0; _i -= 1){
        var outsideDate = (0, $7zY9I.clone)(firstWeek[0]);
        outsideDate.setDate(firstWeek[0].getDate() - 1);
        firstWeek.unshift(outsideDate);
    }
    // push days until the end of the last week
    var lastWeek = weekArray[weekArray.length - 1];
    for(var _i2 = lastWeek.length; _i2 < 7; _i2 += 1){
        var _outsideDate = (0, $7zY9I.clone)(lastWeek[lastWeek.length - 1]);
        _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
        lastWeek.push(_outsideDate);
    }
    // add extra weeks to reach 6 weeks
    if (fixedWeeks && weekArray.length < 6) {
        var lastExtraWeek = void 0;
        for(var _i3 = weekArray.length; _i3 < 6; _i3 += 1){
            lastExtraWeek = weekArray[weekArray.length - 1];
            var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
            var extraWeek = [];
            for(var j = 0; j < 7; j += 1){
                var _outsideDate2 = (0, $7zY9I.clone)(lastDay);
                _outsideDate2.setDate(lastDay.getDate() + j + 1);
                extraWeek.push(_outsideDate2);
            }
            weekArray.push(extraWeek);
        }
    }
    return weekArray;
}
function $44d195b2f0788f84$var$startOfMonth(d) {
    var newDate = (0, $7zY9I.clone)(d);
    newDate.setDate(1);
    newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
    return newDate;
}
function $44d195b2f0788f84$var$getDayNodes(node, classNames) {
    var outsideClassName = void 0;
    if (classNames === $44d195b2f0788f84$var$_classNames2.default) // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + "--" + classNames.outside;
    else outsideClassName = "" + classNames.outside;
    var dayQuery = classNames.day.replace(/ /g, ".");
    var outsideDayQuery = outsideClassName.replace(/ /g, ".");
    var selector = "." + dayQuery + ":not(." + outsideDayQuery + ")";
    return node.querySelectorAll(selector);
}
function $44d195b2f0788f84$var$nodeListToArray(nodeList) {
    return Array.prototype.slice.call(nodeList, 0);
}
function $44d195b2f0788f84$var$hasOwnProp(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});


parcelRegister("40ahm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dayMatchesModifier = $2e9f22bb58f365f2$var$dayMatchesModifier;
module.exports.getModifiersForDay = $2e9f22bb58f365f2$var$getModifiersForDay;

var $7zY9I = parcelRequire("7zY9I");

var $5UjR8 = parcelRequire("5UjR8");
/**
 * Return `true` if a date matches the specified modifier.
 *
 * @export
 * @param {Date} day
 * @param {Any} modifier
 * @return {Boolean}
 */ function $2e9f22bb58f365f2$var$dayMatchesModifier(day, modifier) {
    if (!modifier) return false;
    var arr = Array.isArray(modifier) ? modifier : [
        modifier
    ];
    return arr.some(function(mod) {
        if (!mod) return false;
        if (mod instanceof Date) return (0, $7zY9I.isSameDay)(day, mod);
        if ((0, $5UjR8.isRangeOfDates)(mod)) return (0, $7zY9I.isDayInRange)(day, mod);
        if (mod.after && mod.before && (0, $7zY9I.isDayAfter)(mod.before, mod.after)) return (0, $7zY9I.isDayAfter)(day, mod.after) && (0, $7zY9I.isDayBefore)(day, mod.before);
        if (mod.after && mod.before && ((0, $7zY9I.isDayAfter)(mod.after, mod.before) || (0, $7zY9I.isSameDay)(mod.after, mod.before))) return (0, $7zY9I.isDayAfter)(day, mod.after) || (0, $7zY9I.isDayBefore)(day, mod.before);
        if (mod.after) return (0, $7zY9I.isDayAfter)(day, mod.after);
        if (mod.before) return (0, $7zY9I.isDayBefore)(day, mod.before);
        if (mod.daysOfWeek) return mod.daysOfWeek.some(function(dayOfWeek) {
            return day.getDay() === dayOfWeek;
        });
        if (typeof mod === "function") return mod(day);
        return false;
    });
}
/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 *
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}]
 * @return {Array}
 */ function $2e9f22bb58f365f2$var$getModifiersForDay(day) {
    var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(modifiersObj).reduce(function(modifiers, modifierName) {
        var value = modifiersObj[modifierName];
        if ($2e9f22bb58f365f2$var$dayMatchesModifier(day, value)) modifiers.push(modifierName);
        return modifiers;
    }, []);
}
module.exports.default = {
    dayMatchesModifier: $2e9f22bb58f365f2$var$dayMatchesModifier,
    getModifiersForDay: $2e9f22bb58f365f2$var$getModifiersForDay
};

});


parcelRegister("b4bsz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $80e8f52172a42ae9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $ca3MY = parcelRequire("ca3MY");
var $80e8f52172a42ae9$var$_react2 = $80e8f52172a42ae9$var$_interopRequireDefault($ca3MY);
function $80e8f52172a42ae9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $80e8f52172a42ae9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $80e8f52172a42ae9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $80e8f52172a42ae9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $80e8f52172a42ae9$var$Weekday = function(_Component) {
    $80e8f52172a42ae9$var$_inherits(Weekday, _Component);
    function Weekday() {
        $80e8f52172a42ae9$var$_classCallCheck(this, Weekday);
        return $80e8f52172a42ae9$var$_possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
    }
    $80e8f52172a42ae9$var$_createClass(Weekday, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return this.props !== nextProps;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, weekday = _props.weekday, className = _props.className, weekdaysLong = _props.weekdaysLong, weekdaysShort = _props.weekdaysShort, localeUtils = _props.localeUtils, locale = _props.locale;
                var title = void 0;
                if (weekdaysLong) title = weekdaysLong[weekday];
                else title = localeUtils.formatWeekdayLong(weekday, locale);
                var content = void 0;
                if (weekdaysShort) content = weekdaysShort[weekday];
                else content = localeUtils.formatWeekdayShort(weekday, locale);
                return $80e8f52172a42ae9$var$_react2.default.createElement("div", {
                    className: className,
                    role: "columnheader"
                }, $80e8f52172a42ae9$var$_react2.default.createElement("abbr", {
                    title: title
                }, content));
            }
        }
    ]);
    return Weekday;
}($ca3MY.Component);
module.exports.default = $80e8f52172a42ae9$var$Weekday;

});




parcelRegister("23Qu9", function(module, exports) {

module.exports = (parcelRequire("iuLYp"));

});
parcelRegister("iuLYp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatDay = $d7703dd3054e3014$var$formatDay;
module.exports.formatMonthTitle = $d7703dd3054e3014$var$formatMonthTitle;
module.exports.formatWeekdayShort = $d7703dd3054e3014$var$formatWeekdayShort;
module.exports.formatWeekdayLong = $d7703dd3054e3014$var$formatWeekdayLong;
module.exports.getFirstDayOfWeek = $d7703dd3054e3014$var$getFirstDayOfWeek;
module.exports.getMonths = $d7703dd3054e3014$var$getMonths;
module.exports.formatDate = $d7703dd3054e3014$var$formatDate;
module.exports.parseDate = $d7703dd3054e3014$var$parseDate;

var $g6ndF = parcelRequire("g6ndF");
var $d7703dd3054e3014$var$_moment2 = $d7703dd3054e3014$var$_interopRequireDefault($g6ndF);
function $d7703dd3054e3014$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d7703dd3054e3014$var$formatDay(day) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
    return (0, $d7703dd3054e3014$var$_moment2.default)(day).locale(locale).format("ddd ll");
} /* eslint-disable import/no-extraneous-dependencies, no-underscore-dangle */ 
function $d7703dd3054e3014$var$formatMonthTitle(date) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
    return (0, $d7703dd3054e3014$var$_moment2.default)(date).locale(locale).format("MMMM YYYY");
}
function $d7703dd3054e3014$var$formatWeekdayShort(day) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
    return $d7703dd3054e3014$var$_moment2.default.localeData(locale).weekdaysMin()[day];
}
function $d7703dd3054e3014$var$formatWeekdayLong(day) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
    return $d7703dd3054e3014$var$_moment2.default.localeData(locale).weekdays()[day];
}
function $d7703dd3054e3014$var$getFirstDayOfWeek() {
    var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en";
    return $d7703dd3054e3014$var$_moment2.default.localeData(locale).firstDayOfWeek();
}
function $d7703dd3054e3014$var$getMonths() {
    var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en";
    return $d7703dd3054e3014$var$_moment2.default.localeData(locale).months();
}
function $d7703dd3054e3014$var$formatDate(date) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "L";
    var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en";
    return (0, $d7703dd3054e3014$var$_moment2.default)(date).locale(locale).format(Array.isArray(format) ? format[0] : format);
}
function $d7703dd3054e3014$var$parseDate(str) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "L";
    var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en";
    var m = (0, $d7703dd3054e3014$var$_moment2.default)(str, format, locale, true);
    if (m.isValid()) return m.toDate();
    return undefined;
}
module.exports.default = {
    formatDay: $d7703dd3054e3014$var$formatDay,
    formatMonthTitle: $d7703dd3054e3014$var$formatMonthTitle,
    formatWeekdayShort: $d7703dd3054e3014$var$formatWeekdayShort,
    formatWeekdayLong: $d7703dd3054e3014$var$formatWeekdayLong,
    getFirstDayOfWeek: $d7703dd3054e3014$var$getFirstDayOfWeek,
    getMonths: $d7703dd3054e3014$var$getMonths,
    formatDate: $d7703dd3054e3014$var$formatDate,
    parseDate: $d7703dd3054e3014$var$parseDate
};

});


parcelRegister("9HTXl", function(module, exports) {

(function(global, factory) {
    factory((parcelRequire("g6ndF")));
})(module.exports, function(moment) {
    "use strict";
    //! moment.js locale configuration
    moment.defineLocale("af", {
        months: "Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),
        monthsShort: "Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),
        weekdays: "Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),
        weekdaysShort: "Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),
        weekdaysMin: "So_Ma_Di_Wo_Do_Vr_Sa".split("_"),
        meridiemParse: /vm|nm/i,
        isPM: function(input) {
            return /^nm$/i.test(input);
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 12) return isLower ? "vm" : "VM";
            else return isLower ? "nm" : "NM";
        },
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Vandag om] LT",
            nextDay: "[M\xf4re om] LT",
            nextWeek: "dddd [om] LT",
            lastDay: "[Gister om] LT",
            lastWeek: "[Laas] dddd [om] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "oor %s",
            past: "%s gelede",
            s: "'n paar sekondes",
            ss: "%d sekondes",
            m: "'n minuut",
            mm: "%d minute",
            h: "'n uur",
            hh: "%d ure",
            d: "'n dag",
            dd: "%d dae",
            M: "'n maand",
            MM: "%d maande",
            y: "'n jaar",
            yy: "%d jaar"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? "ste" : "de"); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var pluralForm = function(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
            "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
                "\u062B\u0627\u0646\u064A\u062A\u064A\u0646"
            ],
            "%d \u062B\u0648\u0627\u0646",
            "%d \u062B\u0627\u0646\u064A\u0629",
            "%d \u062B\u0627\u0646\u064A\u0629"
        ],
        m: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
            "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
                "\u062F\u0642\u064A\u0642\u062A\u064A\u0646"
            ],
            "%d \u062F\u0642\u0627\u0626\u0642",
            "%d \u062F\u0642\u064A\u0642\u0629",
            "%d \u062F\u0642\u064A\u0642\u0629"
        ],
        h: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
            "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u0633\u0627\u0639\u062A\u0627\u0646",
                "\u0633\u0627\u0639\u062A\u064A\u0646"
            ],
            "%d \u0633\u0627\u0639\u0627\u062A",
            "%d \u0633\u0627\u0639\u0629",
            "%d \u0633\u0627\u0639\u0629"
        ],
        d: [
            "\u0623\u0642\u0644 \u0645\u0646 \u064A\u0648\u0645",
            "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u064A\u0648\u0645\u0627\u0646",
                "\u064A\u0648\u0645\u064A\u0646"
            ],
            "%d \u0623\u064A\u0627\u0645",
            "%d \u064A\u0648\u0645\u064B\u0627",
            "%d \u064A\u0648\u0645"
        ],
        M: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
            "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
            [
                "\u0634\u0647\u0631\u0627\u0646",
                "\u0634\u0647\u0631\u064A\u0646"
            ],
            "%d \u0623\u0634\u0647\u0631",
            "%d \u0634\u0647\u0631\u0627",
            "%d \u0634\u0647\u0631"
        ],
        y: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
            "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u0639\u0627\u0645\u0627\u0646",
                "\u0639\u0627\u0645\u064A\u0646"
            ],
            "%d \u0623\u0639\u0648\u0627\u0645",
            "%d \u0639\u0627\u0645\u064B\u0627",
            "%d \u0639\u0627\u0645"
        ]
    }, pluralize = function(u) {
        return function(number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number), str = plurals[u][pluralForm(number)];
            if (f === 2) str = str[withoutSuffix ? 0 : 1];
            return str.replace(/%d/i, number);
        };
    }, months = [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ];
    moment.defineLocale("ar-dz", {
        months: months,
        monthsShort: months,
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
        weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/\u200FM/\u200FYYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /ص|م/,
        isPM: function(input) {
            return "\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635";
            else return "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u064B\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0628\u0639\u062F %s",
            past: "\u0645\u0646\u0630 %s",
            s: pluralize("s"),
            ss: pluralize("s"),
            m: pluralize("m"),
            mm: pluralize("m"),
            h: pluralize("h"),
            hh: pluralize("h"),
            d: pluralize("d"),
            dd: pluralize("d"),
            M: pluralize("M"),
            MM: pluralize("M"),
            y: pluralize("y"),
            yy: pluralize("y")
        },
        postformat: function(string) {
            return string.replace(/,/g, "\u060C");
        },
        week: {
            dow: 0,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("ar-kw", {
        months: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648\u0632_\u063A\u0634\u062A_\u0634\u062A\u0646\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062F\u062C\u0646\u0628\u0631".split("_"),
        monthsShort: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648\u0632_\u063A\u0634\u062A_\u0634\u062A\u0646\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062F\u062C\u0646\u0628\u0631".split("_"),
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062A\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
        weekdaysShort: "\u0627\u062D\u062F_\u0627\u062A\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0641\u064A %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062B\u0648\u0627\u0646",
            ss: "%d \u062B\u0627\u0646\u064A\u0629",
            m: "\u062F\u0642\u064A\u0642\u0629",
            mm: "%d \u062F\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062A",
            d: "\u064A\u0648\u0645",
            dd: "%d \u0623\u064A\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062A"
        },
        week: {
            dow: 0,
            doy: 12
        }
    });
    //! moment.js locale configuration
    var symbolMap = {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        0: "0"
    }, pluralForm$1 = function(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals$1 = {
        s: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
            "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
                "\u062B\u0627\u0646\u064A\u062A\u064A\u0646"
            ],
            "%d \u062B\u0648\u0627\u0646",
            "%d \u062B\u0627\u0646\u064A\u0629",
            "%d \u062B\u0627\u0646\u064A\u0629"
        ],
        m: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
            "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
                "\u062F\u0642\u064A\u0642\u062A\u064A\u0646"
            ],
            "%d \u062F\u0642\u0627\u0626\u0642",
            "%d \u062F\u0642\u064A\u0642\u0629",
            "%d \u062F\u0642\u064A\u0642\u0629"
        ],
        h: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
            "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u0633\u0627\u0639\u062A\u0627\u0646",
                "\u0633\u0627\u0639\u062A\u064A\u0646"
            ],
            "%d \u0633\u0627\u0639\u0627\u062A",
            "%d \u0633\u0627\u0639\u0629",
            "%d \u0633\u0627\u0639\u0629"
        ],
        d: [
            "\u0623\u0642\u0644 \u0645\u0646 \u064A\u0648\u0645",
            "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u064A\u0648\u0645\u0627\u0646",
                "\u064A\u0648\u0645\u064A\u0646"
            ],
            "%d \u0623\u064A\u0627\u0645",
            "%d \u064A\u0648\u0645\u064B\u0627",
            "%d \u064A\u0648\u0645"
        ],
        M: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
            "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
            [
                "\u0634\u0647\u0631\u0627\u0646",
                "\u0634\u0647\u0631\u064A\u0646"
            ],
            "%d \u0623\u0634\u0647\u0631",
            "%d \u0634\u0647\u0631\u0627",
            "%d \u0634\u0647\u0631"
        ],
        y: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
            "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u0639\u0627\u0645\u0627\u0646",
                "\u0639\u0627\u0645\u064A\u0646"
            ],
            "%d \u0623\u0639\u0648\u0627\u0645",
            "%d \u0639\u0627\u0645\u064B\u0627",
            "%d \u0639\u0627\u0645"
        ]
    }, pluralize$1 = function(u) {
        return function(number, withoutSuffix, string, isFuture) {
            var f = pluralForm$1(number), str = plurals$1[u][pluralForm$1(number)];
            if (f === 2) str = str[withoutSuffix ? 0 : 1];
            return str.replace(/%d/i, number);
        };
    }, months$1 = [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ];
    moment.defineLocale("ar-ly", {
        months: months$1,
        monthsShort: months$1,
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
        weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/\u200FM/\u200FYYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /ص|م/,
        isPM: function(input) {
            return "\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635";
            else return "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u064B\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0628\u0639\u062F %s",
            past: "\u0645\u0646\u0630 %s",
            s: pluralize$1("s"),
            ss: pluralize$1("s"),
            m: pluralize$1("m"),
            mm: pluralize$1("m"),
            h: pluralize$1("h"),
            hh: pluralize$1("h"),
            d: pluralize$1("d"),
            dd: pluralize$1("d"),
            M: pluralize$1("M"),
            MM: pluralize$1("M"),
            y: pluralize$1("y"),
            yy: pluralize$1("y")
        },
        preparse: function(string) {
            return string.replace(/،/g, ",");
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap[match];
            }).replace(/,/g, "\u060C");
        },
        week: {
            dow: 6,
            doy: 12
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("ar-ma", {
        months: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648\u0632_\u063A\u0634\u062A_\u0634\u062A\u0646\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062F\u062C\u0646\u0628\u0631".split("_"),
        monthsShort: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648\u0632_\u063A\u0634\u062A_\u0634\u062A\u0646\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062F\u062C\u0646\u0628\u0631".split("_"),
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
        weekdaysShort: "\u0627\u062D\u062F_\u0627\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0641\u064A %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062B\u0648\u0627\u0646",
            ss: "%d \u062B\u0627\u0646\u064A\u0629",
            m: "\u062F\u0642\u064A\u0642\u0629",
            mm: "%d \u062F\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062A",
            d: "\u064A\u0648\u0645",
            dd: "%d \u0623\u064A\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062A"
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$1 = {
        1: "\u0661",
        2: "\u0662",
        3: "\u0663",
        4: "\u0664",
        5: "\u0665",
        6: "\u0666",
        7: "\u0667",
        8: "\u0668",
        9: "\u0669",
        0: "\u0660"
    }, numberMap = {
        "\u0661": "1",
        "\u0662": "2",
        "\u0663": "3",
        "\u0664": "4",
        "\u0665": "5",
        "\u0666": "6",
        "\u0667": "7",
        "\u0668": "8",
        "\u0669": "9",
        "\u0660": "0"
    };
    moment.defineLocale("ar-ps", {
        months: "\u0643\u0627\u0646\u0648\u0646 \u0627\u0644\u062B\u0627\u0646\u064A_\u0634\u0628\u0627\u0637_\u0622\u0630\u0627\u0631_\u0646\u064A\u0633\u0627\u0646_\u0623\u064A\u0651\u0627\u0631_\u062D\u0632\u064A\u0631\u0627\u0646_\u062A\u0645\u0651\u0648\u0632_\u0622\u0628_\u0623\u064A\u0644\u0648\u0644_\u062A\u0634\u0631\u064A \u0627\u0644\u0623\u0648\u0651\u0644_\u062A\u0634\u0631\u064A\u0646 \u0627\u0644\u062B\u0627\u0646\u064A_\u0643\u0627\u0646\u0648\u0646 \u0627\u0644\u0623\u0648\u0651\u0644".split("_"),
        monthsShort: "\u0643\u0662_\u0634\u0628\u0627\u0637_\u0622\u0630\u0627\u0631_\u0646\u064A\u0633\u0627\u0646_\u0623\u064A\u0651\u0627\u0631_\u062D\u0632\u064A\u0631\u0627\u0646_\u062A\u0645\u0651\u0648\u0632_\u0622\u0628_\u0623\u064A\u0644\u0648\u0644_\u062A\u0661_\u062A\u0662_\u0643\u0661".split("_"),
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
        weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /ص|م/,
        isPM: function(input) {
            return "\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635";
            else return "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0641\u064A %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062B\u0648\u0627\u0646",
            ss: "%d \u062B\u0627\u0646\u064A\u0629",
            m: "\u062F\u0642\u064A\u0642\u0629",
            mm: "%d \u062F\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062A",
            d: "\u064A\u0648\u0645",
            dd: "%d \u0623\u064A\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062A"
        },
        preparse: function(string) {
            return string.replace(/[٣٤٥٦٧٨٩٠]/g, function(match) {
                return numberMap[match];
            }).split("") // reversed since negative lookbehind not supported everywhere
            .reverse().join("").replace(/[١٢](?![\u062a\u0643])/g, function(match) {
                return numberMap[match];
            }).split("").reverse().join("").replace(/،/g, ",");
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$1[match];
            }).replace(/,/g, "\u060C");
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    var symbolMap$2 = {
        1: "\u0661",
        2: "\u0662",
        3: "\u0663",
        4: "\u0664",
        5: "\u0665",
        6: "\u0666",
        7: "\u0667",
        8: "\u0668",
        9: "\u0669",
        0: "\u0660"
    }, numberMap$1 = {
        "\u0661": "1",
        "\u0662": "2",
        "\u0663": "3",
        "\u0664": "4",
        "\u0665": "5",
        "\u0666": "6",
        "\u0667": "7",
        "\u0668": "8",
        "\u0669": "9",
        "\u0660": "0"
    };
    moment.defineLocale("ar-sa", {
        months: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A\u0648_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648_\u0623\u063A\u0633\u0637\u0633_\u0633\u0628\u062A\u0645\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062F\u064A\u0633\u0645\u0628\u0631".split("_"),
        monthsShort: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A\u0648_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648_\u0623\u063A\u0633\u0637\u0633_\u0633\u0628\u062A\u0645\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062F\u064A\u0633\u0645\u0628\u0631".split("_"),
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
        weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /ص|م/,
        isPM: function(input) {
            return "\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635";
            else return "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0641\u064A %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062B\u0648\u0627\u0646",
            ss: "%d \u062B\u0627\u0646\u064A\u0629",
            m: "\u062F\u0642\u064A\u0642\u0629",
            mm: "%d \u062F\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062A",
            d: "\u064A\u0648\u0645",
            dd: "%d \u0623\u064A\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062A"
        },
        preparse: function(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function(match) {
                return numberMap$1[match];
            }).replace(/،/g, ",");
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$2[match];
            }).replace(/,/g, "\u060C");
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("ar-tn", {
        months: "\u062C\u0627\u0646\u0641\u064A_\u0641\u064A\u0641\u0631\u064A_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064A\u0644_\u0645\u0627\u064A_\u062C\u0648\u0627\u0646_\u062C\u0648\u064A\u0644\u064A\u0629_\u0623\u0648\u062A_\u0633\u0628\u062A\u0645\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062F\u064A\u0633\u0645\u0628\u0631".split("_"),
        monthsShort: "\u062C\u0627\u0646\u0641\u064A_\u0641\u064A\u0641\u0631\u064A_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064A\u0644_\u0645\u0627\u064A_\u062C\u0648\u0627\u0646_\u062C\u0648\u064A\u0644\u064A\u0629_\u0623\u0648\u062A_\u0633\u0628\u062A\u0645\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062F\u064A\u0633\u0645\u0628\u0631".split("_"),
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
        weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0641\u064A %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062B\u0648\u0627\u0646",
            ss: "%d \u062B\u0627\u0646\u064A\u0629",
            m: "\u062F\u0642\u064A\u0642\u0629",
            mm: "%d \u062F\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062A",
            d: "\u064A\u0648\u0645",
            dd: "%d \u0623\u064A\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062A"
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$3 = {
        1: "\u0661",
        2: "\u0662",
        3: "\u0663",
        4: "\u0664",
        5: "\u0665",
        6: "\u0666",
        7: "\u0667",
        8: "\u0668",
        9: "\u0669",
        0: "\u0660"
    }, numberMap$2 = {
        "\u0661": "1",
        "\u0662": "2",
        "\u0663": "3",
        "\u0664": "4",
        "\u0665": "5",
        "\u0666": "6",
        "\u0667": "7",
        "\u0668": "8",
        "\u0669": "9",
        "\u0660": "0"
    }, pluralForm$2 = function(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals$2 = {
        s: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
            "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
                "\u062B\u0627\u0646\u064A\u062A\u064A\u0646"
            ],
            "%d \u062B\u0648\u0627\u0646",
            "%d \u062B\u0627\u0646\u064A\u0629",
            "%d \u062B\u0627\u0646\u064A\u0629"
        ],
        m: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
            "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
                "\u062F\u0642\u064A\u0642\u062A\u064A\u0646"
            ],
            "%d \u062F\u0642\u0627\u0626\u0642",
            "%d \u062F\u0642\u064A\u0642\u0629",
            "%d \u062F\u0642\u064A\u0642\u0629"
        ],
        h: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
            "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u0633\u0627\u0639\u062A\u0627\u0646",
                "\u0633\u0627\u0639\u062A\u064A\u0646"
            ],
            "%d \u0633\u0627\u0639\u0627\u062A",
            "%d \u0633\u0627\u0639\u0629",
            "%d \u0633\u0627\u0639\u0629"
        ],
        d: [
            "\u0623\u0642\u0644 \u0645\u0646 \u064A\u0648\u0645",
            "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u064A\u0648\u0645\u0627\u0646",
                "\u064A\u0648\u0645\u064A\u0646"
            ],
            "%d \u0623\u064A\u0627\u0645",
            "%d \u064A\u0648\u0645\u064B\u0627",
            "%d \u064A\u0648\u0645"
        ],
        M: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
            "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
            [
                "\u0634\u0647\u0631\u0627\u0646",
                "\u0634\u0647\u0631\u064A\u0646"
            ],
            "%d \u0623\u0634\u0647\u0631",
            "%d \u0634\u0647\u0631\u0627",
            "%d \u0634\u0647\u0631"
        ],
        y: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
            "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u0639\u0627\u0645\u0627\u0646",
                "\u0639\u0627\u0645\u064A\u0646"
            ],
            "%d \u0623\u0639\u0648\u0627\u0645",
            "%d \u0639\u0627\u0645\u064B\u0627",
            "%d \u0639\u0627\u0645"
        ]
    }, pluralize$2 = function(u) {
        return function(number, withoutSuffix, string, isFuture) {
            var f = pluralForm$2(number), str = plurals$2[u][pluralForm$2(number)];
            if (f === 2) str = str[withoutSuffix ? 0 : 1];
            return str.replace(/%d/i, number);
        };
    }, months$2 = [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ];
    moment.defineLocale("ar", {
        months: months$2,
        monthsShort: months$2,
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
        weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/\u200FM/\u200FYYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /ص|م/,
        isPM: function(input) {
            return "\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635";
            else return "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u064B\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0628\u0639\u062F %s",
            past: "\u0645\u0646\u0630 %s",
            s: pluralize$2("s"),
            ss: pluralize$2("s"),
            m: pluralize$2("m"),
            mm: pluralize$2("m"),
            h: pluralize$2("h"),
            hh: pluralize$2("h"),
            d: pluralize$2("d"),
            dd: pluralize$2("d"),
            M: pluralize$2("M"),
            MM: pluralize$2("M"),
            y: pluralize$2("y"),
            yy: pluralize$2("y")
        },
        preparse: function(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function(match) {
                return numberMap$2[match];
            }).replace(/،/g, ",");
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$3[match];
            }).replace(/,/g, "\u060C");
        },
        week: {
            dow: 6,
            doy: 12
        }
    });
    //! moment.js locale configuration
    var suffixes = {
        1: "-inci",
        5: "-inci",
        8: "-inci",
        70: "-inci",
        80: "-inci",
        2: "-nci",
        7: "-nci",
        20: "-nci",
        50: "-nci",
        3: "-\xfcnc\xfc",
        4: "-\xfcnc\xfc",
        100: "-\xfcnc\xfc",
        6: "-nc\u0131",
        9: "-uncu",
        10: "-uncu",
        30: "-uncu",
        60: "-\u0131nc\u0131",
        90: "-\u0131nc\u0131"
    };
    moment.defineLocale("az", {
        months: "yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split("_"),
        monthsShort: "yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),
        weekdays: "Bazar_Bazar ert\u0259si_\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131_\xc7\u0259r\u015F\u0259nb\u0259_C\xfcm\u0259 ax\u015Fam\u0131_C\xfcm\u0259_\u015E\u0259nb\u0259".split("_"),
        weekdaysShort: "Baz_BzE_\xc7Ax_\xc7\u0259r_CAx_C\xfcm_\u015E\u0259n".split("_"),
        weekdaysMin: "Bz_BE_\xc7A_\xc7\u0259_CA_C\xfc_\u015E\u0259".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[bug\xfcn saat] LT",
            nextDay: "[sabah saat] LT",
            nextWeek: "[g\u0259l\u0259n h\u0259ft\u0259] dddd [saat] LT",
            lastDay: "[d\xfcn\u0259n] LT",
            lastWeek: "[ke\xe7\u0259n h\u0259ft\u0259] dddd [saat] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s sonra",
            past: "%s \u0259vv\u0259l",
            s: "bir ne\xe7\u0259 saniy\u0259",
            ss: "%d saniy\u0259",
            m: "bir d\u0259qiq\u0259",
            mm: "%d d\u0259qiq\u0259",
            h: "bir saat",
            hh: "%d saat",
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            M: "bir ay",
            MM: "%d ay",
            y: "bir il",
            yy: "%d il"
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function(input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "gec\u0259";
            else if (hour < 12) return "s\u0259h\u0259r";
            else if (hour < 17) return "g\xfcnd\xfcz";
            else return "ax\u015Fam";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function(number) {
            if (number === 0) // special case for zero
            return number + "-\u0131nc\u0131";
            var a = number % 10, b = number % 100 - a, c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    function plural(word, num) {
        var forms = word.split("_");
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? "\u0441\u0435\u043A\u0443\u043D\u0434\u0430_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434" : "\u0441\u0435\u043A\u0443\u043D\u0434\u0443_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434",
            mm: withoutSuffix ? "\u0445\u0432\u0456\u043B\u0456\u043D\u0430_\u0445\u0432\u0456\u043B\u0456\u043D\u044B_\u0445\u0432\u0456\u043B\u0456\u043D" : "\u0445\u0432\u0456\u043B\u0456\u043D\u0443_\u0445\u0432\u0456\u043B\u0456\u043D\u044B_\u0445\u0432\u0456\u043B\u0456\u043D",
            hh: withoutSuffix ? "\u0433\u0430\u0434\u0437\u0456\u043D\u0430_\u0433\u0430\u0434\u0437\u0456\u043D\u044B_\u0433\u0430\u0434\u0437\u0456\u043D" : "\u0433\u0430\u0434\u0437\u0456\u043D\u0443_\u0433\u0430\u0434\u0437\u0456\u043D\u044B_\u0433\u0430\u0434\u0437\u0456\u043D",
            dd: "\u0434\u0437\u0435\u043D\u044C_\u0434\u043D\u0456_\u0434\u0437\u0451\u043D",
            MM: "\u043C\u0435\u0441\u044F\u0446_\u043C\u0435\u0441\u044F\u0446\u044B_\u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            yy: "\u0433\u043E\u0434_\u0433\u0430\u0434\u044B_\u0433\u0430\u0434\u043E\u045E"
        };
        if (key === "m") return withoutSuffix ? "\u0445\u0432\u0456\u043B\u0456\u043D\u0430" : "\u0445\u0432\u0456\u043B\u0456\u043D\u0443";
        else if (key === "h") return withoutSuffix ? "\u0433\u0430\u0434\u0437\u0456\u043D\u0430" : "\u0433\u0430\u0434\u0437\u0456\u043D\u0443";
        else return number + " " + plural(format[key], +number);
    }
    moment.defineLocale("be", {
        months: {
            format: "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F_\u043B\u044E\u0442\u0430\u0433\u0430_\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430_\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430_\u0442\u0440\u0430\u045E\u043D\u044F_\u0447\u044D\u0440\u0432\u0435\u043D\u044F_\u043B\u0456\u043F\u0435\u043D\u044F_\u0436\u043D\u0456\u045E\u043D\u044F_\u0432\u0435\u0440\u0430\u0441\u043D\u044F_\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430_\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430_\u0441\u043D\u0435\u0436\u043D\u044F".split("_"),
            standalone: "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C_\u043B\u044E\u0442\u044B_\u0441\u0430\u043A\u0430\u0432\u0456\u043A_\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A_\u0442\u0440\u0430\u0432\u0435\u043D\u044C_\u0447\u044D\u0440\u0432\u0435\u043D\u044C_\u043B\u0456\u043F\u0435\u043D\u044C_\u0436\u043D\u0456\u0432\u0435\u043D\u044C_\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C_\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A_\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434_\u0441\u043D\u0435\u0436\u0430\u043D\u044C".split("_")
        },
        monthsShort: "\u0441\u0442\u0443\u0434_\u043B\u044E\u0442_\u0441\u0430\u043A_\u043A\u0440\u0430\u0441_\u0442\u0440\u0430\u0432_\u0447\u044D\u0440\u0432_\u043B\u0456\u043F_\u0436\u043D\u0456\u0432_\u0432\u0435\u0440_\u043A\u0430\u0441\u0442_\u043B\u0456\u0441\u0442_\u0441\u043D\u0435\u0436".split("_"),
        weekdays: {
            format: "\u043D\u044F\u0434\u0437\u0435\u043B\u044E_\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A_\u0430\u045E\u0442\u043E\u0440\u0430\u043A_\u0441\u0435\u0440\u0430\u0434\u0443_\u0447\u0430\u0446\u0432\u0435\u0440_\u043F\u044F\u0442\u043D\u0456\u0446\u0443_\u0441\u0443\u0431\u043E\u0442\u0443".split("_"),
            standalone: "\u043D\u044F\u0434\u0437\u0435\u043B\u044F_\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A_\u0430\u045E\u0442\u043E\u0440\u0430\u043A_\u0441\u0435\u0440\u0430\u0434\u0430_\u0447\u0430\u0446\u0432\u0435\u0440_\u043F\u044F\u0442\u043D\u0456\u0446\u0430_\u0441\u0443\u0431\u043E\u0442\u0430".split("_"),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort: "\u043D\u0434_\u043F\u043D_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043F\u0442_\u0441\u0431".split("_"),
        weekdaysMin: "\u043D\u0434_\u043F\u043D_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043F\u0442_\u0441\u0431".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0433.",
            LLL: "D MMMM YYYY \u0433., HH:mm",
            LLLL: "dddd, D MMMM YYYY \u0433., HH:mm"
        },
        calendar: {
            sameDay: "[\u0421\u0451\u043D\u043D\u044F \u045E] LT",
            nextDay: "[\u0417\u0430\u045E\u0442\u0440\u0430 \u045E] LT",
            lastDay: "[\u0423\u0447\u043E\u0440\u0430 \u045E] LT",
            nextWeek: function() {
                return "[\u0423] dddd [\u045E] LT";
            },
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return "[\u0423 \u043C\u0456\u043D\u0443\u043B\u0443\u044E] dddd [\u045E] LT";
                    case 1:
                    case 2:
                    case 4:
                        return "[\u0423 \u043C\u0456\u043D\u0443\u043B\u044B] dddd [\u045E] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u043F\u0440\u0430\u0437 %s",
            past: "%s \u0442\u0430\u043C\u0443",
            s: "\u043D\u0435\u043A\u0430\u043B\u044C\u043A\u0456 \u0441\u0435\u043A\u0443\u043D\u0434",
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: "\u0434\u0437\u0435\u043D\u044C",
            dd: relativeTimeWithPlural,
            M: "\u043C\u0435\u0441\u044F\u0446",
            MM: relativeTimeWithPlural,
            y: "\u0433\u043E\u0434",
            yy: relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function(input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u043D\u043E\u0447\u044B";
            else if (hour < 12) return "\u0440\u0430\u043D\u0456\u0446\u044B";
            else if (hour < 17) return "\u0434\u043D\u044F";
            else return "\u0432\u0435\u0447\u0430\u0440\u0430";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function(number, period) {
            switch(period){
                case "M":
                case "d":
                case "DDD":
                case "w":
                case "W":
                    return (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? number + "-\u0456" : number + "-\u044B";
                case "D":
                    return number + "-\u0433\u0430";
                default:
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("bg", {
        months: "\u044F\u043D\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0438\u043B_\u043C\u0430\u0439_\u044E\u043D\u0438_\u044E\u043B\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438_\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438_\u043D\u043E\u0435\u043C\u0432\u0440\u0438_\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438".split("_"),
        monthsShort: "\u044F\u043D\u0443_\u0444\u0435\u0432_\u043C\u0430\u0440_\u0430\u043F\u0440_\u043C\u0430\u0439_\u044E\u043D\u0438_\u044E\u043B\u0438_\u0430\u0432\u0433_\u0441\u0435\u043F_\u043E\u043A\u0442_\u043D\u043E\u0435_\u0434\u0435\u043A".split("_"),
        weekdays: "\u043D\u0435\u0434\u0435\u043B\u044F_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u044F\u0434\u0430_\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A_\u043F\u0435\u0442\u044A\u043A_\u0441\u044A\u0431\u043E\u0442\u0430".split("_"),
        weekdaysShort: "\u043D\u0435\u0434_\u043F\u043E\u043D_\u0432\u0442\u043E_\u0441\u0440\u044F_\u0447\u0435\u0442_\u043F\u0435\u0442_\u0441\u044A\u0431".split("_"),
        weekdaysMin: "\u043D\u0434_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "D.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY H:mm",
            LLLL: "dddd, D MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[\u0414\u043D\u0435\u0441 \u0432] LT",
            nextDay: "[\u0423\u0442\u0440\u0435 \u0432] LT",
            nextWeek: "dddd [\u0432] LT",
            lastDay: "[\u0412\u0447\u0435\u0440\u0430 \u0432] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                    case 6:
                        return "[\u041C\u0438\u043D\u0430\u043B\u0430\u0442\u0430] dddd [\u0432] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[\u041C\u0438\u043D\u0430\u043B\u0438\u044F] dddd [\u0432] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0441\u043B\u0435\u0434 %s",
            past: "\u043F\u0440\u0435\u0434\u0438 %s",
            s: "\u043D\u044F\u043A\u043E\u043B\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            ss: "%d \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            m: "\u043C\u0438\u043D\u0443\u0442\u0430",
            mm: "%d \u043C\u0438\u043D\u0443\u0442\u0438",
            h: "\u0447\u0430\u0441",
            hh: "%d \u0447\u0430\u0441\u0430",
            d: "\u0434\u0435\u043D",
            dd: "%d \u0434\u0435\u043D\u0430",
            w: "\u0441\u0435\u0434\u043C\u0438\u0446\u0430",
            ww: "%d \u0441\u0435\u0434\u043C\u0438\u0446\u0438",
            M: "\u043C\u0435\u0441\u0435\u0446",
            MM: "%d \u043C\u0435\u0441\u0435\u0446\u0430",
            y: "\u0433\u043E\u0434\u0438\u043D\u0430",
            yy: "%d \u0433\u043E\u0434\u0438\u043D\u0438"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function(number) {
            var lastDigit = number % 10, last2Digits = number % 100;
            if (number === 0) return number + "-\u0435\u0432";
            else if (last2Digits === 0) return number + "-\u0435\u043D";
            else if (last2Digits > 10 && last2Digits < 20) return number + "-\u0442\u0438";
            else if (lastDigit === 1) return number + "-\u0432\u0438";
            else if (lastDigit === 2) return number + "-\u0440\u0438";
            else if (lastDigit === 7 || lastDigit === 8) return number + "-\u043C\u0438";
            else return number + "-\u0442\u0438";
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("bm", {
        months: "Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_M\u025Bkalo_Zuw\u025Bnkalo_Zuluyekalo_Utikalo_S\u025Btanburukalo_\u0254kut\u0254burukalo_Nowanburukalo_Desanburukalo".split("_"),
        monthsShort: "Zan_Few_Mar_Awi_M\u025B_Zuw_Zul_Uti_S\u025Bt_\u0254ku_Now_Des".split("_"),
        weekdays: "Kari_Nt\u025Bn\u025Bn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),
        weekdaysShort: "Kar_Nt\u025B_Tar_Ara_Ala_Jum_Sib".split("_"),
        weekdaysMin: "Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "MMMM [tile] D [san] YYYY",
            LLL: "MMMM [tile] D [san] YYYY [l\u025Br\u025B] HH:mm",
            LLLL: "dddd MMMM [tile] D [san] YYYY [l\u025Br\u025B] HH:mm"
        },
        calendar: {
            sameDay: "[Bi l\u025Br\u025B] LT",
            nextDay: "[Sini l\u025Br\u025B] LT",
            nextWeek: "dddd [don l\u025Br\u025B] LT",
            lastDay: "[Kunu l\u025Br\u025B] LT",
            lastWeek: "dddd [t\u025Bm\u025Bnen l\u025Br\u025B] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s k\u0254n\u0254",
            past: "a b\u025B %s b\u0254",
            s: "sanga dama dama",
            ss: "sekondi %d",
            m: "miniti kelen",
            mm: "miniti %d",
            h: "l\u025Br\u025B kelen",
            hh: "l\u025Br\u025B %d",
            d: "tile kelen",
            dd: "tile %d",
            M: "kalo kelen",
            MM: "kalo %d",
            y: "san kelen",
            yy: "san %d"
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$4 = {
        1: "\u09E7",
        2: "\u09E8",
        3: "\u09E9",
        4: "\u09EA",
        5: "\u09EB",
        6: "\u09EC",
        7: "\u09ED",
        8: "\u09EE",
        9: "\u09EF",
        0: "\u09E6"
    }, numberMap$3 = {
        "\u09E7": "1",
        "\u09E8": "2",
        "\u09E9": "3",
        "\u09EA": "4",
        "\u09EB": "5",
        "\u09EC": "6",
        "\u09ED": "7",
        "\u09EE": "8",
        "\u09EF": "9",
        "\u09E6": "0"
    };
    moment.defineLocale("bn-bd", {
        months: "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF_\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF_\u09AE\u09BE\u09B0\u09CD\u099A_\u098F\u09AA\u09CD\u09B0\u09BF\u09B2_\u09AE\u09C7_\u099C\u09C1\u09A8_\u099C\u09C1\u09B2\u09BE\u0987_\u0986\u0997\u09B8\u09CD\u099F_\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0_\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0_\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0_\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0".split("_"),
        monthsShort: "\u099C\u09BE\u09A8\u09C1_\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1_\u09AE\u09BE\u09B0\u09CD\u099A_\u098F\u09AA\u09CD\u09B0\u09BF\u09B2_\u09AE\u09C7_\u099C\u09C1\u09A8_\u099C\u09C1\u09B2\u09BE\u0987_\u0986\u0997\u09B8\u09CD\u099F_\u09B8\u09C7\u09AA\u09CD\u099F_\u0985\u0995\u09CD\u099F\u09CB_\u09A8\u09AD\u09C7_\u09A1\u09BF\u09B8\u09C7".split("_"),
        weekdays: "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0_\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0_\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0_\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0_\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0_\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0_\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0".split("_"),
        weekdaysShort: "\u09B0\u09AC\u09BF_\u09B8\u09CB\u09AE_\u09AE\u0999\u09CD\u0997\u09B2_\u09AC\u09C1\u09A7_\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF_\u09B6\u09C1\u0995\u09CD\u09B0_\u09B6\u09A8\u09BF".split("_"),
        weekdaysMin: "\u09B0\u09AC\u09BF_\u09B8\u09CB\u09AE_\u09AE\u0999\u09CD\u0997\u09B2_\u09AC\u09C1\u09A7_\u09AC\u09C3\u09B9_\u09B6\u09C1\u0995\u09CD\u09B0_\u09B6\u09A8\u09BF".split("_"),
        longDateFormat: {
            LT: "A h:mm \u09B8\u09AE\u09DF",
            LTS: "A h:mm:ss \u09B8\u09AE\u09DF",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u09B8\u09AE\u09DF",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u09B8\u09AE\u09DF"
        },
        calendar: {
            sameDay: "[\u0986\u099C] LT",
            nextDay: "[\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0997\u09A4\u0995\u09BE\u09B2] LT",
            lastWeek: "[\u0997\u09A4] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u09AA\u09B0\u09C7",
            past: "%s \u0986\u0997\u09C7",
            s: "\u0995\u09DF\u09C7\u0995 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
            ss: "%d \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
            m: "\u098F\u0995 \u09AE\u09BF\u09A8\u09BF\u099F",
            mm: "%d \u09AE\u09BF\u09A8\u09BF\u099F",
            h: "\u098F\u0995 \u0998\u09A8\u09CD\u099F\u09BE",
            hh: "%d \u0998\u09A8\u09CD\u099F\u09BE",
            d: "\u098F\u0995 \u09A6\u09BF\u09A8",
            dd: "%d \u09A6\u09BF\u09A8",
            M: "\u098F\u0995 \u09AE\u09BE\u09B8",
            MM: "%d \u09AE\u09BE\u09B8",
            y: "\u098F\u0995 \u09AC\u099B\u09B0",
            yy: "%d \u09AC\u099B\u09B0"
        },
        preparse: function(string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function(match) {
                return numberMap$3[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$4[match];
            });
        },
        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u09B0\u09BE\u09A4") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u09AD\u09CB\u09B0") return hour;
            else if (meridiem === "\u09B8\u0995\u09BE\u09B2") return hour;
            else if (meridiem === "\u09A6\u09C1\u09AA\u09C1\u09B0") return hour >= 3 ? hour : hour + 12;
            else if (meridiem === "\u09AC\u09BF\u0995\u09BE\u09B2") return hour + 12;
            else if (meridiem === "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u09B0\u09BE\u09A4";
            else if (hour < 6) return "\u09AD\u09CB\u09B0";
            else if (hour < 12) return "\u09B8\u0995\u09BE\u09B2";
            else if (hour < 15) return "\u09A6\u09C1\u09AA\u09C1\u09B0";
            else if (hour < 18) return "\u09AC\u09BF\u0995\u09BE\u09B2";
            else if (hour < 20) return "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE";
            else return "\u09B0\u09BE\u09A4";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    var symbolMap$5 = {
        1: "\u09E7",
        2: "\u09E8",
        3: "\u09E9",
        4: "\u09EA",
        5: "\u09EB",
        6: "\u09EC",
        7: "\u09ED",
        8: "\u09EE",
        9: "\u09EF",
        0: "\u09E6"
    }, numberMap$4 = {
        "\u09E7": "1",
        "\u09E8": "2",
        "\u09E9": "3",
        "\u09EA": "4",
        "\u09EB": "5",
        "\u09EC": "6",
        "\u09ED": "7",
        "\u09EE": "8",
        "\u09EF": "9",
        "\u09E6": "0"
    };
    moment.defineLocale("bn", {
        months: "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF_\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF_\u09AE\u09BE\u09B0\u09CD\u099A_\u098F\u09AA\u09CD\u09B0\u09BF\u09B2_\u09AE\u09C7_\u099C\u09C1\u09A8_\u099C\u09C1\u09B2\u09BE\u0987_\u0986\u0997\u09B8\u09CD\u099F_\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0_\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0_\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0_\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0".split("_"),
        monthsShort: "\u099C\u09BE\u09A8\u09C1_\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1_\u09AE\u09BE\u09B0\u09CD\u099A_\u098F\u09AA\u09CD\u09B0\u09BF\u09B2_\u09AE\u09C7_\u099C\u09C1\u09A8_\u099C\u09C1\u09B2\u09BE\u0987_\u0986\u0997\u09B8\u09CD\u099F_\u09B8\u09C7\u09AA\u09CD\u099F_\u0985\u0995\u09CD\u099F\u09CB_\u09A8\u09AD\u09C7_\u09A1\u09BF\u09B8\u09C7".split("_"),
        weekdays: "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0_\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0_\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0_\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0_\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0_\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0_\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0".split("_"),
        weekdaysShort: "\u09B0\u09AC\u09BF_\u09B8\u09CB\u09AE_\u09AE\u0999\u09CD\u0997\u09B2_\u09AC\u09C1\u09A7_\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF_\u09B6\u09C1\u0995\u09CD\u09B0_\u09B6\u09A8\u09BF".split("_"),
        weekdaysMin: "\u09B0\u09AC\u09BF_\u09B8\u09CB\u09AE_\u09AE\u0999\u09CD\u0997\u09B2_\u09AC\u09C1\u09A7_\u09AC\u09C3\u09B9_\u09B6\u09C1\u0995\u09CD\u09B0_\u09B6\u09A8\u09BF".split("_"),
        longDateFormat: {
            LT: "A h:mm \u09B8\u09AE\u09DF",
            LTS: "A h:mm:ss \u09B8\u09AE\u09DF",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u09B8\u09AE\u09DF",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u09B8\u09AE\u09DF"
        },
        calendar: {
            sameDay: "[\u0986\u099C] LT",
            nextDay: "[\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0997\u09A4\u0995\u09BE\u09B2] LT",
            lastWeek: "[\u0997\u09A4] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u09AA\u09B0\u09C7",
            past: "%s \u0986\u0997\u09C7",
            s: "\u0995\u09DF\u09C7\u0995 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
            ss: "%d \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
            m: "\u098F\u0995 \u09AE\u09BF\u09A8\u09BF\u099F",
            mm: "%d \u09AE\u09BF\u09A8\u09BF\u099F",
            h: "\u098F\u0995 \u0998\u09A8\u09CD\u099F\u09BE",
            hh: "%d \u0998\u09A8\u09CD\u099F\u09BE",
            d: "\u098F\u0995 \u09A6\u09BF\u09A8",
            dd: "%d \u09A6\u09BF\u09A8",
            M: "\u098F\u0995 \u09AE\u09BE\u09B8",
            MM: "%d \u09AE\u09BE\u09B8",
            y: "\u098F\u0995 \u09AC\u099B\u09B0",
            yy: "%d \u09AC\u099B\u09B0"
        },
        preparse: function(string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function(match) {
                return numberMap$4[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$5[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u09B0\u09BE\u09A4" && hour >= 4 || meridiem === "\u09A6\u09C1\u09AA\u09C1\u09B0" && hour < 5 || meridiem === "\u09AC\u09BF\u0995\u09BE\u09B2") return hour + 12;
            else return hour;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u09B0\u09BE\u09A4";
            else if (hour < 10) return "\u09B8\u0995\u09BE\u09B2";
            else if (hour < 17) return "\u09A6\u09C1\u09AA\u09C1\u09B0";
            else if (hour < 20) return "\u09AC\u09BF\u0995\u09BE\u09B2";
            else return "\u09B0\u09BE\u09A4";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    var symbolMap$6 = {
        1: "\u0F21",
        2: "\u0F22",
        3: "\u0F23",
        4: "\u0F24",
        5: "\u0F25",
        6: "\u0F26",
        7: "\u0F27",
        8: "\u0F28",
        9: "\u0F29",
        0: "\u0F20"
    }, numberMap$5 = {
        "\u0F21": "1",
        "\u0F22": "2",
        "\u0F23": "3",
        "\u0F24": "4",
        "\u0F25": "5",
        "\u0F26": "6",
        "\u0F27": "7",
        "\u0F28": "8",
        "\u0F29": "9",
        "\u0F20": "0"
    };
    moment.defineLocale("bo", {
        months: "\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F51\u0F44\u0F0B\u0F54\u0F7C_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F42\u0F49\u0F72\u0F66\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F42\u0F66\u0F74\u0F58\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F5E\u0F72\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F63\u0F94\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F51\u0FB2\u0F74\u0F42\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F51\u0F74\u0F53\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F62\u0F92\u0FB1\u0F51\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F51\u0F42\u0F74\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F45\u0F74\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F45\u0F74\u0F0B\u0F42\u0F45\u0F72\u0F42\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F45\u0F74\u0F0B\u0F42\u0F49\u0F72\u0F66\u0F0B\u0F54".split("_"),
        monthsShort: "\u0F5F\u0FB3\u0F0B1_\u0F5F\u0FB3\u0F0B2_\u0F5F\u0FB3\u0F0B3_\u0F5F\u0FB3\u0F0B4_\u0F5F\u0FB3\u0F0B5_\u0F5F\u0FB3\u0F0B6_\u0F5F\u0FB3\u0F0B7_\u0F5F\u0FB3\u0F0B8_\u0F5F\u0FB3\u0F0B9_\u0F5F\u0FB3\u0F0B10_\u0F5F\u0FB3\u0F0B11_\u0F5F\u0FB3\u0F0B12".split("_"),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays: "\u0F42\u0F5F\u0F60\u0F0B\u0F49\u0F72\u0F0B\u0F58\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F5F\u0FB3\u0F0B\u0F56\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F58\u0F72\u0F42\u0F0B\u0F51\u0F58\u0F62\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F63\u0FB7\u0F42\u0F0B\u0F54\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F55\u0F74\u0F62\u0F0B\u0F56\u0F74_\u0F42\u0F5F\u0F60\u0F0B\u0F54\u0F0B\u0F66\u0F44\u0F66\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F66\u0FA4\u0F7A\u0F53\u0F0B\u0F54\u0F0B".split("_"),
        weekdaysShort: "\u0F49\u0F72\u0F0B\u0F58\u0F0B_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B_\u0F58\u0F72\u0F42\u0F0B\u0F51\u0F58\u0F62\u0F0B_\u0F63\u0FB7\u0F42\u0F0B\u0F54\u0F0B_\u0F55\u0F74\u0F62\u0F0B\u0F56\u0F74_\u0F54\u0F0B\u0F66\u0F44\u0F66\u0F0B_\u0F66\u0FA4\u0F7A\u0F53\u0F0B\u0F54\u0F0B".split("_"),
        weekdaysMin: "\u0F49\u0F72_\u0F5F\u0FB3_\u0F58\u0F72\u0F42_\u0F63\u0FB7\u0F42_\u0F55\u0F74\u0F62_\u0F66\u0F44\u0F66_\u0F66\u0FA4\u0F7A\u0F53".split("_"),
        longDateFormat: {
            LT: "A h:mm",
            LTS: "A h:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm",
            LLLL: "dddd, D MMMM YYYY, A h:mm"
        },
        calendar: {
            sameDay: "[\u0F51\u0F72\u0F0B\u0F62\u0F72\u0F44] LT",
            nextDay: "[\u0F66\u0F44\u0F0B\u0F49\u0F72\u0F53] LT",
            nextWeek: "[\u0F56\u0F51\u0F74\u0F53\u0F0B\u0F55\u0FB2\u0F42\u0F0B\u0F62\u0F97\u0F7A\u0F66\u0F0B\u0F58], LT",
            lastDay: "[\u0F41\u0F0B\u0F66\u0F44] LT",
            lastWeek: "[\u0F56\u0F51\u0F74\u0F53\u0F0B\u0F55\u0FB2\u0F42\u0F0B\u0F58\u0F50\u0F60\u0F0B\u0F58] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0F63\u0F0B",
            past: "%s \u0F66\u0F94\u0F53\u0F0B\u0F63",
            s: "\u0F63\u0F58\u0F0B\u0F66\u0F44",
            ss: "%d \u0F66\u0F90\u0F62\u0F0B\u0F46\u0F0D",
            m: "\u0F66\u0F90\u0F62\u0F0B\u0F58\u0F0B\u0F42\u0F45\u0F72\u0F42",
            mm: "%d \u0F66\u0F90\u0F62\u0F0B\u0F58",
            h: "\u0F46\u0F74\u0F0B\u0F5A\u0F7C\u0F51\u0F0B\u0F42\u0F45\u0F72\u0F42",
            hh: "%d \u0F46\u0F74\u0F0B\u0F5A\u0F7C\u0F51",
            d: "\u0F49\u0F72\u0F53\u0F0B\u0F42\u0F45\u0F72\u0F42",
            dd: "%d \u0F49\u0F72\u0F53\u0F0B",
            M: "\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F42\u0F45\u0F72\u0F42",
            MM: "%d \u0F5F\u0FB3\u0F0B\u0F56",
            y: "\u0F63\u0F7C\u0F0B\u0F42\u0F45\u0F72\u0F42",
            yy: "%d \u0F63\u0F7C"
        },
        preparse: function(string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function(match) {
                return numberMap$5[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$6[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0F58\u0F5A\u0F53\u0F0B\u0F58\u0F7C" && hour >= 4 || meridiem === "\u0F49\u0F72\u0F53\u0F0B\u0F42\u0F74\u0F44" && hour < 5 || meridiem === "\u0F51\u0F42\u0F7C\u0F44\u0F0B\u0F51\u0F42") return hour + 12;
            else return hour;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0F58\u0F5A\u0F53\u0F0B\u0F58\u0F7C";
            else if (hour < 10) return "\u0F5E\u0F7C\u0F42\u0F66\u0F0B\u0F40\u0F66";
            else if (hour < 17) return "\u0F49\u0F72\u0F53\u0F0B\u0F42\u0F74\u0F44";
            else if (hour < 20) return "\u0F51\u0F42\u0F7C\u0F44\u0F0B\u0F51\u0F42";
            else return "\u0F58\u0F5A\u0F53\u0F0B\u0F58\u0F7C";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: "munutenn",
            MM: "miz",
            dd: "devezh"
        };
        return number + " " + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch(lastNumber(number)){
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + " bloaz";
            default:
                return number + " vloaz";
        }
    }
    function lastNumber(number) {
        if (number > 9) return lastNumber(number % 10);
        return number;
    }
    function mutation(text, number) {
        if (number === 2) return softMutation(text);
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: "v",
            b: "v",
            d: "z"
        };
        if (mutationTable[text.charAt(0)] === undefined) return text;
        return mutationTable[text.charAt(0)] + text.substring(1);
    }
    var monthsParse = [
        /^gen/i,
        /^c[ʼ\']hwe/i,
        /^meu/i,
        /^ebr/i,
        /^mae/i,
        /^(mez|eve)/i,
        /^gou/i,
        /^eos/i,
        /^gwe/i,
        /^her/i,
        /^du/i,
        /^ker/i
    ], monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i, monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i, monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i, fullWeekdaysParse = [
        /^sul/i,
        /^lun/i,
        /^meurzh/i,
        /^merc[ʼ\']her/i,
        /^yaou/i,
        /^gwener/i,
        /^sadorn/i
    ], shortWeekdaysParse = [
        /^Sul/i,
        /^Lun/i,
        /^Meu/i,
        /^Mer/i,
        /^Yao/i,
        /^Gwe/i,
        /^Sad/i
    ], minWeekdaysParse = [
        /^Su/i,
        /^Lu/i,
        /^Me([^r]|$)/i,
        /^Mer/i,
        /^Ya/i,
        /^Gw/i,
        /^Sa/i
    ];
    moment.defineLocale("br", {
        months: "Genver_C\u02BChwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),
        monthsShort: "Gen_C\u02BChwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),
        weekdays: "Sul_Lun_Meurzh_Merc\u02BCher_Yaou_Gwener_Sadorn".split("_"),
        weekdaysShort: "Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),
        weekdaysMin: "Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [a viz] MMMM YYYY",
            LLL: "D [a viz] MMMM YYYY HH:mm",
            LLLL: "dddd, D [a viz] MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Hiziv da] LT",
            nextDay: "[Warc\u02BChoazh da] LT",
            nextWeek: "dddd [da] LT",
            lastDay: "[Dec\u02BCh da] LT",
            lastWeek: "dddd [paset da] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "a-benn %s",
            past: "%s \u02BCzo",
            s: "un nebeud segondenno\xf9",
            ss: "%d eilenn",
            m: "ur vunutenn",
            mm: relativeTimeWithMutation,
            h: "un eur",
            hh: "%d eur",
            d: "un devezh",
            dd: relativeTimeWithMutation,
            M: "ur miz",
            MM: relativeTimeWithMutation,
            y: "ur bloaz",
            yy: specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function(number) {
            var output = number === 1 ? "a\xf1" : "vet";
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        },
        meridiemParse: /a.m.|g.m./,
        isPM: function(token) {
            return token === "g.m.";
        },
        meridiem: function(hour, minute, isLower) {
            return hour < 12 ? "a.m." : "g.m.";
        }
    });
    //! moment.js locale configuration
    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        switch(key){
            case "m":
                return withoutSuffix ? "jedna minuta" : isFuture ? "jednu minutu" : "jedne minute";
        }
    }
    function translate(number, withoutSuffix, key) {
        var result = number + " ";
        switch(key){
            case "ss":
                if (number === 1) result += "sekunda";
                else if (number === 2 || number === 3 || number === 4) result += "sekunde";
                else result += "sekundi";
                return result;
            case "mm":
                if (number === 1) result += "minuta";
                else if (number === 2 || number === 3 || number === 4) result += "minute";
                else result += "minuta";
                return result;
            case "h":
                return withoutSuffix ? "jedan sat" : "jedan sat";
            case "hh":
                if (number === 1) result += "sat";
                else if (number === 2 || number === 3 || number === 4) result += "sata";
                else result += "sati";
                return result;
            case "dd":
                if (number === 1) result += "dan";
                else result += "dana";
                return result;
            case "MM":
                if (number === 1) result += "mjesec";
                else if (number === 2 || number === 3 || number === 4) result += "mjeseca";
                else result += "mjeseci";
                return result;
            case "yy":
                if (number === 1) result += "godina";
                else if (number === 2 || number === 3 || number === 4) result += "godine";
                else result += "godina";
                return result;
        }
    }
    moment.defineLocale("bs", {
        months: "januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),
        monthsShort: "jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),
        monthsParseExact: true,
        weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010Detvrtak_petak_subota".split("_"),
        weekdaysShort: "ned._pon._uto._sri._\u010Det._pet._sub.".split("_"),
        weekdaysMin: "ne_po_ut_sr_\u010De_pe_su".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[danas u] LT",
            nextDay: "[sutra u] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[u] [nedjelju] [u] LT";
                    case 3:
                        return "[u] [srijedu] [u] LT";
                    case 6:
                        return "[u] [subotu] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[u] dddd [u] LT";
                }
            },
            lastDay: "[ju\u010Der u] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                        return "[pro\u0161lu] dddd [u] LT";
                    case 6:
                        return "[pro\u0161le] [subote] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[pro\u0161li] dddd [u] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "prije %s",
            s: "par sekundi",
            ss: translate,
            m: processRelativeTime,
            mm: translate,
            h: translate,
            hh: translate,
            d: "dan",
            dd: translate,
            M: "mjesec",
            MM: translate,
            y: "godinu",
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("ca", {
        months: {
            standalone: "gener_febrer_mar\xe7_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),
            format: "de gener_de febrer_de mar\xe7_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split("_"),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort: "gen._febr._mar\xe7_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),
        monthsParseExact: true,
        weekdays: "diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),
        weekdaysShort: "dg._dl._dt._dc._dj._dv._ds.".split("_"),
        weekdaysMin: "dg_dl_dt_dc_dj_dv_ds".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM [de] YYYY",
            ll: "D MMM YYYY",
            LLL: "D MMMM [de] YYYY [a les] H:mm",
            lll: "D MMM YYYY, H:mm",
            LLLL: "dddd D MMMM [de] YYYY [a les] H:mm",
            llll: "ddd D MMM YYYY, H:mm"
        },
        calendar: {
            sameDay: function() {
                return "[avui a " + (this.hours() !== 1 ? "les" : "la") + "] LT";
            },
            nextDay: function() {
                return "[dem\xe0 a " + (this.hours() !== 1 ? "les" : "la") + "] LT";
            },
            nextWeek: function() {
                return "dddd [a " + (this.hours() !== 1 ? "les" : "la") + "] LT";
            },
            lastDay: function() {
                return "[ahir a " + (this.hours() !== 1 ? "les" : "la") + "] LT";
            },
            lastWeek: function() {
                return "[el] dddd [passat a " + (this.hours() !== 1 ? "les" : "la") + "] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "d'aqu\xed %s",
            past: "fa %s",
            s: "uns segons",
            ss: "%d segons",
            m: "un minut",
            mm: "%d minuts",
            h: "una hora",
            hh: "%d hores",
            d: "un dia",
            dd: "%d dies",
            M: "un mes",
            MM: "%d mesos",
            y: "un any",
            yy: "%d anys"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function(number, period) {
            var output = number === 1 ? "r" : number === 2 ? "n" : number === 3 ? "r" : number === 4 ? "t" : "\xe8";
            if (period === "w" || period === "W") output = "a";
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var months$3 = {
        standalone: "leden_\xfanor_b\u0159ezen_duben_kv\u011Bten_\u010Derven_\u010Dervenec_srpen_z\xe1\u0159\xed_\u0159\xedjen_listopad_prosinec".split("_"),
        format: "ledna_\xfanora_b\u0159ezna_dubna_kv\u011Btna_\u010Dervna_\u010Dervence_srpna_z\xe1\u0159\xed_\u0159\xedjna_listopadu_prosince".split("_"),
        isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/
    }, monthsShort = "led_\xfano_b\u0159e_dub_kv\u011B_\u010Dvn_\u010Dvc_srp_z\xe1\u0159_\u0159\xedj_lis_pro".split("_"), monthsParse$1 = [
        /^led/i,
        /^úno/i,
        /^bře/i,
        /^dub/i,
        /^kvě/i,
        /^(čvn|červen$|června)/i,
        /^(čvc|červenec|července)/i,
        /^srp/i,
        /^zář/i,
        /^říj/i,
        /^lis/i,
        /^pro/i
    ], // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
    monthsRegex$1 = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
    function plural$1(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate$1(number, withoutSuffix, key, isFuture) {
        var result = number + " ";
        switch(key){
            case "s":
                return withoutSuffix || isFuture ? "p\xe1r sekund" : "p\xe1r sekundami";
            case "ss":
                if (withoutSuffix || isFuture) return result + (plural$1(number) ? "sekundy" : "sekund");
                else return result + "sekundami";
            case "m":
                return withoutSuffix ? "minuta" : isFuture ? "minutu" : "minutou";
            case "mm":
                if (withoutSuffix || isFuture) return result + (plural$1(number) ? "minuty" : "minut");
                else return result + "minutami";
            case "h":
                return withoutSuffix ? "hodina" : isFuture ? "hodinu" : "hodinou";
            case "hh":
                if (withoutSuffix || isFuture) return result + (plural$1(number) ? "hodiny" : "hodin");
                else return result + "hodinami";
            case "d":
                return withoutSuffix || isFuture ? "den" : "dnem";
            case "dd":
                if (withoutSuffix || isFuture) return result + (plural$1(number) ? "dny" : "dn\xed");
                else return result + "dny";
            case "M":
                return withoutSuffix || isFuture ? "m\u011Bs\xedc" : "m\u011Bs\xedcem";
            case "MM":
                if (withoutSuffix || isFuture) return result + (plural$1(number) ? "m\u011Bs\xedce" : "m\u011Bs\xedc\u016F");
                else return result + "m\u011Bs\xedci";
            case "y":
                return withoutSuffix || isFuture ? "rok" : "rokem";
            case "yy":
                if (withoutSuffix || isFuture) return result + (plural$1(number) ? "roky" : "let");
                else return result + "lety";
        }
    }
    moment.defineLocale("cs", {
        months: months$3,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex$1,
        monthsShortRegex: monthsRegex$1,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse$1,
        longMonthsParse: monthsParse$1,
        shortMonthsParse: monthsParse$1,
        weekdays: "ned\u011Ble_pond\u011Bl\xed_\xfater\xfd_st\u0159eda_\u010Dtvrtek_p\xe1tek_sobota".split("_"),
        weekdaysShort: "ne_po_\xfat_st_\u010Dt_p\xe1_so".split("_"),
        weekdaysMin: "ne_po_\xfat_st_\u010Dt_p\xe1_so".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd D. MMMM YYYY H:mm",
            l: "D. M. YYYY"
        },
        calendar: {
            sameDay: "[dnes v] LT",
            nextDay: "[z\xedtra v] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[v ned\u011Bli v] LT";
                    case 1:
                    case 2:
                        return "[v] dddd [v] LT";
                    case 3:
                        return "[ve st\u0159edu v] LT";
                    case 4:
                        return "[ve \u010Dtvrtek v] LT";
                    case 5:
                        return "[v p\xe1tek v] LT";
                    case 6:
                        return "[v sobotu v] LT";
                }
            },
            lastDay: "[v\u010Dera v] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[minulou ned\u011Bli v] LT";
                    case 1:
                    case 2:
                        return "[minul\xe9] dddd [v] LT";
                    case 3:
                        return "[minulou st\u0159edu v] LT";
                    case 4:
                    case 5:
                        return "[minul\xfd] dddd [v] LT";
                    case 6:
                        return "[minulou sobotu v] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "p\u0159ed %s",
            s: translate$1,
            ss: translate$1,
            m: translate$1,
            mm: translate$1,
            h: translate$1,
            hh: translate$1,
            d: translate$1,
            dd: translate$1,
            M: translate$1,
            MM: translate$1,
            y: translate$1,
            yy: translate$1
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("cv", {
        months: "\u043A\u04D1\u0440\u043B\u0430\u0447_\u043D\u0430\u0440\u04D1\u0441_\u043F\u0443\u0448_\u0430\u043A\u0430_\u043C\u0430\u0439_\u04AB\u04D7\u0440\u0442\u043C\u0435_\u0443\u0442\u04D1_\u04AB\u0443\u0440\u043B\u0430_\u0430\u0432\u04D1\u043D_\u044E\u043F\u0430_\u0447\u04F3\u043A_\u0440\u0430\u0448\u0442\u0430\u0432".split("_"),
        monthsShort: "\u043A\u04D1\u0440_\u043D\u0430\u0440_\u043F\u0443\u0448_\u0430\u043A\u0430_\u043C\u0430\u0439_\u04AB\u04D7\u0440_\u0443\u0442\u04D1_\u04AB\u0443\u0440_\u0430\u0432\u043D_\u044E\u043F\u0430_\u0447\u04F3\u043A_\u0440\u0430\u0448".split("_"),
        weekdays: "\u0432\u044B\u0440\u0441\u0430\u0440\u043D\u0438\u043A\u0443\u043D_\u0442\u0443\u043D\u0442\u0438\u043A\u0443\u043D_\u044B\u0442\u043B\u0430\u0440\u0438\u043A\u0443\u043D_\u044E\u043D\u043A\u0443\u043D_\u043A\u04D7\u04AB\u043D\u0435\u0440\u043D\u0438\u043A\u0443\u043D_\u044D\u0440\u043D\u0435\u043A\u0443\u043D_\u0448\u04D1\u043C\u0430\u0442\u043A\u0443\u043D".split("_"),
        weekdaysShort: "\u0432\u044B\u0440_\u0442\u0443\u043D_\u044B\u0442\u043B_\u044E\u043D_\u043A\u04D7\u04AB_\u044D\u0440\u043D_\u0448\u04D1\u043C".split("_"),
        weekdaysMin: "\u0432\u0440_\u0442\u043D_\u044B\u0442_\u044E\u043D_\u043A\u04AB_\u044D\u0440_\u0448\u043C".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD-MM-YYYY",
            LL: "YYYY [\u04AB\u0443\u043B\u0445\u0438] MMMM [\u0443\u0439\u04D1\u0445\u04D7\u043D] D[-\u043C\u04D7\u0448\u04D7]",
            LLL: "YYYY [\u04AB\u0443\u043B\u0445\u0438] MMMM [\u0443\u0439\u04D1\u0445\u04D7\u043D] D[-\u043C\u04D7\u0448\u04D7], HH:mm",
            LLLL: "dddd, YYYY [\u04AB\u0443\u043B\u0445\u0438] MMMM [\u0443\u0439\u04D1\u0445\u04D7\u043D] D[-\u043C\u04D7\u0448\u04D7], HH:mm"
        },
        calendar: {
            sameDay: "[\u041F\u0430\u044F\u043D] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            nextDay: "[\u042B\u0440\u0430\u043D] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            lastDay: "[\u04D6\u043D\u0435\u0440] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            nextWeek: "[\u04AA\u0438\u0442\u0435\u0441] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            lastWeek: "[\u0418\u0440\u0442\u043D\u04D7] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            sameElse: "L"
        },
        relativeTime: {
            future: function(output) {
                var affix = /сехет$/i.exec(output) ? "\u0440\u0435\u043D" : /ҫул$/i.exec(output) ? "\u0442\u0430\u043D" : "\u0440\u0430\u043D";
                return output + affix;
            },
            past: "%s \u043A\u0430\u044F\u043B\u043B\u0430",
            s: "\u043F\u04D7\u0440-\u0438\u043A \u04AB\u0435\u043A\u043A\u0443\u043D\u0442",
            ss: "%d \u04AB\u0435\u043A\u043A\u0443\u043D\u0442",
            m: "\u043F\u04D7\u0440 \u043C\u0438\u043D\u0443\u0442",
            mm: "%d \u043C\u0438\u043D\u0443\u0442",
            h: "\u043F\u04D7\u0440 \u0441\u0435\u0445\u0435\u0442",
            hh: "%d \u0441\u0435\u0445\u0435\u0442",
            d: "\u043F\u04D7\u0440 \u043A\u0443\u043D",
            dd: "%d \u043A\u0443\u043D",
            M: "\u043F\u04D7\u0440 \u0443\u0439\u04D1\u0445",
            MM: "%d \u0443\u0439\u04D1\u0445",
            y: "\u043F\u04D7\u0440 \u04AB\u0443\u043B",
            yy: "%d \u04AB\u0443\u043B"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: "%d-\u043C\u04D7\u0448",
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("cy", {
        months: "Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),
        monthsShort: "Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),
        weekdays: "Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),
        weekdaysShort: "Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),
        weekdaysMin: "Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Heddiw am] LT",
            nextDay: "[Yfory am] LT",
            nextWeek: "dddd [am] LT",
            lastDay: "[Ddoe am] LT",
            lastWeek: "dddd [diwethaf am] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "mewn %s",
            past: "%s yn \xf4l",
            s: "ychydig eiliadau",
            ss: "%d eiliad",
            m: "munud",
            mm: "%d munud",
            h: "awr",
            hh: "%d awr",
            d: "diwrnod",
            dd: "%d diwrnod",
            M: "mis",
            MM: "%d mis",
            y: "blwyddyn",
            yy: "%d flynedd"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function(number) {
            var b = number, output = "", lookup = [
                "",
                "af",
                "il",
                "ydd",
                "ydd",
                "ed",
                "ed",
                "ed",
                "fed",
                "fed",
                "fed",
                "eg",
                "fed",
                "eg",
                "eg",
                "fed",
                "eg",
                "eg",
                "fed",
                "eg",
                "fed"
            ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) output = "fed"; // not 30ain, 70ain or 90ain
                else output = "ain";
            } else if (b > 0) output = lookup[b];
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("da", {
        months: "januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),
        monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
        weekdays: "s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),
        weekdaysShort: "s\xf8n_man_tir_ons_tor_fre_l\xf8r".split("_"),
        weekdaysMin: "s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd [d.] D. MMMM YYYY [kl.] HH:mm"
        },
        calendar: {
            sameDay: "[i dag kl.] LT",
            nextDay: "[i morgen kl.] LT",
            nextWeek: "p\xe5 dddd [kl.] LT",
            lastDay: "[i g\xe5r kl.] LT",
            lastWeek: "[i] dddd[s kl.] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "om %s",
            past: "%s siden",
            s: "f\xe5 sekunder",
            ss: "%d sekunder",
            m: "et minut",
            mm: "%d minutter",
            h: "en time",
            hh: "%d timer",
            d: "en dag",
            dd: "%d dage",
            M: "en m\xe5ned",
            MM: "%d m\xe5neder",
            y: "et \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$1(number, withoutSuffix, key, isFuture) {
        var format = {
            m: [
                "eine Minute",
                "einer Minute"
            ],
            h: [
                "eine Stunde",
                "einer Stunde"
            ],
            d: [
                "ein Tag",
                "einem Tag"
            ],
            dd: [
                number + " Tage",
                number + " Tagen"
            ],
            w: [
                "eine Woche",
                "einer Woche"
            ],
            M: [
                "ein Monat",
                "einem Monat"
            ],
            MM: [
                number + " Monate",
                number + " Monaten"
            ],
            y: [
                "ein Jahr",
                "einem Jahr"
            ],
            yy: [
                number + " Jahre",
                number + " Jahren"
            ]
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    moment.defineLocale("de-at", {
        months: "J\xe4nner_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "J\xe4n._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
        monthsParseExact: true,
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[heute um] LT [Uhr]",
            sameElse: "L",
            nextDay: "[morgen um] LT [Uhr]",
            nextWeek: "dddd [um] LT [Uhr]",
            lastDay: "[gestern um] LT [Uhr]",
            lastWeek: "[letzten] dddd [um] LT [Uhr]"
        },
        relativeTime: {
            future: "in %s",
            past: "vor %s",
            s: "ein paar Sekunden",
            ss: "%d Sekunden",
            m: processRelativeTime$1,
            mm: "%d Minuten",
            h: processRelativeTime$1,
            hh: "%d Stunden",
            d: processRelativeTime$1,
            dd: processRelativeTime$1,
            w: processRelativeTime$1,
            ww: "%d Wochen",
            M: processRelativeTime$1,
            MM: processRelativeTime$1,
            y: processRelativeTime$1,
            yy: processRelativeTime$1
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$2(number, withoutSuffix, key, isFuture) {
        var format = {
            m: [
                "eine Minute",
                "einer Minute"
            ],
            h: [
                "eine Stunde",
                "einer Stunde"
            ],
            d: [
                "ein Tag",
                "einem Tag"
            ],
            dd: [
                number + " Tage",
                number + " Tagen"
            ],
            w: [
                "eine Woche",
                "einer Woche"
            ],
            M: [
                "ein Monat",
                "einem Monat"
            ],
            MM: [
                number + " Monate",
                number + " Monaten"
            ],
            y: [
                "ein Jahr",
                "einem Jahr"
            ],
            yy: [
                number + " Jahre",
                number + " Jahren"
            ]
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    moment.defineLocale("de-ch", {
        months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
        monthsParseExact: true,
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[heute um] LT [Uhr]",
            sameElse: "L",
            nextDay: "[morgen um] LT [Uhr]",
            nextWeek: "dddd [um] LT [Uhr]",
            lastDay: "[gestern um] LT [Uhr]",
            lastWeek: "[letzten] dddd [um] LT [Uhr]"
        },
        relativeTime: {
            future: "in %s",
            past: "vor %s",
            s: "ein paar Sekunden",
            ss: "%d Sekunden",
            m: processRelativeTime$2,
            mm: "%d Minuten",
            h: processRelativeTime$2,
            hh: "%d Stunden",
            d: processRelativeTime$2,
            dd: processRelativeTime$2,
            w: processRelativeTime$2,
            ww: "%d Wochen",
            M: processRelativeTime$2,
            MM: processRelativeTime$2,
            y: processRelativeTime$2,
            yy: processRelativeTime$2
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$3(number, withoutSuffix, key, isFuture) {
        var format = {
            m: [
                "eine Minute",
                "einer Minute"
            ],
            h: [
                "eine Stunde",
                "einer Stunde"
            ],
            d: [
                "ein Tag",
                "einem Tag"
            ],
            dd: [
                number + " Tage",
                number + " Tagen"
            ],
            w: [
                "eine Woche",
                "einer Woche"
            ],
            M: [
                "ein Monat",
                "einem Monat"
            ],
            MM: [
                number + " Monate",
                number + " Monaten"
            ],
            y: [
                "ein Jahr",
                "einem Jahr"
            ],
            yy: [
                number + " Jahre",
                number + " Jahren"
            ]
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    moment.defineLocale("de", {
        months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
        monthsParseExact: true,
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[heute um] LT [Uhr]",
            sameElse: "L",
            nextDay: "[morgen um] LT [Uhr]",
            nextWeek: "dddd [um] LT [Uhr]",
            lastDay: "[gestern um] LT [Uhr]",
            lastWeek: "[letzten] dddd [um] LT [Uhr]"
        },
        relativeTime: {
            future: "in %s",
            past: "vor %s",
            s: "ein paar Sekunden",
            ss: "%d Sekunden",
            m: processRelativeTime$3,
            mm: "%d Minuten",
            h: processRelativeTime$3,
            hh: "%d Stunden",
            d: processRelativeTime$3,
            dd: processRelativeTime$3,
            w: processRelativeTime$3,
            ww: "%d Wochen",
            M: processRelativeTime$3,
            MM: processRelativeTime$3,
            y: processRelativeTime$3,
            yy: processRelativeTime$3
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var months$4 = [
        "\u0796\u07AC\u0782\u07AA\u0787\u07A6\u0783\u07A9",
        "\u078A\u07AC\u0784\u07B0\u0783\u07AA\u0787\u07A6\u0783\u07A9",
        "\u0789\u07A7\u0783\u07A8\u0797\u07AA",
        "\u0787\u07AD\u0795\u07B0\u0783\u07A9\u078D\u07AA",
        "\u0789\u07AD",
        "\u0796\u07AB\u0782\u07B0",
        "\u0796\u07AA\u078D\u07A6\u0787\u07A8",
        "\u0787\u07AF\u078E\u07A6\u0790\u07B0\u0793\u07AA",
        "\u0790\u07AC\u0795\u07B0\u0793\u07AC\u0789\u07B0\u0784\u07A6\u0783\u07AA",
        "\u0787\u07AE\u0786\u07B0\u0793\u07AF\u0784\u07A6\u0783\u07AA",
        "\u0782\u07AE\u0788\u07AC\u0789\u07B0\u0784\u07A6\u0783\u07AA",
        "\u0791\u07A8\u0790\u07AC\u0789\u07B0\u0784\u07A6\u0783\u07AA"
    ], weekdays = [
        "\u0787\u07A7\u078B\u07A8\u0787\u07B0\u078C\u07A6",
        "\u0780\u07AF\u0789\u07A6",
        "\u0787\u07A6\u0782\u07B0\u078E\u07A7\u0783\u07A6",
        "\u0784\u07AA\u078B\u07A6",
        "\u0784\u07AA\u0783\u07A7\u0790\u07B0\u078A\u07A6\u078C\u07A8",
        "\u0780\u07AA\u0786\u07AA\u0783\u07AA",
        "\u0780\u07AE\u0782\u07A8\u0780\u07A8\u0783\u07AA"
    ];
    moment.defineLocale("dv", {
        months: months$4,
        monthsShort: months$4,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: "\u0787\u07A7\u078B\u07A8_\u0780\u07AF\u0789\u07A6_\u0787\u07A6\u0782\u07B0_\u0784\u07AA\u078B\u07A6_\u0784\u07AA\u0783\u07A7_\u0780\u07AA\u0786\u07AA_\u0780\u07AE\u0782\u07A8".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/M/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /މކ|މފ/,
        isPM: function(input) {
            return "\u0789\u078A" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0789\u0786";
            else return "\u0789\u078A";
        },
        calendar: {
            sameDay: "[\u0789\u07A8\u0787\u07A6\u078B\u07AA] LT",
            nextDay: "[\u0789\u07A7\u078B\u07A6\u0789\u07A7] LT",
            nextWeek: "dddd LT",
            lastDay: "[\u0787\u07A8\u0787\u07B0\u0794\u07AC] LT",
            lastWeek: "[\u078A\u07A7\u0787\u07A8\u078C\u07AA\u0788\u07A8] dddd LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u078C\u07AC\u0783\u07AD\u078E\u07A6\u0787\u07A8 %s",
            past: "\u0786\u07AA\u0783\u07A8\u0782\u07B0 %s",
            s: "\u0790\u07A8\u0786\u07AA\u0782\u07B0\u078C\u07AA\u0786\u07AE\u0785\u07AC\u0787\u07B0",
            ss: "d% \u0790\u07A8\u0786\u07AA\u0782\u07B0\u078C\u07AA",
            m: "\u0789\u07A8\u0782\u07A8\u0793\u07AC\u0787\u07B0",
            mm: "\u0789\u07A8\u0782\u07A8\u0793\u07AA %d",
            h: "\u078E\u07A6\u0791\u07A8\u0787\u07A8\u0783\u07AC\u0787\u07B0",
            hh: "\u078E\u07A6\u0791\u07A8\u0787\u07A8\u0783\u07AA %d",
            d: "\u078B\u07AA\u0788\u07A6\u0780\u07AC\u0787\u07B0",
            dd: "\u078B\u07AA\u0788\u07A6\u0790\u07B0 %d",
            M: "\u0789\u07A6\u0780\u07AC\u0787\u07B0",
            MM: "\u0789\u07A6\u0790\u07B0 %d",
            y: "\u0787\u07A6\u0780\u07A6\u0783\u07AC\u0787\u07B0",
            yy: "\u0787\u07A6\u0780\u07A6\u0783\u07AA %d"
        },
        preparse: function(string) {
            return string.replace(/،/g, ",");
        },
        postformat: function(string) {
            return string.replace(/,/g, "\u060C");
        },
        week: {
            dow: 7,
            doy: 12
        }
    });
    //! moment.js locale configuration
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    moment.defineLocale("el", {
        monthsNominativeEl: "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2_\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2_\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2_\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2_\u039C\u03AC\u03B9\u03BF\u03C2_\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2_\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2_\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2_\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2_\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2_\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2_\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2".split("_"),
        monthsGenitiveEl: "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5_\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5_\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5_\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5_\u039C\u03B1\u0390\u03BF\u03C5_\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5_\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5_\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5_\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5_\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5_\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5_\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5".split("_"),
        months: function(momentToFormat, format) {
            if (!momentToFormat) return this._monthsNominativeEl;
            else if (typeof format === "string" && /D/.test(format.substring(0, format.indexOf("MMMM")))) // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
            else return this._monthsNominativeEl[momentToFormat.month()];
        },
        monthsShort: "\u0399\u03B1\u03BD_\u03A6\u03B5\u03B2_\u039C\u03B1\u03C1_\u0391\u03C0\u03C1_\u039C\u03B1\u03CA_\u0399\u03BF\u03C5\u03BD_\u0399\u03BF\u03C5\u03BB_\u0391\u03C5\u03B3_\u03A3\u03B5\u03C0_\u039F\u03BA\u03C4_\u039D\u03BF\u03B5_\u0394\u03B5\u03BA".split("_"),
        weekdays: "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE_\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1_\u03A4\u03C1\u03AF\u03C4\u03B7_\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7_\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7_\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE_\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF".split("_"),
        weekdaysShort: "\u039A\u03C5\u03C1_\u0394\u03B5\u03C5_\u03A4\u03C1\u03B9_\u03A4\u03B5\u03C4_\u03A0\u03B5\u03BC_\u03A0\u03B1\u03C1_\u03A3\u03B1\u03B2".split("_"),
        weekdaysMin: "\u039A\u03C5_\u0394\u03B5_\u03A4\u03C1_\u03A4\u03B5_\u03A0\u03B5_\u03A0\u03B1_\u03A3\u03B1".split("_"),
        meridiem: function(hours, minutes, isLower) {
            if (hours > 11) return isLower ? "\u03BC\u03BC" : "\u039C\u039C";
            else return isLower ? "\u03C0\u03BC" : "\u03A0\u039C";
        },
        isPM: function(input) {
            return (input + "").toLowerCase()[0] === "\u03BC";
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendarEl: {
            sameDay: "[\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1 {}] LT",
            nextDay: "[\u0391\u03CD\u03C1\u03B9\u03BF {}] LT",
            nextWeek: "dddd [{}] LT",
            lastDay: "[\u03A7\u03B8\u03B5\u03C2 {}] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 6:
                        return "[\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF] dddd [{}] LT";
                    default:
                        return "[\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7] dddd [{}] LT";
                }
            },
            sameElse: "L"
        },
        calendar: function(key, mom) {
            var output = this._calendarEl[key], hours = mom && mom.hours();
            if (isFunction(output)) output = output.apply(mom);
            return output.replace("{}", hours % 12 === 1 ? "\u03C3\u03C4\u03B7" : "\u03C3\u03C4\u03B9\u03C2");
        },
        relativeTime: {
            future: "\u03C3\u03B5 %s",
            past: "%s \u03C0\u03C1\u03B9\u03BD",
            s: "\u03BB\u03AF\u03B3\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1",
            ss: "%d \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1",
            m: "\u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
            mm: "%d \u03BB\u03B5\u03C0\u03C4\u03AC",
            h: "\u03BC\u03AF\u03B1 \u03CE\u03C1\u03B1",
            hh: "%d \u03CE\u03C1\u03B5\u03C2",
            d: "\u03BC\u03AF\u03B1 \u03BC\u03AD\u03C1\u03B1",
            dd: "%d \u03BC\u03AD\u03C1\u03B5\u03C2",
            M: "\u03AD\u03BD\u03B1\u03C2 \u03BC\u03AE\u03BD\u03B1\u03C2",
            MM: "%d \u03BC\u03AE\u03BD\u03B5\u03C2",
            y: "\u03AD\u03BD\u03B1\u03C2 \u03C7\u03C1\u03CC\u03BD\u03BF\u03C2",
            yy: "%d \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: "%d\u03B7",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("en-au", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        },
        week: {
            dow: 0,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("en-ca", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "YYYY-MM-DD",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("en-gb", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("en-ie", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("en-il", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("en-in", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("en-nz", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("en-sg", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("eo", {
        months: "januaro_februaro_marto_aprilo_majo_junio_julio_a\u016Dgusto_septembro_oktobro_novembro_decembro".split("_"),
        monthsShort: "jan_feb_mart_apr_maj_jun_jul_a\u016Dg_sept_okt_nov_dec".split("_"),
        weekdays: "diman\u0109o_lundo_mardo_merkredo_\u0135a\u016Ddo_vendredo_sabato".split("_"),
        weekdaysShort: "dim_lun_mard_merk_\u0135a\u016D_ven_sab".split("_"),
        weekdaysMin: "di_lu_ma_me_\u0135a_ve_sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "[la] D[-an de] MMMM, YYYY",
            LLL: "[la] D[-an de] MMMM, YYYY HH:mm",
            LLLL: "dddd[n], [la] D[-an de] MMMM, YYYY HH:mm",
            llll: "ddd, [la] D[-an de] MMM, YYYY HH:mm"
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function(input) {
            return input.charAt(0).toLowerCase() === "p";
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours > 11) return isLower ? "p.t.m." : "P.T.M.";
            else return isLower ? "a.t.m." : "A.T.M.";
        },
        calendar: {
            sameDay: "[Hodia\u016D je] LT",
            nextDay: "[Morga\u016D je] LT",
            nextWeek: "dddd[n je] LT",
            lastDay: "[Hiera\u016D je] LT",
            lastWeek: "[pasintan] dddd[n je] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "post %s",
            past: "anta\u016D %s",
            s: "kelkaj sekundoj",
            ss: "%d sekundoj",
            m: "unu minuto",
            mm: "%d minutoj",
            h: "unu horo",
            hh: "%d horoj",
            d: "unu tago",
            dd: "%d tagoj",
            M: "unu monato",
            MM: "%d monatoj",
            y: "unu jaro",
            yy: "%d jaroj"
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: "%da",
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var monthsShortDot = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"), monthsShort$1 = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), monthsParse$2 = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ], monthsRegex$2 = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    moment.defineLocale("es-do", {
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort: function(m, format) {
            if (!m) return monthsShortDot;
            else if (/-MMM-/.test(format)) return monthsShort$1[m.month()];
            else return monthsShortDot[m.month()];
        },
        monthsRegex: monthsRegex$2,
        monthsShortRegex: monthsRegex$2,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$2,
        longMonthsParse: monthsParse$2,
        shortMonthsParse: monthsParse$2,
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY h:mm A",
            LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A"
        },
        calendar: {
            sameDay: function() {
                return "[hoy a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            nextDay: function() {
                return "[ma\xf1ana a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            nextWeek: function() {
                return "dddd [a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            lastDay: function() {
                return "[ayer a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            lastWeek: function() {
                return "[el] dddd [pasado a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: "una semana",
            ww: "%d semanas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var monthsShortDot$1 = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"), monthsShort$2 = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), monthsParse$3 = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ], monthsRegex$3 = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    moment.defineLocale("es-mx", {
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort: function(m, format) {
            if (!m) return monthsShortDot$1;
            else if (/-MMM-/.test(format)) return monthsShort$2[m.month()];
            else return monthsShortDot$1[m.month()];
        },
        monthsRegex: monthsRegex$3,
        monthsShortRegex: monthsRegex$3,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$3,
        longMonthsParse: monthsParse$3,
        shortMonthsParse: monthsParse$3,
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
        },
        calendar: {
            sameDay: function() {
                return "[hoy a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            nextDay: function() {
                return "[ma\xf1ana a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            nextWeek: function() {
                return "dddd [a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            lastDay: function() {
                return "[ayer a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            lastWeek: function() {
                return "[el] dddd [pasado a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: "una semana",
            ww: "%d semanas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 0,
            doy: 4
        },
        invalidDate: "Fecha inv\xe1lida"
    });
    //! moment.js locale configuration
    var monthsShortDot$2 = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"), monthsShort$3 = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), monthsParse$4 = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ], monthsRegex$4 = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    moment.defineLocale("es-us", {
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort: function(m, format) {
            if (!m) return monthsShortDot$2;
            else if (/-MMM-/.test(format)) return monthsShort$3[m.month()];
            else return monthsShortDot$2[m.month()];
        },
        monthsRegex: monthsRegex$4,
        monthsShortRegex: monthsRegex$4,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$4,
        longMonthsParse: monthsParse$4,
        shortMonthsParse: monthsParse$4,
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "MM/DD/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY h:mm A",
            LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A"
        },
        calendar: {
            sameDay: function() {
                return "[hoy a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            nextDay: function() {
                return "[ma\xf1ana a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            nextWeek: function() {
                return "dddd [a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            lastDay: function() {
                return "[ayer a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            lastWeek: function() {
                return "[el] dddd [pasado a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: "una semana",
            ww: "%d semanas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    var monthsShortDot$3 = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"), monthsShort$4 = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), monthsParse$5 = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ], monthsRegex$5 = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    moment.defineLocale("es", {
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort: function(m, format) {
            if (!m) return monthsShortDot$3;
            else if (/-MMM-/.test(format)) return monthsShort$4[m.month()];
            else return monthsShortDot$3[m.month()];
        },
        monthsRegex: monthsRegex$5,
        monthsShortRegex: monthsRegex$5,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$5,
        longMonthsParse: monthsParse$5,
        shortMonthsParse: monthsParse$5,
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
        },
        calendar: {
            sameDay: function() {
                return "[hoy a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            nextDay: function() {
                return "[ma\xf1ana a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            nextWeek: function() {
                return "dddd [a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            lastDay: function() {
                return "[ayer a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            lastWeek: function() {
                return "[el] dddd [pasado a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: "una semana",
            ww: "%d semanas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        },
        invalidDate: "Fecha inv\xe1lida"
    });
    //! moment.js locale configuration
    function processRelativeTime$4(number, withoutSuffix, key, isFuture) {
        var format = {
            s: [
                "m\xf5ne sekundi",
                "m\xf5ni sekund",
                "paar sekundit"
            ],
            ss: [
                number + "sekundi",
                number + "sekundit"
            ],
            m: [
                "\xfche minuti",
                "\xfcks minut"
            ],
            mm: [
                number + " minuti",
                number + " minutit"
            ],
            h: [
                "\xfche tunni",
                "tund aega",
                "\xfcks tund"
            ],
            hh: [
                number + " tunni",
                number + " tundi"
            ],
            d: [
                "\xfche p\xe4eva",
                "\xfcks p\xe4ev"
            ],
            M: [
                "kuu aja",
                "kuu aega",
                "\xfcks kuu"
            ],
            MM: [
                number + " kuu",
                number + " kuud"
            ],
            y: [
                "\xfche aasta",
                "aasta",
                "\xfcks aasta"
            ],
            yy: [
                number + " aasta",
                number + " aastat"
            ]
        };
        if (withoutSuffix) return format[key][2] ? format[key][2] : format[key][1];
        return isFuture ? format[key][0] : format[key][1];
    }
    moment.defineLocale("et", {
        months: "jaanuar_veebruar_m\xe4rts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),
        monthsShort: "jaan_veebr_m\xe4rts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),
        weekdays: "p\xfchap\xe4ev_esmasp\xe4ev_teisip\xe4ev_kolmap\xe4ev_neljap\xe4ev_reede_laup\xe4ev".split("_"),
        weekdaysShort: "P_E_T_K_N_R_L".split("_"),
        weekdaysMin: "P_E_T_K_N_R_L".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[T\xe4na,] LT",
            nextDay: "[Homme,] LT",
            nextWeek: "[J\xe4rgmine] dddd LT",
            lastDay: "[Eile,] LT",
            lastWeek: "[Eelmine] dddd LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s p\xe4rast",
            past: "%s tagasi",
            s: processRelativeTime$4,
            ss: processRelativeTime$4,
            m: processRelativeTime$4,
            mm: processRelativeTime$4,
            h: processRelativeTime$4,
            hh: processRelativeTime$4,
            d: processRelativeTime$4,
            dd: "%d p\xe4eva",
            M: processRelativeTime$4,
            MM: processRelativeTime$4,
            y: processRelativeTime$4,
            yy: processRelativeTime$4
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("eu", {
        months: "urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),
        monthsShort: "urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),
        monthsParseExact: true,
        weekdays: "igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),
        weekdaysShort: "ig._al._ar._az._og._ol._lr.".split("_"),
        weekdaysMin: "ig_al_ar_az_og_ol_lr".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "YYYY[ko] MMMM[ren] D[a]",
            LLL: "YYYY[ko] MMMM[ren] D[a] HH:mm",
            LLLL: "dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",
            l: "YYYY-M-D",
            ll: "YYYY[ko] MMM D[a]",
            lll: "YYYY[ko] MMM D[a] HH:mm",
            llll: "ddd, YYYY[ko] MMM D[a] HH:mm"
        },
        calendar: {
            sameDay: "[gaur] LT[etan]",
            nextDay: "[bihar] LT[etan]",
            nextWeek: "dddd LT[etan]",
            lastDay: "[atzo] LT[etan]",
            lastWeek: "[aurreko] dddd LT[etan]",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s barru",
            past: "duela %s",
            s: "segundo batzuk",
            ss: "%d segundo",
            m: "minutu bat",
            mm: "%d minutu",
            h: "ordu bat",
            hh: "%d ordu",
            d: "egun bat",
            dd: "%d egun",
            M: "hilabete bat",
            MM: "%d hilabete",
            y: "urte bat",
            yy: "%d urte"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var symbolMap$7 = {
        1: "\u06F1",
        2: "\u06F2",
        3: "\u06F3",
        4: "\u06F4",
        5: "\u06F5",
        6: "\u06F6",
        7: "\u06F7",
        8: "\u06F8",
        9: "\u06F9",
        0: "\u06F0"
    }, numberMap$6 = {
        "\u06F1": "1",
        "\u06F2": "2",
        "\u06F3": "3",
        "\u06F4": "4",
        "\u06F5": "5",
        "\u06F6": "6",
        "\u06F7": "7",
        "\u06F8": "8",
        "\u06F9": "9",
        "\u06F0": "0"
    };
    moment.defineLocale("fa", {
        months: "\u0698\u0627\u0646\u0648\u06CC\u0647_\u0641\u0648\u0631\u06CC\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06CC\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06CC\u0647_\u0627\u0648\u062A_\u0633\u067E\u062A\u0627\u0645\u0628\u0631_\u0627\u06A9\u062A\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062F\u0633\u0627\u0645\u0628\u0631".split("_"),
        monthsShort: "\u0698\u0627\u0646\u0648\u06CC\u0647_\u0641\u0648\u0631\u06CC\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06CC\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06CC\u0647_\u0627\u0648\u062A_\u0633\u067E\u062A\u0627\u0645\u0628\u0631_\u0627\u06A9\u062A\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062F\u0633\u0627\u0645\u0628\u0631".split("_"),
        weekdays: "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split("_"),
        weekdaysShort: "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split("_"),
        weekdaysMin: "\u06CC_\u062F_\u0633_\u0686_\u067E_\u062C_\u0634".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function(input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631";
            else return "\u0628\u0639\u062F \u0627\u0632 \u0638\u0647\u0631";
        },
        calendar: {
            sameDay: "[\u0627\u0645\u0631\u0648\u0632 \u0633\u0627\u0639\u062A] LT",
            nextDay: "[\u0641\u0631\u062F\u0627 \u0633\u0627\u0639\u062A] LT",
            nextWeek: "dddd [\u0633\u0627\u0639\u062A] LT",
            lastDay: "[\u062F\u06CC\u0631\u0648\u0632 \u0633\u0627\u0639\u062A] LT",
            lastWeek: "dddd [\u067E\u06CC\u0634] [\u0633\u0627\u0639\u062A] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u062F\u0631 %s",
            past: "%s \u067E\u06CC\u0634",
            s: "\u0686\u0646\u062F \u062B\u0627\u0646\u06CC\u0647",
            ss: "%d \u062B\u0627\u0646\u06CC\u0647",
            m: "\u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
            mm: "%d \u062F\u0642\u06CC\u0642\u0647",
            h: "\u06CC\u06A9 \u0633\u0627\u0639\u062A",
            hh: "%d \u0633\u0627\u0639\u062A",
            d: "\u06CC\u06A9 \u0631\u0648\u0632",
            dd: "%d \u0631\u0648\u0632",
            M: "\u06CC\u06A9 \u0645\u0627\u0647",
            MM: "%d \u0645\u0627\u0647",
            y: "\u06CC\u06A9 \u0633\u0627\u0644",
            yy: "%d \u0633\u0627\u0644"
        },
        preparse: function(string) {
            return string.replace(/[۰-۹]/g, function(match) {
                return numberMap$6[match];
            }).replace(/،/g, ",");
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$7[match];
            }).replace(/,/g, "\u060C");
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: "%d\u0645",
        week: {
            dow: 6,
            doy: 12
        }
    });
    //! moment.js locale configuration
    var numbersPast = "nolla yksi kaksi kolme nelj\xe4 viisi kuusi seitsem\xe4n kahdeksan yhdeks\xe4n".split(" "), numbersFuture = [
        "nolla",
        "yhden",
        "kahden",
        "kolmen",
        "nelj\xe4n",
        "viiden",
        "kuuden",
        numbersPast[7],
        numbersPast[8],
        numbersPast[9]
    ];
    function translate$2(number, withoutSuffix, key, isFuture) {
        var result = "";
        switch(key){
            case "s":
                return isFuture ? "muutaman sekunnin" : "muutama sekunti";
            case "ss":
                result = isFuture ? "sekunnin" : "sekuntia";
                break;
            case "m":
                return isFuture ? "minuutin" : "minuutti";
            case "mm":
                result = isFuture ? "minuutin" : "minuuttia";
                break;
            case "h":
                return isFuture ? "tunnin" : "tunti";
            case "hh":
                result = isFuture ? "tunnin" : "tuntia";
                break;
            case "d":
                return isFuture ? "p\xe4iv\xe4n" : "p\xe4iv\xe4";
            case "dd":
                result = isFuture ? "p\xe4iv\xe4n" : "p\xe4iv\xe4\xe4";
                break;
            case "M":
                return isFuture ? "kuukauden" : "kuukausi";
            case "MM":
                result = isFuture ? "kuukauden" : "kuukautta";
                break;
            case "y":
                return isFuture ? "vuoden" : "vuosi";
            case "yy":
                result = isFuture ? "vuoden" : "vuotta";
                break;
        }
        result = verbalNumber(number, isFuture) + " " + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
    }
    moment.defineLocale("fi", {
        months: "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kes\xe4kuu_hein\xe4kuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),
        monthsShort: "tammi_helmi_maalis_huhti_touko_kes\xe4_hein\xe4_elo_syys_loka_marras_joulu".split("_"),
        weekdays: "sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),
        weekdaysShort: "su_ma_ti_ke_to_pe_la".split("_"),
        weekdaysMin: "su_ma_ti_ke_to_pe_la".split("_"),
        longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD.MM.YYYY",
            LL: "Do MMMM[ta] YYYY",
            LLL: "Do MMMM[ta] YYYY, [klo] HH.mm",
            LLLL: "dddd, Do MMMM[ta] YYYY, [klo] HH.mm",
            l: "D.M.YYYY",
            ll: "Do MMM YYYY",
            lll: "Do MMM YYYY, [klo] HH.mm",
            llll: "ddd, Do MMM YYYY, [klo] HH.mm"
        },
        calendar: {
            sameDay: "[t\xe4n\xe4\xe4n] [klo] LT",
            nextDay: "[huomenna] [klo] LT",
            nextWeek: "dddd [klo] LT",
            lastDay: "[eilen] [klo] LT",
            lastWeek: "[viime] dddd[na] [klo] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s p\xe4\xe4st\xe4",
            past: "%s sitten",
            s: translate$2,
            ss: translate$2,
            m: translate$2,
            mm: translate$2,
            h: translate$2,
            hh: translate$2,
            d: translate$2,
            dd: translate$2,
            M: translate$2,
            MM: translate$2,
            y: translate$2,
            yy: translate$2
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("fil", {
        months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),
        monthsShort: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
        weekdays: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),
        weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
        weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "MM/D/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY HH:mm",
            LLLL: "dddd, MMMM DD, YYYY HH:mm"
        },
        calendar: {
            sameDay: "LT [ngayong araw]",
            nextDay: "[Bukas ng] LT",
            nextWeek: "LT [sa susunod na] dddd",
            lastDay: "LT [kahapon]",
            lastWeek: "LT [noong nakaraang] dddd",
            sameElse: "L"
        },
        relativeTime: {
            future: "sa loob ng %s",
            past: "%s ang nakalipas",
            s: "ilang segundo",
            ss: "%d segundo",
            m: "isang minuto",
            mm: "%d minuto",
            h: "isang oras",
            hh: "%d oras",
            d: "isang araw",
            dd: "%d araw",
            M: "isang buwan",
            MM: "%d buwan",
            y: "isang taon",
            yy: "%d taon"
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function(number) {
            return number;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("fo", {
        months: "januar_februar_mars_apr\xedl_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        monthsShort: "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
        weekdays: "sunnudagur_m\xe1nadagur_t\xfdsdagur_mikudagur_h\xf3sdagur_fr\xedggjadagur_leygardagur".split("_"),
        weekdaysShort: "sun_m\xe1n_t\xfds_mik_h\xf3s_fr\xed_ley".split("_"),
        weekdaysMin: "su_m\xe1_t\xfd_mi_h\xf3_fr_le".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D. MMMM, YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\xcd dag kl.] LT",
            nextDay: "[\xcd morgin kl.] LT",
            nextWeek: "dddd [kl.] LT",
            lastDay: "[\xcd gj\xe1r kl.] LT",
            lastWeek: "[s\xed\xf0stu] dddd [kl] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "um %s",
            past: "%s s\xed\xf0ani",
            s: "f\xe1 sekund",
            ss: "%d sekundir",
            m: "ein minuttur",
            mm: "%d minuttir",
            h: "ein t\xedmi",
            hh: "%d t\xedmar",
            d: "ein dagur",
            dd: "%d dagar",
            M: "ein m\xe1na\xf0ur",
            MM: "%d m\xe1na\xf0ir",
            y: "eitt \xe1r",
            yy: "%d \xe1r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("fr-ca", {
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
        monthsParseExact: true,
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Aujourd\u2019hui \xe0] LT",
            nextDay: "[Demain \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[Hier \xe0] LT",
            lastWeek: "dddd [dernier \xe0] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            ss: "%d secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function(number, period) {
            switch(period){
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case "M":
                case "Q":
                case "D":
                case "DDD":
                case "d":
                    return number + (number === 1 ? "er" : "e");
                // Words with feminine grammatical gender: semaine
                case "w":
                case "W":
                    return number + (number === 1 ? "re" : "e");
            }
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("fr-ch", {
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
        monthsParseExact: true,
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Aujourd\u2019hui \xe0] LT",
            nextDay: "[Demain \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[Hier \xe0] LT",
            lastWeek: "dddd [dernier \xe0] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            ss: "%d secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function(number, period) {
            switch(period){
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case "M":
                case "Q":
                case "D":
                case "DDD":
                case "d":
                    return number + (number === 1 ? "er" : "e");
                // Words with feminine grammatical gender: semaine
                case "w":
                case "W":
                    return number + (number === 1 ? "re" : "e");
            }
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var monthsStrictRegex$1 = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i, monthsShortStrictRegex$1 = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i, monthsRegex$6 = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i, monthsParse$6 = [
        /^janv/i,
        /^févr/i,
        /^mars/i,
        /^avr/i,
        /^mai/i,
        /^juin/i,
        /^juil/i,
        /^août/i,
        /^sept/i,
        /^oct/i,
        /^nov/i,
        /^déc/i
    ];
    moment.defineLocale("fr", {
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
        monthsRegex: monthsRegex$6,
        monthsShortRegex: monthsRegex$6,
        monthsStrictRegex: monthsStrictRegex$1,
        monthsShortStrictRegex: monthsShortStrictRegex$1,
        monthsParse: monthsParse$6,
        longMonthsParse: monthsParse$6,
        shortMonthsParse: monthsParse$6,
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Aujourd\u2019hui \xe0] LT",
            nextDay: "[Demain \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[Hier \xe0] LT",
            lastWeek: "dddd [dernier \xe0] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            ss: "%d secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            w: "une semaine",
            ww: "%d semaines",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function(number, period) {
            switch(period){
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case "D":
                    return number + (number === 1 ? "er" : "");
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case "M":
                case "Q":
                case "DDD":
                case "d":
                    return number + (number === 1 ? "er" : "e");
                // Words with feminine grammatical gender: semaine
                case "w":
                case "W":
                    return number + (number === 1 ? "re" : "e");
            }
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var monthsShortWithDots = "jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_"), monthsShortWithoutDots = "jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");
    moment.defineLocale("fy", {
        months: "jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split("_"),
        monthsShort: function(m, format) {
            if (!m) return monthsShortWithDots;
            else if (/-MMM-/.test(format)) return monthsShortWithoutDots[m.month()];
            else return monthsShortWithDots[m.month()];
        },
        monthsParseExact: true,
        weekdays: "snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split("_"),
        weekdaysShort: "si._mo._ti._wo._to._fr._so.".split("_"),
        weekdaysMin: "Si_Mo_Ti_Wo_To_Fr_So".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[hjoed om] LT",
            nextDay: "[moarn om] LT",
            nextWeek: "dddd [om] LT",
            lastDay: "[juster om] LT",
            lastWeek: "[\xf4fr\xfbne] dddd [om] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "oer %s",
            past: "%s lyn",
            s: "in pear sekonden",
            ss: "%d sekonden",
            m: "ien min\xfat",
            mm: "%d minuten",
            h: "ien oere",
            hh: "%d oeren",
            d: "ien dei",
            dd: "%d dagen",
            M: "ien moanne",
            MM: "%d moannen",
            y: "ien jier",
            yy: "%d jierren"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? "ste" : "de");
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var months$5 = [
        "Ean\xe1ir",
        "Feabhra",
        "M\xe1rta",
        "Aibre\xe1n",
        "Bealtaine",
        "Meitheamh",
        "I\xfail",
        "L\xfanasa",
        "Me\xe1n F\xf3mhair",
        "Deireadh F\xf3mhair",
        "Samhain",
        "Nollaig"
    ], monthsShort$5 = [
        "Ean",
        "Feabh",
        "M\xe1rt",
        "Aib",
        "Beal",
        "Meith",
        "I\xfail",
        "L\xfan",
        "M.F.",
        "D.F.",
        "Samh",
        "Noll"
    ], weekdays$1 = [
        "D\xe9 Domhnaigh",
        "D\xe9 Luain",
        "D\xe9 M\xe1irt",
        "D\xe9 C\xe9adaoin",
        "D\xe9ardaoin",
        "D\xe9 hAoine",
        "D\xe9 Sathairn"
    ], weekdaysShort = [
        "Domh",
        "Luan",
        "M\xe1irt",
        "C\xe9ad",
        "D\xe9ar",
        "Aoine",
        "Sath"
    ], weekdaysMin = [
        "Do",
        "Lu",
        "M\xe1",
        "C\xe9",
        "D\xe9",
        "A",
        "Sa"
    ];
    moment.defineLocale("ga", {
        months: months$5,
        monthsShort: monthsShort$5,
        monthsParseExact: true,
        weekdays: weekdays$1,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Inniu ag] LT",
            nextDay: "[Am\xe1rach ag] LT",
            nextWeek: "dddd [ag] LT",
            lastDay: "[Inn\xe9 ag] LT",
            lastWeek: "dddd [seo caite] [ag] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "i %s",
            past: "%s \xf3 shin",
            s: "c\xfapla soicind",
            ss: "%d soicind",
            m: "n\xf3im\xe9ad",
            mm: "%d n\xf3im\xe9ad",
            h: "uair an chloig",
            hh: "%d uair an chloig",
            d: "l\xe1",
            dd: "%d l\xe1",
            M: "m\xed",
            MM: "%d m\xedonna",
            y: "bliain",
            yy: "%d bliain"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function(number) {
            var output = number === 1 ? "d" : number % 10 === 2 ? "na" : "mh";
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var months$6 = [
        "Am Faoilleach",
        "An Gearran",
        "Am M\xe0rt",
        "An Giblean",
        "An C\xe8itean",
        "An t-\xd2gmhios",
        "An t-Iuchar",
        "An L\xf9nastal",
        "An t-Sultain",
        "An D\xe0mhair",
        "An t-Samhain",
        "An D\xf9bhlachd"
    ], monthsShort$6 = [
        "Faoi",
        "Gear",
        "M\xe0rt",
        "Gibl",
        "C\xe8it",
        "\xd2gmh",
        "Iuch",
        "L\xf9n",
        "Sult",
        "D\xe0mh",
        "Samh",
        "D\xf9bh"
    ], weekdays$2 = [
        "Did\xf2mhnaich",
        "Diluain",
        "Dim\xe0irt",
        "Diciadain",
        "Diardaoin",
        "Dihaoine",
        "Disathairne"
    ], weekdaysShort$1 = [
        "Did",
        "Dil",
        "Dim",
        "Dic",
        "Dia",
        "Dih",
        "Dis"
    ], weekdaysMin$1 = [
        "D\xf2",
        "Lu",
        "M\xe0",
        "Ci",
        "Ar",
        "Ha",
        "Sa"
    ];
    moment.defineLocale("gd", {
        months: months$6,
        monthsShort: monthsShort$6,
        monthsParseExact: true,
        weekdays: weekdays$2,
        weekdaysShort: weekdaysShort$1,
        weekdaysMin: weekdaysMin$1,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[An-diugh aig] LT",
            nextDay: "[A-m\xe0ireach aig] LT",
            nextWeek: "dddd [aig] LT",
            lastDay: "[An-d\xe8 aig] LT",
            lastWeek: "dddd [seo chaidh] [aig] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "ann an %s",
            past: "bho chionn %s",
            s: "beagan diogan",
            ss: "%d diogan",
            m: "mionaid",
            mm: "%d mionaidean",
            h: "uair",
            hh: "%d uairean",
            d: "latha",
            dd: "%d latha",
            M: "m\xecos",
            MM: "%d m\xecosan",
            y: "bliadhna",
            yy: "%d bliadhna"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function(number) {
            var output = number === 1 ? "d" : number % 10 === 2 ? "na" : "mh";
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("gl", {
        months: "xaneiro_febreiro_marzo_abril_maio_xu\xf1o_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),
        monthsShort: "xan._feb._mar._abr._mai._xu\xf1._xul._ago._set._out._nov._dec.".split("_"),
        monthsParseExact: true,
        weekdays: "domingo_luns_martes_m\xe9rcores_xoves_venres_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._m\xe9r._xov._ven._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_m\xe9_xo_ve_s\xe1".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
        },
        calendar: {
            sameDay: function() {
                return "[hoxe " + (this.hours() !== 1 ? "\xe1s" : "\xe1") + "] LT";
            },
            nextDay: function() {
                return "[ma\xf1\xe1 " + (this.hours() !== 1 ? "\xe1s" : "\xe1") + "] LT";
            },
            nextWeek: function() {
                return "dddd [" + (this.hours() !== 1 ? "\xe1s" : "a") + "] LT";
            },
            lastDay: function() {
                return "[onte " + (this.hours() !== 1 ? "\xe1" : "a") + "] LT";
            },
            lastWeek: function() {
                return "[o] dddd [pasado " + (this.hours() !== 1 ? "\xe1s" : "a") + "] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: function(str) {
                if (str.indexOf("un") === 0) return "n" + str;
                return "en " + str;
            },
            past: "hai %s",
            s: "uns segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "unha hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            M: "un mes",
            MM: "%d meses",
            y: "un ano",
            yy: "%d anos"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$5(number, withoutSuffix, key, isFuture) {
        var format = {
            s: [
                "\u0925\u094B\u0921\u092F\u093E \u0938\u0945\u0915\u0902\u0921\u093E\u0902\u0928\u0940",
                "\u0925\u094B\u0921\u0947 \u0938\u0945\u0915\u0902\u0921"
            ],
            ss: [
                number + " \u0938\u0945\u0915\u0902\u0921\u093E\u0902\u0928\u0940",
                number + " \u0938\u0945\u0915\u0902\u0921"
            ],
            m: [
                "\u090F\u0915\u093E \u092E\u093F\u0923\u091F\u093E\u0928",
                "\u090F\u0915 \u092E\u093F\u0928\u0942\u091F"
            ],
            mm: [
                number + " \u092E\u093F\u0923\u091F\u093E\u0902\u0928\u0940",
                number + " \u092E\u093F\u0923\u091F\u093E\u0902"
            ],
            h: [
                "\u090F\u0915\u093E \u0935\u0930\u093E\u0928",
                "\u090F\u0915 \u0935\u0930"
            ],
            hh: [
                number + " \u0935\u0930\u093E\u0902\u0928\u0940",
                number + " \u0935\u0930\u093E\u0902"
            ],
            d: [
                "\u090F\u0915\u093E \u0926\u093F\u0938\u093E\u0928",
                "\u090F\u0915 \u0926\u0940\u0938"
            ],
            dd: [
                number + " \u0926\u093F\u0938\u093E\u0902\u0928\u0940",
                number + " \u0926\u0940\u0938"
            ],
            M: [
                "\u090F\u0915\u093E \u092E\u094D\u0939\u092F\u0928\u094D\u092F\u093E\u0928",
                "\u090F\u0915 \u092E\u094D\u0939\u092F\u0928\u094B"
            ],
            MM: [
                number + " \u092E\u094D\u0939\u092F\u0928\u094D\u092F\u093E\u0928\u0940",
                number + " \u092E\u094D\u0939\u092F\u0928\u0947"
            ],
            y: [
                "\u090F\u0915\u093E \u0935\u0930\u094D\u0938\u093E\u0928",
                "\u090F\u0915 \u0935\u0930\u094D\u0938"
            ],
            yy: [
                number + " \u0935\u0930\u094D\u0938\u093E\u0902\u0928\u0940",
                number + " \u0935\u0930\u094D\u0938\u093E\u0902"
            ]
        };
        return isFuture ? format[key][0] : format[key][1];
    }
    moment.defineLocale("gom-deva", {
        months: {
            standalone: "\u091C\u093E\u0928\u0947\u0935\u093E\u0930\u0940_\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u093E\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u090F\u092A\u094D\u0930\u0940\u0932_\u092E\u0947_\u091C\u0942\u0928_\u091C\u0941\u0932\u092F_\u0911\u0917\u0938\u094D\u091F_\u0938\u092A\u094D\u091F\u0947\u0902\u092C\u0930_\u0911\u0915\u094D\u091F\u094B\u092C\u0930_\u0928\u094B\u0935\u094D\u0939\u0947\u0902\u092C\u0930_\u0921\u093F\u0938\u0947\u0902\u092C\u0930".split("_"),
            format: "\u091C\u093E\u0928\u0947\u0935\u093E\u0930\u0940\u091A\u094D\u092F\u093E_\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u093E\u0930\u0940\u091A\u094D\u092F\u093E_\u092E\u093E\u0930\u094D\u091A\u093E\u091A\u094D\u092F\u093E_\u090F\u092A\u094D\u0930\u0940\u0932\u093E\u091A\u094D\u092F\u093E_\u092E\u0947\u092F\u093E\u091A\u094D\u092F\u093E_\u091C\u0942\u0928\u093E\u091A\u094D\u092F\u093E_\u091C\u0941\u0932\u092F\u093E\u091A\u094D\u092F\u093E_\u0911\u0917\u0938\u094D\u091F\u093E\u091A\u094D\u092F\u093E_\u0938\u092A\u094D\u091F\u0947\u0902\u092C\u0930\u093E\u091A\u094D\u092F\u093E_\u0911\u0915\u094D\u091F\u094B\u092C\u0930\u093E\u091A\u094D\u092F\u093E_\u0928\u094B\u0935\u094D\u0939\u0947\u0902\u092C\u0930\u093E\u091A\u094D\u092F\u093E_\u0921\u093F\u0938\u0947\u0902\u092C\u0930\u093E\u091A\u094D\u092F\u093E".split("_"),
            isFormat: /MMMM(\s)+D[oD]?/
        },
        monthsShort: "\u091C\u093E\u0928\u0947._\u092B\u0947\u092C\u094D\u0930\u0941._\u092E\u093E\u0930\u094D\u091A_\u090F\u092A\u094D\u0930\u0940._\u092E\u0947_\u091C\u0942\u0928_\u091C\u0941\u0932._\u0911\u0917._\u0938\u092A\u094D\u091F\u0947\u0902._\u0911\u0915\u094D\u091F\u094B._\u0928\u094B\u0935\u094D\u0939\u0947\u0902._\u0921\u093F\u0938\u0947\u0902.".split("_"),
        monthsParseExact: true,
        weekdays: "\u0906\u092F\u0924\u093E\u0930_\u0938\u094B\u092E\u093E\u0930_\u092E\u0902\u0917\u0933\u093E\u0930_\u092C\u0941\u0927\u0935\u093E\u0930_\u092C\u093F\u0930\u0947\u0938\u094D\u0924\u093E\u0930_\u0938\u0941\u0915\u094D\u0930\u093E\u0930_\u0936\u0947\u0928\u0935\u093E\u0930".split("_"),
        weekdaysShort: "\u0906\u092F\u0924._\u0938\u094B\u092E._\u092E\u0902\u0917\u0933._\u092C\u0941\u0927._\u092C\u094D\u0930\u0947\u0938\u094D\u0924._\u0938\u0941\u0915\u094D\u0930._\u0936\u0947\u0928.".split("_"),
        weekdaysMin: "\u0906_\u0938\u094B_\u092E\u0902_\u092C\u0941_\u092C\u094D\u0930\u0947_\u0938\u0941_\u0936\u0947".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "A h:mm [\u0935\u093E\u091C\u0924\u093E\u0902]",
            LTS: "A h:mm:ss [\u0935\u093E\u091C\u0924\u093E\u0902]",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY A h:mm [\u0935\u093E\u091C\u0924\u093E\u0902]",
            LLLL: "dddd, MMMM Do, YYYY, A h:mm [\u0935\u093E\u091C\u0924\u093E\u0902]",
            llll: "ddd, D MMM YYYY, A h:mm [\u0935\u093E\u091C\u0924\u093E\u0902]"
        },
        calendar: {
            sameDay: "[\u0906\u092F\u091C] LT",
            nextDay: "[\u092B\u093E\u0932\u094D\u092F\u093E\u0902] LT",
            nextWeek: "[\u092B\u0941\u0921\u0932\u094B] dddd[,] LT",
            lastDay: "[\u0915\u093E\u0932] LT",
            lastWeek: "[\u092B\u093E\u091F\u0932\u094B] dddd[,] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s",
            past: "%s \u0906\u0926\u0940\u0902",
            s: processRelativeTime$5,
            ss: processRelativeTime$5,
            m: processRelativeTime$5,
            mm: processRelativeTime$5,
            h: processRelativeTime$5,
            hh: processRelativeTime$5,
            d: processRelativeTime$5,
            dd: processRelativeTime$5,
            M: processRelativeTime$5,
            MM: processRelativeTime$5,
            y: processRelativeTime$5,
            yy: processRelativeTime$5
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function(number, period) {
            switch(period){
                // the ordinal 'वेर' only applies to day of the month
                case "D":
                    return number + "\u0935\u0947\u0930";
                default:
                case "M":
                case "Q":
                case "DDD":
                case "d":
                case "w":
                case "W":
                    return number;
            }
        },
        week: {
            dow: 0,
            doy: 3
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0930\u093E\u0924\u0940") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0938\u0915\u093E\u0933\u0940\u0902") return hour;
            else if (meridiem === "\u0926\u0928\u092A\u093E\u0930\u093E\u0902") return hour > 12 ? hour : hour + 12;
            else if (meridiem === "\u0938\u093E\u0902\u091C\u0947") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0930\u093E\u0924\u0940";
            else if (hour < 12) return "\u0938\u0915\u093E\u0933\u0940\u0902";
            else if (hour < 16) return "\u0926\u0928\u092A\u093E\u0930\u093E\u0902";
            else if (hour < 20) return "\u0938\u093E\u0902\u091C\u0947";
            else return "\u0930\u093E\u0924\u0940";
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$6(number, withoutSuffix, key, isFuture) {
        var format = {
            s: [
                "thoddea sekondamni",
                "thodde sekond"
            ],
            ss: [
                number + " sekondamni",
                number + " sekond"
            ],
            m: [
                "eka mintan",
                "ek minut"
            ],
            mm: [
                number + " mintamni",
                number + " mintam"
            ],
            h: [
                "eka voran",
                "ek vor"
            ],
            hh: [
                number + " voramni",
                number + " voram"
            ],
            d: [
                "eka disan",
                "ek dis"
            ],
            dd: [
                number + " disamni",
                number + " dis"
            ],
            M: [
                "eka mhoinean",
                "ek mhoino"
            ],
            MM: [
                number + " mhoineamni",
                number + " mhoine"
            ],
            y: [
                "eka vorsan",
                "ek voros"
            ],
            yy: [
                number + " vorsamni",
                number + " vorsam"
            ]
        };
        return isFuture ? format[key][0] : format[key][1];
    }
    moment.defineLocale("gom-latn", {
        months: {
            standalone: "Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split("_"),
            format: "Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea".split("_"),
            isFormat: /MMMM(\s)+D[oD]?/
        },
        monthsShort: "Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split("_"),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split("_"),
        weekdaysShort: "Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),
        weekdaysMin: "Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "A h:mm [vazta]",
            LTS: "A h:mm:ss [vazta]",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY A h:mm [vazta]",
            LLLL: "dddd, MMMM Do, YYYY, A h:mm [vazta]",
            llll: "ddd, D MMM YYYY, A h:mm [vazta]"
        },
        calendar: {
            sameDay: "[Aiz] LT",
            nextDay: "[Faleam] LT",
            nextWeek: "[Fuddlo] dddd[,] LT",
            lastDay: "[Kal] LT",
            lastWeek: "[Fattlo] dddd[,] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s",
            past: "%s adim",
            s: processRelativeTime$6,
            ss: processRelativeTime$6,
            m: processRelativeTime$6,
            mm: processRelativeTime$6,
            h: processRelativeTime$6,
            hh: processRelativeTime$6,
            d: processRelativeTime$6,
            dd: processRelativeTime$6,
            M: processRelativeTime$6,
            MM: processRelativeTime$6,
            y: processRelativeTime$6,
            yy: processRelativeTime$6
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function(number, period) {
            switch(period){
                // the ordinal 'er' only applies to day of the month
                case "D":
                    return number + "er";
                default:
                case "M":
                case "Q":
                case "DDD":
                case "d":
                case "w":
                case "W":
                    return number;
            }
        },
        week: {
            dow: 0,
            doy: 3
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "rati") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "sokallim") return hour;
            else if (meridiem === "donparam") return hour > 12 ? hour : hour + 12;
            else if (meridiem === "sanje") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "rati";
            else if (hour < 12) return "sokallim";
            else if (hour < 16) return "donparam";
            else if (hour < 20) return "sanje";
            else return "rati";
        }
    });
    //! moment.js locale configuration
    var symbolMap$8 = {
        1: "\u0AE7",
        2: "\u0AE8",
        3: "\u0AE9",
        4: "\u0AEA",
        5: "\u0AEB",
        6: "\u0AEC",
        7: "\u0AED",
        8: "\u0AEE",
        9: "\u0AEF",
        0: "\u0AE6"
    }, numberMap$7 = {
        "\u0AE7": "1",
        "\u0AE8": "2",
        "\u0AE9": "3",
        "\u0AEA": "4",
        "\u0AEB": "5",
        "\u0AEC": "6",
        "\u0AED": "7",
        "\u0AEE": "8",
        "\u0AEF": "9",
        "\u0AE6": "0"
    };
    moment.defineLocale("gu", {
        months: "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0_\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0_\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A_\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2_\u0AAE\u0AC7_\u0A9C\u0AC2\u0AA8_\u0A9C\u0AC1\u0AB2\u0ABE\u0A88_\u0A91\u0A97\u0AB8\u0ACD\u0A9F_\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0_\u0A91\u0A95\u0ACD\u0A9F\u0ACD\u0AAC\u0AB0_\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0_\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0".split("_"),
        monthsShort: "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1._\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1._\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A_\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF._\u0AAE\u0AC7_\u0A9C\u0AC2\u0AA8_\u0A9C\u0AC1\u0AB2\u0ABE._\u0A91\u0A97._\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7._\u0A91\u0A95\u0ACD\u0A9F\u0ACD._\u0AA8\u0AB5\u0AC7._\u0AA1\u0ABF\u0AB8\u0AC7.".split("_"),
        monthsParseExact: true,
        weekdays: "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0_\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0_\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0_\u0AAC\u0AC1\u0AA7\u0ACD\u0AB5\u0ABE\u0AB0_\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0_\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0_\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0".split("_"),
        weekdaysShort: "\u0AB0\u0AB5\u0ABF_\u0AB8\u0ACB\u0AAE_\u0AAE\u0A82\u0A97\u0AB3_\u0AAC\u0AC1\u0AA7\u0ACD_\u0A97\u0AC1\u0AB0\u0AC1_\u0AB6\u0AC1\u0A95\u0ACD\u0AB0_\u0AB6\u0AA8\u0ABF".split("_"),
        weekdaysMin: "\u0AB0_\u0AB8\u0ACB_\u0AAE\u0A82_\u0AAC\u0AC1_\u0A97\u0AC1_\u0AB6\u0AC1_\u0AB6".split("_"),
        longDateFormat: {
            LT: "A h:mm \u0AB5\u0ABE\u0A97\u0ACD\u0AAF\u0AC7",
            LTS: "A h:mm:ss \u0AB5\u0ABE\u0A97\u0ACD\u0AAF\u0AC7",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u0AB5\u0ABE\u0A97\u0ACD\u0AAF\u0AC7",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u0AB5\u0ABE\u0A97\u0ACD\u0AAF\u0AC7"
        },
        calendar: {
            sameDay: "[\u0A86\u0A9C] LT",
            nextDay: "[\u0A95\u0ABE\u0AB2\u0AC7] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0A97\u0A87\u0A95\u0ABE\u0AB2\u0AC7] LT",
            lastWeek: "[\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0AAE\u0ABE",
            past: "%s \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE",
            s: "\u0A85\u0AAE\u0AC1\u0A95 \u0AAA\u0AB3\u0ACB",
            ss: "%d \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
            m: "\u0A8F\u0A95 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
            mm: "%d \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
            h: "\u0A8F\u0A95 \u0A95\u0AB2\u0ABE\u0A95",
            hh: "%d \u0A95\u0AB2\u0ABE\u0A95",
            d: "\u0A8F\u0A95 \u0AA6\u0ABF\u0AB5\u0AB8",
            dd: "%d \u0AA6\u0ABF\u0AB5\u0AB8",
            M: "\u0A8F\u0A95 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
            MM: "%d \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
            y: "\u0A8F\u0A95 \u0AB5\u0AB0\u0ACD\u0AB7",
            yy: "%d \u0AB5\u0AB0\u0ACD\u0AB7"
        },
        preparse: function(string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function(match) {
                return numberMap$7[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$8[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0AB0\u0ABE\u0AA4") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0AB8\u0AB5\u0ABE\u0AB0") return hour;
            else if (meridiem === "\u0AAC\u0AAA\u0ACB\u0AB0") return hour >= 10 ? hour : hour + 12;
            else if (meridiem === "\u0AB8\u0ABE\u0A82\u0A9C") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0AB0\u0ABE\u0AA4";
            else if (hour < 10) return "\u0AB8\u0AB5\u0ABE\u0AB0";
            else if (hour < 17) return "\u0AAC\u0AAA\u0ACB\u0AB0";
            else if (hour < 20) return "\u0AB8\u0ABE\u0A82\u0A9C";
            else return "\u0AB0\u0ABE\u0AA4";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("he", {
        months: "\u05D9\u05E0\u05D5\u05D0\u05E8_\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8_\u05DE\u05E8\u05E5_\u05D0\u05E4\u05E8\u05D9\u05DC_\u05DE\u05D0\u05D9_\u05D9\u05D5\u05E0\u05D9_\u05D9\u05D5\u05DC\u05D9_\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8_\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8_\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8_\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8_\u05D3\u05E6\u05DE\u05D1\u05E8".split("_"),
        monthsShort: "\u05D9\u05E0\u05D5\u05F3_\u05E4\u05D1\u05E8\u05F3_\u05DE\u05E8\u05E5_\u05D0\u05E4\u05E8\u05F3_\u05DE\u05D0\u05D9_\u05D9\u05D5\u05E0\u05D9_\u05D9\u05D5\u05DC\u05D9_\u05D0\u05D5\u05D2\u05F3_\u05E1\u05E4\u05D8\u05F3_\u05D0\u05D5\u05E7\u05F3_\u05E0\u05D5\u05D1\u05F3_\u05D3\u05E6\u05DE\u05F3".split("_"),
        weekdays: "\u05E8\u05D0\u05E9\u05D5\u05DF_\u05E9\u05E0\u05D9_\u05E9\u05DC\u05D9\u05E9\u05D9_\u05E8\u05D1\u05D9\u05E2\u05D9_\u05D7\u05DE\u05D9\u05E9\u05D9_\u05E9\u05D9\u05E9\u05D9_\u05E9\u05D1\u05EA".split("_"),
        weekdaysShort: "\u05D0\u05F3_\u05D1\u05F3_\u05D2\u05F3_\u05D3\u05F3_\u05D4\u05F3_\u05D5\u05F3_\u05E9\u05F3".split("_"),
        weekdaysMin: "\u05D0_\u05D1_\u05D2_\u05D3_\u05D4_\u05D5_\u05E9".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [\u05D1]MMMM YYYY",
            LLL: "D [\u05D1]MMMM YYYY HH:mm",
            LLLL: "dddd, D [\u05D1]MMMM YYYY HH:mm",
            l: "D/M/YYYY",
            ll: "D MMM YYYY",
            lll: "D MMM YYYY HH:mm",
            llll: "ddd, D MMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u05D4\u05D9\u05D5\u05DD \u05D1\u05BE]LT",
            nextDay: "[\u05DE\u05D7\u05E8 \u05D1\u05BE]LT",
            nextWeek: "dddd [\u05D1\u05E9\u05E2\u05D4] LT",
            lastDay: "[\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05BE]LT",
            lastWeek: "[\u05D1\u05D9\u05D5\u05DD] dddd [\u05D4\u05D0\u05D7\u05E8\u05D5\u05DF \u05D1\u05E9\u05E2\u05D4] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u05D1\u05E2\u05D5\u05D3 %s",
            past: "\u05DC\u05E4\u05E0\u05D9 %s",
            s: "\u05DE\u05E1\u05E4\u05E8 \u05E9\u05E0\u05D9\u05D5\u05EA",
            ss: "%d \u05E9\u05E0\u05D9\u05D5\u05EA",
            m: "\u05D3\u05E7\u05D4",
            mm: "%d \u05D3\u05E7\u05D5\u05EA",
            h: "\u05E9\u05E2\u05D4",
            hh: function(number) {
                if (number === 2) return "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD";
                return number + " \u05E9\u05E2\u05D5\u05EA";
            },
            d: "\u05D9\u05D5\u05DD",
            dd: function(number) {
                if (number === 2) return "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD";
                return number + " \u05D9\u05DE\u05D9\u05DD";
            },
            M: "\u05D7\u05D5\u05D3\u05E9",
            MM: function(number) {
                if (number === 2) return "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD";
                return number + " \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD";
            },
            y: "\u05E9\u05E0\u05D4",
            yy: function(number) {
                if (number === 2) return "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD";
                else if (number % 10 === 0 && number !== 10) return number + " \u05E9\u05E0\u05D4";
                return number + " \u05E9\u05E0\u05D9\u05DD";
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function(input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 5) return "\u05DC\u05E4\u05E0\u05D5\u05EA \u05D1\u05D5\u05E7\u05E8";
            else if (hour < 10) return "\u05D1\u05D1\u05D5\u05E7\u05E8";
            else if (hour < 12) return isLower ? '\u05DC\u05E4\u05E0\u05D4"\u05E6' : "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD";
            else if (hour < 18) return isLower ? '\u05D0\u05D7\u05D4"\u05E6' : "\u05D0\u05D7\u05E8\u05D9 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD";
            else return "\u05D1\u05E2\u05E8\u05D1";
        }
    });
    //! moment.js locale configuration
    var symbolMap$9 = {
        1: "\u0967",
        2: "\u0968",
        3: "\u0969",
        4: "\u096A",
        5: "\u096B",
        6: "\u096C",
        7: "\u096D",
        8: "\u096E",
        9: "\u096F",
        0: "\u0966"
    }, numberMap$8 = {
        "\u0967": "1",
        "\u0968": "2",
        "\u0969": "3",
        "\u096A": "4",
        "\u096B": "5",
        "\u096C": "6",
        "\u096D": "7",
        "\u096E": "8",
        "\u096F": "9",
        "\u0966": "0"
    }, monthsParse$7 = [
        /^जन/i,
        /^फ़र|फर/i,
        /^मार्च/i,
        /^अप्रै/i,
        /^मई/i,
        /^जून/i,
        /^जुल/i,
        /^अग/i,
        /^सितं|सित/i,
        /^अक्टू/i,
        /^नव|नवं/i,
        /^दिसं|दिस/i
    ], shortMonthsParse = [
        /^जन/i,
        /^फ़र/i,
        /^मार्च/i,
        /^अप्रै/i,
        /^मई/i,
        /^जून/i,
        /^जुल/i,
        /^अग/i,
        /^सित/i,
        /^अक्टू/i,
        /^नव/i,
        /^दिस/i
    ];
    moment.defineLocale("hi", {
        months: {
            format: "\u091C\u0928\u0935\u0930\u0940_\u092B\u093C\u0930\u0935\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u0948\u0932_\u092E\u0908_\u091C\u0942\u0928_\u091C\u0941\u0932\u093E\u0908_\u0905\u0917\u0938\u094D\u0924_\u0938\u093F\u0924\u092E\u094D\u092C\u0930_\u0905\u0915\u094D\u091F\u0942\u092C\u0930_\u0928\u0935\u092E\u094D\u092C\u0930_\u0926\u093F\u0938\u092E\u094D\u092C\u0930".split("_"),
            standalone: "\u091C\u0928\u0935\u0930\u0940_\u092B\u0930\u0935\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u0948\u0932_\u092E\u0908_\u091C\u0942\u0928_\u091C\u0941\u0932\u093E\u0908_\u0905\u0917\u0938\u094D\u0924_\u0938\u093F\u0924\u0902\u092C\u0930_\u0905\u0915\u094D\u091F\u0942\u092C\u0930_\u0928\u0935\u0902\u092C\u0930_\u0926\u093F\u0938\u0902\u092C\u0930".split("_")
        },
        monthsShort: "\u091C\u0928._\u092B\u093C\u0930._\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u0948._\u092E\u0908_\u091C\u0942\u0928_\u091C\u0941\u0932._\u0905\u0917._\u0938\u093F\u0924._\u0905\u0915\u094D\u091F\u0942._\u0928\u0935._\u0926\u093F\u0938.".split("_"),
        weekdays: "\u0930\u0935\u093F\u0935\u093E\u0930_\u0938\u094B\u092E\u0935\u093E\u0930_\u092E\u0902\u0917\u0932\u0935\u093E\u0930_\u092C\u0941\u0927\u0935\u093E\u0930_\u0917\u0941\u0930\u0942\u0935\u093E\u0930_\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930_\u0936\u0928\u093F\u0935\u093E\u0930".split("_"),
        weekdaysShort: "\u0930\u0935\u093F_\u0938\u094B\u092E_\u092E\u0902\u0917\u0932_\u092C\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094D\u0930_\u0936\u0928\u093F".split("_"),
        weekdaysMin: "\u0930_\u0938\u094B_\u092E\u0902_\u092C\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),
        longDateFormat: {
            LT: "A h:mm \u092C\u091C\u0947",
            LTS: "A h:mm:ss \u092C\u091C\u0947",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u092C\u091C\u0947",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u092C\u091C\u0947"
        },
        monthsParse: monthsParse$7,
        longMonthsParse: monthsParse$7,
        shortMonthsParse: shortMonthsParse,
        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
        calendar: {
            sameDay: "[\u0906\u091C] LT",
            nextDay: "[\u0915\u0932] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0915\u0932] LT",
            lastWeek: "[\u092A\u093F\u091B\u0932\u0947] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u092E\u0947\u0902",
            past: "%s \u092A\u0939\u0932\u0947",
            s: "\u0915\u0941\u091B \u0939\u0940 \u0915\u094D\u0937\u0923",
            ss: "%d \u0938\u0947\u0915\u0902\u0921",
            m: "\u090F\u0915 \u092E\u093F\u0928\u091F",
            mm: "%d \u092E\u093F\u0928\u091F",
            h: "\u090F\u0915 \u0918\u0902\u091F\u093E",
            hh: "%d \u0918\u0902\u091F\u0947",
            d: "\u090F\u0915 \u0926\u093F\u0928",
            dd: "%d \u0926\u093F\u0928",
            M: "\u090F\u0915 \u092E\u0939\u0940\u0928\u0947",
            MM: "%d \u092E\u0939\u0940\u0928\u0947",
            y: "\u090F\u0915 \u0935\u0930\u094D\u0937",
            yy: "%d \u0935\u0930\u094D\u0937"
        },
        preparse: function(string) {
            return string.replace(/[१२३४५६७८९०]/g, function(match) {
                return numberMap$8[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$9[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0930\u093E\u0924") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0938\u0941\u092C\u0939") return hour;
            else if (meridiem === "\u0926\u094B\u092A\u0939\u0930") return hour >= 10 ? hour : hour + 12;
            else if (meridiem === "\u0936\u093E\u092E") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0930\u093E\u0924";
            else if (hour < 10) return "\u0938\u0941\u092C\u0939";
            else if (hour < 17) return "\u0926\u094B\u092A\u0939\u0930";
            else if (hour < 20) return "\u0936\u093E\u092E";
            else return "\u0930\u093E\u0924";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    function translate$3(number, withoutSuffix, key) {
        var result = number + " ";
        switch(key){
            case "ss":
                if (number === 1) result += "sekunda";
                else if (number === 2 || number === 3 || number === 4) result += "sekunde";
                else result += "sekundi";
                return result;
            case "m":
                return withoutSuffix ? "jedna minuta" : "jedne minute";
            case "mm":
                if (number === 1) result += "minuta";
                else if (number === 2 || number === 3 || number === 4) result += "minute";
                else result += "minuta";
                return result;
            case "h":
                return withoutSuffix ? "jedan sat" : "jednog sata";
            case "hh":
                if (number === 1) result += "sat";
                else if (number === 2 || number === 3 || number === 4) result += "sata";
                else result += "sati";
                return result;
            case "dd":
                if (number === 1) result += "dan";
                else result += "dana";
                return result;
            case "MM":
                if (number === 1) result += "mjesec";
                else if (number === 2 || number === 3 || number === 4) result += "mjeseca";
                else result += "mjeseci";
                return result;
            case "yy":
                if (number === 1) result += "godina";
                else if (number === 2 || number === 3 || number === 4) result += "godine";
                else result += "godina";
                return result;
        }
    }
    moment.defineLocale("hr", {
        months: {
            format: "sije\u010Dnja_velja\u010De_o\u017Eujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),
            standalone: "sije\u010Danj_velja\u010Da_o\u017Eujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")
        },
        monthsShort: "sij._velj._o\u017Eu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),
        monthsParseExact: true,
        weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010Detvrtak_petak_subota".split("_"),
        weekdaysShort: "ned._pon._uto._sri._\u010Det._pet._sub.".split("_"),
        weekdaysMin: "ne_po_ut_sr_\u010De_pe_su".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "Do MMMM YYYY",
            LLL: "Do MMMM YYYY H:mm",
            LLLL: "dddd, Do MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[danas u] LT",
            nextDay: "[sutra u] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[u] [nedjelju] [u] LT";
                    case 3:
                        return "[u] [srijedu] [u] LT";
                    case 6:
                        return "[u] [subotu] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[u] dddd [u] LT";
                }
            },
            lastDay: "[ju\u010Der u] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[pro\u0161lu] [nedjelju] [u] LT";
                    case 3:
                        return "[pro\u0161lu] [srijedu] [u] LT";
                    case 6:
                        return "[pro\u0161le] [subote] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[pro\u0161li] dddd [u] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "prije %s",
            s: "par sekundi",
            ss: translate$3,
            m: translate$3,
            mm: translate$3,
            h: translate$3,
            hh: translate$3,
            d: "dan",
            dd: translate$3,
            M: "mjesec",
            MM: translate$3,
            y: "godinu",
            yy: translate$3
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var weekEndings = "vas\xe1rnap h\xe9tf\u0151n kedden szerd\xe1n cs\xfct\xf6rt\xf6k\xf6n p\xe9nteken szombaton".split(" ");
    function translate$4(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch(key){
            case "s":
                return isFuture || withoutSuffix ? "n\xe9h\xe1ny m\xe1sodperc" : "n\xe9h\xe1ny m\xe1sodperce";
            case "ss":
                return num + (isFuture || withoutSuffix) ? " m\xe1sodperc" : " m\xe1sodperce";
            case "m":
                return "egy" + (isFuture || withoutSuffix ? " perc" : " perce");
            case "mm":
                return num + (isFuture || withoutSuffix ? " perc" : " perce");
            case "h":
                return "egy" + (isFuture || withoutSuffix ? " \xf3ra" : " \xf3r\xe1ja");
            case "hh":
                return num + (isFuture || withoutSuffix ? " \xf3ra" : " \xf3r\xe1ja");
            case "d":
                return "egy" + (isFuture || withoutSuffix ? " nap" : " napja");
            case "dd":
                return num + (isFuture || withoutSuffix ? " nap" : " napja");
            case "M":
                return "egy" + (isFuture || withoutSuffix ? " h\xf3nap" : " h\xf3napja");
            case "MM":
                return num + (isFuture || withoutSuffix ? " h\xf3nap" : " h\xf3napja");
            case "y":
                return "egy" + (isFuture || withoutSuffix ? " \xe9v" : " \xe9ve");
            case "yy":
                return num + (isFuture || withoutSuffix ? " \xe9v" : " \xe9ve");
        }
        return "";
    }
    function week(isFuture) {
        return (isFuture ? "" : "[m\xfalt] ") + "[" + weekEndings[this.day()] + "] LT[-kor]";
    }
    moment.defineLocale("hu", {
        months: "janu\xe1r_febru\xe1r_m\xe1rcius_\xe1prilis_m\xe1jus_j\xfanius_j\xfalius_augusztus_szeptember_okt\xf3ber_november_december".split("_"),
        monthsShort: "jan._feb._m\xe1rc._\xe1pr._m\xe1j._j\xfan._j\xfal._aug._szept._okt._nov._dec.".split("_"),
        monthsParseExact: true,
        weekdays: "vas\xe1rnap_h\xe9tf\u0151_kedd_szerda_cs\xfct\xf6rt\xf6k_p\xe9ntek_szombat".split("_"),
        weekdaysShort: "vas_h\xe9t_kedd_sze_cs\xfct_p\xe9n_szo".split("_"),
        weekdaysMin: "v_h_k_sze_cs_p_szo".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "YYYY.MM.DD.",
            LL: "YYYY. MMMM D.",
            LLL: "YYYY. MMMM D. H:mm",
            LLLL: "YYYY. MMMM D., dddd H:mm"
        },
        meridiemParse: /de|du/i,
        isPM: function(input) {
            return input.charAt(1).toLowerCase() === "u";
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 12) return isLower === true ? "de" : "DE";
            else return isLower === true ? "du" : "DU";
        },
        calendar: {
            sameDay: "[ma] LT[-kor]",
            nextDay: "[holnap] LT[-kor]",
            nextWeek: function() {
                return week.call(this, true);
            },
            lastDay: "[tegnap] LT[-kor]",
            lastWeek: function() {
                return week.call(this, false);
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "%s m\xfalva",
            past: "%s",
            s: translate$4,
            ss: translate$4,
            m: translate$4,
            mm: translate$4,
            h: translate$4,
            hh: translate$4,
            d: translate$4,
            dd: translate$4,
            M: translate$4,
            MM: translate$4,
            y: translate$4,
            yy: translate$4
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("hy-am", {
        months: {
            format: "\u0570\u0578\u0582\u0576\u057E\u0561\u0580\u056B_\u0583\u0565\u057F\u0580\u057E\u0561\u0580\u056B_\u0574\u0561\u0580\u057F\u056B_\u0561\u057A\u0580\u056B\u056C\u056B_\u0574\u0561\u0575\u056B\u057D\u056B_\u0570\u0578\u0582\u0576\u056B\u057D\u056B_\u0570\u0578\u0582\u056C\u056B\u057D\u056B_\u0585\u0563\u0578\u057D\u057F\u0578\u057D\u056B_\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580\u056B_\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580\u056B_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580\u056B_\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580\u056B".split("_"),
            standalone: "\u0570\u0578\u0582\u0576\u057E\u0561\u0580_\u0583\u0565\u057F\u0580\u057E\u0561\u0580_\u0574\u0561\u0580\u057F_\u0561\u057A\u0580\u056B\u056C_\u0574\u0561\u0575\u056B\u057D_\u0570\u0578\u0582\u0576\u056B\u057D_\u0570\u0578\u0582\u056C\u056B\u057D_\u0585\u0563\u0578\u057D\u057F\u0578\u057D_\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580_\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580_\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580".split("_")
        },
        monthsShort: "\u0570\u0576\u057E_\u0583\u057F\u0580_\u0574\u0580\u057F_\u0561\u057A\u0580_\u0574\u0575\u057D_\u0570\u0576\u057D_\u0570\u056C\u057D_\u0585\u0563\u057D_\u057D\u057A\u057F_\u0570\u056F\u057F_\u0576\u0574\u0562_\u0564\u056F\u057F".split("_"),
        weekdays: "\u056F\u056B\u0580\u0561\u056F\u056B_\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B_\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B_\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B_\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B_\u0578\u0582\u0580\u0562\u0561\u0569_\u0577\u0561\u0562\u0561\u0569".split("_"),
        weekdaysShort: "\u056F\u0580\u056F_\u0565\u0580\u056F_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),
        weekdaysMin: "\u056F\u0580\u056F_\u0565\u0580\u056F_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0569.",
            LLL: "D MMMM YYYY \u0569., HH:mm",
            LLLL: "dddd, D MMMM YYYY \u0569., HH:mm"
        },
        calendar: {
            sameDay: "[\u0561\u0575\u057D\u0585\u0580] LT",
            nextDay: "[\u057E\u0561\u0572\u0568] LT",
            lastDay: "[\u0565\u0580\u0565\u056F] LT",
            nextWeek: function() {
                return "dddd [\u0585\u0580\u0568 \u056A\u0561\u0574\u0568] LT";
            },
            lastWeek: function() {
                return "[\u0561\u0576\u0581\u0561\u056E] dddd [\u0585\u0580\u0568 \u056A\u0561\u0574\u0568] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0570\u0565\u057F\u0578",
            past: "%s \u0561\u057C\u0561\u057B",
            s: "\u0574\u056B \u0584\u0561\u0576\u056B \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
            ss: "%d \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
            m: "\u0580\u0578\u057A\u0565",
            mm: "%d \u0580\u0578\u057A\u0565",
            h: "\u056A\u0561\u0574",
            hh: "%d \u056A\u0561\u0574",
            d: "\u0585\u0580",
            dd: "%d \u0585\u0580",
            M: "\u0561\u0574\u056B\u057D",
            MM: "%d \u0561\u0574\u056B\u057D",
            y: "\u057F\u0561\u0580\u056B",
            yy: "%d \u057F\u0561\u0580\u056B"
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function(input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function(hour) {
            if (hour < 4) return "\u0563\u056B\u0577\u0565\u0580\u057E\u0561";
            else if (hour < 12) return "\u0561\u057C\u0561\u057E\u0578\u057F\u057E\u0561";
            else if (hour < 17) return "\u0581\u0565\u0580\u0565\u056F\u057E\u0561";
            else return "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576";
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function(number, period) {
            switch(period){
                case "DDD":
                case "w":
                case "W":
                case "DDDo":
                    if (number === 1) return number + "-\u056B\u0576";
                    return number + "-\u0580\u0564";
                default:
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("id", {
        months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),
        weekdays: "Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),
        weekdaysShort: "Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),
        weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),
        longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [pukul] HH.mm",
            LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "pagi") return hour;
            else if (meridiem === "siang") return hour >= 11 ? hour : hour + 12;
            else if (meridiem === "sore" || meridiem === "malam") return hour + 12;
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 11) return "pagi";
            else if (hours < 15) return "siang";
            else if (hours < 19) return "sore";
            else return "malam";
        },
        calendar: {
            sameDay: "[Hari ini pukul] LT",
            nextDay: "[Besok pukul] LT",
            nextWeek: "dddd [pukul] LT",
            lastDay: "[Kemarin pukul] LT",
            lastWeek: "dddd [lalu pukul] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dalam %s",
            past: "%s yang lalu",
            s: "beberapa detik",
            ss: "%d detik",
            m: "semenit",
            mm: "%d menit",
            h: "sejam",
            hh: "%d jam",
            d: "sehari",
            dd: "%d hari",
            M: "sebulan",
            MM: "%d bulan",
            y: "setahun",
            yy: "%d tahun"
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    function plural$2(n) {
        if (n % 100 === 11) return true;
        else if (n % 10 === 1) return false;
        return true;
    }
    function translate$5(number, withoutSuffix, key, isFuture) {
        var result = number + " ";
        switch(key){
            case "s":
                return withoutSuffix || isFuture ? "nokkrar sek\xfandur" : "nokkrum sek\xfandum";
            case "ss":
                if (plural$2(number)) return result + (withoutSuffix || isFuture ? "sek\xfandur" : "sek\xfandum");
                return result + "sek\xfanda";
            case "m":
                return withoutSuffix ? "m\xedn\xfata" : "m\xedn\xfatu";
            case "mm":
                if (plural$2(number)) return result + (withoutSuffix || isFuture ? "m\xedn\xfatur" : "m\xedn\xfatum");
                else if (withoutSuffix) return result + "m\xedn\xfata";
                return result + "m\xedn\xfatu";
            case "hh":
                if (plural$2(number)) return result + (withoutSuffix || isFuture ? "klukkustundir" : "klukkustundum");
                return result + "klukkustund";
            case "d":
                if (withoutSuffix) return "dagur";
                return isFuture ? "dag" : "degi";
            case "dd":
                if (plural$2(number)) {
                    if (withoutSuffix) return result + "dagar";
                    return result + (isFuture ? "daga" : "d\xf6gum");
                } else if (withoutSuffix) return result + "dagur";
                return result + (isFuture ? "dag" : "degi");
            case "M":
                if (withoutSuffix) return "m\xe1nu\xf0ur";
                return isFuture ? "m\xe1nu\xf0" : "m\xe1nu\xf0i";
            case "MM":
                if (plural$2(number)) {
                    if (withoutSuffix) return result + "m\xe1nu\xf0ir";
                    return result + (isFuture ? "m\xe1nu\xf0i" : "m\xe1nu\xf0um");
                } else if (withoutSuffix) return result + "m\xe1nu\xf0ur";
                return result + (isFuture ? "m\xe1nu\xf0" : "m\xe1nu\xf0i");
            case "y":
                return withoutSuffix || isFuture ? "\xe1r" : "\xe1ri";
            case "yy":
                if (plural$2(number)) return result + (withoutSuffix || isFuture ? "\xe1r" : "\xe1rum");
                return result + (withoutSuffix || isFuture ? "\xe1r" : "\xe1ri");
        }
    }
    moment.defineLocale("is", {
        months: "jan\xfaar_febr\xfaar_mars_apr\xedl_ma\xed_j\xfan\xed_j\xfal\xed_\xe1g\xfast_september_okt\xf3ber_n\xf3vember_desember".split("_"),
        monthsShort: "jan_feb_mar_apr_ma\xed_j\xfan_j\xfal_\xe1g\xfa_sep_okt_n\xf3v_des".split("_"),
        weekdays: "sunnudagur_m\xe1nudagur_\xferi\xf0judagur_mi\xf0vikudagur_fimmtudagur_f\xf6studagur_laugardagur".split("_"),
        weekdaysShort: "sun_m\xe1n_\xferi_mi\xf0_fim_f\xf6s_lau".split("_"),
        weekdaysMin: "Su_M\xe1_\xder_Mi_Fi_F\xf6_La".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY [kl.] H:mm",
            LLLL: "dddd, D. MMMM YYYY [kl.] H:mm"
        },
        calendar: {
            sameDay: "[\xed dag kl.] LT",
            nextDay: "[\xe1 morgun kl.] LT",
            nextWeek: "dddd [kl.] LT",
            lastDay: "[\xed g\xe6r kl.] LT",
            lastWeek: "[s\xed\xf0asta] dddd [kl.] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "eftir %s",
            past: "fyrir %s s\xed\xf0an",
            s: translate$5,
            ss: translate$5,
            m: translate$5,
            mm: translate$5,
            h: "klukkustund",
            hh: translate$5,
            d: translate$5,
            dd: translate$5,
            M: translate$5,
            MM: translate$5,
            y: translate$5,
            yy: translate$5
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("it-ch", {
        months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
        monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
        weekdays: "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),
        weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
        weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Oggi alle] LT",
            nextDay: "[Domani alle] LT",
            nextWeek: "dddd [alle] LT",
            lastDay: "[Ieri alle] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[la scorsa] dddd [alle] LT";
                    default:
                        return "[lo scorso] dddd [alle] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: function(s) {
                return (/^[0-9].+$/.test(s) ? "tra" : "in") + " " + s;
            },
            past: "%s fa",
            s: "alcuni secondi",
            ss: "%d secondi",
            m: "un minuto",
            mm: "%d minuti",
            h: "un'ora",
            hh: "%d ore",
            d: "un giorno",
            dd: "%d giorni",
            M: "un mese",
            MM: "%d mesi",
            y: "un anno",
            yy: "%d anni"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("it", {
        months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
        monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
        weekdays: "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),
        weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
        weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: function() {
                return "[Oggi a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
            },
            nextDay: function() {
                return "[Domani a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
            },
            nextWeek: function() {
                return "dddd [a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
            },
            lastDay: function() {
                return "[Ieri a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
            },
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[La scorsa] dddd [a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
                    default:
                        return "[Lo scorso] dddd [a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "tra %s",
            past: "%s fa",
            s: "alcuni secondi",
            ss: "%d secondi",
            m: "un minuto",
            mm: "%d minuti",
            h: "un'ora",
            hh: "%d ore",
            d: "un giorno",
            dd: "%d giorni",
            w: "una settimana",
            ww: "%d settimane",
            M: "un mese",
            MM: "%d mesi",
            y: "un anno",
            yy: "%d anni"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("ja", {
        eras: [
            {
                since: "2019-05-01",
                offset: 1,
                name: "\u4EE4\u548C",
                narrow: "\u32FF",
                abbr: "R"
            },
            {
                since: "1989-01-08",
                until: "2019-04-30",
                offset: 1,
                name: "\u5E73\u6210",
                narrow: "\u337B",
                abbr: "H"
            },
            {
                since: "1926-12-25",
                until: "1989-01-07",
                offset: 1,
                name: "\u662D\u548C",
                narrow: "\u337C",
                abbr: "S"
            },
            {
                since: "1912-07-30",
                until: "1926-12-24",
                offset: 1,
                name: "\u5927\u6B63",
                narrow: "\u337D",
                abbr: "T"
            },
            {
                since: "1873-01-01",
                until: "1912-07-29",
                offset: 6,
                name: "\u660E\u6CBB",
                narrow: "\u337E",
                abbr: "M"
            },
            {
                since: "0001-01-01",
                until: "1873-12-31",
                offset: 1,
                name: "\u897F\u66A6",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "\u7D00\u5143\u524D",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function(input, match) {
            return match[1] === "\u5143" ? 1 : parseInt(match[1] || input, 10);
        },
        months: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
        weekdays: "\u65E5\u66DC\u65E5_\u6708\u66DC\u65E5_\u706B\u66DC\u65E5_\u6C34\u66DC\u65E5_\u6728\u66DC\u65E5_\u91D1\u66DC\u65E5_\u571F\u66DC\u65E5".split("_"),
        weekdaysShort: "\u65E5_\u6708_\u706B_\u6C34_\u6728_\u91D1_\u571F".split("_"),
        weekdaysMin: "\u65E5_\u6708_\u706B_\u6C34_\u6728_\u91D1_\u571F".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY\u5E74M\u6708D\u65E5",
            LLL: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            LLLL: "YYYY\u5E74M\u6708D\u65E5 dddd HH:mm",
            l: "YYYY/MM/DD",
            ll: "YYYY\u5E74M\u6708D\u65E5",
            lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            llll: "YYYY\u5E74M\u6708D\u65E5(ddd) HH:mm"
        },
        meridiemParse: /午前|午後/i,
        isPM: function(input) {
            return input === "\u5348\u5F8C";
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u5348\u524D";
            else return "\u5348\u5F8C";
        },
        calendar: {
            sameDay: "[\u4ECA\u65E5] LT",
            nextDay: "[\u660E\u65E5] LT",
            nextWeek: function(now) {
                if (now.week() !== this.week()) return "[\u6765\u9031]dddd LT";
                else return "dddd LT";
            },
            lastDay: "[\u6628\u65E5] LT",
            lastWeek: function(now) {
                if (this.week() !== now.week()) return "[\u5148\u9031]dddd LT";
                else return "dddd LT";
            },
            sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function(number, period) {
            switch(period){
                case "y":
                    return number === 1 ? "\u5143\u5E74" : number + "\u5E74";
                case "d":
                case "D":
                case "DDD":
                    return number + "\u65E5";
                default:
                    return number;
            }
        },
        relativeTime: {
            future: "%s\u5F8C",
            past: "%s\u524D",
            s: "\u6570\u79D2",
            ss: "%d\u79D2",
            m: "1\u5206",
            mm: "%d\u5206",
            h: "1\u6642\u9593",
            hh: "%d\u6642\u9593",
            d: "1\u65E5",
            dd: "%d\u65E5",
            M: "1\u30F6\u6708",
            MM: "%d\u30F6\u6708",
            y: "1\u5E74",
            yy: "%d\u5E74"
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("jv", {
        months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),
        weekdays: "Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),
        weekdaysShort: "Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),
        weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),
        longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [pukul] HH.mm",
            LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "enjing") return hour;
            else if (meridiem === "siyang") return hour >= 11 ? hour : hour + 12;
            else if (meridiem === "sonten" || meridiem === "ndalu") return hour + 12;
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 11) return "enjing";
            else if (hours < 15) return "siyang";
            else if (hours < 19) return "sonten";
            else return "ndalu";
        },
        calendar: {
            sameDay: "[Dinten puniko pukul] LT",
            nextDay: "[Mbenjang pukul] LT",
            nextWeek: "dddd [pukul] LT",
            lastDay: "[Kala wingi pukul] LT",
            lastWeek: "dddd [kepengker pukul] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "wonten ing %s",
            past: "%s ingkang kepengker",
            s: "sawetawis detik",
            ss: "%d detik",
            m: "setunggal menit",
            mm: "%d menit",
            h: "setunggal jam",
            hh: "%d jam",
            d: "sedinten",
            dd: "%d dinten",
            M: "sewulan",
            MM: "%d wulan",
            y: "setaun",
            yy: "%d taun"
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("ka", {
        months: "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8_\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8_\u10DB\u10D0\u10E0\u10E2\u10D8_\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8_\u10DB\u10D0\u10D8\u10E1\u10D8_\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8_\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8_\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD_\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8_\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8_\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8_\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8".split("_"),
        monthsShort: "\u10D8\u10D0\u10DC_\u10D7\u10D4\u10D1_\u10DB\u10D0\u10E0_\u10D0\u10DE\u10E0_\u10DB\u10D0\u10D8_\u10D8\u10D5\u10DC_\u10D8\u10D5\u10DA_\u10D0\u10D2\u10D5_\u10E1\u10D4\u10E5_\u10DD\u10E5\u10E2_\u10DC\u10DD\u10D4_\u10D3\u10D4\u10D9".split("_"),
        weekdays: {
            standalone: "\u10D9\u10D5\u10D8\u10E0\u10D0_\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8_\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8_\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8_\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8_\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8_\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8".split("_"),
            format: "\u10D9\u10D5\u10D8\u10E0\u10D0\u10E1_\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1_\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1_\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1_\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1_\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10E1_\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1".split("_"),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort: "\u10D9\u10D5\u10D8_\u10DD\u10E0\u10E8_\u10E1\u10D0\u10DB_\u10DD\u10D7\u10EE_\u10EE\u10E3\u10D7_\u10DE\u10D0\u10E0_\u10E8\u10D0\u10D1".split("_"),
        weekdaysMin: "\u10D9\u10D5_\u10DD\u10E0_\u10E1\u10D0_\u10DD\u10D7_\u10EE\u10E3_\u10DE\u10D0_\u10E8\u10D0".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u10D3\u10E6\u10D4\u10E1] LT[-\u10D6\u10D4]",
            nextDay: "[\u10EE\u10D5\u10D0\u10DA] LT[-\u10D6\u10D4]",
            lastDay: "[\u10D2\u10E3\u10E8\u10D8\u10DC] LT[-\u10D6\u10D4]",
            nextWeek: "[\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2] dddd LT[-\u10D6\u10D4]",
            lastWeek: "[\u10EC\u10D8\u10DC\u10D0] dddd LT-\u10D6\u10D4",
            sameElse: "L"
        },
        relativeTime: {
            future: function(s) {
                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function($0, $1, $2) {
                    return $2 === "\u10D8" ? $1 + "\u10E8\u10D8" : $1 + $2 + "\u10E8\u10D8";
                });
            },
            past: function(s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) return s.replace(/(ი|ე)$/, "\u10D8\u10E1 \u10EC\u10D8\u10DC");
                if (/წელი/.test(s)) return s.replace(/წელი$/, "\u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC");
                return s;
            },
            s: "\u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10EC\u10D0\u10DB\u10D8",
            ss: "%d \u10EC\u10D0\u10DB\u10D8",
            m: "\u10EC\u10E3\u10D7\u10D8",
            mm: "%d \u10EC\u10E3\u10D7\u10D8",
            h: "\u10E1\u10D0\u10D0\u10D7\u10D8",
            hh: "%d \u10E1\u10D0\u10D0\u10D7\u10D8",
            d: "\u10D3\u10E6\u10D4",
            dd: "%d \u10D3\u10E6\u10D4",
            M: "\u10D7\u10D5\u10D4",
            MM: "%d \u10D7\u10D5\u10D4",
            y: "\u10EC\u10D4\u10DA\u10D8",
            yy: "%d \u10EC\u10D4\u10DA\u10D8"
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function(number) {
            if (number === 0) return number;
            if (number === 1) return number + "-\u10DA\u10D8";
            if (number < 20 || number <= 100 && number % 20 === 0 || number % 100 === 0) return "\u10DB\u10D4-" + number;
            return number + "-\u10D4";
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var suffixes$1 = {
        0: "-\u0448\u0456",
        1: "-\u0448\u0456",
        2: "-\u0448\u0456",
        3: "-\u0448\u0456",
        4: "-\u0448\u0456",
        5: "-\u0448\u0456",
        6: "-\u0448\u044B",
        7: "-\u0448\u0456",
        8: "-\u0448\u0456",
        9: "-\u0448\u044B",
        10: "-\u0448\u044B",
        20: "-\u0448\u044B",
        30: "-\u0448\u044B",
        40: "-\u0448\u044B",
        50: "-\u0448\u0456",
        60: "-\u0448\u044B",
        70: "-\u0448\u0456",
        80: "-\u0448\u0456",
        90: "-\u0448\u044B",
        100: "-\u0448\u0456"
    };
    moment.defineLocale("kk", {
        months: "\u049B\u0430\u04A3\u0442\u0430\u0440_\u0430\u049B\u043F\u0430\u043D_\u043D\u0430\u0443\u0440\u044B\u0437_\u0441\u04D9\u0443\u0456\u0440_\u043C\u0430\u043C\u044B\u0440_\u043C\u0430\u0443\u0441\u044B\u043C_\u0448\u0456\u043B\u0434\u0435_\u0442\u0430\u043C\u044B\u0437_\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A_\u049B\u0430\u0437\u0430\u043D_\u049B\u0430\u0440\u0430\u0448\u0430_\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D".split("_"),
        monthsShort: "\u049B\u0430\u04A3_\u0430\u049B\u043F_\u043D\u0430\u0443_\u0441\u04D9\u0443_\u043C\u0430\u043C_\u043C\u0430\u0443_\u0448\u0456\u043B_\u0442\u0430\u043C_\u049B\u044B\u0440_\u049B\u0430\u0437_\u049B\u0430\u0440_\u0436\u0435\u043B".split("_"),
        weekdays: "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456_\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456_\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456_\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456_\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456_\u0436\u04B1\u043C\u0430_\u0441\u0435\u043D\u0431\u0456".split("_"),
        weekdaysShort: "\u0436\u0435\u043A_\u0434\u04AF\u0439_\u0441\u0435\u0439_\u0441\u04D9\u0440_\u0431\u0435\u0439_\u0436\u04B1\u043C_\u0441\u0435\u043D".split("_"),
        weekdaysMin: "\u0436\u043A_\u0434\u0439_\u0441\u0439_\u0441\u0440_\u0431\u0439_\u0436\u043C_\u0441\u043D".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u0411\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442] LT",
            nextDay: "[\u0415\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442] LT",
            nextWeek: "dddd [\u0441\u0430\u0493\u0430\u0442] LT",
            lastDay: "[\u041A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442] LT",
            lastWeek: "[\u04E8\u0442\u043A\u0435\u043D \u0430\u043F\u0442\u0430\u043D\u044B\u04A3] dddd [\u0441\u0430\u0493\u0430\u0442] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0456\u0448\u0456\u043D\u0434\u0435",
            past: "%s \u0431\u04B1\u0440\u044B\u043D",
            s: "\u0431\u0456\u0440\u043D\u0435\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434",
            ss: "%d \u0441\u0435\u043A\u0443\u043D\u0434",
            m: "\u0431\u0456\u0440 \u043C\u0438\u043D\u0443\u0442",
            mm: "%d \u043C\u0438\u043D\u0443\u0442",
            h: "\u0431\u0456\u0440 \u0441\u0430\u0493\u0430\u0442",
            hh: "%d \u0441\u0430\u0493\u0430\u0442",
            d: "\u0431\u0456\u0440 \u043A\u04AF\u043D",
            dd: "%d \u043A\u04AF\u043D",
            M: "\u0431\u0456\u0440 \u0430\u0439",
            MM: "%d \u0430\u0439",
            y: "\u0431\u0456\u0440 \u0436\u044B\u043B",
            yy: "%d \u0436\u044B\u043B"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function(number) {
            var a = number % 10, b = number >= 100 ? 100 : null;
            return number + (suffixes$1[number] || suffixes$1[a] || suffixes$1[b]);
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var symbolMap$a = {
        1: "\u17E1",
        2: "\u17E2",
        3: "\u17E3",
        4: "\u17E4",
        5: "\u17E5",
        6: "\u17E6",
        7: "\u17E7",
        8: "\u17E8",
        9: "\u17E9",
        0: "\u17E0"
    }, numberMap$9 = {
        "\u17E1": "1",
        "\u17E2": "2",
        "\u17E3": "3",
        "\u17E4": "4",
        "\u17E5": "5",
        "\u17E6": "6",
        "\u17E7": "7",
        "\u17E8": "8",
        "\u17E9": "9",
        "\u17E0": "0"
    };
    moment.defineLocale("km", {
        months: "\u1798\u1780\u179A\u17B6_\u1780\u17BB\u1798\u17D2\u1797\u17C8_\u1798\u17B8\u1793\u17B6_\u1798\u17C1\u179F\u17B6_\u17A7\u179F\u1797\u17B6_\u1798\u17B7\u1790\u17BB\u1793\u17B6_\u1780\u1780\u17D2\u1780\u178A\u17B6_\u179F\u17B8\u17A0\u17B6_\u1780\u1789\u17D2\u1789\u17B6_\u178F\u17BB\u179B\u17B6_\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6_\u1792\u17D2\u1793\u17BC".split("_"),
        monthsShort: "\u1798\u1780\u179A\u17B6_\u1780\u17BB\u1798\u17D2\u1797\u17C8_\u1798\u17B8\u1793\u17B6_\u1798\u17C1\u179F\u17B6_\u17A7\u179F\u1797\u17B6_\u1798\u17B7\u1790\u17BB\u1793\u17B6_\u1780\u1780\u17D2\u1780\u178A\u17B6_\u179F\u17B8\u17A0\u17B6_\u1780\u1789\u17D2\u1789\u17B6_\u178F\u17BB\u179B\u17B6_\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6_\u1792\u17D2\u1793\u17BC".split("_"),
        weekdays: "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799_\u1785\u17D0\u1793\u17D2\u1791_\u17A2\u1784\u17D2\u1782\u17B6\u179A_\u1796\u17BB\u1792_\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD_\u179F\u17BB\u1780\u17D2\u179A_\u179F\u17C5\u179A\u17CD".split("_"),
        weekdaysShort: "\u17A2\u17B6_\u1785_\u17A2_\u1796_\u1796\u17D2\u179A_\u179F\u17BB_\u179F".split("_"),
        weekdaysMin: "\u17A2\u17B6_\u1785_\u17A2_\u1796_\u1796\u17D2\u179A_\u179F\u17BB_\u179F".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function(input) {
            return input === "\u179B\u17D2\u1784\u17B6\u1785";
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u1796\u17D2\u179A\u17B9\u1780";
            else return "\u179B\u17D2\u1784\u17B6\u1785";
        },
        calendar: {
            sameDay: "[\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7 \u1798\u17C9\u17C4\u1784] LT",
            nextDay: "[\u179F\u17D2\u17A2\u17C2\u1780 \u1798\u17C9\u17C4\u1784] LT",
            nextWeek: "dddd [\u1798\u17C9\u17C4\u1784] LT",
            lastDay: "[\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789 \u1798\u17C9\u17C4\u1784] LT",
            lastWeek: "dddd [\u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD\u1798\u17BB\u1793] [\u1798\u17C9\u17C4\u1784] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s\u1791\u17C0\u178F",
            past: "%s\u1798\u17BB\u1793",
            s: "\u1794\u17C9\u17BB\u1793\u17D2\u1798\u17B6\u1793\u179C\u17B7\u1793\u17B6\u1791\u17B8",
            ss: "%d \u179C\u17B7\u1793\u17B6\u1791\u17B8",
            m: "\u1798\u17BD\u1799\u1793\u17B6\u1791\u17B8",
            mm: "%d \u1793\u17B6\u1791\u17B8",
            h: "\u1798\u17BD\u1799\u1798\u17C9\u17C4\u1784",
            hh: "%d \u1798\u17C9\u17C4\u1784",
            d: "\u1798\u17BD\u1799\u1790\u17D2\u1784\u17C3",
            dd: "%d \u1790\u17D2\u1784\u17C3",
            M: "\u1798\u17BD\u1799\u1781\u17C2",
            MM: "%d \u1781\u17C2",
            y: "\u1798\u17BD\u1799\u1786\u17D2\u1793\u17B6\u17C6",
            yy: "%d \u1786\u17D2\u1793\u17B6\u17C6"
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: "\u1791\u17B8%d",
        preparse: function(string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function(match) {
                return numberMap$9[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$a[match];
            });
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$b = {
        1: "\u0CE7",
        2: "\u0CE8",
        3: "\u0CE9",
        4: "\u0CEA",
        5: "\u0CEB",
        6: "\u0CEC",
        7: "\u0CED",
        8: "\u0CEE",
        9: "\u0CEF",
        0: "\u0CE6"
    }, numberMap$a = {
        "\u0CE7": "1",
        "\u0CE8": "2",
        "\u0CE9": "3",
        "\u0CEA": "4",
        "\u0CEB": "5",
        "\u0CEC": "6",
        "\u0CED": "7",
        "\u0CEE": "8",
        "\u0CEF": "9",
        "\u0CE6": "0"
    };
    moment.defineLocale("kn", {
        months: "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF_\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF_\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD_\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD_\u0CAE\u0CC6\u0CD5_\u0C9C\u0CC2\u0CA8\u0CCD_\u0C9C\u0CC1\u0CB2\u0CC6\u0CD6_\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD_\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD_\u0C85\u0C95\u0CCD\u0C9F\u0CC6\u0CC2\u0CD5\u0CAC\u0CB0\u0CCD_\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD_\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD".split("_"),
        monthsShort: "\u0C9C\u0CA8_\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0_\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD_\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD_\u0CAE\u0CC6\u0CD5_\u0C9C\u0CC2\u0CA8\u0CCD_\u0C9C\u0CC1\u0CB2\u0CC6\u0CD6_\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD_\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82_\u0C85\u0C95\u0CCD\u0C9F\u0CC6\u0CC2\u0CD5_\u0CA8\u0CB5\u0CC6\u0C82_\u0CA1\u0CBF\u0CB8\u0CC6\u0C82".split("_"),
        monthsParseExact: true,
        weekdays: "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0_\u0CB8\u0CC6\u0CC2\u0CD5\u0CAE\u0CB5\u0CBE\u0CB0_\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0_\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0_\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0_\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0_\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0".split("_"),
        weekdaysShort: "\u0CAD\u0CBE\u0CA8\u0CC1_\u0CB8\u0CC6\u0CC2\u0CD5\u0CAE_\u0CAE\u0C82\u0C97\u0CB3_\u0CAC\u0CC1\u0CA7_\u0C97\u0CC1\u0CB0\u0CC1_\u0CB6\u0CC1\u0C95\u0CCD\u0CB0_\u0CB6\u0CA8\u0CBF".split("_"),
        weekdaysMin: "\u0CAD\u0CBE_\u0CB8\u0CC6\u0CC2\u0CD5_\u0CAE\u0C82_\u0CAC\u0CC1_\u0C97\u0CC1_\u0CB6\u0CC1_\u0CB6".split("_"),
        longDateFormat: {
            LT: "A h:mm",
            LTS: "A h:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm",
            LLLL: "dddd, D MMMM YYYY, A h:mm"
        },
        calendar: {
            sameDay: "[\u0C87\u0C82\u0CA6\u0CC1] LT",
            nextDay: "[\u0CA8\u0CBE\u0CB3\u0CC6] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6] LT",
            lastWeek: "[\u0C95\u0CC6\u0CC2\u0CA8\u0CC6\u0CAF] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0CA8\u0C82\u0CA4\u0CB0",
            past: "%s \u0CB9\u0CBF\u0C82\u0CA6\u0CC6",
            s: "\u0C95\u0CC6\u0CB2\u0CB5\u0CC1 \u0C95\u0CCD\u0CB7\u0CA3\u0C97\u0CB3\u0CC1",
            ss: "%d \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            m: "\u0C92\u0C82\u0CA6\u0CC1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            mm: "%d \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            h: "\u0C92\u0C82\u0CA6\u0CC1 \u0C97\u0C82\u0C9F\u0CC6",
            hh: "%d \u0C97\u0C82\u0C9F\u0CC6",
            d: "\u0C92\u0C82\u0CA6\u0CC1 \u0CA6\u0CBF\u0CA8",
            dd: "%d \u0CA6\u0CBF\u0CA8",
            M: "\u0C92\u0C82\u0CA6\u0CC1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            MM: "%d \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            y: "\u0C92\u0C82\u0CA6\u0CC1 \u0CB5\u0CB0\u0CCD\u0CB7",
            yy: "%d \u0CB5\u0CB0\u0CCD\u0CB7"
        },
        preparse: function(string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function(match) {
                return numberMap$a[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$b[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0CAC\u0CC6\u0CB3\u0CBF\u0C97\u0CCD\u0C97\u0CC6") return hour;
            else if (meridiem === "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8") return hour >= 10 ? hour : hour + 12;
            else if (meridiem === "\u0CB8\u0C82\u0C9C\u0CC6") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF";
            else if (hour < 10) return "\u0CAC\u0CC6\u0CB3\u0CBF\u0C97\u0CCD\u0C97\u0CC6";
            else if (hour < 17) return "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8";
            else if (hour < 20) return "\u0CB8\u0C82\u0C9C\u0CC6";
            else return "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF";
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function(number) {
            return number + "\u0CA8\u0CC6\u0CD5";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("ko", {
        months: "1\uC6D4_2\uC6D4_3\uC6D4_4\uC6D4_5\uC6D4_6\uC6D4_7\uC6D4_8\uC6D4_9\uC6D4_10\uC6D4_11\uC6D4_12\uC6D4".split("_"),
        monthsShort: "1\uC6D4_2\uC6D4_3\uC6D4_4\uC6D4_5\uC6D4_6\uC6D4_7\uC6D4_8\uC6D4_9\uC6D4_10\uC6D4_11\uC6D4_12\uC6D4".split("_"),
        weekdays: "\uC77C\uC694\uC77C_\uC6D4\uC694\uC77C_\uD654\uC694\uC77C_\uC218\uC694\uC77C_\uBAA9\uC694\uC77C_\uAE08\uC694\uC77C_\uD1A0\uC694\uC77C".split("_"),
        weekdaysShort: "\uC77C_\uC6D4_\uD654_\uC218_\uBAA9_\uAE08_\uD1A0".split("_"),
        weekdaysMin: "\uC77C_\uC6D4_\uD654_\uC218_\uBAA9_\uAE08_\uD1A0".split("_"),
        longDateFormat: {
            LT: "A h:mm",
            LTS: "A h:mm:ss",
            L: "YYYY.MM.DD.",
            LL: "YYYY\uB144 MMMM D\uC77C",
            LLL: "YYYY\uB144 MMMM D\uC77C A h:mm",
            LLLL: "YYYY\uB144 MMMM D\uC77C dddd A h:mm",
            l: "YYYY.MM.DD.",
            ll: "YYYY\uB144 MMMM D\uC77C",
            lll: "YYYY\uB144 MMMM D\uC77C A h:mm",
            llll: "YYYY\uB144 MMMM D\uC77C dddd A h:mm"
        },
        calendar: {
            sameDay: "\uC624\uB298 LT",
            nextDay: "\uB0B4\uC77C LT",
            nextWeek: "dddd LT",
            lastDay: "\uC5B4\uC81C LT",
            lastWeek: "\uC9C0\uB09C\uC8FC dddd LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \uD6C4",
            past: "%s \uC804",
            s: "\uBA87 \uCD08",
            ss: "%d\uCD08",
            m: "1\uBD84",
            mm: "%d\uBD84",
            h: "\uD55C \uC2DC\uAC04",
            hh: "%d\uC2DC\uAC04",
            d: "\uD558\uB8E8",
            dd: "%d\uC77C",
            M: "\uD55C \uB2EC",
            MM: "%d\uB2EC",
            y: "\uC77C \uB144",
            yy: "%d\uB144"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function(number, period) {
            switch(period){
                case "d":
                case "D":
                case "DDD":
                    return number + "\uC77C";
                case "M":
                    return number + "\uC6D4";
                case "w":
                case "W":
                    return number + "\uC8FC";
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function(token) {
            return token === "\uC624\uD6C4";
        },
        meridiem: function(hour, minute, isUpper) {
            return hour < 12 ? "\uC624\uC804" : "\uC624\uD6C4";
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$7(num, withoutSuffix, key, isFuture) {
        var format = {
            s: [
                "\xe7end san\xeeye",
                "\xe7end san\xeeyeyan"
            ],
            ss: [
                num + " san\xeeye",
                num + " san\xeeyeyan"
            ],
            m: [
                "deq\xeeqeyek",
                "deq\xeeqeyek\xea"
            ],
            mm: [
                num + " deq\xeeqe",
                num + " deq\xeeqeyan"
            ],
            h: [
                "saetek",
                "saetek\xea"
            ],
            hh: [
                num + " saet",
                num + " saetan"
            ],
            d: [
                "rojek",
                "rojek\xea"
            ],
            dd: [
                num + " roj",
                num + " rojan"
            ],
            w: [
                "hefteyek",
                "hefteyek\xea"
            ],
            ww: [
                num + " hefte",
                num + " hefteyan"
            ],
            M: [
                "mehek",
                "mehek\xea"
            ],
            MM: [
                num + " meh",
                num + " mehan"
            ],
            y: [
                "salek",
                "salek\xea"
            ],
            yy: [
                num + " sal",
                num + " salan"
            ]
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    // function obliqueNumSuffix(num) {
    //     if(num.includes(':'))
    //         num = parseInt(num.split(':')[0]);
    //     else
    //         num = parseInt(num);
    //     return num == 0 || num % 10 == 1 ? 'ê'
    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
    // }
    function ezafeNumSuffix(num) {
        num = "" + num;
        var l = num.substring(num.length - 1), ll = num.length > 1 ? num.substring(num.length - 2) : "";
        if (!(ll == 12 || ll == 13) && (l == "2" || l == "3" || ll == "50" || l == "70" || l == "80")) return "y\xea";
        return "\xea";
    }
    moment.defineLocale("ku-kmr", {
        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
        // But the names below are more well known and handy
        months: "R\xeabendan_Sibat_Adar_N\xeesan_Gulan_Hez\xeeran_T\xeermeh_Tebax_\xcelon_Cotmeh_Mijdar_Berfanbar".split("_"),
        monthsShort: "R\xeab_Sib_Ada_N\xees_Gul_Hez_T\xeer_Teb_\xcelo_Cot_Mij_Ber".split("_"),
        monthsParseExact: true,
        weekdays: "Yek\u015Fem_Du\u015Fem_S\xea\u015Fem_\xc7ar\u015Fem_P\xeanc\u015Fem_\xcen_\u015Eem\xee".split("_"),
        weekdaysShort: "Yek_Du_S\xea_\xc7ar_P\xean_\xcen_\u015Eem".split("_"),
        weekdaysMin: "Ye_Du_S\xea_\xc7a_P\xea_\xcen_\u015Ee".split("_"),
        meridiem: function(hours, minutes, isLower) {
            if (hours < 12) return isLower ? "bn" : "BN";
            else return isLower ? "pn" : "PN";
        },
        meridiemParse: /bn|BN|pn|PN/,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "Do MMMM[a] YYYY[an]",
            LLL: "Do MMMM[a] YYYY[an] HH:mm",
            LLLL: "dddd, Do MMMM[a] YYYY[an] HH:mm",
            ll: "Do MMM[.] YYYY[an]",
            lll: "Do MMM[.] YYYY[an] HH:mm",
            llll: "ddd[.], Do MMM[.] YYYY[an] HH:mm"
        },
        calendar: {
            sameDay: "[\xcero di saet] LT [de]",
            nextDay: "[Sib\xea di saet] LT [de]",
            nextWeek: "dddd [di saet] LT [de]",
            lastDay: "[Duh di saet] LT [de]",
            lastWeek: "dddd[a bor\xee di saet] LT [de]",
            sameElse: "L"
        },
        relativeTime: {
            future: "di %s de",
            past: "ber\xee %s",
            s: processRelativeTime$7,
            ss: processRelativeTime$7,
            m: processRelativeTime$7,
            mm: processRelativeTime$7,
            h: processRelativeTime$7,
            hh: processRelativeTime$7,
            d: processRelativeTime$7,
            dd: processRelativeTime$7,
            w: processRelativeTime$7,
            ww: processRelativeTime$7,
            M: processRelativeTime$7,
            MM: processRelativeTime$7,
            y: processRelativeTime$7,
            yy: processRelativeTime$7
        },
        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
        ordinal: function(num, period) {
            var p = period.toLowerCase();
            if (p.includes("w") || p.includes("m")) return num + ".";
            return num + ezafeNumSuffix(num);
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$c = {
        1: "\u0661",
        2: "\u0662",
        3: "\u0663",
        4: "\u0664",
        5: "\u0665",
        6: "\u0666",
        7: "\u0667",
        8: "\u0668",
        9: "\u0669",
        0: "\u0660"
    }, numberMap$b = {
        "\u0661": "1",
        "\u0662": "2",
        "\u0663": "3",
        "\u0664": "4",
        "\u0665": "5",
        "\u0666": "6",
        "\u0667": "7",
        "\u0668": "8",
        "\u0669": "9",
        "\u0660": "0"
    }, months$7 = [
        "\u06A9\u0627\u0646\u0648\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
        "\u0634\u0648\u0628\u0627\u062A",
        "\u0626\u0627\u0632\u0627\u0631",
        "\u0646\u06CC\u0633\u0627\u0646",
        "\u0626\u0627\u06CC\u0627\u0631",
        "\u062D\u0648\u0632\u06D5\u06CC\u0631\u0627\u0646",
        "\u062A\u06D5\u0645\u0645\u0648\u0632",
        "\u0626\u0627\u0628",
        "\u0626\u06D5\u06CC\u0644\u0648\u0648\u0644",
        "\u062A\u0634\u0631\u06CC\u0646\u06CC \u06CC\u06D5\u0643\u06D5\u0645",
        "\u062A\u0634\u0631\u06CC\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
        "\u0643\u0627\u0646\u0648\u0646\u06CC \u06CC\u06D5\u06A9\u06D5\u0645"
    ];
    moment.defineLocale("ku", {
        months: months$7,
        monthsShort: months$7,
        weekdays: "\u06CC\u0647\u200C\u0643\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u062F\u0648\u0648\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u0633\u06CE\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u0686\u0648\u0627\u0631\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u067E\u06CE\u0646\u062C\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u0647\u0647\u200C\u06CC\u0646\u06CC_\u0634\u0647\u200C\u0645\u0645\u0647\u200C".split("_"),
        weekdaysShort: "\u06CC\u0647\u200C\u0643\u0634\u0647\u200C\u0645_\u062F\u0648\u0648\u0634\u0647\u200C\u0645_\u0633\u06CE\u0634\u0647\u200C\u0645_\u0686\u0648\u0627\u0631\u0634\u0647\u200C\u0645_\u067E\u06CE\u0646\u062C\u0634\u0647\u200C\u0645_\u0647\u0647\u200C\u06CC\u0646\u06CC_\u0634\u0647\u200C\u0645\u0645\u0647\u200C".split("_"),
        weekdaysMin: "\u06CC_\u062F_\u0633_\u0686_\u067E_\u0647_\u0634".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function(input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0628\u0647\u200C\u06CC\u0627\u0646\u06CC";
            else return "\u0626\u06CE\u0648\u0627\u0631\u0647\u200C";
        },
        calendar: {
            sameDay: "[\u0626\u0647\u200C\u0645\u0631\u06C6 \u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
            nextDay: "[\u0628\u0647\u200C\u06CC\u0627\u0646\u06CC \u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
            nextWeek: "dddd [\u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
            lastDay: "[\u062F\u0648\u06CE\u0646\u06CE \u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
            lastWeek: "dddd [\u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0644\u0647\u200C %s",
            past: "%s",
            s: "\u0686\u0647\u200C\u0646\u062F \u0686\u0631\u0643\u0647\u200C\u06CC\u0647\u200C\u0643",
            ss: "\u0686\u0631\u0643\u0647\u200C %d",
            m: "\u06CC\u0647\u200C\u0643 \u062E\u0648\u0644\u0647\u200C\u0643",
            mm: "%d \u062E\u0648\u0644\u0647\u200C\u0643",
            h: "\u06CC\u0647\u200C\u0643 \u0643\u0627\u062A\u0698\u0645\u06CE\u0631",
            hh: "%d \u0643\u0627\u062A\u0698\u0645\u06CE\u0631",
            d: "\u06CC\u0647\u200C\u0643 \u0695\u06C6\u0698",
            dd: "%d \u0695\u06C6\u0698",
            M: "\u06CC\u0647\u200C\u0643 \u0645\u0627\u0646\u06AF",
            MM: "%d \u0645\u0627\u0646\u06AF",
            y: "\u06CC\u0647\u200C\u0643 \u0633\u0627\u06B5",
            yy: "%d \u0633\u0627\u06B5"
        },
        preparse: function(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function(match) {
                return numberMap$b[match];
            }).replace(/،/g, ",");
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$c[match];
            }).replace(/,/g, "\u060C");
        },
        week: {
            dow: 6,
            doy: 12
        }
    });
    //! moment.js locale configuration
    var suffixes$2 = {
        0: "-\u0447\u04AF",
        1: "-\u0447\u0438",
        2: "-\u0447\u0438",
        3: "-\u0447\u04AF",
        4: "-\u0447\u04AF",
        5: "-\u0447\u0438",
        6: "-\u0447\u044B",
        7: "-\u0447\u0438",
        8: "-\u0447\u0438",
        9: "-\u0447\u0443",
        10: "-\u0447\u0443",
        20: "-\u0447\u044B",
        30: "-\u0447\u0443",
        40: "-\u0447\u044B",
        50: "-\u0447\u04AF",
        60: "-\u0447\u044B",
        70: "-\u0447\u0438",
        80: "-\u0447\u0438",
        90: "-\u0447\u0443",
        100: "-\u0447\u04AF"
    };
    moment.defineLocale("ky", {
        months: "\u044F\u043D\u0432\u0430\u0440\u044C_\u0444\u0435\u0432\u0440\u0430\u043B\u044C_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B\u044C_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C_\u043E\u043A\u0442\u044F\u0431\u0440\u044C_\u043D\u043E\u044F\u0431\u0440\u044C_\u0434\u0435\u043A\u0430\u0431\u0440\u044C".split("_"),
        monthsShort: "\u044F\u043D\u0432_\u0444\u0435\u0432_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433_\u0441\u0435\u043D_\u043E\u043A\u0442_\u043D\u043E\u044F_\u0434\u0435\u043A".split("_"),
        weekdays: "\u0416\u0435\u043A\u0448\u0435\u043C\u0431\u0438_\u0414\u04AF\u0439\u0448\u04E9\u043C\u0431\u04AF_\u0428\u0435\u0439\u0448\u0435\u043C\u0431\u0438_\u0428\u0430\u0440\u0448\u0435\u043C\u0431\u0438_\u0411\u0435\u0439\u0448\u0435\u043C\u0431\u0438_\u0416\u0443\u043C\u0430_\u0418\u0448\u0435\u043C\u0431\u0438".split("_"),
        weekdaysShort: "\u0416\u0435\u043A_\u0414\u04AF\u0439_\u0428\u0435\u0439_\u0428\u0430\u0440_\u0411\u0435\u0439_\u0416\u0443\u043C_\u0418\u0448\u0435".split("_"),
        weekdaysMin: "\u0416\u043A_\u0414\u0439_\u0428\u0439_\u0428\u0440_\u0411\u0439_\u0416\u043C_\u0418\u0448".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u0411\u04AF\u0433\u04AF\u043D \u0441\u0430\u0430\u0442] LT",
            nextDay: "[\u042D\u0440\u0442\u0435\u04A3 \u0441\u0430\u0430\u0442] LT",
            nextWeek: "dddd [\u0441\u0430\u0430\u0442] LT",
            lastDay: "[\u041A\u0435\u0447\u044D\u044D \u0441\u0430\u0430\u0442] LT",
            lastWeek: "[\u04E8\u0442\u043A\u04E9\u043D \u0430\u043F\u0442\u0430\u043D\u044B\u043D] dddd [\u043A\u04AF\u043D\u04AF] [\u0441\u0430\u0430\u0442] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0438\u0447\u0438\u043D\u0434\u0435",
            past: "%s \u043C\u0443\u0440\u0443\u043D",
            s: "\u0431\u0438\u0440\u043D\u0435\u0447\u0435 \u0441\u0435\u043A\u0443\u043D\u0434",
            ss: "%d \u0441\u0435\u043A\u0443\u043D\u0434",
            m: "\u0431\u0438\u0440 \u043C\u04AF\u043D\u04E9\u0442",
            mm: "%d \u043C\u04AF\u043D\u04E9\u0442",
            h: "\u0431\u0438\u0440 \u0441\u0430\u0430\u0442",
            hh: "%d \u0441\u0430\u0430\u0442",
            d: "\u0431\u0438\u0440 \u043A\u04AF\u043D",
            dd: "%d \u043A\u04AF\u043D",
            M: "\u0431\u0438\u0440 \u0430\u0439",
            MM: "%d \u0430\u0439",
            y: "\u0431\u0438\u0440 \u0436\u044B\u043B",
            yy: "%d \u0436\u044B\u043B"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function(number) {
            var a = number % 10, b = number >= 100 ? 100 : null;
            return number + (suffixes$2[number] || suffixes$2[a] || suffixes$2[b]);
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$8(number, withoutSuffix, key, isFuture) {
        var format = {
            m: [
                "eng Minutt",
                "enger Minutt"
            ],
            h: [
                "eng Stonn",
                "enger Stonn"
            ],
            d: [
                "een Dag",
                "engem Dag"
            ],
            M: [
                "ee Mount",
                "engem Mount"
            ],
            y: [
                "ee Joer",
                "engem Joer"
            ]
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(" "));
        if (eifelerRegelAppliesToNumber(number)) return "a " + string;
        return "an " + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(" "));
        if (eifelerRegelAppliesToNumber(number)) return "viru " + string;
        return "virun " + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */ function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) return false;
        if (number < 0) // Negative Number --> always true
        return true;
        else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) return true;
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) return eifelerRegelAppliesToNumber(firstDigit);
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while(number >= 10)number = number / 10;
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }
    moment.defineLocale("lb", {
        months: "Januar_Februar_M\xe4erz_Abr\xebll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),
        monthsParseExact: true,
        weekdays: "Sonndeg_M\xe9indeg_D\xebnschdeg_M\xebttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),
        weekdaysShort: "So._M\xe9._D\xeb._M\xeb._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_M\xe9_D\xeb_M\xeb_Do_Fr_Sa".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "H:mm [Auer]",
            LTS: "H:mm:ss [Auer]",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm [Auer]",
            LLLL: "dddd, D. MMMM YYYY H:mm [Auer]"
        },
        calendar: {
            sameDay: "[Haut um] LT",
            sameElse: "L",
            nextDay: "[Muer um] LT",
            nextWeek: "dddd [um] LT",
            lastDay: "[G\xebschter um] LT",
            lastWeek: function() {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch(this.day()){
                    case 2:
                    case 4:
                        return "[Leschten] dddd [um] LT";
                    default:
                        return "[Leschte] dddd [um] LT";
                }
            }
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: "e puer Sekonnen",
            ss: "%d Sekonnen",
            m: processRelativeTime$8,
            mm: "%d Minutten",
            h: processRelativeTime$8,
            hh: "%d Stonnen",
            d: processRelativeTime$8,
            dd: "%d Deeg",
            M: processRelativeTime$8,
            MM: "%d M\xe9int",
            y: processRelativeTime$8,
            yy: "%d Joer"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("lo", {
        months: "\u0EA1\u0EB1\u0E87\u0E81\u0EAD\u0E99_\u0E81\u0EB8\u0EA1\u0E9E\u0EB2_\u0EA1\u0EB5\u0E99\u0EB2_\u0EC0\u0EA1\u0EAA\u0EB2_\u0E9E\u0EB6\u0E94\u0EAA\u0EB0\u0E9E\u0EB2_\u0EA1\u0EB4\u0E96\u0EB8\u0E99\u0EB2_\u0E81\u0ECD\u0EA5\u0EB0\u0E81\u0EBB\u0E94_\u0EAA\u0EB4\u0E87\u0EAB\u0EB2_\u0E81\u0EB1\u0E99\u0E8D\u0EB2_\u0E95\u0EB8\u0EA5\u0EB2_\u0E9E\u0EB0\u0E88\u0EB4\u0E81_\u0E97\u0EB1\u0E99\u0EA7\u0EB2".split("_"),
        monthsShort: "\u0EA1\u0EB1\u0E87\u0E81\u0EAD\u0E99_\u0E81\u0EB8\u0EA1\u0E9E\u0EB2_\u0EA1\u0EB5\u0E99\u0EB2_\u0EC0\u0EA1\u0EAA\u0EB2_\u0E9E\u0EB6\u0E94\u0EAA\u0EB0\u0E9E\u0EB2_\u0EA1\u0EB4\u0E96\u0EB8\u0E99\u0EB2_\u0E81\u0ECD\u0EA5\u0EB0\u0E81\u0EBB\u0E94_\u0EAA\u0EB4\u0E87\u0EAB\u0EB2_\u0E81\u0EB1\u0E99\u0E8D\u0EB2_\u0E95\u0EB8\u0EA5\u0EB2_\u0E9E\u0EB0\u0E88\u0EB4\u0E81_\u0E97\u0EB1\u0E99\u0EA7\u0EB2".split("_"),
        weekdays: "\u0EAD\u0EB2\u0E97\u0EB4\u0E94_\u0E88\u0EB1\u0E99_\u0EAD\u0EB1\u0E87\u0E84\u0EB2\u0E99_\u0E9E\u0EB8\u0E94_\u0E9E\u0EB0\u0EAB\u0EB1\u0E94_\u0EAA\u0EB8\u0E81_\u0EC0\u0EAA\u0EBB\u0EB2".split("_"),
        weekdaysShort: "\u0E97\u0EB4\u0E94_\u0E88\u0EB1\u0E99_\u0EAD\u0EB1\u0E87\u0E84\u0EB2\u0E99_\u0E9E\u0EB8\u0E94_\u0E9E\u0EB0\u0EAB\u0EB1\u0E94_\u0EAA\u0EB8\u0E81_\u0EC0\u0EAA\u0EBB\u0EB2".split("_"),
        weekdaysMin: "\u0E97_\u0E88_\u0EAD\u0E84_\u0E9E_\u0E9E\u0EAB_\u0EAA\u0E81_\u0EAA".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "\u0EA7\u0EB1\u0E99dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function(input) {
            return input === "\u0E95\u0EAD\u0E99\u0EC1\u0EA5\u0E87";
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0E95\u0EAD\u0E99\u0EC0\u0E8A\u0EBB\u0EC9\u0EB2";
            else return "\u0E95\u0EAD\u0E99\u0EC1\u0EA5\u0E87";
        },
        calendar: {
            sameDay: "[\u0EA1\u0EB7\u0EC9\u0E99\u0EB5\u0EC9\u0EC0\u0EA7\u0EA5\u0EB2] LT",
            nextDay: "[\u0EA1\u0EB7\u0EC9\u0EAD\u0EB7\u0EC8\u0E99\u0EC0\u0EA7\u0EA5\u0EB2] LT",
            nextWeek: "[\u0EA7\u0EB1\u0E99]dddd[\u0EDC\u0EC9\u0EB2\u0EC0\u0EA7\u0EA5\u0EB2] LT",
            lastDay: "[\u0EA1\u0EB7\u0EC9\u0EA7\u0EB2\u0E99\u0E99\u0EB5\u0EC9\u0EC0\u0EA7\u0EA5\u0EB2] LT",
            lastWeek: "[\u0EA7\u0EB1\u0E99]dddd[\u0EC1\u0EA5\u0EC9\u0EA7\u0E99\u0EB5\u0EC9\u0EC0\u0EA7\u0EA5\u0EB2] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0EAD\u0EB5\u0E81 %s",
            past: "%s\u0E9C\u0EC8\u0EB2\u0E99\u0EA1\u0EB2",
            s: "\u0E9A\u0ECD\u0EC8\u0EC0\u0E97\u0EBB\u0EC8\u0EB2\u0EC3\u0E94\u0EA7\u0EB4\u0E99\u0EB2\u0E97\u0EB5",
            ss: "%d \u0EA7\u0EB4\u0E99\u0EB2\u0E97\u0EB5",
            m: "1 \u0E99\u0EB2\u0E97\u0EB5",
            mm: "%d \u0E99\u0EB2\u0E97\u0EB5",
            h: "1 \u0E8A\u0EBB\u0EC8\u0EA7\u0EC2\u0EA1\u0E87",
            hh: "%d \u0E8A\u0EBB\u0EC8\u0EA7\u0EC2\u0EA1\u0E87",
            d: "1 \u0EA1\u0EB7\u0EC9",
            dd: "%d \u0EA1\u0EB7\u0EC9",
            M: "1 \u0EC0\u0E94\u0EB7\u0EAD\u0E99",
            MM: "%d \u0EC0\u0E94\u0EB7\u0EAD\u0E99",
            y: "1 \u0E9B\u0EB5",
            yy: "%d \u0E9B\u0EB5"
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function(number) {
            return "\u0E97\u0EB5\u0EC8" + number;
        }
    });
    //! moment.js locale configuration
    var units = {
        ss: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
        m: "minut\u0117_minut\u0117s_minut\u0119",
        mm: "minut\u0117s_minu\u010Di\u0173_minutes",
        h: "valanda_valandos_valand\u0105",
        hh: "valandos_valand\u0173_valandas",
        d: "diena_dienos_dien\u0105",
        dd: "dienos_dien\u0173_dienas",
        M: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
        MM: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
        y: "metai_met\u0173_metus",
        yy: "metai_met\u0173_metus"
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) return "kelios sekund\u0117s";
        else return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : "kelias sekundes";
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || number > 10 && number < 20;
    }
    function forms(key) {
        return units[key].split("_");
    }
    function translate$6(number, withoutSuffix, key, isFuture) {
        var result = number + " ";
        if (number === 1) return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        else if (withoutSuffix) return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        else {
            if (isFuture) return result + forms(key)[1];
            else return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
    moment.defineLocale("lt", {
        months: {
            format: "sausio_vasario_kovo_baland\u017Eio_gegu\u017E\u0117s_bir\u017Eelio_liepos_rugpj\u016B\u010Dio_rugs\u0117jo_spalio_lapkri\u010Dio_gruod\u017Eio".split("_"),
            standalone: "sausis_vasaris_kovas_balandis_gegu\u017E\u0117_bir\u017Eelis_liepa_rugpj\u016Btis_rugs\u0117jis_spalis_lapkritis_gruodis".split("_"),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort: "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),
        weekdays: {
            format: "sekmadien\u012F_pirmadien\u012F_antradien\u012F_tre\u010Diadien\u012F_ketvirtadien\u012F_penktadien\u012F_\u0161e\u0161tadien\u012F".split("_"),
            standalone: "sekmadienis_pirmadienis_antradienis_tre\u010Diadienis_ketvirtadienis_penktadienis_\u0161e\u0161tadienis".split("_"),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort: "Sek_Pir_Ant_Tre_Ket_Pen_\u0160e\u0161".split("_"),
        weekdaysMin: "S_P_A_T_K_Pn_\u0160".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "YYYY [m.] MMMM D [d.]",
            LLL: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
            LLLL: "YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",
            l: "YYYY-MM-DD",
            ll: "YYYY [m.] MMMM D [d.]",
            lll: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
            llll: "YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"
        },
        calendar: {
            sameDay: "[\u0160iandien] LT",
            nextDay: "[Rytoj] LT",
            nextWeek: "dddd LT",
            lastDay: "[Vakar] LT",
            lastWeek: "[Pra\u0117jus\u012F] dddd LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "po %s",
            past: "prie\u0161 %s",
            s: translateSeconds,
            ss: translate$6,
            m: translateSingular,
            mm: translate$6,
            h: translateSingular,
            hh: translate$6,
            d: translateSingular,
            dd: translate$6,
            M: translateSingular,
            MM: translate$6,
            y: translateSingular,
            yy: translate$6
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function(number) {
            return number + "-oji";
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var units$1 = {
        ss: "sekundes_sekund\u0113m_sekunde_sekundes".split("_"),
        m: "min\u016Btes_min\u016Bt\u0113m_min\u016Bte_min\u016Btes".split("_"),
        mm: "min\u016Btes_min\u016Bt\u0113m_min\u016Bte_min\u016Btes".split("_"),
        h: "stundas_stund\u0101m_stunda_stundas".split("_"),
        hh: "stundas_stund\u0101m_stunda_stundas".split("_"),
        d: "dienas_dien\u0101m_diena_dienas".split("_"),
        dd: "dienas_dien\u0101m_diena_dienas".split("_"),
        M: "m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),
        MM: "m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),
        y: "gada_gadiem_gads_gadi".split("_"),
        yy: "gada_gadiem_gads_gadi".split("_")
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */ function format(forms, number, withoutSuffix) {
        if (withoutSuffix) // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        else // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
    function relativeTimeWithPlural$1(number, withoutSuffix, key) {
        return number + " " + format(units$1[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units$1[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? "da\u017Eas sekundes" : "da\u017E\u0101m sekund\u0113m";
    }
    moment.defineLocale("lv", {
        months: "janv\u0101ris_febru\u0101ris_marts_apr\u012Blis_maijs_j\u016Bnijs_j\u016Blijs_augusts_septembris_oktobris_novembris_decembris".split("_"),
        monthsShort: "jan_feb_mar_apr_mai_j\u016Bn_j\u016Bl_aug_sep_okt_nov_dec".split("_"),
        weekdays: "sv\u0113tdiena_pirmdiena_otrdiena_tre\u0161diena_ceturtdiena_piektdiena_sestdiena".split("_"),
        weekdaysShort: "Sv_P_O_T_C_Pk_S".split("_"),
        weekdaysMin: "Sv_P_O_T_C_Pk_S".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY.",
            LL: "YYYY. [gada] D. MMMM",
            LLL: "YYYY. [gada] D. MMMM, HH:mm",
            LLLL: "YYYY. [gada] D. MMMM, dddd, HH:mm"
        },
        calendar: {
            sameDay: "[\u0160odien pulksten] LT",
            nextDay: "[R\u012Bt pulksten] LT",
            nextWeek: "dddd [pulksten] LT",
            lastDay: "[Vakar pulksten] LT",
            lastWeek: "[Pag\u0101ju\u0161\u0101] dddd [pulksten] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "p\u0113c %s",
            past: "pirms %s",
            s: relativeSeconds,
            ss: relativeTimeWithPlural$1,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural$1,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural$1,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural$1,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural$1,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural$1
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var translator = {
        words: {
            //Different grammatical cases
            ss: [
                "sekund",
                "sekunda",
                "sekundi"
            ],
            m: [
                "jedan minut",
                "jednog minuta"
            ],
            mm: [
                "minut",
                "minuta",
                "minuta"
            ],
            h: [
                "jedan sat",
                "jednog sata"
            ],
            hh: [
                "sat",
                "sata",
                "sati"
            ],
            dd: [
                "dan",
                "dana",
                "dana"
            ],
            MM: [
                "mjesec",
                "mjeseca",
                "mjeseci"
            ],
            yy: [
                "godina",
                "godine",
                "godina"
            ]
        },
        correctGrammaticalCase: function(number, wordKey) {
            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
        },
        translate: function(number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) return withoutSuffix ? wordKey[0] : wordKey[1];
            else return number + " " + translator.correctGrammaticalCase(number, wordKey);
        }
    };
    moment.defineLocale("me", {
        months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),
        monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
        monthsParseExact: true,
        weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010Detvrtak_petak_subota".split("_"),
        weekdaysShort: "ned._pon._uto._sri._\u010Det._pet._sub.".split("_"),
        weekdaysMin: "ne_po_ut_sr_\u010De_pe_su".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[danas u] LT",
            nextDay: "[sjutra u] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[u] [nedjelju] [u] LT";
                    case 3:
                        return "[u] [srijedu] [u] LT";
                    case 6:
                        return "[u] [subotu] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[u] dddd [u] LT";
                }
            },
            lastDay: "[ju\u010De u] LT",
            lastWeek: function() {
                var lastWeekDays = [
                    "[pro\u0161le] [nedjelje] [u] LT",
                    "[pro\u0161log] [ponedjeljka] [u] LT",
                    "[pro\u0161log] [utorka] [u] LT",
                    "[pro\u0161le] [srijede] [u] LT",
                    "[pro\u0161log] [\u010Detvrtka] [u] LT",
                    "[pro\u0161log] [petka] [u] LT",
                    "[pro\u0161le] [subote] [u] LT"
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "prije %s",
            s: "nekoliko sekundi",
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: "dan",
            dd: translator.translate,
            M: "mjesec",
            MM: translator.translate,
            y: "godinu",
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("mi", {
        months: "Kohi-t\u0101te_Hui-tanguru_Pout\u016B-te-rangi_Paenga-wh\u0101wh\u0101_Haratua_Pipiri_H\u014Dngoingoi_Here-turi-k\u014Dk\u0101_Mahuru_Whiringa-\u0101-nuku_Whiringa-\u0101-rangi_Hakihea".split("_"),
        monthsShort: "Kohi_Hui_Pou_Pae_Hara_Pipi_H\u014Dngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split("_"),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: "R\u0101tapu_Mane_T\u016Brei_Wenerei_T\u0101ite_Paraire_H\u0101tarei".split("_"),
        weekdaysShort: "Ta_Ma_T\u016B_We_T\u0101i_Pa_H\u0101".split("_"),
        weekdaysMin: "Ta_Ma_T\u016B_We_T\u0101i_Pa_H\u0101".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [i] HH:mm",
            LLLL: "dddd, D MMMM YYYY [i] HH:mm"
        },
        calendar: {
            sameDay: "[i teie mahana, i] LT",
            nextDay: "[apopo i] LT",
            nextWeek: "dddd [i] LT",
            lastDay: "[inanahi i] LT",
            lastWeek: "dddd [whakamutunga i] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "i roto i %s",
            past: "%s i mua",
            s: "te h\u0113kona ruarua",
            ss: "%d h\u0113kona",
            m: "he meneti",
            mm: "%d meneti",
            h: "te haora",
            hh: "%d haora",
            d: "he ra",
            dd: "%d ra",
            M: "he marama",
            MM: "%d marama",
            y: "he tau",
            yy: "%d tau"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("mk", {
        months: "\u0458\u0430\u043D\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0438\u043B_\u043C\u0430\u0458_\u0458\u0443\u043D\u0438_\u0458\u0443\u043B\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438_\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438_\u043D\u043E\u0435\u043C\u0432\u0440\u0438_\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438".split("_"),
        monthsShort: "\u0458\u0430\u043D_\u0444\u0435\u0432_\u043C\u0430\u0440_\u0430\u043F\u0440_\u043C\u0430\u0458_\u0458\u0443\u043D_\u0458\u0443\u043B_\u0430\u0432\u0433_\u0441\u0435\u043F_\u043E\u043A\u0442_\u043D\u043E\u0435_\u0434\u0435\u043A".split("_"),
        weekdays: "\u043D\u0435\u0434\u0435\u043B\u0430_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A_\u043F\u0435\u0442\u043E\u043A_\u0441\u0430\u0431\u043E\u0442\u0430".split("_"),
        weekdaysShort: "\u043D\u0435\u0434_\u043F\u043E\u043D_\u0432\u0442\u043E_\u0441\u0440\u0435_\u0447\u0435\u0442_\u043F\u0435\u0442_\u0441\u0430\u0431".split("_"),
        weekdaysMin: "\u043De_\u043Fo_\u0432\u0442_\u0441\u0440_\u0447\u0435_\u043F\u0435_\u0441a".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "D.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY H:mm",
            LLLL: "dddd, D MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[\u0414\u0435\u043D\u0435\u0441 \u0432\u043E] LT",
            nextDay: "[\u0423\u0442\u0440\u0435 \u0432\u043E] LT",
            nextWeek: "[\u0412\u043E] dddd [\u0432\u043E] LT",
            lastDay: "[\u0412\u0447\u0435\u0440\u0430 \u0432\u043E] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                    case 6:
                        return "[\u0418\u0437\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430] dddd [\u0432\u043E] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[\u0418\u0437\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442] dddd [\u0432\u043E] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0437\u0430 %s",
            past: "\u043F\u0440\u0435\u0434 %s",
            s: "\u043D\u0435\u043A\u043E\u043B\u043A\u0443 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            ss: "%d \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            m: "\u0435\u0434\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
            mm: "%d \u043C\u0438\u043D\u0443\u0442\u0438",
            h: "\u0435\u0434\u0435\u043D \u0447\u0430\u0441",
            hh: "%d \u0447\u0430\u0441\u0430",
            d: "\u0435\u0434\u0435\u043D \u0434\u0435\u043D",
            dd: "%d \u0434\u0435\u043D\u0430",
            M: "\u0435\u0434\u0435\u043D \u043C\u0435\u0441\u0435\u0446",
            MM: "%d \u043C\u0435\u0441\u0435\u0446\u0438",
            y: "\u0435\u0434\u043D\u0430 \u0433\u043E\u0434\u0438\u043D\u0430",
            yy: "%d \u0433\u043E\u0434\u0438\u043D\u0438"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function(number) {
            var lastDigit = number % 10, last2Digits = number % 100;
            if (number === 0) return number + "-\u0435\u0432";
            else if (last2Digits === 0) return number + "-\u0435\u043D";
            else if (last2Digits > 10 && last2Digits < 20) return number + "-\u0442\u0438";
            else if (lastDigit === 1) return number + "-\u0432\u0438";
            else if (lastDigit === 2) return number + "-\u0440\u0438";
            else if (lastDigit === 7 || lastDigit === 8) return number + "-\u043C\u0438";
            else return number + "-\u0442\u0438";
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("ml", {
        months: "\u0D1C\u0D28\u0D41\u0D35\u0D30\u0D3F_\u0D2B\u0D46\u0D2C\u0D4D\u0D30\u0D41\u0D35\u0D30\u0D3F_\u0D2E\u0D3E\u0D7C\u0D1A\u0D4D\u0D1A\u0D4D_\u0D0F\u0D2A\u0D4D\u0D30\u0D3F\u0D7D_\u0D2E\u0D47\u0D2F\u0D4D_\u0D1C\u0D42\u0D7A_\u0D1C\u0D42\u0D32\u0D48_\u0D13\u0D17\u0D38\u0D4D\u0D31\u0D4D\u0D31\u0D4D_\u0D38\u0D46\u0D2A\u0D4D\u0D31\u0D4D\u0D31\u0D02\u0D2C\u0D7C_\u0D12\u0D15\u0D4D\u0D1F\u0D4B\u0D2C\u0D7C_\u0D28\u0D35\u0D02\u0D2C\u0D7C_\u0D21\u0D3F\u0D38\u0D02\u0D2C\u0D7C".split("_"),
        monthsShort: "\u0D1C\u0D28\u0D41._\u0D2B\u0D46\u0D2C\u0D4D\u0D30\u0D41._\u0D2E\u0D3E\u0D7C._\u0D0F\u0D2A\u0D4D\u0D30\u0D3F._\u0D2E\u0D47\u0D2F\u0D4D_\u0D1C\u0D42\u0D7A_\u0D1C\u0D42\u0D32\u0D48._\u0D13\u0D17._\u0D38\u0D46\u0D2A\u0D4D\u0D31\u0D4D\u0D31._\u0D12\u0D15\u0D4D\u0D1F\u0D4B._\u0D28\u0D35\u0D02._\u0D21\u0D3F\u0D38\u0D02.".split("_"),
        monthsParseExact: true,
        weekdays: "\u0D1E\u0D3E\u0D2F\u0D31\u0D3E\u0D34\u0D4D\u0D1A_\u0D24\u0D3F\u0D19\u0D4D\u0D15\u0D33\u0D3E\u0D34\u0D4D\u0D1A_\u0D1A\u0D4A\u0D35\u0D4D\u0D35\u0D3E\u0D34\u0D4D\u0D1A_\u0D2C\u0D41\u0D27\u0D28\u0D3E\u0D34\u0D4D\u0D1A_\u0D35\u0D4D\u0D2F\u0D3E\u0D34\u0D3E\u0D34\u0D4D\u0D1A_\u0D35\u0D46\u0D33\u0D4D\u0D33\u0D3F\u0D2F\u0D3E\u0D34\u0D4D\u0D1A_\u0D36\u0D28\u0D3F\u0D2F\u0D3E\u0D34\u0D4D\u0D1A".split("_"),
        weekdaysShort: "\u0D1E\u0D3E\u0D2F\u0D7C_\u0D24\u0D3F\u0D19\u0D4D\u0D15\u0D7E_\u0D1A\u0D4A\u0D35\u0D4D\u0D35_\u0D2C\u0D41\u0D27\u0D7B_\u0D35\u0D4D\u0D2F\u0D3E\u0D34\u0D02_\u0D35\u0D46\u0D33\u0D4D\u0D33\u0D3F_\u0D36\u0D28\u0D3F".split("_"),
        weekdaysMin: "\u0D1E\u0D3E_\u0D24\u0D3F_\u0D1A\u0D4A_\u0D2C\u0D41_\u0D35\u0D4D\u0D2F\u0D3E_\u0D35\u0D46_\u0D36".split("_"),
        longDateFormat: {
            LT: "A h:mm -\u0D28\u0D41",
            LTS: "A h:mm:ss -\u0D28\u0D41",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm -\u0D28\u0D41",
            LLLL: "dddd, D MMMM YYYY, A h:mm -\u0D28\u0D41"
        },
        calendar: {
            sameDay: "[\u0D07\u0D28\u0D4D\u0D28\u0D4D] LT",
            nextDay: "[\u0D28\u0D3E\u0D33\u0D46] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0D07\u0D28\u0D4D\u0D28\u0D32\u0D46] LT",
            lastWeek: "[\u0D15\u0D34\u0D3F\u0D1E\u0D4D\u0D1E] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0D15\u0D34\u0D3F\u0D1E\u0D4D\u0D1E\u0D4D",
            past: "%s \u0D2E\u0D41\u0D7B\u0D2A\u0D4D",
            s: "\u0D05\u0D7D\u0D2A \u0D28\u0D3F\u0D2E\u0D3F\u0D37\u0D19\u0D4D\u0D19\u0D7E",
            ss: "%d \u0D38\u0D46\u0D15\u0D4D\u0D15\u0D7B\u0D21\u0D4D",
            m: "\u0D12\u0D30\u0D41 \u0D2E\u0D3F\u0D28\u0D3F\u0D31\u0D4D\u0D31\u0D4D",
            mm: "%d \u0D2E\u0D3F\u0D28\u0D3F\u0D31\u0D4D\u0D31\u0D4D",
            h: "\u0D12\u0D30\u0D41 \u0D2E\u0D23\u0D3F\u0D15\u0D4D\u0D15\u0D42\u0D7C",
            hh: "%d \u0D2E\u0D23\u0D3F\u0D15\u0D4D\u0D15\u0D42\u0D7C",
            d: "\u0D12\u0D30\u0D41 \u0D26\u0D3F\u0D35\u0D38\u0D02",
            dd: "%d \u0D26\u0D3F\u0D35\u0D38\u0D02",
            M: "\u0D12\u0D30\u0D41 \u0D2E\u0D3E\u0D38\u0D02",
            MM: "%d \u0D2E\u0D3E\u0D38\u0D02",
            y: "\u0D12\u0D30\u0D41 \u0D35\u0D7C\u0D37\u0D02",
            yy: "%d \u0D35\u0D7C\u0D37\u0D02"
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0D30\u0D3E\u0D24\u0D4D\u0D30\u0D3F" && hour >= 4 || meridiem === "\u0D09\u0D1A\u0D4D\u0D1A \u0D15\u0D34\u0D3F\u0D1E\u0D4D\u0D1E\u0D4D" || meridiem === "\u0D35\u0D48\u0D15\u0D41\u0D28\u0D4D\u0D28\u0D47\u0D30\u0D02") return hour + 12;
            else return hour;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0D30\u0D3E\u0D24\u0D4D\u0D30\u0D3F";
            else if (hour < 12) return "\u0D30\u0D3E\u0D35\u0D3F\u0D32\u0D46";
            else if (hour < 17) return "\u0D09\u0D1A\u0D4D\u0D1A \u0D15\u0D34\u0D3F\u0D1E\u0D4D\u0D1E\u0D4D";
            else if (hour < 20) return "\u0D35\u0D48\u0D15\u0D41\u0D28\u0D4D\u0D28\u0D47\u0D30\u0D02";
            else return "\u0D30\u0D3E\u0D24\u0D4D\u0D30\u0D3F";
        }
    });
    //! moment.js locale configuration
    function translate$7(number, withoutSuffix, key, isFuture) {
        switch(key){
            case "s":
                return withoutSuffix ? "\u0445\u044D\u0434\u0445\u044D\u043D \u0441\u0435\u043A\u0443\u043D\u0434" : "\u0445\u044D\u0434\u0445\u044D\u043D \u0441\u0435\u043A\u0443\u043D\u0434\u044B\u043D";
            case "ss":
                return number + (withoutSuffix ? " \u0441\u0435\u043A\u0443\u043D\u0434" : " \u0441\u0435\u043A\u0443\u043D\u0434\u044B\u043D");
            case "m":
            case "mm":
                return number + (withoutSuffix ? " \u043C\u0438\u043D\u0443\u0442" : " \u043C\u0438\u043D\u0443\u0442\u044B\u043D");
            case "h":
            case "hh":
                return number + (withoutSuffix ? " \u0446\u0430\u0433" : " \u0446\u0430\u0433\u0438\u0439\u043D");
            case "d":
            case "dd":
                return number + (withoutSuffix ? " \u04E9\u0434\u04E9\u0440" : " \u04E9\u0434\u0440\u0438\u0439\u043D");
            case "M":
            case "MM":
                return number + (withoutSuffix ? " \u0441\u0430\u0440" : " \u0441\u0430\u0440\u044B\u043D");
            case "y":
            case "yy":
                return number + (withoutSuffix ? " \u0436\u0438\u043B" : " \u0436\u0438\u043B\u0438\u0439\u043D");
            default:
                return number;
        }
    }
    moment.defineLocale("mn", {
        months: "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440_\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440_\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0417\u0443\u0440\u0433\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u043E\u043B\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440_\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043D \u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440".split("_"),
        monthsShort: "1 \u0441\u0430\u0440_2 \u0441\u0430\u0440_3 \u0441\u0430\u0440_4 \u0441\u0430\u0440_5 \u0441\u0430\u0440_6 \u0441\u0430\u0440_7 \u0441\u0430\u0440_8 \u0441\u0430\u0440_9 \u0441\u0430\u0440_10 \u0441\u0430\u0440_11 \u0441\u0430\u0440_12 \u0441\u0430\u0440".split("_"),
        monthsParseExact: true,
        weekdays: "\u041D\u044F\u043C_\u0414\u0430\u0432\u0430\u0430_\u041C\u044F\u0433\u043C\u0430\u0440_\u041B\u0445\u0430\u0433\u0432\u0430_\u041F\u04AF\u0440\u044D\u0432_\u0411\u0430\u0430\u0441\u0430\u043D_\u0411\u044F\u043C\u0431\u0430".split("_"),
        weekdaysShort: "\u041D\u044F\u043C_\u0414\u0430\u0432_\u041C\u044F\u0433_\u041B\u0445\u0430_\u041F\u04AF\u0440_\u0411\u0430\u0430_\u0411\u044F\u043C".split("_"),
        weekdaysMin: "\u041D\u044F_\u0414\u0430_\u041C\u044F_\u041B\u0445_\u041F\u04AF_\u0411\u0430_\u0411\u044F".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "YYYY \u043E\u043D\u044B MMMM\u044B\u043D D",
            LLL: "YYYY \u043E\u043D\u044B MMMM\u044B\u043D D HH:mm",
            LLLL: "dddd, YYYY \u043E\u043D\u044B MMMM\u044B\u043D D HH:mm"
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function(input) {
            return input === "\u04AE\u0425";
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u04AE\u04E8";
            else return "\u04AE\u0425";
        },
        calendar: {
            sameDay: "[\u04E8\u043D\u04E9\u04E9\u0434\u04E9\u0440] LT",
            nextDay: "[\u041C\u0430\u0440\u0433\u0430\u0430\u0448] LT",
            nextWeek: "[\u0418\u0440\u044D\u0445] dddd LT",
            lastDay: "[\u04E8\u0447\u0438\u0433\u0434\u04E9\u0440] LT",
            lastWeek: "[\u04E8\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D] dddd LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0434\u0430\u0440\u0430\u0430",
            past: "%s \u04E9\u043C\u043D\u04E9",
            s: translate$7,
            ss: translate$7,
            m: translate$7,
            mm: translate$7,
            h: translate$7,
            hh: translate$7,
            d: translate$7,
            dd: translate$7,
            M: translate$7,
            MM: translate$7,
            y: translate$7,
            yy: translate$7
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function(number, period) {
            switch(period){
                case "d":
                case "D":
                case "DDD":
                    return number + " \u04E9\u0434\u04E9\u0440";
                default:
                    return number;
            }
        }
    });
    //! moment.js locale configuration
    var symbolMap$d = {
        1: "\u0967",
        2: "\u0968",
        3: "\u0969",
        4: "\u096A",
        5: "\u096B",
        6: "\u096C",
        7: "\u096D",
        8: "\u096E",
        9: "\u096F",
        0: "\u0966"
    }, numberMap$c = {
        "\u0967": "1",
        "\u0968": "2",
        "\u0969": "3",
        "\u096A": "4",
        "\u096B": "5",
        "\u096C": "6",
        "\u096D": "7",
        "\u096E": "8",
        "\u096F": "9",
        "\u0966": "0"
    };
    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = "";
        if (withoutSuffix) switch(string){
            case "s":
                output = "\u0915\u093E\u0939\u0940 \u0938\u0947\u0915\u0902\u0926";
                break;
            case "ss":
                output = "%d \u0938\u0947\u0915\u0902\u0926";
                break;
            case "m":
                output = "\u090F\u0915 \u092E\u093F\u0928\u093F\u091F";
                break;
            case "mm":
                output = "%d \u092E\u093F\u0928\u093F\u091F\u0947";
                break;
            case "h":
                output = "\u090F\u0915 \u0924\u093E\u0938";
                break;
            case "hh":
                output = "%d \u0924\u093E\u0938";
                break;
            case "d":
                output = "\u090F\u0915 \u0926\u093F\u0935\u0938";
                break;
            case "dd":
                output = "%d \u0926\u093F\u0935\u0938";
                break;
            case "M":
                output = "\u090F\u0915 \u092E\u0939\u093F\u0928\u093E";
                break;
            case "MM":
                output = "%d \u092E\u0939\u093F\u0928\u0947";
                break;
            case "y":
                output = "\u090F\u0915 \u0935\u0930\u094D\u0937";
                break;
            case "yy":
                output = "%d \u0935\u0930\u094D\u0937\u0947";
                break;
        }
        else switch(string){
            case "s":
                output = "\u0915\u093E\u0939\u0940 \u0938\u0947\u0915\u0902\u0926\u093E\u0902";
                break;
            case "ss":
                output = "%d \u0938\u0947\u0915\u0902\u0926\u093E\u0902";
                break;
            case "m":
                output = "\u090F\u0915\u093E \u092E\u093F\u0928\u093F\u091F\u093E";
                break;
            case "mm":
                output = "%d \u092E\u093F\u0928\u093F\u091F\u093E\u0902";
                break;
            case "h":
                output = "\u090F\u0915\u093E \u0924\u093E\u0938\u093E";
                break;
            case "hh":
                output = "%d \u0924\u093E\u0938\u093E\u0902";
                break;
            case "d":
                output = "\u090F\u0915\u093E \u0926\u093F\u0935\u0938\u093E";
                break;
            case "dd":
                output = "%d \u0926\u093F\u0935\u0938\u093E\u0902";
                break;
            case "M":
                output = "\u090F\u0915\u093E \u092E\u0939\u093F\u0928\u094D\u092F\u093E";
                break;
            case "MM":
                output = "%d \u092E\u0939\u093F\u0928\u094D\u092F\u093E\u0902";
                break;
            case "y":
                output = "\u090F\u0915\u093E \u0935\u0930\u094D\u0937\u093E";
                break;
            case "yy":
                output = "%d \u0935\u0930\u094D\u0937\u093E\u0902";
                break;
        }
        return output.replace(/%d/i, number);
    }
    moment.defineLocale("mr", {
        months: "\u091C\u093E\u0928\u0947\u0935\u093E\u0930\u0940_\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u093E\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u090F\u092A\u094D\u0930\u093F\u0932_\u092E\u0947_\u091C\u0942\u0928_\u091C\u0941\u0932\u0948_\u0911\u0917\u0938\u094D\u091F_\u0938\u092A\u094D\u091F\u0947\u0902\u092C\u0930_\u0911\u0915\u094D\u091F\u094B\u092C\u0930_\u0928\u094B\u0935\u094D\u0939\u0947\u0902\u092C\u0930_\u0921\u093F\u0938\u0947\u0902\u092C\u0930".split("_"),
        monthsShort: "\u091C\u093E\u0928\u0947._\u092B\u0947\u092C\u094D\u0930\u0941._\u092E\u093E\u0930\u094D\u091A._\u090F\u092A\u094D\u0930\u093F._\u092E\u0947._\u091C\u0942\u0928._\u091C\u0941\u0932\u0948._\u0911\u0917._\u0938\u092A\u094D\u091F\u0947\u0902._\u0911\u0915\u094D\u091F\u094B._\u0928\u094B\u0935\u094D\u0939\u0947\u0902._\u0921\u093F\u0938\u0947\u0902.".split("_"),
        monthsParseExact: true,
        weekdays: "\u0930\u0935\u093F\u0935\u093E\u0930_\u0938\u094B\u092E\u0935\u093E\u0930_\u092E\u0902\u0917\u0933\u0935\u093E\u0930_\u092C\u0941\u0927\u0935\u093E\u0930_\u0917\u0941\u0930\u0942\u0935\u093E\u0930_\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930_\u0936\u0928\u093F\u0935\u093E\u0930".split("_"),
        weekdaysShort: "\u0930\u0935\u093F_\u0938\u094B\u092E_\u092E\u0902\u0917\u0933_\u092C\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094D\u0930_\u0936\u0928\u093F".split("_"),
        weekdaysMin: "\u0930_\u0938\u094B_\u092E\u0902_\u092C\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),
        longDateFormat: {
            LT: "A h:mm \u0935\u093E\u091C\u0924\u093E",
            LTS: "A h:mm:ss \u0935\u093E\u091C\u0924\u093E",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u0935\u093E\u091C\u0924\u093E",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u0935\u093E\u091C\u0924\u093E"
        },
        calendar: {
            sameDay: "[\u0906\u091C] LT",
            nextDay: "[\u0909\u0926\u094D\u092F\u093E] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0915\u093E\u0932] LT",
            lastWeek: "[\u092E\u093E\u0917\u0940\u0932] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s\u092E\u0927\u094D\u092F\u0947",
            past: "%s\u092A\u0942\u0930\u094D\u0935\u0940",
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function(string) {
            return string.replace(/[१२३४५६७८९०]/g, function(match) {
                return numberMap$c[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$d[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u092A\u0939\u093E\u091F\u0947" || meridiem === "\u0938\u0915\u093E\u0933\u0940") return hour;
            else if (meridiem === "\u0926\u0941\u092A\u093E\u0930\u0940" || meridiem === "\u0938\u093E\u092F\u0902\u0915\u093E\u0933\u0940" || meridiem === "\u0930\u093E\u0924\u094D\u0930\u0940") return hour >= 12 ? hour : hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour >= 0 && hour < 6) return "\u092A\u0939\u093E\u091F\u0947";
            else if (hour < 12) return "\u0938\u0915\u093E\u0933\u0940";
            else if (hour < 17) return "\u0926\u0941\u092A\u093E\u0930\u0940";
            else if (hour < 20) return "\u0938\u093E\u092F\u0902\u0915\u093E\u0933\u0940";
            else return "\u0930\u093E\u0924\u094D\u0930\u0940";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("ms-my", {
        months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
        monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
        weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
        weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
        weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
        longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [pukul] HH.mm",
            LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "pagi") return hour;
            else if (meridiem === "tengahari") return hour >= 11 ? hour : hour + 12;
            else if (meridiem === "petang" || meridiem === "malam") return hour + 12;
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 11) return "pagi";
            else if (hours < 15) return "tengahari";
            else if (hours < 19) return "petang";
            else return "malam";
        },
        calendar: {
            sameDay: "[Hari ini pukul] LT",
            nextDay: "[Esok pukul] LT",
            nextWeek: "dddd [pukul] LT",
            lastDay: "[Kelmarin pukul] LT",
            lastWeek: "dddd [lepas pukul] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dalam %s",
            past: "%s yang lepas",
            s: "beberapa saat",
            ss: "%d saat",
            m: "seminit",
            mm: "%d minit",
            h: "sejam",
            hh: "%d jam",
            d: "sehari",
            dd: "%d hari",
            M: "sebulan",
            MM: "%d bulan",
            y: "setahun",
            yy: "%d tahun"
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("ms", {
        months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
        monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
        weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
        weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
        weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
        longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [pukul] HH.mm",
            LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "pagi") return hour;
            else if (meridiem === "tengahari") return hour >= 11 ? hour : hour + 12;
            else if (meridiem === "petang" || meridiem === "malam") return hour + 12;
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 11) return "pagi";
            else if (hours < 15) return "tengahari";
            else if (hours < 19) return "petang";
            else return "malam";
        },
        calendar: {
            sameDay: "[Hari ini pukul] LT",
            nextDay: "[Esok pukul] LT",
            nextWeek: "dddd [pukul] LT",
            lastDay: "[Kelmarin pukul] LT",
            lastWeek: "dddd [lepas pukul] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dalam %s",
            past: "%s yang lepas",
            s: "beberapa saat",
            ss: "%d saat",
            m: "seminit",
            mm: "%d minit",
            h: "sejam",
            hh: "%d jam",
            d: "sehari",
            dd: "%d hari",
            M: "sebulan",
            MM: "%d bulan",
            y: "setahun",
            yy: "%d tahun"
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("mt", {
        months: "Jannar_Frar_Marzu_April_Mejju_\u0120unju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Di\u010Bembru".split("_"),
        monthsShort: "Jan_Fra_Mar_Apr_Mej_\u0120un_Lul_Aww_Set_Ott_Nov_Di\u010B".split("_"),
        weekdays: "Il-\u0126add_It-Tnejn_It-Tlieta_L-Erbg\u0127a_Il-\u0126amis_Il-\u0120img\u0127a_Is-Sibt".split("_"),
        weekdaysShort: "\u0126ad_Tne_Tli_Erb_\u0126am_\u0120im_Sib".split("_"),
        weekdaysMin: "\u0126a_Tn_Tl_Er_\u0126a_\u0120i_Si".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Illum fil-]LT",
            nextDay: "[G\u0127ada fil-]LT",
            nextWeek: "dddd [fil-]LT",
            lastDay: "[Il-biera\u0127 fil-]LT",
            lastWeek: "dddd [li g\u0127adda] [fil-]LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "f\u2019 %s",
            past: "%s ilu",
            s: "ftit sekondi",
            ss: "%d sekondi",
            m: "minuta",
            mm: "%d minuti",
            h: "sieg\u0127a",
            hh: "%d sieg\u0127at",
            d: "\u0121urnata",
            dd: "%d \u0121ranet",
            M: "xahar",
            MM: "%d xhur",
            y: "sena",
            yy: "%d sni"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$e = {
        1: "\u1041",
        2: "\u1042",
        3: "\u1043",
        4: "\u1044",
        5: "\u1045",
        6: "\u1046",
        7: "\u1047",
        8: "\u1048",
        9: "\u1049",
        0: "\u1040"
    }, numberMap$d = {
        "\u1041": "1",
        "\u1042": "2",
        "\u1043": "3",
        "\u1044": "4",
        "\u1045": "5",
        "\u1046": "6",
        "\u1047": "7",
        "\u1048": "8",
        "\u1049": "9",
        "\u1040": "0"
    };
    moment.defineLocale("my", {
        months: "\u1007\u1014\u103A\u1014\u101D\u102B\u101B\u102E_\u1016\u1031\u1016\u1031\u102C\u103A\u101D\u102B\u101B\u102E_\u1019\u1010\u103A_\u1027\u1015\u103C\u102E_\u1019\u1031_\u1007\u103D\u1014\u103A_\u1007\u1030\u101C\u102D\u102F\u1004\u103A_\u101E\u103C\u1002\u102F\u1010\u103A_\u1005\u1000\u103A\u1010\u1004\u103A\u1018\u102C_\u1021\u1031\u102C\u1000\u103A\u1010\u102D\u102F\u1018\u102C_\u1014\u102D\u102F\u101D\u1004\u103A\u1018\u102C_\u1012\u102E\u1007\u1004\u103A\u1018\u102C".split("_"),
        monthsShort: "\u1007\u1014\u103A_\u1016\u1031_\u1019\u1010\u103A_\u1015\u103C\u102E_\u1019\u1031_\u1007\u103D\u1014\u103A_\u101C\u102D\u102F\u1004\u103A_\u101E\u103C_\u1005\u1000\u103A_\u1021\u1031\u102C\u1000\u103A_\u1014\u102D\u102F_\u1012\u102E".split("_"),
        weekdays: "\u1010\u1014\u1004\u103A\u1039\u1002\u1014\u103D\u1031_\u1010\u1014\u1004\u103A\u1039\u101C\u102C_\u1021\u1004\u103A\u1039\u1002\u102B_\u1017\u102F\u1012\u1039\u1013\u101F\u1030\u1038_\u1000\u103C\u102C\u101E\u1015\u1010\u1031\u1038_\u101E\u1031\u102C\u1000\u103C\u102C_\u1005\u1014\u1031".split("_"),
        weekdaysShort: "\u1014\u103D\u1031_\u101C\u102C_\u1002\u102B_\u101F\u1030\u1038_\u1000\u103C\u102C_\u101E\u1031\u102C_\u1014\u1031".split("_"),
        weekdaysMin: "\u1014\u103D\u1031_\u101C\u102C_\u1002\u102B_\u101F\u1030\u1038_\u1000\u103C\u102C_\u101E\u1031\u102C_\u1014\u1031".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u101A\u1014\u1031.] LT [\u1019\u103E\u102C]",
            nextDay: "[\u1019\u1014\u1000\u103A\u1016\u103C\u1014\u103A] LT [\u1019\u103E\u102C]",
            nextWeek: "dddd LT [\u1019\u103E\u102C]",
            lastDay: "[\u1019\u1014\u1031.\u1000] LT [\u1019\u103E\u102C]",
            lastWeek: "[\u1015\u103C\u102E\u1038\u1001\u1032\u1037\u101E\u1031\u102C] dddd LT [\u1019\u103E\u102C]",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u101C\u102C\u1019\u100A\u103A\u1037 %s \u1019\u103E\u102C",
            past: "\u101C\u103D\u1014\u103A\u1001\u1032\u1037\u101E\u1031\u102C %s \u1000",
            s: "\u1005\u1000\u1039\u1000\u1014\u103A.\u1021\u1014\u100A\u103A\u1038\u1004\u101A\u103A",
            ss: "%d \u1005\u1000\u1039\u1000\u1014\u1037\u103A",
            m: "\u1010\u1005\u103A\u1019\u102D\u1014\u1005\u103A",
            mm: "%d \u1019\u102D\u1014\u1005\u103A",
            h: "\u1010\u1005\u103A\u1014\u102C\u101B\u102E",
            hh: "%d \u1014\u102C\u101B\u102E",
            d: "\u1010\u1005\u103A\u101B\u1000\u103A",
            dd: "%d \u101B\u1000\u103A",
            M: "\u1010\u1005\u103A\u101C",
            MM: "%d \u101C",
            y: "\u1010\u1005\u103A\u1014\u103E\u1005\u103A",
            yy: "%d \u1014\u103E\u1005\u103A"
        },
        preparse: function(string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function(match) {
                return numberMap$d[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$e[match];
            });
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("nb", {
        months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        monthsShort: "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
        monthsParseExact: true,
        weekdays: "s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),
        weekdaysShort: "s\xf8._ma._ti._on._to._fr._l\xf8.".split("_"),
        weekdaysMin: "s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY [kl.] HH:mm",
            LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
        },
        calendar: {
            sameDay: "[i dag kl.] LT",
            nextDay: "[i morgen kl.] LT",
            nextWeek: "dddd [kl.] LT",
            lastDay: "[i g\xe5r kl.] LT",
            lastWeek: "[forrige] dddd [kl.] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "om %s",
            past: "%s siden",
            s: "noen sekunder",
            ss: "%d sekunder",
            m: "ett minutt",
            mm: "%d minutter",
            h: "\xe9n time",
            hh: "%d timer",
            d: "\xe9n dag",
            dd: "%d dager",
            w: "\xe9n uke",
            ww: "%d uker",
            M: "\xe9n m\xe5ned",
            MM: "%d m\xe5neder",
            y: "ett \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$f = {
        1: "\u0967",
        2: "\u0968",
        3: "\u0969",
        4: "\u096A",
        5: "\u096B",
        6: "\u096C",
        7: "\u096D",
        8: "\u096E",
        9: "\u096F",
        0: "\u0966"
    }, numberMap$e = {
        "\u0967": "1",
        "\u0968": "2",
        "\u0969": "3",
        "\u096A": "4",
        "\u096B": "5",
        "\u096C": "6",
        "\u096D": "7",
        "\u096E": "8",
        "\u096F": "9",
        "\u0966": "0"
    };
    moment.defineLocale("ne", {
        months: "\u091C\u0928\u0935\u0930\u0940_\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u093F\u0932_\u092E\u0908_\u091C\u0941\u0928_\u091C\u0941\u0932\u093E\u0908_\u0905\u0917\u0937\u094D\u091F_\u0938\u0947\u092A\u094D\u091F\u0947\u092E\u094D\u092C\u0930_\u0905\u0915\u094D\u091F\u094B\u092C\u0930_\u0928\u094B\u092D\u0947\u092E\u094D\u092C\u0930_\u0921\u093F\u0938\u0947\u092E\u094D\u092C\u0930".split("_"),
        monthsShort: "\u091C\u0928._\u092B\u0947\u092C\u094D\u0930\u0941._\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u093F._\u092E\u0908_\u091C\u0941\u0928_\u091C\u0941\u0932\u093E\u0908._\u0905\u0917._\u0938\u0947\u092A\u094D\u091F._\u0905\u0915\u094D\u091F\u094B._\u0928\u094B\u092D\u0947._\u0921\u093F\u0938\u0947.".split("_"),
        monthsParseExact: true,
        weekdays: "\u0906\u0907\u0924\u092C\u093E\u0930_\u0938\u094B\u092E\u092C\u093E\u0930_\u092E\u0919\u094D\u0917\u0932\u092C\u093E\u0930_\u092C\u0941\u0927\u092C\u093E\u0930_\u092C\u093F\u0939\u093F\u092C\u093E\u0930_\u0936\u0941\u0915\u094D\u0930\u092C\u093E\u0930_\u0936\u0928\u093F\u092C\u093E\u0930".split("_"),
        weekdaysShort: "\u0906\u0907\u0924._\u0938\u094B\u092E._\u092E\u0919\u094D\u0917\u0932._\u092C\u0941\u0927._\u092C\u093F\u0939\u093F._\u0936\u0941\u0915\u094D\u0930._\u0936\u0928\u093F.".split("_"),
        weekdaysMin: "\u0906._\u0938\u094B._\u092E\u0902._\u092C\u0941._\u092C\u093F._\u0936\u0941._\u0936.".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "A\u0915\u094B h:mm \u092C\u091C\u0947",
            LTS: "A\u0915\u094B h:mm:ss \u092C\u091C\u0947",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A\u0915\u094B h:mm \u092C\u091C\u0947",
            LLLL: "dddd, D MMMM YYYY, A\u0915\u094B h:mm \u092C\u091C\u0947"
        },
        preparse: function(string) {
            return string.replace(/[१२३४५६७८९०]/g, function(match) {
                return numberMap$e[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$f[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0930\u093E\u0924\u093F") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u092C\u093F\u0939\u093E\u0928") return hour;
            else if (meridiem === "\u0926\u093F\u0909\u0901\u0938\u094B") return hour >= 10 ? hour : hour + 12;
            else if (meridiem === "\u0938\u093E\u0901\u091D") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 3) return "\u0930\u093E\u0924\u093F";
            else if (hour < 12) return "\u092C\u093F\u0939\u093E\u0928";
            else if (hour < 16) return "\u0926\u093F\u0909\u0901\u0938\u094B";
            else if (hour < 20) return "\u0938\u093E\u0901\u091D";
            else return "\u0930\u093E\u0924\u093F";
        },
        calendar: {
            sameDay: "[\u0906\u091C] LT",
            nextDay: "[\u092D\u094B\u0932\u093F] LT",
            nextWeek: "[\u0906\u0909\u0901\u0926\u094B] dddd[,] LT",
            lastDay: "[\u0939\u093F\u091C\u094B] LT",
            lastWeek: "[\u0917\u090F\u0915\u094B] dddd[,] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s\u092E\u093E",
            past: "%s \u0905\u0917\u093E\u0921\u093F",
            s: "\u0915\u0947\u0939\u0940 \u0915\u094D\u0937\u0923",
            ss: "%d \u0938\u0947\u0915\u0947\u0923\u094D\u0921",
            m: "\u090F\u0915 \u092E\u093F\u0928\u0947\u091F",
            mm: "%d \u092E\u093F\u0928\u0947\u091F",
            h: "\u090F\u0915 \u0918\u0923\u094D\u091F\u093E",
            hh: "%d \u0918\u0923\u094D\u091F\u093E",
            d: "\u090F\u0915 \u0926\u093F\u0928",
            dd: "%d \u0926\u093F\u0928",
            M: "\u090F\u0915 \u092E\u0939\u093F\u0928\u093E",
            MM: "%d \u092E\u0939\u093F\u0928\u093E",
            y: "\u090F\u0915 \u092C\u0930\u094D\u0937",
            yy: "%d \u092C\u0930\u094D\u0937"
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    var monthsShortWithDots$1 = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"), monthsShortWithoutDots$1 = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"), monthsParse$8 = [
        /^jan/i,
        /^feb/i,
        /^(maart|mrt\.?)$/i,
        /^apr/i,
        /^mei$/i,
        /^jun[i.]?$/i,
        /^jul[i.]?$/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ], monthsRegex$7 = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
    moment.defineLocale("nl-be", {
        months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
        monthsShort: function(m, format) {
            if (!m) return monthsShortWithDots$1;
            else if (/-MMM-/.test(format)) return monthsShortWithoutDots$1[m.month()];
            else return monthsShortWithDots$1[m.month()];
        },
        monthsRegex: monthsRegex$7,
        monthsShortRegex: monthsRegex$7,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
        monthsParse: monthsParse$8,
        longMonthsParse: monthsParse$8,
        shortMonthsParse: monthsParse$8,
        weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
        weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
        weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[vandaag om] LT",
            nextDay: "[morgen om] LT",
            nextWeek: "dddd [om] LT",
            lastDay: "[gisteren om] LT",
            lastWeek: "[afgelopen] dddd [om] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "over %s",
            past: "%s geleden",
            s: "een paar seconden",
            ss: "%d seconden",
            m: "\xe9\xe9n minuut",
            mm: "%d minuten",
            h: "\xe9\xe9n uur",
            hh: "%d uur",
            d: "\xe9\xe9n dag",
            dd: "%d dagen",
            M: "\xe9\xe9n maand",
            MM: "%d maanden",
            y: "\xe9\xe9n jaar",
            yy: "%d jaar"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? "ste" : "de");
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var monthsShortWithDots$2 = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"), monthsShortWithoutDots$2 = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"), monthsParse$9 = [
        /^jan/i,
        /^feb/i,
        /^(maart|mrt\.?)$/i,
        /^apr/i,
        /^mei$/i,
        /^jun[i.]?$/i,
        /^jul[i.]?$/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ], monthsRegex$8 = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
    moment.defineLocale("nl", {
        months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
        monthsShort: function(m, format) {
            if (!m) return monthsShortWithDots$2;
            else if (/-MMM-/.test(format)) return monthsShortWithoutDots$2[m.month()];
            else return monthsShortWithDots$2[m.month()];
        },
        monthsRegex: monthsRegex$8,
        monthsShortRegex: monthsRegex$8,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
        monthsParse: monthsParse$9,
        longMonthsParse: monthsParse$9,
        shortMonthsParse: monthsParse$9,
        weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
        weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
        weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[vandaag om] LT",
            nextDay: "[morgen om] LT",
            nextWeek: "dddd [om] LT",
            lastDay: "[gisteren om] LT",
            lastWeek: "[afgelopen] dddd [om] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "over %s",
            past: "%s geleden",
            s: "een paar seconden",
            ss: "%d seconden",
            m: "\xe9\xe9n minuut",
            mm: "%d minuten",
            h: "\xe9\xe9n uur",
            hh: "%d uur",
            d: "\xe9\xe9n dag",
            dd: "%d dagen",
            w: "\xe9\xe9n week",
            ww: "%d weken",
            M: "\xe9\xe9n maand",
            MM: "%d maanden",
            y: "\xe9\xe9n jaar",
            yy: "%d jaar"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? "ste" : "de");
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("nn", {
        months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        monthsShort: "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
        monthsParseExact: true,
        weekdays: "sundag_m\xe5ndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),
        weekdaysShort: "su._m\xe5._ty._on._to._fr._lau.".split("_"),
        weekdaysMin: "su_m\xe5_ty_on_to_fr_la".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY [kl.] H:mm",
            LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
        },
        calendar: {
            sameDay: "[I dag klokka] LT",
            nextDay: "[I morgon klokka] LT",
            nextWeek: "dddd [klokka] LT",
            lastDay: "[I g\xe5r klokka] LT",
            lastWeek: "[F\xf8reg\xe5ande] dddd [klokka] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "om %s",
            past: "%s sidan",
            s: "nokre sekund",
            ss: "%d sekund",
            m: "eit minutt",
            mm: "%d minutt",
            h: "ein time",
            hh: "%d timar",
            d: "ein dag",
            dd: "%d dagar",
            w: "ei veke",
            ww: "%d veker",
            M: "ein m\xe5nad",
            MM: "%d m\xe5nader",
            y: "eit \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("oc-lnc", {
        months: {
            standalone: "geni\xe8r_febri\xe8r_mar\xe7_abril_mai_junh_julhet_agost_setembre_oct\xf2bre_novembre_decembre".split("_"),
            format: "de geni\xe8r_de febri\xe8r_de mar\xe7_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'oct\xf2bre_de novembre_de decembre".split("_"),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort: "gen._febr._mar\xe7_abr._mai_junh_julh._ago._set._oct._nov._dec.".split("_"),
        monthsParseExact: true,
        weekdays: "dimenge_diluns_dimars_dim\xe8cres_dij\xf2us_divendres_dissabte".split("_"),
        weekdaysShort: "dg._dl._dm._dc._dj._dv._ds.".split("_"),
        weekdaysMin: "dg_dl_dm_dc_dj_dv_ds".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM [de] YYYY",
            ll: "D MMM YYYY",
            LLL: "D MMMM [de] YYYY [a] H:mm",
            lll: "D MMM YYYY, H:mm",
            LLLL: "dddd D MMMM [de] YYYY [a] H:mm",
            llll: "ddd D MMM YYYY, H:mm"
        },
        calendar: {
            sameDay: "[u\xe8i a] LT",
            nextDay: "[deman a] LT",
            nextWeek: "dddd [a] LT",
            lastDay: "[i\xe8r a] LT",
            lastWeek: "dddd [passat a] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "d'aqu\xed %s",
            past: "fa %s",
            s: "unas segondas",
            ss: "%d segondas",
            m: "una minuta",
            mm: "%d minutas",
            h: "una ora",
            hh: "%d oras",
            d: "un jorn",
            dd: "%d jorns",
            M: "un mes",
            MM: "%d meses",
            y: "un an",
            yy: "%d ans"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function(number, period) {
            var output = number === 1 ? "r" : number === 2 ? "n" : number === 3 ? "r" : number === 4 ? "t" : "\xe8";
            if (period === "w" || period === "W") output = "a";
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var symbolMap$g = {
        1: "\u0A67",
        2: "\u0A68",
        3: "\u0A69",
        4: "\u0A6A",
        5: "\u0A6B",
        6: "\u0A6C",
        7: "\u0A6D",
        8: "\u0A6E",
        9: "\u0A6F",
        0: "\u0A66"
    }, numberMap$f = {
        "\u0A67": "1",
        "\u0A68": "2",
        "\u0A69": "3",
        "\u0A6A": "4",
        "\u0A6B": "5",
        "\u0A6C": "6",
        "\u0A6D": "7",
        "\u0A6E": "8",
        "\u0A6F": "9",
        "\u0A66": "0"
    };
    moment.defineLocale("pa-in", {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: "\u0A1C\u0A28\u0A35\u0A30\u0A40_\u0A2B\u0A3C\u0A30\u0A35\u0A30\u0A40_\u0A2E\u0A3E\u0A30\u0A1A_\u0A05\u0A2A\u0A4D\u0A30\u0A48\u0A32_\u0A2E\u0A08_\u0A1C\u0A42\u0A28_\u0A1C\u0A41\u0A32\u0A3E\u0A08_\u0A05\u0A17\u0A38\u0A24_\u0A38\u0A24\u0A70\u0A2C\u0A30_\u0A05\u0A15\u0A24\u0A42\u0A2C\u0A30_\u0A28\u0A35\u0A70\u0A2C\u0A30_\u0A26\u0A38\u0A70\u0A2C\u0A30".split("_"),
        monthsShort: "\u0A1C\u0A28\u0A35\u0A30\u0A40_\u0A2B\u0A3C\u0A30\u0A35\u0A30\u0A40_\u0A2E\u0A3E\u0A30\u0A1A_\u0A05\u0A2A\u0A4D\u0A30\u0A48\u0A32_\u0A2E\u0A08_\u0A1C\u0A42\u0A28_\u0A1C\u0A41\u0A32\u0A3E\u0A08_\u0A05\u0A17\u0A38\u0A24_\u0A38\u0A24\u0A70\u0A2C\u0A30_\u0A05\u0A15\u0A24\u0A42\u0A2C\u0A30_\u0A28\u0A35\u0A70\u0A2C\u0A30_\u0A26\u0A38\u0A70\u0A2C\u0A30".split("_"),
        weekdays: "\u0A10\u0A24\u0A35\u0A3E\u0A30_\u0A38\u0A4B\u0A2E\u0A35\u0A3E\u0A30_\u0A2E\u0A70\u0A17\u0A32\u0A35\u0A3E\u0A30_\u0A2C\u0A41\u0A27\u0A35\u0A3E\u0A30_\u0A35\u0A40\u0A30\u0A35\u0A3E\u0A30_\u0A38\u0A3C\u0A41\u0A71\u0A15\u0A30\u0A35\u0A3E\u0A30_\u0A38\u0A3C\u0A28\u0A40\u0A1A\u0A30\u0A35\u0A3E\u0A30".split("_"),
        weekdaysShort: "\u0A10\u0A24_\u0A38\u0A4B\u0A2E_\u0A2E\u0A70\u0A17\u0A32_\u0A2C\u0A41\u0A27_\u0A35\u0A40\u0A30_\u0A38\u0A3C\u0A41\u0A15\u0A30_\u0A38\u0A3C\u0A28\u0A40".split("_"),
        weekdaysMin: "\u0A10\u0A24_\u0A38\u0A4B\u0A2E_\u0A2E\u0A70\u0A17\u0A32_\u0A2C\u0A41\u0A27_\u0A35\u0A40\u0A30_\u0A38\u0A3C\u0A41\u0A15\u0A30_\u0A38\u0A3C\u0A28\u0A40".split("_"),
        longDateFormat: {
            LT: "A h:mm \u0A35\u0A1C\u0A47",
            LTS: "A h:mm:ss \u0A35\u0A1C\u0A47",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u0A35\u0A1C\u0A47",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u0A35\u0A1C\u0A47"
        },
        calendar: {
            sameDay: "[\u0A05\u0A1C] LT",
            nextDay: "[\u0A15\u0A32] LT",
            nextWeek: "[\u0A05\u0A17\u0A32\u0A3E] dddd, LT",
            lastDay: "[\u0A15\u0A32] LT",
            lastWeek: "[\u0A2A\u0A3F\u0A1B\u0A32\u0A47] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0A35\u0A3F\u0A71\u0A1A",
            past: "%s \u0A2A\u0A3F\u0A1B\u0A32\u0A47",
            s: "\u0A15\u0A41\u0A1D \u0A38\u0A15\u0A3F\u0A70\u0A1F",
            ss: "%d \u0A38\u0A15\u0A3F\u0A70\u0A1F",
            m: "\u0A07\u0A15 \u0A2E\u0A3F\u0A70\u0A1F",
            mm: "%d \u0A2E\u0A3F\u0A70\u0A1F",
            h: "\u0A07\u0A71\u0A15 \u0A18\u0A70\u0A1F\u0A3E",
            hh: "%d \u0A18\u0A70\u0A1F\u0A47",
            d: "\u0A07\u0A71\u0A15 \u0A26\u0A3F\u0A28",
            dd: "%d \u0A26\u0A3F\u0A28",
            M: "\u0A07\u0A71\u0A15 \u0A2E\u0A39\u0A40\u0A28\u0A3E",
            MM: "%d \u0A2E\u0A39\u0A40\u0A28\u0A47",
            y: "\u0A07\u0A71\u0A15 \u0A38\u0A3E\u0A32",
            yy: "%d \u0A38\u0A3E\u0A32"
        },
        preparse: function(string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function(match) {
                return numberMap$f[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$g[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0A30\u0A3E\u0A24") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0A38\u0A35\u0A47\u0A30") return hour;
            else if (meridiem === "\u0A26\u0A41\u0A2A\u0A39\u0A3F\u0A30") return hour >= 10 ? hour : hour + 12;
            else if (meridiem === "\u0A38\u0A3C\u0A3E\u0A2E") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0A30\u0A3E\u0A24";
            else if (hour < 10) return "\u0A38\u0A35\u0A47\u0A30";
            else if (hour < 17) return "\u0A26\u0A41\u0A2A\u0A39\u0A3F\u0A30";
            else if (hour < 20) return "\u0A38\u0A3C\u0A3E\u0A2E";
            else return "\u0A30\u0A3E\u0A24";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    var monthsNominative = "stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017Adziernik_listopad_grudzie\u0144".split("_"), monthsSubjective = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015Bnia_pa\u017Adziernika_listopada_grudnia".split("_"), monthsParse$a = [
        /^sty/i,
        /^lut/i,
        /^mar/i,
        /^kwi/i,
        /^maj/i,
        /^cze/i,
        /^lip/i,
        /^sie/i,
        /^wrz/i,
        /^paź/i,
        /^lis/i,
        /^gru/i
    ];
    function plural$3(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate$8(number, withoutSuffix, key) {
        var result = number + " ";
        switch(key){
            case "ss":
                return result + (plural$3(number) ? "sekundy" : "sekund");
            case "m":
                return withoutSuffix ? "minuta" : "minut\u0119";
            case "mm":
                return result + (plural$3(number) ? "minuty" : "minut");
            case "h":
                return withoutSuffix ? "godzina" : "godzin\u0119";
            case "hh":
                return result + (plural$3(number) ? "godziny" : "godzin");
            case "ww":
                return result + (plural$3(number) ? "tygodnie" : "tygodni");
            case "MM":
                return result + (plural$3(number) ? "miesi\u0105ce" : "miesi\u0119cy");
            case "yy":
                return result + (plural$3(number) ? "lata" : "lat");
        }
    }
    moment.defineLocale("pl", {
        months: function(momentToFormat, format) {
            if (!momentToFormat) return monthsNominative;
            else if (/D MMMM/.test(format)) return monthsSubjective[momentToFormat.month()];
            else return monthsNominative[momentToFormat.month()];
        },
        monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017A_lis_gru".split("_"),
        monthsParse: monthsParse$a,
        longMonthsParse: monthsParse$a,
        shortMonthsParse: monthsParse$a,
        weekdays: "niedziela_poniedzia\u0142ek_wtorek_\u015Broda_czwartek_pi\u0105tek_sobota".split("_"),
        weekdaysShort: "ndz_pon_wt_\u015Br_czw_pt_sob".split("_"),
        weekdaysMin: "Nd_Pn_Wt_\u015Ar_Cz_Pt_So".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Dzi\u015B o] LT",
            nextDay: "[Jutro o] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[W niedziel\u0119 o] LT";
                    case 2:
                        return "[We wtorek o] LT";
                    case 3:
                        return "[W \u015Brod\u0119 o] LT";
                    case 6:
                        return "[W sobot\u0119 o] LT";
                    default:
                        return "[W] dddd [o] LT";
                }
            },
            lastDay: "[Wczoraj o] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[W zesz\u0142\u0105 niedziel\u0119 o] LT";
                    case 3:
                        return "[W zesz\u0142\u0105 \u015Brod\u0119 o] LT";
                    case 6:
                        return "[W zesz\u0142\u0105 sobot\u0119 o] LT";
                    default:
                        return "[W zesz\u0142y] dddd [o] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "%s temu",
            s: "kilka sekund",
            ss: translate$8,
            m: translate$8,
            mm: translate$8,
            h: translate$8,
            hh: translate$8,
            d: "1 dzie\u0144",
            dd: "%d dni",
            w: "tydzie\u0144",
            ww: translate$8,
            M: "miesi\u0105c",
            MM: translate$8,
            y: "rok",
            yy: translate$8
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("pt-br", {
        months: "janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
        monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
        weekdays: "domingo_segunda-feira_ter\xe7a-feira_quarta-feira_quinta-feira_sexta-feira_s\xe1bado".split("_"),
        weekdaysShort: "dom_seg_ter_qua_qui_sex_s\xe1b".split("_"),
        weekdaysMin: "do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_s\xe1".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY [\xe0s] HH:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY [\xe0s] HH:mm"
        },
        calendar: {
            sameDay: "[Hoje \xe0s] LT",
            nextDay: "[Amanh\xe3 \xe0s] LT",
            nextWeek: "dddd [\xe0s] LT",
            lastDay: "[Ontem \xe0s] LT",
            lastWeek: function() {
                return this.day() === 0 || this.day() === 6 ? "[\xdaltimo] dddd [\xe0s] LT" // Saturday + Sunday
                 : "[\xdaltima] dddd [\xe0s] LT"; // Monday - Friday
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "em %s",
            past: "h\xe1 %s",
            s: "poucos segundos",
            ss: "%d segundos",
            m: "um minuto",
            mm: "%d minutos",
            h: "uma hora",
            hh: "%d horas",
            d: "um dia",
            dd: "%d dias",
            M: "um m\xeas",
            MM: "%d meses",
            y: "um ano",
            yy: "%d anos"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        invalidDate: "Data inv\xe1lida"
    });
    //! moment.js locale configuration
    moment.defineLocale("pt", {
        months: "janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
        monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
        weekdays: "Domingo_Segunda-feira_Ter\xe7a-feira_Quarta-feira_Quinta-feira_Sexta-feira_S\xe1bado".split("_"),
        weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_S\xe1b".split("_"),
        weekdaysMin: "Do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_S\xe1".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY HH:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Hoje \xe0s] LT",
            nextDay: "[Amanh\xe3 \xe0s] LT",
            nextWeek: "dddd [\xe0s] LT",
            lastDay: "[Ontem \xe0s] LT",
            lastWeek: function() {
                return this.day() === 0 || this.day() === 6 ? "[\xdaltimo] dddd [\xe0s] LT" // Saturday + Sunday
                 : "[\xdaltima] dddd [\xe0s] LT"; // Monday - Friday
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "em %s",
            past: "h\xe1 %s",
            s: "segundos",
            ss: "%d segundos",
            m: "um minuto",
            mm: "%d minutos",
            h: "uma hora",
            hh: "%d horas",
            d: "um dia",
            dd: "%d dias",
            w: "uma semana",
            ww: "%d semanas",
            M: "um m\xeas",
            MM: "%d meses",
            y: "um ano",
            yy: "%d anos"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    function relativeTimeWithPlural$2(number, withoutSuffix, key) {
        var format = {
            ss: "secunde",
            mm: "minute",
            hh: "ore",
            dd: "zile",
            ww: "s\u0103pt\u0103m\xe2ni",
            MM: "luni",
            yy: "ani"
        }, separator = " ";
        if (number % 100 >= 20 || number >= 100 && number % 100 === 0) separator = " de ";
        return number + separator + format[key];
    }
    moment.defineLocale("ro", {
        months: "ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),
        monthsShort: "ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),
        monthsParseExact: true,
        weekdays: "duminic\u0103_luni_mar\u021Bi_miercuri_joi_vineri_s\xe2mb\u0103t\u0103".split("_"),
        weekdaysShort: "Dum_Lun_Mar_Mie_Joi_Vin_S\xe2m".split("_"),
        weekdaysMin: "Du_Lu_Ma_Mi_Jo_Vi_S\xe2".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY H:mm",
            LLLL: "dddd, D MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[azi la] LT",
            nextDay: "[m\xe2ine la] LT",
            nextWeek: "dddd [la] LT",
            lastDay: "[ieri la] LT",
            lastWeek: "[fosta] dddd [la] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "peste %s",
            past: "%s \xeen urm\u0103",
            s: "c\xe2teva secunde",
            ss: relativeTimeWithPlural$2,
            m: "un minut",
            mm: relativeTimeWithPlural$2,
            h: "o or\u0103",
            hh: relativeTimeWithPlural$2,
            d: "o zi",
            dd: relativeTimeWithPlural$2,
            w: "o s\u0103pt\u0103m\xe2n\u0103",
            ww: relativeTimeWithPlural$2,
            M: "o lun\u0103",
            MM: relativeTimeWithPlural$2,
            y: "un an",
            yy: relativeTimeWithPlural$2
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    function plural$4(word, num) {
        var forms = word.split("_");
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural$3(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? "\u0441\u0435\u043A\u0443\u043D\u0434\u0430_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434" : "\u0441\u0435\u043A\u0443\u043D\u0434\u0443_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434",
            mm: withoutSuffix ? "\u043C\u0438\u043D\u0443\u0442\u0430_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442" : "\u043C\u0438\u043D\u0443\u0442\u0443_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442",
            hh: "\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043E\u0432",
            dd: "\u0434\u0435\u043D\u044C_\u0434\u043D\u044F_\u0434\u043D\u0435\u0439",
            ww: "\u043D\u0435\u0434\u0435\u043B\u044F_\u043D\u0435\u0434\u0435\u043B\u0438_\u043D\u0435\u0434\u0435\u043B\u044C",
            MM: "\u043C\u0435\u0441\u044F\u0446_\u043C\u0435\u0441\u044F\u0446\u0430_\u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            yy: "\u0433\u043E\u0434_\u0433\u043E\u0434\u0430_\u043B\u0435\u0442"
        };
        if (key === "m") return withoutSuffix ? "\u043C\u0438\u043D\u0443\u0442\u0430" : "\u043C\u0438\u043D\u0443\u0442\u0443";
        else return number + " " + plural$4(format[key], +number);
    }
    var monthsParse$b = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i
    ];
    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    moment.defineLocale("ru", {
        months: {
            format: "\u044F\u043D\u0432\u0430\u0440\u044F_\u0444\u0435\u0432\u0440\u0430\u043B\u044F_\u043C\u0430\u0440\u0442\u0430_\u0430\u043F\u0440\u0435\u043B\u044F_\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F_\u043E\u043A\u0442\u044F\u0431\u0440\u044F_\u043D\u043E\u044F\u0431\u0440\u044F_\u0434\u0435\u043A\u0430\u0431\u0440\u044F".split("_"),
            standalone: "\u044F\u043D\u0432\u0430\u0440\u044C_\u0444\u0435\u0432\u0440\u0430\u043B\u044C_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B\u044C_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C_\u043E\u043A\u0442\u044F\u0431\u0440\u044C_\u043D\u043E\u044F\u0431\u0440\u044C_\u0434\u0435\u043A\u0430\u0431\u0440\u044C".split("_")
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440._\u0430\u043F\u0440._\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split("_"),
            standalone: "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440\u0442_\u0430\u043F\u0440._\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split("_")
        },
        weekdays: {
            standalone: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043F\u044F\u0442\u043D\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043E\u0442\u0430".split("_"),
            format: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043F\u044F\u0442\u043D\u0438\u0446\u0443_\u0441\u0443\u0431\u0431\u043E\u0442\u0443".split("_"),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
        },
        weekdaysShort: "\u0432\u0441_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
        weekdaysMin: "\u0432\u0441_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
        monthsParse: monthsParse$b,
        longMonthsParse: monthsParse$b,
        shortMonthsParse: monthsParse$b,
        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0433.",
            LLL: "D MMMM YYYY \u0433., H:mm",
            LLLL: "dddd, D MMMM YYYY \u0433., H:mm"
        },
        calendar: {
            sameDay: "[\u0421\u0435\u0433\u043E\u0434\u043D\u044F, \u0432] LT",
            nextDay: "[\u0417\u0430\u0432\u0442\u0440\u0430, \u0432] LT",
            lastDay: "[\u0412\u0447\u0435\u0440\u0430, \u0432] LT",
            nextWeek: function(now) {
                if (now.week() !== this.week()) switch(this.day()){
                    case 0:
                        return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435] dddd, [\u0432] LT";
                    case 1:
                    case 2:
                    case 4:
                        return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439] dddd, [\u0432] LT";
                    case 3:
                    case 5:
                    case 6:
                        return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E] dddd, [\u0432] LT";
                }
                else {
                    if (this.day() === 2) return "[\u0412\u043E] dddd, [\u0432] LT";
                    else return "[\u0412] dddd, [\u0432] LT";
                }
            },
            lastWeek: function(now) {
                if (now.week() !== this.week()) switch(this.day()){
                    case 0:
                        return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u043E\u0435] dddd, [\u0432] LT";
                    case 1:
                    case 2:
                    case 4:
                        return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u044B\u0439] dddd, [\u0432] LT";
                    case 3:
                    case 5:
                    case 6:
                        return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u0443\u044E] dddd, [\u0432] LT";
                }
                else {
                    if (this.day() === 2) return "[\u0412\u043E] dddd, [\u0432] LT";
                    else return "[\u0412] dddd, [\u0432] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0447\u0435\u0440\u0435\u0437 %s",
            past: "%s \u043D\u0430\u0437\u0430\u0434",
            s: "\u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434",
            ss: relativeTimeWithPlural$3,
            m: relativeTimeWithPlural$3,
            mm: relativeTimeWithPlural$3,
            h: "\u0447\u0430\u0441",
            hh: relativeTimeWithPlural$3,
            d: "\u0434\u0435\u043D\u044C",
            dd: relativeTimeWithPlural$3,
            w: "\u043D\u0435\u0434\u0435\u043B\u044F",
            ww: relativeTimeWithPlural$3,
            M: "\u043C\u0435\u0441\u044F\u0446",
            MM: relativeTimeWithPlural$3,
            y: "\u0433\u043E\u0434",
            yy: relativeTimeWithPlural$3
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function(input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u043D\u043E\u0447\u0438";
            else if (hour < 12) return "\u0443\u0442\u0440\u0430";
            else if (hour < 17) return "\u0434\u043D\u044F";
            else return "\u0432\u0435\u0447\u0435\u0440\u0430";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function(number, period) {
            switch(period){
                case "M":
                case "d":
                case "DDD":
                    return number + "-\u0439";
                case "D":
                    return number + "-\u0433\u043E";
                case "w":
                case "W":
                    return number + "-\u044F";
                default:
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var months$8 = [
        "\u062C\u0646\u0648\u0631\u064A",
        "\u0641\u064A\u0628\u0631\u0648\u0631\u064A",
        "\u0645\u0627\u0631\u0686",
        "\u0627\u067E\u0631\u064A\u0644",
        "\u0645\u0626\u064A",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u0621\u0650",
        "\u0622\u06AF\u0633\u067D",
        "\u0633\u064A\u067E\u067D\u0645\u0628\u0631",
        "\u0622\u06AA\u067D\u0648\u0628\u0631",
        "\u0646\u0648\u0645\u0628\u0631",
        "\u068A\u0633\u0645\u0628\u0631"
    ], days = [
        "\u0622\u0686\u0631",
        "\u0633\u0648\u0645\u0631",
        "\u0627\u06B1\u0627\u0631\u0648",
        "\u0627\u0631\u0628\u0639",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639",
        "\u0687\u0646\u0687\u0631"
    ];
    moment.defineLocale("sd", {
        months: months$8,
        monthsShort: months$8,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd\u060C D MMMM YYYY HH:mm"
        },
        meridiemParse: /صبح|شام/,
        isPM: function(input) {
            return "\u0634\u0627\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635\u0628\u062D";
            return "\u0634\u0627\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0684] LT",
            nextDay: "[\u0633\u0680\u0627\u06BB\u064A] LT",
            nextWeek: "dddd [\u0627\u06B3\u064A\u0646 \u0647\u0641\u062A\u064A \u062A\u064A] LT",
            lastDay: "[\u06AA\u0627\u0644\u0647\u0647] LT",
            lastWeek: "[\u06AF\u0632\u0631\u064A\u0644 \u0647\u0641\u062A\u064A] dddd [\u062A\u064A] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u067E\u0648\u0621",
            past: "%s \u0627\u06B3",
            s: "\u0686\u0646\u062F \u0633\u064A\u06AA\u0646\u068A",
            ss: "%d \u0633\u064A\u06AA\u0646\u068A",
            m: "\u0647\u06AA \u0645\u0646\u067D",
            mm: "%d \u0645\u0646\u067D",
            h: "\u0647\u06AA \u06AA\u0644\u0627\u06AA",
            hh: "%d \u06AA\u0644\u0627\u06AA",
            d: "\u0647\u06AA \u068F\u064A\u0646\u0647\u0646",
            dd: "%d \u068F\u064A\u0646\u0647\u0646",
            M: "\u0647\u06AA \u0645\u0647\u064A\u0646\u0648",
            MM: "%d \u0645\u0647\u064A\u0646\u0627",
            y: "\u0647\u06AA \u0633\u0627\u0644",
            yy: "%d \u0633\u0627\u0644"
        },
        preparse: function(string) {
            return string.replace(/،/g, ",");
        },
        postformat: function(string) {
            return string.replace(/,/g, "\u060C");
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("se", {
        months: "o\u0111\u0111ajagem\xe1nnu_guovvam\xe1nnu_njuk\u010Dam\xe1nnu_cuo\u014Bom\xe1nnu_miessem\xe1nnu_geassem\xe1nnu_suoidnem\xe1nnu_borgem\xe1nnu_\u010Dak\u010Dam\xe1nnu_golggotm\xe1nnu_sk\xe1bmam\xe1nnu_juovlam\xe1nnu".split("_"),
        monthsShort: "o\u0111\u0111j_guov_njuk_cuo_mies_geas_suoi_borg_\u010Dak\u010D_golg_sk\xe1b_juov".split("_"),
        weekdays: "sotnabeaivi_vuoss\xe1rga_ma\u014B\u014Beb\xe1rga_gaskavahkku_duorastat_bearjadat_l\xe1vvardat".split("_"),
        weekdaysShort: "sotn_vuos_ma\u014B_gask_duor_bear_l\xe1v".split("_"),
        weekdaysMin: "s_v_m_g_d_b_L".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "MMMM D. [b.] YYYY",
            LLL: "MMMM D. [b.] YYYY [ti.] HH:mm",
            LLLL: "dddd, MMMM D. [b.] YYYY [ti.] HH:mm"
        },
        calendar: {
            sameDay: "[otne ti] LT",
            nextDay: "[ihttin ti] LT",
            nextWeek: "dddd [ti] LT",
            lastDay: "[ikte ti] LT",
            lastWeek: "[ovddit] dddd [ti] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s gea\u017Ees",
            past: "ma\u014Bit %s",
            s: "moadde sekunddat",
            ss: "%d sekunddat",
            m: "okta minuhta",
            mm: "%d minuhtat",
            h: "okta diimmu",
            hh: "%d diimmut",
            d: "okta beaivi",
            dd: "%d beaivvit",
            M: "okta m\xe1nnu",
            MM: "%d m\xe1nut",
            y: "okta jahki",
            yy: "%d jagit"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    /*jshint -W100*/ moment.defineLocale("si", {
        months: "\u0DA2\u0DB1\u0DC0\u0DCF\u0DBB\u0DD2_\u0DB4\u0DD9\u0DB6\u0DBB\u0DC0\u0DCF\u0DBB\u0DD2_\u0DB8\u0DCF\u0DBB\u0DCA\u0DAD\u0DD4_\u0D85\u0DB4\u0DCA\u200D\u0DBB\u0DDA\u0DBD\u0DCA_\u0DB8\u0DD0\u0DBA\u0DD2_\u0DA2\u0DD6\u0DB1\u0DD2_\u0DA2\u0DD6\u0DBD\u0DD2_\u0D85\u0D9C\u0DDD\u0DC3\u0DCA\u0DAD\u0DD4_\u0DC3\u0DD0\u0DB4\u0DCA\u0DAD\u0DD0\u0DB8\u0DCA\u0DB6\u0DBB\u0DCA_\u0D94\u0D9A\u0DCA\u0DAD\u0DDD\u0DB6\u0DBB\u0DCA_\u0DB1\u0DDC\u0DC0\u0DD0\u0DB8\u0DCA\u0DB6\u0DBB\u0DCA_\u0DAF\u0DD9\u0DC3\u0DD0\u0DB8\u0DCA\u0DB6\u0DBB\u0DCA".split("_"),
        monthsShort: "\u0DA2\u0DB1_\u0DB4\u0DD9\u0DB6_\u0DB8\u0DCF\u0DBB\u0DCA_\u0D85\u0DB4\u0DCA_\u0DB8\u0DD0\u0DBA\u0DD2_\u0DA2\u0DD6\u0DB1\u0DD2_\u0DA2\u0DD6\u0DBD\u0DD2_\u0D85\u0D9C\u0DDD_\u0DC3\u0DD0\u0DB4\u0DCA_\u0D94\u0D9A\u0DCA_\u0DB1\u0DDC\u0DC0\u0DD0_\u0DAF\u0DD9\u0DC3\u0DD0".split("_"),
        weekdays: "\u0D89\u0DBB\u0DD2\u0DAF\u0DCF_\u0DC3\u0DB3\u0DD4\u0DAF\u0DCF_\u0D85\u0D9F\u0DC4\u0DBB\u0DD4\u0DC0\u0DCF\u0DAF\u0DCF_\u0DB6\u0DAF\u0DCF\u0DAF\u0DCF_\u0DB6\u0DCA\u200D\u0DBB\u0DC4\u0DC3\u0DCA\u0DB4\u0DAD\u0DD2\u0DB1\u0DCA\u0DAF\u0DCF_\u0DC3\u0DD2\u0D9A\u0DD4\u0DBB\u0DCF\u0DAF\u0DCF_\u0DC3\u0DD9\u0DB1\u0DC3\u0DD4\u0DBB\u0DCF\u0DAF\u0DCF".split("_"),
        weekdaysShort: "\u0D89\u0DBB\u0DD2_\u0DC3\u0DB3\u0DD4_\u0D85\u0D9F_\u0DB6\u0DAF\u0DCF_\u0DB6\u0DCA\u200D\u0DBB\u0DC4_\u0DC3\u0DD2\u0D9A\u0DD4_\u0DC3\u0DD9\u0DB1".split("_"),
        weekdaysMin: "\u0D89_\u0DC3_\u0D85_\u0DB6_\u0DB6\u0DCA\u200D\u0DBB_\u0DC3\u0DD2_\u0DC3\u0DD9".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "a h:mm",
            LTS: "a h:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY MMMM D",
            LLL: "YYYY MMMM D, a h:mm",
            LLLL: "YYYY MMMM D [\u0DC0\u0DD0\u0DB1\u0DD2] dddd, a h:mm:ss"
        },
        calendar: {
            sameDay: "[\u0D85\u0DAF] LT[\u0DA7]",
            nextDay: "[\u0DC4\u0DD9\u0DA7] LT[\u0DA7]",
            nextWeek: "dddd LT[\u0DA7]",
            lastDay: "[\u0D8A\u0DBA\u0DDA] LT[\u0DA7]",
            lastWeek: "[\u0DB4\u0DC3\u0DD4\u0D9C\u0DD2\u0DBA] dddd LT[\u0DA7]",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s\u0D9A\u0DD2\u0DB1\u0DCA",
            past: "%s\u0D9A\u0DA7 \u0DB4\u0DD9\u0DBB",
            s: "\u0DAD\u0DAD\u0DCA\u0DB4\u0DBB \u0D9A\u0DD2\u0DC4\u0DD2\u0DB4\u0DBA",
            ss: "\u0DAD\u0DAD\u0DCA\u0DB4\u0DBB %d",
            m: "\u0DB8\u0DD2\u0DB1\u0DD2\u0DAD\u0DCA\u0DAD\u0DD4\u0DC0",
            mm: "\u0DB8\u0DD2\u0DB1\u0DD2\u0DAD\u0DCA\u0DAD\u0DD4 %d",
            h: "\u0DB4\u0DD0\u0DBA",
            hh: "\u0DB4\u0DD0\u0DBA %d",
            d: "\u0DAF\u0DD2\u0DB1\u0DBA",
            dd: "\u0DAF\u0DD2\u0DB1 %d",
            M: "\u0DB8\u0DCF\u0DC3\u0DBA",
            MM: "\u0DB8\u0DCF\u0DC3 %d",
            y: "\u0DC0\u0DC3\u0DBB",
            yy: "\u0DC0\u0DC3\u0DBB %d"
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function(number) {
            return number + " \u0DC0\u0DD0\u0DB1\u0DD2";
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function(input) {
            return input === "\u0DB4.\u0DC0." || input === "\u0DB4\u0DC3\u0DCA \u0DC0\u0DBB\u0DD4";
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours > 11) return isLower ? "\u0DB4.\u0DC0." : "\u0DB4\u0DC3\u0DCA \u0DC0\u0DBB\u0DD4";
            else return isLower ? "\u0DB4\u0DD9.\u0DC0." : "\u0DB4\u0DD9\u0DBB \u0DC0\u0DBB\u0DD4";
        }
    });
    //! moment.js locale configuration
    var months$9 = "janu\xe1r_febru\xe1r_marec_apr\xedl_m\xe1j_j\xfan_j\xfal_august_september_okt\xf3ber_november_december".split("_"), monthsShort$7 = "jan_feb_mar_apr_m\xe1j_j\xfan_j\xfal_aug_sep_okt_nov_dec".split("_");
    function plural$5(n) {
        return n > 1 && n < 5;
    }
    function translate$9(number, withoutSuffix, key, isFuture) {
        var result = number + " ";
        switch(key){
            case "s":
                return withoutSuffix || isFuture ? "p\xe1r sek\xfand" : "p\xe1r sekundami";
            case "ss":
                if (withoutSuffix || isFuture) return result + (plural$5(number) ? "sekundy" : "sek\xfand");
                else return result + "sekundami";
            case "m":
                return withoutSuffix ? "min\xfata" : isFuture ? "min\xfatu" : "min\xfatou";
            case "mm":
                if (withoutSuffix || isFuture) return result + (plural$5(number) ? "min\xfaty" : "min\xfat");
                else return result + "min\xfatami";
            case "h":
                return withoutSuffix ? "hodina" : isFuture ? "hodinu" : "hodinou";
            case "hh":
                if (withoutSuffix || isFuture) return result + (plural$5(number) ? "hodiny" : "hod\xedn");
                else return result + "hodinami";
            case "d":
                return withoutSuffix || isFuture ? "de\u0148" : "d\u0148om";
            case "dd":
                if (withoutSuffix || isFuture) return result + (plural$5(number) ? "dni" : "dn\xed");
                else return result + "d\u0148ami";
            case "M":
                return withoutSuffix || isFuture ? "mesiac" : "mesiacom";
            case "MM":
                if (withoutSuffix || isFuture) return result + (plural$5(number) ? "mesiace" : "mesiacov");
                else return result + "mesiacmi";
            case "y":
                return withoutSuffix || isFuture ? "rok" : "rokom";
            case "yy":
                if (withoutSuffix || isFuture) return result + (plural$5(number) ? "roky" : "rokov");
                else return result + "rokmi";
        }
    }
    moment.defineLocale("sk", {
        months: months$9,
        monthsShort: monthsShort$7,
        weekdays: "nede\u013Ea_pondelok_utorok_streda_\u0161tvrtok_piatok_sobota".split("_"),
        weekdaysShort: "ne_po_ut_st_\u0161t_pi_so".split("_"),
        weekdaysMin: "ne_po_ut_st_\u0161t_pi_so".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd D. MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[dnes o] LT",
            nextDay: "[zajtra o] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[v nede\u013Eu o] LT";
                    case 1:
                    case 2:
                        return "[v] dddd [o] LT";
                    case 3:
                        return "[v stredu o] LT";
                    case 4:
                        return "[vo \u0161tvrtok o] LT";
                    case 5:
                        return "[v piatok o] LT";
                    case 6:
                        return "[v sobotu o] LT";
                }
            },
            lastDay: "[v\u010Dera o] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[minul\xfa nede\u013Eu o] LT";
                    case 1:
                    case 2:
                        return "[minul\xfd] dddd [o] LT";
                    case 3:
                        return "[minul\xfa stredu o] LT";
                    case 4:
                    case 5:
                        return "[minul\xfd] dddd [o] LT";
                    case 6:
                        return "[minul\xfa sobotu o] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "pred %s",
            s: translate$9,
            ss: translate$9,
            m: translate$9,
            mm: translate$9,
            h: translate$9,
            hh: translate$9,
            d: translate$9,
            dd: translate$9,
            M: translate$9,
            MM: translate$9,
            y: translate$9,
            yy: translate$9
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    function processRelativeTime$9(number, withoutSuffix, key, isFuture) {
        var result = number + " ";
        switch(key){
            case "s":
                return withoutSuffix || isFuture ? "nekaj sekund" : "nekaj sekundami";
            case "ss":
                if (number === 1) result += withoutSuffix ? "sekundo" : "sekundi";
                else if (number === 2) result += withoutSuffix || isFuture ? "sekundi" : "sekundah";
                else if (number < 5) result += withoutSuffix || isFuture ? "sekunde" : "sekundah";
                else result += "sekund";
                return result;
            case "m":
                return withoutSuffix ? "ena minuta" : "eno minuto";
            case "mm":
                if (number === 1) result += withoutSuffix ? "minuta" : "minuto";
                else if (number === 2) result += withoutSuffix || isFuture ? "minuti" : "minutama";
                else if (number < 5) result += withoutSuffix || isFuture ? "minute" : "minutami";
                else result += withoutSuffix || isFuture ? "minut" : "minutami";
                return result;
            case "h":
                return withoutSuffix ? "ena ura" : "eno uro";
            case "hh":
                if (number === 1) result += withoutSuffix ? "ura" : "uro";
                else if (number === 2) result += withoutSuffix || isFuture ? "uri" : "urama";
                else if (number < 5) result += withoutSuffix || isFuture ? "ure" : "urami";
                else result += withoutSuffix || isFuture ? "ur" : "urami";
                return result;
            case "d":
                return withoutSuffix || isFuture ? "en dan" : "enim dnem";
            case "dd":
                if (number === 1) result += withoutSuffix || isFuture ? "dan" : "dnem";
                else if (number === 2) result += withoutSuffix || isFuture ? "dni" : "dnevoma";
                else result += withoutSuffix || isFuture ? "dni" : "dnevi";
                return result;
            case "M":
                return withoutSuffix || isFuture ? "en mesec" : "enim mesecem";
            case "MM":
                if (number === 1) result += withoutSuffix || isFuture ? "mesec" : "mesecem";
                else if (number === 2) result += withoutSuffix || isFuture ? "meseca" : "mesecema";
                else if (number < 5) result += withoutSuffix || isFuture ? "mesece" : "meseci";
                else result += withoutSuffix || isFuture ? "mesecev" : "meseci";
                return result;
            case "y":
                return withoutSuffix || isFuture ? "eno leto" : "enim letom";
            case "yy":
                if (number === 1) result += withoutSuffix || isFuture ? "leto" : "letom";
                else if (number === 2) result += withoutSuffix || isFuture ? "leti" : "letoma";
                else if (number < 5) result += withoutSuffix || isFuture ? "leta" : "leti";
                else result += withoutSuffix || isFuture ? "let" : "leti";
                return result;
        }
    }
    moment.defineLocale("sl", {
        months: "januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),
        monthsShort: "jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),
        monthsParseExact: true,
        weekdays: "nedelja_ponedeljek_torek_sreda_\u010Detrtek_petek_sobota".split("_"),
        weekdaysShort: "ned._pon._tor._sre._\u010Det._pet._sob.".split("_"),
        weekdaysMin: "ne_po_to_sr_\u010De_pe_so".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD. MM. YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[danes ob] LT",
            nextDay: "[jutri ob] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[v] [nedeljo] [ob] LT";
                    case 3:
                        return "[v] [sredo] [ob] LT";
                    case 6:
                        return "[v] [soboto] [ob] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[v] dddd [ob] LT";
                }
            },
            lastDay: "[v\u010Deraj ob] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[prej\u0161njo] [nedeljo] [ob] LT";
                    case 3:
                        return "[prej\u0161njo] [sredo] [ob] LT";
                    case 6:
                        return "[prej\u0161njo] [soboto] [ob] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[prej\u0161nji] dddd [ob] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u010Dez %s",
            past: "pred %s",
            s: processRelativeTime$9,
            ss: processRelativeTime$9,
            m: processRelativeTime$9,
            mm: processRelativeTime$9,
            h: processRelativeTime$9,
            hh: processRelativeTime$9,
            d: processRelativeTime$9,
            dd: processRelativeTime$9,
            M: processRelativeTime$9,
            MM: processRelativeTime$9,
            y: processRelativeTime$9,
            yy: processRelativeTime$9
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("sq", {
        months: "Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_N\xebntor_Dhjetor".split("_"),
        monthsShort: "Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_N\xebn_Dhj".split("_"),
        weekdays: "E Diel_E H\xebn\xeb_E Mart\xeb_E M\xebrkur\xeb_E Enjte_E Premte_E Shtun\xeb".split("_"),
        weekdaysShort: "Die_H\xebn_Mar_M\xebr_Enj_Pre_Sht".split("_"),
        weekdaysMin: "D_H_Ma_M\xeb_E_P_Sh".split("_"),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function(input) {
            return input.charAt(0) === "M";
        },
        meridiem: function(hours, minutes, isLower) {
            return hours < 12 ? "PD" : "MD";
        },
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Sot n\xeb] LT",
            nextDay: "[Nes\xebr n\xeb] LT",
            nextWeek: "dddd [n\xeb] LT",
            lastDay: "[Dje n\xeb] LT",
            lastWeek: "dddd [e kaluar n\xeb] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "n\xeb %s",
            past: "%s m\xeb par\xeb",
            s: "disa sekonda",
            ss: "%d sekonda",
            m: "nj\xeb minut\xeb",
            mm: "%d minuta",
            h: "nj\xeb or\xeb",
            hh: "%d or\xeb",
            d: "nj\xeb dit\xeb",
            dd: "%d dit\xeb",
            M: "nj\xeb muaj",
            MM: "%d muaj",
            y: "nj\xeb vit",
            yy: "%d vite"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var translator$1 = {
        words: {
            //Different grammatical cases
            ss: [
                "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
                "\u0441\u0435\u043A\u0443\u043D\u0434\u0435",
                "\u0441\u0435\u043A\u0443\u043D\u0434\u0438"
            ],
            m: [
                "\u0458\u0435\u0434\u0430\u043D \u043C\u0438\u043D\u0443\u0442",
                "\u0458\u0435\u0434\u043D\u043E\u0433 \u043C\u0438\u043D\u0443\u0442\u0430"
            ],
            mm: [
                "\u043C\u0438\u043D\u0443\u0442",
                "\u043C\u0438\u043D\u0443\u0442\u0430",
                "\u043C\u0438\u043D\u0443\u0442\u0430"
            ],
            h: [
                "\u0458\u0435\u0434\u0430\u043D \u0441\u0430\u0442",
                "\u0458\u0435\u0434\u043D\u043E\u0433 \u0441\u0430\u0442\u0430"
            ],
            hh: [
                "\u0441\u0430\u0442",
                "\u0441\u0430\u0442\u0430",
                "\u0441\u0430\u0442\u0438"
            ],
            d: [
                "\u0458\u0435\u0434\u0430\u043D \u0434\u0430\u043D",
                "\u0458\u0435\u0434\u043D\u043E\u0433 \u0434\u0430\u043D\u0430"
            ],
            dd: [
                "\u0434\u0430\u043D",
                "\u0434\u0430\u043D\u0430",
                "\u0434\u0430\u043D\u0430"
            ],
            M: [
                "\u0458\u0435\u0434\u0430\u043D \u043C\u0435\u0441\u0435\u0446",
                "\u0458\u0435\u0434\u043D\u043E\u0433 \u043C\u0435\u0441\u0435\u0446\u0430"
            ],
            MM: [
                "\u043C\u0435\u0441\u0435\u0446",
                "\u043C\u0435\u0441\u0435\u0446\u0430",
                "\u043C\u0435\u0441\u0435\u0446\u0438"
            ],
            y: [
                "\u0458\u0435\u0434\u043D\u0443 \u0433\u043E\u0434\u0438\u043D\u0443",
                "\u0458\u0435\u0434\u043D\u0435 \u0433\u043E\u0434\u0438\u043D\u0435"
            ],
            yy: [
                "\u0433\u043E\u0434\u0438\u043D\u0443",
                "\u0433\u043E\u0434\u0438\u043D\u0435",
                "\u0433\u043E\u0434\u0438\u043D\u0430"
            ]
        },
        correctGrammaticalCase: function(number, wordKey) {
            if (number % 10 >= 1 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20)) return number % 10 === 1 ? wordKey[0] : wordKey[1];
            return wordKey[2];
        },
        translate: function(number, withoutSuffix, key, isFuture) {
            var wordKey = translator$1.words[key], word;
            if (key.length === 1) {
                // Nominativ
                if (key === "y" && withoutSuffix) return "\u0458\u0435\u0434\u043D\u0430 \u0433\u043E\u0434\u0438\u043D\u0430";
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }
            word = translator$1.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === "yy" && withoutSuffix && word === "\u0433\u043E\u0434\u0438\u043D\u0443") return number + " \u0433\u043E\u0434\u0438\u043D\u0430";
            return number + " " + word;
        }
    };
    moment.defineLocale("sr-cyrl", {
        months: "\u0458\u0430\u043D\u0443\u0430\u0440_\u0444\u0435\u0431\u0440\u0443\u0430\u0440_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0438\u043B_\u043C\u0430\u0458_\u0458\u0443\u043D_\u0458\u0443\u043B_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440_\u043E\u043A\u0442\u043E\u0431\u0430\u0440_\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440_\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440".split("_"),
        monthsShort: "\u0458\u0430\u043D._\u0444\u0435\u0431._\u043C\u0430\u0440._\u0430\u043F\u0440._\u043C\u0430\u0458_\u0458\u0443\u043D_\u0458\u0443\u043B_\u0430\u0432\u0433._\u0441\u0435\u043F._\u043E\u043A\u0442._\u043D\u043E\u0432._\u0434\u0435\u0446.".split("_"),
        monthsParseExact: true,
        weekdays: "\u043D\u0435\u0434\u0435\u0459\u0430_\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A_\u0443\u0442\u043E\u0440\u0430\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A_\u043F\u0435\u0442\u0430\u043A_\u0441\u0443\u0431\u043E\u0442\u0430".split("_"),
        weekdaysShort: "\u043D\u0435\u0434._\u043F\u043E\u043D._\u0443\u0442\u043E._\u0441\u0440\u0435._\u0447\u0435\u0442._\u043F\u0435\u0442._\u0441\u0443\u0431.".split("_"),
        weekdaysMin: "\u043D\u0435_\u043F\u043E_\u0443\u0442_\u0441\u0440_\u0447\u0435_\u043F\u0435_\u0441\u0443".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "D. M. YYYY.",
            LL: "D. MMMM YYYY.",
            LLL: "D. MMMM YYYY. H:mm",
            LLLL: "dddd, D. MMMM YYYY. H:mm"
        },
        calendar: {
            sameDay: "[\u0434\u0430\u043D\u0430\u0441 \u0443] LT",
            nextDay: "[\u0441\u0443\u0442\u0440\u0430 \u0443] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[\u0443] [\u043D\u0435\u0434\u0435\u0459\u0443] [\u0443] LT";
                    case 3:
                        return "[\u0443] [\u0441\u0440\u0435\u0434\u0443] [\u0443] LT";
                    case 6:
                        return "[\u0443] [\u0441\u0443\u0431\u043E\u0442\u0443] [\u0443] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[\u0443] dddd [\u0443] LT";
                }
            },
            lastDay: "[\u0458\u0443\u0447\u0435 \u0443] LT",
            lastWeek: function() {
                var lastWeekDays = [
                    "[\u043F\u0440\u043E\u0448\u043B\u0435] [\u043D\u0435\u0434\u0435\u0459\u0435] [\u0443] LT",
                    "[\u043F\u0440\u043E\u0448\u043B\u043E\u0433] [\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u043A\u0430] [\u0443] LT",
                    "[\u043F\u0440\u043E\u0448\u043B\u043E\u0433] [\u0443\u0442\u043E\u0440\u043A\u0430] [\u0443] LT",
                    "[\u043F\u0440\u043E\u0448\u043B\u0435] [\u0441\u0440\u0435\u0434\u0435] [\u0443] LT",
                    "[\u043F\u0440\u043E\u0448\u043B\u043E\u0433] [\u0447\u0435\u0442\u0432\u0440\u0442\u043A\u0430] [\u0443] LT",
                    "[\u043F\u0440\u043E\u0448\u043B\u043E\u0433] [\u043F\u0435\u0442\u043A\u0430] [\u0443] LT",
                    "[\u043F\u0440\u043E\u0448\u043B\u0435] [\u0441\u0443\u0431\u043E\u0442\u0435] [\u0443] LT"
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0437\u0430 %s",
            past: "\u043F\u0440\u0435 %s",
            s: "\u043D\u0435\u043A\u043E\u043B\u0438\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            ss: translator$1.translate,
            m: translator$1.translate,
            mm: translator$1.translate,
            h: translator$1.translate,
            hh: translator$1.translate,
            d: translator$1.translate,
            dd: translator$1.translate,
            M: translator$1.translate,
            MM: translator$1.translate,
            y: translator$1.translate,
            yy: translator$1.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var translator$2 = {
        words: {
            //Different grammatical cases
            ss: [
                "sekunda",
                "sekunde",
                "sekundi"
            ],
            m: [
                "jedan minut",
                "jednog minuta"
            ],
            mm: [
                "minut",
                "minuta",
                "minuta"
            ],
            h: [
                "jedan sat",
                "jednog sata"
            ],
            hh: [
                "sat",
                "sata",
                "sati"
            ],
            d: [
                "jedan dan",
                "jednog dana"
            ],
            dd: [
                "dan",
                "dana",
                "dana"
            ],
            M: [
                "jedan mesec",
                "jednog meseca"
            ],
            MM: [
                "mesec",
                "meseca",
                "meseci"
            ],
            y: [
                "jednu godinu",
                "jedne godine"
            ],
            yy: [
                "godinu",
                "godine",
                "godina"
            ]
        },
        correctGrammaticalCase: function(number, wordKey) {
            if (number % 10 >= 1 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20)) return number % 10 === 1 ? wordKey[0] : wordKey[1];
            return wordKey[2];
        },
        translate: function(number, withoutSuffix, key, isFuture) {
            var wordKey = translator$2.words[key], word;
            if (key.length === 1) {
                // Nominativ
                if (key === "y" && withoutSuffix) return "jedna godina";
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }
            word = translator$2.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === "yy" && withoutSuffix && word === "godinu") return number + " godina";
            return number + " " + word;
        }
    };
    moment.defineLocale("sr", {
        months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),
        monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
        monthsParseExact: true,
        weekdays: "nedelja_ponedeljak_utorak_sreda_\u010Detvrtak_petak_subota".split("_"),
        weekdaysShort: "ned._pon._uto._sre._\u010Det._pet._sub.".split("_"),
        weekdaysMin: "ne_po_ut_sr_\u010De_pe_su".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "D. M. YYYY.",
            LL: "D. MMMM YYYY.",
            LLL: "D. MMMM YYYY. H:mm",
            LLLL: "dddd, D. MMMM YYYY. H:mm"
        },
        calendar: {
            sameDay: "[danas u] LT",
            nextDay: "[sutra u] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[u] [nedelju] [u] LT";
                    case 3:
                        return "[u] [sredu] [u] LT";
                    case 6:
                        return "[u] [subotu] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[u] dddd [u] LT";
                }
            },
            lastDay: "[ju\u010De u] LT",
            lastWeek: function() {
                var lastWeekDays = [
                    "[pro\u0161le] [nedelje] [u] LT",
                    "[pro\u0161log] [ponedeljka] [u] LT",
                    "[pro\u0161log] [utorka] [u] LT",
                    "[pro\u0161le] [srede] [u] LT",
                    "[pro\u0161log] [\u010Detvrtka] [u] LT",
                    "[pro\u0161log] [petka] [u] LT",
                    "[pro\u0161le] [subote] [u] LT"
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "pre %s",
            s: "nekoliko sekundi",
            ss: translator$2.translate,
            m: translator$2.translate,
            mm: translator$2.translate,
            h: translator$2.translate,
            hh: translator$2.translate,
            d: translator$2.translate,
            dd: translator$2.translate,
            M: translator$2.translate,
            MM: translator$2.translate,
            y: translator$2.translate,
            yy: translator$2.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("ss", {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split("_"),
        monthsShort: "Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),
        weekdays: "Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),
        weekdaysShort: "Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),
        weekdaysMin: "Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
            sameDay: "[Namuhla nga] LT",
            nextDay: "[Kusasa nga] LT",
            nextWeek: "dddd [nga] LT",
            lastDay: "[Itolo nga] LT",
            lastWeek: "dddd [leliphelile] [nga] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "nga %s",
            past: "wenteka nga %s",
            s: "emizuzwana lomcane",
            ss: "%d mzuzwana",
            m: "umzuzu",
            mm: "%d emizuzu",
            h: "lihora",
            hh: "%d emahora",
            d: "lilanga",
            dd: "%d emalanga",
            M: "inyanga",
            MM: "%d tinyanga",
            y: "umnyaka",
            yy: "%d iminyaka"
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function(hours, minutes, isLower) {
            if (hours < 11) return "ekuseni";
            else if (hours < 15) return "emini";
            else if (hours < 19) return "entsambama";
            else return "ebusuku";
        },
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "ekuseni") return hour;
            else if (meridiem === "emini") return hour >= 11 ? hour : hour + 12;
            else if (meridiem === "entsambama" || meridiem === "ebusuku") {
                if (hour === 0) return 0;
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: "%d",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("sv", {
        months: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),
        monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
        weekdays: "s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split("_"),
        weekdaysShort: "s\xf6n_m\xe5n_tis_ons_tor_fre_l\xf6r".split("_"),
        weekdaysMin: "s\xf6_m\xe5_ti_on_to_fr_l\xf6".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [kl.] HH:mm",
            LLLL: "dddd D MMMM YYYY [kl.] HH:mm",
            lll: "D MMM YYYY HH:mm",
            llll: "ddd D MMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Idag] LT",
            nextDay: "[Imorgon] LT",
            lastDay: "[Ig\xe5r] LT",
            nextWeek: "[P\xe5] dddd LT",
            lastWeek: "[I] dddd[s] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "om %s",
            past: "f\xf6r %s sedan",
            s: "n\xe5gra sekunder",
            ss: "%d sekunder",
            m: "en minut",
            mm: "%d minuter",
            h: "en timme",
            hh: "%d timmar",
            d: "en dag",
            dd: "%d dagar",
            M: "en m\xe5nad",
            MM: "%d m\xe5nader",
            y: "ett \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? ":e" : b === 1 ? ":a" : b === 2 ? ":a" : b === 3 ? ":e" : ":e";
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("sw", {
        months: "Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split("_"),
        monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),
        weekdays: "Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split("_"),
        weekdaysShort: "Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),
        weekdaysMin: "J2_J3_J4_J5_Al_Ij_J1".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "hh:mm A",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[leo saa] LT",
            nextDay: "[kesho saa] LT",
            nextWeek: "[wiki ijayo] dddd [saat] LT",
            lastDay: "[jana] LT",
            lastWeek: "[wiki iliyopita] dddd [saat] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s baadaye",
            past: "tokea %s",
            s: "hivi punde",
            ss: "sekunde %d",
            m: "dakika moja",
            mm: "dakika %d",
            h: "saa limoja",
            hh: "masaa %d",
            d: "siku moja",
            dd: "siku %d",
            M: "mwezi mmoja",
            MM: "miezi %d",
            y: "mwaka mmoja",
            yy: "miaka %d"
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var symbolMap$h = {
        1: "\u0BE7",
        2: "\u0BE8",
        3: "\u0BE9",
        4: "\u0BEA",
        5: "\u0BEB",
        6: "\u0BEC",
        7: "\u0BED",
        8: "\u0BEE",
        9: "\u0BEF",
        0: "\u0BE6"
    }, numberMap$g = {
        "\u0BE7": "1",
        "\u0BE8": "2",
        "\u0BE9": "3",
        "\u0BEA": "4",
        "\u0BEB": "5",
        "\u0BEC": "6",
        "\u0BED": "7",
        "\u0BEE": "8",
        "\u0BEF": "9",
        "\u0BE6": "0"
    };
    moment.defineLocale("ta", {
        months: "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF_\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF_\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD_\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD_\u0BAE\u0BC7_\u0B9C\u0BC2\u0BA9\u0BCD_\u0B9C\u0BC2\u0BB2\u0BC8_\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD_\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BC6\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD_\u0B85\u0B95\u0BCD\u0B9F\u0BC7\u0BBE\u0BAA\u0BB0\u0BCD_\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD_\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD".split("_"),
        monthsShort: "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF_\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF_\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD_\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD_\u0BAE\u0BC7_\u0B9C\u0BC2\u0BA9\u0BCD_\u0B9C\u0BC2\u0BB2\u0BC8_\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD_\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BC6\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD_\u0B85\u0B95\u0BCD\u0B9F\u0BC7\u0BBE\u0BAA\u0BB0\u0BCD_\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD_\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD".split("_"),
        weekdays: "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0B9F\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0B9A\u0BA9\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8".split("_"),
        weekdaysShort: "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1_\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD_\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD_\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD_\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD_\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF_\u0B9A\u0BA9\u0BBF".split("_"),
        weekdaysMin: "\u0B9E\u0BBE_\u0BA4\u0BBF_\u0B9A\u0BC6_\u0BAA\u0BC1_\u0BB5\u0BBF_\u0BB5\u0BC6_\u0B9A".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, HH:mm",
            LLLL: "dddd, D MMMM YYYY, HH:mm"
        },
        calendar: {
            sameDay: "[\u0B87\u0BA9\u0BCD\u0BB1\u0BC1] LT",
            nextDay: "[\u0BA8\u0BBE\u0BB3\u0BC8] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1] LT",
            lastWeek: "[\u0B95\u0B9F\u0BA8\u0BCD\u0BA4 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0B87\u0BB2\u0BCD",
            past: "%s \u0BAE\u0BC1\u0BA9\u0BCD",
            s: "\u0B92\u0BB0\u0BC1 \u0B9A\u0BBF\u0BB2 \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            ss: "%d \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            m: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            mm: "%d \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            h: "\u0B92\u0BB0\u0BC1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            hh: "%d \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            d: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBE\u0BB3\u0BCD",
            dd: "%d \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            M: "\u0B92\u0BB0\u0BC1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            MM: "%d \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            y: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            yy: "%d \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD"
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function(number) {
            return number + "\u0BB5\u0BA4\u0BC1";
        },
        preparse: function(string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function(match) {
                return numberMap$g[match];
            });
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap$h[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function(hour, minute, isLower) {
            if (hour < 2) return " \u0BAF\u0BBE\u0BAE\u0BAE\u0BCD";
            else if (hour < 6) return " \u0BB5\u0BC8\u0B95\u0BB1\u0BC8"; // வைகறை
            else if (hour < 10) return " \u0B95\u0BBE\u0BB2\u0BC8"; // காலை
            else if (hour < 14) return " \u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD"; // நண்பகல்
            else if (hour < 18) return " \u0B8E\u0BB1\u0BCD\u0BAA\u0BBE\u0B9F\u0BC1"; // எற்பாடு
            else if (hour < 22) return " \u0BAE\u0BBE\u0BB2\u0BC8"; // மாலை
            else return " \u0BAF\u0BBE\u0BAE\u0BAE\u0BCD";
        },
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0BAF\u0BBE\u0BAE\u0BAE\u0BCD") return hour < 2 ? hour : hour + 12;
            else if (meridiem === "\u0BB5\u0BC8\u0B95\u0BB1\u0BC8" || meridiem === "\u0B95\u0BBE\u0BB2\u0BC8") return hour;
            else if (meridiem === "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD") return hour >= 10 ? hour : hour + 12;
            else return hour + 12;
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("te", {
        months: "\u0C1C\u0C28\u0C35\u0C30\u0C3F_\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F_\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F_\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D_\u0C2E\u0C47_\u0C1C\u0C42\u0C28\u0C4D_\u0C1C\u0C41\u0C32\u0C48_\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41_\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D_\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D_\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D_\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D".split("_"),
        monthsShort: "\u0C1C\u0C28._\u0C2B\u0C3F\u0C2C\u0C4D\u0C30._\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F_\u0C0F\u0C2A\u0C4D\u0C30\u0C3F._\u0C2E\u0C47_\u0C1C\u0C42\u0C28\u0C4D_\u0C1C\u0C41\u0C32\u0C48_\u0C06\u0C17._\u0C38\u0C46\u0C2A\u0C4D._\u0C05\u0C15\u0C4D\u0C1F\u0C4B._\u0C28\u0C35._\u0C21\u0C3F\u0C38\u0C46.".split("_"),
        monthsParseExact: true,
        weekdays: "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02_\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02_\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02_\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02_\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02_\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02_\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02".split("_"),
        weekdaysShort: "\u0C06\u0C26\u0C3F_\u0C38\u0C4B\u0C2E_\u0C2E\u0C02\u0C17\u0C33_\u0C2C\u0C41\u0C27_\u0C17\u0C41\u0C30\u0C41_\u0C36\u0C41\u0C15\u0C4D\u0C30_\u0C36\u0C28\u0C3F".split("_"),
        weekdaysMin: "\u0C06_\u0C38\u0C4B_\u0C2E\u0C02_\u0C2C\u0C41_\u0C17\u0C41_\u0C36\u0C41_\u0C36".split("_"),
        longDateFormat: {
            LT: "A h:mm",
            LTS: "A h:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm",
            LLLL: "dddd, D MMMM YYYY, A h:mm"
        },
        calendar: {
            sameDay: "[\u0C28\u0C47\u0C21\u0C41] LT",
            nextDay: "[\u0C30\u0C47\u0C2A\u0C41] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0C28\u0C3F\u0C28\u0C4D\u0C28] LT",
            lastWeek: "[\u0C17\u0C24] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0C32\u0C4B",
            past: "%s \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02",
            s: "\u0C15\u0C4A\u0C28\u0C4D\u0C28\u0C3F \u0C15\u0C4D\u0C37\u0C23\u0C3E\u0C32\u0C41",
            ss: "%d \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32\u0C41",
            m: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            mm: "%d \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41",
            h: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            hh: "%d \u0C17\u0C02\u0C1F\u0C32\u0C41",
            d: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            dd: "%d \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41",
            M: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            MM: "%d \u0C28\u0C46\u0C32\u0C32\u0C41",
            y: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            yy: "%d \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: "%d\u0C35",
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0C09\u0C26\u0C2F\u0C02") return hour;
            else if (meridiem === "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02") return hour >= 10 ? hour : hour + 12;
            else if (meridiem === "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F";
            else if (hour < 10) return "\u0C09\u0C26\u0C2F\u0C02";
            else if (hour < 17) return "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02";
            else if (hour < 20) return "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02";
            else return "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("tet", {
        months: "Janeiru_Fevereiru_Marsu_Abril_Maiu_Ju\xf1u_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split("_"),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
        weekdays: "Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split("_"),
        weekdaysShort: "Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),
        weekdaysMin: "Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Ohin iha] LT",
            nextDay: "[Aban iha] LT",
            nextWeek: "dddd [iha] LT",
            lastDay: "[Horiseik iha] LT",
            lastWeek: "dddd [semana kotuk] [iha] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "iha %s",
            past: "%s liuba",
            s: "segundu balun",
            ss: "segundu %d",
            m: "minutu ida",
            mm: "minutu %d",
            h: "oras ida",
            hh: "oras %d",
            d: "loron ida",
            dd: "loron %d",
            M: "fulan ida",
            MM: "fulan %d",
            y: "tinan ida",
            yy: "tinan %d"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var suffixes$3 = {
        0: "-\u0443\u043C",
        1: "-\u0443\u043C",
        2: "-\u044E\u043C",
        3: "-\u044E\u043C",
        4: "-\u0443\u043C",
        5: "-\u0443\u043C",
        6: "-\u0443\u043C",
        7: "-\u0443\u043C",
        8: "-\u0443\u043C",
        9: "-\u0443\u043C",
        10: "-\u0443\u043C",
        12: "-\u0443\u043C",
        13: "-\u0443\u043C",
        20: "-\u0443\u043C",
        30: "-\u044E\u043C",
        40: "-\u0443\u043C",
        50: "-\u0443\u043C",
        60: "-\u0443\u043C",
        70: "-\u0443\u043C",
        80: "-\u0443\u043C",
        90: "-\u0443\u043C",
        100: "-\u0443\u043C"
    };
    moment.defineLocale("tg", {
        months: {
            format: "\u044F\u043D\u0432\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0430\u043B\u0438_\u043C\u0430\u0440\u0442\u0438_\u0430\u043F\u0440\u0435\u043B\u0438_\u043C\u0430\u0439\u0438_\u0438\u044E\u043D\u0438_\u0438\u044E\u043B\u0438_\u0430\u0432\u0433\u0443\u0441\u0442\u0438_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u0438_\u043E\u043A\u0442\u044F\u0431\u0440\u0438_\u043D\u043E\u044F\u0431\u0440\u0438_\u0434\u0435\u043A\u0430\u0431\u0440\u0438".split("_"),
            standalone: "\u044F\u043D\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043B_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B_\u043C\u0430\u0439_\u0438\u044E\u043D_\u0438\u044E\u043B_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440_\u043E\u043A\u0442\u044F\u0431\u0440_\u043D\u043E\u044F\u0431\u0440_\u0434\u0435\u043A\u0430\u0431\u0440".split("_")
        },
        monthsShort: "\u044F\u043D\u0432_\u0444\u0435\u0432_\u043C\u0430\u0440_\u0430\u043F\u0440_\u043C\u0430\u0439_\u0438\u044E\u043D_\u0438\u044E\u043B_\u0430\u0432\u0433_\u0441\u0435\u043D_\u043E\u043A\u0442_\u043D\u043E\u044F_\u0434\u0435\u043A".split("_"),
        weekdays: "\u044F\u043A\u0448\u0430\u043D\u0431\u0435_\u0434\u0443\u0448\u0430\u043D\u0431\u0435_\u0441\u0435\u0448\u0430\u043D\u0431\u0435_\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0435_\u043F\u0430\u043D\u04B7\u0448\u0430\u043D\u0431\u0435_\u04B7\u0443\u043C\u044A\u0430_\u0448\u0430\u043D\u0431\u0435".split("_"),
        weekdaysShort: "\u044F\u0448\u0431_\u0434\u0448\u0431_\u0441\u0448\u0431_\u0447\u0448\u0431_\u043F\u0448\u0431_\u04B7\u0443\u043C_\u0448\u043D\u0431".split("_"),
        weekdaysMin: "\u044F\u0448_\u0434\u0448_\u0441\u0448_\u0447\u0448_\u043F\u0448_\u04B7\u043C_\u0448\u0431".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u0418\u043C\u0440\u04EF\u0437 \u0441\u043E\u0430\u0442\u0438] LT",
            nextDay: "[\u0424\u0430\u0440\u0434\u043E \u0441\u043E\u0430\u0442\u0438] LT",
            lastDay: "[\u0414\u0438\u0440\u04EF\u0437 \u0441\u043E\u0430\u0442\u0438] LT",
            nextWeek: "dddd[\u0438] [\u04B3\u0430\u0444\u0442\u0430\u0438 \u043E\u044F\u043D\u0434\u0430 \u0441\u043E\u0430\u0442\u0438] LT",
            lastWeek: "dddd[\u0438] [\u04B3\u0430\u0444\u0442\u0430\u0438 \u0433\u0443\u0437\u0430\u0448\u0442\u0430 \u0441\u043E\u0430\u0442\u0438] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0431\u0430\u044A\u0434\u0438 %s",
            past: "%s \u043F\u0435\u0448",
            s: "\u044F\u043A\u0447\u0430\u043D\u0434 \u0441\u043E\u043D\u0438\u044F",
            m: "\u044F\u043A \u0434\u0430\u049B\u0438\u049B\u0430",
            mm: "%d \u0434\u0430\u049B\u0438\u049B\u0430",
            h: "\u044F\u043A \u0441\u043E\u0430\u0442",
            hh: "%d \u0441\u043E\u0430\u0442",
            d: "\u044F\u043A \u0440\u04EF\u0437",
            dd: "%d \u0440\u04EF\u0437",
            M: "\u044F\u043A \u043C\u043E\u04B3",
            MM: "%d \u043C\u043E\u04B3",
            y: "\u044F\u043A \u0441\u043E\u043B",
            yy: "%d \u0441\u043E\u043B"
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u0448\u0430\u0431") return hour < 4 ? hour : hour + 12;
            else if (meridiem === "\u0441\u0443\u0431\u04B3") return hour;
            else if (meridiem === "\u0440\u04EF\u0437") return hour >= 11 ? hour : hour + 12;
            else if (meridiem === "\u0431\u0435\u0433\u043E\u04B3") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u0448\u0430\u0431";
            else if (hour < 11) return "\u0441\u0443\u0431\u04B3";
            else if (hour < 16) return "\u0440\u04EF\u0437";
            else if (hour < 19) return "\u0431\u0435\u0433\u043E\u04B3";
            else return "\u0448\u0430\u0431";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function(number) {
            var a = number % 10, b = number >= 100 ? 100 : null;
            return number + (suffixes$3[number] || suffixes$3[a] || suffixes$3[b]);
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("th", {
        months: "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21_\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C_\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21_\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19_\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21_\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19_\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21_\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21_\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19_\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21_\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19_\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21".split("_"),
        monthsShort: "\u0E21.\u0E04._\u0E01.\u0E1E._\u0E21\u0E35.\u0E04._\u0E40\u0E21.\u0E22._\u0E1E.\u0E04._\u0E21\u0E34.\u0E22._\u0E01.\u0E04._\u0E2A.\u0E04._\u0E01.\u0E22._\u0E15.\u0E04._\u0E1E.\u0E22._\u0E18.\u0E04.".split("_"),
        monthsParseExact: true,
        weekdays: "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C_\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C_\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23_\u0E1E\u0E38\u0E18_\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35_\u0E28\u0E38\u0E01\u0E23\u0E4C_\u0E40\u0E2A\u0E32\u0E23\u0E4C".split("_"),
        weekdaysShort: "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C_\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C_\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23_\u0E1E\u0E38\u0E18_\u0E1E\u0E24\u0E2B\u0E31\u0E2A_\u0E28\u0E38\u0E01\u0E23\u0E4C_\u0E40\u0E2A\u0E32\u0E23\u0E4C".split("_"),
        weekdaysMin: "\u0E2D\u0E32._\u0E08._\u0E2D._\u0E1E._\u0E1E\u0E24._\u0E28._\u0E2A.".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY \u0E40\u0E27\u0E25\u0E32 H:mm",
            LLLL: "\u0E27\u0E31\u0E19dddd\u0E17\u0E35\u0E48 D MMMM YYYY \u0E40\u0E27\u0E25\u0E32 H:mm"
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function(input) {
            return input === "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07";
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07";
            else return "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07";
        },
        calendar: {
            sameDay: "[\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49 \u0E40\u0E27\u0E25\u0E32] LT",
            nextDay: "[\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49 \u0E40\u0E27\u0E25\u0E32] LT",
            nextWeek: "dddd[\u0E2B\u0E19\u0E49\u0E32 \u0E40\u0E27\u0E25\u0E32] LT",
            lastDay: "[\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49 \u0E40\u0E27\u0E25\u0E32] LT",
            lastWeek: "[\u0E27\u0E31\u0E19]dddd[\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E40\u0E27\u0E25\u0E32] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0E2D\u0E35\u0E01 %s",
            past: "%s\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27",
            s: "\u0E44\u0E21\u0E48\u0E01\u0E35\u0E48\u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
            ss: "%d \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
            m: "1 \u0E19\u0E32\u0E17\u0E35",
            mm: "%d \u0E19\u0E32\u0E17\u0E35",
            h: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
            hh: "%d \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
            d: "1 \u0E27\u0E31\u0E19",
            dd: "%d \u0E27\u0E31\u0E19",
            w: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
            ww: "%d \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
            M: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
            MM: "%d \u0E40\u0E14\u0E37\u0E2D\u0E19",
            y: "1 \u0E1B\u0E35",
            yy: "%d \u0E1B\u0E35"
        }
    });
    //! moment.js locale configuration
    var suffixes$4 = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'\xfcnji",
        4: "'\xfcnji",
        100: "'\xfcnji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy"
    };
    moment.defineLocale("tk", {
        months: "\xddanwar_Fewral_Mart_Aprel_Ma\xfd_I\xfdun_I\xfdul_Awgust_Sent\xfdabr_Okt\xfdabr_No\xfdabr_Dekabr".split("_"),
        monthsShort: "\xddan_Few_Mar_Apr_Ma\xfd_I\xfdn_I\xfdl_Awg_Sen_Okt_No\xfd_Dek".split("_"),
        weekdays: "\xddek\u015Fenbe_Du\u015Fenbe_Si\u015Fenbe_\xc7ar\u015Fenbe_Pen\u015Fenbe_Anna_\u015Eenbe".split("_"),
        weekdaysShort: "\xddek_Du\u015F_Si\u015F_\xc7ar_Pen_Ann_\u015Een".split("_"),
        weekdaysMin: "\xddk_D\u015F_S\u015F_\xc7r_Pn_An_\u015En".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[bug\xfcn sagat] LT",
            nextDay: "[ertir sagat] LT",
            nextWeek: "[indiki] dddd [sagat] LT",
            lastDay: "[d\xfc\xfdn] LT",
            lastWeek: "[ge\xe7en] dddd [sagat] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s so\u0148",
            past: "%s \xf6\u0148",
            s: "birn\xe4\xe7e sekunt",
            m: "bir minut",
            mm: "%d minut",
            h: "bir sagat",
            hh: "%d sagat",
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            M: "bir a\xfd",
            MM: "%d a\xfd",
            y: "bir \xfdyl",
            yy: "%d \xfdyl"
        },
        ordinal: function(number, period) {
            switch(period){
                case "d":
                case "D":
                case "Do":
                case "DD":
                    return number;
                default:
                    if (number === 0) // special case for zero
                    return number + "'unjy";
                    var a = number % 10, b = number % 100 - a, c = number >= 100 ? 100 : null;
                    return number + (suffixes$4[a] || suffixes$4[b] || suffixes$4[c]);
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("tl-ph", {
        months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),
        monthsShort: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
        weekdays: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),
        weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
        weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "MM/D/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY HH:mm",
            LLLL: "dddd, MMMM DD, YYYY HH:mm"
        },
        calendar: {
            sameDay: "LT [ngayong araw]",
            nextDay: "[Bukas ng] LT",
            nextWeek: "LT [sa susunod na] dddd",
            lastDay: "LT [kahapon]",
            lastWeek: "LT [noong nakaraang] dddd",
            sameElse: "L"
        },
        relativeTime: {
            future: "sa loob ng %s",
            past: "%s ang nakalipas",
            s: "ilang segundo",
            ss: "%d segundo",
            m: "isang minuto",
            mm: "%d minuto",
            h: "isang oras",
            hh: "%d oras",
            d: "isang araw",
            dd: "%d araw",
            M: "isang buwan",
            MM: "%d buwan",
            y: "isang taon",
            yy: "%d taon"
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function(number) {
            return number;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var numbersNouns = "pagh_wa\u2019_cha\u2019_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_");
    function translateFuture(output) {
        var time = output;
        time = output.indexOf("jaj") !== -1 ? time.slice(0, -3) + "leS" : output.indexOf("jar") !== -1 ? time.slice(0, -3) + "waQ" : output.indexOf("DIS") !== -1 ? time.slice(0, -3) + "nem" : time + " pIq";
        return time;
    }
    function translatePast(output) {
        var time = output;
        time = output.indexOf("jaj") !== -1 ? time.slice(0, -3) + "Hu\u2019" : output.indexOf("jar") !== -1 ? time.slice(0, -3) + "wen" : output.indexOf("DIS") !== -1 ? time.slice(0, -3) + "ben" : time + " ret";
        return time;
    }
    function translate$a(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch(string){
            case "ss":
                return numberNoun + " lup";
            case "mm":
                return numberNoun + " tup";
            case "hh":
                return numberNoun + " rep";
            case "dd":
                return numberNoun + " jaj";
            case "MM":
                return numberNoun + " jar";
            case "yy":
                return numberNoun + " DIS";
        }
    }
    function numberAsNoun(number) {
        var hundred = Math.floor(number % 1000 / 100), ten = Math.floor(number % 100 / 10), one = number % 10, word = "";
        if (hundred > 0) word += numbersNouns[hundred] + "vatlh";
        if (ten > 0) word += (word !== "" ? " " : "") + numbersNouns[ten] + "maH";
        if (one > 0) word += (word !== "" ? " " : "") + numbersNouns[one];
        return word === "" ? "pagh" : word;
    }
    moment.defineLocale("tlh", {
        months: "tera\u2019 jar wa\u2019_tera\u2019 jar cha\u2019_tera\u2019 jar wej_tera\u2019 jar loS_tera\u2019 jar vagh_tera\u2019 jar jav_tera\u2019 jar Soch_tera\u2019 jar chorgh_tera\u2019 jar Hut_tera\u2019 jar wa\u2019maH_tera\u2019 jar wa\u2019maH wa\u2019_tera\u2019 jar wa\u2019maH cha\u2019".split("_"),
        monthsShort: "jar wa\u2019_jar cha\u2019_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa\u2019maH_jar wa\u2019maH wa\u2019_jar wa\u2019maH cha\u2019".split("_"),
        monthsParseExact: true,
        weekdays: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
        weekdaysShort: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
        weekdaysMin: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[DaHjaj] LT",
            nextDay: "[wa\u2019leS] LT",
            nextWeek: "LLL",
            lastDay: "[wa\u2019Hu\u2019] LT",
            lastWeek: "LLL",
            sameElse: "L"
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: "puS lup",
            ss: translate$a,
            m: "wa\u2019 tup",
            mm: translate$a,
            h: "wa\u2019 rep",
            hh: translate$a,
            d: "wa\u2019 jaj",
            dd: translate$a,
            M: "wa\u2019 jar",
            MM: translate$a,
            y: "wa\u2019 DIS",
            yy: translate$a
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    var suffixes$5 = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'\xfcnc\xfc",
        4: "'\xfcnc\xfc",
        100: "'\xfcnc\xfc",
        6: "'nc\u0131",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'\u0131nc\u0131",
        90: "'\u0131nc\u0131"
    };
    moment.defineLocale("tr", {
        months: "Ocak_\u015Eubat_Mart_Nisan_May\u0131s_Haziran_Temmuz_A\u011Fustos_Eyl\xfcl_Ekim_Kas\u0131m_Aral\u0131k".split("_"),
        monthsShort: "Oca_\u015Eub_Mar_Nis_May_Haz_Tem_A\u011Fu_Eyl_Eki_Kas_Ara".split("_"),
        weekdays: "Pazar_Pazartesi_Sal\u0131_\xc7ar\u015Famba_Per\u015Fembe_Cuma_Cumartesi".split("_"),
        weekdaysShort: "Paz_Pzt_Sal_\xc7ar_Per_Cum_Cmt".split("_"),
        weekdaysMin: "Pz_Pt_Sa_\xc7a_Pe_Cu_Ct".split("_"),
        meridiem: function(hours, minutes, isLower) {
            if (hours < 12) return isLower ? "\xf6\xf6" : "\xd6\xd6";
            else return isLower ? "\xf6s" : "\xd6S";
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function(input) {
            return input === "\xf6s" || input === "\xd6S";
        },
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[bug\xfcn saat] LT",
            nextDay: "[yar\u0131n saat] LT",
            nextWeek: "[gelecek] dddd [saat] LT",
            lastDay: "[d\xfcn] LT",
            lastWeek: "[ge\xe7en] dddd [saat] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s sonra",
            past: "%s \xf6nce",
            s: "birka\xe7 saniye",
            ss: "%d saniye",
            m: "bir dakika",
            mm: "%d dakika",
            h: "bir saat",
            hh: "%d saat",
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            w: "bir hafta",
            ww: "%d hafta",
            M: "bir ay",
            MM: "%d ay",
            y: "bir y\u0131l",
            yy: "%d y\u0131l"
        },
        ordinal: function(number, period) {
            switch(period){
                case "d":
                case "D":
                case "Do":
                case "DD":
                    return number;
                default:
                    if (number === 0) // special case for zero
                    return number + "'\u0131nc\u0131";
                    var a = number % 10, b = number % 100 - a, c = number >= 100 ? 100 : null;
                    return number + (suffixes$5[a] || suffixes$5[b] || suffixes$5[c]);
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    moment.defineLocale("tzl", {
        months: "Januar_Fevraglh_Mar\xe7_Avr\xefu_Mai_G\xfcn_Julia_Guscht_Setemvar_Listop\xe4ts_Noemvar_Zecemvar".split("_"),
        monthsShort: "Jan_Fev_Mar_Avr_Mai_G\xfcn_Jul_Gus_Set_Lis_Noe_Zec".split("_"),
        weekdays: "S\xfaladi_L\xfane\xe7i_Maitzi_M\xe1rcuri_Xh\xfaadi_Vi\xe9ner\xe7i_S\xe1turi".split("_"),
        weekdaysShort: "S\xfal_L\xfan_Mai_M\xe1r_Xh\xfa_Vi\xe9_S\xe1t".split("_"),
        weekdaysMin: "S\xfa_L\xfa_Ma_M\xe1_Xh_Vi_S\xe1".split("_"),
        longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM [dallas] YYYY",
            LLL: "D. MMMM [dallas] YYYY HH.mm",
            LLLL: "dddd, [li] D. MMMM [dallas] YYYY HH.mm"
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function(input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours > 11) return isLower ? "d'o" : "D'O";
            else return isLower ? "d'a" : "D'A";
        },
        calendar: {
            sameDay: "[oxhi \xe0] LT",
            nextDay: "[dem\xe0 \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[ieiri \xe0] LT",
            lastWeek: "[s\xfcr el] dddd [lasteu \xe0] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "osprei %s",
            past: "ja%s",
            s: processRelativeTime$a,
            ss: processRelativeTime$a,
            m: processRelativeTime$a,
            mm: processRelativeTime$a,
            h: processRelativeTime$a,
            hh: processRelativeTime$a,
            d: processRelativeTime$a,
            dd: processRelativeTime$a,
            M: processRelativeTime$a,
            MM: processRelativeTime$a,
            y: processRelativeTime$a,
            yy: processRelativeTime$a
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    function processRelativeTime$a(number, withoutSuffix, key, isFuture) {
        var format = {
            s: [
                "viensas secunds",
                "'iensas secunds"
            ],
            ss: [
                number + " secunds",
                "" + number + " secunds"
            ],
            m: [
                "'n m\xedut",
                "'iens m\xedut"
            ],
            mm: [
                number + " m\xeduts",
                "" + number + " m\xeduts"
            ],
            h: [
                "'n \xfeora",
                "'iensa \xfeora"
            ],
            hh: [
                number + " \xfeoras",
                "" + number + " \xfeoras"
            ],
            d: [
                "'n ziua",
                "'iensa ziua"
            ],
            dd: [
                number + " ziuas",
                "" + number + " ziuas"
            ],
            M: [
                "'n mes",
                "'iens mes"
            ],
            MM: [
                number + " mesen",
                "" + number + " mesen"
            ],
            y: [
                "'n ar",
                "'iens ar"
            ],
            yy: [
                number + " ars",
                "" + number + " ars"
            ]
        };
        return isFuture ? format[key][0] : withoutSuffix ? format[key][0] : format[key][1];
    }
    //! moment.js locale configuration
    moment.defineLocale("tzm-latn", {
        months: "innayr_br\u02E4ayr\u02E4_mar\u02E4s\u02E4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02E4wbr\u02E4_nwwanbir_dwjnbir".split("_"),
        monthsShort: "innayr_br\u02E4ayr\u02E4_mar\u02E4s\u02E4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02E4wbr\u02E4_nwwanbir_dwjnbir".split("_"),
        weekdays: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1E0Dyas".split("_"),
        weekdaysShort: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1E0Dyas".split("_"),
        weekdaysMin: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1E0Dyas".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[asdkh g] LT",
            nextDay: "[aska g] LT",
            nextWeek: "dddd [g] LT",
            lastDay: "[assant g] LT",
            lastWeek: "dddd [g] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dadkh s yan %s",
            past: "yan %s",
            s: "imik",
            ss: "%d imik",
            m: "minu\u1E0D",
            mm: "%d minu\u1E0D",
            h: "sa\u025Ba",
            hh: "%d tassa\u025Bin",
            d: "ass",
            dd: "%d ossan",
            M: "ayowr",
            MM: "%d iyyirn",
            y: "asgas",
            yy: "%d isgasn"
        },
        week: {
            dow: 6,
            doy: 12
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("tzm", {
        months: "\u2D49\u2D4F\u2D4F\u2D30\u2D62\u2D54_\u2D31\u2D55\u2D30\u2D62\u2D55_\u2D4E\u2D30\u2D55\u2D5A_\u2D49\u2D31\u2D54\u2D49\u2D54_\u2D4E\u2D30\u2D62\u2D62\u2D53_\u2D62\u2D53\u2D4F\u2D62\u2D53_\u2D62\u2D53\u2D4D\u2D62\u2D53\u2D63_\u2D56\u2D53\u2D5B\u2D5C_\u2D5B\u2D53\u2D5C\u2D30\u2D4F\u2D31\u2D49\u2D54_\u2D3D\u2D5F\u2D53\u2D31\u2D55_\u2D4F\u2D53\u2D61\u2D30\u2D4F\u2D31\u2D49\u2D54_\u2D37\u2D53\u2D4A\u2D4F\u2D31\u2D49\u2D54".split("_"),
        monthsShort: "\u2D49\u2D4F\u2D4F\u2D30\u2D62\u2D54_\u2D31\u2D55\u2D30\u2D62\u2D55_\u2D4E\u2D30\u2D55\u2D5A_\u2D49\u2D31\u2D54\u2D49\u2D54_\u2D4E\u2D30\u2D62\u2D62\u2D53_\u2D62\u2D53\u2D4F\u2D62\u2D53_\u2D62\u2D53\u2D4D\u2D62\u2D53\u2D63_\u2D56\u2D53\u2D5B\u2D5C_\u2D5B\u2D53\u2D5C\u2D30\u2D4F\u2D31\u2D49\u2D54_\u2D3D\u2D5F\u2D53\u2D31\u2D55_\u2D4F\u2D53\u2D61\u2D30\u2D4F\u2D31\u2D49\u2D54_\u2D37\u2D53\u2D4A\u2D4F\u2D31\u2D49\u2D54".split("_"),
        weekdays: "\u2D30\u2D59\u2D30\u2D4E\u2D30\u2D59_\u2D30\u2D62\u2D4F\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4F\u2D30\u2D59_\u2D30\u2D3D\u2D54\u2D30\u2D59_\u2D30\u2D3D\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4E\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D39\u2D62\u2D30\u2D59".split("_"),
        weekdaysShort: "\u2D30\u2D59\u2D30\u2D4E\u2D30\u2D59_\u2D30\u2D62\u2D4F\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4F\u2D30\u2D59_\u2D30\u2D3D\u2D54\u2D30\u2D59_\u2D30\u2D3D\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4E\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D39\u2D62\u2D30\u2D59".split("_"),
        weekdaysMin: "\u2D30\u2D59\u2D30\u2D4E\u2D30\u2D59_\u2D30\u2D62\u2D4F\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4F\u2D30\u2D59_\u2D30\u2D3D\u2D54\u2D30\u2D59_\u2D30\u2D3D\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4E\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D39\u2D62\u2D30\u2D59".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u2D30\u2D59\u2D37\u2D45 \u2D34] LT",
            nextDay: "[\u2D30\u2D59\u2D3D\u2D30 \u2D34] LT",
            nextWeek: "dddd [\u2D34] LT",
            lastDay: "[\u2D30\u2D5A\u2D30\u2D4F\u2D5C \u2D34] LT",
            lastWeek: "dddd [\u2D34] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u2D37\u2D30\u2D37\u2D45 \u2D59 \u2D62\u2D30\u2D4F %s",
            past: "\u2D62\u2D30\u2D4F %s",
            s: "\u2D49\u2D4E\u2D49\u2D3D",
            ss: "%d \u2D49\u2D4E\u2D49\u2D3D",
            m: "\u2D4E\u2D49\u2D4F\u2D53\u2D3A",
            mm: "%d \u2D4E\u2D49\u2D4F\u2D53\u2D3A",
            h: "\u2D59\u2D30\u2D44\u2D30",
            hh: "%d \u2D5C\u2D30\u2D59\u2D59\u2D30\u2D44\u2D49\u2D4F",
            d: "\u2D30\u2D59\u2D59",
            dd: "%d o\u2D59\u2D59\u2D30\u2D4F",
            M: "\u2D30\u2D62o\u2D53\u2D54",
            MM: "%d \u2D49\u2D62\u2D62\u2D49\u2D54\u2D4F",
            y: "\u2D30\u2D59\u2D33\u2D30\u2D59",
            yy: "%d \u2D49\u2D59\u2D33\u2D30\u2D59\u2D4F"
        },
        week: {
            dow: 6,
            doy: 12
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("ug-cn", {
        months: "\u064A\u0627\u0646\u06CB\u0627\u0631_\u0641\u06D0\u06CB\u0631\u0627\u0644_\u0645\u0627\u0631\u062A_\u0626\u0627\u067E\u0631\u06D0\u0644_\u0645\u0627\u064A_\u0626\u0649\u064A\u06C7\u0646_\u0626\u0649\u064A\u06C7\u0644_\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A_\u0633\u06D0\u0646\u062A\u06D5\u0628\u0649\u0631_\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631_\u0646\u0648\u064A\u0627\u0628\u0649\u0631_\u062F\u06D0\u0643\u0627\u0628\u0649\u0631".split("_"),
        monthsShort: "\u064A\u0627\u0646\u06CB\u0627\u0631_\u0641\u06D0\u06CB\u0631\u0627\u0644_\u0645\u0627\u0631\u062A_\u0626\u0627\u067E\u0631\u06D0\u0644_\u0645\u0627\u064A_\u0626\u0649\u064A\u06C7\u0646_\u0626\u0649\u064A\u06C7\u0644_\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A_\u0633\u06D0\u0646\u062A\u06D5\u0628\u0649\u0631_\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631_\u0646\u0648\u064A\u0627\u0628\u0649\u0631_\u062F\u06D0\u0643\u0627\u0628\u0649\u0631".split("_"),
        weekdays: "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5_\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5_\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5_\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5_\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5_\u062C\u06C8\u0645\u06D5_\u0634\u06D5\u0646\u0628\u06D5".split("_"),
        weekdaysShort: "\u064A\u06D5_\u062F\u06C8_\u0633\u06D5_\u0686\u0627_\u067E\u06D5_\u062C\u06C8_\u0634\u06D5".split("_"),
        weekdaysMin: "\u064A\u06D5_\u062F\u06C8_\u0633\u06D5_\u0686\u0627_\u067E\u06D5_\u062C\u06C8_\u0634\u06D5".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "YYYY-\u064A\u0649\u0644\u0649M-\u0626\u0627\u064A\u0646\u0649\u06ADD-\u0643\u06C8\u0646\u0649",
            LLL: "YYYY-\u064A\u0649\u0644\u0649M-\u0626\u0627\u064A\u0646\u0649\u06ADD-\u0643\u06C8\u0646\u0649\u060C HH:mm",
            LLLL: "dddd\u060C YYYY-\u064A\u0649\u0644\u0649M-\u0626\u0627\u064A\u0646\u0649\u06ADD-\u0643\u06C8\u0646\u0649\u060C HH:mm"
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u064A\u06D0\u0631\u0649\u0645 \u0643\u06D0\u0686\u06D5" || meridiem === "\u0633\u06D5\u06BE\u06D5\u0631" || meridiem === "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646") return hour;
            else if (meridiem === "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u06D0\u064A\u0649\u0646" || meridiem === "\u0643\u06D5\u0686") return hour + 12;
            else return hour >= 11 ? hour : hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) return "\u064A\u06D0\u0631\u0649\u0645 \u0643\u06D0\u0686\u06D5";
            else if (hm < 900) return "\u0633\u06D5\u06BE\u06D5\u0631";
            else if (hm < 1130) return "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646";
            else if (hm < 1230) return "\u0686\u06C8\u0634";
            else if (hm < 1800) return "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u06D0\u064A\u0649\u0646";
            else return "\u0643\u06D5\u0686";
        },
        calendar: {
            sameDay: "[\u0628\u06C8\u06AF\u06C8\u0646 \u0633\u0627\u0626\u06D5\u062A] LT",
            nextDay: "[\u0626\u06D5\u062A\u06D5 \u0633\u0627\u0626\u06D5\u062A] LT",
            nextWeek: "[\u0643\u06D0\u0644\u06D5\u0631\u0643\u0649] dddd [\u0633\u0627\u0626\u06D5\u062A] LT",
            lastDay: "[\u062A\u06C6\u0646\u06C8\u06AF\u06C8\u0646] LT",
            lastWeek: "[\u0626\u0627\u0644\u062F\u0649\u0646\u0642\u0649] dddd [\u0633\u0627\u0626\u06D5\u062A] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0643\u06D0\u064A\u0649\u0646",
            past: "%s \u0628\u06C7\u0631\u06C7\u0646",
            s: "\u0646\u06D5\u0686\u0686\u06D5 \u0633\u06D0\u0643\u0648\u0646\u062A",
            ss: "%d \u0633\u06D0\u0643\u0648\u0646\u062A",
            m: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
            mm: "%d \u0645\u0649\u0646\u06C7\u062A",
            h: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
            hh: "%d \u0633\u0627\u0626\u06D5\u062A",
            d: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
            dd: "%d \u0643\u06C8\u0646",
            M: "\u0628\u0649\u0631 \u0626\u0627\u064A",
            MM: "%d \u0626\u0627\u064A",
            y: "\u0628\u0649\u0631 \u064A\u0649\u0644",
            yy: "%d \u064A\u0649\u0644"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function(number, period) {
            switch(period){
                case "d":
                case "D":
                case "DDD":
                    return number + "-\u0643\u06C8\u0646\u0649";
                case "w":
                case "W":
                    return number + "-\u06BE\u06D5\u067E\u062A\u06D5";
                default:
                    return number;
            }
        },
        preparse: function(string) {
            return string.replace(/،/g, ",");
        },
        postformat: function(string) {
            return string.replace(/,/g, "\u060C");
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    function plural$6(word, num) {
        var forms = word.split("_");
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural$4(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? "\u0441\u0435\u043A\u0443\u043D\u0434\u0430_\u0441\u0435\u043A\u0443\u043D\u0434\u0438_\u0441\u0435\u043A\u0443\u043D\u0434" : "\u0441\u0435\u043A\u0443\u043D\u0434\u0443_\u0441\u0435\u043A\u0443\u043D\u0434\u0438_\u0441\u0435\u043A\u0443\u043D\u0434",
            mm: withoutSuffix ? "\u0445\u0432\u0438\u043B\u0438\u043D\u0430_\u0445\u0432\u0438\u043B\u0438\u043D\u0438_\u0445\u0432\u0438\u043B\u0438\u043D" : "\u0445\u0432\u0438\u043B\u0438\u043D\u0443_\u0445\u0432\u0438\u043B\u0438\u043D\u0438_\u0445\u0432\u0438\u043B\u0438\u043D",
            hh: withoutSuffix ? "\u0433\u043E\u0434\u0438\u043D\u0430_\u0433\u043E\u0434\u0438\u043D\u0438_\u0433\u043E\u0434\u0438\u043D" : "\u0433\u043E\u0434\u0438\u043D\u0443_\u0433\u043E\u0434\u0438\u043D\u0438_\u0433\u043E\u0434\u0438\u043D",
            dd: "\u0434\u0435\u043D\u044C_\u0434\u043D\u0456_\u0434\u043D\u0456\u0432",
            MM: "\u043C\u0456\u0441\u044F\u0446\u044C_\u043C\u0456\u0441\u044F\u0446\u0456_\u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            yy: "\u0440\u0456\u043A_\u0440\u043E\u043A\u0438_\u0440\u043E\u043A\u0456\u0432"
        };
        if (key === "m") return withoutSuffix ? "\u0445\u0432\u0438\u043B\u0438\u043D\u0430" : "\u0445\u0432\u0438\u043B\u0438\u043D\u0443";
        else if (key === "h") return withoutSuffix ? "\u0433\u043E\u0434\u0438\u043D\u0430" : "\u0433\u043E\u0434\u0438\u043D\u0443";
        else return number + " " + plural$6(format[key], +number);
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            nominative: "\u043D\u0435\u0434\u0456\u043B\u044F_\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A_\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A_\u0441\u0435\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440_\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F_\u0441\u0443\u0431\u043E\u0442\u0430".split("_"),
            accusative: "\u043D\u0435\u0434\u0456\u043B\u044E_\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A_\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A_\u0441\u0435\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440_\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E_\u0441\u0443\u0431\u043E\u0442\u0443".split("_"),
            genitive: "\u043D\u0435\u0434\u0456\u043B\u0456_\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043A\u0430_\u0432\u0456\u0432\u0442\u043E\u0440\u043A\u0430_\u0441\u0435\u0440\u0435\u0434\u0438_\u0447\u0435\u0442\u0432\u0435\u0440\u0433\u0430_\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u0456_\u0441\u0443\u0431\u043E\u0442\u0438".split("_")
        }, nounCase;
        if (m === true) return weekdays["nominative"].slice(1, 7).concat(weekdays["nominative"].slice(0, 1));
        if (!m) return weekdays["nominative"];
        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format) ? "accusative" : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format) ? "genitive" : "nominative";
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function() {
            return str + "\u043E" + (this.hours() === 11 ? "\u0431" : "") + "] LT";
        };
    }
    moment.defineLocale("uk", {
        months: {
            format: "\u0441\u0456\u0447\u043D\u044F_\u043B\u044E\u0442\u043E\u0433\u043E_\u0431\u0435\u0440\u0435\u0437\u043D\u044F_\u043A\u0432\u0456\u0442\u043D\u044F_\u0442\u0440\u0430\u0432\u043D\u044F_\u0447\u0435\u0440\u0432\u043D\u044F_\u043B\u0438\u043F\u043D\u044F_\u0441\u0435\u0440\u043F\u043D\u044F_\u0432\u0435\u0440\u0435\u0441\u043D\u044F_\u0436\u043E\u0432\u0442\u043D\u044F_\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430_\u0433\u0440\u0443\u0434\u043D\u044F".split("_"),
            standalone: "\u0441\u0456\u0447\u0435\u043D\u044C_\u043B\u044E\u0442\u0438\u0439_\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C_\u043A\u0432\u0456\u0442\u0435\u043D\u044C_\u0442\u0440\u0430\u0432\u0435\u043D\u044C_\u0447\u0435\u0440\u0432\u0435\u043D\u044C_\u043B\u0438\u043F\u0435\u043D\u044C_\u0441\u0435\u0440\u043F\u0435\u043D\u044C_\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C_\u0436\u043E\u0432\u0442\u0435\u043D\u044C_\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434_\u0433\u0440\u0443\u0434\u0435\u043D\u044C".split("_")
        },
        monthsShort: "\u0441\u0456\u0447_\u043B\u044E\u0442_\u0431\u0435\u0440_\u043A\u0432\u0456\u0442_\u0442\u0440\u0430\u0432_\u0447\u0435\u0440\u0432_\u043B\u0438\u043F_\u0441\u0435\u0440\u043F_\u0432\u0435\u0440_\u0436\u043E\u0432\u0442_\u043B\u0438\u0441\u0442_\u0433\u0440\u0443\u0434".split("_"),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: "\u043D\u0434_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
        weekdaysMin: "\u043D\u0434_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0440.",
            LLL: "D MMMM YYYY \u0440., HH:mm",
            LLLL: "dddd, D MMMM YYYY \u0440., HH:mm"
        },
        calendar: {
            sameDay: processHoursFunction("[\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456 "),
            nextDay: processHoursFunction("[\u0417\u0430\u0432\u0442\u0440\u0430 "),
            lastDay: processHoursFunction("[\u0412\u0447\u043E\u0440\u0430 "),
            nextWeek: processHoursFunction("[\u0423] dddd ["),
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction("[\u041C\u0438\u043D\u0443\u043B\u043E\u0457] dddd [").call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction("[\u041C\u0438\u043D\u0443\u043B\u043E\u0433\u043E] dddd [").call(this);
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0437\u0430 %s",
            past: "%s \u0442\u043E\u043C\u0443",
            s: "\u0434\u0435\u043A\u0456\u043B\u044C\u043A\u0430 \u0441\u0435\u043A\u0443\u043D\u0434",
            ss: relativeTimeWithPlural$4,
            m: relativeTimeWithPlural$4,
            mm: relativeTimeWithPlural$4,
            h: "\u0433\u043E\u0434\u0438\u043D\u0443",
            hh: relativeTimeWithPlural$4,
            d: "\u0434\u0435\u043D\u044C",
            dd: relativeTimeWithPlural$4,
            M: "\u043C\u0456\u0441\u044F\u0446\u044C",
            MM: relativeTimeWithPlural$4,
            y: "\u0440\u0456\u043A",
            yy: relativeTimeWithPlural$4
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function(input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u043D\u043E\u0447\u0456";
            else if (hour < 12) return "\u0440\u0430\u043D\u043A\u0443";
            else if (hour < 17) return "\u0434\u043D\u044F";
            else return "\u0432\u0435\u0447\u043E\u0440\u0430";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function(number, period) {
            switch(period){
                case "M":
                case "d":
                case "DDD":
                case "w":
                case "W":
                    return number + "-\u0439";
                case "D":
                    return number + "-\u0433\u043E";
                default:
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    var months$a = [
        "\u062C\u0646\u0648\u0631\u06CC",
        "\u0641\u0631\u0648\u0631\u06CC",
        "\u0645\u0627\u0631\u0686",
        "\u0627\u067E\u0631\u06CC\u0644",
        "\u0645\u0626\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u0626\u06CC",
        "\u0627\u06AF\u0633\u062A",
        "\u0633\u062A\u0645\u0628\u0631",
        "\u0627\u06A9\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0645\u0628\u0631",
        "\u062F\u0633\u0645\u0628\u0631"
    ], days$1 = [
        "\u0627\u062A\u0648\u0627\u0631",
        "\u067E\u06CC\u0631",
        "\u0645\u0646\u06AF\u0644",
        "\u0628\u062F\u06BE",
        "\u062C\u0645\u0639\u0631\u0627\u062A",
        "\u062C\u0645\u0639\u06C1",
        "\u06C1\u0641\u062A\u06C1"
    ];
    moment.defineLocale("ur", {
        months: months$a,
        monthsShort: months$a,
        weekdays: days$1,
        weekdaysShort: days$1,
        weekdaysMin: days$1,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd\u060C D MMMM YYYY HH:mm"
        },
        meridiemParse: /صبح|شام/,
        isPM: function(input) {
            return "\u0634\u0627\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635\u0628\u062D";
            return "\u0634\u0627\u0645";
        },
        calendar: {
            sameDay: "[\u0622\u062C \u0628\u0648\u0642\u062A] LT",
            nextDay: "[\u06A9\u0644 \u0628\u0648\u0642\u062A] LT",
            nextWeek: "dddd [\u0628\u0648\u0642\u062A] LT",
            lastDay: "[\u06AF\u0630\u0634\u062A\u06C1 \u0631\u0648\u0632 \u0628\u0648\u0642\u062A] LT",
            lastWeek: "[\u06AF\u0630\u0634\u062A\u06C1] dddd [\u0628\u0648\u0642\u062A] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0628\u0639\u062F",
            past: "%s \u0642\u0628\u0644",
            s: "\u0686\u0646\u062F \u0633\u06CC\u06A9\u0646\u0688",
            ss: "%d \u0633\u06CC\u06A9\u0646\u0688",
            m: "\u0627\u06CC\u06A9 \u0645\u0646\u0679",
            mm: "%d \u0645\u0646\u0679",
            h: "\u0627\u06CC\u06A9 \u06AF\u06BE\u0646\u0679\u06C1",
            hh: "%d \u06AF\u06BE\u0646\u0679\u06D2",
            d: "\u0627\u06CC\u06A9 \u062F\u0646",
            dd: "%d \u062F\u0646",
            M: "\u0627\u06CC\u06A9 \u0645\u0627\u06C1",
            MM: "%d \u0645\u0627\u06C1",
            y: "\u0627\u06CC\u06A9 \u0633\u0627\u0644",
            yy: "%d \u0633\u0627\u0644"
        },
        preparse: function(string) {
            return string.replace(/،/g, ",");
        },
        postformat: function(string) {
            return string.replace(/,/g, "\u060C");
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("uz-latn", {
        months: "Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split("_"),
        monthsShort: "Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),
        weekdays: "Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split("_"),
        weekdaysShort: "Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),
        weekdaysMin: "Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "D MMMM YYYY, dddd HH:mm"
        },
        calendar: {
            sameDay: "[Bugun soat] LT [da]",
            nextDay: "[Ertaga] LT [da]",
            nextWeek: "dddd [kuni soat] LT [da]",
            lastDay: "[Kecha soat] LT [da]",
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: "L"
        },
        relativeTime: {
            future: "Yaqin %s ichida",
            past: "Bir necha %s oldin",
            s: "soniya",
            ss: "%d soniya",
            m: "bir daqiqa",
            mm: "%d daqiqa",
            h: "bir soat",
            hh: "%d soat",
            d: "bir kun",
            dd: "%d kun",
            M: "bir oy",
            MM: "%d oy",
            y: "bir yil",
            yy: "%d yil"
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("uz", {
        months: "\u044F\u043D\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043B_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B_\u043C\u0430\u0439_\u0438\u044E\u043D_\u0438\u044E\u043B_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440_\u043E\u043A\u0442\u044F\u0431\u0440_\u043D\u043E\u044F\u0431\u0440_\u0434\u0435\u043A\u0430\u0431\u0440".split("_"),
        monthsShort: "\u044F\u043D\u0432_\u0444\u0435\u0432_\u043C\u0430\u0440_\u0430\u043F\u0440_\u043C\u0430\u0439_\u0438\u044E\u043D_\u0438\u044E\u043B_\u0430\u0432\u0433_\u0441\u0435\u043D_\u043E\u043A\u0442_\u043D\u043E\u044F_\u0434\u0435\u043A".split("_"),
        weekdays: "\u042F\u043A\u0448\u0430\u043D\u0431\u0430_\u0414\u0443\u0448\u0430\u043D\u0431\u0430_\u0421\u0435\u0448\u0430\u043D\u0431\u0430_\u0427\u043E\u0440\u0448\u0430\u043D\u0431\u0430_\u041F\u0430\u0439\u0448\u0430\u043D\u0431\u0430_\u0416\u0443\u043C\u0430_\u0428\u0430\u043D\u0431\u0430".split("_"),
        weekdaysShort: "\u042F\u043A\u0448_\u0414\u0443\u0448_\u0421\u0435\u0448_\u0427\u043E\u0440_\u041F\u0430\u0439_\u0416\u0443\u043C_\u0428\u0430\u043D".split("_"),
        weekdaysMin: "\u042F\u043A_\u0414\u0443_\u0421\u0435_\u0427\u043E_\u041F\u0430_\u0416\u0443_\u0428\u0430".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "D MMMM YYYY, dddd HH:mm"
        },
        calendar: {
            sameDay: "[\u0411\u0443\u0433\u0443\u043D \u0441\u043E\u0430\u0442] LT [\u0434\u0430]",
            nextDay: "[\u042D\u0440\u0442\u0430\u0433\u0430] LT [\u0434\u0430]",
            nextWeek: "dddd [\u043A\u0443\u043D\u0438 \u0441\u043E\u0430\u0442] LT [\u0434\u0430]",
            lastDay: "[\u041A\u0435\u0447\u0430 \u0441\u043E\u0430\u0442] LT [\u0434\u0430]",
            lastWeek: "[\u0423\u0442\u0433\u0430\u043D] dddd [\u043A\u0443\u043D\u0438 \u0441\u043E\u0430\u0442] LT [\u0434\u0430]",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u042F\u043A\u0438\u043D %s \u0438\u0447\u0438\u0434\u0430",
            past: "\u0411\u0438\u0440 \u043D\u0435\u0447\u0430 %s \u043E\u043B\u0434\u0438\u043D",
            s: "\u0444\u0443\u0440\u0441\u0430\u0442",
            ss: "%d \u0444\u0443\u0440\u0441\u0430\u0442",
            m: "\u0431\u0438\u0440 \u0434\u0430\u043A\u0438\u043A\u0430",
            mm: "%d \u0434\u0430\u043A\u0438\u043A\u0430",
            h: "\u0431\u0438\u0440 \u0441\u043E\u0430\u0442",
            hh: "%d \u0441\u043E\u0430\u0442",
            d: "\u0431\u0438\u0440 \u043A\u0443\u043D",
            dd: "%d \u043A\u0443\u043D",
            M: "\u0431\u0438\u0440 \u043E\u0439",
            MM: "%d \u043E\u0439",
            y: "\u0431\u0438\u0440 \u0439\u0438\u043B",
            yy: "%d \u0439\u0438\u043B"
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("vi", {
        months: "th\xe1ng 1_th\xe1ng 2_th\xe1ng 3_th\xe1ng 4_th\xe1ng 5_th\xe1ng 6_th\xe1ng 7_th\xe1ng 8_th\xe1ng 9_th\xe1ng 10_th\xe1ng 11_th\xe1ng 12".split("_"),
        monthsShort: "Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12".split("_"),
        monthsParseExact: true,
        weekdays: "ch\u1EE7 nh\u1EADt_th\u1EE9 hai_th\u1EE9 ba_th\u1EE9 t\u01B0_th\u1EE9 n\u0103m_th\u1EE9 s\xe1u_th\u1EE9 b\u1EA3y".split("_"),
        weekdaysShort: "CN_T2_T3_T4_T5_T6_T7".split("_"),
        weekdaysMin: "CN_T2_T3_T4_T5_T6_T7".split("_"),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function(input) {
            return /^ch$/i.test(input);
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 12) return isLower ? "sa" : "SA";
            else return isLower ? "ch" : "CH";
        },
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM [n\u0103m] YYYY",
            LLL: "D MMMM [n\u0103m] YYYY HH:mm",
            LLLL: "dddd, D MMMM [n\u0103m] YYYY HH:mm",
            l: "DD/M/YYYY",
            ll: "D MMM YYYY",
            lll: "D MMM YYYY HH:mm",
            llll: "ddd, D MMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[H\xf4m nay l\xfac] LT",
            nextDay: "[Ng\xe0y mai l\xfac] LT",
            nextWeek: "dddd [tu\u1EA7n t\u1EDBi l\xfac] LT",
            lastDay: "[H\xf4m qua l\xfac] LT",
            lastWeek: "dddd [tu\u1EA7n tr\u01B0\u1EDBc l\xfac] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s t\u1EDBi",
            past: "%s tr\u01B0\u1EDBc",
            s: "v\xe0i gi\xe2y",
            ss: "%d gi\xe2y",
            m: "m\u1ED9t ph\xfat",
            mm: "%d ph\xfat",
            h: "m\u1ED9t gi\u1EDD",
            hh: "%d gi\u1EDD",
            d: "m\u1ED9t ng\xe0y",
            dd: "%d ng\xe0y",
            w: "m\u1ED9t tu\u1EA7n",
            ww: "%d tu\u1EA7n",
            M: "m\u1ED9t th\xe1ng",
            MM: "%d th\xe1ng",
            y: "m\u1ED9t n\u0103m",
            yy: "%d n\u0103m"
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function(number) {
            return number;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("x-pseudo", {
        months: "J~\xe1\xf1\xfa\xe1~r\xfd_F~\xe9br\xfa~\xe1r\xfd_~M\xe1rc~h_\xc1p~r\xedl_~M\xe1\xfd_~J\xfa\xf1\xe9~_J\xfal~\xfd_\xc1\xfa~g\xfast~_S\xe9p~t\xe9mb~\xe9r_\xd3~ct\xf3b~\xe9r_\xd1~\xf3v\xe9m~b\xe9r_~D\xe9c\xe9~mb\xe9r".split("_"),
        monthsShort: "J~\xe1\xf1_~F\xe9b_~M\xe1r_~\xc1pr_~M\xe1\xfd_~J\xfa\xf1_~J\xfal_~\xc1\xfag_~S\xe9p_~\xd3ct_~\xd1\xf3v_~D\xe9c".split("_"),
        monthsParseExact: true,
        weekdays: "S~\xfa\xf1d\xe1~\xfd_M\xf3~\xf1d\xe1\xfd~_T\xfa\xe9~sd\xe1\xfd~_W\xe9d~\xf1\xe9sd~\xe1\xfd_T~h\xfars~d\xe1\xfd_~Fr\xedd~\xe1\xfd_S~\xe1t\xfar~d\xe1\xfd".split("_"),
        weekdaysShort: "S~\xfa\xf1_~M\xf3\xf1_~T\xfa\xe9_~W\xe9d_~Th\xfa_~Fr\xed_~S\xe1t".split("_"),
        weekdaysMin: "S~\xfa_M\xf3~_T\xfa_~W\xe9_T~h_Fr~_S\xe1".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[T~\xf3d\xe1~\xfd \xe1t] LT",
            nextDay: "[T~\xf3m\xf3~rr\xf3~w \xe1t] LT",
            nextWeek: "dddd [\xe1t] LT",
            lastDay: "[\xdd~\xe9st~\xe9rd\xe1~\xfd \xe1t] LT",
            lastWeek: "[L~\xe1st] dddd [\xe1t] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\xed~\xf1 %s",
            past: "%s \xe1~g\xf3",
            s: "\xe1 ~f\xe9w ~s\xe9c\xf3~\xf1ds",
            ss: "%d s~\xe9c\xf3\xf1~ds",
            m: "\xe1 ~m\xed\xf1~\xfat\xe9",
            mm: "%d m~\xed\xf1\xfa~t\xe9s",
            h: "\xe1~\xf1 h\xf3~\xfar",
            hh: "%d h~\xf3\xfars",
            d: "\xe1 ~d\xe1\xfd",
            dd: "%d d~\xe1\xfds",
            M: "\xe1 ~m\xf3\xf1~th",
            MM: "%d m~\xf3\xf1t~hs",
            y: "\xe1 ~\xfd\xe9\xe1r",
            yy: "%d \xfd~\xe9\xe1rs"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("yo", {
        months: "S\u1EB9\u0301r\u1EB9\u0301_E\u0300re\u0300le\u0300_\u1EB8r\u1EB9\u0300na\u0300_I\u0300gbe\u0301_E\u0300bibi_O\u0300ku\u0300du_Ag\u1EB9mo_O\u0300gu\u0301n_Owewe_\u1ECC\u0300wa\u0300ra\u0300_Be\u0301lu\u0301_\u1ECC\u0300p\u1EB9\u0300\u0300".split("_"),
        monthsShort: "S\u1EB9\u0301r_E\u0300rl_\u1EB8rn_I\u0300gb_E\u0300bi_O\u0300ku\u0300_Ag\u1EB9_O\u0300gu\u0301_Owe_\u1ECC\u0300wa\u0300_Be\u0301l_\u1ECC\u0300p\u1EB9\u0300\u0300".split("_"),
        weekdays: "A\u0300i\u0300ku\u0301_Aje\u0301_I\u0300s\u1EB9\u0301gun_\u1ECCj\u1ECD\u0301ru\u0301_\u1ECCj\u1ECD\u0301b\u1ECD_\u1EB8ti\u0300_A\u0300ba\u0301m\u1EB9\u0301ta".split("_"),
        weekdaysShort: "A\u0300i\u0300k_Aje\u0301_I\u0300s\u1EB9\u0301_\u1ECCjr_\u1ECCjb_\u1EB8ti\u0300_A\u0300ba\u0301".split("_"),
        weekdaysMin: "A\u0300i\u0300_Aj_I\u0300s_\u1ECCr_\u1ECCb_\u1EB8t_A\u0300b".split("_"),
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
            sameDay: "[O\u0300ni\u0300 ni] LT",
            nextDay: "[\u1ECC\u0300la ni] LT",
            nextWeek: "dddd [\u1ECCs\u1EB9\u0300 to\u0301n'b\u1ECD] [ni] LT",
            lastDay: "[A\u0300na ni] LT",
            lastWeek: "dddd [\u1ECCs\u1EB9\u0300 to\u0301l\u1ECD\u0301] [ni] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "ni\u0301 %s",
            past: "%s k\u1ECDja\u0301",
            s: "i\u0300s\u1EB9ju\u0301 aaya\u0301 die",
            ss: "aaya\u0301 %d",
            m: "i\u0300s\u1EB9ju\u0301 kan",
            mm: "i\u0300s\u1EB9ju\u0301 %d",
            h: "wa\u0301kati kan",
            hh: "wa\u0301kati %d",
            d: "\u1ECDj\u1ECD\u0301 kan",
            dd: "\u1ECDj\u1ECD\u0301 %d",
            M: "osu\u0300 kan",
            MM: "osu\u0300 %d",
            y: "\u1ECDdu\u0301n kan",
            yy: "\u1ECDdu\u0301n %d"
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: "\u1ECDj\u1ECD\u0301 %d",
        week: {
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("zh-cn", {
        months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split("_"),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
        weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split("_"),
        weekdaysShort: "\u5468\u65E5_\u5468\u4E00_\u5468\u4E8C_\u5468\u4E09_\u5468\u56DB_\u5468\u4E94_\u5468\u516D".split("_"),
        weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY\u5E74M\u6708D\u65E5",
            LLL: "YYYY\u5E74M\u6708D\u65E5Ah\u70B9mm\u5206",
            LLLL: "YYYY\u5E74M\u6708D\u65E5ddddAh\u70B9mm\u5206",
            l: "YYYY/M/D",
            ll: "YYYY\u5E74M\u6708D\u65E5",
            lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm"
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u51CC\u6668" || meridiem === "\u65E9\u4E0A" || meridiem === "\u4E0A\u5348") return hour;
            else if (meridiem === "\u4E0B\u5348" || meridiem === "\u665A\u4E0A") return hour + 12;
            else // '中午'
            return hour >= 11 ? hour : hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) return "\u51CC\u6668";
            else if (hm < 900) return "\u65E9\u4E0A";
            else if (hm < 1130) return "\u4E0A\u5348";
            else if (hm < 1230) return "\u4E2D\u5348";
            else if (hm < 1800) return "\u4E0B\u5348";
            else return "\u665A\u4E0A";
        },
        calendar: {
            sameDay: "[\u4ECA\u5929]LT",
            nextDay: "[\u660E\u5929]LT",
            nextWeek: function(now) {
                if (now.week() !== this.week()) return "[\u4E0B]dddLT";
                else return "[\u672C]dddLT";
            },
            lastDay: "[\u6628\u5929]LT",
            lastWeek: function(now) {
                if (this.week() !== now.week()) return "[\u4E0A]dddLT";
                else return "[\u672C]dddLT";
            },
            sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function(number, period) {
            switch(period){
                case "d":
                case "D":
                case "DDD":
                    return number + "\u65E5";
                case "M":
                    return number + "\u6708";
                case "w":
                case "W":
                    return number + "\u5468";
                default:
                    return number;
            }
        },
        relativeTime: {
            future: "%s\u540E",
            past: "%s\u524D",
            s: "\u51E0\u79D2",
            ss: "%d \u79D2",
            m: "1 \u5206\u949F",
            mm: "%d \u5206\u949F",
            h: "1 \u5C0F\u65F6",
            hh: "%d \u5C0F\u65F6",
            d: "1 \u5929",
            dd: "%d \u5929",
            w: "1 \u5468",
            ww: "%d \u5468",
            M: "1 \u4E2A\u6708",
            MM: "%d \u4E2A\u6708",
            y: "1 \u5E74",
            yy: "%d \u5E74"
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1,
            doy: 4
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("zh-hk", {
        months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split("_"),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
        weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split("_"),
        weekdaysShort: "\u9031\u65E5_\u9031\u4E00_\u9031\u4E8C_\u9031\u4E09_\u9031\u56DB_\u9031\u4E94_\u9031\u516D".split("_"),
        weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY\u5E74M\u6708D\u65E5",
            LLL: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            LLLL: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm",
            l: "YYYY/M/D",
            ll: "YYYY\u5E74M\u6708D\u65E5",
            lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm"
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u51CC\u6668" || meridiem === "\u65E9\u4E0A" || meridiem === "\u4E0A\u5348") return hour;
            else if (meridiem === "\u4E2D\u5348") return hour >= 11 ? hour : hour + 12;
            else if (meridiem === "\u4E0B\u5348" || meridiem === "\u665A\u4E0A") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) return "\u51CC\u6668";
            else if (hm < 900) return "\u65E9\u4E0A";
            else if (hm < 1200) return "\u4E0A\u5348";
            else if (hm === 1200) return "\u4E2D\u5348";
            else if (hm < 1800) return "\u4E0B\u5348";
            else return "\u665A\u4E0A";
        },
        calendar: {
            sameDay: "[\u4ECA\u5929]LT",
            nextDay: "[\u660E\u5929]LT",
            nextWeek: "[\u4E0B]ddddLT",
            lastDay: "[\u6628\u5929]LT",
            lastWeek: "[\u4E0A]ddddLT",
            sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function(number, period) {
            switch(period){
                case "d":
                case "D":
                case "DDD":
                    return number + "\u65E5";
                case "M":
                    return number + "\u6708";
                case "w":
                case "W":
                    return number + "\u9031";
                default:
                    return number;
            }
        },
        relativeTime: {
            future: "%s\u5F8C",
            past: "%s\u524D",
            s: "\u5E7E\u79D2",
            ss: "%d \u79D2",
            m: "1 \u5206\u9418",
            mm: "%d \u5206\u9418",
            h: "1 \u5C0F\u6642",
            hh: "%d \u5C0F\u6642",
            d: "1 \u5929",
            dd: "%d \u5929",
            M: "1 \u500B\u6708",
            MM: "%d \u500B\u6708",
            y: "1 \u5E74",
            yy: "%d \u5E74"
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("zh-mo", {
        months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split("_"),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
        weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split("_"),
        weekdaysShort: "\u9031\u65E5_\u9031\u4E00_\u9031\u4E8C_\u9031\u4E09_\u9031\u56DB_\u9031\u4E94_\u9031\u516D".split("_"),
        weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "YYYY\u5E74M\u6708D\u65E5",
            LLL: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            LLLL: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm",
            l: "D/M/YYYY",
            ll: "YYYY\u5E74M\u6708D\u65E5",
            lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm"
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u51CC\u6668" || meridiem === "\u65E9\u4E0A" || meridiem === "\u4E0A\u5348") return hour;
            else if (meridiem === "\u4E2D\u5348") return hour >= 11 ? hour : hour + 12;
            else if (meridiem === "\u4E0B\u5348" || meridiem === "\u665A\u4E0A") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) return "\u51CC\u6668";
            else if (hm < 900) return "\u65E9\u4E0A";
            else if (hm < 1130) return "\u4E0A\u5348";
            else if (hm < 1230) return "\u4E2D\u5348";
            else if (hm < 1800) return "\u4E0B\u5348";
            else return "\u665A\u4E0A";
        },
        calendar: {
            sameDay: "[\u4ECA\u5929] LT",
            nextDay: "[\u660E\u5929] LT",
            nextWeek: "[\u4E0B]dddd LT",
            lastDay: "[\u6628\u5929] LT",
            lastWeek: "[\u4E0A]dddd LT",
            sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function(number, period) {
            switch(period){
                case "d":
                case "D":
                case "DDD":
                    return number + "\u65E5";
                case "M":
                    return number + "\u6708";
                case "w":
                case "W":
                    return number + "\u9031";
                default:
                    return number;
            }
        },
        relativeTime: {
            future: "%s\u5167",
            past: "%s\u524D",
            s: "\u5E7E\u79D2",
            ss: "%d \u79D2",
            m: "1 \u5206\u9418",
            mm: "%d \u5206\u9418",
            h: "1 \u5C0F\u6642",
            hh: "%d \u5C0F\u6642",
            d: "1 \u5929",
            dd: "%d \u5929",
            M: "1 \u500B\u6708",
            MM: "%d \u500B\u6708",
            y: "1 \u5E74",
            yy: "%d \u5E74"
        }
    });
    //! moment.js locale configuration
    moment.defineLocale("zh-tw", {
        months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split("_"),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
        weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split("_"),
        weekdaysShort: "\u9031\u65E5_\u9031\u4E00_\u9031\u4E8C_\u9031\u4E09_\u9031\u56DB_\u9031\u4E94_\u9031\u516D".split("_"),
        weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY\u5E74M\u6708D\u65E5",
            LLL: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            LLLL: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm",
            l: "YYYY/M/D",
            ll: "YYYY\u5E74M\u6708D\u65E5",
            lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
            llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm"
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function(hour, meridiem) {
            if (hour === 12) hour = 0;
            if (meridiem === "\u51CC\u6668" || meridiem === "\u65E9\u4E0A" || meridiem === "\u4E0A\u5348") return hour;
            else if (meridiem === "\u4E2D\u5348") return hour >= 11 ? hour : hour + 12;
            else if (meridiem === "\u4E0B\u5348" || meridiem === "\u665A\u4E0A") return hour + 12;
        },
        meridiem: function(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) return "\u51CC\u6668";
            else if (hm < 900) return "\u65E9\u4E0A";
            else if (hm < 1130) return "\u4E0A\u5348";
            else if (hm < 1230) return "\u4E2D\u5348";
            else if (hm < 1800) return "\u4E0B\u5348";
            else return "\u665A\u4E0A";
        },
        calendar: {
            sameDay: "[\u4ECA\u5929] LT",
            nextDay: "[\u660E\u5929] LT",
            nextWeek: "[\u4E0B]dddd LT",
            lastDay: "[\u6628\u5929] LT",
            lastWeek: "[\u4E0A]dddd LT",
            sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function(number, period) {
            switch(period){
                case "d":
                case "D":
                case "DDD":
                    return number + "\u65E5";
                case "M":
                    return number + "\u6708";
                case "w":
                case "W":
                    return number + "\u9031";
                default:
                    return number;
            }
        },
        relativeTime: {
            future: "%s\u5F8C",
            past: "%s\u524D",
            s: "\u5E7E\u79D2",
            ss: "%d \u79D2",
            m: "1 \u5206\u9418",
            mm: "%d \u5206\u9418",
            h: "1 \u5C0F\u6642",
            hh: "%d \u5C0F\u6642",
            d: "1 \u5929",
            dd: "%d \u5929",
            M: "1 \u500B\u6708",
            MM: "%d \u500B\u6708",
            y: "1 \u5E74",
            yy: "%d \u5E74"
        }
    });
    moment.locale("en");
    return moment;
});

});


parcelRegister("gXzQg", function(module, exports) {

$parcel$export(module.exports, "DropdownlistWithLabel", function () { return $c58df57f91b8d132$export$afa8b69b312066d4; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $cJ5lq = parcelRequire("cJ5lq");

var $g6ndF = parcelRequire("g6ndF");

var $iFvPA = parcelRequire("iFvPA");

var $iSxgd = parcelRequire("iSxgd");
const { get: $c58df57f91b8d132$var$get } = (0, (/*@__PURE__*/$parcel$interopDefault($cJ5lq)));
const $c58df57f91b8d132$export$afa8b69b312066d4 = (props)=>{
    const optionIdentifier = props.optionIdentifier ?? "Id";
    const optionText = props.optionText ?? "Text";
    const wrappingClass = `single-step__section single-step__section--dropdown`;
    const [openStatus, setOpenStatus] = (0, $ca3MY.useState)(false);
    const [selectedItem, setSelectedItem] = (0, $ca3MY.useState)({
        item: {
            Text: "Select",
            Id: 0
        }
    });
    const [searchText, setSearchText] = (0, $ca3MY.useState)("");
    const [searchVisible, setSearchVisible] = (0, $ca3MY.useState)(false);
    const [emptyList, setEmptyList] = (0, $ca3MY.useState)(false);
    const buttonRef = (0, $ca3MY.useRef)(null);
    const wrapperRef = (0, $ca3MY.useRef)(null);
    const searchRef = (0, $ca3MY.useRef)(null);
    let selectedItemText = $c58df57f91b8d132$var$get(selectedItem.item, optionText) ?? selectedItem.item.PlateText ?? "";
    if (!selectedItemText || selectedItemText.length === 0 && props.optionTextFallback) selectedItemText = $c58df57f91b8d132$var$get(selectedItem.item, props.optionTextFallback);
    const newPrice = props.isAfterPriceChange && selectedItem.item.UpcomingPriceChange?.MonthlyPrice ? `${selectedItem.item.OverviewText} ${selectedItem.item.UpcomingPriceChange?.MonthlyPrice} ${selectedItem.item.Currency}` : "";
    const selectedLocale = props.locale === "no" ? "nb" : props.locale === "se" ? "sv" : props.locale;
    const selectedLanguage = document.querySelector("html").getAttribute("lang");
    const selectedDate = props?.selectedDate?.date ? (0, $iFvPA.parseDate)(props.selectedDate.date) : null;
    const dropdownId = props.dropdownId ?? "options";
    const selectAnOptionText = selectedLanguage == "sv" ? "V\xe4lj ett alternativ" : selectedLanguage == "fi" ? "Valitse vaihtoehto" : selectedLanguage == "no" ? "Velg et alternativ" : "Select an option";
    (0, $ca3MY.useEffect)(()=>{
        //Make sure datalist options closes when scrolling on Chrome
        const scrollElement = props.scrollElement ? document.querySelector(props.scrollElement) : "";
        if (!scrollElement || !props.searchable) return;
        const onScroll = ()=>{
            if (searchRef?.current) searchRef.current.blur();
        };
        //Clean up code
        scrollElement.removeEventListener("scroll", debounce(onScroll, 1000, true));
        scrollElement.addEventListener("scroll", debounce(onScroll, 1000, true), {
            passive: true
        });
        return ()=>scrollElement.removeEventListener("scroll", debounce(onScroll, 1000, true));
    }, []);
    (0, $ca3MY.useEffect)(()=>{
        if (props.value) {
            const name = $c58df57f91b8d132$var$get(props.value.item, optionText);
            if (props.searchable) setSearchText(name);
            setSelectedItem(props.value);
        }
    }, [
        props.value
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (searchVisible && buttonRef?.current?.childNodes[0].tagName.toUpperCase() === "INPUT") {
            setSearchText("");
            buttonRef.current.childNodes[0].focus();
        }
    }, [
        searchVisible
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (!props.options.length || !props.searchable) return;
        if (props.options.filter((singleoption)=>filterOptions(singleoption)).length === 0) setEmptyList(true);
        else setEmptyList(false);
        const items = props.options.filter((option)=>{
            return filterOptions(option) && option;
        });
        const item = items.length === 1 ? items[0] : null;
        if (item) //if (searchText !== item.name) setSearchText(item.name);
        selectItemHandler(item);
    }, [
        searchText
    ]);
    const debounce = (func, wait, immediate)=>{
        let timeout;
        return function() {
            const context = this, args = arguments;
            const later = ()=>{
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };
    const filterOptions = (singleoption)=>{
        const name = singleoption.name ?? singleoption.Name ?? "";
        const uid = singleoption.uid ?? singleoption.Uid ?? "";
        const textToSearch = name + " " + uid;
        return textToSearch.toUpperCase().includes(searchText.toUpperCase());
    };
    const useOutsideAlerter = (button, wrapper)=>{
        (0, $ca3MY.useEffect)(()=>{
            const handleClickOutside = (event)=>{
                if (wrapper.current && !wrapper.current.contains(event.target) && button.current && !button.current.contains(event.target)) {
                    setSearchVisible(false);
                    setOpenStatus(false);
                }
            };
            document.addEventListener("mousedown", handleClickOutside);
            return ()=>{
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [
            button,
            wrapper
        ]);
    };
    useOutsideAlerter(buttonRef, wrapperRef);
    //const blurHandler = () => {
    //  if (!selectedItem) return;
    //  setSearchText(selectedItem.item.name);
    //}
    const openCloseHandler = ()=>{
        setOpenStatus(!openStatus);
        if (props.searchable) setSearchVisible(!searchVisible);
    };
    const datalistFocusHandler = ()=>{
        setSearchText("");
    };
    const selectItemHandler = (item)=>{
        setOpenStatus(false);
        if (props.searchable) {
            setSearchVisible(false);
            setTimeout(()=>{
                searchRef.current.blur();
            }, 100);
        }
        if (props.setValue && props.isSeasonTicket) props.setValue({
            item: item
        }, props.index);
        else if (props.setValue) props.setValue({
            ...props.value,
            item: item
        }, props.index);
        (0, $iSxgd.pushToDataLayer)({
            event: "dropdownlist_change",
            label: props.text,
            value: item
        });
    };
    const selectNativeItemHandler = (event)=>{
        const selectedItem = props.options.filter((item)=>$c58df57f91b8d132$var$get(item.item ? item.item : item, optionIdentifier) === event.target.value);
        if (selectedItem.length > 0) selectItemHandler(selectedItem[0]);
    };
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: wrappingClass,
        children: [
            /*#__PURE__*/ (0, $54dlf.jsxs)("label", {
                htmlFor: dropdownId,
                className: "single-step__section__label",
                children: [
                    props.text,
                    props.required ? "*" : ""
                ]
            }),
            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                className: "single-step__section__dropdown-button-wrapper",
                children: [
                    props.searchable ? /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)("input", {
                                type: "text",
                                placeholder: props.loading ? "" : props.searchPlaceholder,
                                className: "single-step__section__dropdown-button single-step__section__dropdown-button--select",
                                spellCheck: "false",
                                ref: searchRef,
                                onFocus: datalistFocusHandler,
                                list: "datalistoptions",
                                value: searchText,
                                onChange: (e)=>setSearchText(e.target.value),
                                disabled: props.disabled || props.options.length === 0,
                                "aria-busy": props.loading
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)("datalist", {
                                id: "datalistoptions",
                                children: props.options.map((singleoption, index)=>{
                                    const name = singleoption.name ?? singleoption.Name ?? "";
                                    const uid = singleoption.uid ?? singleoption.Uid ?? "";
                                    return /*#__PURE__*/ (0, $54dlf.jsx)("option", {
                                        value: name + " " + uid
                                    }, uid);
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $54dlf.jsxs)("select", {
                        id: dropdownId,
                        className: "single-step__section__dropdown-button single-step__section__dropdown-button--select",
                        "aria-label": selectAnOptionText,
                        onChange: (e)=>selectNativeItemHandler(e),
                        value: selectedItem.item && ($c58df57f91b8d132$var$get(selectedItem.item, optionIdentifier) ?? selectedItem.item.Id),
                        disabled: props.disabled || props.options.length === 0,
                        "aria-busy": props.loading,
                        children: [
                            selectedItem.item && ($c58df57f91b8d132$var$get(selectedItem.item, optionIdentifier) === "00000000-0000-0000-0000-000000000000" || selectedItem.item.IsUnselected) && /*#__PURE__*/ (0, $54dlf.jsx)("option", {
                                defaultValue: $c58df57f91b8d132$var$get(selectedItem.item, optionIdentifier) ?? selectedItem.item.Id,
                                value: "selected",
                                children: selectedItemText
                            }),
                            props.options.map((singleoption, index)=>{
                                let extraPricingText = "";
                                if (props.selectedDay && props.selectedDay > -1 && singleoption.WeekdayPrices) {
                                    const dayPrice = singleoption.WeekdayPrices[props.selectedDay];
                                    extraPricingText = dayPrice ? ` - ${dayPrice} ${singleoption.Currency}` : "";
                                }
                                let singleOptionText = $c58df57f91b8d132$var$get(singleoption, optionText) ?? $c58df57f91b8d132$var$get(singleoption.item, optionText);
                                if (!singleOptionText || singleOptionText.length === 0 && props.optionTextFallback) singleOptionText = $c58df57f91b8d132$var$get(singleoption, props.optionTextFallback);
                                if (!singleOptionText || singleOptionText.length === 0) singleOptionText = singleoption.PlateText ?? singleoption.Text ?? "";
                                let startSellingDateText = "";
                                const startSellingDate = (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(singleoption.StartSellingDate)).add(6, "hours") || (singleoption.LastBookingEnds ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(singleoption.LastBookingEnds)).add(1, "days") : null);
                                if (startSellingDate && (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(selectedDate).isBefore(startSellingDate, "day")) startSellingDateText = `${props.available} ${(0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(startSellingDate).locale(selectedLocale).format("L")}`;
                                else if (singleoption.ParkingSpaceStatus && singleoption.ParkingSpaceStatus === "NOT_AVAILABLE") startSellingDateText = `${props.available} \u{2013}`;
                                return /*#__PURE__*/ (0, $54dlf.jsx)("option", {
                                    disabled: startSellingDateText,
                                    value: $c58df57f91b8d132$var$get(singleoption, optionIdentifier) ?? $c58df57f91b8d132$var$get(singleoption.item, optionIdentifier) ?? singleoption.Id ?? "",
                                    children: singleoption.Zone ? `${singleoption.Text} (${singleoption.Zone})${extraPricingText} ${startSellingDateText}` : `${singleOptionText} ${startSellingDateText}`
                                }, index);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                        className: [
                            "single-step__section__dropdown-button",
                            props.searchable ? "single-step__section__dropdown-button--searchable" : null,
                            openStatus ? "single-step__section__dropdown-button--active" : null,
                            props.options.length === 0 ? "single-step__section__dropdown-button--empty" : null
                        ].join(" "),
                        tabIndex: -1,
                        "aria-invalid": props.value && props.value.error ? true : null,
                        onClick: openCloseHandler,
                        ref: buttonRef,
                        disabled: !props.loading && (props.disabled || props.options.length === 0),
                        "aria-busy": props.loading,
                        children: searchVisible ? /*#__PURE__*/ (0, $54dlf.jsx)("input", {
                            type: "text",
                            placeholder: props.loading ? "" : props.searchPlaceholder,
                            value: searchText,
                            onKeyDown: (e)=>{
                                if (e.key === " " || e.keyCode === 32) {
                                    e.preventDefault();
                                    setSearchText(searchText + " ");
                                }
                            },
                            onChange: (e)=>setSearchText(e.target.value)
                        }) : /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                            children: props.isAfterPriceChange && selectedItemText && newPrice ? newPrice : selectedItemText
                        })
                    }),
                    props.value && props.value.error && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                        className: "validation-error",
                        children: props.value.error
                    }),
                    openStatus && props.options.length > 0 && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                        className: "single-step__section__dropdown-selection",
                        onMouseDown: (e)=>emptyList && e.preventDefault(),
                        ref: wrapperRef,
                        children: emptyList ? /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                            className: "single-step__section__dropdown-item single-step__section__dropdown-item--empty",
                            children: /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                className: "single-step__section__dropdown-item__text",
                                children: props.customerNotFound
                            })
                        }) : props.options.map((singleoption, index)=>{
                            if (props.searchable && !filterOptions(singleoption)) return;
                            let extraPricingText = "";
                            const isAfterPriceChangeSingleOption = singleoption.UpcomingPriceChange?.Validity?.ValidFrom && selectedDate ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(singleoption.UpcomingPriceChange?.Validity?.ValidFrom).isSameOrBefore(selectedDate, "day") : false;
                            if (props.selectedDay && props.selectedDay > -1 && singleoption.WeekdayPrices) {
                                const dayPrice = singleoption.WeekdayPrices[props.selectedDay];
                                extraPricingText = dayPrice ? ` - ${dayPrice} ${singleoption.Currency}` : "";
                            }
                            let singleOptionText = $c58df57f91b8d132$var$get(singleoption, optionText) ?? $c58df57f91b8d132$var$get(singleoption.item, optionText);
                            if (!singleOptionText || singleOptionText.length === 0 && props.optionTextFallback) singleOptionText = $c58df57f91b8d132$var$get(singleoption, props.optionTextFallback);
                            if (!singleOptionText || singleOptionText.length === 0) singleOptionText = singleoption.PlateText ?? singleoption.Text ?? "";
                            let startSellingDateText = "";
                            const startSellingDate = (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(singleoption.StartSellingDate)).add(6, "hours") || (singleoption.LastBookingEnds ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(singleoption.LastBookingEnds)).add(1, "days") : null);
                            if (startSellingDate && (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(selectedDate).isBefore(startSellingDate, "day")) startSellingDateText = `${props.available} ${(0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(startSellingDate).locale(selectedLocale).format("L")}`;
                            else if (singleoption.ParkingSpaceStatus && singleoption.ParkingSpaceStatus === "NOT_AVAILABLE") startSellingDateText = `${props.available} \u{2013}`;
                            if (isAfterPriceChangeSingleOption && singleoption.UpcomingPriceChange?.MonthlyPrice) singleOptionText = `${singleoption.OverviewText} ${singleoption.UpcomingPriceChange?.MonthlyPrice} ${singleoption.Currency}`;
                            return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                className: [
                                    "single-step__section__dropdown-item",
                                    startSellingDateText && "single-step__section__dropdown-item--notavailable",
                                    !props.isSeasonTicket && $c58df57f91b8d132$var$get(singleoption.item ?? singleoption, optionIdentifier) !== undefined && $c58df57f91b8d132$var$get(singleoption.item ?? singleoption, optionIdentifier) === $c58df57f91b8d132$var$get(selectedItem.item, optionIdentifier) || selectedItemText === singleOptionText ? "single-step__section__dropdown-item--selected" : ""
                                ].join(" "),
                                onClick: ()=>!startSellingDateText && selectItemHandler(singleoption),
                                children: [
                                    singleoption.Zone && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                        className: "single-step__section__dropdown-item__zone",
                                        children: singleoption.Zone
                                    }),
                                    /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                                        className: "single-step__section__dropdown-item__text",
                                        children: [
                                            singleOptionText,
                                            extraPricingText
                                        ]
                                    }),
                                    startSellingDateText && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                        className: "single-step__section__dropdown-item__date",
                                        children: startSellingDateText
                                    }),
                                    Array.isArray(singleoption.Promotions) && singleoption.Promotions.length > 0 && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $54dlf.jsx)("img", {
                                            className: "single-step__section__dropdown-item__promo",
                                            src: `/publicResources/icons/promo/${selectedLanguage}/Promotion2_${selectedLanguage}.svg`
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            props.children
        ]
    });
};

});

parcelRegister("7HCW7", function(module, exports) {

$parcel$export(module.exports, "RadioButtonListWithLabel", function () { return $59bac0895a6d931a$export$227f59f172de3f7e; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $4kqcG = parcelRequire("4kqcG");

var $iFvPA = parcelRequire("iFvPA");

var $g6ndF = parcelRequire("g6ndF");
const $59bac0895a6d931a$export$227f59f172de3f7e = (props)=>{
    const wrappingClass = `single-step__section single-step__section--radiobuttonlist ${props.modifierClass}`;
    const valueId = props.value ? props.value.item.id || props.value.item.Id : null;
    const selectedDate = props?.selectedDate?.date ? (0, $iFvPA.parseDate)(props.selectedDate.date) : null;
    const formLang = props.formLang;
    const selectedLanguage = props.selectedLanguage;
    const selectedLocale = props.locale;
    const loadingArray = [
        0,
        1,
        2,
        3
    ];
    const [isExpanded, setIsExpanded] = (0, $ca3MY.useState)([]);
    const onLockedProductSelected = props.onLockedProductSelected;
    (0, $ca3MY.useEffect)(()=>{
        if (props.options.length === 0) return;
        if (props.productList && props.index === 0) props.options.unshift({
            Text: "No product",
            Id: "00000000-0000-0000-0000-000000000000"
        });
        if (props.options.filter((singleoption)=>singleoption.id === valueId || singleoption.Id === valueId).length > 0) return;
        if (!props.index && !props.productList) props.setValue({
            ...props.value,
            item: props.options[0]
        });
    }, [
        props.options
    ]);
    const createPromotText = (singleoption, promotion)=>{
        let promoTextFirstLine;
        let promoTextSecondLine;
        if ((promotion.DiscountPercent === 100 || promotion.DiscountPercent === 50) && promotion.StartAfter) {
            const text = promotion.Duration > 1 ? formLang.promomonthfree.multipleduration : formLang.promomonthfree.singleduration;
            promoTextFirstLine = text.replace("{0}", promotion.StartAfter + promotion.Duration).replace("{1}", promotion.Duration);
            promoTextFirstLine = promoTextFirstLine + ` ${promotion.DiscountPercent === 100 ? formLang.promomonthfree.forfree : formLang.promomonthfree.halfprice}`;
            promoTextSecondLine = promotion.DiscountValidity?.ValidFrom ? `${formLang.promovalid}${promotion.DiscountValidity?.ValidTo ? "" : " " + formLang.promofrom.split(" ")[0]} ${(0, $iFvPA.parseDate)(promotion.DiscountValidity.ValidFrom, selectedLocale, "L")}${promotion.DiscountValidity?.ValidTo ? "\u2013" + (0, $iFvPA.parseDate)(promotion.DiscountValidity.ValidTo, selectedLocale, "L") : ""}` : "";
        } else {
            promoTextFirstLine = `${formLang.promodiscount} ${Math.round(promotion.DiscountPercent || promotion.DiscountValue)}${promotion.DiscountValue ? " " + singleoption.Currency : "\u202F%"}`;
            promoTextSecondLine = promotion.DiscountValidity?.ValidFrom ? `${formLang.promovalid}${promotion.DiscountValidity?.ValidTo ? "" : " " + formLang.promofrom.split(" ")[0]} ${(0, $iFvPA.parseDate)(promotion.DiscountValidity.ValidFrom, selectedLocale, "L")}${promotion.DiscountValidity?.ValidTo ? "\u2013" + (0, $iFvPA.parseDate)(promotion.DiscountValidity.ValidTo, selectedLocale, "L") : ""}` : promotion.Duration > 0 ? `${formLang.promovalid}${promotion.Duration ? promotion.Duration > 1 ? " " + formLang.promodurations.replace("{0}", promotion.Duration) : " " + formLang.promoduration.replace("{0}", promotion.Duration) : ""} ${formLang.promofrom} ${promotion.StartAfter + 1}` : "";
        }
        return [
            promoTextFirstLine,
            promoTextSecondLine
        ];
    };
    const expandText = (id)=>{
        setIsExpanded((prev)=>{
            if (prev.includes(id)) return prev.filter((item)=>item !== id);
            else return [
                ...prev,
                id
            ];
        });
    };
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: wrappingClass,
        children: [
            props.text && /*#__PURE__*/ (0, $54dlf.jsx)("label", {
                className: "single-step__section__label",
                children: props.text
            }),
            props.subText && /*#__PURE__*/ (0, $54dlf.jsx)("label", {
                className: "single-step__section__label italic",
                children: props.subText
            }),
            props.options.map((singleoption, index)=>{
                let extraPricingText = "";
                if (props.selectedDay && props.selectedDay > -1 && singleoption.WeekdayPrices) {
                    const dayPrice = singleoption.WeekdayPrices[props.selectedDay];
                    extraPricingText = dayPrice ? ` - ${dayPrice}` : "";
                }
                const isAfterPriceChangeSingleOption = singleoption.UpcomingPriceChange?.Validity?.ValidFrom && selectedDate ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(singleoption.UpcomingPriceChange?.Validity?.ValidFrom).isSameOrBefore(selectedDate, "day") : false;
                let startSellingDateText = "";
                const startSellingDate = (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(singleoption.StartSellingDate)).add(6, "hours") || (singleoption.LastBookingEnds ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(singleoption.LastBookingEnds)).add(1, "days") : null);
                if (startSellingDate && (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(selectedDate).isBefore(startSellingDate, "day")) startSellingDateText = `${props.available} ${(0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(startSellingDate).locale(selectedLocale).format("L")}`;
                else if (singleoption.ParkingSpaceStatus && singleoption.ParkingSpaceStatus === "NOT_AVAILABLE") startSellingDateText = `${props.available} \u{2013}`;
                const availability = props.productList ? singleoption.Availability ? singleoption.Availability > 4 ? formLang.free : formLang.few : formLang.full : "";
                const availabilityClass = props.productList ? singleoption.Availability ? singleoption.Availability > 4 ? "" : " single-step__section__radio-label__availability--low" : " single-step__section__radio-label__availability--full" : "";
                const noAvailability = props.productList ? singleoption.Availability === 0 : false;
                const availabilityFrom = noAvailability && singleoption.AvailabilityFrom ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(singleoption.AvailabilityFrom)).locale(selectedLocale).format("L") : "";
                if (availabilityFrom && selectedDate && (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(selectedDate).isBefore((0, $iFvPA.parseDate)(availabilityFrom), "day")) startSellingDateText = `${props.available} ${availabilityFrom}`;
                const singleOptionId = singleoption.id || singleoption.Id;
                const hasPromo = singleoption.Promotions && singleoption.Promotions.length > 0;
                const descriptionAndNotes = singleoption.Description + singleoption.Notes;
                const newPrice = props.priceTimes && props.priceTimes > 0 ? singleoption.optionPrice * props.priceTimes : singleoption.optionPrice ? singleoption.optionPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : null;
                const expandedDescription = isExpanded.includes(singleOptionId);
                if (props.readOnly) return /*#__PURE__*/ (0, $54dlf.jsx)("label", {
                    className: "single-step__section__radio-wrapper single-step__section__radio-wrapper--readonly",
                    children: /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                        className: "single-step__section__radio-label",
                        children: [
                            singleoption.text,
                            ":",
                            " ",
                            newPrice > 0 && (0, $4kqcG.formatCurrency)(newPrice),
                            " ",
                            singleoption.currency
                        ]
                    })
                }, index);
                const urlParams = new URLSearchParams(window.location.search);
                const verifiedLockedCode = urlParams.get("verifiedLockedCode");
                const verifiedPid = urlParams.get("pid") ?? urlParams.get("pId");
                const isUnlockedByCode = verifiedLockedCode && verifiedPid && singleoption.ZoneAndProduct === verifiedPid;
                const isLockedPmc = singleoption.Visibility === "LOCKED" && !isUnlockedByCode;
                return !props.loading && /*#__PURE__*/ (0, $54dlf.jsxs)("label", {
                    onMouseEnter: props.productList ? ()=>!props.scrollEnabled && props.setScrollEnabled(true) : undefined,
                    onKeyDown: props.productList ? (e)=>props.scrollEnabled && props.setScrollEnabled(false) : undefined,
                    className: singleOptionId === "00000000-0000-0000-0000-000000000000" ? "single-step__section__radio-wrapper--hide" : props.productList && singleOptionId === valueId ? "single-step__section__radio-wrapper selected" : "single-step__section__radio-wrapper",
                    children: [
                        /*#__PURE__*/ (0, $54dlf.jsx)("input", {
                            className: "single-step__section__radio-original",
                            type: "radio",
                            id: singleOptionId,
                            checked: singleOptionId === valueId,
                            onClick: (e)=>e.type === "click" && e.clientX !== 0 && e.clientY !== 0 && e.currentTarget.blur(),
                            onChange: ()=>{
                                if (isLockedPmc) {
                                    if (onLockedProductSelected) onLockedProductSelected(singleoption);
                                    return;
                                }
                                props.setValue({
                                    ...props.value,
                                    item: singleoption
                                });
                            },
                            disabled: props.disabled || singleoption.disabled || startSellingDateText
                        }),
                        /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                            className: "single-step__section__radio-circle"
                        }),
                        /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                            className: "single-step__section__radio-label",
                            children: [
                                singleoption.text || singleoption.OverviewText || singleoption.Text,
                                isLockedPmc ? /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                    className: "single-step__section__radio-label__locked-icon"
                                }) : " ",
                                availability ? props.availabilityUpdate ? /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                    className: "loadingdots"
                                }) : /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                    className: "single-step__section__radio-label__availability" + availabilityClass,
                                    children: availability
                                }) : null,
                                !isLockedPmc && singleoption.MonthlyPrice != null && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                    children: (isAfterPriceChangeSingleOption && singleoption.UpcomingPriceChange?.MonthlyPrice ? (0, $4kqcG.formatCurrency)(singleoption.UpcomingPriceChange?.MonthlyPrice) : (0, $4kqcG.formatCurrency)(singleoption.MonthlyPrice)) + (extraPricingText ?? "") + " " + singleoption.Currency
                                }),
                                newPrice > 0 ? (0, $4kqcG.formatCurrency)(newPrice) : null,
                                singleoption.currency
                            ]
                        }),
                        props.productList && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                            children: [
                                (singleoption.Notes || singleoption.Description || startSellingDateText || extraPricingText) && /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                    children: [
                                        descriptionAndNotes && (window.innerWidth < 768 && descriptionAndNotes.length > 80 || descriptionAndNotes.length > 160) ? /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                            className: `${expandedDescription ? "expanded" : "truncated"}`,
                                            children: [
                                                /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                    children: singleoption.Description
                                                }),
                                                /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                    children: singleoption.Notes
                                                }),
                                                /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                                                    onClick: ()=>expandText(singleOptionId),
                                                    children: expandedDescription ? formLang.readless : formLang.readmore
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                    children: singleoption.Description
                                                }),
                                                /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                    children: singleoption.Notes
                                                })
                                            ]
                                        }),
                                        startSellingDateText && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                            className: "italic",
                                            children: startSellingDateText
                                        }),
                                        extraPricingText && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                            className: "italic",
                                            children: extraPricingText
                                        })
                                    ]
                                }),
                                singleoption.Id !== "00000000-0000-0000-0000-000000000000" && hasPromo && formLang && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                                    children: singleoption.Promotions.map((promotion, i)=>{
                                        const promoIsValid = hasPromo && !!(selectedDate && (!promotion.OrderLineValidFromValidity.ValidTo || (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(selectedDate)).isSameOrBefore((0, $iFvPA.parseDate)(promotion.OrderLineValidFromValidity.ValidTo))) && (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(selectedDate)).isSameOrAfter((0, $iFvPA.parseDate)(promotion.OrderLineValidFromValidity.ValidFrom)));
                                        const promoText = createPromotText(singleoption, promotion);
                                        return (!selectedDate || promoIsValid) && /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                            className: "promo-with-text",
                                            children: [
                                                /*#__PURE__*/ (0, $54dlf.jsx)("img", {
                                                    src: `/publicResources/icons/promo/${selectedLanguage}/Promotion2_${selectedLanguage}.svg`
                                                }),
                                                /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                                    className: "discount",
                                                    children: [
                                                        /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                            children: promoText[0]
                                                        }),
                                                        promoText[1] && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                            children: promoText[1]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, "" + (promotion.DiscountPercent || promotion.DiscountValue) + (promotion.Duration || 1) + i);
                                    })
                                })
                            ]
                        })
                    ]
                }, index);
            }),
            props.productList && props.loading && loadingArray.map((i)=>{
                return /*#__PURE__*/ (0, $54dlf.jsxs)("label", {
                    className: "single-step__section__radio-wrapper single-step__section__radio-wrapper--loading",
                    children: [
                        /*#__PURE__*/ (0, $54dlf.jsx)("input", {
                            className: "single-step__section__radio-original",
                            type: "radio",
                            checked: false,
                            disabled: true
                        }),
                        /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                            className: "single-step__section__radio-circle"
                        }),
                        /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                            className: "single-step__section__radio-label",
                            children: /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                className: "loadingdots"
                            })
                        })
                    ]
                }, i);
            })
        ]
    });
};

});
parcelRegister("4kqcG", function(module, exports) {

$parcel$export(module.exports, "formatCurrency", function () { return $326d5b2868057d34$export$3dc27271f5d5c629; });
const $326d5b2868057d34$export$3dc27271f5d5c629 = (value, addCurrency = false)=>{
    const country = document.querySelector("html").getAttribute("country");
    let countryCode = "", currency = "";
    if (country === "se") countryCode = "sv-SE", currency = "SEK";
    else if (country === "no") countryCode = "nn-NO", currency = "NOK"; //'nb-NO' = Bokmål
    else if (country === "fi") countryCode = "fi-FI", currency = "EUR";
    let returnValue = new Intl.NumberFormat(countryCode, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: value % 1 === 0 ? 0 : 2
    }).format(value).replace("\xa0\u20AC", "").replace("\xa0kr", "").replace("\xa0Nkr", "").replace("NOK\xa0", "").replace("\xa0", "\u202F");
    if (addCurrency) returnValue = returnValue + " " + currency;
    return returnValue;
};

});


parcelRegister("gxSZA", function(module, exports) {

$parcel$export(module.exports, "LockedPmcPopup", function () { return $c0ba62bcabd17b76$export$a522294221f26ed9; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");
const $c0ba62bcabd17b76$export$a522294221f26ed9 = ({ title: title, description: description, visible: visible, onClose: onClose, children: children })=>{
    (0, $ca3MY.useEffect)(()=>{
        document.body.style.overflow = visible ? "hidden" : "";
        return ()=>{
            document.body.style.overflow = "";
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
        className: "lockedpmc__popup",
        style: {
            display: visible ? "flex" : "none"
        },
        children: /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
            className: `lockedpmc__popup__inner ${visible ? "visible" : ""}`,
            children: [
                /*#__PURE__*/ (0, $54dlf.jsxs)("header", {
                    children: [
                        /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                            className: "lockedpmc__popup__heading",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                            className: "lockedpmc__popup__close",
                            "aria-label": "Close popup",
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $54dlf.jsxs)("main", {
                    children: [
                        description && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                            className: "lockedpmc__popup__description_container",
                            children: /*#__PURE__*/ (0, $54dlf.jsx)("h4", {
                                className: "lockedpmc__popup__description",
                                children: description
                            })
                        }),
                        /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                            className: "main popup__form-content",
                            "data-app-container": "true",
                            children: children
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("4cWVp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3105fdb0fa402302$export$2e2bcd8739ae039; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $kKqEP = parcelRequire("kKqEP");

var $5MyUm = parcelRequire("5MyUm");
const $3105fdb0fa402302$var$LockedPmcForm = ({ lang: lang, onSuccess: onSuccess, pmcId: pmcId, onSubmit: onSubmit })=>{
    const [pending, setPending] = (0, $ca3MY.useState)(false);
    const [code, setCode] = (0, $ca3MY.useState)("");
    const [errors, setErrors] = (0, $ca3MY.useState)({});
    const [touched, setTouched] = (0, $ca3MY.useState)(false);
    const [success, setSuccess] = (0, $ca3MY.useState)(false);
    const timeoutRef = (0, $ca3MY.useRef)(null);
    const codeText = lang == "sv" ? "Kod" : lang == "fi" ? "Koodi" : lang == "nb" ? "Kode" : "Code";
    const codeIsRequiredText = lang == "sv" ? "Kod kr\xe4vs" : lang == "fi" ? "Koodi on pakollinen" : lang == "nb" ? "Kode kreves" : "Code is required";
    const codeIsTooShortText = lang == "sv" ? "Koden \xe4r f\xf6r kort (minst 4 tecken)" : lang == "fi" ? "Koodi on liian lyhyt (v\xe4hint\xe4\xe4n 4 merkki\xe4)" : lang == "nb" ? "Koden er for kort (minst 4 tegn)" : "The code is too short (minimum 4 characters)";
    const invalidCodeRegexText = lang == "sv" ? "Ogiltig kod. Endast bokst\xe4ver, siffror, '-' och '' \xe4r till\xe5tna" : lang == "fi" ? "Virheellinen koodi. Vain kirjaimet, numerot, '-' ja '_' ovat sallittuja." : lang == "nb" ? "Ugyldig kode. Bare bokstaver, tall, '-' og '' er tillatt." : "Invalid code. Only letters, numbers, '-' and '_' are allowed";
    const invalidCodeText = lang == "sv" ? "Ogiltig kod. F\xf6rs\xf6k med en annan kod." : lang == "fi" ? "Virheellinen koodi. Kokeile toista koodia." : lang == "nb" ? "Ugyldig kode. Pr\xf8v en annen kode." : "Invalid code. Try another code.";
    const submitText = lang == "sv" ? "Skicka" : lang == "fi" ? "L\xe4het\xe4" : lang == "nb" ? "Sende" : "Submit";
    const submitingText = lang == "sv" ? "Skickar..." : lang == "fi" ? "L\xe4hetet\xe4\xe4n..." : lang == "nb" ? "Sender..." : "Submiting...";
    const maxLimitReachedText = lang == "sv" ? "Den h\xe4r koden har inga tillg\xe4ngliga anv\xe4ndningsomr\xe5den kvar." : lang == "fi" ? "Annetussa koodissa ei ole en\xe4\xe4 k\xe4ytt\xf6kertoja j\xe4ljell\xe4." : lang == "nb" ? "Denne koden har ingen tilgjengelige bruksomr\xe5der igjen." : "This code has no available uses left.";
    const validateCode = (0, $ca3MY.useCallback)((value)=>{
        const trimmed = value.trim();
        if (!trimmed) return codeIsRequiredText;
        if (trimmed.length < 4) return codeIsTooShortText;
        const codeRegex = /^[A-Za-z0-9_-]+$/;
        if (!codeRegex.test(trimmed)) return invalidCodeRegexText;
        return "";
    }, []);
    const resetForm = (0, $ca3MY.useCallback)(()=>{
        setCode("");
        setSuccess(false);
        setErrors({});
        setTouched(false);
    }, []);
    const handleSubmit = (0, $ca3MY.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setTouched(true);
        const codeError = validateCode(code);
        if (codeError) return setErrors({
            code: codeError
        });
        try {
            setPending(true);
            const getUnlockedConfigs = await (0, $kKqEP.permitService).getUnlockedConfigs({
                pmcId: pmcId,
                "unlockCode": code
            }, false);
            if (getUnlockedConfigs.status !== 200) {
                const msg = getUnlockedConfigs.body?.StatusDescription == "Invalid code" ? invalidCodeText : "No configs returned. Please try again.";
                setErrors({
                    common: msg
                });
                return;
            }
            const data = getUnlockedConfigs.body.content;
            if (data.numberOfCodes > data.numberOfUsedCodes) {
                setSuccess(true);
                localStorage.setItem("validUnlockCode", code);
                localStorage.setItem("validUnlockPmcId", pmcId);
                onSubmit();
                timeoutRef.current = setTimeout(()=>{
                    onSuccess();
                    resetForm();
                }, 1400);
            } else {
                console.log("Code exists but has no available uses left.");
                setErrors({
                    common: maxLimitReachedText
                });
            }
        } catch (error) {
            setErrors({
                common: "Unable to check the code. Please try again!"
            });
        } finally{
            setPending(false);
        }
    }, [
        code,
        onSuccess,
        resetForm,
        validateCode
    ]);
    const handleCodeChange = (0, $ca3MY.useCallback)((e)=>{
        const value = e.target.value;
        setCode(value);
        if (touched) {
            const message = validateCode(value);
            setErrors({
                code: message
            });
        }
    }, [
        touched,
        validateCode
    ]);
    const handleBlur = (0, $ca3MY.useCallback)(()=>{
        setTouched(true);
        const message = validateCode(code);
        setErrors({
            code: message
        });
    }, [
        code,
        validateCode
    ]);
    (0, $ca3MY.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
        onClick: (e)=>e.stopPropagation(),
        children: !success ? /*#__PURE__*/ (0, $54dlf.jsxs)("form", {
            className: "pmc-locked-form",
            onSubmit: handleSubmit,
            noValidate: true,
            children: [
                /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                    className: "input-container",
                    children: [
                        /*#__PURE__*/ (0, $54dlf.jsx)("label", {
                            htmlFor: "code-input",
                            className: "code-form__label",
                            children: codeText
                        }),
                        /*#__PURE__*/ (0, $54dlf.jsx)("input", {
                            id: "code-input",
                            type: "text",
                            value: code,
                            onChange: handleCodeChange,
                            onBlur: handleBlur,
                            className: "code-form__input",
                            placeholder: "",
                            disabled: pending,
                            autoComplete: "code"
                        })
                    ]
                }),
                errors.code && touched && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                    className: "form-error",
                    children: errors.code
                }),
                errors.common && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                    className: "form-error",
                    children: errors.common
                }),
                /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                    className: "pmc-locked-form__buttons",
                    children: /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                        type: "submit",
                        className: "btn btn--save",
                        disabled: pending,
                        children: pending ? submitingText : submitText
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $54dlf.jsx)("div", {
            className: "success-message",
            children: /*#__PURE__*/ (0, $54dlf.jsx)((0, $5MyUm.default), {})
        })
    });
};
var $3105fdb0fa402302$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ca3MY))).memo($3105fdb0fa402302$var$LockedPmcForm);

});
parcelRegister("kKqEP", function(module, exports) {

$parcel$export(module.exports, "permitService", function () { return $f1acc8231c4434f8$export$9dae77a0acac5077; });
$parcel$export(module.exports, "vehicles", function () { return $f1acc8231c4434f8$export$f227cb3279b11c6; });
$parcel$export(module.exports, "users", function () { return $f1acc8231c4434f8$export$7652f722913b5d7; });
$parcel$export(module.exports, "permits", function () { return $f1acc8231c4434f8$export$74f1b9aacd84208a; });
$parcel$export(module.exports, "salesOrderAttachments", function () { return $f1acc8231c4434f8$export$db4af9377a73eb7e; });
$parcel$export(module.exports, "waitinglist", function () { return $f1acc8231c4434f8$export$2a75adfc65cf1; });
$parcel$export(module.exports, "refreshlogin", function () { return $f1acc8231c4434f8$export$a65ef5bb44a523aa; });

var $lA5kC = parcelRequire("lA5kC");

var $hSKRm = parcelRequire("hSKRm");
const $f1acc8231c4434f8$export$9dae77a0acac5077 = {
    createPermits: async (data, mocked, lang)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/landlord/createpermits`, data).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/landlord/createpermits`, data, lang, "POST").catch((err)=>err),
    getPlaces: async (mocked)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/landlord/getplaces`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/landlord/getplaces`).catch((err)=>err),
    getTypes: async (data, mocked)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/permits/types`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/permits/types`, data).catch((err)=>err),
    getCustomers: async (mocked)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/landlord/getcustomers`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/landlord/getcustomers`).catch((err)=>err),
    getPermitDetails: async (data, mocked, lang)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/permits/permitdetails`, data).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/landlord/getpermitdetails`, data, lang).catch((err)=>err),
    updatePermit: async (data, mocked, lang)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/landlord/updatepermit`, data).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/landlord/updatepermit`, data, lang, "POST").catch((err)=>err),
    getUnlockedConfigs: async (data, mocked)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/booking/getunlockedconfigs`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/booking/getunlockedconfigs`, data, null).catch((err)=>err)
};
const $f1acc8231c4434f8$export$f227cb3279b11c6 = {
    removeVehicle: async (data, mocked)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/vehicle/deletevehicle`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/myaimoparksettingspage/deletevehicle`, data, "POST").catch((err)=>err),
    updateCustomerVehicle: async (data, mocked, lang)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/booking/updatevehicle`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data.bookingController}updatevehicle`, data.form, lang, "POST").catch((err)=>err),
    createCustomerVehicle: async (data, mocked, lang)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/booking/createvehicle`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data.bookingController}createvehicle`, data.form, lang, "POST").catch((err)=>err),
    getCustomerVehicles: async (data, mocked, lang)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/booking/getvehicles`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`${data.bookingController}getvehicles`, null, lang).catch((err)=>err),
    deleteVehicle: async (data, lang)=>(0, $lA5kC.apiPromise)(`/myaimoparksettingspage/deletevehicle`, data, lang, "POST").catch((err)=>err),
    checkPermitForDeleteVehicle: async (data)=>(0, $lA5kC.apiPromise)(`/myaimoparksettingspage/checkpermitfordeletevehicle`, data, "POST").catch((err)=>err)
};
const $f1acc8231c4434f8$export$7652f722913b5d7 = {
    createUser: async (data, mocked, lang)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/landlord/createuser`, data).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/landlord/createuser`, data, lang, "POST").catch((err)=>err),
    deleteCustomer: async (data, mocked, lang)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/user/removeuser`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/landlord/deletecustomer`, data, lang, "POST").catch((err)=>err),
    demoteAdmin: async (data, mocked, lang)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/user/demoteadmin`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/landlord/demoteadmin`, data, lang, "POST").catch((err)=>err)
};
const $f1acc8231c4434f8$export$74f1b9aacd84208a = {
    updatePermit: async (data, lang)=>(0, $lA5kC.apiPromise)(`/myaimopark/updatepermit`, data, lang, "POST").catch((err)=>err),
    approvePreliminaryOrder: async (data, lang)=>(0, $lA5kC.apiPromise)(`/myaimoparkpreliminaryorderpage/approvesalesorder`, data, lang, "POST").catch((err)=>err),
    declinePreliminaryOrder: async (data, lang)=>(0, $lA5kC.apiPromise)(`/myaimoparkpreliminaryorderpage/declinesalesorder`, data, lang, "POST").catch((err)=>err)
};
const $f1acc8231c4434f8$export$db4af9377a73eb7e = {
    prepareUpload: async (data)=>(0, $lA5kC.apiPromise)(`/booking/preparesalesorderattachmentupload`, data, null, "POST").catch((err)=>err),
    link: async (data)=>(0, $lA5kC.apiPromise)(`/booking/linksalesorderattachments`, data, null, "POST").catch((err)=>err),
    getDownloadUrl: (orderId, attachmentId)=>`/booking/downloadsalesorderattachment?orderId=${encodeURIComponent(orderId)}&attachmentId=${encodeURIComponent(attachmentId)}`
};
const $f1acc8231c4434f8$export$2a75adfc65cf1 = {
    registerForNotifications: async (data)=>(0, $lA5kC.apiPromise)("/waitinglist/RegisterForNotifications", data, null, "POST").catch((err)=>err),
    registerForWaitingList: async (data)=>(0, $lA5kC.apiPromise)("/waitinglist/RegisterForWaitingList", data, null, "POST").catch((err)=>err),
    getWaitingListItem: async (data)=>(0, $lA5kC.apiPromise)("/waitinglist/GetWaitinglistItem", data, null).catch((err)=>err),
    removeFromWaitingList: async (data)=>(0, $lA5kC.apiPromise)("/waitinglist/RemoveFromWaitingList", data, null, "DELETE").catch((err)=>err),
    getNextAvailablePosition: async (data)=>(0, $lA5kC.apiPromise)("/waitinglist/GetNextAvailablePosition", data, null).catch((err)=>err),
    removeFromWaitingListApproval: async (data)=>(0, $lA5kC.apiPromise)("/waitinglist/RemoveFromWaitingListApproval", data, null, "DELETE").catch((err)=>err),
    prepareUpload: async (data)=>(0, $lA5kC.apiPromise)("/waitinglist/PrepareUpload", data, null, "POST").catch((err)=>err)
};
const $f1acc8231c4434f8$export$e0969da9b8fb378d = {
    getTestCall: async (data, returnTime = 3000)=>{
        return new Promise((resolve)=>{
            console.log(`Test call (${returnTime}ms). Data: `, data);
            setTimeout(()=>{
                resolve({
                    status: 200,
                    info: "OK",
                    body: "Test call (3000ms)"
                });
            }, returnTime);
        });
    }
};
const $f1acc8231c4434f8$export$a65ef5bb44a523aa = async (mocked)=>mocked ? $f1acc8231c4434f8$var$apiMockedPromise(`/refreshlogin`).catch((err)=>err) : (0, $lA5kC.apiPromise)(`/refreshlogin`, null, "POST").catch((err)=>err);
const $f1acc8231c4434f8$var$apiMockedPromise = (url, data = {}, returnTime = 0)=>{
    return new Promise((resolve)=>{
        let returnData;
        //let returnTime = 3000; //Milliseconds
        if (url.lastIndexOf("/landlord/getplaces", 0) === 0) returnData = (0, $hSKRm.mockedData).placesOptions;
        else if (url.lastIndexOf("/permits/types", 0) === 0) returnData = (0, $hSKRm.mockedData).permitTypeOptions;
        else if (url.lastIndexOf("/landlord/getcustomers", 0) === 0) returnData = (0, $hSKRm.mockedData).permitUserOptions;
        else if (url.lastIndexOf("/permits/permitdetails", 0) === 0) returnData = (0, $hSKRm.mockedData).permitDetails[data.permitId ?? 0], returnTime = 3000;
        else if (url.lastIndexOf("/vehicle/removevehicle", 0) === 0) returnData = "", returnTime = 500;
        else if (url.lastIndexOf("/user/removeuser", 0) === 0) returnData = "", returnTime = 500;
        else if (url.lastIndexOf("/landlord/createpermits", 0) === 0) returnData = data, returnTime = 1000;
        else if (url.lastIndexOf("/landlord/updatepermit", 0) === 0) returnData = data, returnTime = 1000;
        else if (url.lastIndexOf("/landlord/createuser", 0) === 0) returnData = data, returnTime = 500;
        else if (url.lastIndexOf("/refreshlogin", 0) === 0) returnData = data;
        else if (url.lastIndexOf("/booking/getunlockedconfigs", 0) === 0) returnData = (0, $hSKRm.mockedData).unlockedConfigs[data.pmcId ?? 0], returnTime = 500;
        else returnData = "No mocked api endpoint match!";
        console.log(`Mocked data: ${url}, data: `, data, {
            status: 200,
            info: "OK",
            body: returnData
        });
        setTimeout(()=>{
            resolve({
                status: 200,
                info: "OK",
                body: returnData
            });
        }, returnTime === 0 ? Math.floor(Math.random() * 5) * 1000 : returnTime);
    });
};

});
parcelRegister("hSKRm", function(module, exports) {

$parcel$export(module.exports, "mockedData", function () { return $d04bd4246835eac5$export$c8de751bd7a46f3d; });
const $d04bd4246835eac5$export$c8de751bd7a46f3d = {
    placesOptions: [
        {
            Text: "First place",
            Id: "8bca584c-3125-49eb-9727-a99de7302281"
        },
        {
            Text: "Second place",
            Id: "a942b646-0fbe-4180-aea4-fdc196b3e321"
        },
        {
            Text: "Third and final long named place",
            Id: "a942b646-0fbe-4180-aea4-fdc196b3e322"
        }
    ],
    permitTypeOptions: [
        {
            Text: "One permit",
            Id: "8bca584c-3125-49eb-9727-a99de7302281"
        },
        {
            Text: "Other permit",
            Id: "a942b646-0fbe-4180-aea4-fdc196b3e321"
        },
        {
            Text: "Yet another permit",
            Id: "a942b646-0fbe-4180-aea4-fdc196b3e322"
        }
    ],
    permitUserOptions: [
        {
            Text: "Demo Demosson",
            Id: "8bca584c-3125-49eb-9727-a99de7302281",
            FirstName: "Demo",
            LastName: "Demosson",
            Email: "email1@email.se",
            Phone: "0123456789-1",
            LicensePlate: "ABC123"
        },
        {
            Text: "Test Testarsson",
            Id: "a942b646-0fbe-4180-aea4-fdc196b3e321",
            FirstName: "Test",
            LastName: "Testsson",
            Email: "email2@email.se",
            Phone: "0123456789-2",
            LicensePlate: "ABC123"
        },
        {
            Text: "Clicker Clickmeister",
            Id: "a942b646-0fbe-4180-aea4-fdc196b3e322",
            FirstName: "Clicker",
            LastName: "Clickmeister",
            Email: "email3@email.se",
            Phone: "0123456789-3",
            LicensePlate: "ABC123"
        }
    ],
    permitDetails: [
        {
            customerId: "8bca584c-3125-49eb-9727-a99de7302281",
            salesLocation: "a942b646-0fbe-4180-aea4-fdc196b3e321",
            permitType: "a942b646-0fbe-4180-aea4-fdc196b3e322",
            startDate: new Date(),
            startTime: "09:00",
            endDate: new Date(),
            endTime: "16:00",
            spaceNumber: "A1",
            notes: "Lorem ipsum..."
        },
        {
            firstName: "Demo 2",
            lastName: "Demosson 2",
            email: "demo@demosson.se",
            phone: "+46 70 123 45 67",
            licensePlate: "ABC 123",
            salesLocation: "a942b646-0fbe-4180-aea4-fdc196b3e322",
            permitType: "a942b646-0fbe-4180-aea4-fdc196b3e321",
            startDate: "2021-04-01",
            startTime: "10:00",
            endDate: "2021-04-07",
            endTime: "17:00",
            spaceNumber: "B-2",
            notes: "Lorem ipsum!"
        }
    ],
    unlockedConfigs: [
        {
            uid: "740513cc-0527-4531-9309-a96b5c585f51",
            name: "ROXANA TEST2 Unlock Code",
            countryCode: "SE",
            generateUniqueCodes: false,
            numberOfCodes: 20,
            codePrefix: null,
            numberOfUsedCodes: 0,
            code: "ROXA",
            unlockingCodes: [
                {
                    "code": "LTP-ROXA-HJ3N22JMJW",
                    "comment": "for employee Maria Didriksson",
                    "used": false,
                    "sentOut": "2025-11-14T08:06:01.895Z",
                    "sentOutBy": null,
                    "usedBy": null
                }
            ],
            pmcIdRefs: [
                "22ae8f61-9b59-4857-814b-7b7590fe7b6e",
                "14453",
                "b327408b-66f1-4e01-8cc6-762417489ad3"
            ],
            serviceChannelRefs: [
                "Online Sales",
                "AIMO_ONE"
            ]
        }
    ]
};

});


parcelRegister("5MyUm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $435c83782ab697e2$export$2e2bcd8739ae039; });

var $54dlf = parcelRequire("54dlf");

const $435c83782ab697e2$var$SuccessAnimation = ()=>{
    return /*#__PURE__*/ (0, $54dlf.jsxs)("svg", {
        className: "checkmark",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        children: [
            " ",
            /*#__PURE__*/ (0, $54dlf.jsx)("circle", {
                className: "checkmarkCircle",
                cx: "26",
                cy: "26",
                r: "25",
                fill: "none"
            }),
            " ",
            /*#__PURE__*/ (0, $54dlf.jsx)("path", {
                className: "checkmarkCheck",
                fill: "none",
                d: "M14.1 27.2l7.1 7.2 16.7-16.8"
            })
        ]
    });
};
var $435c83782ab697e2$export$2e2bcd8739ae039 = $435c83782ab697e2$var$SuccessAnimation;

});


parcelRegister("5kjCO", function(module, exports) {

$parcel$export(module.exports, "Divider", function () { return $3e0e0b1e9a42537f$export$2e0a83ec2e27ecbb; });

var $54dlf = parcelRequire("54dlf");
parcelRequire("ca3MY");
const $3e0e0b1e9a42537f$export$2e0a83ec2e27ecbb = (props)=>{
    const wrappingClass = [
        "single-step__divider",
        props.hideOnDesktop && "single-step__divider--hideondesktop"
    ].join(" ");
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: wrappingClass,
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)("hr", {}),
            props.text && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                children: props.text
            })
        ]
    });
};

});

parcelRegister("6bYiZ", function(module, exports) {

$parcel$export(module.exports, "BackNavigation", function () { return $48228c8741f4462c$export$644fdc4cb02aec57; });
$parcel$export(module.exports, "ReturnStepAfterVehicleStage", function () { return $48228c8741f4462c$export$2f24eeb623ba1b0c; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $8oRQh = parcelRequire("8oRQh");
parcelRequire("bJXZr");

var $i33el = parcelRequire("i33el");
const $48228c8741f4462c$export$644fdc4cb02aec57 = ({ disabled: disabled = false })=>{
    const { bookingFlowContext: bookingFlowContext, setBookingFlowContext: setBookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    const backHandler = ()=>{
        const newActiveStep = $48228c8741f4462c$export$4214fce2893b7773(bookingFlowContext);
        setBookingFlowContext({
            ...bookingFlowContext,
            activeStep: newActiveStep
        });
    };
    (0, $ca3MY.useEffect)(()=>{
        const initPopstateListener = (e)=>{
            if (e.state && e.state?.activeStep !== null && e.state.activeStep < bookingFlowContext.activeStep) backHandler();
        };
        window.addEventListener("popstate", initPopstateListener);
        return ()=>{
            window.removeEventListener("popstate", initPopstateListener);
        };
    }, [
        bookingFlowContext.availableSteps.onlineBooking.order
    ]);
    const clickHandler = ()=>{
        const activeStep = $48228c8741f4462c$export$4214fce2893b7773(bookingFlowContext);
        setBookingFlowContext({
            ...bookingFlowContext,
            activeStep: activeStep
        });
        if (!bookingFlowContext.episerver.hasWebticketAccount && activeStep === bookingFlowContext.availableSteps.onlineBooking.index) location.reload();
    };
    return /*#__PURE__*/ (0, $54dlf.jsx)("button", {
        className: "bookingflowpage__back",
        disabled: disabled,
        onClick: clickHandler,
        children: bookingFlowContext.localization.global.buttons.previousStep
    });
};
const $48228c8741f4462c$export$35e74ca67397283e = (bookingFlowContext)=>bookingFlowContext?.availableSteps?.onlineBooking?.formData?.productSelection?.item?.PermitUsageType?.toLowerCase() === "skidata";
const $48228c8741f4462c$export$2f24eeb623ba1b0c = (bookingFlowContext)=>(0, $i33el.isSalesOrderAttachmentsEnabled)(bookingFlowContext) ? bookingFlowContext.availableSteps.documentUpload.index : bookingFlowContext.availableSteps.orderOverview.index;
const $48228c8741f4462c$export$4214fce2893b7773 = (bookingFlowContext)=>{
    if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.login.index) //Login selection
    return bookingFlowContext.availableSteps.onlineBooking.index;
    else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.createAccount.index) //Create account
    return bookingFlowContext.availableSteps.onlineBooking.index;
    else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.addVehicle.index) //Add vehicle
    return bookingFlowContext.availableSteps.onlineBooking.index;
    else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.documentUpload.index) //Document upload — back to addVehicle (or onlineBooking for SKIDATA where addVehicle is skipped)
    return $48228c8741f4462c$export$35e74ca67397283e(bookingFlowContext) ? bookingFlowContext.availableSteps.onlineBooking.index : bookingFlowContext.availableSteps.addVehicle.index;
    else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.orderOverview.index) {
        //Order overview — back to DocumentUpload if attachments are enabled,
        //otherwise jump back over it to the vehicle stage (or onlineBooking for SKIDATA).
        if ((0, $i33el.isSalesOrderAttachmentsEnabled)(bookingFlowContext)) return bookingFlowContext.availableSteps.documentUpload.index;
        return $48228c8741f4462c$export$35e74ca67397283e(bookingFlowContext) ? bookingFlowContext.availableSteps.onlineBooking.index : bookingFlowContext.availableSteps.addVehicle.index;
    }
};

});
parcelRegister("bJXZr", function(module, exports) {

$parcel$export(module.exports, "getUniqueVehicles", function () { return $88c26e6c45d2261f$export$b7fc48bfc67a7dff; });
$parcel$export(module.exports, "shouldAccountBeUpdated", function () { return $88c26e6c45d2261f$export$6cd78c8c2d812d0a; });
/**
 * This code is ugly, but performs really well according to a person on StackOverflow https://stackoverflow.com/questions/9229645/remove-duplicate-values-from-js-array
 * Removes duplicates vehicles in an array
 * @param {array of vehicles} array 
 * @returns {array of vehicles without duplicates}
 */ const $88c26e6c45d2261f$export$b7fc48bfc67a7dff = (array)=>{
    var seen = {};
    var out = [];
    var len = array.length;
    var j = 0;
    for(var i = 0; i < len; i++){
        var current = array[i];
        var vehicle = current.item.PlateText ?? current.item.Text;
        if (seen[vehicle] !== 1) {
            seen[vehicle] = 1;
            out[j++] = current;
        }
    }
    return out;
};
const $88c26e6c45d2261f$export$6cd78c8c2d812d0a = (context)=>$88c26e6c45d2261f$export$366282c44fe7e350(context) && (context.episerver.shouldUpdateAccount === true || context.episerver.shouldUpdateAccount === "true");
const $88c26e6c45d2261f$export$366282c44fe7e350 = (context)=>+context.episerver.productType === 1;
const $88c26e6c45d2261f$export$26675f0d449b11d8 = (context)=>!$88c26e6c45d2261f$export$366282c44fe7e350(context);
const $88c26e6c45d2261f$export$b1a1893aa827b7e4 = (label, val)=>{
    console.log("%c" + label, "color: #fff; background: #245057; padding: 0.2rem 1.5rem;");
    console.log(val);
};

});

parcelRegister("i33el", function(module, exports) {

$parcel$export(module.exports, "fileToBase64", function () { return $d23b034f392f802b$export$25df2e315be8e003; });
$parcel$export(module.exports, "isSalesOrderAttachmentsEnabled", function () { return $d23b034f392f802b$export$e09f8d2720f2e6d1; });
$parcel$export(module.exports, "isSalesOrderAttachmentRequired", function () { return $d23b034f392f802b$export$aa84ff73713996; });
$parcel$export(module.exports, "hasSalesOrderAttachment", function () { return $d23b034f392f802b$export$b14d7eeb82d17898; });
$parcel$export(module.exports, "appliedPromotionConfig", function () { return $d23b034f392f802b$export$d7cfc94aa069a5a9; });
$parcel$export(module.exports, "isMonthsFreeOrHalfPricePromotion", function () { return $d23b034f392f802b$export$af0a9b6049e57d67; });
$parcel$export(module.exports, "base64ToFile", function () { return $d23b034f392f802b$export$962b7713c8684eac; });

var $6yjdU = parcelRequire("6yjdU");
const $d23b034f392f802b$export$25df2e315be8e003 = (file)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};
const $d23b034f392f802b$var$salesOrderProduct = (bookingFlowContext)=>bookingFlowContext?.availableSteps?.onlineBooking?.formData?.productSelection?.item;
const $d23b034f392f802b$export$e09f8d2720f2e6d1 = (bookingFlowContext)=>{
    const product = $d23b034f392f802b$var$salesOrderProduct(bookingFlowContext);
    const policy = (0, $6yjdU.attachmentPolicyOf)(product);
    return policy ? (0, $6yjdU.policyEnablesAttachments)(policy) : product?.EnableSalesOrderAttachments === true;
};
const $d23b034f392f802b$export$aa84ff73713996 = (bookingFlowContext)=>{
    if (!$d23b034f392f802b$export$e09f8d2720f2e6d1(bookingFlowContext)) return false;
    const product = $d23b034f392f802b$var$salesOrderProduct(bookingFlowContext);
    const policy = (0, $6yjdU.attachmentPolicyOf)(product);
    // Direct purchase treats both MANDATORY policies alike, the waiting list is what distinguishes them.
    return policy ? (0, $6yjdU.policyRequiresBeforeActivation)(policy) : product?.RequireSalesOrderAttachments === true;
};
const $d23b034f392f802b$export$b14d7eeb82d17898 = (bookingFlowContext)=>!!bookingFlowContext?.availableSteps?.documentUpload?.fileMeta?.uid;
const $d23b034f392f802b$export$d7cfc94aa069a5a9 = (bookingFlowContext, appliedPromotion)=>$d23b034f392f802b$var$salesOrderProduct(bookingFlowContext)?.Promotions?.find(({ Uid: Uid })=>!!Uid && Uid === appliedPromotion?.Uid) ?? null;
const $d23b034f392f802b$export$af0a9b6049e57d67 = (appliedPromotion, promotionConfig)=>[
        100,
        50
    ].includes(appliedPromotion?.Percent) && promotionConfig?.StartAfter != null && promotionConfig?.Duration != null;
const $d23b034f392f802b$export$962b7713c8684eac = (base64String, fileName, mimeType)=>{
    const byteString = atob(base64String.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for(let i = 0; i < byteString.length; i++)ia[i] = byteString.charCodeAt(i);
    return new File([
        ab
    ], fileName, {
        type: mimeType
    });
};

});
parcelRegister("6yjdU", function(module, exports) {

$parcel$export(module.exports, "attachmentPolicyOf", function () { return $4c54d46bfe6df54f$export$1b64d8aa3557b5da; });
$parcel$export(module.exports, "policyEnablesAttachments", function () { return $4c54d46bfe6df54f$export$811f3883dfeb049d; });
$parcel$export(module.exports, "policyRequiresBeforeActivation", function () { return $4c54d46bfe6df54f$export$c0208c32bc5af713; });
$parcel$export(module.exports, "policyRequiresAtWaitingList", function () { return $4c54d46bfe6df54f$export$5cf1d71e389a839c; });
const $4c54d46bfe6df54f$export$e9aa2794f4a48e7f = {
    NONE: "NONE",
    OPTIONAL: "OPTIONAL",
    MANDATORY_AT_WAITING_LIST: "MANDATORY_AT_WAITING_LIST",
    MANDATORY_BEFORE_ACTIVATION: "MANDATORY_BEFORE_ACTIVATION"
};
const $4c54d46bfe6df54f$export$1b64d8aa3557b5da = (product)=>product?.AttachmentPolicy ?? null;
const $4c54d46bfe6df54f$export$811f3883dfeb049d = (policy)=>!!policy && policy !== $4c54d46bfe6df54f$export$e9aa2794f4a48e7f.NONE;
const $4c54d46bfe6df54f$export$c0208c32bc5af713 = (policy)=>policy === $4c54d46bfe6df54f$export$e9aa2794f4a48e7f.MANDATORY_AT_WAITING_LIST || policy === $4c54d46bfe6df54f$export$e9aa2794f4a48e7f.MANDATORY_BEFORE_ACTIVATION;
const $4c54d46bfe6df54f$export$5cf1d71e389a839c = (policy)=>policy === $4c54d46bfe6df54f$export$e9aa2794f4a48e7f.MANDATORY_AT_WAITING_LIST;

});



parcelRegister("7zbft", function(module, exports) {

$parcel$export(module.exports, "CheckboxWithLabel", function () { return $5824870992f04293$export$6cb1578e30bfa58d; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $iSxgd = parcelRequire("iSxgd");

var $jl9cc = parcelRequire("jl9cc");
const $5824870992f04293$export$6cb1578e30bfa58d = (props)=>{
    const wrappingClass = `single-step__section single-step__section--checkbox`;
    const isValueObject = typeof props.value === "object" && props.value !== null;
    const error = isValueObject && props.value && props.value.error;
    const [isChecked, setIsChecked] = (0, $ca3MY.useState)(isValueObject ? props.value.selected : props.value);
    const onChangeHandler = (e)=>{
        setIsChecked(!isChecked);
        if (props.isAccessDevice) props.handleClick(e);
        if (isValueObject) {
            (0, $iSxgd.pushToDataLayer)({
                event: "checkbox_change",
                label: props.text,
                value: !props.value.selected
            });
            props.setValue({
                ...props.value,
                selected: !props.value.selected
            });
        } else if (!props.isAccessDevice) {
            (0, $iSxgd.pushToDataLayer)({
                event: "checkbox_change",
                label: props.text,
                value: !props.value
            });
            props.setValue(!props.value);
        }
    };
    (0, $ca3MY.useEffect)(()=>setIsChecked(isValueObject ? props.value.selected : props.value), [
        props.value
    ]);
    return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
        className: wrappingClass,
        children: /*#__PURE__*/ (0, $54dlf.jsxs)("label", {
            className: "single-step__section__checkbox-wrapper",
            "aria-disabled": props.disabled,
            children: [
                /*#__PURE__*/ (0, $54dlf.jsx)("input", {
                    className: "single-step__section__checkbox-original",
                    type: "checkbox",
                    "aria-invalid": error ? true : null,
                    checked: isChecked,
                    onChange: onChangeHandler,
                    disabled: props.disabled
                }),
                /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                    className: "single-step__section__checkbox-check"
                }),
                props.isAccessDevice && props.children,
                !props.isAccessDevice && /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                    className: "single-step__section__checkbox-label",
                    children: [
                        /*#__PURE__*/ (0, $54dlf.jsx)((0, $jl9cc.HtmlOutput), {
                            html: props.text
                        }),
                        error && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                            className: "validation-error",
                            children: error
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("kj4aw", function(module, exports) {

$parcel$export(module.exports, "InputWithLabel", function () { return $ec88d0d597a00351$export$cc1ef317067e4e4b; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $iSxgd = parcelRequire("iSxgd");

var $8Nnza = parcelRequire("8Nnza");
const $ec88d0d597a00351$export$cc1ef317067e4e4b = (props)=>{
    const wrappingClass = `single-step__section single-step__section--${(props.inputType === "quantity" ? "number" : props.inputType) || "text"}${props.toUpperCase ? " single-step__section--uppercase" : ""}`;
    const inputType = props.inputType ? props.inputType !== "ssn" && props.inputType !== "email" && props.inputType !== "organisation" ? props.inputType : "text" : "text";
    const inputTypeNumberProps = props.inputType === "number" || props.inputType === "quantity" ? {
        min: 1,
        step: 1,
        pattern: "d+"
    } : null;
    const error = props.value?.error ?? null;
    const value = props.value?.text ?? null;
    const defaultValue = props.defaultText !== null ? typeof props.defaultText === "object" ? props.defaultText.text ?? "" : props.defaultText : "";
    const useExtendedSupport = $ec88d0d597a00351$var$extendedSupport();
    const [inputValue, setInputValue] = (0, $ca3MY.useState)(props.inputType === "quantity" && !value ? "1" : value);
    const debouncedInputValue = (0, $8Nnza.useDebounce)(inputValue, props.debounce ?? 0);
    (0, $ca3MY.useEffect)(()=>{
        //if (!debouncedInputValue)
        //  return;
        if (props.onChange) {
            props.onChange(props.index, debouncedInputValue);
            (0, $iSxgd.pushToDataLayer)({
                event: "input_change",
                label: props.text,
                value: debouncedInputValue
            }, 1000);
        } else {
            if (!props.setValue) return;
            if (useExtendedSupport && debouncedInputValue && inputType === "time") {
                const value = debouncedInputValue.match(/\d+/g)?.join("") ?? "";
                if (value.length === 4) {
                    const outputHours = value.substring(0, 2);
                    const outputMinutes = value.substring(2);
                    if (parseInt(outputHours, 10) > 24 || parseInt(outputMinutes, 10) > 59) return;
                    props.setValue({
                        ...props.value,
                        text: `${outputHours}:${outputMinutes}`
                    });
                    return;
                } else if (debouncedInputValue.length >= 5) return;
            }
            const value = (props.inputType === "number" || props.inputType === "quantity") && debouncedInputValue ? `${debouncedInputValue}`.match(/\d+/g)?.join("") : debouncedInputValue;
            props.setValue({
                ...props.value,
                text: value
            });
        }
    }, [
        debouncedInputValue
    ]);
    (0, $ca3MY.useEffect)(()=>{
        setInputValue(props.inputType === "quantity" && value === "0" ? "1" : value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
        className: wrappingClass,
        children: /*#__PURE__*/ (0, $54dlf.jsxs)("label", {
            children: [
                props.text && /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                    className: [
                        "single-step__section__label",
                        props.displayAsText ? "single-step__section__label--small" : ""
                    ].join(" "),
                    children: [
                        props.text,
                        props.description && /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                            children: [
                                " ",
                                props.description
                            ]
                        })
                    ]
                }),
                props.displayAsText && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                    className: "single-step__section__text",
                    children: value
                }),
                !props.displayAsText && /*#__PURE__*/ (0, $54dlf.jsx)("input", {
                    type: inputType === "quantity" ? "number" : inputType,
                    inputMode: inputType === "quantity" || inputType === "number" ? "numeric" : "text",
                    "aria-invalid": error ? true : null,
                    onKeyDown: (e)=>props.keyDown ? props.keyDown(e) : null,
                    placeholder: props.placeholder,
                    autoComplete: props.autocomplete,
                    onChange: (e)=>setInputValue(e.target.value),
                    // defaultValue={defaultValue}
                    value: inputValue ?? defaultValue ?? "",
                    disabled: props.disabled,
                    autoFocus: props.autoFocus,
                    maxLength: props.maxLength,
                    name: props.name ?? "",
                    ...inputTypeNumberProps
                }),
                error && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                    className: "validation-error",
                    children: error
                })
            ]
        })
    });
};
const $ec88d0d597a00351$var$extendedSupport = ()=>{
    if (window.document.documentMode) return true;
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1 && ua.indexOf("chrome") === -1) return true;
    return false;
};

});
parcelRegister("8Nnza", function(module, exports) {

$parcel$export(module.exports, "useDebounce", function () { return $66752e12b0463437$export$21805fee57372823; });

var $ca3MY = parcelRequire("ca3MY");
const $66752e12b0463437$export$21805fee57372823 = (value, delay)=>{
    const [debouncedValue, setDebouncedValue] = (0, $ca3MY.useState)(value);
    (0, $ca3MY.useEffect)(()=>{
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value
    ]);
    return debouncedValue;
};

});


parcelRegister("dlTon", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b88343f2a041eed$export$2e2bcd8739ae039; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $8oRQh = parcelRequire("8oRQh");

var $se1IJ = parcelRequire("se1IJ");

var $axmXn = parcelRequire("axmXn");

var $leuhm = parcelRequire("leuhm");

var $6bYiZ = parcelRequire("6bYiZ");

var $7Kdfk = parcelRequire("7Kdfk");

var $jRoJF = parcelRequire("jRoJF");

var $iRAPu = parcelRequire("iRAPu");

var $5kjCO = parcelRequire("5kjCO");

var $2sdqj = parcelRequire("2sdqj");

var $gXzQg = parcelRequire("gXzQg");

var $7zbft = parcelRequire("7zbft");

var $gXJP5 = parcelRequire("gXJP5");

var $bJXZr = parcelRequire("bJXZr");
const $9b88343f2a041eed$var$CreateAccount = (props)=>{
    const { bookingFlowContext: bookingFlowContext, setBookingFlowContext: setBookingFlowContext } = props.editSettings || props.formLogin ? {
        bookingFlowContext: props.bookingFlowContext,
        setBookingFlowContext: null
    } : (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    const formLang = {
        ...bookingFlowContext.episerver,
        ...bookingFlowContext.localization.global,
        ...bookingFlowContext.localization.createAccount
    };
    const isGuestAccount = bookingFlowContext.guest;
    const [pending, setPending] = (0, $ca3MY.useState)(false);
    const [error, setError] = (0, $ca3MY.useState)(null);
    const [enableSave, setEnableSave] = (0, $ca3MY.useState)(!props.editSettings);
    const [showSaveButtonCheck, setShowSaveButtonCheck] = (0, $ca3MY.useState)(false);
    const topOfContainerRef = (0, $ca3MY.useRef)(null);
    const currentLanguage = document.querySelector("html").getAttribute("lang");
    const disableOthers = bookingFlowContext.country !== "no" && formLang.invoicePreference === "EDI" || formLang.invoicePreference === "E_INVOICE" || formLang.invoicePreference === "FINVOICE";
    const render = (0, $ca3MY.useRef)(1);
    // få in detta från BE och sätt val; guest är alltid B2C, men kan vara te.x. landlord
    const accountSelectionOptions = [
        {
            Text: formLang.accountTypeOptions.private,
            Id: 1,
            Value: "B2C"
        },
        {
            Text: formLang.accountTypeOptions.business,
            Id: 2,
            Value: "B2B"
        }
    ];
    var countrySelectionOptions = [];
    for(var c in formLang.countryOptions)countrySelectionOptions.push({
        Text: c,
        Id: c
    });
    const languageOptions = [
        ...bookingFlowContext.country === "fi" ? [
            {
                id: "fi",
                text: formLang.languageOptions.fi
            }
        ] : [],
        ...bookingFlowContext.country === "fi" || bookingFlowContext.country === "se" ? [
            {
                id: "sv",
                text: formLang.languageOptions.se
            }
        ] : [],
        ...bookingFlowContext.country === "no" ? [
            {
                id: "no",
                text: formLang.languageOptions.no
            }
        ] : [],
        {
            id: "en",
            text: formLang.languageOptions.en
        }
    ];
    const invoiceOptions = bookingFlowContext.country === "se" && bookingFlowContext.episerver.paymentMethod && bookingFlowContext.episerver.paymentMethod === "DIRECT_DEBIT" ? [
        {
            id: "EMAIL",
            text: formLang.invoiceOptions.emailreceipt,
            disabled: false
        },
        {
            id: "PAPER",
            text: formLang.invoiceOptions.noreceipt,
            disabled: false
        }
    ] : [
        {
            id: "EMAIL",
            text: formLang.invoiceOptions.email,
            disabled: !!disableOthers
        },
        {
            id: "PAPER",
            text: formLang.invoiceOptions.paper + (props.editSettings && bookingFlowContext.episerver.account_type === "B2B" || bookingFlowContext.episerver.PaymentInfoUrl ? "" : "\xb9"),
            disabled: !!disableOthers
        },
        ...props.editSettings && (bookingFlowContext.episerver.account_type === "B2C" || bookingFlowContext.country === "se") ? [
            {
                id: "E_INVOICE",
                text: formLang.invoiceOptions.e_invoice + (props.editSettings && bookingFlowContext.episerver.account_type === "B2B" ? "\xb9" : ""),
                disabled: formLang.invoicePreference !== "E_INVOICE"
            }
        ] : []
    ];
    const notificationOptions = [
        {
            id: "EMAIL",
            text: formLang.notificationOptions.email
        },
        {
            id: "PAPER",
            text: formLang.notificationOptions.paper
        }
    ];
    let shippingSameAsBillingDefault = false;
    if (bookingFlowContext.country === "se" || bookingFlowContext.country === "no") shippingSameAsBillingDefault = true;
    const [shippingSameAsBilling, setShippingSameAsBilling] = (0, $ca3MY.useState)({
        selected: shippingSameAsBillingDefault,
        elementType: "checkbox"
    });
    const defaultCountrySelection = (isShippingCountry = false)=>{
        if (isShippingCountry && !!bookingFlowContext.episerver.shipping_country) return {
            item: countrySelectionOptions.find((country)=>country.Id === bookingFlowContext.episerver.shipping_country),
            required: !shippingSameAsBilling.selected,
            elementType: "select"
        };
        else if (!isShippingCountry && !!bookingFlowContext.episerver.billing_country) return {
            item: countrySelectionOptions.find((country)=>country.Id === bookingFlowContext.episerver.billing_country),
            required: true,
            elementType: "select"
        };
        else if (!bookingFlowContext.episerver.billing_country) return {
            item: {
                Text: formLang.countrySelect,
                Id: ""
            },
            required: !(isShippingCountry && shippingSameAsBilling.selected),
            elementType: "select"
        };
        return {
            item: countrySelectionOptions.find((country)=>country.Id === bookingFlowContext.episerver.billing_country),
            required: true,
            elementType: "select"
        };
    };
    const defaultAccountState = ()=>{
        if (!!bookingFlowContext.episerver.account_type) return {
            item: accountSelectionOptions.find((accountType)=>accountType.Value === bookingFlowContext.episerver.account_type),
            elementType: "select"
        };
        else if (isGuestAccount) return {
            item: {
                Text: "Guest",
                Id: 0,
                Value: "B2C"
            },
            elementType: "select"
        };
        return {
            item: accountSelectionOptions[0],
            elementType: "select"
        };
    };
    const countryCallingCode = bookingFlowContext.episerver.customer_phone;
    const [notification, setNotification] = (0, $ca3MY.useState)({
        item: {
            id: props.editSettings ? bookingFlowContext.episerver.notificationPreference : "EMAIL"
        },
        elementType: "radio"
    });
    const [invoice, setInvoice] = (0, $ca3MY.useState)({
        item: {
            id: props.editSettings ? bookingFlowContext.episerver.invoicePreference : "EMAIL"
        },
        elementType: "radio"
    });
    const [language, setLanguage] = (0, $ca3MY.useState)({
        item: {
            id: props.editSettings ? bookingFlowContext.episerver.languagePreference : bookingFlowContext.localization.language
        },
        elementType: "radio"
    });
    const [accountSelection, setAccountSelection] = (0, $ca3MY.useState)(defaultAccountState());
    const [companyName, setCompanyName] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.company_name,
        required: true
    });
    const [organisationNumber, setOrganisationNumber] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.organisation_number,
        required: true,
        elementType: "organisation"
    });
    const [firstName, setFirstName] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.given_name ?? "",
        required: true
    });
    const [lastName, setLastName] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.family_name ?? "",
        required: true
    });
    const [ssn, setSsn] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.social_security_number,
        required: bookingFlowContext.country === "se",
        elementType: "ssn",
        notSet: !!!bookingFlowContext.episerver.social_security_number
    });
    const [phone, setPhone] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.customer_phone,
        required: false,
        elementType: "phone"
    });
    const [mobile, setMobile] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.customer_mobile,
        required: false,
        elementType: "phone"
    });
    //const [email, setEmail] = useState({ text: bookingFlowContext.episerver.emailAddress ?? '', required: true, elementType: 'email' })
    const [primaryContactEmailAddress, setPrimaryContactEmailAddress] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.emailAddress ?? "",
        required: true,
        elementType: "email"
    });
    const [invoiceEmail, setInvoiceEmail] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.invoice_email_address ?? "",
        required: invoice.item.id === "EMAIL" ? true : false,
        elementType: "email"
    });
    const [vatRegistrationNumber, setVatRegistrationNumber] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.vat_registration_number ?? "",
        required: false
    });
    const [street, setStreet] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.billing_street,
        required: true
    });
    const [street3, setStreet3] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.billing_street3,
        required: false
    });
    const [box, setBox] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.billing_box,
        required: false
    });
    const [co, setCO] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.billing_co,
        required: false
    });
    const [attention, setAttention] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.billing_attention,
        required: false
    });
    const [reference, setReference] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.billing_reference,
        required: false
    });
    const [zipcode, setZipcode] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.billing_zip,
        required: true,
        elementType: "zipcode"
    });
    const [city, setCity] = (0, $ca3MY.useState)({
        text: bookingFlowContext.episerver.billing_city,
        required: true
    });
    const [countrySelection, setCountrySelection] = (0, $ca3MY.useState)(defaultCountrySelection(false));
    const [shippingStreet, setShippingStreet] = (0, $ca3MY.useState)({
        text: "",
        required: true
    });
    const [shippingBox, setShippingBox] = (0, $ca3MY.useState)({
        text: "",
        required: false
    });
    const [shippingCO, setShippingCO] = (0, $ca3MY.useState)({
        text: "",
        required: false
    });
    const [shippingAttention, setShippingAttention] = (0, $ca3MY.useState)({
        text: "",
        required: false
    });
    const [shippingReference, setShippingReference] = (0, $ca3MY.useState)({
        text: "",
        required: false
    });
    const [shippingZipcode, setShippingZipcode] = (0, $ca3MY.useState)({
        text: "",
        required: true,
        elementType: "zipcode"
    });
    const [shippingCity, setShippingCity] = (0, $ca3MY.useState)({
        text: "",
        required: true
    });
    const [shippingCountrySelection, setShippingCountrySelection] = (0, $ca3MY.useState)(defaultCountrySelection(true));
    const [privacyStatement, setPrivacyStatement] = (0, $ca3MY.useState)({
        selected: !!props.editSettings,
        required: true,
        elementType: "checkbox"
    });
    const [marketingCompliance, setMarketingCompliance] = (0, $ca3MY.useState)({
        selected: false,
        required: false,
        elementType: "checkbox"
    });
    const paymentMethod = bookingFlowContext.episerver.paymentMethod;
    const formData = {
        notification: notification,
        setNotification: setNotification,
        notificationOptions: notificationOptions,
        invoice: invoice,
        setInvoice: setInvoice,
        invoiceOptions: invoiceOptions,
        language: language,
        setLanguage: setLanguage,
        languageOptions: languageOptions,
        firstName: firstName,
        setFirstName: setFirstName,
        lastName: lastName,
        setLastName: setLastName,
        ssn: ssn,
        setSsn: setSsn,
        phone: phone,
        setPhone: setPhone,
        street: street,
        setStreet: setStreet,
        street3: street3,
        setStreet3: setStreet3,
        zipcode: zipcode,
        setZipcode: setZipcode,
        city: city,
        setCity: setCity,
        box: box,
        setBox: setBox,
        co: co,
        setCO: setCO,
        attention: attention,
        setAttention: setAttention,
        reference: reference,
        setReference: setReference,
        shippingStreet: shippingStreet,
        setShippingStreet: setShippingStreet,
        shippingBox: shippingBox,
        setShippingBox: setShippingBox,
        shippingCO: shippingCO,
        setShippingCO: setShippingCO,
        shippingAttention: shippingAttention,
        setShippingAttention: setShippingAttention,
        shippingReference: shippingReference,
        setShippingReference: setShippingReference,
        shippingZipcode: shippingZipcode,
        setShippingZipcode: setShippingZipcode,
        shippingCity: shippingCity,
        setShippingCity: setShippingCity,
        shippingCountrySelection: shippingCountrySelection,
        setShippingCountrySelection: setShippingCountrySelection,
        mobile: mobile,
        setMobile: setMobile,
        companyName: companyName,
        setCompanyName: setCompanyName,
        paymentMethod: paymentMethod,
        organisationNumber: organisationNumber,
        setOrganisationNumber: setOrganisationNumber,
        primaryContactEmailAddress: primaryContactEmailAddress,
        setPrimaryContactEmailAddress: setPrimaryContactEmailAddress,
        vatRegistrationNumber: vatRegistrationNumber,
        setVatRegistrationNumber: setVatRegistrationNumber,
        shippingSameAsBilling: shippingSameAsBilling,
        setShippingSameAsBilling: setShippingSameAsBilling,
        invoiceEmail: invoiceEmail,
        setInvoiceEmail: setInvoiceEmail,
        countrySelection: countrySelection,
        setCountrySelection: setCountrySelection,
        countrySelectionOptions: countrySelectionOptions
    };
    (0, $ca3MY.useEffect)(()=>{
        if (render.current > 2) setEnableSave(true);
        if (!shippingSameAsBilling.selected) {
            setShippingStreet({
                text: bookingFlowContext.episerver.shipping_street || street.text,
                required: true
            });
            setShippingBox({
                text: bookingFlowContext.episerver.shipping_box || box.text,
                required: false
            });
            setShippingCO({
                text: bookingFlowContext.episerver.shipping_co || co.text,
                required: false
            });
            setShippingAttention({
                text: bookingFlowContext.episerver.shipping_attention || attention.text,
                required: false
            });
            setShippingReference({
                text: bookingFlowContext.episerver.shipping_reference || reference.text,
                required: false
            });
            setShippingZipcode({
                text: bookingFlowContext.episerver.shipping_zip || zipcode.text,
                required: true,
                elementType: "zipcode"
            });
            setShippingCity({
                text: bookingFlowContext.episerver.shipping_city || city.text,
                required: true
            });
            setShippingCountrySelection(countrySelection.item.Id ? {
                item: {
                    ...countrySelection.item
                },
                required: true,
                elementType: "select"
            } : defaultCountrySelection(true));
        } else setShippingCountrySelection(countrySelection.item.Id ? {
            item: {
                ...countrySelection.item
            },
            required: false,
            elementType: "select"
        } : defaultCountrySelection(true));
    }, [
        shippingSameAsBilling.selected
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (render.current > 2) setEnableSave(true);
        if (invoice.item.id != "EMAIL") {
            const error = invoiceEmail.error ? null : invoiceEmail.error;
            if (accountSelection.item.Id === 1 || accountSelection.item.Id === 2) setInvoiceEmail({
                ...invoiceEmail,
                required: false,
                error: error
            });
            else setInvoiceEmail({
                ...invoiceEmail,
                required: true,
                error: error
            });
        } else setInvoiceEmail({
            ...invoiceEmail,
            required: true
        });
    }, [
        invoice.item.id,
        accountSelection.item.Id
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (render.current > 2) setEnableSave(true);
        if (notification.item.id === "EMAIL") setPrimaryContactEmailAddress({
            ...primaryContactEmailAddress,
            required: true
        });
        else {
            const error = primaryContactEmailAddress.error && accountSelection.item.Id == 2 ? null : primaryContactEmailAddress.error;
            setPrimaryContactEmailAddress({
                ...primaryContactEmailAddress,
                required: accountSelection.item.Id == 2 ? false : true,
                error: error
            });
        }
    }, [
        notification.item.id,
        accountSelection.item.Id
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (render.current > 2) setEnableSave(true);
    }, [
        language.item.id
    ]);
    (0, $ca3MY.useLayoutEffect)(()=>{
        if (render.current > 2) return;
        render.current++;
    });
    const handleKeyDown = function(event) {
        setEnableSave(true);
        if (event.key === "Enter") createAccountHandler();
    };
    (0, $ca3MY.useEffect)(()=>{
        if (render.current > 2) setEnableSave(true);
        setCountrySelection({
            ...countrySelection,
            error: null
        });
    }, [
        countrySelection.item.Id
    ]);
    const createAccountHandler = async ()=>{
        setError(null);
        let newAccountForm = {
            notificationPreference: {
                value: notification,
                setValue: setNotification
            },
            invoiceMethod: {
                value: invoice,
                setValue: setInvoice
            },
            preferredLanguage: {
                value: language,
                setValue: setLanguage
            },
            billingStreet: {
                value: street,
                setValue: setStreet
            },
            billingStreet2: {
                value: box,
                setValue: setBox
            },
            billingStreet3: {
                value: street3,
                setValue: setStreet3
            },
            billingCO: {
                value: co,
                setValue: setCO
            },
            billingAttention: {
                value: attention,
                setValue: setAttention
            },
            billingReference: {
                value: reference,
                setValue: setReference
            },
            billingPostalCode: {
                value: zipcode,
                setValue: setZipcode
            },
            billingCity: {
                value: city,
                setValue: setCity
            },
            billingCountry: {
                value: countrySelection,
                setValue: setCountrySelection
            },
            invoiceEmailAddress: {
                value: invoiceEmail,
                setValue: setInvoiceEmail
            },
            privacyStatement: {
                value: privacyStatement,
                setValue: setPrivacyStatement
            },
            marketingCompliance: {
                value: marketingCompliance,
                setValue: setMarketingCompliance
            },
            shippingSameAsBilling: {
                value: shippingSameAsBilling,
                setValue: setShippingSameAsBilling
            }
        };
        if (!isGuestAccount && accountSelection.item.Id === 0 || accountSelection.item.Id === 1) newAccountForm = {
            ...newAccountForm,
            firstName: {
                value: firstName,
                setValue: setFirstName
            },
            lastName: {
                value: lastName,
                setValue: setLastName
            },
            socialSecurityNumber: {
                value: ssn,
                setValue: setSsn
            },
            primaryContactEmailAddress: {
                value: primaryContactEmailAddress,
                setValue: setPrimaryContactEmailAddress
            },
            personMobilePhone: {
                value: countryCallingCode === mobile.text ? {
                    text: "",
                    required: false,
                    elementType: "phone"
                } : mobile,
                setValue: setMobile
            },
            phone: {
                value: countryCallingCode === phone.text ? {
                    text: "",
                    required: false,
                    elementType: "phone"
                } : phone,
                setValue: setPhone
            },
            shippingStreet: {
                value: shippingStreet,
                setValue: setShippingStreet
            },
            shippingStreet2: {
                value: shippingBox,
                setValue: setShippingBox
            },
            shippingCO: {
                value: shippingCO,
                setValue: setShippingCO
            },
            shippingAttention: {
                value: shippingAttention,
                setValue: setShippingAttention
            },
            shippingReference: {
                value: shippingReference,
                setValue: setShippingReference
            },
            shippingPostalCode: {
                value: shippingZipcode,
                setValue: setShippingZipcode
            },
            shippingCity: {
                value: shippingCity,
                setValue: setShippingCity
            },
            shippingCountry: {
                value: shippingCountrySelection,
                setValue: setShippingCountrySelection
            }
        };
        else if (!isGuestAccount && accountSelection.item.Id === 2) newAccountForm = {
            ...newAccountForm,
            name: {
                value: companyName,
                setValue: setCompanyName
            },
            primaryContactEmailAddress: {
                value: primaryContactEmailAddress,
                setValue: setPrimaryContactEmailAddress
            },
            phone: {
                value: countryCallingCode === phone.text ? {
                    text: "",
                    required: false,
                    elementType: "phone"
                } : phone,
                setValue: setPhone
            },
            vatNumber: {
                value: vatRegistrationNumber,
                setValue: setVatRegistrationNumber
            },
            organisationNumber: {
                value: organisationNumber,
                setValue: setOrganisationNumber
            },
            shippingStreet: {
                value: shippingStreet,
                setValue: setShippingStreet
            },
            shippingStreet2: {
                value: shippingBox,
                setValue: setShippingBox
            },
            shippingCO: {
                value: shippingCO,
                setValue: setShippingCO
            },
            shippingAttention: {
                value: shippingAttention,
                setValue: setShippingAttention
            },
            shippingReference: {
                value: shippingReference,
                setValue: setShippingReference
            },
            shippingPostalCode: {
                value: shippingZipcode,
                setValue: setShippingZipcode
            },
            shippingCity: {
                value: shippingCity,
                setValue: setShippingCity
            },
            shippingCountry: {
                value: shippingCountrySelection,
                setValue: setShippingCountrySelection
            }
        };
        else if (isGuestAccount) newAccountForm = {
            firstName: {
                value: firstName,
                setValue: setFirstName
            },
            lastName: {
                value: lastName,
                setValue: setLastName
            },
            personEmail: {
                value: email,
                setValue: setEmail
            },
            privacyStatement: {
                value: privacyStatement,
                setValue: setPrivacyStatement
            },
            marketingCompliance: {
                value: marketingCompliance,
                setValue: setMarketingCompliance
            }
        };
        let [formValidationError, cleanFormData, flatCleanFormData] = (0, $se1IJ.validateFormObject)(newAccountForm, formLang.errorMessages, bookingFlowContext.country);
        if (formValidationError) {
            if (flatCleanFormData.personMobilePhone?.value === "" || !flatCleanFormData.personMobilePhone) setMobile({
                text: bookingFlowContext.episerver.customer_mobile,
                required: false,
                elementType: "phone"
            });
            if (flatCleanFormData.phone?.value === "" || !flatCleanFormData.phone) setPhone({
                text: bookingFlowContext.episerver.customer_phone,
                required: false,
                elementType: "phone"
            });
            setTimeout(()=>setError({
                    error: true
                }), 250);
            return;
        }
        setPending(true);
        const createdCustomer = await (0, $axmXn.account).createOrEditCustomer({
            bookingController: bookingFlowContext.episerver.bookingController,
            form: {
                ...flatCleanFormData,
                recordType: accountSelection.item.Value,
                uid: props.editSettings ? bookingFlowContext.episerver.uid : null,
                updateSSN: ssn.notSet
            }
        }, bookingFlowContext.useMockedData, currentLanguage);
        if (!createdCustomer.status || createdCustomer.status !== 200) {
            setPending(false);
            if ((0, $bJXZr.shouldAccountBeUpdated)(bookingFlowContext)) setError({
                error: true,
                errorText: formLang.anerroroccurred
            });
            else setError({
                error: true,
                errorText: createdCustomer.errorMessage
            });
            return;
        }
        setEnableSave(false);
        setPending(false);
        setTimeout(()=>setShowSaveButtonCheck(true), 10);
        if (!props.editSettings && !props.formLogin) {
            // If permit Usage type is SKIDATA, jump over 'Add vehicle' step (CPS-24723) 
            const isSkidata = bookingFlowContext?.availableSteps?.onlineBooking?.formData?.productSelection?.item?.PermitUsageType?.toLowerCase() === "skidata";
            let newActiveStep = bookingFlowContext.availableSteps.addVehicle.index;
            if (isSkidata) newActiveStep = (0, $6bYiZ.ReturnStepAfterVehicleStage)(bookingFlowContext);
            setTimeout(()=>{
                setBookingFlowContext({
                    ...bookingFlowContext,
                    activeStep: newActiveStep,
                    user: {
                        email: bookingFlowContext.episerver.emailAddress,
                        givenName: bookingFlowContext.episerver.given_name,
                        familyName: bookingFlowContext.episerver.family_name
                    },
                    availableSteps: {
                        ...bookingFlowContext.availableSteps,
                        createAccount: {
                            ...bookingFlowContext.availableSteps.createAccount,
                            formData: cleanFormData
                        }
                    }
                });
            }, 1000);
        } else {
            if (props.editSettings) setTimeout(()=>setShowSaveButtonCheck(false), 2000);
            if (props.formLogin) setTimeout(()=>window.location.href = window.location.href, 500);
        }
    };
    (0, $ca3MY.useEffect)(()=>{
        if (!error || error.errorText?.length > 0) return;
        const firstInvalidElement = document.querySelector("[aria-invalid]");
        if (firstInvalidElement) firstInvalidElement.scrollIntoView({
            behavior: "smooth"
        });
        else if (topOfContainerRef && topOfContainerRef.current) topOfContainerRef.current.scrollIntoView({
            behavior: "smooth"
        });
    }, [
        error
    ]);
    // console.log("bookingFlowContext CreateAccount", bookingFlowContext);
    // console.log("formLang CreateAccount", formLang);
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: "bookingflowpage__app bookingflowpage__app--createaccount",
        children: [
            !props.editSettings && !props.formLogin && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $6bYiZ.BackNavigation), {}),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $leuhm.Heading), {})
                ]
            }),
            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                className: "single-step single-step--createaccount",
                ref: topOfContainerRef,
                children: [
                    !props.editSettings && /*#__PURE__*/ (0, $54dlf.jsx)("h2", {
                        children: (0, $bJXZr.shouldAccountBeUpdated)(bookingFlowContext) ? formLang.updateAccountHeading : formLang.heading
                    }),
                    !isGuestAccount && !(0, $bJXZr.shouldAccountBeUpdated)(bookingFlowContext) && !props.editSettings && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $2sdqj.TwoColumnWrapper), {
                                children: /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXzQg.DropdownlistWithLabel), {
                                    text: formLang.accountType,
                                    options: accountSelectionOptions,
                                    value: accountSelection,
                                    setValue: setAccountSelection
                                })
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {})
                        ]
                    }),
                    !isGuestAccount && (accountSelection.item.Id === 0 || accountSelection.item.Id === 1 || props.editSettings && bookingFlowContext.episerver.account_type !== "B2B") && /*#__PURE__*/ (0, $54dlf.jsx)((0, $7Kdfk.default), {
                        bookingFlowContext: bookingFlowContext,
                        formData: formData,
                        keyDown: handleKeyDown
                    }),
                    !isGuestAccount && (accountSelection.item.Id === 2 || bookingFlowContext.episerver.account_type === "B2B") && /*#__PURE__*/ (0, $54dlf.jsx)((0, $jRoJF.default), {
                        bookingFlowContext: bookingFlowContext,
                        formData: formData,
                        keyDown: handleKeyDown
                    }),
                    isGuestAccount && /*#__PURE__*/ (0, $54dlf.jsx)((0, $iRAPu.default), {
                        bookingFlowContext: bookingFlowContext,
                        formData: formData,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
                    !props.editSettings && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                                children: "Terms and conditions"
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $7zbft.CheckboxWithLabel), {
                                text: formLang.privacyStatement,
                                value: privacyStatement,
                                setValue: setPrivacyStatement
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $7zbft.CheckboxWithLabel), {
                                text: formLang.marketingCompliance,
                                value: marketingCompliance,
                                setValue: setMarketingCompliance
                            })
                        ]
                    }),
                    error && error.errorText?.length > 0 && /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXJP5.Error), {
                        text: error.errorText
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                        className: `single-step__button single-step__button--saveable single-step__button--createaccount ${showSaveButtonCheck ? "single-step__button--complete" : ""}`,
                        "data-map-button": props.editSettings ? "save-settings" : undefined,
                        disabled: pending || !privacyStatement.selected || props.editSettings && !enableSave || showSaveButtonCheck,
                        "aria-busy": pending,
                        onClick: createAccountHandler,
                        children: (0, $bJXZr.shouldAccountBeUpdated)(bookingFlowContext) ? formLang.submitupdateform : props.editSettings ? formLang.savechanges : formLang.submitform
                    })
                ]
            })
        ]
    });
};
var $9b88343f2a041eed$export$2e2bcd8739ae039 = $9b88343f2a041eed$var$CreateAccount;

});
parcelRegister("7Kdfk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a371aaf41d3ccfd$export$2e2bcd8739ae039; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $5kjCO = parcelRequire("5kjCO");

var $2sdqj = parcelRequire("2sdqj");

var $kj4aw = parcelRequire("kj4aw");

var $7zbft = parcelRequire("7zbft");

var $gXzQg = parcelRequire("gXzQg");

var $7HCW7 = parcelRequire("7HCW7");

var $4kqcG = parcelRequire("4kqcG");
const $5a371aaf41d3ccfd$var$CreateAccountPrivate = (props)=>{
    const formLang = props.bookingFlowContext.localization.createAccount;
    const invoiceFee = props.bookingFlowContext.episerver.PaperInvoiceFeeB2C;
    const formData = props.formData;
    const handleKeyDown = props.keyDown;
    const currentYear = new Date().getFullYear().toString().slice(-2);
    let ssnPlaceholderText = "", phoneNumberPlaceholderText = "", street3PlaceholderText = "";
    if (props.bookingFlowContext.country === "se") ssnPlaceholderText = "YYYYMMDD-XXXX", phoneNumberPlaceholderText = "+46123456789", street3PlaceholderText = "Gatuadress - linje 2";
    else if (props.bookingFlowContext.country === "no") ssnPlaceholderText = "12345678901", phoneNumberPlaceholderText = "+47123456789", street3PlaceholderText = "Gateadresse \u2013 linje 2";
    else if (props.bookingFlowContext.country === "fi") ssnPlaceholderText = "XXXXXX-ZZZZ", phoneNumberPlaceholderText = "+35812345678", street3PlaceholderText = "Katuosoite - rivi 2";
    else ssnPlaceholderText = "XXXXXX-ZZZZ", phoneNumberPlaceholderText = "+46123456789", street3PlaceholderText = "Street - line 2";
    const autoFormatSsn = (ssn)=>{
        if (props.bookingFlowContext.country === "se") {
            ssn.text = ssn.text.length === 2 && ssn.text.slice(0, 2) !== "19" && ssn.text.slice(0, 2) !== "20" && +ssn.text.slice(0, 2) > +currentYear ? "19" + ssn.text : ssn.text;
            ssn.text = ssn.text.length === 2 && ssn.text.slice(0, 2) !== "19" && ssn.text.slice(0, 2) !== "20" && +ssn.text.slice(0, 2) < +currentYear - 5 ? "20" + ssn.text : ssn.text;
            ssn.text = (ssn.text.slice(0, 2) === "19" || ssn.text.slice(0, 2) === "20") && ssn.text.length === 12 && !isNaN(ssn.text) ? ssn.text.slice(0, 8) + "-" + ssn.text.slice(8) : ssn.text;
        }
        formData.setSsn(ssn);
    };
    return /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $7HCW7.RadioButtonListWithLabel), {
                text: formLang.notificationpreference,
                options: formData.notificationOptions,
                value: formData.notification,
                setValue: formData.setNotification
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            props.bookingFlowContext.country === "se" && formData.paymentMethod && formData.paymentMethod === "DIRECT_DEBIT" ? /*#__PURE__*/ (0, $54dlf.jsx)((0, $7HCW7.RadioButtonListWithLabel), {
                modifierClass: "direct_debit",
                text: formLang.invoicepreference + " " + formLang.invoiceOptions.directdebit,
                options: formData.invoiceOptions,
                value: formData.invoice,
                setValue: formData.setInvoice
            }) : /*#__PURE__*/ (0, $54dlf.jsx)((0, $7HCW7.RadioButtonListWithLabel), {
                text: formLang.invoicepreference,
                options: formData.invoiceOptions,
                value: formData.invoice,
                setValue: formData.setInvoice
            }),
            props.bookingFlowContext.country === "se" && props.bookingFlowContext.episerver.PaymentInfoUrl ? /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                className: "single-step__information",
                children: /*#__PURE__*/ (0, $54dlf.jsxs)("a", {
                    href: props.bookingFlowContext.episerver.PaymentInfoUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: [
                        " ",
                        formLang.invoiceOptions.paymentinfo
                    ]
                })
            }) : formData.paymentMethod && formData.paymentMethod === "DIRECT_DEBIT" ? null : /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                className: "single-step__information",
                children: "\xb9" + formLang.invoiceOptions.paperinformation.replace("{0}", (0, $4kqcG.formatCurrency)(invoiceFee, props.bookingFlowContext.country, true))
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $7HCW7.RadioButtonListWithLabel), {
                text: formLang.languagepreference,
                options: formData.languageOptions,
                value: formData.language,
                setValue: formData.setLanguage
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                children: formLang.subheadings?.personal
            }),
            /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.firstName,
                        defaultText: props.skipAutofill ? null : formData.firstName,
                        value: formData.firstName,
                        setValue: formData.setFirstName,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.lastName,
                        defaultText: props.skipAutofill ? null : formData.lastName,
                        value: formData.lastName,
                        setValue: formData.setLastName,
                        keyDown: handleKeyDown
                    }),
                    props.bookingFlowContext.country === "se" && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                                inputType: "ssn",
                                text: formLang.ssn,
                                value: formData.ssn,
                                setValue: autoFormatSsn,
                                keyDown: handleKeyDown,
                                placeholder: ssnPlaceholderText,
                                disabled: props.bookingFlowContext.episerver.uid && !formData.ssn.notSet
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                                className: "single-step__section"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "email",
                        text: formLang.invoiceEmail + (formData.invoiceEmail.required ? "*" : ""),
                        defaultText: props.skipAutofill ? null : formData.invoiceEmail,
                        value: formData.invoiceEmail,
                        setValue: formData.setInvoiceEmail,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "email",
                        text: formLang.email + (formData.primaryContactEmailAddress.required ? "*" : ""),
                        defaultText: props.skipAutofill ? null : formData.primaryContactEmailAddress,
                        value: formData.primaryContactEmailAddress,
                        setValue: formData.setPrimaryContactEmailAddress,
                        disabled: true
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.mobile,
                        description: `(${phoneNumberPlaceholderText})`,
                        value: formData.mobile,
                        defaultText: formData.mobile,
                        setValue: formData.setMobile,
                        keyDown: handleKeyDown,
                        maxLength: 20,
                        placeholder: phoneNumberPlaceholderText
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.phone,
                        description: `(${phoneNumberPlaceholderText})`,
                        value: formData.phone,
                        defaultText: formData.phone,
                        setValue: formData.setPhone,
                        keyDown: handleKeyDown,
                        maxLength: 20,
                        placeholder: phoneNumberPlaceholderText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                children: formLang.subheadings?.address
            }),
            /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.co,
                        value: formData.co,
                        setValue: formData.setCO,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.street + "*",
                        value: formData.street,
                        setValue: formData.setStreet,
                        keyDown: handleKeyDown
                    }),
                    formData.street3 && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                                className: "single-step__section"
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                                inputType: "text",
                                text: "",
                                value: formData.street3,
                                setValue: formData.setStreet3,
                                disabled: true,
                                placeholder: street3PlaceholderText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.box,
                        value: formData.box,
                        setValue: formData.setBox,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.zipcode + (formData.zipcode.required ? "*" : ""),
                        value: formData.zipcode,
                        setValue: formData.setZipcode,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.city + (formData.city.required ? "*" : ""),
                        value: formData.city,
                        setValue: formData.setCity,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXzQg.DropdownlistWithLabel), {
                        text: formLang.country + "*",
                        options: formData.countrySelectionOptions,
                        value: formData.countrySelection,
                        setValue: formData.setCountrySelection
                    })
                ]
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $7zbft.CheckboxWithLabel), {
                text: formLang.copyBillingInformation,
                value: formData.shippingSameAsBilling,
                setValue: formData.setShippingSameAsBilling
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                children: formLang.subheadings?.shipping
            }),
            /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.co,
                        defaultText: formData.shippingSameAsBilling.selected ? formData.co : formData.shippingCO,
                        value: formData.shippingSameAsBilling.selected ? formData.co : formData.shippingCO,
                        setValue: formData.setShippingCO,
                        disabled: formData.shippingSameAsBilling.selected,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.street + "*",
                        defaultText: formData.shippingSameAsBilling.selected ? formData.street : formData.shippingStreet,
                        value: formData.shippingSameAsBilling.selected ? formData.street : formData.shippingStreet,
                        setValue: formData.setShippingStreet,
                        disabled: formData.shippingSameAsBilling.selected,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.box,
                        defaultText: formData.shippingSameAsBilling.selected ? formData.box : formData.shippingBox,
                        value: formData.shippingSameAsBilling.selected ? formData.box : formData.shippingBox,
                        setValue: formData.setShippingBox,
                        disabled: formData.shippingSameAsBilling.selected,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.zipcode + (formData.shippingZipcode.required ? "*" : ""),
                        defaultText: formData.shippingSameAsBilling.selected ? formData.zipcode : formData.shippingZipcode,
                        value: formData.shippingSameAsBilling.selected ? formData.zipcode : formData.shippingZipcode,
                        setValue: formData.setShippingZipcode,
                        disabled: formData.shippingSameAsBilling.selected,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.city + (formData.shippingCity.required ? "*" : ""),
                        defaultText: formData.shippingSameAsBilling.selected ? formData.city : formData.shippingCity,
                        value: formData.shippingSameAsBilling.selected ? formData.city : formData.shippingCity,
                        setValue: formData.setShippingCity,
                        disabled: formData.shippingSameAsBilling.selected,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXzQg.DropdownlistWithLabel), {
                        dropdownId: "shippingCountrySelectOptions",
                        text: formLang.country + "*",
                        options: formData.countrySelectionOptions,
                        value: formData.shippingSameAsBilling.selected ? formData.countrySelection : formData.shippingCountrySelection,
                        setValue: formData.setShippingCountrySelection,
                        disabled: formData.shippingSameAsBilling.selected
                    })
                ]
            })
        ]
    });
};
var $5a371aaf41d3ccfd$export$2e2bcd8739ae039 = $5a371aaf41d3ccfd$var$CreateAccountPrivate;

});

parcelRegister("jRoJF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e75627878acd714f$export$2e2bcd8739ae039; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $5kjCO = parcelRequire("5kjCO");

var $2sdqj = parcelRequire("2sdqj");

var $kj4aw = parcelRequire("kj4aw");

var $7zbft = parcelRequire("7zbft");

var $gXzQg = parcelRequire("gXzQg");

var $7HCW7 = parcelRequire("7HCW7");

var $4kqcG = parcelRequire("4kqcG");
const $e75627878acd714f$var$CreateAccountPrivate = (props)=>{
    const formLang = props.bookingFlowContext.localization.createAccount;
    const invoiceFee = props.bookingFlowContext.episerver.PaperInvoiceFeeB2B;
    const formData = props.formData;
    const invoiceOptions = [
        ...props.formData.invoiceOptions,
        ...props.bookingFlowContext.country === "no" || props.bookingFlowContext.episerver.uid && props.bookingFlowContext.country !== "fi" ? [
            {
                id: "EDI",
                text: formLang.invoiceOptions.edi + (props.bookingFlowContext.country !== "no" ? "\xb9" : ""),
                disabled: props.bookingFlowContext.country !== "no" && formData.invoice.item.id !== "EDI"
            }
        ] : [],
        ...props.bookingFlowContext.country === "fi" && props.bookingFlowContext.episerver.uid ? [
            {
                id: "FINVOICE",
                text: formLang.invoiceOptions.finvoice + "\xb9",
                disabled: formData.invoice.item.id !== "FINVOICE"
            }
        ] : []
    ];
    const handleKeyDown = props.keyDown;
    let organisationNumberPlaceholderText = "", phoneNumberPlaceholderText = "";
    if (props.bookingFlowContext.country === "se") organisationNumberPlaceholderText = "XXXXXX-YYYY", phoneNumberPlaceholderText = "+46123456789";
    else if (props.bookingFlowContext.country === "no") organisationNumberPlaceholderText = "XXXXXXXXX", phoneNumberPlaceholderText = "+47123456789";
    else if (props.bookingFlowContext.country === "fi") organisationNumberPlaceholderText = "XXXXXXX-Y", phoneNumberPlaceholderText = "+35812345678";
    else organisationNumberPlaceholderText = "XXXXXX-YYYY", phoneNumberPlaceholderText = "+46123456789";
    return /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $7HCW7.RadioButtonListWithLabel), {
                text: formLang.notificationpreference,
                options: formData.notificationOptions,
                value: formData.notification,
                setValue: formData.setNotification
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            props.bookingFlowContext.country === "se" && formData.paymentMethod && formData.paymentMethod === "DIRECT_DEBIT" ? /*#__PURE__*/ (0, $54dlf.jsx)((0, $7HCW7.RadioButtonListWithLabel), {
                modifierClass: "direct_debit",
                text: formLang.invoicepreference + " " + formLang.invoiceOptions.directdebit,
                options: formData.invoiceOptions,
                value: formData.invoice,
                setValue: formData.setInvoice
            }) : /*#__PURE__*/ (0, $54dlf.jsx)((0, $7HCW7.RadioButtonListWithLabel), {
                text: formLang.invoicepreference,
                options: invoiceOptions,
                value: formData.invoice,
                setValue: formData.setInvoice
            }),
            (!formData.paymentMethod || formData.paymentMethod !== "DIRECT_DEBIT") && props.bookingFlowContext.episerver.uid && props.bookingFlowContext.country !== "no" && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                className: "single-step__information",
                children: "\xb9" + formLang.invoiceOptions.einformation
            }),
            props.bookingFlowContext.country === "se" && props.bookingFlowContext.episerver.PaymentInfoUrl ? /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                className: "single-step__information",
                children: /*#__PURE__*/ (0, $54dlf.jsxs)("a", {
                    href: props.bookingFlowContext.episerver.PaymentInfoUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: [
                        " ",
                        formLang.invoiceOptions.paymentinfo
                    ]
                })
            }) : !props.bookingFlowContext.episerver.uid && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                className: "single-step__information",
                children: "\xb9" + formLang.invoiceOptions.paperinformation.replace("{0}", (0, $4kqcG.formatCurrency)(invoiceFee, props.bookingFlowContext.country, true))
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $7HCW7.RadioButtonListWithLabel), {
                text: formLang.languagepreference,
                options: formData.languageOptions,
                value: formData.language,
                setValue: formData.setLanguage
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                children: formLang.subheadings?.business
            }),
            /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.company,
                        value: formData.companyName,
                        defaultText: props.skipAutofill ? null : formData.companyName,
                        setValue: formData.setCompanyName,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "organisation",
                        text: formLang.organisationNumber,
                        value: formData.organisationNumber,
                        defaultText: props.skipAutofill ? null : formData.organisationNumber,
                        setValue: formData.setOrganisationNumber,
                        keyDown: handleKeyDown,
                        placeholder: organisationNumberPlaceholderText
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "email",
                        text: formLang.invoiceEmail + (formData.invoiceEmail.required ? "*" : ""),
                        defaultText: props.skipAutofill ? null : formData.invoiceEmail,
                        value: formData.invoiceEmail,
                        setValue: formData.setInvoiceEmail,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "email",
                        text: formLang.email + (formData.primaryContactEmailAddress.required ? "*" : ""),
                        defaultText: props.skipAutofill ? null : formData.primaryContactEmailAddress,
                        value: formData.primaryContactEmailAddress,
                        setValue: formData.setPrimaryContactEmailAddress,
                        disabled: true
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.phone,
                        description: `(${phoneNumberPlaceholderText})`,
                        value: formData.phone,
                        defaultText: formData.phone,
                        setValue: formData.setPhone,
                        keyDown: handleKeyDown,
                        maxLength: 20,
                        placeholder: phoneNumberPlaceholderText
                    }),
                    (props.bookingFlowContext.episerver.uid && formData.vatRegistrationNumber?.text || !props.bookingFlowContext.episerver.uid) && /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.vatRegistrationNumber,
                        value: formData.vatRegistrationNumber,
                        setValue: formData.setVatRegistrationNumber,
                        disabled: props.bookingFlowContext.episerver.uid,
                        keyDown: handleKeyDown
                    })
                ]
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                children: formLang.subheadings?.billing
            }),
            /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.co,
                        value: formData.CO,
                        setValue: formData.setCO,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.attention,
                        value: formData.attention,
                        setValue: formData.setAttention,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.reference,
                        value: formData.reference,
                        setValue: formData.setReference,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.street + (formData.street.required ? "*" : ""),
                        value: formData.street,
                        setValue: formData.setStreet,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.box,
                        value: formData.box,
                        setValue: formData.setBox,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.zipcode + (formData.zipcode.required ? "*" : ""),
                        value: formData.zipcode,
                        setValue: formData.setZipcode,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.city + (formData.city.required ? "*" : ""),
                        value: formData.city,
                        setValue: formData.setCity,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXzQg.DropdownlistWithLabel), {
                        text: formLang.country + "*",
                        options: formData.countrySelectionOptions,
                        value: formData.countrySelection,
                        setValue: formData.setCountrySelection
                    })
                ]
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $7zbft.CheckboxWithLabel), {
                text: formLang.copyBillingInformation,
                value: formData.shippingSameAsBilling,
                setValue: formData.setShippingSameAsBilling
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                children: formLang.subheadings?.shipping
            }),
            /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.co,
                        defaultText: formData.shippingSameAsBilling.selected ? formData.co : formData.shippingCO,
                        value: formData.shippingSameAsBilling.selected ? formData.co : formData.shippingCO,
                        setValue: formData.setShippingCO,
                        disabled: formData.shippingSameAsBilling.selected,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.attention,
                        defaultText: formData.shippingSameAsBilling.selected ? formData.shippingAttention : formData.shippingAttention,
                        value: formData.shippingSameAsBilling.selected ? formData.attention : formData.shippingAttention,
                        setValue: formData.setShippingAttention,
                        disabled: formData.shippingSameAsBilling.selected,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.reference,
                        defaultText: formData.shippingSameAsBilling.selected ? formData.shippingReference : formData.shippingReference,
                        value: formData.shippingSameAsBilling.selected ? formData.reference : formData.shippingReference,
                        setValue: formData.setShippingReference,
                        disabled: formData.shippingSameAsBilling.selected,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.street + (formData.shippingStreet.required ? "*" : ""),
                        defaultText: formData.shippingSameAsBilling.selected ? formData.street : formData.shippingStreet,
                        value: formData.shippingSameAsBilling.selected ? formData.street : formData.shippingStreet,
                        setValue: formData.setShippingStreet,
                        disabled: formData.shippingSameAsBilling.selected,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.box,
                        defaultText: formData.shippingSameAsBilling.selected ? formData.box : formData.shippingBox,
                        value: formData.shippingSameAsBilling.selected ? formData.box : formData.shippingBox,
                        setValue: formData.setShippingBox,
                        disabled: formData.shippingSameAsBilling.selected,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.zipcode + (formData.shippingZipcode.required ? "*" : ""),
                        defaultText: formData.shippingSameAsBilling.selected ? formData.zipcode : formData.shippingZipcode,
                        value: formData.shippingSameAsBilling.selected ? formData.zipcode : formData.shippingZipcode,
                        setValue: formData.setShippingZipcode,
                        disabled: formData.shippingSameAsBilling.selected,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.city + (formData.shippingCity.required ? "*" : ""),
                        defaultText: formData.shippingSameAsBilling.selected ? formData.city : formData.shippingCity,
                        value: formData.shippingSameAsBilling.selected ? formData.city : formData.shippingCity,
                        setValue: formData.setShippingCity,
                        disabled: formData.shippingSameAsBilling.selected,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXzQg.DropdownlistWithLabel), {
                        dropdownId: "shippingCountrySelectOptions",
                        text: formLang.country + "*",
                        options: formData.countrySelectionOptions,
                        value: formData.shippingSameAsBilling.selected ? formData.countrySelection : formData.shippingCountrySelection,
                        setValue: formData.setShippingCountrySelection,
                        disabled: formData.shippingSameAsBilling.selected
                    })
                ]
            })
        ]
    });
};
var $e75627878acd714f$export$2e2bcd8739ae039 = $e75627878acd714f$var$CreateAccountPrivate;

});

parcelRegister("iRAPu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbb9becef6e466a6$export$2e2bcd8739ae039; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $2sdqj = parcelRequire("2sdqj");

var $kj4aw = parcelRequire("kj4aw");
const $dbb9becef6e466a6$var$CreateAccountGuest = (props)=>{
    const formLang = props.bookingFlowContext.localization.createAccount;
    const formData = props.formData;
    const handleKeyDown = props.handleKeyDown;
    return /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                children: formLang.subheadings.guest
            }),
            /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.firstName,
                        defaultText: formData.firstName,
                        value: formData.firstName,
                        setValue: formData.setFirstName,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "text",
                        text: formLang.lastName,
                        defaultText: formData.lastName,
                        value: formData.lastName,
                        setValue: formData.setLastName,
                        keyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        inputType: "email",
                        text: formLang.email,
                        defaultText: formData.email,
                        value: formData.email,
                        setValue: formData.setEmail,
                        keyDown: handleKeyDown
                    })
                ]
            })
        ]
    });
};
var $dbb9becef6e466a6$export$2e2bcd8739ae039 = $dbb9becef6e466a6$var$CreateAccountGuest;

});


parcelRegister("kLhVA", function(module, exports) {

$parcel$export(module.exports, "setSearchHistory", function () { return $f1d61a80ed47ee9b$export$a126c81aa6589a88; });
$parcel$export(module.exports, "paramsToObject", function () { return $f1d61a80ed47ee9b$export$17d9a81ce3c86a85; });

var $8OcmI = parcelRequire("8OcmI");
const $f1d61a80ed47ee9b$export$a126c81aa6589a88 = (newParams, replace)=>{
    const params = new (0, $8OcmI.default)(window.location.search);
    if (newParams && newParams.name) params.set("name", newParams.name);
    if (newParams && newParams.address) params.set("address", newParams.address);
    if (newParams && newParams.position && newParams.position.lat) params.set("lat", newParams.position.lat);
    if (newParams && newParams.position && newParams.position.lng) params.set("lng", newParams.position.lng);
    if (newParams && newParams.date) params.set("date", newParams.date);
    if (newParams && newParams.items) params.set("items", newParams.items);
    const newUrl = window.location.origin + window.location.pathname + "?" + params.toString();
    if (replace) history.replaceState(newParams, document.title, newUrl);
    else history.pushState(newParams, document.title, newUrl);
};
const $f1d61a80ed47ee9b$export$17d9a81ce3c86a85 = (paramsObject)=>{
    const result = {};
    for (const [key, value] of paramsObject)result[key] = value;
    return result;
};
const $f1d61a80ed47ee9b$export$ee5c73f71f007ab9 = (stepIndex)=>{
    const state = {
        activeStep: stepIndex
    };
    const title = document.title;
    const url = window.location.origin + window.location.pathname + window.location.search;
    history.pushState(state, title, url);
    console.log("pushState", state);
};

});

parcelRegister("6g396", function(module, exports) {

$parcel$export(module.exports, "Lightbox", function () { return $48e6ad690594ccb4$export$7d2670a66155874b; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $5Wno7 = parcelRequire("5Wno7");
const $48e6ad690594ccb4$export$7d2670a66155874b = (props)=>{
    const backgroundRef = (0, $ca3MY.useRef)(null);
    const [requestAnimation, setRequestAnimation] = (0, $ca3MY.useState)(false);
    const [maxHeight, setMaxHeight] = (0, $ca3MY.useState)({
        maxHeight: "100%"
    });
    const closeHandler = (e)=>{
        if (!e || e.target === backgroundRef.current) {
            window.removeEventListener("resize", initMaxHeight);
            props.onCloseEvent();
        }
    };
    const initMaxHeight = (e)=>{
        if (!requestAnimation) window.requestAnimationFrame(()=>{
            setMaxHeight({
                maxHeight: `${window.innerHeight}px`
            });
            setRequestAnimation(false);
        });
        setRequestAnimation(false);
    };
    (0, $ca3MY.useEffect)(()=>{
        window.addEventListener("resize", initMaxHeight);
        return ()=>window.removeEventListener("resize", initMaxHeight);
    }, []);
    (0, $ca3MY.useEffect)(()=>{
        //Focus trap
        const overlayFocusTrap = (0, $5Wno7.createFocusTrap)(backgroundRef.current);
        overlayFocusTrap.activate();
        return ()=>{
            overlayFocusTrap.deactivate();
        };
    }, []);
    return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
        className: "single-step__lightbox",
        ref: backgroundRef,
        onClick: (e)=>closeHandler(e),
        children: /*#__PURE__*/ (0, $54dlf.jsxs)("section", {
            className: "single-step__lightbox__inner",
            style: maxHeight,
            children: [
                /*#__PURE__*/ (0, $54dlf.jsxs)("header", {
                    children: [
                        props.heading ?? /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                            onClick: ()=>closeHandler(null),
                            className: "single-step__lightbox__close",
                            children: props.close
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $54dlf.jsx)("main", {
                    children: props.children
                })
            ]
        })
    });
};

});
parcelRegister("5Wno7", function(module, exports) {

$parcel$export(module.exports, "createFocusTrap", function () { return $453482ec53519826$export$360440dfcba94c00; });
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ 
var $iHlyg = parcelRequire("iHlyg");
function $453482ec53519826$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $453482ec53519826$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $453482ec53519826$var$ownKeys(Object(t), !0).forEach(function(r) {
            $453482ec53519826$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $453482ec53519826$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $453482ec53519826$var$_defineProperty(obj, key, value) {
    key = $453482ec53519826$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $453482ec53519826$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $453482ec53519826$var$_toPropertyKey(arg) {
    var key = $453482ec53519826$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var $453482ec53519826$var$activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
        if (trapStack.length > 0) {
            var activeTrap = trapStack[trapStack.length - 1];
            if (activeTrap !== trap) activeTrap.pause();
        }
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            // move this existing trap to the front of the queue
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        if (trapStack.length > 0) trapStack[trapStack.length - 1].unpause();
    }
};
var $453482ec53519826$var$isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var $453482ec53519826$var$isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Escape" || (e === null || e === void 0 ? void 0 : e.key) === "Esc" || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var $453482ec53519826$var$isTabEvent = function isTabEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Tab" || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
// checks for TAB by default
var $453482ec53519826$var$isKeyForward = function isKeyForward(e) {
    return $453482ec53519826$var$isTabEvent(e) && !e.shiftKey;
};
// checks for SHIFT+TAB by default
var $453482ec53519826$var$isKeyBackward = function isKeyBackward(e) {
    return $453482ec53519826$var$isTabEvent(e) && e.shiftKey;
};
var $453482ec53519826$var$delay = function delay(fn) {
    return setTimeout(fn, 0);
};
// Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var $453482ec53519826$var$findIndex = function findIndex(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false; // break
        }
        return true; // next
    });
    return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var $453482ec53519826$var$valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var $453482ec53519826$var$getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var $453482ec53519826$var$internalTrapStack = [];
var $453482ec53519826$export$360440dfcba94c00 = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || $453482ec53519826$var$internalTrapStack;
    var config = $453482ec53519826$var$_objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isKeyForward: $453482ec53519826$var$isKeyForward,
        isKeyBackward: $453482ec53519826$var$isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === "function" ? event.composedPath() : undefined;
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
            // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue); // resolve to node, or null if fails
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption("initialFocus");
        // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined || !(0, $iHlyg.isFocusable)(node, config.tabbableOptions)) {
            // option not specified nor focusable: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, $iHlyg.tabbable)(container, config.tabbableOptions);
            // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
            //  are focusable but not tabbable
            var focusableNodes = (0, $iHlyg.focusable)(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return (0, $iHlyg.isTabbable)(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return (0, $iHlyg.isTabbable)(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return (0, $iHlyg.getTabIndex)(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound: posTabIndexesFound,
                /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode: firstTabbableNode,
                /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode: lastTabbableNode,
                // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode: firstDomTabbableNode,
                /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode: lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
                        //  since `node` should at least have been focusable, we assume that's the case and mimic
                        //  what browsers do, which is set focus to the next node in __document position order__,
                        //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
                        //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
                        //  basic DOM order
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return (0, $iHlyg.isTabbable)(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return (0, $iHlyg.isTabbable)(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus") // returning false not supported for this option
        ) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        // NOTE: Positive tabindexes are only properly supported in single-container traps because
        //  doing it across multiple containers where tabindexes could be all over the place
        //  would require Tabbable to support multiple containers, would require additional
        //  specialized Shadow DOM support, and would require Tabbable's multi-container support
        //  to look at those containers in document position order rather than user-provided
        //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
        //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement} The element that currently has the focus
   **/ var getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === getActiveElement(document)) return;
        if (!node || !node.focus) {
            tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        // NOTE: focus() API does not trigger focusIn event so set MRU node manually
        state.mostRecentlyFocusedNode = node;
        if ($453482ec53519826$var$isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    };
    /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */ var findNextNavNode = function findNextNavNode(_ref2) {
        var target = _ref2.target, event = _ref2.event, _ref2$isBackward = _ref2.isBackward, isBackward = _ref2$isBackward === void 0 ? false : _ref2$isBackward;
        target = target || $453482ec53519826$var$getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back into...
                if (isBackward) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = $453482ec53519826$var$findIndex(state.tabbableGroups, function(_ref3) {
                    var firstTabbableNode = _ref3.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, $iHlyg.isFocusable)(target, config.tabbableOptions) && !(0, $iHlyg.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = (0, $iHlyg.getTabIndex)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!$453482ec53519826$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = $453482ec53519826$var$findIndex(state.tabbableGroups, function(_ref4) {
                    var lastTabbableNode = _ref4.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, $iHlyg.isFocusable)(target, config.tabbableOptions) && !(0, $iHlyg.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = (0, $iHlyg.getTabIndex)(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!$453482ec53519826$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else // no groups available
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption("fallbackFocus");
        return destinationNode;
    };
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = $453482ec53519826$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) // allow the click since it ocurred inside the trap
        return;
        if ($453482ec53519826$var$valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if ($453482ec53519826$var$valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
        // otherwise, prevent the click
        e.preventDefault();
    };
    // In case focus escapes the trap for some strange reason, pull it back in.
    // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
    //  scrolling if the node that got focused was out of view; there's nothing we can do to
    //  prevent that from happening by the time we discover that focus escaped
    var checkFocusIn = function checkFocusIn(event) {
        var target = $453482ec53519826$var$getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            event.stopImmediatePropagation();
            // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
            //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
            //  toward a node with a positive tab index
            var nextNode; // next node to focus, if we find one
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if ((0, $iHlyg.getTabIndex)(state.mostRecentlyFocusedNode) > 0) {
                    // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    // there MAY not be any tabbable nodes in the container if there are at least 2 containers
                    //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
                    //  with at least one tabbable node in order to function, so this could be the other container
                    //  with nothing tabbable in it)
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        // else, don't find in container order without considering direction too
                        }
                    }
                // else, no tabbable nodes in that container (which means we must have at least one other
                //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
                //  an error the last time updateTabbableNodes() was run): find next node among all known
                //  containers
                } else // check to see if there's at least one tabbable node with a positive tab index inside
                //  the trap because focus seems to escape when navigating backward from a tabbable node
                //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
                //  the greatest positive tab index like it should)
                if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return (0, $iHlyg.getTabIndex)(n) > 0;
                    });
                })) // no containers with tabbable nodes with positive tab indexes which means the focus
                //  escaped for some other reason and we should just execute the fallback to the
                //  MRU node or initial focus node, if any
                navAcrossContainers = false;
            } else // no MRU node means we're likely in some initial condition when the trap has just
            //  been activated and initial focus hasn't been given yet, in which case we should
            //  fall through to trying to focus the initial focus node, which is what should
            //  happen below at this point in the logic
            navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) tryFocus(nextNode);
            else tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = undefined; // clear
    };
    // Hijack key nav events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkKeyNav = function checkKeyNav(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if ($453482ec53519826$var$isTabEvent(event)) // since tab natively moves focus, we wouldn't have a destination node unless we
            //  were on the edge of a container and had to move to the next/previous edge, in
            //  which case we want to prevent default to keep the browser from moving focus
            //  to where it normally would
            event.preventDefault();
            tryFocus(destinationNode);
        }
    // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkKey = function checkKey(event) {
        if ($453482ec53519826$var$isEscapeEvent(event) && $453482ec53519826$var$valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
            return;
        }
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    var checkClick = function checkClick(e) {
        var target = $453482ec53519826$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if ($453482ec53519826$var$valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if ($453482ec53519826$var$valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        $453482ec53519826$var$activeFocusTraps.activateTrap(trapStack, trap);
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? $453482ec53519826$var$delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    };
    //
    // MUTATION OBSERVER
    //
    var checkDomRemoval = function checkDomRemoval(mutations) {
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === state.mostRecentlyFocusedNode;
            });
        });
        // If the currently focused is removed then browsers will move focus to the
        // <body> element. If this happens, try to move focus back into the trap.
        if (isFocusedNodeRemoved) tryFocus(getInitialFocusNode());
    };
    // Use MutationObserver - if supported - to detect if focused node is removed
    // from the DOM.
    var mutationObserver = typeof window !== "undefined" && "MutationObserver" in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            onActivate === null || onActivate === void 0 || onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                updateObservedNodes();
                onPostActivate === null || onPostActivate === void 0 || onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = $453482ec53519826$var$_objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            $453482ec53519826$var$activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            onDeactivate === null || onDeactivate === void 0 || onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                $453482ec53519826$var$delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (state.paused || !state.active) return this;
            var onPause = getOption(pauseOptions, "onPause");
            var onPostPause = getOption(pauseOptions, "onPostPause");
            state.paused = true;
            onPause === null || onPause === void 0 || onPause();
            removeListeners();
            updateObservedNodes();
            onPostPause === null || onPostPause === void 0 || onPostPause();
            return this;
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.paused || !state.active) return this;
            var onUnpause = getOption(unpauseOptions, "onUnpause");
            var onPostUnpause = getOption(unpauseOptions, "onPostUnpause");
            state.paused = false;
            onUnpause === null || onUnpause === void 0 || onUnpause();
            updateTabbableNodes();
            addListeners();
            updateObservedNodes();
            onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            updateObservedNodes();
            return this;
        }
    };
    // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};

});
parcelRegister("iHlyg", function(module, exports) {

$parcel$export(module.exports, "getTabIndex", function () { return $d9ccf5d521690da3$export$a4672efddb4181b8; });
$parcel$export(module.exports, "tabbable", function () { return $d9ccf5d521690da3$export$17100aea90429aa7; });
$parcel$export(module.exports, "focusable", function () { return $d9ccf5d521690da3$export$ecc6d1fcdff4f700; });
$parcel$export(module.exports, "isTabbable", function () { return $d9ccf5d521690da3$export$bebd5a1431fec25d; });
$parcel$export(module.exports, "isFocusable", function () { return $d9ccf5d521690da3$export$4c063cf1350e6fed; });
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $d9ccf5d521690da3$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $d9ccf5d521690da3$var$candidateSelector = /* #__PURE__ */ $d9ccf5d521690da3$var$candidateSelectors.join(",");
var $d9ccf5d521690da3$var$NoElement = typeof Element === "undefined";
var $d9ccf5d521690da3$var$matches = $d9ccf5d521690da3$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $d9ccf5d521690da3$var$getRootNode = !$d9ccf5d521690da3$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $d9ccf5d521690da3$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $d9ccf5d521690da3$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $d9ccf5d521690da3$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($d9ccf5d521690da3$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($d9ccf5d521690da3$var$candidateSelector));
    if (includeContainer && $d9ccf5d521690da3$var$matches.call(el, $d9ccf5d521690da3$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $d9ccf5d521690da3$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($d9ccf5d521690da3$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $d9ccf5d521690da3$var$matches.call(element, $d9ccf5d521690da3$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$d9ccf5d521690da3$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $d9ccf5d521690da3$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $d9ccf5d521690da3$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $d9ccf5d521690da3$var$isContentEditable(node)) && !$d9ccf5d521690da3$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $d9ccf5d521690da3$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $d9ccf5d521690da3$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$d9ccf5d521690da3$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $d9ccf5d521690da3$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $d9ccf5d521690da3$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $d9ccf5d521690da3$var$isHiddenInput = function isHiddenInput(node) {
    return $d9ccf5d521690da3$var$isInput(node) && node.type === "hidden";
};
var $d9ccf5d521690da3$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $d9ccf5d521690da3$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $d9ccf5d521690da3$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $d9ccf5d521690da3$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $d9ccf5d521690da3$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $d9ccf5d521690da3$var$isRadio = function isRadio(node) {
    return $d9ccf5d521690da3$var$isInput(node) && node.type === "radio";
};
var $d9ccf5d521690da3$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $d9ccf5d521690da3$var$isRadio(node) && !$d9ccf5d521690da3$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $d9ccf5d521690da3$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $d9ccf5d521690da3$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $d9ccf5d521690da3$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $d9ccf5d521690da3$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $d9ccf5d521690da3$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $d9ccf5d521690da3$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($d9ccf5d521690da3$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $d9ccf5d521690da3$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $d9ccf5d521690da3$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($d9ccf5d521690da3$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $d9ccf5d521690da3$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $d9ccf5d521690da3$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $d9ccf5d521690da3$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $d9ccf5d521690da3$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $d9ccf5d521690da3$var$isInert(node) || $d9ccf5d521690da3$var$isHiddenInput(node) || $d9ccf5d521690da3$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $d9ccf5d521690da3$var$isDetailsWithSummary(node) || $d9ccf5d521690da3$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $d9ccf5d521690da3$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($d9ccf5d521690da3$var$isNonTabbableRadio(node) || $d9ccf5d521690da3$export$a4672efddb4181b8(node) < 0 || !$d9ccf5d521690da3$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $d9ccf5d521690da3$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $d9ccf5d521690da3$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $d9ccf5d521690da3$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($d9ccf5d521690da3$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $d9ccf5d521690da3$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $d9ccf5d521690da3$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $d9ccf5d521690da3$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $d9ccf5d521690da3$var$isValidShadowRootTabbable
    });
    else candidates = $d9ccf5d521690da3$var$getCandidates(container, options.includeContainer, $d9ccf5d521690da3$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $d9ccf5d521690da3$var$sortByOrder(candidates);
};
var $d9ccf5d521690da3$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $d9ccf5d521690da3$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $d9ccf5d521690da3$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $d9ccf5d521690da3$var$getCandidates(container, options.includeContainer, $d9ccf5d521690da3$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $d9ccf5d521690da3$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($d9ccf5d521690da3$var$matches.call(node, $d9ccf5d521690da3$var$candidateSelector) === false) return false;
    return $d9ccf5d521690da3$var$isNodeMatchingSelectorTabbable(options, node);
};
var $d9ccf5d521690da3$var$focusableCandidateSelector = /* #__PURE__ */ $d9ccf5d521690da3$var$candidateSelectors.concat("iframe").join(",");
var $d9ccf5d521690da3$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($d9ccf5d521690da3$var$matches.call(node, $d9ccf5d521690da3$var$focusableCandidateSelector) === false) return false;
    return $d9ccf5d521690da3$var$isNodeMatchingSelectorFocusable(options, node);
};

});



parcelRegister("lnu9l", function(module, exports) {

$parcel$export(module.exports, "Dialog", function () { return $f9032216501017d7$export$3ddf2d174ce01153; });

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");
const $f9032216501017d7$export$3ddf2d174ce01153 = (props)=>{
    const handleConfirm = ()=>props.onDialogConfirm();
    const handleCancel = ()=>props.onDialogCancel();
    (0, $ca3MY.useEffect)(()=>{
        document.body.style.overflow = "hidden";
        return ()=>document.body.style.overflow = null;
    });
    return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
        className: "myaimopark-confirm",
        "data-selection-no": "true",
        children: /*#__PURE__*/ (0, $54dlf.jsxs)("section", {
            className: "myaimopark-confirm__box",
            role: "alert",
            children: [
                props.shouldIncludeCloseButton && /*#__PURE__*/ (0, $54dlf.jsx)("header", {
                    children: /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                        "data-selection-no": "true",
                        children: "Close"
                    })
                }),
                /*#__PURE__*/ (0, $54dlf.jsxs)("main", {
                    children: [
                        /*#__PURE__*/ (0, $54dlf.jsx)("h1", {
                            children: props.langHeading ?? props.lang.heading
                        }),
                        props.children,
                        props.onDialogCancel && /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                            onClick: ()=>handleCancel(),
                            "data-selection-no": "true",
                            className: "myaimopark-confirm__box__cancel",
                            children: props.langCancel ?? props.lang.cancel
                        }),
                        props.onDialogConfirm && /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                            onClick: ()=>handleConfirm(),
                            "data-selection-yes": "true",
                            className: "myaimopark-confirm__box__confirm",
                            children: props.langConfirm ?? props.lang.confirm
                        })
                    ]
                })
            ]
        })
    });
};

});

// PRE JS
parcelRequire("h1pc7");
parcelRequire("jclte");
parcelRequire("cWUZS");

var $54dlf = parcelRequire("54dlf");

var $jQtCH = parcelRequire("jQtCH");

var $ca3MY = parcelRequire("ca3MY");

var $bUNms = parcelRequire("bUNms");

var $8OcmI = parcelRequire("8OcmI");

var $iSxgd = parcelRequire("iSxgd");
const $716d5d85e060137b$export$157b27307c5a0381 = (element)=>{
    const rect = element.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};



var $8oRQh = parcelRequire("8oRQh");

var $axmXn = parcelRequire("axmXn");

var $gXJP5 = parcelRequire("gXJP5");

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $8oRQh = parcelRequire("8oRQh");

var $leuhm = parcelRequire("leuhm");

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $cJ5lq = parcelRequire("cJ5lq");

var $g6ndF = parcelRequire("g6ndF");

var $8oRQh = parcelRequire("8oRQh");

var $8BTjt = parcelRequire("8BTjt");

var $ca3MY = parcelRequire("ca3MY");

var $axmXn = parcelRequire("axmXn");
parcelRequire("iFvPA");

var $g6ndF = parcelRequire("g6ndF");
const $effc430ba36988ec$export$e9082e1603ae8290 = (isAccessDevice, product, startDate, bookingFlowContext)=>{
    const costLang = bookingFlowContext.localization.global.cost;
    const [productAvailability, useProductAvailability] = (0, $ca3MY.useState)(null);
    const [productAvailabilityCount, useProductAvailabilityCount] = (0, $ca3MY.useState)(null);
    const [productAvailableFrom, useProductAvailableFrom] = (0, $ca3MY.useState)(null);
    const [paymentOptions, setPaymentOptions] = (0, $ca3MY.useState)([]);
    const [pending, setPending] = (0, $ca3MY.useState)(false);
    (0, $ca3MY.useEffect)(()=>{
        let isSubscribed = true;
        const getProductAvailability = async ()=>{
            if (product.Id === "00000000-0000-0000-0000-000000000000" || !isAccessDevice && startDate === null) return;
            setPending(true);
            const productPaymentOptions = [];
            if (product.MonthlyPrice && parseFloat(product.MonthlyPrice) > 0) productPaymentOptions.push({
                text: costLang.monthly,
                value: "MONTHLY",
                currency: product.Currency,
                optionPrice: product.MonthlyPrice,
                id: "5b6cc789-365f-4483-848a-ab429c30ddaf"
            });
            if (product.QuarterlyPrice && parseFloat(product.QuarterlyPrice) > 0) productPaymentOptions.push({
                text: costLang.quarterly,
                value: "QUARTERLY",
                currency: product.Currency,
                optionPrice: product.QuarterlyPrice,
                id: "667cd478-0b04-4df5-bd9c-c89cac22d2dd"
            });
            if (product.HalfYearlyPrice && parseFloat(product.HalfYearlyPrice) > 0) productPaymentOptions.push({
                text: costLang.half_yearly,
                value: "HALF_YEARLY",
                currency: product.Currency,
                optionPrice: product.HalfYearlyPrice,
                id: "557201b3-241b-4663-8e33-4f44f1ea9fbd"
            });
            if (product.AnnualPrice && parseFloat(product.AnnualPrice) > 0) productPaymentOptions.push({
                text: costLang.annually,
                value: "ANNUALLY",
                currency: product.Currency,
                optionPrice: product.AnnualPrice,
                id: "11261993-13f1-409d-ac9f-7d6a6e9039e3"
            });
            if (product.BillingFrequencyOptions) {
                const filteredProductPaymentOptions = productPaymentOptions.filter((paymentOption)=>product.BillingFrequencyOptions.includes(paymentOption.value));
                setPaymentOptions(filteredProductPaymentOptions);
            } else setPaymentOptions(productPaymentOptions);
            let isReservedProduct = product.Type === "RESERVED";
            const productAvailability = await (0, $axmXn.products).getAvailability({
                bookingController: bookingFlowContext.episerver.bookingController,
                pmcId: product.Id,
                startDate: startDate
            }, bookingFlowContext.useMockedData);
            let availableSpotsCount = productAvailability.status === 200 ? productAvailability.body.Availability ?? 0 : 0;
            //if (!isAccessDevice) {
            //  const startSellingDate = parseDate(product.StartSellingDate, 'sv', 'L')
            //  const compareStartDate = parseDate(startDate, 'sv', 'L');
            //  if (moment(compareStartDate).isBefore(startSellingDate, 'day')) {
            //    availableSpotsCount = 0;
            //  }
            //}
            let availableFrom = productAvailability.body?.AvailableFrom ? {
                until: new Date((0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(productAvailability.body?.AvailableFrom).subtract(12, "hours")).toISOString(),
                from: new Date((0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(productAvailability.body?.AvailableFrom).add(12, "hours")).toISOString()
            } : null;
            const productMaxSpotOnline = parseFloat(product.MaxSpotOnline ?? 10000);
            if (productMaxSpotOnline < availableSpotsCount) availableSpotsCount = productMaxSpotOnline;
            if (isReservedProduct && isSubscribed || isAccessDevice && isSubscribed) {
                const availableSpots = await (0, $axmXn.products).getParkingSpaceAvailability({
                    bookingController: bookingFlowContext.episerver.bookingController,
                    pmcId: product.Id,
                    startDate: startDate,
                    onlyAvailableSpaces: false
                }, bookingFlowContext.useMockedData);
                if (availableSpots.status === 200 && isSubscribed && availableSpotsCount > 0 && !availableFrom && availableSpots.body.some((spot)=>spot.ParkingSpaceStatus === "AVAILABLE")) {
                    if (isAccessDevice && availableSpots.body) {
                        availableSpots.body = availableSpots.body.filter((spot)=>spot.ParkingSpaceStatus === "NOT_AVAILABLE");
                        availableSpots.body.unshift({
                            ParkingSpace: {
                                Name: "N/A"
                            }
                        });
                    }
                    useProductAvailability(availableSpots.body.filter((spot)=>spot.ParkingSpaceStatus === "AVAILABLE" || spot.LastBookingEnds) ?? []), useProductAvailabilityCount(availableSpotsCount);
                } else {
                    useProductAvailability([]), useProductAvailabilityCount(0);
                    if (availableSpots.body && availableSpots.body.some((spot)=>spot.LastBookingEnds)) {
                        let lastBookingEnds = productAvailability.body?.AvailableFrom || availableSpots.body.find((spot)=>spot.LastBookingEnds)?.LastBookingEnds;
                        availableSpots.body.forEach((spot)=>{
                            if (spot.LastBookingEnds && (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(spot.LastBookingEnds).isBefore(lastBookingEnds)) lastBookingEnds = spot.LastBookingEnds;
                        });
                        availableFrom = {
                            until: new Date((0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(lastBookingEnds).subtract(12, "hours")).toISOString(),
                            from: new Date((0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(lastBookingEnds).add(12, "hours")).toISOString()
                        };
                    }
                    useProductAvailableFrom(availableFrom);
                }
                setPending(false);
            } else if (!isReservedProduct && availableSpotsCount > 0 && isSubscribed && !isAccessDevice) {
                let i = 0;
                const arr = [];
                while(i < availableSpotsCount)arr.push({
                    ParkingSpace: {
                        Name: "-",
                        Uid: i
                    }
                }), i++;
                useProductAvailability(arr), useProductAvailabilityCount(arr.length);
                setPending(false);
            } else if (isSubscribed) {
                useProductAvailability([]), useProductAvailabilityCount(0), useProductAvailableFrom(availableFrom);
                setPending(false);
            }
        };
        getProductAvailability();
        return ()=>isSubscribed = false;
    }, [
        product,
        startDate
    ]);
    return [
        productAvailability,
        productAvailabilityCount,
        paymentOptions,
        pending,
        productAvailableFrom
    ];
};



var $se1IJ = parcelRequire("se1IJ");

var $ca3MY = parcelRequire("ca3MY");

var $axmXn = parcelRequire("axmXn");
const $d0f2efe7934d0911$export$f34663f909e04f6b = (productAccessDevices, accessDeviceAvailability)=>{
    if (!productAccessDevices.some((ad)=>ad.Required || ad.Bundled)) return;
    let requiredOrBundledADs = productAccessDevices.filter((ad)=>ad.Required || ad.Bundled).map((ad)=>ad.ProductDetails?.ProductId);
    return Math.min(...accessDeviceAvailability.map((ada)=>requiredOrBundledADs.length > 0 && requiredOrBundledADs.includes(ada.ProductId) ? +ada.Availability : null).filter((ada)=>ada !== null));
};
const $d0f2efe7934d0911$export$408040c9a8487ff8 = (isAccessDevice, hasAccessDevice, product, bookingFlowContext)=>{
    const [accessDevices, setAccessDevices] = (0, $ca3MY.useState)(null);
    const [pending, setPending] = (0, $ca3MY.useState)(false);
    const [mandatoryAccessDeviceNotAvailable, setMandatoryAccessDeviceNotAvailable] = (0, $ca3MY.useState)(false);
    const [mandatoryAccessDeviceAvailability, setMandatoryAccessDeviceAvailability] = (0, $ca3MY.useState)(null);
    const isReservedProduct = product.Type === "RESERVED";
    const optional = accessDevices && accessDevices.length && accessDevices.some((device)=>!device.Required && !device.Bundled);
    (0, $ca3MY.useEffect)(()=>{
        let isSubscribed = true;
        const getAccessDevices = async ()=>{
            let accessDevicesIds = [];
            if (hasAccessDevice) accessDevicesIds = product.AccessDevices.map((device)=>{
                return {
                    ProductId: device.ProductDetails?.ProductId
                };
            });
            if (isAccessDevice) accessDevicesIds = [
                {
                    ProductId: product.ProductId
                }
            ];
            const params = {
                accessDevices: accessDevicesIds
            };
            setPending(true);
            if (isSubscribed) {
                if (!hasAccessDevice && !isAccessDevice) //setMandatoryAccessDeviceNotAvailable(true);
                return;
                const response = await (0, $axmXn.products).getAccessDeviceAvailability(params);
                if (response.status === 200) {
                    if (isAccessDevice) {
                        let availability = +response.body?.AccessDevices[0].Availability;
                        product.Availability = availability;
                        setMandatoryAccessDeviceAvailability(availability);
                        setMandatoryAccessDeviceNotAvailable(availability && availability < 1);
                    } else {
                        let leastRequired = $d0f2efe7934d0911$export$f34663f909e04f6b(product.AccessDevices, response.body?.AccessDevices);
                        product.AccessDevices.forEach((device, n)=>{
                            product.AccessDevices[n].Availability = +response.body?.AccessDevices.find((d)=>d.ProductId === device.ProductDetails?.ProductId).Availability;
                        });
                        setMandatoryAccessDeviceAvailability(leastRequired);
                        setMandatoryAccessDeviceNotAvailable(leastRequired && leastRequired < 1);
                    }
                    setAccessDevices(hasAccessDevice ? product.AccessDevices : isAccessDevice ? [
                        product
                    ] : null);
                    setPending(false);
                } else {
                    //Set availability to 0 if error
                    setMandatoryAccessDeviceAvailability(null);
                    setMandatoryAccessDeviceNotAvailable(true);
                    //**********
                    setAccessDevices(hasAccessDevice ? product.AccessDevices : isAccessDevice ? [
                        product
                    ] : null);
                    setPending(false);
                    console.log("ERROR");
                }
            }
            return;
        };
        if (!isReservedProduct && (isAccessDevice || hasAccessDevice)) getAccessDevices();
        return ()=>isSubscribed = false;
    }, [
        product
    ]);
    return [
        accessDevices,
        pending,
        optional,
        mandatoryAccessDeviceNotAvailable,
        mandatoryAccessDeviceAvailability
    ];
};



var $iFvPA = parcelRequire("iFvPA");

var $54dlf = parcelRequire("54dlf");
parcelRequire("ca3MY");
const $72618502e1458656$export$a2ec690cee38f777 = (props)=>{
    const wrappingClass = "single-step__section single-step__section--info";
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: wrappingClass,
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)("label", {
                className: "single-step__section__label",
                children: props.heading
            }),
            props.children,
            /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                children: props.text
            })
        ]
    });
};



var $gXJP5 = parcelRequire("gXJP5");

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $g6ndF = parcelRequire("g6ndF");

var $iFvPA = parcelRequire("iFvPA");

var $ca3MY = parcelRequire("ca3MY");

var $axmXn = parcelRequire("axmXn");
const $136c7d65950e631f$export$bd56c6fbf056b36d = (bookingFlowContext, productSelection, lang, date)=>{
    //{ item: { Text: lang.chooseproduct, Id: emptyGuid, ZoneAndProduct: emptyGuid, initial: true }, required: true, elementType: 'select' }
    const [productOptions, setProductOptions] = (0, $ca3MY.useState)(null);
    const [hasPrivatePmcs, setHasPrivatePmcs] = (0, $ca3MY.useState)(false);
    const [pending, setPending] = (0, $ca3MY.useState)(false);
    (0, $ca3MY.useEffect)(()=>{
        let isSubscribed = true;
        const getFacilityProducts = async ()=>{
            setPending(true);
            const returnedProducts = await (0, $axmXn.products).getProducts({
                bookingController: bookingFlowContext.episerver.bookingController,
                fId: bookingFlowContext.facility.id,
                productType: bookingFlowContext.episerver.productType,
                lang: lang,
                availabilityFrom: date.date
            }, bookingFlowContext.useMockedData);
            // setProductOptions((returnedProducts.status === 200 && isSubscribed) ? [productSelection.item, ...returnedProducts.body] : []);
            if (isSubscribed) {
                if (returnedProducts.status === 200) {
                    setProductOptions(returnedProducts.body.Places);
                    setHasPrivatePmcs(returnedProducts.body.HasPrivatePmcs ?? false);
                } else setProductOptions([]);
                setPending(false);
            }
        };
        getFacilityProducts();
        return ()=>isSubscribed = false;
    }, [
        date
    ]);
    return [
        productOptions,
        pending,
        hasPrivatePmcs
    ];
};



var $2sdqj = parcelRequire("2sdqj");

var $i4bvp = parcelRequire("i4bvp");

var $gXzQg = parcelRequire("gXzQg");

var $7HCW7 = parcelRequire("7HCW7");

var $gxSZA = parcelRequire("gxSZA");

var $4cWVp = parcelRequire("4cWVp");
const $ef5b0e978e82ebfa$export$86677682429ed406 = ({ scrollEnabled: scrollEnabled, setScrollEnabled: setScrollEnabled, bookingFlowContext: bookingFlowContext, useRadioButtonList: useRadioButtonList, formLang: formLang, pending: pending, setFromUrl: setFromUrl, date: date, setDate: setDate, productSelection: productSelection, setProductSelection: setProductSelection, dateDisabled: dateDisabled, isAfterPriceChange: isAfterPriceChange, startDate: startDate, availableFrom: availableFrom })=>{
    const urlParams = new URLSearchParams(window.location.search);
    const [products, pendingProducts, hasPrivatePmcs] = (0, $136c7d65950e631f$export$bd56c6fbf056b36d)(bookingFlowContext, productSelection, formLang.language, date);
    const emptyGuid = "00000000-0000-0000-0000-000000000000";
    const language = bookingFlowContext.localization.language;
    const country = bookingFlowContext.country;
    const selectedLocale = country === "no" ? "nb" : country === "se" ? "sv" : country;
    const selectedLanguage = language === "no" ? "nb" : language === "se" ? "sv" : language;
    const hasPromo = Array.isArray(productSelection.item?.Promotions) && productSelection.item.Promotions.length > 0;
    const flexDays = productSelection.item?.OnlineBookingFlexibleStartDate ?? null;
    const dropdownProducts = products ? products.map((zone)=>zone.Item2).flat() : null;
    const imageAltText = selectedLanguage == "sv" ? "kampanj ikon" : selectedLanguage == "fi" ? "kampanjakuvake" : selectedLanguage == "nb" ? "kampanjeikon" : "campaign icon";
    const verifiedLockedCode = urlParams.get("verifiedLockedCode") ?? urlParams.get("verifiedLockedCode");
    const verifiedPid = urlParams.get("pid") ?? urlParams.get("pId");
    const isProductUnlockedByCode = (product)=>{
        if (!verifiedLockedCode || !verifiedPid) return false;
        return product.ZoneAndProduct === verifiedPid;
    };
    const [lockedPopupVisible, setLockedPopupVisible] = (0, $ca3MY.useState)(false);
    const [selectedLockedProduct, setSelectedLockedProduct] = (0, $ca3MY.useState)(null);
    const lockedPmcModalTitle = selectedLanguage == "sv" ? "L\xe5st prenumeration!" : selectedLanguage == "fi" ? "Lukittu tilaus!" : selectedLanguage == "nb" ? "L\xe5st abonnement!" : "Locked subscription!";
    const lockedPmcModalDescription = selectedLanguage == "sv" ? "Ange din kod f\xf6r att l\xe5sa upp denna prenumeration." : selectedLanguage == "fi" ? "Sy\xf6t\xe4 koodisi avataksesi t\xe4m\xe4n tilauksen." : selectedLanguage == "nb" ? "Skriv inn koden din for \xe5 l\xe5se opp dette abonnementet." : "Enter your code to unlock this subscription.";
    const handleLockedProductSelected = (selectedProduct)=>{
        if (selectedProduct.Visibility === "LOCKED" && verifiedLockedCode == null) {
            setSelectedLockedProduct(selectedProduct);
            setLockedPopupVisible(true);
        }
    };
    (0, $ca3MY.useEffect)(()=>{
        if (!products) return;
        if (products.length > 0) {
            const urlPid = urlParams.get("pId") ?? urlParams.get("pid");
            if ((productSelection.item.Id === emptyGuid || productSelection.item.ZoneAndProduct === emptyGuid) && urlPid) {
                const selectedProduct = products.map((item)=>item.Item2.find((i)=>i.ZoneAndProduct === urlPid)).filter((product)=>product !== undefined)[0];
                if (selectedProduct) {
                    setProductSelection({
                        ...productSelection,
                        item: selectedProduct
                    });
                    setFromUrl(true);
                    return;
                }
            }
            /*  If entering the booking flow without a selected PMC,
             *  there is no pId in the URL.
             *  A valid pId must contain: <PlaceUid>-<pmcId>.
             *  Since pmcId is not known yet, set pId as <PlaceUid>-
             */ if (!urlPid) {
                const firstProduct = products.map((g)=>g.Item2).flat().find((p)=>p.ZoneAndProduct && p.ZoneAndProduct !== emptyGuid);
                if (firstProduct?.PlaceUid) {
                    const currentUrl = new URL(window.location.href);
                    const newPid = firstProduct.PlaceUid + "-";
                    currentUrl.searchParams.set("pid", newPid);
                    window.location.href = currentUrl.toString();
                }
            }
        } else setProductSelection({
            ...productSelection,
            item: {
                ...productSelection.item,
                Text: formLang.errorMessages.noAvailableProducts,
                Id: "00000000-0000-0000-0000-000000000000"
            },
            noproducts: true
        });
        setFromUrl(false);
    }, [
        products
    ]);
    const createPromotText = (promotion)=>{
        let promoTextFirstLine;
        let promoTextSecondLine;
        if ((promotion.DiscountPercent === 100 || promotion.DiscountPercent === 50) && promotion.StartAfter) {
            const text = promotion.Duration > 1 ? formLang.promomonthfree.multipleduration : formLang.promomonthfree.singleduration;
            promoTextFirstLine = text.replace("{0}", promotion.StartAfter + promotion.Duration).replace("{1}", promotion.Duration);
            promoTextFirstLine = promoTextFirstLine + ` ${promotion.DiscountPercent === 100 ? formLang.promomonthfree.forfree : formLang.promomonthfree.halfprice}`;
            promoTextSecondLine = promotion.DiscountValidity?.ValidFrom ? `${formLang.promovalid}${promotion.DiscountValidity?.ValidTo ? "" : " " + formLang.promofrom.split(" ")[0]} ${(0, $iFvPA.parseDate)(promotion.DiscountValidity.ValidFrom, selectedLocale, "L")}${promotion.DiscountValidity?.ValidTo ? "\u2013" + (0, $iFvPA.parseDate)(promotion.DiscountValidity.ValidTo, selectedLocale, "L") : ""}` : "";
        } else {
            promoTextFirstLine = `${formLang.promodiscount} ${Math.round(promotion.DiscountPercent || promotion.DiscountValue)}${promotion.DiscountValue ? " " + productSelection.item.Currency : "\u202F%"}`;
            promoTextSecondLine = promotion.DiscountValidity?.ValidFrom ? `${formLang.promovalid}${promotion.DiscountValidity?.ValidTo ? "" : " " + formLang.promofrom.split(" ")[0]} ${(0, $iFvPA.parseDate)(promotion.DiscountValidity.ValidFrom, selectedLocale, "L")}${promotion.DiscountValidity?.ValidTo ? "\u2013" + (0, $iFvPA.parseDate)(promotion.DiscountValidity.ValidTo, selectedLocale, "L") : ""}` : promotion.Duration > 0 ? `${formLang.promovalid}${promotion.Duration ? promotion.Duration > 1 ? " " + formLang.promodurations.replace("{0}", promotion.Duration) : " " + formLang.promoduration.replace("{0}", promotion.Duration) : ""} ${formLang.promofrom} ${promotion.StartAfter + 1}` : "";
        }
        return [
            promoTextFirstLine,
            promoTextSecondLine
        ];
    };
    return /*#__PURE__*/ (0, $54dlf.jsxs)((0, $54dlf.Fragment), {
        children: [
            /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $i4bvp.DateSelectionWithLabel), {
                        flexDays: flexDays,
                        error: formLang.errorMessages.invalidDate,
                        text: formLang.startDate,
                        startDateExplanation: formLang.startDateExplanation,
                        startDateInfo: formLang.startDateInfo,
                        value: date,
                        startSellingDate: (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(productSelection.item?.StartSellingDate)).add(6, "hours").locale(selectedLocale).format("L"),
                        setValue: setDate,
                        locale: selectedLocale,
                        language: selectedLanguage,
                        placeholder: formLang.selectdate,
                        showAllDates: false,
                        disabled: !products && pendingProducts || pending || dateDisabled,
                        country: bookingFlowContext.country,
                        startDate: startDate,
                        endDate: bookingFlowContext.episerver.LatestSalesorderStartDay
                    }),
                    useRadioButtonList ? products ? products.map((zone, i)=>{
                        return /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                                    className: "single-step__section__productlist__zone-heading",
                                    children: zone.Item1.Name
                                }),
                                /*#__PURE__*/ (0, $54dlf.jsxs)((0, $7HCW7.RadioButtonListWithLabel), {
                                    scrollEnabled: scrollEnabled,
                                    setScrollEnabled: setScrollEnabled,
                                    index: i,
                                    productList: true,
                                    isAfterPriceChange: isAfterPriceChange,
                                    selectedLanguage: selectedLanguage,
                                    formLang: formLang,
                                    modifierClass: "single-step__section__productlist",
                                    selectedDate: date,
                                    text: formLang.product,
                                    available: formLang.available,
                                    locale: selectedLocale,
                                    options: zone.Item2 ?? [],
                                    value: productSelection,
                                    setValue: setProductSelection,
                                    availabilityUpdate: products && pendingProducts,
                                    loading: !products && pendingProducts,
                                    errorMessages: formLang.errorMessages,
                                    selectedDay: date.dayOfWeek,
                                    lockedCode: verifiedLockedCode,
                                    isLockedPmc: productSelection.item?.Visibility === "LOCKED" && !isProductUnlockedByCode(productSelection.item),
                                    onLockedProductSelected: handleLockedProductSelected,
                                    children: [
                                        productSelection.item.Id !== "00000000-0000-0000-0000-000000000000" && productSelection.item.Description && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                                            children: productSelection.item.Description
                                        }),
                                        productSelection.item.Id !== "00000000-0000-0000-0000-000000000000" && productSelection.item.Notes && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                                            children: productSelection.item.Notes
                                        }),
                                        productSelection.item.Id !== "00000000-0000-0000-0000-000000000000" && hasPromo && productSelection.item.Promotions.map((promotion, i)=>{
                                            const promoIsValid = hasPromo && !!(date.date && (!promotion.OrderLineValidFromValidity.ValidTo || (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(date.date)).isSameOrBefore((0, $iFvPA.parseDate)(promotion.OrderLineValidFromValidity.ValidTo))) && (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(date.date)).isSameOrAfter((0, $iFvPA.parseDate)(promotion.OrderLineValidFromValidity.ValidFrom)));
                                            const promoText = createPromotText(promotion);
                                            return (!date.date || promoIsValid) && /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                                className: "promo-with-text",
                                                children: [
                                                    /*#__PURE__*/ (0, $54dlf.jsx)("img", {
                                                        src: `/publicResources/icons/promo/${selectedLanguage}/Promotion2_${selectedLanguage}.svg`,
                                                        alt: imageAltText
                                                    }),
                                                    /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                                        className: "discount",
                                                        children: [
                                                            /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                                children: promoText[0]
                                                            }),
                                                            promoText[1] && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                                children: promoText[1]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, "" + (promotion.DiscountPercent || promotion.DiscountValue) + (promotion.Duration || 1) + i);
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    }) : /*#__PURE__*/ (0, $54dlf.jsx)((0, $7HCW7.RadioButtonListWithLabel), {
                        productList: true,
                        isAfterPriceChange: isAfterPriceChange,
                        selectedLanguage: selectedLanguage,
                        formLang: formLang,
                        modifierClass: "single-step__section__productlist",
                        selectedDate: date,
                        text: formLang.product,
                        available: formLang.available,
                        locale: selectedLocale,
                        options: [],
                        value: productSelection,
                        setValue: setProductSelection,
                        loading: !products && pendingProducts,
                        errorMessages: formLang.errorMessages,
                        selectedDay: date.dayOfWeek,
                        lockedCode: isProductUnlockedByCode(productSelection.item) ? verifiedLockedCode : null,
                        isLockedPmc: productSelection.item?.Visibility === "LOCKED" && verifiedLockedCode == null,
                        onLockedProductSelected: handleLockedProductSelected
                    }) : /*#__PURE__*/ (0, $54dlf.jsxs)((0, $gXzQg.DropdownlistWithLabel), {
                        isAfterPriceChange: isAfterPriceChange,
                        selectedDate: date,
                        text: formLang.product,
                        available: formLang.available,
                        locale: selectedLocale,
                        options: dropdownProducts ?? [],
                        optionIdentifier: "ZoneAndProduct",
                        value: productSelection,
                        setValue: setProductSelection,
                        disabled: pending || pendingProducts,
                        loading: pendingProducts,
                        errorMessages: formLang.errorMessages,
                        selectedDay: date.dayOfWeek,
                        children: [
                            productSelection.item.Id !== "00000000-0000-0000-0000-000000000000" && productSelection.item.Description && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                                children: productSelection.item.Description
                            }),
                            productSelection.item.Id !== "00000000-0000-0000-0000-000000000000" && productSelection.item.Notes && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                                children: productSelection.item.Notes
                            }),
                            productSelection.item.Id !== "00000000-0000-0000-0000-000000000000" && hasPromo && productSelection.item.Promotions.map((promotion, i)=>{
                                const promoIsValid = hasPromo && !!(date.date && (!promotion.OrderLineValidFromValidity.ValidTo || (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(date.date)).isSameOrBefore((0, $iFvPA.parseDate)(promotion.OrderLineValidFromValidity.ValidTo))) && (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(date.date)).isSameOrAfter((0, $iFvPA.parseDate)(promotion.OrderLineValidFromValidity.ValidFrom)));
                                const promoText = createPromotText(promotion);
                                return (!date.date || promoIsValid) && /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                    className: "promo-with-text",
                                    children: [
                                        /*#__PURE__*/ (0, $54dlf.jsx)("img", {
                                            src: `/publicResources/icons/promo/${selectedLanguage}/Promotion2_${selectedLanguage}.svg`,
                                            alt: imageAltText
                                        }),
                                        /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                            className: "discount",
                                            children: [
                                                /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                    children: promoText[0]
                                                }),
                                                promoText[1] && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                    children: promoText[1]
                                                })
                                            ]
                                        })
                                    ]
                                }, "" + (promotion.DiscountPercent || promotion.DiscountValue) + (promotion.Duration || 1) + i);
                            })
                        ]
                    })
                ]
            }),
            hasPrivatePmcs && !bookingFlowContext.episerver.loggedIn && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                children: /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                    children: formLang.privatepmcmore
                })
            }),
            hasPrivatePmcs && bookingFlowContext.episerver.loggedIn && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                children: /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                    children: formLang.privatepmcmoreloggedin
                })
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $gxSZA.LockedPmcPopup), {
                title: lockedPmcModalTitle,
                description: lockedPmcModalDescription,
                visible: lockedPopupVisible,
                onClose: ()=>setLockedPopupVisible(false),
                children: /*#__PURE__*/ (0, $54dlf.jsx)((0, $4cWVp.default), {
                    lang: selectedLanguage,
                    onSuccess: ()=>{
                        setLockedPopupVisible(false);
                    },
                    pmcId: selectedLockedProduct?.Id,
                    onSubmit: ()=>{
                        setLockedPopupVisible(false);
                        const currentUrl = new URL(window.location.href);
                        //add verifiedLockedCode parameter
                        if (!currentUrl.searchParams.has("verifiedLockedCode")) currentUrl.searchParams.append("verifiedLockedCode", "checkedAndValid");
                        //update pid parameter
                        if (selectedLockedProduct?.ZoneAndProduct) currentUrl.searchParams.set("pid", selectedLockedProduct.ZoneAndProduct);
                        window.location.href = currentUrl.toString();
                    }
                })
            })
        ]
    });
};



var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $5kjCO = parcelRequire("5kjCO");

var $2sdqj = parcelRequire("2sdqj");

var $gXzQg = parcelRequire("gXzQg");
const $eca55d121a7a94f5$export$cc52d1da9ced64d9 = ({ locale: locale, children: children, productAvailability: productAvailability, maxAmount: maxAmount, spotSelection: spotSelection, formLang: formLang, pending: pending, pendingAvailability: pendingAvailability, addSpotEvent: addSpotEvent, removeSpotEvent: removeSpotEvent, incrementEvent: incrementEvent, selectedDate: selectedDate })=>{
    children = (0, (/*@__PURE__*/$parcel$interopDefault($ca3MY))).Children.toArray(children);
    const emptyGuid = "00000000-0000-0000-0000-000000000000";
    const spotSelected = spotSelection.some((selection)=>selection.item.ParkingSpace.Uid !== emptyGuid);
    return /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            spotSelection.map((item, index)=>{
                const notes = $eca55d121a7a94f5$var$getNotes(item);
                return /*#__PURE__*/ (0, $54dlf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ca3MY))).Fragment, {
                    children: /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXzQg.DropdownlistWithLabel), {
                                selectedDate: selectedDate,
                                locale: locale,
                                available: formLang.available,
                                text: `${formLang.spotselection} ${index + 1}`,
                                options: productAvailability ?? [],
                                optionIdentifier: "ParkingSpace.Uid",
                                optionText: "ParkingSpace.Name",
                                value: item,
                                setValue: addSpotEvent,
                                index: index,
                                disabled: pending || pendingAvailability || removeSpotEvent !== null && index + 1 !== spotSelection.length,
                                loading: !(removeSpotEvent !== null && index + 1 !== spotSelection.length) && pendingAvailability,
                                errorMessages: formLang.errorMessages,
                                children: notes !== "" && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                                    children: notes
                                })
                            }),
                            children[index],
                            removeSpotEvent !== null && index + 1 !== spotSelection.length && /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                className: "single-step__section single-step__section--negativetopmargin",
                                children: [
                                    /*#__PURE__*/ (0, $54dlf.jsx)("label", {
                                        className: "single-step__section__label single-step__section__label--hideonphone",
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                                        className: "single-step__link single-step__link--remove",
                                        disabled: pending,
                                        onClick: ()=>{
                                            removeSpotEvent(index);
                                        },
                                        children: "Remove"
                                    })
                                ]
                            }),
                            index + 1 === spotSelection.length && /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                className: `single-step__section ${removeSpotEvent !== null && index > 0 && "single-step__section--space-between"}`,
                                children: [
                                    removeSpotEvent !== null && index > 0 && /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $54dlf.jsx)("label", {
                                                className: "single-step__section__label single-step__section__label--hideonphone",
                                                children: "\xa0"
                                            }),
                                            /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                                                className: "single-step__link single-step__link--remove",
                                                disabled: pending,
                                                onClick: ()=>{
                                                    removeSpotEvent(index);
                                                },
                                                children: "Remove"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $54dlf.jsx)("label", {
                                                className: "single-step__section__label single-step__section__label--hideonphone",
                                                children: "\xa0"
                                            }),
                                            spotSelection.length < maxAmount?.number && /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                                                className: "single-step__button single-step__button--addspot",
                                                onClick: ()=>{
                                                    incrementEvent();
                                                },
                                                disabled: item.error || item.item.ParkingSpace.Uid === emptyGuid || pending || pendingAvailability,
                                                children: formLang.addspot
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }, `single-spot-${index}`);
            }),
            spotSelection.length === maxAmount?.number && spotSelected && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                className: "single-step__section",
                children: spotSelection.length === maxAmount?.number && maxAmount?.type === "product" && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                    className: "nomargin italic",
                    children: formLang.numberOfParkingSpotsInfo
                })
            })
        ]
    });
};
const $eca55d121a7a94f5$var$getNotes = (item)=>{
    const thisItem = item?.item ?? item;
    const externalNote = thisItem?.ParkingSpace?.ExternalNote ?? "";
    const accessDeviceExternalNote = thisItem?.ParkingSpace?.AccessDeviceExternalNote ?? "";
    return externalNote + (externalNote !== "" ? " " : "") + accessDeviceExternalNote;
};



var $axmXn = parcelRequire("axmXn");

var $6bYiZ = parcelRequire("6bYiZ");

var $5kjCO = parcelRequire("5kjCO");

var $7HCW7 = parcelRequire("7HCW7");

var $54dlf = parcelRequire("54dlf");
parcelRequire("ca3MY");
const $6deb44746c60b73b$export$44d296a485bd0579 = (props)=>{
    const wrappingClass = `single-step__section single-step__section--numberselection`;
    const clickUpHandler = ()=>{
        const newValue = props.value.number + 1;
        props.setValue({
            ...props.value,
            number: newValue
        });
    };
    const clickDownHandler = ()=>{
        const newValue = props.value.number - 1;
        props.setValue({
            ...props.value,
            number: newValue
        });
    };
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: wrappingClass,
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)("label", {
                className: "single-step__section__label",
                children: props.text
            }),
            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                className: "single-step__section__selection",
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                        className: "minus",
                        onClick: clickDownHandler,
                        disabled: props.value.number === props.defaultMinValue || props.disabled || props.defaultMaxValue === 0,
                        children: "Minus"
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                        className: "number",
                        ref: props.inputRef,
                        disabled: props.disabled || props.defaultMaxValue === 0,
                        children: props.value.number
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                        className: "plus",
                        onClick: clickUpHandler,
                        disabled: props.value.number === props.defaultMaxValue || props.disabled || props.defaultMaxValue === 0,
                        children: "Plus"
                    })
                ]
            }),
            props.children,
            props.value.error && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                className: "validation-error",
                children: props.value.error
            })
        ]
    });
};




var $bJXZr = parcelRequire("bJXZr");

var $54dlf = parcelRequire("54dlf");
parcelRequire("cJ5lq");

var $ca3MY = parcelRequire("ca3MY");

var $7zbft = parcelRequire("7zbft");

var $4kqcG = parcelRequire("4kqcG");
const $9e0433d8a0a59552$export$bb7322575bc85fcd = ({ headings: headings = true, spotADAmount: spotADAmount, formLang: formLang, addSelectedAccessDevices: addSelectedAccessDevices, accessDevices: accessDevices, currency: currency, numberOfParkingSpots: numberOfParkingSpots, optional: optional = false, csr: csr = false, locked: locked = false, nextToProduct: nextToProduct = false, reserved: reserved = false, availabilityPending: availabilityPending = false })=>{
    const isAccessDeviceProduct = accessDevices ? accessDevices[0]?.Family === "Access Device" : false;
    const mandatory = isAccessDeviceProduct || accessDevices && accessDevices.length && accessDevices.some((device)=>device.Required || device.Bundled);
    const [accessDevicesToDisplay, setAccessDevicesToDisplay] = (0, $ca3MY.useState)([]);
    const [selected, setSelected] = (0, $ca3MY.useState)([]);
    (0, $ca3MY.useEffect)(()=>{
        if (!accessDevices || accessDevices.length === 0) return;
        const parsedAccessDevices = accessDevices.filter((device)=>csr ? true : optional ? !(device.Required || device.Bundled) : device.Required || device.Bundled).map((ad)=>{
            const spotADAmountAvailability = spotADAmount?.availability ?? [];
            return {
                ...ad,
                Availability: reserved && spotADAmount?.availability ? isAccessDeviceProduct ? spotADAmountAvailability[0].Availability : spotADAmountAvailability[spotADAmountAvailability.findIndex((item)=>item.ProductId === ad.ProductDetails?.ProductId)]?.Availability : ad.Availability
            };
        });
        setAccessDevicesToDisplay(parsedAccessDevices);
    }, [
        accessDevices,
        spotADAmount
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (!accessDevicesToDisplay || accessDevicesToDisplay.length === 0) return;
        const parsedAccessDevices = accessDevicesToDisplay.map((device)=>{
            return {
                id: device.ProductOptionId,
                selected: device.Required || device.Bundled || device.Selected && device.Availability > 0,
                maxAmount: device.Availability,
                mandatory: device.Required || device.Bundled,
                ProductOption: device.ProductOptionId,
                Quantity: numberOfParkingSpots <= device.Availability ? reserved && !device.Bundled && !device.Required ? 1 : numberOfParkingSpots : device.Availability,
                BillingFrequency: "One-Time",
                Name: device.ProductDetails?.Name,
                changed: device.Selected ? true : false,
                spotName: reserved && !device.Bundled && !device.Required ? [
                    spotADAmount.spotName
                ] : null
            };
        });
        setSelected(parsedAccessDevices);
    }, [
        accessDevicesToDisplay
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (!addSelectedAccessDevices) return;
        if (reserved && selected.some((s)=>s.Quantity)) addSelectedAccessDevices(selected);
        else if (!reserved) addSelectedAccessDevices(selected.filter((device)=>device.selected));
    }, [
        selected
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (reserved || !selected || selected.length === 0) return;
        setSelected(selected.map((device)=>({
                ...device,
                Quantity: device.selected && numberOfParkingSpots <= device.maxAmount ? numberOfParkingSpots : device.maxAmount
            })));
    }, [
        numberOfParkingSpots,
        spotADAmount
    ]);
    const handleSelectedAccessDevice = (event)=>{
        const nearestLiId = event.target.closest("li").id;
        setSelected(selected.map((device)=>({
                ...device,
                changed: device.id === nearestLiId ? true : false,
                selected: device.id === nearestLiId ? !device.selected : device.selected
            })));
    };
    if (!csr && nextToProduct && mandatory) return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
        className: "hasaccessdevice__nexttoproduct",
        children: /*#__PURE__*/ (0, $54dlf.jsx)("ul", {
            className: "hasaccessdevice__list",
            children: accessDevicesToDisplay.map((device)=>{
                let notAvailable = device.Availability < 1;
                return (device.Required || device.Bundled) && /*#__PURE__*/ (0, $54dlf.jsx)("li", {
                    className: "hasaccessdevice__listitem",
                    id: device.ProductOptionId || device.Id,
                    children: /*#__PURE__*/ (0, $54dlf.jsxs)((0, $7zbft.CheckboxWithLabel), {
                        disabled: locked || device.Required || device.Bundled || notAvailable || isAccessDeviceProduct,
                        isAccessDevice: true,
                        value: !notAvailable && (device.Selected || device.Required || device.Bundled || isAccessDeviceProduct),
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                className: "hasaccessdevice__listitem--description",
                                children: [
                                    numberOfParkingSpots && !reserved && numberOfParkingSpots > 1 && /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                                        children: [
                                            numberOfParkingSpots,
                                            "\xd7 "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                        children: device.Name || device.Text
                                    }),
                                    /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                        children: device.ProductDetails?.Description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                className: "price-and-availability",
                                children: [
                                    !availabilityPending || !reserved ? /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                        children: device.SbqqUnitPrice ? `${(0, $4kqcG.formatCurrency)(device.SbqqUnitPrice * (!reserved && numberOfParkingSpots ? numberOfParkingSpots : 1), true)}` : formLang.accessDevice.bundled
                                    }) : /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                        className: "loadingdots"
                                    }),
                                    notAvailable && !availabilityPending && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                                        className: "hasaccessdevice__listitem--availability",
                                        children: /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                            children: formLang.accessDevice.notAvailable
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }, device.ProductOptionId || device.Id);
            })
        })
    });
    else if (csr && nextToProduct && mandatory || optional) return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: nextToProduct ? "hasaccessdevice__nexttoproduct--csr" : "",
        children: [
            !nextToProduct && headings && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                children: /*#__PURE__*/ (0, $54dlf.jsx)("strong", {
                    children: "Other"
                })
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                className: "hasaccessdevice",
                children: /*#__PURE__*/ (0, $54dlf.jsxs)("ul", {
                    className: "hasaccessdevice__list",
                    children: [
                        headings && /*#__PURE__*/ (0, $54dlf.jsxs)("li", {
                            className: "hasaccessdevice__listitem hasaccessdevice__listitem--heading",
                            children: [
                                /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                    children: formLang.accessDevice.product
                                }),
                                /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                    className: "hasaccessdevice__listitem--heading-price",
                                    children: formLang.accessDevice.price
                                }),
                                /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                    children: csr && formLang.accessDevice.availability
                                })
                            ]
                        }),
                        accessDevicesToDisplay.map((device, i)=>{
                            let notAvailable = device.Availability < 1;
                            let price = +device.SbqqUnitPrice || +device.UnitPrice;
                            return (isAccessDeviceProduct || !device.Required && !device.Bundled && !nextToProduct || csr && nextToProduct && (device.Required || device.Bundled) || csr && !nextToProduct && !device.Required && !device.Bundled) && /*#__PURE__*/ (0, $54dlf.jsx)("li", {
                                className: "hasaccessdevice__listitem hasaccessdevice__listitem--csr",
                                id: device.ProductOptionId || device.Id,
                                children: /*#__PURE__*/ (0, $54dlf.jsxs)((0, $7zbft.CheckboxWithLabel), {
                                    disabled: locked || device.Required || device.Bundled || notAvailable || isAccessDeviceProduct,
                                    isAccessDevice: true,
                                    value: !notAvailable && (device.Selected || device.Required || device.Bundled || isAccessDeviceProduct),
                                    handleClick: handleSelectedAccessDevice,
                                    children: [
                                        /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                            className: "hasaccessdevice__listitem--description",
                                            children: [
                                                /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                                                    children: [
                                                        !notAvailable && !reserved && numberOfParkingSpots && numberOfParkingSpots > 1 && (device.Availability >= numberOfParkingSpots ? `${numberOfParkingSpots}\xd7 ` : `${device.Availability}\xd7 `),
                                                        device.Name || device.Text,
                                                        spotADAmount && " \u2013 " + spotADAmount.spotName
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                    children: device.ProductDetails?.Description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                            className: "hasaccessdevice__listitem--optional",
                                            children: csr && (device.Required ? formLang.accessDevice.mandatory : device.Bundled ? formLang.accessDevice.bundled : formLang.accessDevice.optional)
                                        }),
                                        /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                                            className: "hasaccessdevice__listitem--price",
                                            children: [
                                                /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                    children: "Price: "
                                                }),
                                                !availabilityPending && price ? !reserved && price ? (0, $4kqcG.formatCurrency)(price * (device.Availability >= numberOfParkingSpots ? numberOfParkingSpots : 1), true) : (0, $4kqcG.formatCurrency)(price, true) ?? 0 : /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                    className: "loadingdots"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                            className: "hasaccessdevice__listitem--availability",
                                            children: [
                                                csr && (!availabilityPending ? !notAvailable && `${device?.Availability ?? ""}` : /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                    className: "loadingdots"
                                                })),
                                                notAvailable && !availabilityPending && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                                    children: formLang.accessDevice.notAvailable
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, device.ProductOptionId || device.Id);
                        })
                    ]
                })
            })
        ]
    });
    else return null;
};



var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $jl9cc = parcelRequire("jl9cc");
const $b0a99c563b858690$export$afdb6dae40f95261 = (props)=>{
    const wrappingClass = `single-step__section single-step__section--switch`;
    const isValueObject = typeof props.value === "object" && props.value !== null;
    const error = isValueObject && props.value && props.value.error || props.error;
    const [isChecked, setIsChecked] = (0, $ca3MY.useState)(isValueObject ? props.value.selected : props.value);
    const onChangeHandler = ()=>{
        setIsChecked(!isChecked);
        if (isValueObject) props.setValue({
            ...props.value,
            selected: !props.value.selected
        });
        else props.setValue(!props.value);
    };
    (0, $ca3MY.useEffect)(()=>setIsChecked(isValueObject ? props.value.selected : props.value), [
        props.value
    ]);
    return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
        className: wrappingClass,
        children: /*#__PURE__*/ (0, $54dlf.jsxs)("label", {
            className: "single-step__section__switch-wrapper",
            children: [
                /*#__PURE__*/ (0, $54dlf.jsx)("input", {
                    className: "single-step__section__switch-original",
                    disabled: props.disabled,
                    type: "checkbox",
                    "aria-invalid": error ? true : null,
                    checked: isChecked,
                    onChange: onChangeHandler
                }),
                /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                    className: "single-step__section__switch-check"
                }),
                /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                    className: "single-step__section__switch-label",
                    children: [
                        /*#__PURE__*/ (0, $54dlf.jsx)((0, $jl9cc.HtmlOutput), {
                            html: props.text
                        }),
                        error && /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                            className: "validation-error",
                            children: error
                        })
                    ]
                })
            ]
        })
    });
};


const $a78324d24ce69030$var$emptyGuid = "00000000-0000-0000-0000-000000000000";
const $a78324d24ce69030$var$initialState = (lang)=>{
    return {
        form: {
            date: {
                date: new URLSearchParams(window.location.search).get("date"),
                error: null,
                required: true,
                elementType: "date"
            },
            productSelection: {
                item: {
                    Text: lang.chooseproduct,
                    Id: $a78324d24ce69030$var$emptyGuid,
                    ZoneAndProduct: $a78324d24ce69030$var$emptyGuid,
                    initial: true
                },
                required: true,
                elementType: "select"
            },
            numberOfParkingSpots: {
                number: 1,
                elementType: "number"
            },
            paymentSelection: {
                item: {
                    id: $a78324d24ce69030$var$emptyGuid,
                    initial: true
                },
                elementType: "radio"
            },
            spotSelection: [
                {
                    item: {
                        ParkingSpace: {
                            Name: lang.choosespot,
                            Uid: $a78324d24ce69030$var$emptyGuid
                        }
                    },
                    initial: true
                }
            ],
            accessDevices: [],
            accessDevicesOptional: []
        },
        pending: false
    };
};
const $a78324d24ce69030$var$reducer = (state, action)=>{
    //console.log('reducer', action)
    switch(action.type){
        case (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).OVERRIDE:
            return {
                ...state,
                form: {
                    ...action.payload
                }
            };
        case (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).DATE:
            return {
                ...state,
                form: {
                    ...state.form,
                    date: action.payload
                }
            };
        case (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).PRODUCT:
            return {
                ...state,
                form: {
                    ...state.form,
                    productSelection: action.payload.value,
                    accessDevices: state.form.productSelection.item.Type === action.payload.value.item.Type ? state.form.accessDevices : [],
                    accessDevicesOptional: state.form.productSelection.item.Type === action.payload.value.item.Type ? state.form.accessDevicesOptional : [],
                    spotSelection: [
                        {
                            item: {
                                ParkingSpace: {
                                    Name: action.payload.formLang.choosespot,
                                    Uid: $a78324d24ce69030$var$emptyGuid
                                }
                            },
                            initial: true
                        }
                    ]
                }
            };
        case (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).PAYMENT:
            return {
                ...state,
                form: {
                    ...state.form,
                    paymentSelection: action.payload
                }
            };
        case (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).SPOT_COUNT:
            return {
                ...state,
                form: {
                    ...state.form,
                    numberOfParkingSpots: action.payload.number ? action.payload : {
                        ...state.form.numberOfParkingSpots,
                        number: action.payload
                    }
                }
            };
        case (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).SPOT_COUNT_INCREMENT:
            return {
                ...state,
                form: {
                    ...state.form,
                    numberOfParkingSpots: {
                        number: state.form.numberOfParkingSpots.number + 1,
                        elementType: "number"
                    }
                }
            };
        case (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).SPOT_SELECTION:
            return {
                ...state,
                form: {
                    ...state.form,
                    spotSelection: action.payload
                }
            };
        case (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).ACCESS_DEVICES:
            return {
                ...state,
                form: {
                    ...state.form,
                    accessDevices: action.payload
                }
            };
        case (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).ACCESS_DEVICES_OPTIONAL:
            return {
                ...state,
                form: {
                    ...state.form,
                    accessDevicesOptional: action.payload
                }
            };
        case (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).SPOT_SELECTION_INCREMENT:
            return {
                ...state,
                form: {
                    ...state.form,
                    spotSelection: [
                        ...state.form.spotSelection,
                        {
                            item: {
                                ParkingSpace: {
                                    Name: action.payload.choosespot,
                                    Uid: $a78324d24ce69030$var$emptyGuid
                                }
                            },
                            initial: true
                        }
                    ]
                }
            };
        case (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).PENDING:
            return {
                ...state,
                pending: action.payload
            };
        default:
            console.log("No reducer action specified.");
    }
};
const $a78324d24ce69030$var$OnlineBookingLtp = ()=>{
    const { bookingFlowContext: bookingFlowContext, setBookingFlowContext: setBookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    const currentStepFormData = {
        ...bookingFlowContext.availableSteps.onlineBooking.formData
    } ?? {};
    const formLang = {
        ...bookingFlowContext.localization.global,
        ...bookingFlowContext.localization.onlineBooking,
        ...bookingFlowContext.localization.login,
        buttons: {
            ...bookingFlowContext.localization.global.buttons,
            ...bookingFlowContext.localization.onlineBooking.buttons,
            ...bookingFlowContext.localization.login.buttons
        },
        language: bookingFlowContext.localization.language
    };
    const endDate = bookingFlowContext.episerver.LatestSalesorderStartDay ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(bookingFlowContext.episerver.LatestSalesorderStartDay)).toDate() : (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))().add(1, "years").toDate();
    let id = null;
    let urlParams = new URLSearchParams(window.location.search);
    const urlPid = urlParams.get("pid") ?? urlParams.get("pId");
    const contextPid = currentStepFormData.productSelection?.item?.ZoneAndProduct;
    const shouldRestoreFromContext = currentStepFormData.date && !urlParams.has("date") && (!urlPid || urlPid.endsWith("-") || urlPid === contextPid);
    const [stepState, dispatch] = (0, $ca3MY.useReducer)($a78324d24ce69030$var$reducer, shouldRestoreFromContext ? {
        ...$a78324d24ce69030$var$initialState(formLang),
        form: currentStepFormData
    } : $a78324d24ce69030$var$initialState(formLang));
    const prevStepState = (0, $8BTjt.usePrevious)(stepState);
    const isAccessDevice = !stepState.form.productSelection.item.initial ? stepState.form.productSelection.item.Family === "Access Device" : false;
    const hasAccessDevice = !stepState.form.productSelection.item.initial && stepState.form.productSelection.item.AccessDevices ? stepState.form.productSelection.item.AccessDevices.length > 0 : false;
    const [productAvailability, productAvailabilityCount, paymentOptions, pendingAvailability, availableFrom] = (0, $effc430ba36988ec$export$e9082e1603ae8290)(isAccessDevice, stepState.form.productSelection.item, stepState.form.date.date, bookingFlowContext);
    let availableFromUrl = null;
    if (availableFrom && (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(availableFrom.from).isBefore(endDate)) {
        urlParams.set("date", (0, $iFvPA.parseDate)(availableFrom.from, "sv", "L")), urlParams.set("pid", stepState.form.productSelection.item.ZoneAndProduct);
        availableFromUrl = window.location.origin + window.location.pathname + "?" + urlParams.toString();
        urlParams.delete("date");
    }
    let isReservedProduct = !stepState.form.productSelection.item.initial ? stepState.form.productSelection.item.Type === "RESERVED" : null;
    const accessDeviceObject = (0, $d0f2efe7934d0911$export$408040c9a8487ff8)(isAccessDevice, hasAccessDevice, stepState.form.productSelection.item, bookingFlowContext);
    const [accessDevices, pendingAccessDeviceAvailability, optionalAccessDevices, mandatoryADNotAvailable, mandatoryADAvailability] = isReservedProduct ? [
        stepState.form.productSelection.item.AccessDevices,
        false,
        stepState.form.productSelection.item.AccessDevices ? stepState.form.productSelection.item.AccessDevices.filter((device)=>!device.Bundled && !device.Required).length > 0 : null,
        false,
        null
    ] : accessDeviceObject;
    const [maxAmount, setMaxAmount] = (0, $ca3MY.useState)(null);
    const [spotADAmount, setSpotADAmount] = (0, $ca3MY.useState)(null);
    const [spotADAmountPending, setSpotADAmountPending] = (0, $ca3MY.useState)(false);
    const [spotADNotAvailable, setSpotADNotAvailable] = (0, $ca3MY.useState)(false);
    const [isAfterPriceChange, setIsAfterPriceChange] = (0, $ca3MY.useState)(false);
    id = stepState.form.productSelection.item.Id;
    const locale = bookingFlowContext.country;
    const selectedLocale = locale === "no" ? "nb" : locale === "se" ? "sv" : locale;
    const [spotSelectionMade, setSpotSelectionMade] = (0, $ca3MY.useState)(false);
    const [showAllSpots, setShowAllSpots] = (0, $ca3MY.useState)(false);
    const [noNotAvailableSpots, setNoNotAvailableSpots] = (0, $ca3MY.useState)(false);
    const [scrollEnabled, setScrollEnabled] = (0, $ca3MY.useState)(null);
    const [fromUrl, setFromUrl] = (0, $ca3MY.useState)(null);
    const useRadioButtonList = bookingFlowContext.episerver.useRadioButtonList === "True";
    const isNotScrolledIntoView = (element)=>{
        const rect = element.getBoundingClientRect();
        const elemTop = rect.top;
        const elemBottom = rect.bottom;
        const isVisible = elemTop < window.innerHeight && elemBottom >= 0;
        return !isVisible;
    };
    (0, $ca3MY.useEffect)(()=>{
        if (id === bookingFlowContext.availableSteps.onlineBooking?.formData?.productSelection?.item?.Id) return;
        dispatch({
            type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).SPOT_COUNT,
            payload: {
                number: 1,
                elementType: "number"
            }
        });
    }, [
        id
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (stepState.form.date.error) return;
        const selectedProductId = stepState.form.productSelection.item.ZoneAndProduct;
        const storedDateIsInvalid = fromUrl !== null ? checkDate() : false;
        if (selectedProductId === $a78324d24ce69030$var$emptyGuid) return;
        if (scrollEnabled) scrollNextOrDateIntoView(storedDateIsInvalid);
        urlParams.set("pid", stepState.form.productSelection.item.ZoneAndProduct);
        history.replaceState({
            activeStep: 0
        }, document.title, window.location.origin + window.location.pathname + "?" + urlParams.toString());
    }, [
        id,
        stepState.form.date.date,
        fromUrl
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (hasAccessDevice && mandatoryADAvailability != null && productAvailabilityCount) {
            const max = mandatoryADAvailability < productAvailabilityCount ? {
                number: mandatoryADAvailability,
                type: "AD"
            } : {
                number: productAvailabilityCount,
                type: "product"
            };
            setMaxAmount(max);
        } else if (productAvailabilityCount) setMaxAmount({
            number: productAvailabilityCount,
            type: "product"
        });
    }, [
        id,
        mandatoryADAvailability,
        productAvailabilityCount
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (productAvailability && !productAvailability.some((spot)=>spot.ParkingSpaceStatus === "NOT_AVAILABLE") || isAccessDevice) {
            setNoNotAvailableSpots(true);
            setShowAllSpots(false);
        }
    }, [
        productAvailability
    ]);
    (0, $ca3MY.useEffect)(()=>{
        setNoNotAvailableSpots(false);
        setShowAllSpots(false);
        setIsAfterPriceChange(false);
        if (stepState.form.date.date) window.sessionStorage.setItem("selected_date", JSON.stringify(stepState.form.date));
        if (!stepState.form.date.date || !id || !stepState.form?.productSelection?.item?.UpcomingPriceChange) return;
        const selectedDate = (0, $iFvPA.parseDate)(stepState.form.date.date);
        const startSellingDate = stepState.form.productSelection.item?.StartSellingDate ? (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))((0, $iFvPA.parseDate)(stepState.form.productSelection.item?.StartSellingDate)).add(6, "hours") : null;
        if (startSellingDate && (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(selectedDate).isBefore(startSellingDate, "day")) {
            window.sessionStorage.removeItem("selected_date");
            dispatch({
                type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).DATE,
                payload: {
                    date: null,
                    error: null,
                    required: true,
                    elementType: "date"
                }
            });
        }
        setIsAfterPriceChange((0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(stepState.form?.productSelection?.item?.UpcomingPriceChange?.Validity.ValidFrom).isSameOrBefore(selectedDate, "day"));
    }, [
        stepState.form.date,
        id
    ]);
    const checkDate = ()=>{
        let storedDateIsInvalid = false;
        const stored = window.sessionStorage.getItem("selected_date") ? JSON.parse(window.sessionStorage.getItem("selected_date")) : undefined;
        const flexDays = stepState.form.productSelection.item?.OnlineBookingFlexibleStartDate;
        if (stored && !urlParams.has("date")) {
            const addDays = flexDays === null || flexDays === undefined ? locale === "no" ? 3 : 7 : stepState.form.productSelection.item?.OnlineBookingFlexibleStartDate;
            const startDate = (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))().add(addDays, "days").toDate();
            const storedDate = (0, $iFvPA.parseDate)(stored.date);
            storedDateIsInvalid = (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(storedDate).isBefore(startDate, "day") || (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(storedDate).isAfter(endDate, "day");
        }
        if (storedDateIsInvalid || stepState.form.date.error) {
            window.sessionStorage.removeItem("selected_date");
            if (!stepState.form.date.date && !stepState.form.date.error) dispatch({
                type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).DATE,
                payload: {
                    date: null,
                    error: null,
                    required: true,
                    elementType: "date"
                }
            });
        } else if (stored && (!stepState.form.date.date && !stepState.form.date.error || urlParams.has("date"))) dispatch({
            type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).DATE,
            payload: stored
        });
        if (scrollEnabled === null) setTimeout(()=>{
            setScrollEnabled(true);
        }, 1000);
        if (urlParams.has("date")) {
            urlParams.delete("date");
            history.replaceState({
                activeStep: 0
            }, document.title, window.location.origin + window.location.pathname + "?" + urlParams.toString());
        }
        return storedDateIsInvalid;
    };
    const scrollNextOrDateIntoView = (storedDateIsInvalid)=>{
        setTimeout(()=>{
            if (document.querySelector(".DayPickerInput-OverlayWrapper")) return;
            if (stepState.form.date.date && !storedDateIsInvalid) setTimeout(()=>{
                const nextButton = document.querySelector(".single-step__button--next");
                isNotScrolledIntoView(nextButton) && nextButton.scrollIntoView({
                    behavior: "smooth",
                    block: "end"
                });
            }, 200);
            else if (scrollEnabled && (storedDateIsInvalid || !stepState.form.date.date)) {
                const dateSelection = document.querySelector(".single-step__section--date .single-step__section__label");
                isNotScrolledIntoView(dateSelection) && dateSelection.scrollIntoView({
                    behavior: "smooth"
                });
            }
        }, 200);
    };
    const onlineBookingHandler = async ()=>{
        if (!stepState.form.date.date) {
            scrollNextOrDateIntoView(true);
            dispatch({
                type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).DATE,
                payload: {
                    ...stepState.form.date,
                    error: true
                }
            });
            return;
        }
        const loggedIn = bookingFlowContext.episerver.loggedIn;
        const switchAccountUrl = bookingFlowContext.episerver.switchAccountUrl;
        const activeProfile = !!bookingFlowContext.episerver.activeProfile;
        const hasMoreThanOneProfile = bookingFlowContext.episerver.hasMoreThanOneProfile;
        const spotSelection = stepState.form.spotSelection;
        urlParams = urlParams.toString().length > 0 ? "?" + urlParams.toString() + "&" : "?";
        let [updatedForm, formValidationError, cleanFormData] = (0, $se1IJ.validateFormObjectAlt)(stepState.form, formLang.errorMessages);
        if (formValidationError) {
            dispatch({
                type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).OVERRIDE,
                payload: updatedForm
            });
            return;
        }
        let activeStep = null;
        let user = null;
        if (bookingFlowContext.episerver.loggedIn && (!hasMoreThanOneProfile || activeProfile)) {
            user = {
                email: bookingFlowContext.episerver.emailAddress,
                givenName: bookingFlowContext.episerver.given_name,
                familyName: bookingFlowContext.episerver.family_name
            };
            if (bookingFlowContext.episerver.hasWebticketAccount && !(0, $bJXZr.shouldAccountBeUpdated)(bookingFlowContext)) {
                // If permit Usage type is SKIDATA, jump over 'Add vehicle' step (CPS-24723) 
                const isSkidata = stepState.form.productSelection?.item?.PermitUsageType?.toLowerCase() === "skidata";
                let newActiveStep = bookingFlowContext.availableSteps.addVehicle.index;
                if (isSkidata) newActiveStep = (0, $6bYiZ.ReturnStepAfterVehicleStage)(bookingFlowContext);
                activeStep = newActiveStep;
            } else activeStep = bookingFlowContext.availableSteps.createAccount.index;
        } else if (loggedIn && hasMoreThanOneProfile && !activeProfile) {
            activeStep = bookingFlowContext.availableSteps.onlineBooking.index;
            window.location.href = switchAccountUrl + encodeURIComponent(urlParams + "l=lgn");
        } else {
            activeStep = bookingFlowContext.availableSteps.onlineBooking.index;
            window.location.href = bookingFlowContext.episerver.loginUrl + encodeURIComponent(urlParams + "l=lgn");
        }
        const previousBooking = bookingFlowContext.availableSteps.onlineBooking.formData;
        const numberOfParkingSpots = stepState.form.numberOfParkingSpots.number || stepState.form.spotSelection.length;
        const changedSpots = isReservedProduct && spotSelection && previousBooking?.spotSelection && (spotSelection.length != previousBooking.spotSelection?.length || spotSelection.some((item)=>!previousBooking.spotSelection?.some((prevItem)=>prevItem.item.ParkingSpace.Uid === item.item.ParkingSpace.Uid)));
        const update = previousBooking ? previousBooking.productSelection.item.Id != id || previousBooking.numberOfParkingSpots.number != numberOfParkingSpots || previousBooking.date.date != stepState.form.date.date || previousBooking.paymentSelection.item.id != stepState.form.paymentSelection.item.id || changedSpots : true;
        setBookingFlowContext({
            ...bookingFlowContext,
            user: user,
            activeStep: activeStep,
            availableSteps: {
                ...bookingFlowContext.availableSteps,
                onlineBooking: {
                    ...bookingFlowContext.availableSteps.onlineBooking,
                    formData: {
                        ...cleanFormData
                    },
                    update: update
                },
                addVehicle: {
                    ...bookingFlowContext.availableSteps.addVehicle,
                    formData: bookingFlowContext.availableSteps.onlineBooking.formData?.productSelection.item.Type === stepState.form.productSelection.item.Type ? bookingFlowContext.availableSteps.addVehicle.formData : null
                }
            }
        });
    };
    (0, $ca3MY.useEffect)(()=>{
        const loggedIn = bookingFlowContext.episerver.loggedIn;
        const switchAccountUrl = bookingFlowContext.episerver.switchAccountUrl;
        const activeProfile = !!bookingFlowContext.episerver.activeProfile;
        const hasMoreThanOneProfile = bookingFlowContext.episerver.hasMoreThanOneProfile;
        const alreadyLoggedIn = !!bookingFlowContext.user;
        const productNotSelected = stepState.form.productSelection.item.initial;
        const urlParams = new URLSearchParams(window.location.search);
        const loginType = urlParams.get("L") ?? urlParams.get("l");
        history.replaceState({
            activeStep: 0
        }, document.title);
        if (alreadyLoggedIn || productNotSelected || (!loggedIn || !loginType) && !hasMoreThanOneProfile) return;
        if (loginType === "lgn" && loggedIn && hasMoreThanOneProfile && !activeProfile) {
            window.location.href = switchAccountUrl + encodeURIComponent("?" + urlParams);
            return;
        }
        if (bookingFlowContext.episerver.hasWebticketAccount && !(0, $bJXZr.shouldAccountBeUpdated)(bookingFlowContext) && (!hasMoreThanOneProfile || activeProfile)) {
            // If permit Usage type is SKIDATA, jump over 'Add vehicle' step (CPS-24723) 
            const isSkidata = stepState.form.productSelection?.item?.PermitUsageType?.toLowerCase() === "skidata";
            let newActiveStep = bookingFlowContext.availableSteps.addVehicle.index;
            if (isSkidata) newActiveStep = (0, $6bYiZ.ReturnStepAfterVehicleStage)(bookingFlowContext);
            setBookingFlowContext({
                ...bookingFlowContext,
                activeStep: newActiveStep,
                user: {
                    email: bookingFlowContext.episerver.emailAddress,
                    givenName: bookingFlowContext.episerver.given_name,
                    familyName: bookingFlowContext.episerver.family_name
                }
            });
        } else if (loginType === "gst") setBookingFlowContext({
            ...bookingFlowContext,
            activeStep: bookingFlowContext.availableSteps.createAccount.index,
            guest: true
        });
        else if (loginType === "lgn") setBookingFlowContext({
            ...bookingFlowContext,
            activeStep: bookingFlowContext.availableSteps.createAccount.index,
            guest: false
        });
    }, [
        bookingFlowContext.episerver.activeProfile
    ]);
    (0, $ca3MY.useEffect)(()=>{
        dispatch({
            type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).ACCESS_DEVICES,
            payload: []
        });
    }, [
        hasAccessDevice
    ]);
    const addSelectedAccessDevices = (selectedAccessDevices)=>{
        dispatch({
            type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).ACCESS_DEVICES,
            payload: selectedAccessDevices
        });
    };
    const handleReservedSelectedAccessDevices = (selectedAccessDevices, currentSpots)=>{
        const changedAD = selectedAccessDevices.filter((a)=>a.changed);
        const selectedSpots = currentSpots ? currentSpots.map((spot)=>spot.item.ParkingSpace.Name) : stepState.form.spotSelection.map((spot)=>spot.item.ParkingSpace.Name);
        let updatedState;
        if (currentSpots) {
            if (selectedAccessDevices.some((a)=>a.spotName.some((b)=>!selectedSpots.includes(b)))) updatedState = selectedAccessDevices.map((a)=>{
                return a.spotName.some((b)=>!selectedSpots.includes(b)) ? {
                    ...a,
                    Quantity: a.Quantity - 1,
                    spotName: a.spotName.filter((b)=>selectedSpots.includes(b))
                } : a;
            }).filter((a)=>a.Quantity !== 0);
        } else if (stepState?.form?.accessDevicesOptional?.length && changedAD.length) {
            const adToIncrease = changedAD.filter((a)=>stepState.form.accessDevicesOptional.some((b)=>{
                    return a.id === b.id && a.selected;
                }))[0];
            const adToDecrease = changedAD.filter((a)=>stepState.form.accessDevicesOptional.some((b)=>{
                    return a.id === b.id && !a.selected;
                }))[0];
            if (adToIncrease) {
                if (stepState.form.accessDevicesOptional.some((a)=>a.spotName.includes(changedAD[0].spotName[0]))) return;
                updatedState = stepState.form.accessDevicesOptional.map((a)=>{
                    return a.id === adToIncrease.id ? {
                        ...a,
                        Quantity: a.Quantity + +changedAD.map((b)=>b.id === a.id && b.Quantity),
                        spotName: [
                            ...a.spotName,
                            changedAD.map((b)=>b.id === a.id && b.spotName[0])[0]
                        ]
                    } : a;
                });
            } else if (adToDecrease) updatedState = stepState.form.accessDevicesOptional.map((a)=>{
                return a.id === adToDecrease.id ? {
                    ...a,
                    Quantity: a.Quantity - +changedAD.map((b)=>b.id === a.id && b.Quantity),
                    spotName: a.spotName.filter((a)=>a !== adToDecrease.spotName[0])
                } : a;
            }).filter((a)=>a.Quantity !== 0);
            else updatedState = [
                ...stepState.form.accessDevicesOptional,
                ...changedAD
            ];
        } else if (selectedAccessDevices.some((a)=>a.selected)) updatedState = selectedAccessDevices.filter((device)=>device.selected);
        if (updatedState) dispatch({
            type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).ACCESS_DEVICES_OPTIONAL,
            payload: updatedState
        });
    };
    const checkSpotADAvailability = async (spotNames)=>{
        const spotName = spotNames[spotNames.length - 1];
        const accessDevicesParams = [];
        accessDevices.filter((device)=>{
            accessDevicesParams.push({
                ProductId: device.ProductDetails?.ProductId,
                Spot: spotName
            });
        });
        const params = {
            accessDevices: accessDevicesParams
        };
        return await (0, $axmXn.products).getAccessDeviceAvailability(params);
    };
    const checkSpotADAmount = async (validSelectionList)=>{
        setSpotADAmountPending(true);
        const mandatoryAD = accessDevices?.some((ad)=>ad.Required || ad.Bundled);
        let choosenSpots = [];
        let leastRequiredOrBundledADAvailable;
        if (!spotADAmount && validSelectionList.length > 1) {
            const spotNames = validSelectionList.map((item)=>{
                return item.item.ParkingSpace.Name;
            });
            choosenSpots = spotNames.map((spotName)=>{
                return {
                    spotName: spotName,
                    availability: null
                };
            });
            setSpotADAmount(choosenSpots);
            const response = await checkSpotADAvailability(spotNames);
            if (response.status === 200) {
                leastRequiredOrBundledADAvailable = (0, $d0f2efe7934d0911$export$f34663f909e04f6b)(accessDevices, response.body?.AccessDevices);
                choosenSpots = spotNames.map((spotName, i)=>{
                    return {
                        spotName: spotName,
                        availability: response.body?.AccessDevices
                    };
                });
                if (leastRequiredOrBundledADAvailable) setMaxAmount({
                    number: leastRequiredOrBundledADAvailable,
                    type: "AD"
                });
            } else {
                console.log("Access device availability check error");
                choosenSpots = spotNames.map((spotName, i)=>{
                    return {
                        spotName: spotName,
                        availability: null,
                        productId: null
                    };
                });
                if (mandatoryAD) setMaxAmount({
                    number: 0,
                    type: "AD"
                });
            }
        } else {
            const spotName = validSelectionList[validSelectionList.length - 1].item.ParkingSpace.Name;
            choosenSpots = spotADAmount ?? [
                {
                    spotName: spotName,
                    availability: null
                }
            ];
            if (choosenSpots.length === validSelectionList.length) choosenSpots[validSelectionList.length - 1] = {
                spotName: spotName,
                availability: null
            };
            else choosenSpots.push({
                name: spotName,
                availability: null
            });
            setSpotADAmount(choosenSpots);
            const response = await checkSpotADAvailability([
                spotName
            ]);
            if (response.status === 200) {
                leastRequiredOrBundledADAvailable = (0, $d0f2efe7934d0911$export$f34663f909e04f6b)(accessDevices, response.body?.AccessDevices);
                choosenSpots[choosenSpots.length - 1] = {
                    spotName: spotName,
                    availability: response.body?.AccessDevices
                };
                if (leastRequiredOrBundledADAvailable) setMaxAmount({
                    number: leastRequiredOrBundledADAvailable,
                    type: "AD"
                });
            } else {
                console.log("Access device availability check error");
                choosenSpots[choosenSpots.length - 1] = {
                    spotName: spotName,
                    availability: null
                };
                if (mandatoryAD) setMaxAmount({
                    number: 0,
                    type: "AD"
                });
            }
        }
        setSpotADAmount(choosenSpots);
        setTimeout(()=>{
            setSpotADNotAvailable(leastRequiredOrBundledADAvailable < 1);
            setSpotADAmountPending(false);
        }, 500);
    };
    (0, $ca3MY.useEffect)(()=>{
        if (!isReservedProduct && !hasAccessDevice) return;
        handleSpotSelectionError();
    }, [
        spotADNotAvailable,
        stepState.form.spotSelection.length
    ]);
    const handleSpotSelectionError = ()=>{
        if (spotADNotAvailable === stepState.form.spotSelection[stepState.form.spotSelection.length - 1].error) return;
        const selectionList = stepState.form.spotSelection;
        const groupedList = (0, $cJ5lq.groupBy)(selectionList, (item)=>item.item.ParkingSpace.Uid);
        const validSelectionList = selectionList.map((item, i)=>{
            return {
                ...item,
                error: groupedList[item.item.ParkingSpace.Uid].length > 1 || i === selectionList.length - 1 && spotADNotAvailable ? true : false
            };
        });
        const lastInList = validSelectionList[validSelectionList.length - 1];
        if (lastInList.item.ParkingSpace.Uid !== $a78324d24ce69030$var$emptyGuid && !lastInList.error && (!lastInList.item.ParkingSpace.Name || spotADAmount && lastInList.item?.ParkingSpace?.Name !== spotADAmount[spotADAmount.length - 1]?.spotName)) checkSpotADAmount(validSelectionList);
        dispatch({
            type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).SPOT_SELECTION,
            payload: validSelectionList
        });
    };
    const addSpotSelectionHandler = async (selection, selectionIndex)=>{
        if (isReservedProduct && hasAccessDevice) setSpotADNotAvailable(false);
        const currentSpotADSelection = spotADAmount;
        const selectionList = stepState.form.spotSelection.map((item, index)=>index === selectionIndex ? {
                ...selection
            } : item);
        const groupedList = (0, $cJ5lq.groupBy)(selectionList, (item)=>item.item.ParkingSpace.Uid);
        const validSelectionList = selectionList.map((item)=>{
            return {
                ...item,
                error: groupedList[item.item.ParkingSpace.Uid].length > 1 ? true : false,
                initial: false
            };
        });
        if (spotADAmount?.length === validSelectionList.length) validSelectionList.forEach((item, i)=>{
            if (groupedList[item.item.ParkingSpace.Uid].length > 1 && i === spotADAmount?.length - 1) {
                currentSpotADSelection.splice(selectionIndex, 1);
                setSpotADAmount(currentSpotADSelection);
            }
        });
        dispatch({
            type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).SPOT_SELECTION,
            payload: validSelectionList
        });
        if (selection.item.ParkingSpace && selection.item.ParkingSpace.Uid !== $a78324d24ce69030$var$emptyGuid && validSelectionList.filter((item)=>item.error).length === 0) {
            if (hasAccessDevice && accessDevices && accessDevices.length) checkSpotADAmount(validSelectionList);
            setSpotSelectionMade(true);
        } else setSpotSelectionMade(false);
    };
    const removeSpotSelectionHandler = (selectionIndex)=>{
        const currentSpotSelections = stepState.form.spotSelection;
        const currentSpotADSelection = spotADAmount;
        if (selectionIndex > -1) {
            currentSpotSelections.splice(selectionIndex, 1);
            if (currentSpotADSelection) {
                currentSpotADSelection.splice(selectionIndex, 1);
                setSpotADAmount(currentSpotADSelection);
                handleSpotSelectionError();
                if (selectionIndex === stepState.form.spotSelection.length) {
                    setMaxAmount({
                        number: +Math.min(currentSpotADSelection[selectionIndex - 1].availability.map((device)=>{
                            return device.Availability;
                        })),
                        type: "AD"
                    });
                    setSpotADNotAvailable(null);
                }
            }
        }
        if (currentSpotADSelection) setSpotADAmount(currentSpotADSelection);
        const groupedList = (0, $cJ5lq.groupBy)(currentSpotSelections, (item)=>item.item.ParkingSpace.Uid);
        const validSelectionList = currentSpotSelections.map((item)=>{
            return {
                ...item,
                error: item.item.ParkingSpace.Uid !== $a78324d24ce69030$var$emptyGuid && groupedList[item.item.ParkingSpace.Uid].length > 1 ? true : false
            };
        });
        if (validSelectionList.filter((spot)=>spot.item.ParkingSpace.Uid === $a78324d24ce69030$var$emptyGuid || spot.error).length > 0) setSpotSelectionMade(false);
        else setSpotSelectionMade(true);
        dispatch({
            type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).SPOT_SELECTION,
            payload: validSelectionList
        });
    };
    (0, $ca3MY.useEffect)(()=>{
        if (!productAvailability || productAvailability.length === 0 || stepState.form.spotSelection.length === 0 || stepState.form.productSelection.item.Type !== "RESERVED") return;
        const filteredItems = stepState.form.spotSelection.map((item)=>{
            if (productAvailability.filter((newItem)=>newItem.ParkingSpace.Uid === item.item.ParkingSpace.Uid).length > 0) return {
                ...item,
                initial: false
            };
            else {
                setSpotADAmount(null);
                setSpotADNotAvailable(null);
                return {
                    item: {
                        ParkingSpace: {
                            Name: formLang.choosespot,
                            Uid: $a78324d24ce69030$var$emptyGuid
                        }
                    },
                    initial: true
                };
            }
        });
        hasAccessDevice && accessDevices && accessDevices.length && !filteredItems.slice(0, productAvailability.length ?? 1)[0].initial && checkSpotADAmount(filteredItems.slice(0, productAvailability.length ?? 1));
        dispatch({
            type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).SPOT_SELECTION,
            payload: filteredItems.slice(0, productAvailability.length ?? 1)
        });
        setSpotSelectionMade(filteredItems.filter((item)=>!item.initial).length > 0);
    }, [
        productAvailability
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (!stepState || !prevStepState) return;
        if (stepState.form.spotSelection.length !== prevStepState.form.spotSelection.length) removeSpotSelectionHandler(-1);
    }, [
        stepState.form.spotSelection
    ]);
    const getNewPrices = (options, upcomingPriceChange)=>{
        return options.map((option)=>{
            for (const [key, value] of Object.entries(upcomingPriceChange)){
                if (key.toLowerCase().includes(option.value.toLowerCase().replace("_", "").substring(0, 6)) && value) return {
                    ...option,
                    optionPrice: value
                };
            }
            return option;
        });
    };
    return /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $ef5b0e978e82ebfa$export$86677682429ed406), {
                bookingFlowContext: bookingFlowContext,
                formLang: formLang,
                setFromUrl: setFromUrl,
                pending: stepState.pending || fromUrl === null,
                date: stepState.form.date,
                productSelection: stepState.form.productSelection,
                useRadioButtonList: useRadioButtonList,
                setPending: (value)=>dispatch({
                        type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).PENDING,
                        payload: value
                    }),
                setDate: (value)=>dispatch({
                        type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).DATE,
                        payload: value
                    }),
                setProductSelection: (value)=>{
                    setSpotADAmount(null);
                    dispatch({
                        type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).PRODUCT,
                        payload: {
                            value: value,
                            formLang: formLang
                        }
                    });
                },
                isAfterPriceChange: isAfterPriceChange,
                scrollEnabled: scrollEnabled,
                setScrollEnabled: setScrollEnabled,
                dateDisabled: stepState.form.date.date && !stepState.form.productSelection.item.initial && !pendingAvailability && (productAvailabilityCount === 0 && !availableFrom || (isReservedProduct ? productAvailability?.length === 0 && !availableFrom : false)),
                availableFrom: availableFrom
            }),
            stepState.form.date.date && !stepState.form.productSelection.item.initial && !pendingAvailability && (productAvailabilityCount === 0 || (isReservedProduct ? productAvailability?.length === 0 : false)) && /*#__PURE__*/ (0, $54dlf.jsx)((0, $ca3MY.Fragment), {
                children: /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXJP5.Error), {
                    text: availableFrom ? formLang.availableparkingspotsinfodate.replace("{0}", (0, $iFvPA.parseDate)(availableFrom.until, selectedLocale, "L")) + (availableFromUrl ? " " + formLang.availableparkingspotsinfolink.replace("{1}", availableFromUrl) : "") : formLang.availableparkingspotsinfonolink
                })
            }),
            !stepState.form.productSelection.item.initial && stepState.form.productSelection.item.UpcomingPriceChange && stepState.form.productSelection.item.MonthlyPrice !== stepState.form.productSelection.item.UpcomingPriceChange.MonthlyPrice && /*#__PURE__*/ (0, $54dlf.jsx)((0, $ca3MY.Fragment), {
                children: /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXJP5.Error), {
                    text: [
                        `${formLang.pricechangedate} ${(0, $iFvPA.parseDate)(stepState.form.productSelection.item.UpcomingPriceChange.Validity.ValidFrom, selectedLocale, "L")}.`,
                        stepState.form.productSelection.item.UpcomingPriceChange.MonthlyPrice ? ` ${formLang.pricechangeprice} ${stepState.form.productSelection.item.UpcomingPriceChange.MonthlyPrice} ${stepState.form.productSelection.item.Currency}.` : ""
                    ].join("")
                })
            }),
            (!stepState.form.productSelection.item.initial && productAvailabilityCount && productAvailabilityCount > 0 && productAvailability?.length > 0 || pendingAvailability) && isReservedProduct && stepState.form.spotSelection?.length > 0 && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $eca55d121a7a94f5$export$cc52d1da9ced64d9), {
                        locale: selectedLocale,
                        productAvailability: productAvailability && productAvailability.filter((spot)=>showAllSpots || isAccessDevice ? spot : spot.ParkingSpaceStatus === "AVAILABLE"),
                        productAvailabilityCount: productAvailabilityCount,
                        maxAmount: maxAmount ?? 1,
                        spotSelection: stepState.form.spotSelection,
                        formLang: formLang,
                        pending: stepState.pending || spotADAmountPending,
                        pendingAvailability: pendingAvailability,
                        addSpotEvent: addSpotSelectionHandler,
                        removeSpotEvent: removeSpotSelectionHandler,
                        selectedDate: stepState.form.date,
                        incrementEvent: ()=>dispatch({
                                type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).SPOT_SELECTION_INCREMENT,
                                payload: formLang
                            }),
                        children: hasAccessDevice && !pendingAccessDeviceAvailability && !pendingAvailability && spotADAmount && spotADAmount.map((spotAD, i)=>{
                            return spotAD.spotName && /*#__PURE__*/ (0, $54dlf.jsx)((0, $9e0433d8a0a59552$export$bb7322575bc85fcd), {
                                spotADAmount: spotAD,
                                formLang: formLang,
                                availabilityPending: i === spotADAmount.length - 1 ? spotADAmountPending : false,
                                addSelectedAccessDevices: addSelectedAccessDevices,
                                reserved: true,
                                numberOfParkingSpots: stepState.form.spotSelection.length,
                                nextToProduct: spotADAmount,
                                accessDevices: accessDevices,
                                currency: stepState.form.productSelection.item.Currency
                            }, spotAD.spotName);
                        })
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $b0a99c563b858690$export$afdb6dae40f95261), {
                        disabled: pendingAvailability || noNotAvailableSpots,
                        value: showAllSpots,
                        setValue: setShowAllSpots,
                        error: noNotAvailableSpots,
                        text: formLang.futureAvailability
                    })
                ]
            }),
            !stepState.form.productSelection.item.initial && (productAvailabilityCount && productAvailabilityCount > 0 || pendingAvailability) && isReservedProduct !== null && isReservedProduct === false && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $6deb44746c60b73b$export$44d296a485bd0579), {
                        text: formLang.numberOfParkingSpots,
                        exceededText: maxAmount?.type === "product" ? formLang.exceededMaximumAmountInfo : formLang.accessDevice.exceededMaximumAmountInfo,
                        value: stepState.form.numberOfParkingSpots,
                        setValue: (value)=>dispatch({
                                type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).SPOT_COUNT,
                                payload: value
                            }),
                        defaultMinValue: 1,
                        defaultMaxValue: maxAmount?.number ?? 1,
                        disabled: hasAccessDevice && mandatoryADNotAvailable || pendingAccessDeviceAvailability || stepState.pending || pendingAvailability || productAvailabilityCount === 0,
                        children: /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                            className: "single-step__section",
                            children: productAvailabilityCount > 0 && stepState.form.numberOfParkingSpots.number === productAvailabilityCount && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                                className: "italic",
                                children: formLang.numberOfParkingSpotsInfo
                            })
                        })
                    }),
                    hasAccessDevice && !pendingAccessDeviceAvailability && /*#__PURE__*/ (0, $54dlf.jsx)((0, $9e0433d8a0a59552$export$bb7322575bc85fcd), {
                        formLang: formLang,
                        addSelectedAccessDevices: addSelectedAccessDevices,
                        numberOfParkingSpots: stepState.form.numberOfParkingSpots.number,
                        nextToProduct: true,
                        accessDevices: accessDevices,
                        currency: stepState.form.productSelection.item.Currency
                    })
                ]
            }),
            !stepState.form.productSelection.item.initial && paymentOptions.length > 0 && !(productAvailabilityCount === 0 || (isReservedProduct ? productAvailability?.length === 0 : false)) && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $7HCW7.RadioButtonListWithLabel), {
                        text: formLang.paymentSelection,
                        options: isAfterPriceChange && stepState.form.productSelection?.item?.UpcomingPriceChange ? getNewPrices(paymentOptions, stepState.form.productSelection?.item?.UpcomingPriceChange) : paymentOptions,
                        priceTimes: isReservedProduct ? stepState.form.spotSelection.length : stepState.form.numberOfParkingSpots.number,
                        locale: bookingFlowContext.country,
                        value: stepState.form.paymentSelection,
                        setValue: (value)=>dispatch({
                                type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).PAYMENT,
                                payload: value
                            }),
                        disabled: stepState.pending || pendingAvailability || productAvailabilityCount === 0 || (isReservedProduct ? productAvailability?.length === 0 : false)
                    })
                ]
            }),
            !stepState.form.productSelection.item.initial && stepState.form.productSelection.item.ExtraFee && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $72618502e1458656$export$a2ec690cee38f777), {
                        heading: stepState.form.productSelection.item.ExtraFee.Heading,
                        text: stepState.form.productSelection.item.ExtraFee.Text
                    })
                ]
            }),
            !stepState.form.productSelection.item.initial && hasAccessDevice && !pendingAccessDeviceAvailability && !pendingAvailability && !stepState.pending && optionalAccessDevices && productAvailabilityCount && productAvailabilityCount > 0 && accessDevices?.length > 0 && (isReservedProduct ? !stepState.form.spotSelection[0].initial && optionalAccessDevices : true) && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
                    /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                        className: "access-device__wrapper",
                        children: isReservedProduct && spotADAmount?.length ? spotADAmount.map((spotAD, i)=>{
                            return spotAD.spotName && /*#__PURE__*/ (0, $54dlf.jsx)((0, $9e0433d8a0a59552$export$bb7322575bc85fcd), {
                                spotADAmount: spotAD,
                                headings: i === 0,
                                formLang: formLang,
                                availabilityPending: i === spotADAmount.length - 1 ? spotADAmountPending : false,
                                addSelectedAccessDevices: handleReservedSelectedAccessDevices,
                                reserved: true,
                                numberOfParkingSpots: stepState.form.spotSelection.length,
                                optional: optionalAccessDevices,
                                accessDevices: accessDevices,
                                currency: stepState.form.productSelection.item.Currency
                            }, spotAD.spotName);
                        }) : !isReservedProduct && /*#__PURE__*/ (0, $54dlf.jsx)((0, $9e0433d8a0a59552$export$bb7322575bc85fcd), {
                            formLang: formLang,
                            optional: true,
                            addSelectedAccessDevices: (payload)=>dispatch({
                                    type: (0, $59fb50fb2c8e26e9$export$92a1a3b7554e9387).ACCESS_DEVICES_OPTIONAL,
                                    payload: payload
                                }),
                            accessDevices: accessDevices,
                            currency: stepState.form.productSelection.item.Currency,
                            numberOfParkingSpots: isReservedProduct ? stepState.form.spotSelection.length : stepState.form.numberOfParkingSpots.number
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            !bookingFlowContext.episerver.loggedIn && /*#__PURE__*/ (0, $54dlf.jsx)("h2", {
                className: "smallmargin",
                children: formLang.heading
            }),
            !bookingFlowContext.episerver.loggedIn && formLang.loginPreamble && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                className: "maxwidth margin center",
                children: formLang.loginPreamble
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                className: "single-step__button single-step__button--next",
                "data-booking-flow-step": "ltp-selectproduct",
                onClick: onlineBookingHandler,
                disabled: stepState.form.productSelection.item.initial || stepState.form.date.date && (stepState.form.date.error || isReservedProduct && productAvailability?.length === 0 || stepState.pending || pendingAvailability || productAvailabilityCount === null || productAvailabilityCount === 0 || isReservedProduct !== null && isReservedProduct === true && !spotSelectionMade || spotADAmountPending || pendingAccessDeviceAvailability || hasAccessDevice && (!isReservedProduct && mandatoryADNotAvailable || isReservedProduct && spotADNotAvailable && productAvailability?.length > 0)),
                children: bookingFlowContext.episerver.loggedIn ? formLang.buttons.nextStep : formLang.buttons.loginOrCreate
            }),
            stepState.form.date.date && hasAccessDevice && !pendingAccessDeviceAvailability && !pendingAvailability && !spotADAmountPending && !stepState.pending && (!isReservedProduct && mandatoryADNotAvailable && productAvailabilityCount > 0 || isReservedProduct && spotADNotAvailable && productAvailability?.length > 0) && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                className: "single-step__section access-device-error",
                children: /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                    className: "validation-error validation-error--inline",
                    children: /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                        children: formLang.accessDevice.mandatoryNotAvailable
                    })
                })
            })
        ]
    });
};
var $a78324d24ce69030$export$2e2bcd8739ae039 = $a78324d24ce69030$var$OnlineBookingLtp;



var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $g6ndF = parcelRequire("g6ndF");

var $axmXn = parcelRequire("axmXn");

var $8oRQh = parcelRequire("8oRQh");

var $8BTjt = parcelRequire("8BTjt");

var $se1IJ = parcelRequire("se1IJ");

var $iFvPA = parcelRequire("iFvPA");


var $gXJP5 = parcelRequire("gXJP5");


var $i4bvp = parcelRequire("i4bvp");

var $5kjCO = parcelRequire("5kjCO");

var $kj4aw = parcelRequire("kj4aw");

var $2sdqj = parcelRequire("2sdqj");

var $7zbft = parcelRequire("7zbft");
const $cc95b02d509bfe9c$var$ACTIONS = {
    OVERRIDE: "override-state",
    DATE: "update-date",
    TIME: "update-time",
    END_DATE: "update-end-date",
    END_TIME: "update-end-time",
    CLEAR_END_DATE_TIME: "clear-end-date-time",
    PRODUCT: "update-product",
    PRODUCT_AVAILABLE: "available-product",
    PENDING: "pending",
    PENDING_TRUE: "pending-true",
    PENDING_FALSE: "pending-false",
    PRE_PRICE: "set-prebooking-price",
    FLEX_PRICE: "set-flex-price",
    FLEX_PRICE_PENDING: "pending-price",
    FLEX_PRICE_ERROR: "error-price",
    INSURANCE_FEE: "insurance-fee"
};
const $cc95b02d509bfe9c$var$emptyGuid = "00000000-0000-0000-0000-000000000000";
const $cc95b02d509bfe9c$var$initialState = (lang)=>{
    return {
        form: {
            date: {
                date: new URLSearchParams(window.location.search).get("date"),
                dayOfWeek: -1,
                required: true,
                elementType: "date"
            },
            time: {
                text: "",
                required: false
            },
            endDate: {
                date: null,
                required: false,
                elementType: "date"
            },
            endTime: {
                text: "",
                required: false
            },
            productSelection: {
                item: {
                    Text: lang.chooseproduct,
                    Id: $cc95b02d509bfe9c$var$emptyGuid,
                    ZoneAndProduct: $cc95b02d509bfe9c$var$emptyGuid,
                    initial: true
                },
                required: true,
                elementType: "select"
            },
            numberOfParkingSpots: {
                number: 1,
                elementType: "number"
            },
            //paymentSelection: { item: { id: emptyGuid, initial: true }, elementType: 'radio' },
            insuranceFee: {
                selected: false,
                required: false,
                elementType: "checkbox"
            },
            preBookingPrice: null,
            calculatedFlexPrice: null,
            errorPrice: false,
            availableProduct: true
        },
        //data: {
        //  availableProducts: null,
        //  availableSpots: null,
        //},
        pending: false,
        pendingPrice: false
    };
};
const $cc95b02d509bfe9c$var$reducer = (state, action)=>{
    switch(action.type){
        case $cc95b02d509bfe9c$var$ACTIONS.OVERRIDE:
            return {
                ...state,
                form: {
                    ...action.payload
                }
            };
        case $cc95b02d509bfe9c$var$ACTIONS.DATE:
            return {
                ...state,
                form: {
                    ...state.form,
                    date: action.payload
                }
            };
        case $cc95b02d509bfe9c$var$ACTIONS.TIME:
            return {
                ...state,
                form: {
                    ...state.form,
                    time: action.payload
                }
            };
        case $cc95b02d509bfe9c$var$ACTIONS.END_DATE:
            return {
                ...state,
                form: {
                    ...state.form,
                    endDate: action.payload
                }
            };
        case $cc95b02d509bfe9c$var$ACTIONS.END_TIME:
            return {
                ...state,
                form: {
                    ...state.form,
                    endTime: action.payload
                }
            };
        case $cc95b02d509bfe9c$var$ACTIONS.CLEAR_END_DATE_TIME:
            return {
                ...state,
                form: {
                    ...state.form,
                    time: {
                        ...state.form.time,
                        text: ""
                    },
                    endDate: {
                        ...state.form.endDate,
                        date: null
                    },
                    endTime: {
                        ...state.form.endTime,
                        text: ""
                    },
                    calculatedFlexPrice: null
                }
            };
        case $cc95b02d509bfe9c$var$ACTIONS.PRE_PRICE:
            return {
                ...state,
                form: {
                    ...state.form,
                    preBookingPrice: {
                        text: action.payload
                    },
                    calculatedFlexPrice: null
                }
            };
        case $cc95b02d509bfe9c$var$ACTIONS.FLEX_PRICE:
            return {
                ...state,
                form: {
                    ...state.form,
                    preBookingPrice: null,
                    calculatedFlexPrice: {
                        text: action.payload
                    }
                },
                pendingPrice: false
            };
        case $cc95b02d509bfe9c$var$ACTIONS.FLEX_PRICE_PENDING:
            return {
                ...state,
                pendingPrice: action.payload
            };
        case $cc95b02d509bfe9c$var$ACTIONS.FLEX_PRICE_ERROR:
            return {
                ...state,
                form: {
                    ...state.form,
                    errorPrice: action.payload
                }
            };
        case $cc95b02d509bfe9c$var$ACTIONS.PRODUCT:
            {
                const isFlex = action.payload.item.ProcessType === "Flexbooking";
                return {
                    ...state,
                    form: {
                        ...state.form,
                        productSelection: action.payload,
                        //date: { ...state.form.date, required: !isFlex, error: null },
                        time: {
                            ...state.form.time,
                            required: isFlex,
                            error: null
                        },
                        endDate: {
                            ...state.form.endDate,
                            required: isFlex,
                            error: null
                        },
                        endTime: {
                            ...state.form.endTime,
                            required: isFlex,
                            error: null
                        }
                    }
                };
            }
        case $cc95b02d509bfe9c$var$ACTIONS.PRODUCT_AVAILABLE:
            return {
                ...state,
                form: {
                    ...state.form,
                    availableProduct: action.payload
                }
            };
        case $cc95b02d509bfe9c$var$ACTIONS.INSURANCE_FEE:
            return {
                ...state,
                form: {
                    ...state.form,
                    insuranceFee: action.payload
                }
            };
        case $cc95b02d509bfe9c$var$ACTIONS.PENDING:
            return {
                ...state,
                pending: action.payload
            };
        case $cc95b02d509bfe9c$var$ACTIONS.PENDING_TRUE:
            return {
                ...state,
                pending: true
            };
        case $cc95b02d509bfe9c$var$ACTIONS.PENDING_FALSE:
            return {
                ...state,
                pending: false
            };
        default:
            console.log("No reducer action specified.");
            return state;
    }
};
const $cc95b02d509bfe9c$var$OnlineBookingStp = ()=>{
    const { bookingFlowContext: bookingFlowContext, setBookingFlowContext: setBookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    const currentStepFormData = bookingFlowContext.availableSteps.onlineBooking.formData ?? {};
    const formLang = {
        ...bookingFlowContext.localization.global,
        ...bookingFlowContext.localization.onlineBooking,
        language: bookingFlowContext.localization.language
    };
    const [stepState, dispatch] = (0, $ca3MY.useReducer)($cc95b02d509bfe9c$var$reducer, currentStepFormData.date ? {
        ...$cc95b02d509bfe9c$var$initialState(formLang),
        form: currentStepFormData
    } : $cc95b02d509bfe9c$var$initialState(formLang));
    const prevStepState = (0, $8BTjt.usePrevious)(stepState);
    const language = bookingFlowContext.localization.language;
    const country = bookingFlowContext.country;
    const selectedLocale = country === "no" ? "nb" : country === "se" ? "sv" : country;
    const selectedLanguage = language === "no" ? "nb" : language === "se" ? "sv" : language;
    //const [productAvailability, productAvailabilityCount, pendingAvailability] = useProductAvailability(stepState.form.productSelection.item, stepState.form.date.date, bookingFlowContext);
    let isFlexBooking = !stepState.form.productSelection.item.initial ? stepState.form.productSelection.item.ProcessType === "Flexbooking" : null;
    const onlineBookingHandler = ()=>{
        let [updatedForm, formValidationError] = (0, $se1IJ.validateFormObjectAlt)(stepState.form, formLang.errorMessages);
        if (formValidationError) {
            dispatch({
                type: $cc95b02d509bfe9c$var$ACTIONS.OVERRIDE,
                payload: updatedForm
            });
            return;
        }
        let activeStep = null;
        let user = null;
        if (bookingFlowContext.episerver.loggedIn) {
            user = {
                email: bookingFlowContext.episerver.emailAddress,
                givenName: bookingFlowContext.episerver.given_name,
                familyName: bookingFlowContext.episerver.family_name
            };
            if (bookingFlowContext.episerver.hasWebticketAccount) activeStep = bookingFlowContext.availableSteps.addVehicle.index;
            else activeStep = bookingFlowContext.availableSteps.createAccount.index;
        } else activeStep = bookingFlowContext.availableSteps.login.index;
        setBookingFlowContext({
            ...bookingFlowContext,
            user: user,
            activeStep: activeStep,
            availableSteps: {
                ...bookingFlowContext.availableSteps,
                onlineBooking: {
                    ...bookingFlowContext.availableSteps.onlineBooking,
                    formData: {
                        ...updatedForm
                    }
                },
                addVehicle: {
                    ...bookingFlowContext.availableSteps.addVehicle,
                    formData: bookingFlowContext.availableSteps.onlineBooking.formData?.productSelection.item.Type === stepState.form.productSelection.item.Type ? bookingFlowContext.availableSteps.addVehicle.formData : null
                }
            }
        });
    };
    (0, $ca3MY.useEffect)(()=>{
        let subscribe = true;
        let isFlexBooking = !stepState.form.productSelection.item.initial ? stepState.form.productSelection.item.ProcessType === "Flexbooking" : null;
        if (!stepState.form.date.date || stepState.form.productSelection.item.initial) return;
        if (!stepState.form.productSelection.item.CancellationInsuranceFee) dispatch({
            type: $cc95b02d509bfe9c$var$ACTIONS.INSURANCE_FEE,
            payload: false
        });
        if (!isFlexBooking) {
            dispatch({
                type: $cc95b02d509bfe9c$var$ACTIONS.PRODUCT_AVAILABLE,
                payload: true
            });
            const getAvailability = async ()=>{
                const data = {
                    bookingController: bookingFlowContext.episerver.bookingController,
                    pmcId: stepState.form.productSelection.item.Id,
                    startDate: stepState.form.date.date
                };
                const productAvailability = await (0, $axmXn.products).getAvailability(data, bookingFlowContext.useMockedData);
                const availableSpotsCount = productAvailability.status === 200 ? productAvailability.body.Availability ?? 0 : 0;
                if (availableSpotsCount === 0) {
                    dispatch({
                        type: $cc95b02d509bfe9c$var$ACTIONS.PRODUCT_AVAILABLE,
                        payload: false
                    });
                    dispatch({
                        type: $cc95b02d509bfe9c$var$ACTIONS.PRE_PRICE,
                        payload: null
                    });
                    return;
                }
                //Check Prebooking price from "WeekdayPrices"
                if (stepState.form.date.dayOfWeek > -1 && stepState.form.productSelection.item.WeekdayPrices) dispatch({
                    type: $cc95b02d509bfe9c$var$ACTIONS.PRE_PRICE,
                    payload: stepState.form.productSelection.item.WeekdayPrices[stepState.form.date.dayOfWeek]
                });
                else dispatch({
                    type: $cc95b02d509bfe9c$var$ACTIONS.PRE_PRICE,
                    payload: null
                });
            };
            getAvailability();
            return;
        }
        if (!stepState.form.time.text || !stepState.form.endDate.date || !stepState.form.endTime.text) return;
        if (stepState.form.date.date == stepState.form.endDate.date && parseFloat(stepState.form.endTime.text.replace(":", ".")) <= parseFloat(stepState.form.time.text.replace(":", "."))) {
            console.log(`End time (${stepState.form.endTime.text}) should be AFTER start time (${stepState.form.time.text}).`);
            return;
        }
        const getPrice = async ()=>{
            dispatch({
                type: $cc95b02d509bfe9c$var$ACTIONS.FLEX_PRICE_PENDING,
                payload: true
            });
            dispatch({
                type: $cc95b02d509bfe9c$var$ACTIONS.PRODUCT_AVAILABLE,
                payload: true
            });
            const startDate = `${stepState.form.date.date} ${stepState.form.time.text}`;
            const endDate = `${stepState.form.endDate.date} ${stepState.form.endTime.text}`;
            const data = {
                bookingController: bookingFlowContext.episerver.bookingController,
                pmcId: stepState.form.productSelection.item.Id,
                startDate: startDate,
                endDate: endDate
            };
            const productAvailability = await (0, $axmXn.products).getAvailability(data, bookingFlowContext.useMockedData);
            const availableSpotsCount = productAvailability.status === 200 ? productAvailability.body.Availability ?? 0 : 0;
            if (availableSpotsCount === 0) {
                dispatch({
                    type: $cc95b02d509bfe9c$var$ACTIONS.PRODUCT_AVAILABLE,
                    payload: false
                });
                dispatch({
                    type: $cc95b02d509bfe9c$var$ACTIONS.FLEX_PRICE_PENDING,
                    payload: false
                });
                dispatch({
                    type: $cc95b02d509bfe9c$var$ACTIONS.FLEX_PRICE,
                    payload: null
                });
                return;
            }
            const flexBookingPrice = await (0, $axmXn.products).getFlexbookingPrice(data, bookingFlowContext.useMockedData, formLang.language);
            if (subscribe && flexBookingPrice.status === 200) {
                dispatch({
                    type: $cc95b02d509bfe9c$var$ACTIONS.PRODUCT_AVAILABLE,
                    payload: true
                });
                dispatch({
                    type: $cc95b02d509bfe9c$var$ACTIONS.FLEX_PRICE,
                    payload: flexBookingPrice.body.Price
                });
            } else if (subscribe) {
                dispatch({
                    type: $cc95b02d509bfe9c$var$ACTIONS.PRODUCT_AVAILABLE,
                    payload: false
                });
                dispatch({
                    type: $cc95b02d509bfe9c$var$ACTIONS.FLEX_PRICE_ERROR,
                    payload: true
                });
            }
            dispatch({
                type: $cc95b02d509bfe9c$var$ACTIONS.FLEX_PRICE_PENDING,
                payload: false
            });
        };
        getPrice();
        return ()=>subscribe = false;
    }, [
        stepState.form.date,
        stepState.form.time,
        stepState.form.endDate,
        stepState.form.endTime,
        stepState.form.productSelection
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (!stepState || !prevStepState) return;
        dispatch({
            type: $cc95b02d509bfe9c$var$ACTIONS.PRODUCT_AVAILABLE,
            payload: true
        });
        let isFlexBooking = !stepState.form.productSelection.item.initial ? stepState.form.productSelection.item.ProcessType === "Flexbooking" : null;
        let wasFlexBooking = !prevStepState.form.productSelection.item.initial ? prevStepState.form.productSelection.item.ProcessType === "Flexbooking" : null;
        if (!isFlexBooking && wasFlexBooking) dispatch({
            type: $cc95b02d509bfe9c$var$ACTIONS.CLEAR_END_DATE_TIME
        });
    }, [
        stepState.form.productSelection
    ]);
    const flexStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))().add(0, "days").toDate();
    return /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $ef5b0e978e82ebfa$export$86677682429ed406), {
                bookingFlowContext: bookingFlowContext,
                formLang: formLang,
                pending: stepState.pending,
                date: stepState.form.date,
                productSelection: stepState.form.productSelection,
                setPending: (value)=>dispatch({
                        type: $cc95b02d509bfe9c$var$ACTIONS.PENDING,
                        payload: value
                    }),
                setDate: (value)=>dispatch({
                        type: $cc95b02d509bfe9c$var$ACTIONS.DATE,
                        payload: value
                    }),
                setProductSelection: (value)=>dispatch({
                        type: $cc95b02d509bfe9c$var$ACTIONS.PRODUCT,
                        payload: value
                    }),
                dateDisabled: !stepState.form.productSelection.item.initial && isFlexBooking,
                startDate: flexStartDate
            }),
            !isFlexBooking && stepState.form.date.dayOfWeek > -1 && !stepState.form.productSelection.item.initial && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                children: [
                    stepState.form.preBookingPrice && stepState.form.preBookingPrice.text && /*#__PURE__*/ (0, $54dlf.jsxs)("p", {
                        className: "flex-price",
                        children: [
                            "Your price: ",
                            /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                                children: [
                                    stepState.form.preBookingPrice.text,
                                    " ",
                                    stepState.form.productSelection.item.Currency
                                ]
                            })
                        ]
                    }),
                    stepState.form.preBookingPrice && !stepState.form.preBookingPrice.text && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXJP5.Error), {
                                text: formLang.availableparkingspotsinfonone
                            })
                        ]
                    })
                ]
            }),
            isFlexBooking && !stepState.form.productSelection.item.initial && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
                    /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                        children: formLang.flexheading
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                                children: [
                                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $i4bvp.DateSelectionWithLabel), {
                                        extraClass: "startdate",
                                        text: formLang.flexstartdate,
                                        extraText: " " + formLang.flexandtime,
                                        value: stepState.form.date,
                                        setValue: (value)=>dispatch({
                                                type: $cc95b02d509bfe9c$var$ACTIONS.DATE,
                                                payload: value
                                            }),
                                        placeholder: formLang.selectdate,
                                        locale: selectedLocale,
                                        language: selectedLanguage,
                                        selectedDays: [
                                            stepState.form.date.date && new Date((0, $iFvPA.parseDate)(stepState.form.date.date)),
                                            {
                                                from: stepState.form.date.date && new Date((0, $iFvPA.parseDate)(stepState.form.date.date)),
                                                to: stepState.form.endDate.date && new Date((0, $iFvPA.parseDate)(stepState.form.endDate.date))
                                            }
                                        ],
                                        disabledDays: stepState.form.endDate.date && {
                                            before: flexStartDate,
                                            after: new Date((0, $iFvPA.parseDate)(stepState.form.endDate.date))
                                        },
                                        month: stepState.form.date.date ? new Date((0, $iFvPA.parseDate)(stepState.form.date.date)) : flexStartDate,
                                        fromMonth: flexStartDate,
                                        startDate: flexStartDate
                                    }),
                                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                                        inputType: "time",
                                        text: formLang.flexstarttime,
                                        value: stepState.form.time,
                                        setValue: (value)=>dispatch({
                                                type: $cc95b02d509bfe9c$var$ACTIONS.TIME,
                                                payload: value
                                            }),
                                        debounce: 750
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                                children: [
                                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $i4bvp.DateSelectionWithLabel), {
                                        extraClass: "enddate",
                                        text: formLang.flexenddate,
                                        extraText: " " + formLang.flexandtime,
                                        value: stepState.form.endDate,
                                        setValue: (value)=>dispatch({
                                                type: $cc95b02d509bfe9c$var$ACTIONS.END_DATE,
                                                payload: value
                                            }),
                                        placeholder: formLang.selectdate,
                                        locale: selectedLocale,
                                        language: selectedLanguage,
                                        selectedDays: [
                                            stepState.form.date.date && new Date((0, $iFvPA.parseDate)(stepState.form.date.date)),
                                            {
                                                from: stepState.form.date.date && new Date((0, $iFvPA.parseDate)(stepState.form.date.date)),
                                                to: stepState.form.endDate.date && new Date((0, $iFvPA.parseDate)(stepState.form.endDate.date))
                                            }
                                        ],
                                        disabledDays: {
                                            before: stepState.form.date.date ? new Date((0, $iFvPA.parseDate)(stepState.form.date.date)) : flexStartDate
                                        },
                                        month: stepState.form.date.date && new Date((0, $iFvPA.parseDate)(stepState.form.date.date)),
                                        fromMonth: stepState.form.date.date && new Date((0, $iFvPA.parseDate)(stepState.form.date.date)),
                                        startDate: flexStartDate
                                    }),
                                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                                        inputType: "time",
                                        text: formLang.flexendtime,
                                        value: stepState.form.endTime,
                                        setValue: (value)=>dispatch({
                                                type: $cc95b02d509bfe9c$var$ACTIONS.END_TIME,
                                                payload: value
                                            }),
                                        debounce: 750
                                    })
                                ]
                            })
                        ]
                    }),
                    (stepState.pendingPrice || stepState.form.calculatedFlexPrice) && stepState.form.availableProduct && /*#__PURE__*/ (0, $54dlf.jsxs)("p", {
                        className: "flex-price",
                        children: [
                            "Your price: ",
                            stepState.pendingPrice ? /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                className: "loading",
                                children: /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                                    className: "aimo-spinner",
                                    children: [
                                        /*#__PURE__*/ (0, $54dlf.jsx)("span", {}),
                                        /*#__PURE__*/ (0, $54dlf.jsx)("span", {}),
                                        /*#__PURE__*/ (0, $54dlf.jsx)("span", {}),
                                        /*#__PURE__*/ (0, $54dlf.jsx)("span", {})
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                children: stepState.form.calculatedFlexPrice.text
                            })
                        ]
                    }),
                    isFlexBooking && !stepState.form.availableProduct && /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXJP5.Error), {
                        text: formLang.availableparkingspotsinfonone
                    })
                ]
            }),
            !stepState.form.productSelection.item.initial && stepState.form.productSelection.item.CancellationInsuranceFee && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $72618502e1458656$export$a2ec690cee38f777), {
                        heading: formLang.otheroptionsheading,
                        text: formLang.insurancefeetext,
                        children: /*#__PURE__*/ (0, $54dlf.jsx)((0, $7zbft.CheckboxWithLabel), {
                            text: `${stepState.form.productSelection.item.CancellationInsuranceFee.Heading}: ${stepState.form.productSelection.item.CancellationInsuranceFee.Price.replace(".", ",")} ${stepState.form.productSelection.item.Currency}`,
                            value: stepState.form.insuranceFee,
                            setValue: (value)=>dispatch({
                                    type: $cc95b02d509bfe9c$var$ACTIONS.INSURANCE_FEE,
                                    payload: value
                                })
                        })
                    })
                ]
            }),
            stepState.form.productSelection.item.ExtraFee && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $72618502e1458656$export$a2ec690cee38f777), {
                        heading: stepState.form.productSelection.item.ExtraFee.Heading,
                        text: stepState.form.productSelection.item.ExtraFee.Text
                    })
                ]
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                className: "single-step__button single-step__button--next",
                onClick: onlineBookingHandler,
                disabled: stepState.form.productSelection.item.initial || !isFlexBooking && (!stepState.form.preBookingPrice || !stepState.form.preBookingPrice.text) || isFlexBooking && (stepState.pendingPrice || !stepState.form.calculatedFlexPrice),
                children: formLang.buttons.nextStep
            })
        ]
    });
};
var $cc95b02d509bfe9c$export$2e2bcd8739ae039 = $cc95b02d509bfe9c$var$OnlineBookingStp;



var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $8oRQh = parcelRequire("8oRQh");

var $axmXn = parcelRequire("axmXn");
const $065e8015ec5a6244$export$3dcd3668af12f823 = ()=>{
    const { bookingFlowContext: bookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    const nearbyFacilities = bookingFlowContext.facility.nearbyFacilities;
    const [itemsToShow, setItemsToShow] = (0, $ca3MY.useState)(nearbyFacilities?.length > 5 ? 5 : nearbyFacilities?.length);
    const currentFacility = bookingFlowContext.facility;
    const formLang = bookingFlowContext.localization.onlineBooking;
    const selectedLang = document.querySelector("html").getAttribute("lang");
    const selectedLocale = selectedLang === "no" ? "nb" : selectedLang === "se" ? "sv" : selectedLang;
    const [checkedFacilities, setCheckedFacilities] = (0, $ca3MY.useState)([]);
    (0, $ca3MY.useEffect)(()=>{
        if (!nearbyFacilities?.length) return;
        let isSubscribed = true;
        let hasAvailableSpot = null;
        let hasLowAvailability = null;
        let hasPromotion = false;
        const facilities = [];
        const checkDetails = async (uid)=>{
            const allProducts = await (0, $axmXn.products).getProducts({
                bookingController: bookingFlowContext.episerver.bookingController,
                fId: uid,
                lang: selectedLocale,
                includeNotBookableOnline: true
            });
            if (allProducts.status === 200 && allProducts.body.Places.length > 0) {
                const listOfProducts = allProducts.body.Places.map((zone)=>zone.Item2).flat();
                const isBookableOnline = listOfProducts.some((product)=>!product.OnlineBookingNotAllowed);
                hasPromotion = listOfProducts.some((product)=>Array.isArray(product.Promotions) && product.Promotions.length > 0);
                if (!bookingFlowContext.episerver.hideAvailability && isBookableOnline) {
                    hasAvailableSpot = formLang.availability && listOfProducts.some((product)=>!product.OnlineBookingNotAllowed && product.Availability && product.Availability > 0);
                    hasLowAvailability = formLang.availability && !listOfProducts.some((product)=>!product.OnlineBookingNotAllowed && product.Availability && product.Availability > 4);
                }
            }
            return {
                uid: uid,
                hasPromotion: hasPromotion,
                hasAvailableSpot: hasAvailableSpot,
                hasLowAvailability: hasLowAvailability
            };
        };
        nearbyFacilities.slice(0, itemsToShow).forEach((facility)=>{
            if (checkedFacilities.find((f)=>f.uid === facility.Uid)) return;
            const icons = checkDetails(facility.Uid);
            facilities.push(icons);
        });
        Promise.all(facilities).then((icons)=>{
            if (!isSubscribed) return;
            setCheckedFacilities([
                ...checkedFacilities,
                ...icons
            ]);
        });
        return ()=>isSubscribed = false;
    }, [
        itemsToShow
    ]);
    return nearbyFacilities?.length ? /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: "bookingflowpage__nearby-facilities",
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                children: `${formLang.nearbyfacilities} ${currentFacility.name}`
            }),
            /*#__PURE__*/ (0, $54dlf.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                children: formLang.address
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                children: `${formLang.distanceto} ${currentFacility.name}`
                            })
                        ]
                    }),
                    nearbyFacilities.slice(0, itemsToShow).map((facility)=>/*#__PURE__*/ (0, $54dlf.jsx)($065e8015ec5a6244$var$ListItem, {
                            formLang: bookingFlowContext?.localization?.onlineBooking,
                            distance: facility.Address.Distance,
                            url: facility.Url,
                            name: facility.Name,
                            address: facility.Address,
                            icons: checkedFacilities.length ? checkedFacilities.find((f)=>f.uid === facility.Uid) : null,
                            selectedLocale: selectedLocale
                        }, facility.Uid + itemsToShow))
                ]
            }),
            nearbyFacilities.length > 5 && nearbyFacilities.length !== itemsToShow && /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                onClick: ()=>setItemsToShow(itemsToShow + (nearbyFacilities.length - itemsToShow < 5 ? nearbyFacilities.length - itemsToShow : 5)),
                className: "bookingflowpage__nearby-facilities__cta",
                children: /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                    children: formLang.showmore
                })
            })
        ]
    }) : null;
};
const $065e8015ec5a6244$var$ListItem = ({ formLang: formLang, distance: distance, url: url, name: name, address: address, selectedLocale: selectedLocale, icons: icons })=>{
    const currentDistance = distance > 1 ? distance.toFixed(2) : Math.round(distance * 1000);
    const currentDistanceText = distance > 1 ? "km" : "m";
    const hasPromotion = icons?.hasPromotion;
    const hasAvailableSpot = icons?.hasAvailableSpot;
    const hasLowAvailability = icons?.hasLowAvailability;
    const facilityAddress = address.Number ? `${address.Street} ${address.Number}` : address.Street;
    const facilityName = name === facilityAddress ? facilityAddress : name;
    return /*#__PURE__*/ (0, $54dlf.jsxs)("li", {
        children: [
            hasPromotion ? /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                className: "left--promo",
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                        className: "left",
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)("a", {
                                href: url,
                                onClick: (e)=>{
                                    if (!url) e.preventDefault();
                                },
                                children: facilityName
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                className: "left--availablespot",
                                "data-low": hasLowAvailability,
                                children: [
                                    facilityAddress,
                                    hasAvailableSpot && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                                        children: hasLowAvailability ? formLang.lowavailability : formLang.availability
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("img", {
                        src: `/publicResources/icons/promo/${selectedLocale}/Promotion2_${selectedLocale}.svg`,
                        alt: "promotion icon"
                    })
                ]
            }) : /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                className: "left",
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)("a", {
                        href: url,
                        onClick: (e)=>{
                            if (!url) e.preventDefault();
                        },
                        children: facilityName
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                        className: "left--availablespot",
                        "data-low": hasLowAvailability,
                        children: [
                            facilityAddress,
                            hasAvailableSpot && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                                children: hasLowAvailability ? formLang.lowavailability : formLang.availability
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                className: "right",
                children: /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                    children: [
                        currentDistance,
                        " ",
                        currentDistanceText
                    ]
                })
            })
        ]
    });
};


const $59fb50fb2c8e26e9$export$92a1a3b7554e9387 = {
    OVERRIDE: "override-state",
    DATE: "update-date",
    PRODUCT: "update-product",
    PAYMENT: "update-payment",
    SPOT_COUNT: "update-spotcount",
    SPOT_COUNT_INCREMENT: "update-spotcount-increment",
    SPOT_SELECTION: "update-spotselection",
    SPOT_SELECTION_INCREMENT: "update-spotselection-inrcement",
    PENDING: "pending",
    PENDING_TRUE: "pending-true",
    PENDING_FALSE: "pending-false",
    ACCESS_DEVICES: "access-devices",
    ACCESS_DEVICES_OPTIONAL: "access-devices-optional"
};
const $59fb50fb2c8e26e9$var$OnlineBooking = ()=>{
    const { bookingFlowContext: bookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    const formLang = bookingFlowContext.localization.onlineBooking;
    (0, $ca3MY.useEffect)(()=>{
        history.replaceState({
            activeStep: 0
        }, document.title);
    }, []);
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: "bookingflowpage__app bookingflowpage__app--onlinebooking",
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $leuhm.Heading), {}),
            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                className: "single-step single-step--booking",
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)("h2", {
                        children: formLang.heading
                    }),
                    bookingFlowContext.episerver.productType === 1 && /*#__PURE__*/ (0, $54dlf.jsx)((0, $a78324d24ce69030$export$2e2bcd8739ae039), {}),
                    bookingFlowContext.episerver.productType === 2 && /*#__PURE__*/ (0, $54dlf.jsx)((0, $cc95b02d509bfe9c$export$2e2bcd8739ae039), {})
                ]
            }),
            bookingFlowContext.facility.nearbyFacilities?.length > 0 && /*#__PURE__*/ (0, $54dlf.jsx)((0, $065e8015ec5a6244$export$3dcd3668af12f823), {})
        ]
    });
};
var $59fb50fb2c8e26e9$export$2e2bcd8739ae039 = $59fb50fb2c8e26e9$var$OnlineBooking;



var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $8oRQh = parcelRequire("8oRQh");

var $leuhm = parcelRequire("leuhm");

var $6bYiZ = parcelRequire("6bYiZ");

var $bJXZr = parcelRequire("bJXZr");

var $5kjCO = parcelRequire("5kjCO");
const $9bc0899bf9a0bd1d$var$Login = ()=>{
    const { bookingFlowContext: bookingFlowContext, setBookingFlowContext: setBookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    const selectedProductType = bookingFlowContext.availableSteps.onlineBooking.formData.productSelection.item.Type;
    const lang = bookingFlowContext.localization.login;
    let urlParams = new URLSearchParams(window.location.search);
    urlParams = urlParams.toString().length > 0 ? "?" + urlParams.toString() + "&" : "?";
    const loginHandler = ()=>{
        window.location.href = bookingFlowContext.episerver.loginUrl + encodeURIComponent(urlParams + "l=lgn") + "&lang=" + bookingFlowContext.localization.language;
    };
    const createAccountHandler = ()=>{
        window.location.href = bookingFlowContext.episerver.loginUrl + encodeURIComponent(urlParams + "l=usr") + "&signUp=true&lang=" + bookingFlowContext.localization.language;
    };
    const createGuestAccountHandler = ()=>{
        window.location.href = bookingFlowContext.episerver.loginUrl + encodeURIComponent(urlParams + "l = gst") + " & signUp=true & lang=" + bookingFlowContext.localization.language;
    };
    (0, $ca3MY.useEffect)(()=>{
        const loggedIn = bookingFlowContext.episerver.loggedIn;
        const switchAccountUrl = bookingFlowContext.episerver.switchAccountUrl;
        const activeProfile = !!bookingFlowContext.episerver.activeProfile;
        const hasMoreThanOneProfile = bookingFlowContext.episerver.hasMoreThanOneProfile;
        const urlParams = new URLSearchParams(window.location.search);
        const loginType = urlParams.get("L") ?? urlParams.get("l");
        history.replaceState({
            activeStep: 0
        }, document.title);
        if ((!loggedIn || !loginType) && !hasMoreThanOneProfile) return;
        if (loggedIn && hasMoreThanOneProfile && !activeProfile) {
            window.location.href = switchAccountUrl;
            return;
        }
        if (bookingFlowContext.episerver.hasWebticketAccount && !(0, $bJXZr.shouldAccountBeUpdated)(bookingFlowContext) && (!hasMoreThanOneProfile || activeProfile)) {
            // If permit Usage type is SKIDATA, jump over 'Add vehicle' step (CPS-24723) 
            const isSkidata = bookingFlowContext?.availableSteps?.onlineBooking?.formData?.productSelection?.item?.PermitUsageType?.toLowerCase() === "skidata";
            let newActiveStep = bookingFlowContext.availableSteps.addVehicle.index;
            if (isSkidata) newActiveStep = (0, $6bYiZ.ReturnStepAfterVehicleStage)(bookingFlowContext);
            setBookingFlowContext({
                ...bookingFlowContext,
                activeStep: newActiveStep,
                user: {
                    email: bookingFlowContext.episerver.emailAddress,
                    givenName: bookingFlowContext.episerver.given_name,
                    familyName: bookingFlowContext.episerver.family_name
                }
            });
        } else if (loginType === "gst") setBookingFlowContext({
            ...bookingFlowContext,
            activeStep: bookingFlowContext.availableSteps.createAccount.index,
            guest: true
        });
        else setBookingFlowContext({
            ...bookingFlowContext,
            activeStep: bookingFlowContext.availableSteps.onlineBooking.index,
            guest: false
        });
    }, [
        bookingFlowContext.episerver.activeProfile
    ]);
    //useEffect(() => setBookingflowStep(bookingFlowContext.availableSteps.login.index), [])
    const activeProfile = bookingFlowContext.episerver.activeProfile || false;
    if (bookingFlowContext.episerver.loggedIn && bookingFlowContext.episerver.hasMoreThanOneProfile && !activeProfile) return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
        className: "bookingflowpage__loader",
        children: /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
            className: "aimo-spinner",
            children: [
                /*#__PURE__*/ (0, $54dlf.jsx)("span", {}),
                /*#__PURE__*/ (0, $54dlf.jsx)("span", {}),
                /*#__PURE__*/ (0, $54dlf.jsx)("span", {}),
                /*#__PURE__*/ (0, $54dlf.jsx)("span", {})
            ]
        })
    });
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: "bookingflowpage__app bookingflowpage__app--login",
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $6bYiZ.BackNavigation), {}),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $leuhm.Heading), {}),
            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                className: "single-step single-step--login",
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)("h2", {
                        children: lang.heading
                    }),
                    lang.loginPreamble && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                        className: "margin center",
                        children: lang.loginPreamble
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                        className: bookingFlowContext.episerver.productType === 2 ? "single-step__login-wrapper single-step__login-wrapper--margin" : "single-step__login-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                                className: "single-step__button single-step__button--proceed",
                                onClick: loginHandler,
                                children: lang.buttons.proceed
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {
                                text: lang.divider
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                                className: "single-step__button single-step__button--createaccount",
                                onClick: createAccountHandler,
                                children: lang.buttons.createAccount
                            })
                        ]
                    }),
                    bookingFlowContext.episerver.productType === 2 && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $ca3MY.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
                            /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                                className: "nomargin",
                                children: lang.guest.heading
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                                className: "margin center",
                                children: lang.guest.text
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                                className: "single-step__button single-step__button--blue single-step__button--createguestaccount",
                                onClick: createGuestAccountHandler,
                                children: lang.buttons.guestAccount
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $9bc0899bf9a0bd1d$export$2e2bcd8739ae039 = $9bc0899bf9a0bd1d$var$Login;



var $dlTon = parcelRequire("dlTon");

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $8oRQh = parcelRequire("8oRQh");

var $axmXn = parcelRequire("axmXn");

var $se1IJ = parcelRequire("se1IJ");

var $leuhm = parcelRequire("leuhm");

var $6bYiZ = parcelRequire("6bYiZ");

var $jl9cc = parcelRequire("jl9cc");

var $5kjCO = parcelRequire("5kjCO");

var $2sdqj = parcelRequire("2sdqj");

var $kj4aw = parcelRequire("kj4aw");

var $gXzQg = parcelRequire("gXzQg");
const $01596d8bca3ec658$var$Vehicle = ()=>{
    const currentCountry = document.querySelector("html").getAttribute("country");
    const { bookingFlowContext: bookingFlowContext, setBookingFlowContext: setBookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    const formLang = {
        ...bookingFlowContext.episerver,
        ...bookingFlowContext.localization.global,
        ...bookingFlowContext.localization.createAccount,
        ...bookingFlowContext.localization.addVehicle
    };
    const defaultCountryCode = currentCountry === "no" ? "N" : currentCountry === "se" ? "S" : "FIN";
    const defaultCountryCodes = [
        {
            Id: "S",
            Name: "S"
        },
        {
            Id: "FIN",
            Name: "FIN"
        },
        {
            Id: "N",
            Name: "N"
        },
        {
            Id: "DK",
            Name: "DK"
        }
    ];
    const countryCodeOptions = [
        ...defaultCountryCodes.filter((cc)=>cc.Id === defaultCountryCode),
        ...defaultCountryCodes.filter((cc)=>cc.Id !== defaultCountryCode)
    ];
    for (const [value] of Object.entries(formLang.licensePlateCountryCodeOptions))if (value !== "FIN" && value !== "N" && value !== "S" && value !== "N" && value !== "DK") countryCodeOptions.push({
        Id: value,
        Name: value
    });
    const isReservedProduct = bookingFlowContext.availableSteps.onlineBooking.formData.productSelection.item.Type === "RESERVED";
    const maxLicensePlatesPerQuantity = bookingFlowContext.availableSteps.onlineBooking.formData.productSelection.item.MaxLicensePlatesPerQuantity ?? 0;
    const pooling = !!maxLicensePlatesPerQuantity > 0;
    const existingVehicleList = bookingFlowContext.availableSteps.addVehicle.formData ?? [];
    const selectedLang = document.querySelector("html").getAttribute("lang");
    const [validationErrors, setValidationErrors] = (0, $ca3MY.useState)([]);
    const selectedSpotAmount = bookingFlowContext.availableSteps.onlineBooking.formData.numberOfParkingSpots.number;
    const [pending, setPending] = (0, $ca3MY.useState)(true);
    const [vehicleList, setVehicleList] = (0, $ca3MY.useState)(existingVehicleList);
    const [userVehicleList, setUserVehicleList] = (0, $ca3MY.useState)([]);
    const [getVehicleListDone, setGetVehicleListDone] = (0, $ca3MY.useState)(false);
    //const CountryCode = bookingFlowContext.country === 'se' ? 'S' : bookingFlowContext.country === 'fi' ? 'FIN' : 'N';
    const onChangeRegistrationNumberHandler = (index, value)=>{
        const newVehicleList = vehicleList.map((listItem)=>{
            if (listItem.index === index) return {
                ...listItem,
                PlateText: value ? value.toUpperCase().split(" ").join("") : value,
                error: null
            };
            return listItem;
        });
        setVehicleList(newVehicleList);
    };
    const onChangeCountryCodeHandler = (index, value)=>{
        const newVehicleList = vehicleList.map((listItem)=>{
            if (listItem.index === index) return {
                ...listItem,
                CountryCode: value,
                error: null
            };
            return listItem;
        });
        setVehicleList(newVehicleList);
    };
    const onChangeDescriptionTextHandler = (index, value)=>{
        const newVehicleList = vehicleList.map((listItem)=>{
            if (listItem.index === index) return {
                ...listItem,
                Description: value ?? listItem.Description
            };
            return listItem;
        });
        setVehicleList(newVehicleList);
    };
    const onChangeSelectionHandler = (index, PlateText, CountryCode, Description)=>{
        const newVehicleList = vehicleList.map((listItem)=>{
            if (listItem.index === index) //return { ...listItem, registrationNumber: id, descriptionText: value };
            return {
                ...listItem,
                PlateText: PlateText,
                CountryCode: CountryCode,
                Description: Description
            };
            return listItem;
        });
        setVehicleList(newVehicleList);
    };
    const addNewVehicleHandler = ()=>{
        //setVehicleList([...vehicleList, { index: generateGuid(), registrationNumber: '', descriptionText: '' }])
        setVehicleList([
            ...vehicleList,
            {
                index: generateGuid(),
                PlateText: "",
                CountryCode: defaultCountryCode
            }
        ]);
    };
    const addVehicleHandler = async ()=>{
        if (vehicleList.length === 0) return;
        if (vehicleList.length > 0) {
            let validationError = null;
            setValidationErrors([]);
            const validatedVehicleList = vehicleList.map((vehicle)=>{
                const lp = {
                    licensePlate: {
                        value: {
                            text: vehicle.PlateText,
                            elementType: "licenseplate",
                            multiple: true,
                            error: null,
                            countryCode: vehicle.CountryCode
                        }
                    }
                };
                let [formValidationError, cleanFormData] = (0, $se1IJ.validateFormObject)(lp, formLang.errorMessages, bookingFlowContext.country);
                setValidationErrors((validationErrors)=>[
                        ...validationErrors,
                        formValidationError
                    ]);
                vehicle.error = cleanFormData.licensePlate.error;
                if (formValidationError) validationError = true;
                return vehicle;
            });
            setVehicleList(validatedVehicleList);
            if (validationError) {
                setTimeout(()=>{
                    const firstInvalidElement = document.querySelector("[aria-invalid]").closest("label");
                    if (firstInvalidElement) firstInvalidElement.scrollIntoView({
                        behavior: "smooth"
                    });
                }, 500);
                return;
            }
            setPending(true);
            for (const vehicle of validatedVehicleList)if (!userVehicleList.some((userVehicle)=>userVehicle.Id === vehicle.PlateText)) {
                const createVehicleResponse = await (0, $axmXn.vehicles).createCustomerVehicle({
                    bookingController: bookingFlowContext.episerver.bookingController,
                    form: {
                        name: vehicle.Description,
                        licensePlate: {
                            plateText: vehicle.PlateText,
                            countryCode: vehicle.CountryCode
                        }
                    }
                }, false, selectedLang);
                if (createVehicleResponse.status === 200) ;
                else console.error(createVehicleResponse.errorMessage);
            }
            setPending(false);
        }
        setBookingFlowContext({
            ...bookingFlowContext,
            activeStep: (0, $6bYiZ.ReturnStepAfterVehicleStage)(bookingFlowContext),
            availableSteps: {
                ...bookingFlowContext.availableSteps,
                addVehicle: {
                    ...bookingFlowContext.availableSteps.addVehicle,
                    formData: vehicleList
                }
            }
        });
    };
    const removeVehicleListItemHandler = (indexToRemove)=>{
        const newArr = [
            ...vehicleList
        ];
        newArr.splice(indexToRemove, 1);
        setVehicleList(newArr);
    };
    const generateGuid = ()=>{
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    };
    (0, $ca3MY.useEffect)(()=>{
        setPending(bookingFlowContext.availableSteps.onlineBooking.order && getVehicleListDone ? false : true);
    }, [
        bookingFlowContext.availableSteps.onlineBooking.order
    ]);
    (0, $ca3MY.useEffect)(()=>{
        let isSubscribed = true;
        if (vehicleList.length === 0) {
            const blankPlaceholderList = [];
            if (isReservedProduct) //blankPlaceholderList.push({ index: generateGuid(), registrationNumber: '', descriptionText: '' })
            blankPlaceholderList.push({
                index: generateGuid(),
                PlateText: "",
                CountryCode: defaultCountryCode,
                Description: ""
            });
            else for(let i = 0; i < selectedSpotAmount; i++)//blankPlaceholderList.push({ index: generateGuid(), registrationNumber: '', descriptionText: '' })
            blankPlaceholderList.push({
                index: generateGuid(),
                PlateText: "",
                CountryCode: defaultCountryCode,
                Description: ""
            });
            setVehicleList(blankPlaceholderList);
        } else if (!isReservedProduct && vehicleList.length !== selectedSpotAmount) {
            const updatedPlaceholderList = vehicleList;
            if (vehicleList.length > selectedSpotAmount) {
                const newArrayLength = vehicleList.length - selectedSpotAmount;
                updatedPlaceholderList.splice(-newArrayLength, newArrayLength);
            } else if (vehicleList.length < selectedSpotAmount) for(let i = vehicleList.length; i < selectedSpotAmount; i++)//updatedPlaceholderList.push({ index: generateGuid(), registrationNumber: '', descriptionText: '' })
            updatedPlaceholderList.push({
                index: generateGuid(),
                PlateText: "",
                CountryCode: defaultCountryCode,
                Description: ""
            });
            setVehicleList(updatedPlaceholderList);
        }
        const getUserVehicleList = async ()=>{
            setPending(true);
            const allUserVehicles = await (0, $axmXn.vehicles).getCustomerVehicles({
                bookingController: bookingFlowContext.episerver.bookingController
            }, bookingFlowContext.useMockedData, selectedLang);
            setGetVehicleListDone(true);
            //console.log(bookingFlowContext.availableSteps.onlineBooking)
            if (allUserVehicles.status === 200 && isSubscribed && allUserVehicles.body !== null && allUserVehicles.body.length > 0) {
                if (bookingFlowContext.availableSteps.onlineBooking.order) setPending(false);
                const userVehiclesPlusCreateOption = [];
                for(let i = 0; i < allUserVehicles.body.length; i++){
                    const singleVehicle = allUserVehicles.body[i];
                    userVehiclesPlusCreateOption.push({
                        Id: singleVehicle.LicensePlate.PlateText,
                        Description: singleVehicle.Description ?? "",
                        Text: singleVehicle.Description ? `${singleVehicle.LicensePlate.PlateText} (${singleVehicle.Description})` : singleVehicle.LicensePlate.PlateText,
                        CountryCode: singleVehicle.LicensePlate.CountryCode
                    });
                }
                userVehiclesPlusCreateOption.push({
                    Text: bookingFlowContext.localization.addVehicle.buttons.addNewVehicle,
                    Id: "NEW"
                });
                setUserVehicleList(userVehiclesPlusCreateOption);
            } else if (isSubscribed) {
                if (bookingFlowContext.availableSteps.onlineBooking.order) setPending(false);
            }
        };
        if (userVehicleList.length === 0) getUserVehicleList();
        return ()=>isSubscribed = false;
    }, []);
    const dataBookingFlowStep = bookingFlowContext.episerver.productType === 1 ? "ltp-addvehicle" : bookingFlowContext.episerver.productType === 2 ? "stp-addvehicle" : null;
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: "bookingflowpage__app bookingflowpage__app--unreservedproduct",
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $6bYiZ.BackNavigation), {}),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $leuhm.Heading), {}),
            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                className: "single-step single-step--booking",
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)("h2", {
                        children: bookingFlowContext.localization.addVehicle.heading
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                        className: "left nomargin",
                        children: bookingFlowContext.localization.addVehicle.registerheading
                    }),
                    isReservedProduct && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                        className: "margin",
                        children: /*#__PURE__*/ (0, $54dlf.jsx)((0, $jl9cc.HtmlOutput), {
                            html: bookingFlowContext.localization.addVehicle.registerreservedtext
                        })
                    }),
                    !isReservedProduct && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                        className: "margin",
                        children: /*#__PURE__*/ (0, $54dlf.jsx)((0, $jl9cc.HtmlOutput), {
                            html: bookingFlowContext.localization.addVehicle.registerunreservedtext
                        })
                    }),
                    vehicleList.length > 0 && vehicleList.map((singleVehicle, index)=>/*#__PURE__*/ (0, $54dlf.jsx)($01596d8bca3ec658$var$ProductItem, {
                            rowIndex: index,
                            singleVehicle: singleVehicle,
                            onChangeRegistrationNumberHandler: onChangeRegistrationNumberHandler,
                            onChangeCountryCodeHandler: onChangeCountryCodeHandler,
                            onChangeDescriptionTextHandler: onChangeDescriptionTextHandler,
                            onChangeSelectionHandler: onChangeSelectionHandler,
                            userVehicleList: userVehicleList,
                            formData: bookingFlowContext.availableSteps.addVehicle.formData,
                            value: singleVehicle,
                            validationError: validationErrors.length ? validationErrors[index] : null,
                            bookingFlowContext: bookingFlowContext,
                            pending: pending,
                            isReservedProduct: isReservedProduct,
                            pooling: pooling,
                            defaultCountryCode: defaultCountryCode,
                            countryCodeOptions: countryCodeOptions,
                            removeVehicleListItem: vehicleList.length > (pooling ? selectedSpotAmount : 1) ? ()=>removeVehicleListItemHandler(index) : null
                        }, singleVehicle.index)),
                    (isReservedProduct || pooling && vehicleList.length < maxLicensePlatesPerQuantity * selectedSpotAmount) && /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                                className: "single-step__small-button",
                                onClick: addNewVehicleHandler,
                                children: bookingFlowContext.localization.addVehicle.buttons.addNewVehicle
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                        className: "single-step__button single-step__button--next",
                        "data-booking-flow-step": dataBookingFlowStep,
                        disabled: pending || vehicleList.filter((item)=>item.PlateText.length === 0 || item.PlateText === "00000000-0000-0000-0000-000000000000").length > 0,
                        onClick: addVehicleHandler,
                        children: bookingFlowContext.localization.global.buttons.nextStep
                    })
                ]
            })
        ]
    });
};
const $01596d8bca3ec658$var$ProductItem = ({ countryCodeOptions: countryCodeOptions, onChangeCountryCodeHandler: onChangeCountryCodeHandler, defaultCountryCode: defaultCountryCode, validationError: validationError, value: value, rowIndex: rowIndex, singleVehicle: singleVehicle, onChangeRegistrationNumberHandler: onChangeRegistrationNumberHandler, onChangeDescriptionTextHandler: onChangeDescriptionTextHandler, onChangeSelectionHandler: onChangeSelectionHandler, userVehicleList: userVehicleList, formData: formData, bookingFlowContext: bookingFlowContext, pending: pending, isReservedProduct: isReservedProduct, pooling: pooling, removeVehicleListItem: removeVehicleListItem })=>{
    const [showForm, setShowForm] = (0, $ca3MY.useState)(false);
    const [selectedVehicle, setSelectedVehicle] = (0, $ca3MY.useState)({
        item: {
            Text: bookingFlowContext.localization.addVehicle.buttons.selectVehicle,
            Id: "00000000-0000-0000-0000-000000000000"
        }
    });
    const [countryCode, setCountryCode] = (0, $ca3MY.useState)({
        item: {
            Name: defaultCountryCode,
            Id: defaultCountryCode
        },
        required: false,
        elementType: "select"
    });
    (0, $ca3MY.useEffect)(()=>{
        if (!formData || !formData.length || selectedVehicle.item.PlateText) return;
        if (formData[0].PlateText) setSelectedVehicle({
            item: formData[0]
        });
    }, [
        formData
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (userVehicleList.length === 0 || pending) return;
        // const formDataItem = formData.filter(option => option.Id === singleVehicle.registrationNumber)
        if (selectedVehicle.item.Id === "NEW") {
            setShowForm(true);
            //index, PlateText, CountryCode, Description
            //if (formData && formData.find(item => item.index === singleVehicle.index)?.registrationNumber === singleVehicle.registrationNumber)
            onChangeSelectionHandler(singleVehicle.index, "", countryCode.item.Id, "");
            return;
        } else if (selectedVehicle.item.Id !== "NEW") {
            setShowForm(false);
            //onChangeSelectionHandler(singleVehicle.index, selectedVehicle.item.Id, selectedVehicle.item.Description)
            onChangeSelectionHandler(singleVehicle.index, selectedVehicle.item.Id, selectedVehicle.item.CountryCode, selectedVehicle.item.Description);
            return;
        }
    }, [
        selectedVehicle
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (userVehicleList.length === 0 || !formData || pending) return;
        //const vehicleInList = userVehicleList.filter(option => option.Id === singleVehicle.registrationNumber);
        const vehicleInList = userVehicleList.filter((option)=>option.Id === singleVehicle.PlateText);
        if (vehicleInList.length === 1) {
            setSelectedVehicle({
                item: vehicleInList[0]
            });
            setShowForm(false);
        } else if (singleVehicle.PlateText.length > 0) {
            setSelectedVehicle({
                item: {
                    Text: bookingFlowContext.localization.addVehicle.buttons.addNewVehicle,
                    Id: "NEW"
                }
            });
            setShowForm(true);
        }
    }, [
        userVehicleList
    ]);
    (0, $ca3MY.useEffect)(()=>{
        onChangeCountryCodeHandler(singleVehicle.index, countryCode.item.Id);
    }, [
        countryCode
    ]);
    return /*#__PURE__*/ (0, $54dlf.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($ca3MY))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
            !isReservedProduct && !pooling && /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                className: "left nomargin",
                children: `${bookingFlowContext.localization.onlineBooking.spotselection} ${rowIndex + 1}`
            }),
            (pending || userVehicleList.length > 0) && /*#__PURE__*/ (0, $54dlf.jsx)((0, $2sdqj.TwoColumnWrapper), {
                children: /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXzQg.DropdownlistWithLabel), {
                    text: bookingFlowContext.localization.addVehicle.buttons.registeredvehicles,
                    options: userVehicleList,
                    value: selectedVehicle,
                    setValue: setSelectedVehicle,
                    loading: pending
                })
            }),
            !pending && (userVehicleList.length === 0 || showForm) && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                modifier: "skipmargintop",
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
                        modifier: "equal",
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                                value: value,
                                autoFocus: true,
                                maxLength: 10,
                                toUpperCase: true,
                                inputType: "text",
                                text: bookingFlowContext.localization.addVehicle.registrationNumber,
                                onChange: onChangeRegistrationNumberHandler,
                                index: singleVehicle.index,
                                placeholder: bookingFlowContext.localization.addVehicle.registrationNumberPlaceholder,
                                defaultText: singleVehicle.PlateText
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXzQg.DropdownlistWithLabel), {
                                dropdownId: "countryCodeOptions",
                                text: bookingFlowContext.localization.addVehicle.countryCode,
                                options: countryCodeOptions,
                                optionText: "Name",
                                value: countryCode,
                                setValue: setCountryCode
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                        maxLength: 255,
                        inputType: "text",
                        text: bookingFlowContext.localization.addVehicle.descriptionText,
                        onChange: onChangeDescriptionTextHandler,
                        index: singleVehicle.index,
                        placeholder: bookingFlowContext.localization.addVehicle.descriptionTextPlaceholder,
                        defaultText: singleVehicle.descriptionText
                    })
                ]
            }),
            removeVehicleListItem !== null && /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                className: "single-step__link single-step__link--remove single-step__link--margin",
                onClick: removeVehicleListItem,
                children: bookingFlowContext.localization.addVehicle.remove
            })
        ]
    });
};
var $01596d8bca3ec658$export$2e2bcd8739ae039 = $01596d8bca3ec658$var$Vehicle;



var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $6bYiZ = parcelRequire("6bYiZ");

var $5kjCO = parcelRequire("5kjCO");

var $8oRQh = parcelRequire("8oRQh");

var $i33el = parcelRequire("i33el");

var $54dlf = parcelRequire("54dlf");
const $2118a6fcc146d1fd$var$Instructions = ({ title: title, instructions: instructions, note: note, titleLeft: titleLeft })=>{
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: "bookingflowpage__instruction__container",
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                className: `bookingflowpage__instruction__title ${titleLeft ? "text-left" : ""}`,
                children: title
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)("ol", {
                className: "bookingflowpage__instruction__subpoint-list",
                children: (instructions || []).map((sub, subIdx)=>/*#__PURE__*/ (0, $54dlf.jsx)("li", {
                        className: "bookingflowpage__instruction__subpoint-item",
                        children: sub
                    }, subIdx))
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                className: "bookingflowpage__instruction__note",
                children: note
            })
        ]
    });
};
var $2118a6fcc146d1fd$export$2e2bcd8739ae039 = $2118a6fcc146d1fd$var$Instructions;



var $axmXn = parcelRequire("axmXn");
const $6c78f3709fac6b6d$var$DocumentUpload = ()=>{
    const { bookingFlowContext: bookingFlowContext, setBookingFlowContext: setBookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    const existingDocument = bookingFlowContext.availableSteps.documentUpload || {};
    const orderId = bookingFlowContext.availableSteps.onlineBooking?.order?.orderId;
    const localization = bookingFlowContext.localization?.uploadDocument || {};
    const globalButtons = bookingFlowContext.localization?.global?.buttons || {};
    const [selectedFile, setSelectedFile] = (0, $ca3MY.useState)(()=>{
        if (existingDocument.selectedFile) {
            const base64String = existingDocument?.selectedFile;
            const file = (0, $i33el.base64ToFile)(base64String, existingDocument?.fileMeta?.name, existingDocument.fileMeta?.mimeType);
            if (file && file.name && file.size) return file;
            const meta = existingDocument?.fileMeta;
            if (meta?.name) return {
                fileName: meta.fileName,
                sizeBytes: meta.sizeBytes
            };
        }
        return null;
    });
    const [error, setError] = (0, $ca3MY.useState)("");
    const attachmentMissing = (0, $i33el.isSalesOrderAttachmentRequired)(bookingFlowContext) && !(0, $i33el.hasSalesOrderAttachment)(bookingFlowContext);
    const handleFileChange = async (e)=>{
        const file = e.target.files[0];
        const maxSize = 5242880;
        const allowedTypes = [
            "application/pdf",
            "text/plain",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "image/png",
            "image/jpeg"
        ];
        if (!file) return;
        if (!allowedTypes.includes(file.type)) {
            setError("Please upload a valid PDF, TXT, DOC, DOCX, PNG, JPG, or JPEG file.");
            e.target.value = null;
            return;
        }
        if (file.size > maxSize) {
            setError("File size must be 5MB or less.");
            e.target.value = null;
            return;
        }
        if (!orderId) {
            setError("Upload failed.");
            e.target.value = null;
            return;
        }
        try {
            const prepareResponse = await (0, $axmXn.products).prepareSalesOrderAttachmentUpload({
                OrderId: orderId,
                FileName: file.name,
                MimeType: file.type
            });
            if (prepareResponse.status >= 400 || !prepareResponse.body?.UploadUrl) {
                console.error("Prepare upload failed", prepareResponse);
                setError("Upload failed.");
                e.target.value = null;
                return;
            }
            const { UploadUrl: uploadUrl, AttachmentId: attachmentId } = prepareResponse.body;
            const s3Response = await fetch(uploadUrl, {
                method: "PUT",
                body: file,
                headers: {
                    "Content-Type": file.type
                }
            });
            if (!s3Response.ok) {
                console.error("S3 upload failed", s3Response.status);
                setError("Upload failed.");
                e.target.value = null;
                return;
            }
            const linkResponse = await (0, $axmXn.products).linkSalesOrderAttachments({
                OrderId: orderId,
                AttachmentIds: [
                    attachmentId
                ]
            });
            if (linkResponse.status >= 400) {
                console.error("Link attachment failed", linkResponse);
                setError("Upload failed.");
                e.target.value = null;
                return;
            }
            const attachmentRef = {
                Uid: attachmentId,
                FileName: file.name,
                MimeType: file.type,
                SizeBytes: file.size
            };
            setSelectedFile(file);
            await addFile(file, attachmentRef);
            setError("");
        } catch (err) {
            console.error("Upload failed", err);
            setError("Upload failed.");
        }
    };
    const finalizeFile = ()=>{
        if (attachmentMissing) return;
        setBookingFlowContext({
            ...bookingFlowContext,
            activeStep: bookingFlowContext.availableSteps.orderOverview.index
        });
    };
    const addFile = async (file, metaData)=>{
        const base64 = await (0, $i33el.fileToBase64)(file);
        setBookingFlowContext({
            ...bookingFlowContext,
            availableSteps: {
                ...bookingFlowContext.availableSteps,
                documentUpload: {
                    ...bookingFlowContext.availableSteps.documentUpload,
                    selectedFile: base64,
                    fileMeta: {
                        uid: metaData.Uid,
                        name: metaData.FileName,
                        sizeBytes: metaData.SizeBytes,
                        mimeType: metaData.MimeType
                    }
                }
            }
        });
    };
    const approvedInstructions = [
        localization.instructions?.approved?.step1,
        localization.instructions?.approved?.step2,
        localization.instructions?.approved?.step3
    ];
    const requiredInstructions = [
        localization.instructions?.required?.step1,
        localization.instructions?.required?.step2,
        localization.instructions?.required?.step3
    ];
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: "bookingflowpage__app bookingflowpage__app--unreservedproduct bookingflowpage__app--documentupload",
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $6bYiZ.BackNavigation), {}),
            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                className: "single-step single-step--booking",
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)("h2", {
                        children: localization.title
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                        className: "bookingflowpage__add-upload-document-container",
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                                className: "left bookingflowpage__add-upload-document__title",
                                children: localization.description
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $2118a6fcc146d1fd$export$2e2bcd8739ae039), {
                                title: localization.instructions?.approved?.title,
                                instructions: approvedInstructions,
                                titleLeft: true
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $2118a6fcc146d1fd$export$2e2bcd8739ae039), {
                                title: localization.instructions?.required?.title,
                                instructions: requiredInstructions,
                                titleLeft: true
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                className: "bookingflowpage__add-upload-document__file",
                                children: [
                                    /*#__PURE__*/ (0, $54dlf.jsx)("input", {
                                        type: "file",
                                        id: "file-upload",
                                        accept: ".pdf,.txt,.doc,.docx,.png,.jpeg,.jpg",
                                        onChange: handleFileChange,
                                        className: "file-upload-hidden"
                                    }),
                                    /*#__PURE__*/ (0, $54dlf.jsx)("label", {
                                        htmlFor: "file-upload",
                                        className: "upload-button",
                                        children: localization.upload
                                    }),
                                    selectedFile && /*#__PURE__*/ (0, $54dlf.jsxs)("p", {
                                        className: "margin",
                                        children: [
                                            /*#__PURE__*/ (0, $54dlf.jsx)("strong", {
                                                children: "Selected:"
                                            }),
                                            " ",
                                            selectedFile.name,
                                            !selectedFile.size && /*#__PURE__*/ (0, $54dlf.jsxs)("span", {
                                                className: "warning",
                                                children: [
                                                    " ",
                                                    "(Please re-upload this file)"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            error && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                                className: "bookingflowpage__add-upload-document__error",
                                children: error
                            }),
                            attachmentMissing && /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                                className: "bookingflowpage__add-upload-document__error",
                                children: localization.requiredError
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $5kjCO.Divider), {}),
                            /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                                className: "single-step__button single-step__button--next",
                                disabled: attachmentMissing,
                                onClick: finalizeFile,
                                children: globalButtons.nextStep || "Next"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $6c78f3709fac6b6d$export$2e2bcd8739ae039 = $6c78f3709fac6b6d$var$DocumentUpload;



var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $8oRQh = parcelRequire("8oRQh");

var $se1IJ = parcelRequire("se1IJ");

var $4kqcG = parcelRequire("4kqcG");

var $axmXn = parcelRequire("axmXn");

var $kLhVA = parcelRequire("kLhVA");

var $leuhm = parcelRequire("leuhm");

var $6bYiZ = parcelRequire("6bYiZ");

var $i33el = parcelRequire("i33el");

var $6g396 = parcelRequire("6g396");

var $54dlf = parcelRequire("54dlf");
parcelRequire("ca3MY");
const $04ea7618eddf83a7$export$54c2e3dc7acea9f5 = (props)=>{
    const wrappingClass = [
        "single-step__list",
        props.class
    ].join(" ");
    return /*#__PURE__*/ (0, $54dlf.jsx)("ul", {
        className: wrappingClass,
        children: props.rows.filter((row)=>row !== null).map((row, index)=>{
            if (row.left) return /*#__PURE__*/ (0, $54dlf.jsxs)("li", {
                className: row.class,
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                        className: "left",
                        children: row.left
                    }),
                    !Array.isArray(row.right) && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                        className: "right",
                        children: row.right
                    }),
                    Array.isArray(row.right) && /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                        className: "right column",
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                className: "strike",
                                children: row.right[0]
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)("span", {
                                children: row.right[1]
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};



var $gXJP5 = parcelRequire("gXJP5");

var $iFvPA = parcelRequire("iFvPA");

var $7zbft = parcelRequire("7zbft");

var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $g6ndF = parcelRequire("g6ndF");

var $8oRQh = parcelRequire("8oRQh");

var $axmXn = parcelRequire("axmXn");

var $2sdqj = parcelRequire("2sdqj");

var $kj4aw = parcelRequire("kj4aw");

var $gXJP5 = parcelRequire("gXJP5");
const $aa55fc6417c72166$var$OrderOverviewDiscount = (props)=>{
    const { bookingFlowContext: bookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    const lang = bookingFlowContext.localization.orderOverview.discount;
    const locale = bookingFlowContext.country;
    const selectedLocale = locale === "no" ? "nb" : locale === "se" ? "sv" : locale;
    (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))().locale(selectedLocale);
    const [disable, setDisable] = (0, $ca3MY.useState)(false);
    const [promoCode, setPromoCode] = (0, $ca3MY.useState)({
        text: ""
    });
    const [promoCodeEnabled, setPromoCodeEnabled] = (0, $ca3MY.useState)(false);
    const discountClickHandler = async ()=>{
        if (!promoCodeEnabled && !promoCode.text || promoCode.text.trim().length === 0) return;
        //if (promoCodeEnabled) {
        //  //const updatedQuote = !parsedQuote ? await products.updateSalesOrder({ form: updateQuoteForm, bookingflowPage: bookingFlowContext.episerver.bookingflowUrl }, bookingFlowContext.useMockedData) : parsedQuote;
        //  props.quoteUpdateEvent(null, null);
        //  setPromoCodeEnabled(false);
        //  return;
        //}
        if (props.pending) return;
        props.setPending(true);
        props.setError(null);
        setDisable(true);
        const updateQuoteForm = {
            OrderId: props.quoteId,
            Data: {
                PromotionCode: promoCodeEnabled ? "" : promoCode.text
            },
            ProcessType: props.processType
        };
        const updatedQuote = await (0, $axmXn.products).updateSalesOrder({
            form: updateQuoteForm,
            bookingflowPage: bookingFlowContext.episerver.bookingflowUrl
        }, bookingFlowContext.useMockedData);
        if (updatedQuote.status === 200) {
            if (promoCodeEnabled) {
                setPromoCode("");
                props.quoteUpdateEvent(null, updatedQuote);
            } else props.quoteUpdateEvent(promoCode.text, updatedQuote);
            setPromoCodeEnabled(!promoCodeEnabled);
        } else props.setError({
            error: true,
            errorText: updatedQuote.errorMessage,
            errorType: "updatedQuote"
        });
        props.setPending(false);
        setDisable(false);
    };
    (0, $ca3MY.useEffect)(()=>{
        if (!props.currentPromotionCode || promoCode.text) return;
        setPromoCode({
            text: props.currentPromotionCode
        });
        setPromoCodeEnabled(true);
    }, [
        props.currentPromotionCode
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (!promoCode.text) props.setError(null);
    }, [
        promoCode
    ]);
    const handleKeyDown = (e)=>e.key === "Enter" && discountClickHandler();
    return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
        className: "single-step__wrapper",
        children: /*#__PURE__*/ (0, $54dlf.jsxs)((0, $2sdqj.TwoColumnWrapper), {
            children: [
                /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                    className: "single-step__discount",
                    children: [
                        /*#__PURE__*/ (0, $54dlf.jsx)((0, $kj4aw.InputWithLabel), {
                            inputType: "text",
                            text: "",
                            placeholder: lang.inputplaceholder,
                            value: promoCode,
                            setValue: setPromoCode,
                            disabled: disable || props.disabled || promoCodeEnabled,
                            keyDown: handleKeyDown
                        }),
                        !promoCodeEnabled && /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                            className: "single-step__button",
                            disabled: disable || props.disabled || !promoCode.text || promoCode.text.trim().length === 0,
                            "aria-busy": props.pending,
                            onClick: discountClickHandler,
                            children: lang.button
                        }),
                        promoCodeEnabled && /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                            className: "single-step__button single-step__button--cancel",
                            disabled: disable || props.disabled,
                            "aria-busy": props.pending,
                            onClick: discountClickHandler,
                            children: lang.buttonremove
                        })
                    ]
                }),
                props.error && props.error.errorText?.length > 0 && props.error.errorType === "updatedQuote" && promoCode.text && /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXJP5.Error), {
                    text: props.error.errorText,
                    modifierClass: "blue"
                })
            ]
        })
    });
};
var $aa55fc6417c72166$export$2e2bcd8739ae039 = $aa55fc6417c72166$var$OrderOverviewDiscount;


const $7b1738e81741b9cb$var$emptyGuid = "00000000-0000-0000-0000-000000000000";
const $7b1738e81741b9cb$var$OrderOverview = (props)=>{
    const { bookingFlowContext: bookingFlowContext, setBookingFlowContext: setBookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    const formLang = {
        ...bookingFlowContext.episerver,
        ...bookingFlowContext.localization.global.cost,
        ...bookingFlowContext.localization.onlineBooking,
        ...bookingFlowContext.localization.orderOverview
    };
    const locale = bookingFlowContext.country;
    const selectedLocale = locale === "no" ? "nb" : locale === "se" ? "sv" : locale;
    const onlineBookingFormData = bookingFlowContext.availableSteps.onlineBooking.formData;
    const productSelection = onlineBookingFormData.productSelection.item;
    const unfilteredAccessDevices = [
        ...onlineBookingFormData.accessDevices ?? [],
        ...onlineBookingFormData.accessDevicesOptional ?? []
    ];
    const accessDevices = unfilteredAccessDevices.map((ad)=>{
        return {
            ProductOption: ad.ProductOption,
            Quantity: ad.Quantity,
            BillingFrequency: ad.BillingFrequency,
            Spot_Name: ad.spotName ? ad.spotName.join(";") : null
        };
    });
    const accessDeviceKeys = accessDevices.map((accessDevice)=>accessDevice.Id).join("-");
    const paymentSelection = onlineBookingFormData.paymentSelection?.item;
    const paymentSelectionValue = formLang.productType === 1 ? paymentSelection.value : "N/A";
    const isFlexbookingProduct = productSelection.ProcessType === "Flexbooking";
    const attachmentMissing = (0, $i33el.isSalesOrderAttachmentRequired)(bookingFlowContext) && !(0, $i33el.hasSalesOrderAttachment)(bookingFlowContext);
    const startDateSelection = onlineBookingFormData.date.date;
    const startTimeSelection = onlineBookingFormData.time?.text;
    const endDateSelection = onlineBookingFormData.endDate?.date;
    const endTimeSelection = onlineBookingFormData.endTime?.text;
    const vehiclesFormData = bookingFlowContext.availableSteps.addVehicle.formData;
    const vehicleLicensePlateNumbers = vehiclesFormData && vehiclesFormData.length > 0 ? vehiclesFormData.map((item)=>item.PlateText.replace(/;/g, "")).join(";") : "";
    const vehicleDescriptions = vehiclesFormData && vehiclesFormData.length > 0 ? vehiclesFormData.map((item)=>(item.descriptionText ?? "").replace(/;/g, "")).join(";") : "";
    const spotSelectionFormData = productSelection.Type === "RESERVED" ? onlineBookingFormData.spotSelection.filter((spot)=>spot.item.ParkingSpace.Uid !== $7b1738e81741b9cb$var$emptyGuid) : [];
    const selectedSpotsList = spotSelectionFormData.length > 0 ? spotSelectionFormData.map((item)=>item.item.ParkingSpace.Name).join(", ") : "N/A";
    const insuranceFeeId = onlineBookingFormData.insuranceFee?.selected ? productSelection.CancellationInsuranceFee.Id : null;
    const numberOfSpots = productSelection.Type === "RESERVED" ? spotSelectionFormData.length : onlineBookingFormData.numberOfParkingSpots.number;
    const flexPrice = onlineBookingFormData.calculatedFlexPrice?.text;
    const zoneNameInfo = productSelection.Zone !== bookingFlowContext.facility.name ? productSelection.Zone : null;
    const productDescription = productSelection.Description ?? null;
    const accessDevicesQuantity = accessDevices.length ? accessDevices.map((device)=>device.Quantity).reduce((prev, next)=>+prev + +next) : null;
    const paymentSelectionText = paymentSelection?.value ? formLang[paymentSelection?.value.toLowerCase()] : paymentSelection.text;
    const listSelectionRows = [
        {
            left: formLang.facility,
            right: bookingFlowContext.facility.name
        },
        zoneNameInfo ? {
            left: formLang.zonename,
            right: productSelection.Zone
        } : {},
        {
            left: formLang.product,
            right: productSelection.OverviewText ?? productSelection.Text
        },
        productDescription ? {
            left: formLang.descriptionText,
            right: productSelection.Description
        } : {},
        insuranceFeeId ? {
            left: productSelection.CancellationInsuranceFee.Heading,
            right: formLang.insuranceFeeActive
        } : {},
        accessDevicesQuantity ? {
            left: formLang.accessDevice.numberOfAD,
            right: accessDevicesQuantity
        } : {},
        isFlexbookingProduct ? {
            left: `${formLang.flexstartdate} ${formLang.flexandtime}`,
            right: (0, $iFvPA.parseDate)(startDateSelection, selectedLocale, "L") + " " + startTimeSelection
        } : {
            left: formLang.startDate,
            right: (0, $iFvPA.parseDate)(startDateSelection, selectedLocale, "L")
        },
        isFlexbookingProduct ? {
            left: `${formLang.flexenddate} ${formLang.flexandtime}`,
            right: (0, $iFvPA.parseDate)(endDateSelection, selectedLocale, "L") + " " + endTimeSelection
        } : {},
        {
            left: formLang.numberOfParkingSpots,
            right: numberOfSpots
        },
        spotSelectionFormData.length > 0 ? {
            left: spotSelectionFormData.length > 1 ? formLang.parkingspots : formLang.parkingspot,
            right: selectedSpotsList
        } : {},
        vehiclesFormData && vehiclesFormData.length > 0 ? {
            left: vehiclesFormData.length > 1 ? formLang.vehicles : formLang.vehicle,
            right: vehicleLicensePlateNumbers.replace(/;/g, ", "),
            class: "uppercase"
        } : {},
        {
            left: formLang.payment,
            right: formLang.productType === 1 ? paymentSelectionText : formLang.creditcard
        },
        {
            left: formLang.termination,
            right: formLang.terminationInfo
        },
        bookingFlowContext.availableSteps.documentUpload?.fileMeta?.name ? {
            left: formLang.attachment || "Attachment",
            right: bookingFlowContext.availableSteps.documentUpload.fileMeta.name
        } : {}
    ];
    const listPaymentProductRows = [
        {
            left: formLang.product,
            right: productSelection.OverviewText ?? productSelection.Text,
            class: "loading"
        },
        insuranceFeeId ? {
            left: productSelection.CancellationInsuranceFee.Heading,
            right: `${productSelection.CancellationInsuranceFee.Price.replace(".", ",")} ${productSelection.Currency}`,
            class: "loading"
        } : {},
        {
            left: `${formLang.total} (${paymentSelectionText})`,
            right: "-",
            class: "bold bordertop loading"
        },
        {
            left: `${formLang.subtotal}`,
            right: "-",
            class: "small loading"
        },
        {
            left: `${formLang.vat} `,
            right: "-",
            class: "small loading"
        }
    ];
    const [pending, setPending] = (0, $ca3MY.useState)(true);
    const [error, setError] = (0, $ca3MY.useState)(null);
    const [selectionRows, setSelectionRows] = (0, $ca3MY.useState)(listSelectionRows);
    const [paymentProductRows, setPaymentProductRows] = (0, $ca3MY.useState)(listPaymentProductRows);
    const [termsAndConditions, setTermsAndConditions] = (0, $ca3MY.useState)({
        selected: false,
        required: true,
        elementType: "checkbox"
    });
    const [promotion, setPromotion] = (0, $ca3MY.useState)(null);
    const [promotionValid, setPromotionValid] = (0, $ca3MY.useState)(null);
    const [quoteUid, setQuoteUid] = (0, $ca3MY.useState)(bookingFlowContext.availableSteps.onlineBooking.orderLineUid);
    const [quoteNumber, setQuoteNumber] = (0, $ca3MY.useState)(null);
    const [updatedQuote, setUpdatedQuote] = (0, $ca3MY.useState)(null);
    const [withPromotion, setWithPromotion] = (0, $ca3MY.useState)(null);
    const [totalPrice, setTotalPrice] = (0, $ca3MY.useState)(null);
    const [paymentUrl, setPaymentUrl] = (0, $ca3MY.useState)(null);
    const [currentQuoteSessionKey, setCurrentQuoteSessionKey] = (0, $ca3MY.useState)(null);
    const previousQuoteSessionKey = props.currentQuoteSessionKey ?? null;
    const [registerNewPayment, setRegisterNewPayment] = (0, $ca3MY.useState)(false);
    const [currentPromotionCode, setCurrentPromotionCode] = (0, $ca3MY.useState)(null);
    const order = bookingFlowContext.availableSteps.onlineBooking.order;
    const [showCancelLightbox, setShowCancelLightbox] = (0, $ca3MY.useState)(false);
    const [serviceFee, setServiceFee] = (0, $ca3MY.useState)(null);
    const closeCancelLightbox = ()=>{
        setShowCancelLightbox(false);
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete("responseCode");
        urlParams.delete("transactionId");
        urlParams.delete("qId");
        const newUrl = window.location.origin + window.location.pathname.replace("/PaymentResult", "/").replace("//", "/") + "?" + urlParams.toString();
        history.pushState((0, $kLhVA.paramsToObject)(urlParams), document.title, newUrl);
    };
    (0, $ca3MY.useEffect)(()=>{
        if (!order) return;
        let isSubscribed = true;
        const getCalculatedPrice = async ()=>{
            setPending(true);
            setError(null);
            setPaymentProductRows(listPaymentProductRows);
            const selectedSpotsIdList = spotSelectionFormData.length > 0 ? spotSelectionFormData.map((item)=>item.item.ParkingSpace.Uid).join(";") : "";
            const selectedSpotsNameList = spotSelectionFormData.length > 0 ? spotSelectionFormData.map((item)=>item.item.ParkingSpace.Name ?? "").join(";") : "";
            let flexBookingParams = isFlexbookingProduct ? {
                StartTime: startTimeSelection,
                EndDate: (0, $iFvPA.parseDate)(endDateSelection, "sv", "L"),
                EndTime: endTimeSelection,
                FacilityId: bookingFlowContext.facility.id,
                ProductType: formLang.productType
            } : {
                FacilityId: bookingFlowContext.facility.id,
                ProductType: formLang.productType
            };
            let flexBookingProductParams = isFlexbookingProduct ? {
                Price: flexPrice
            } : {};
            let quoteForm = {
                ProcessType: productSelection.ProcessType,
                StartDate: (0, $iFvPA.parseDate)(startDateSelection, "sv", "L"),
                ...flexBookingParams,
                Products: [
                    {
                        UID: productSelection.PhysicalZoneId,
                        Product_Options: [
                            {
                                ProductOption: productSelection.Id,
                                Quantity: numberOfSpots,
                                LicensePlateNumber: vehicleLicensePlateNumbers,
                                LicensePlateDescription: vehicleDescriptions,
                                BillingFrequency: paymentSelectionValue,
                                Spot_Id: selectedSpotsIdList,
                                Spot_Name: selectedSpotsNameList,
                                ...flexBookingProductParams
                            }
                        ]
                    }
                ]
            };
            const quoteSessionKey = `__aimo-booking-flow__quote__${order.orderId}-${numberOfSpots}-${insuranceFeeId ?? 0}-${selectedSpotsList.replace(/, /g, "-")}-${paymentSelectionValue}-${quoteForm.StartDate}-${quoteForm.EndDate ?? "N/A"}-${quoteForm.StartTime ?? "N/A"}-${quoteForm.EndTime ?? "N/A"}-${vehicleLicensePlateNumbers.replace(/;/g, "-")}${vehicleDescriptions.length > 0 ? "-" + vehicleDescriptions.replace(/;/g, "-") : ""}${accessDeviceKeys}`;
            setCurrentQuoteSessionKey(quoteSessionKey);
            const OrderId = order.orderId;
            const ProcessType = onlineBookingFormData.productSelection.item.ProcessType;
            //No registration plates data if skidata permit usage type (CPS-24723)
            const isSkidata = bookingFlowContext?.availableSteps?.onlineBooking?.formData?.productSelection?.item?.PermitUsageType?.toLowerCase() === "skidata";
            let Data = {};
            if (!isSkidata) {
                const RegistrationPlates = vehiclesFormData.length > 0 ? vehiclesFormData.map((item)=>({
                        PlateText: item.PlateText.trim().split(" ").join(""),
                        CountryCode: item.CountryCode
                    })) : [];
                Data = {
                    RegistrationPlates: RegistrationPlates
                };
            }
            const updateSalesOrderParams = {
                OrderId: OrderId,
                ProcessType: ProcessType,
                Data: Data
            };
            const createQuote = !updatedQuote ? await (0, $axmXn.products).updateSalesOrder({
                form: updateSalesOrderParams,
                bookingflowPage: bookingFlowContext.episerver.bookingflowUrl
            }) : updatedQuote;
            if (createQuote.status === 200 && isSubscribed) {
                const promoCfg = (0, $i33el.appliedPromotionConfig)(bookingFlowContext, createQuote.body.OrderLines?.[0]?.Promotion);
                const _StartAfter = promoCfg?.StartAfter ?? null;
                const _Duration = promoCfg?.Duration ?? null;
                const withMonthlyPromo = (0, $i33el.isMonthsFreeOrHalfPricePromotion)(createQuote.body.OrderLines?.[0]?.Promotion, promoCfg);
                const withPromo = createQuote.body.OrderLines && createQuote.body.OrderLines[0].Promotion && !withMonthlyPromo ? !!createQuote.body.OrderLines[0].Promotion : false;
                const StartAfter = withMonthlyPromo ? _StartAfter : null;
                const Duration = withMonthlyPromo ? _Duration : null;
                const Discount = createQuote.body.OrderLines && createQuote.body.OrderLines[0].Promotion && createQuote.body.OrderLines[0].Promotion.Percent ? createQuote.body.OrderLines[0].Promotion.Percent : null;
                const ValidFrom = withMonthlyPromo && createQuote.body.OrderLines[0].Promotion.Validity.ValidFrom ? (0, $iFvPA.parseDate)(createQuote.body.OrderLines[0].Promotion.Validity.ValidFrom, "sv", "L") : null;
                const ValidTo = withMonthlyPromo && createQuote.body.OrderLines[0].Promotion.Validity.ValidTo ? (0, $iFvPA.parseDate)(createQuote.body.OrderLines[0].Promotion.Validity.ValidTo, "sv", "L") : null;
                setWithPromotion(withPromo || withMonthlyPromo);
                setCurrentPromotionCode(withPromo && !createQuote.body.OrderLines[0]?.Promotion?.AddAutomatically ? createQuote.body.OrderLines[0]?.Promotion?.PromoCode : null);
                setPromotion(withPromo || withMonthlyPromo ? {
                    ...createQuote.body.OrderLines[0]?.Promotion,
                    StartAfter: StartAfter,
                    Duration: Duration
                } : null);
                setPromotionValid(ValidFrom && ValidTo ? ` (${ValidFrom}\u{2013}${ValidTo})` : "");
                setQuoteNumber(createQuote.body.Uid);
                setPending(false);
                const totalProductAmount = (withPromo ? createQuote.body.OrderLines[0].ListUnitPriceWithPromotion : createQuote.body.OrderLines[0].ListUnitPrice) / 100;
                const totalProductAmountPrevious = withPromo ? (createQuote?.body.OrderLines[0].ListUnitPrice || createQuote.body.OrderLines[0].ListUnitPrice) / 100 : null;
                const totalAmountWithoutTax = (withPromo ? createQuote.body.OrderLines[0].LineTotalWithoutVatWithPromotion : createQuote.body.OrderLines[0].LineTotalWithoutVat) / 100;
                const totalVatAmount = (withPromo ? createQuote.body.OrderLines[0].LineVatAmountWithPromotion : createQuote.body.OrderLines[0].LineVatAmount) / 100;
                const totalNetAmount = (withPromo ? createQuote.body.OrderLines[0].LineTotalWithPromotion : createQuote.body.OrderLines[0].LineTotal) / 100;
                const totalNetAmountPrevious = withPromo ? (createQuote?.body.OrderLines[0].LineTotal || createQuote?.body.OrderLines[0].LineTotal) / 100 : null;
                const totalFullPromoPeroidWithoutPromo = withMonthlyPromo ? createQuote?.body.OrderLines[0].ListUnitPrice * (StartAfter + Duration) / 100 : null;
                const totalFullPromoPeroidWithPromo = withMonthlyPromo ? (createQuote?.body.OrderLines[0].ListUnitPrice * StartAfter + (Discount && Discount !== 100 ? Duration * Discount / 100 * createQuote?.body.OrderLines[0].ListUnitPrice : 0)) / 100 : null;
                const accessDevicesRows = accessDevices?.length ? createQuote?.body.Product[0].ProductOption[0].NestedProductOptions.map((option)=>{
                    return {
                        left: (option.Quantity > 1 ? Math.round(option.Quantity) + "\xd7 " : "") + option.ProductName,
                        right: `${(0, $4kqcG.formatCurrency)(option.NetTotal, true)}`
                    };
                }) : [
                    {}
                ];
                const serviceFee = (createQuote.body.OrderLines[0].ServiceFeeAmount / 100) ?? null;
                setTotalPrice(totalNetAmount);
                setPaymentUrl(createQuote.body.PaymentUrl);
                setServiceFee(serviceFee);
                setPaymentProductRows([
                    withMonthlyPromo ? {
                        left: formLang.promomonthfree.originalprice.replace("{0}", StartAfter + Duration),
                        right: (0, $4kqcG.formatCurrency)(totalFullPromoPeroidWithoutPromo, true),
                        class: "bold strike"
                    } : {},
                    withMonthlyPromo ? {
                        left: formLang.totalwithdiscount,
                        right: (0, $4kqcG.formatCurrency)(totalFullPromoPeroidWithPromo, true),
                        class: "bold"
                    } : {},
                    totalProductAmount ? {
                        left: productSelection.OverviewText ?? productSelection.Text,
                        right: totalProductAmountPrevious ? [
                            (0, $4kqcG.formatCurrency)(totalProductAmountPrevious, true),
                            (0, $4kqcG.formatCurrency)(totalProductAmount, true)
                        ] : (0, $4kqcG.formatCurrency)(totalProductAmount, true)
                    } : {},
                    insuranceFeeId ? {
                        left: productSelection.CancellationInsuranceFee.Heading,
                        right: `${productSelection.CancellationInsuranceFee.Price.replace(".", ",")} ${productSelection.Currency}`
                    } : {},
                    ...accessDevicesRows,
                    {
                        left: `${formLang.total} (${paymentSelectionText})`,
                        right: (0, $4kqcG.formatCurrency)(totalNetAmountPrevious ? totalNetAmountPrevious : totalNetAmount, true) + (totalNetAmountPrevious ? "" : "*"),
                        class: totalNetAmountPrevious ? "bold bordertop strike" : "bold bordertop"
                    },
                    totalNetAmountPrevious ? {
                        left: formLang.totalwithdiscount,
                        right: (0, $4kqcG.formatCurrency)(totalNetAmount, true) + "*",
                        class: "bold"
                    } : {},
                    {
                        left: `${formLang.subtotal} `,
                        right: (0, $4kqcG.formatCurrency)(totalAmountWithoutTax, true),
                        class: "small"
                    },
                    {
                        left: `${formLang.vat} `,
                        right: (0, $4kqcG.formatCurrency)(totalVatAmount, true),
                        class: "small"
                    }
                ]);
                sessionStorage.setItem(quoteSessionKey, JSON.stringify(createQuote));
                if (previousQuoteSessionKey && previousQuoteSessionKey !== quoteSessionKey) sessionStorage.removeItem(previousQuoteSessionKey);
            } else if (isSubscribed) {
                setPending(false);
                setPaymentProductRows([
                    {
                        left: productSelection.OverviewText ?? productSelection.Text,
                        right: "-"
                    },
                    insuranceFeeId ? {
                        left: productSelection.CancellationInsuranceFee.Heading,
                        right: "-"
                    } : {},
                    {
                        left: `${formLang.total} (${paymentSelectionText})`,
                        right: "-",
                        class: "bold border bordertop"
                    },
                    {
                        left: `${formLang.subtotal}`,
                        right: "-",
                        class: "small"
                    },
                    {
                        left: `${formLang.vat} `,
                        right: "-",
                        class: "small"
                    }
                ]);
                setError({
                    error: true,
                    errorText: createQuote.errorMessage,
                    errorType: "createQuote"
                });
            }
        };
        getCalculatedPrice();
        return ()=>isSubscribed = false;
    }, [
        order,
        updatedQuote
    ]);
    (0, $ca3MY.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const responseCode = urlParams.get("responseCode");
        if (!responseCode) return;
        setShowCancelLightbox(true);
        setPaymentUrl(null);
        setRegisterNewPayment(true);
    }, []);
    (0, $ca3MY.useEffect)(()=>{
        let isSubscribed = true;
        const getNewPaymentUrl = async ()=>{
            if (!quoteUid || !quoteNumber || !totalPrice || !currentQuoteSessionKey || !registerNewPayment) return;
            setPending(true);
            const quoteConfirmationForm = {
                facilityId: bookingFlowContext.facility.id,
                productType: formLang.productType,
                processType: productSelection.ProcessType,
                quoteId: quoteUid,
                quoteNumber: quoteNumber,
                amount: totalPrice
            };
            const creditcardPaymentResponse = await (0, $axmXn.payment).getCreditcardPaymentUrl({
                form: quoteConfirmationForm,
                bookingflowPage: bookingFlowContext.episerver.bookingflowUrl
            }, bookingFlowContext.useMockedData);
            if (creditcardPaymentResponse.status === 200) {
                const responseUrl = decodeURIComponent(creditcardPaymentResponse.body.replace(/"/g, "").replace(/\\u0026/g, "&"));
                setPaymentUrl(responseUrl);
                let quoteSessionValue = sessionStorage.getItem(currentQuoteSessionKey);
                if (quoteSessionValue) {
                    quoteSessionValue = JSON.parse(quoteSessionValue);
                    quoteSessionValue.body.PaymentUrl = responseUrl;
                    sessionStorage.setItem(currentQuoteSessionKey, JSON.stringify(quoteSessionValue));
                }
            } else setPaymentUrl(null);
            setPending(false);
        };
        getNewPaymentUrl();
        return ()=>isSubscribed = false;
    }, [
        quoteUid,
        quoteNumber,
        totalPrice,
        currentQuoteSessionKey,
        registerNewPayment
    ]);
    // `disabled` is inert on an anchor, so the href has to be dropped to actually block the click.
    const stpPaymentUrl = attachmentMissing ? undefined : paymentUrl;
    const quoteUpdateEventHandler = (promoCode, newQuote)=>{
        setCurrentPromotionCode(promoCode);
        setUpdatedQuote(newQuote);
    };
    const placeLtpOrderHandler = async ()=>{
        setPending(true);
        setError(null);
        if (attachmentMissing) {
            setError({
                error: true,
                errorText: formLang.attachmentrequired,
                errorType: "confirmQuote"
            });
            setPending(false);
            return;
        }
        const newQuoteForm = {
            termsAndConditions: {
                value: termsAndConditions,
                setValue: setTermsAndConditions
            }
        };
        let [formValidationError, cleanFormData] = (0, $se1IJ.validateFormObject)(newQuoteForm, bookingFlowContext.localization.global.errorMessages);
        if (formValidationError) {
            setPending(false);
            return;
        }
        const quoteConfirmationForm = {
            AutomaticOnlineOrderActivation: productSelection.AutomaticOnlineOrderActivation,
            Uid: order.orderId
        };
        const confirmQuote = await (0, $axmXn.products).confirmSalesOrder({
            form: quoteConfirmationForm,
            bookingflowPage: bookingFlowContext.episerver.bookingflowUrl
        }, bookingFlowContext.useMockedData);
        if (confirmQuote.status === 200) {
            setPending(false);
            setBookingFlowContext({
                ...bookingFlowContext,
                activeStep: bookingFlowContext.availableSteps.orderConfirmation.index,
                availableSteps: {
                    ...bookingFlowContext.availableSteps,
                    orderOverview: {
                        ...bookingFlowContext.availableSteps.orderOverview,
                        formData: {
                            ...cleanFormData,
                            ...quoteConfirmationForm
                        }
                    }
                }
            });
        } else {
            setError({
                error: true,
                errorText: confirmQuote.body.ErrorMessage,
                errorType: "confirmQuote"
            });
            setPending(false);
        }
    };
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: "bookingflowpage__app bookingflowpage__app--orderoverview",
        children: [
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $6bYiZ.BackNavigation), {
                disabled: pending
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)((0, $leuhm.Heading), {}),
            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                className: "single-step single-step--overview",
                children: [
                    showCancelLightbox && /*#__PURE__*/ (0, $54dlf.jsxs)((0, $6g396.Lightbox), {
                        onCloseEvent: closeCancelLightbox,
                        close: "Close",
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                                className: "single-step__lightbox__heading",
                                children: formLang.paymentcancelled.heading
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                                className: "single-step__lightbox__text",
                                children: formLang.paymentcancelled.text
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                className: "single-step__lightbox__options",
                                children: [
                                    /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                                        className: "cancel",
                                        onClick: ()=>window.location = formLang.completionLink,
                                        children: formLang.paymentcancelled.links.startpage
                                    }),
                                    /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                                        onClick: closeCancelLightbox,
                                        children: formLang.paymentcancelled.links.continue
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("h2", {
                        children: bookingFlowContext.localization.orderOverview.selectionHeading
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $04ea7618eddf83a7$export$54c2e3dc7acea9f5), {
                        rows: selectionRows
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $aa55fc6417c72166$export$2e2bcd8739ae039), {
                        disabled: quoteNumber === null,
                        quoteId: quoteNumber,
                        currentPromotionCode: currentPromotionCode,
                        processType: productSelection.ProcessType,
                        formLang: formLang,
                        pending: pending,
                        setPending: setPending,
                        error: error,
                        setError: setError,
                        quoteUpdateEvent: quoteUpdateEventHandler
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                        className: "single-step__yellow-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsx)("h2", {
                                children: bookingFlowContext.localization.orderOverview.paymentHeading
                            }),
                            error && error.errorText?.length > 0 && error.errorType === "createQuote" && /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXJP5.Error), {
                                text: error.errorText,
                                modifierClass: "blue"
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsx)((0, $04ea7618eddf83a7$export$54c2e3dc7acea9f5), {
                                rows: paymentProductRows,
                                class: "single-step__list--smallmargin"
                            }),
                            withPromotion && promotion && /*#__PURE__*/ (0, $54dlf.jsxs)("p", {
                                className: "extrasmall nomargin margintop italic",
                                children: [
                                    `*${currentPromotionCode ? promotion.Name + " - " : ""}${formLang.promodiscount} ${Math.round(promotion.Percent || promotion.Value / 100)}${promotion.Value ? " " + productSelection.Currency : "\u202F%"}`,
                                    promotion.Validity?.ValidFrom && !promotion.StartAfter && ` ${formLang.promovalid.toLowerCase()}${promotion.Validity?.ValidTo ? "" : " " + formLang.promofrom.split(" ")[0]} ${(0, $iFvPA.parseDate)(promotion.Validity.ValidFrom, selectedLocale, "L")}${promotion.Validity?.ValidTo ? "\u2013" + (0, $iFvPA.parseDate)(promotion.Validity.ValidTo, selectedLocale, "L") : ""}`,
                                    promotion.StartAfter > 0 && promotion.Percent !== 100 && promotion.Percent !== 50 && ` ${formLang.promovalid.toLowerCase()}${promotion.Duration ? promotion.Duration > 1 ? " " + formLang.promodurations.replace("{0}", promotion.Duration) : " " + formLang.promoduration.replace("{0}", promotion.Duration) : ""} ${formLang.promofrom} ${promotion.StartAfter + 1}`,
                                    promotion.StartAfter > 0 && (promotion.Percent === 100 || promotion.Percent === 50) && ` ${promotion.Duration > 1 ? formLang.promomonthfree.footnotemultipleduration.replace("{0}", promotion.StartAfter + 1 + "\u2013" + (promotion.StartAfter + promotion.Duration)) : formLang.promomonthfree.footnotesingleduration.replace("{0}", promotion.StartAfter + 1)}${promotionValid ? promotionValid : ""}`
                                ]
                            }),
                            bookingFlowContext.country === "se" && /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                                className: "single-step__information",
                                children: [
                                    serviceFee ? /*#__PURE__*/ (0, $54dlf.jsxs)("p", {
                                        className: "extrasmall nomargin margintop italic",
                                        children: [
                                            "*",
                                            formLang.servicefeeincl.replace("{1}", `${serviceFee} ${productSelection?.Currency}`)
                                        ]
                                    }) : "",
                                    !bookingFlowContext.episerver.PaymentInfoUrl && /*#__PURE__*/ (0, $54dlf.jsxs)("p", {
                                        className: "extrasmall nomargin margintop italic",
                                        children: [
                                            withPromotion && promotion ? "" : "*",
                                            formLang.invoicefeenotincl
                                        ]
                                    }),
                                    bookingFlowContext.episerver.PaymentInfoUrl && /*#__PURE__*/ (0, $54dlf.jsxs)("a", {
                                        href: bookingFlowContext.episerver.PaymentInfoUrl,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: [
                                            " ",
                                            withPromotion && promotion ? "" : "*",
                                            formLang.paymentinfo
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("h2", {
                        children: formLang.termsandconditionsheading
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                        className: "single-step__checkbox-wrapper",
                        children: /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                            children: /*#__PURE__*/ (0, $54dlf.jsx)((0, $7zbft.CheckboxWithLabel), {
                                text: formLang.productType === 1 ? bookingFlowContext.localization.createAccount.termsAndConditionsLTP : bookingFlowContext.localization.createAccount.termsAndConditionsSTP,
                                value: termsAndConditions,
                                setValue: setTermsAndConditions
                            })
                        })
                    }),
                    error && error.errorText?.length > 0 && error.errorType === "confirmQuote" && /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXJP5.Error), {
                        text: error.errorText
                    }),
                    attachmentMissing && /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXJP5.Error), {
                        text: formLang.attachmentrequired
                    }),
                    formLang.productType === 1 && /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                        className: "single-step__button single-step__button--order",
                        "data-booking-flow-step": "ltp-orderoverview",
                        disabled: error && error.errorType !== "updatedQuote" || pending || !termsAndConditions.selected || attachmentMissing,
                        "aria-busy": pending,
                        onClick: placeLtpOrderHandler,
                        children: bookingFlowContext.localization.orderOverview.buttons.placeOrder
                    }),
                    formLang.productType === 2 && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                        className: "single-step__link-wrapper",
                        children: /*#__PURE__*/ (0, $54dlf.jsx)("a", {
                            className: "single-step__button single-step__button--order",
                            "data-booking-flow-step": "stp-orderoverview",
                            disabled: error && error.errorType !== "updatedQuote" || pending || !termsAndConditions.selected || !paymentUrl || totalPrice && totalPrice === "0.00" || attachmentMissing,
                            "aria-busy": pending,
                            href: stpPaymentUrl,
                            children: bookingFlowContext.localization.orderOverview.buttons.placeStpOrder
                        })
                    })
                ]
            })
        ]
    });
};
var $7b1738e81741b9cb$export$2e2bcd8739ae039 = $7b1738e81741b9cb$var$OrderOverview;



var $54dlf = parcelRequire("54dlf");

var $ca3MY = parcelRequire("ca3MY");

var $8oRQh = parcelRequire("8oRQh");

var $axmXn = parcelRequire("axmXn");
parcelRequire("lA5kC");

var $leuhm = parcelRequire("leuhm");

var $jl9cc = parcelRequire("jl9cc");
const $127a1a552a1070b9$var$OrderConfirmation = ()=>{
    const { bookingFlowContext: bookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    const [offersHtml, setOffersHtml] = (0, $ca3MY.useState)(null);
    const typeformId = "01HV4161P35AKJXR3CK4FE76AB";
    const currentCountry = document.querySelector("html").getAttribute("country");
    (0, $ca3MY.useEffect)(()=>{
        setTimeout(()=>{
            var n = sessionStorage.length;
            while(n--){
                var key = sessionStorage.key(n);
                if (/__aimo-booking-flow__/.test(key)) sessionStorage.removeItem(key);
            }
        }, 1000);
        getOffers();
    }, []);
    (0, $ca3MY.useEffect)(()=>{
        if (currentCountry !== "se") return;
        //Add external typeform script tag
        const tagAlreadyExists = !!document.querySelector("script[data-typeform-embed]");
        if (tagAlreadyExists) return;
        const tag = document.createElement("script");
        tag.setAttribute("data-typeform-embed", true);
        tag.setAttribute("src", "https://embed.typeform.com/next/embed.js");
        document.body.appendChild(tag);
        return ()=>document.body.removeChild(tag);
    }, []);
    const getOffers = async ()=>{
        const epslanguage = bookingFlowContext.localization.language;
        const fId = bookingFlowContext.facility.id;
        const offers = await (0, $axmXn.facility).getConfirmationPageOffers({
            fId: fId,
            epslanguage: epslanguage
        });
        if (offers.status === 200) setOffersHtml(offers.body);
    };
    return /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
        className: "bookingflowpage__app bookingflowpage__app--confirmation",
        children: [
            /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                className: "single-step single-step--confirmation",
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)((0, $leuhm.Heading), {
                        text: bookingFlowContext.localization.orderConfirmation.heading
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                        children: /*#__PURE__*/ (0, $54dlf.jsx)((0, $jl9cc.HtmlOutput), {
                            html: bookingFlowContext.localization.orderConfirmation.text.replace("{0}", bookingFlowContext.availableSteps.orderOverview.formData.Uid)
                        })
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("a", {
                        href: bookingFlowContext.episerver.completionLink,
                        children: bookingFlowContext.localization.orderConfirmation.link
                    })
                ]
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                style: {
                    minHeight: "340px"
                },
                "data-tf-live": typeformId
            }),
            offersHtml && /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                className: "facilitypage__offers",
                dangerouslySetInnerHTML: {
                    __html: offersHtml
                }
            })
        ]
    });
};
var $127a1a552a1070b9$export$2e2bcd8739ae039 = $127a1a552a1070b9$var$OrderConfirmation;



var $54dlf = parcelRequire("54dlf");

var $g6ndF = parcelRequire("g6ndF");

var $ca3MY = parcelRequire("ca3MY");

var $lnu9l = parcelRequire("lnu9l");

var $axmXn = parcelRequire("axmXn");

var $axmXn = parcelRequire("axmXn");

var $iFvPA = parcelRequire("iFvPA");
const $71b27ebb9bbd1db6$export$27e354253631d0ae = async (formData, unlockCode)=>{
    const emptyGuid = "00000000-0000-0000-0000-000000000000";
    const lang = document.querySelector("html").getAttribute("lang");
    const BillingFrequency = formData?.paymentSelection?.item?.value;
    const selectedDate = formData?.date?.date ?? "";
    const StartDate = selectedDate ? new Date((0, $iFvPA.parseDate)(selectedDate, "sv", "L")).toISOString() : "";
    const isReserved = formData?.productSelection.item.Type === "RESERVED";
    const ParkingSpaceUids = formData?.spotSelection?.length && formData.spotSelection[0].item?.ParkingSpace?.Uid !== emptyGuid ? formData?.spotSelection?.map((spot)=>spot?.item?.ParkingSpace?.Uid ?? null) : null;
    const PmcId = formData?.productSelection?.item?.Id;
    const Quantity = isReserved && ParkingSpaceUids ? ParkingSpaceUids.length : formData?.numberOfParkingSpots?.number ?? 0;
    const unlockCodeParam = unlockCode != undefined ? unlockCode : "";
    const createSalesOrderParams = {
        StartDate: StartDate,
        PmcId: PmcId,
        Quantity: Quantity,
        BillingFrequency: BillingFrequency,
        ...ParkingSpaceUids && {
            ParkingSpaceUids: ParkingSpaceUids
        },
        UnlockCode: unlockCodeParam
    };
    const response = await (0, $axmXn.products).createSalesOrderDraft(createSalesOrderParams, false, lang);
    return response;
};



var $8oRQh = parcelRequire("8oRQh");
const $b4612543a06d8fdc$export$88de96835c56525a = (props)=>{
    const { bookingFlowContext: bookingFlowContext, setBookingFlowContext: setBookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
    if (!bookingFlowContext) return;
    //Templock duration in minutes
    const duration = 30;
    const [dateLockedUntil, setDateLockedUntil] = (0, $ca3MY.useState)(null);
    const [timeLeft, setTimeLeft] = (0, $ca3MY.useState)(null);
    (0, $ca3MY.useEffect)(()=>{
        switch(bookingFlowContext.activeStep){
            case bookingFlowContext.availableSteps.onlineBooking.index:
            case bookingFlowContext.availableSteps.orderConfirmation.index:
                unLockProducts(bookingFlowContext);
                break;
            case bookingFlowContext.availableSteps.addVehicle.index:
            case bookingFlowContext.availableSteps.orderOverview.index:
                lockProducts(bookingFlowContext);
                break;
        }
    }, [
        bookingFlowContext.activeStep
    ]);
    (0, $ca3MY.useEffect)(()=>{
        if (timeLeft === null) return;
        let timer = setTimeout(()=>{
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return ()=>clearTimeout(timer);
    });
    const lockProducts = async (bookingFlowContext)=>{
        if (bookingFlowContext.availableSteps.onlineBooking.order) updateTempLock(bookingFlowContext);
        else {
            const formData = bookingFlowContext.availableSteps.onlineBooking.formData;
            const selectedPmcId = formData?.productSelection?.item?.Id;
            const storedPmcId = localStorage.getItem("validUnlockPmcId");
            const unlockCode = selectedPmcId && storedPmcId === selectedPmcId ? localStorage.getItem("validUnlockCode") ?? undefined : undefined;
            const response = await (0, $71b27ebb9bbd1db6$export$27e354253631d0ae)(formData, unlockCode);
            const salesOrderDraft = response.body;
            if (response.status === 200) {
                const created = (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF))).utc(new Date());
                setBookingFlowContext({
                    ...bookingFlowContext,
                    availableSteps: {
                        ...bookingFlowContext.availableSteps,
                        onlineBooking: {
                            ...bookingFlowContext.availableSteps.onlineBooking,
                            update: false,
                            order: {
                                orderLineId: salesOrderDraft.OrderLines[0].OrderLineId,
                                orderLine: salesOrderDraft.OrderLines[0],
                                orderId: salesOrderDraft.Uid
                            }
                        }
                    }
                });
                const expiryDate = (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))(created).add(duration, "m");
                setDateLockedUntil(expiryDate);
                setTimeLeft(calculateTimeLeft(expiryDate));
            } else props.setError(response);
        }
    };
    const updateTempLock = async (bookingFlowContext)=>{
        const version = bookingFlowContext.availableSteps.onlineBooking.order.orderLine.Version ? "-" + bookingFlowContext.availableSteps.onlineBooking.order.orderLine.Version : "";
        const orderId = bookingFlowContext.availableSteps.onlineBooking.order.orderId;
        const orderLineId = bookingFlowContext.availableSteps.onlineBooking.order.orderLineId + version;
        const updateExpiryDate = (0, (/*@__PURE__*/$parcel$interopDefault($g6ndF)))().add(duration, "m");
        const response = await (0, $axmXn.tempLock).updateTempLock({
            orderId: orderId,
            orderLineId: orderLineId
        });
        if (response.status === 200) {
            setDateLockedUntil(updateExpiryDate);
            setTimeLeft(calculateTimeLeft(updateExpiryDate));
        }
    };
    const unLockProducts = async (bookingFlowContext)=>{
        if (!bookingFlowContext.availableSteps.onlineBooking.order) return;
        const uid = bookingFlowContext.availableSteps.onlineBooking.order.orderId;
        setDateLockedUntil(null);
        setTimeLeft(null);
        const response = bookingFlowContext.activeStep != bookingFlowContext.availableSteps.orderConfirmation.index ? await (0, $axmXn.tempLock).removeTempLock({
            uid: uid
        }) : null;
        setBookingFlowContext({
            ...bookingFlowContext,
            availableSteps: {
                ...bookingFlowContext.availableSteps,
                onlineBooking: {
                    ...bookingFlowContext.availableSteps.onlineBooking,
                    update: false,
                    order: null
                }
            }
        });
        if (props.currentQuoteSessionKey) sessionStorage.removeItem(props.currentQuoteSessionKey);
    };
    const calculateTimeLeft = (date = dateLockedUntil)=>{
        const difference = date - +new Date();
        let timeLeft = {};
        if (difference > 0) timeLeft = {
            days: Math.floor(difference / 86400000),
            hours: Math.floor(difference / 3600000 % 24),
            minutes: Math.floor(difference / 1000 / 60 % 60),
            seconds: Math.floor(difference / 1000 % 60)
        };
        else timeLeft = {
            none: true
        };
        return timeLeft;
    };
    const handleDialogConfirm = ()=>{
        updateTempLock(bookingFlowContext);
    };
    const handleDialogCancel = ()=>{
        props.takeUserToStep(0);
    };
    if (timeLeft !== null && !timeLeft.none && timeLeft.minutes < 5) return /*#__PURE__*/ (0, $54dlf.jsxs)((0, $lnu9l.Dialog), {
        lang: props.lang,
        onDialogConfirm: handleDialogConfirm,
        onDialogCancel: handleDialogCancel,
        children: [
            /*#__PURE__*/ (0, $54dlf.jsxs)("p", {
                children: [
                    props.lang.message1,
                    " ",
                    timeLeft.minutes > 0 && timeLeft.minutes,
                    " ",
                    timeLeft.minutes > 0 && (timeLeft.minutes === 1 ? props.lang.minute : props.lang.minutes),
                    " ",
                    timeLeft.minutes > 0 && props.lang.and,
                    " ",
                    timeLeft.seconds,
                    " ",
                    timeLeft.seconds === 1 ? props.lang.second : props.lang.seconds,
                    " ",
                    props.lang.message2
                ]
            }),
            /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                children: props.lang.message3
            })
        ]
    });
    if (timeLeft !== null && timeLeft.none) return /*#__PURE__*/ (0, $54dlf.jsx)((0, $lnu9l.Dialog), {
        lang: props.lang,
        onDialogConfirm: handleDialogCancel,
        langHeading: props.lang.bookingexpired,
        langConfirm: props.lang.ok,
        children: /*#__PURE__*/ (0, $54dlf.jsx)("p", {
            children: props.lang.bookingexpiredmessage
        })
    });
    return null;
};


function $d41b026deaa7b4e1$var$bookingFlowPage(context) {
    const appContainer = context;
    const appConfig = (0, $jQtCH.default).getConfig(context);
    const App = ()=>{
        const { bookingFlowContext: bookingFlowContext, setBookingFlowContext: setBookingFlowContext } = (0, $ca3MY.useContext)((0, $8oRQh.BookingFlowContext));
        const [pending, setPending] = (0, $ca3MY.useState)(false);
        const [currentQuoteSessionKey, setCurrentQuoteSessionKey] = (0, $ca3MY.useState)(null);
        const [error, setError] = (0, $ca3MY.useState)(false);
        const [reload, setReload] = (0, $ca3MY.useState)(0);
        const [forceLogin, setForceLogin] = (0, $ca3MY.useState)(false);
        const topOfContainerRef = (0, $ca3MY.useRef)(null);
        const selectedLang = document.querySelector("html").getAttribute("lang");
        (0, $ca3MY.useEffect)(()=>{
            let isSubscribed = true;
            const getFacility = async ()=>{
                if (bookingFlowContext.facility || pending) {
                    document.title = bookingFlowContext.facility.name + " - " + document.title;
                    if (error) {
                        setError(false);
                        takeUserToStep(0);
                    }
                    setError(false);
                    return;
                }
                setPending(true);
                setError(false);
                const urlParams = new (0, $8OcmI.default)(window.location.search);
                const fId = urlParams.get("fId") ?? urlParams.get("fid");
                const country = document.querySelector("html").getAttribute("country");
                const currentFacility = await (0, $axmXn.facility).getFacility({
                    bookingController: bookingFlowContext.episerver.bookingController,
                    fId: fId,
                    productType: bookingFlowContext.episerver.productType,
                    lang: selectedLang === "nb" ? "no" : selectedLang
                }, bookingFlowContext.useMockedData);
                if (currentFacility.status === 200 && isSubscribed) {
                    const currentFacilityData = currentFacility.body;
                    const facilityData = {
                        latitude: currentFacilityData.Address.Marker.Coordinates[1],
                        longitude: currentFacilityData.Address.Marker.Coordinates[0],
                        maxDistance: 5,
                        lang: selectedLang === "nb" ? "no" : selectedLang,
                        withPmcs: false,
                        init: true
                    };
                    const getNearbyFacilities = await (0, $axmXn.facility).getNearbyFacilities(facilityData);
                    const nearbyFacilities = getNearbyFacilities.status === 200 && getNearbyFacilities.body.length ? getNearbyFacilities.body.filter((facility)=>facility.HasLtp && currentFacilityData.Uid !== facility.Uid) : null;
                    setPending(false);
                    setBookingFlowContext({
                        ...bookingFlowContext,
                        country: country,
                        facility: {
                            id: currentFacilityData.Uid,
                            name: currentFacilityData.FacilityName,
                            city: currentFacilityData.Address?.City ?? currentFacilityData.City,
                            coordinates: {
                                latitude: currentFacilityData.Address.Marker.Coordinates[1],
                                longitude: currentFacilityData.Address.Marker.Coordinates[0]
                            },
                            nearbyFacilities: nearbyFacilities
                        }
                    });
                    document.title = currentFacilityData.FacilityName + " - " + document.title;
                } else if (isSubscribed) {
                    setPending(false);
                    setError(true);
                }
                (0, $iSxgd.pushToDataLayer)({
                    event: "bookingflow_init_load",
                    value: currentFacility.status
                });
            };
            getFacility();
            return ()=>isSubscribed = false;
        }, [
            reload
        ]);
        (0, $ca3MY.useEffect)(()=>{
            if (bookingFlowContext.activeStep > 1 && !useMockedLogin && !bookingFlowContext.episerver.loggedIn) setForceLogin(true);
            if (!topOfContainerRef || !topOfContainerRef.current) return;
            if (!(0, $716d5d85e060137b$export$157b27307c5a0381)(topOfContainerRef.current)) {
                const mainElement = document.querySelector(".aimo-main");
                if (mainElement) mainElement.scrollIntoView({
                    behavior: "smooth"
                });
                else topOfContainerRef.current.scrollIntoView({
                    behavior: "smooth"
                });
            }
        }, [
            bookingFlowContext.activeStep
        ]);
        const takeUserToStep = (stepIndex)=>{
            setBookingFlowContext({
                ...bookingFlowContext,
                activeStep: stepIndex
            });
        };
        if (!bookingFlowContext.facility && !error) return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
            className: "bookingflowpage__loader",
            children: /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                className: "aimo-spinner",
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)("span", {}),
                    /*#__PURE__*/ (0, $54dlf.jsx)("span", {}),
                    /*#__PURE__*/ (0, $54dlf.jsx)("span", {}),
                    /*#__PURE__*/ (0, $54dlf.jsx)("span", {})
                ]
            })
        });
        if (error) return /*#__PURE__*/ (0, $54dlf.jsx)("div", {
            className: "bookingflowpage__error",
            children: error.errorMessage ? /*#__PURE__*/ (0, $54dlf.jsx)((0, $gXJP5.Error), {
                text: error.errorMessage
            }) : /*#__PURE__*/ (0, $54dlf.jsxs)("div", {
                className: "bookingflowpage__error__inner",
                children: [
                    /*#__PURE__*/ (0, $54dlf.jsx)("h2", {
                        children: appConfig.localization.global.errorMessages.load.heading
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("p", {
                        children: appConfig.localization.global.errorMessages.load.text
                    }),
                    /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                        onClick: ()=>{
                            setReload(reload + 1);
                        },
                        children: appConfig.localization.global.errorMessages.load.button
                    })
                ]
            })
        });
        const useMockedLogin = false;
        const loggedInWithActiveProfile = bookingFlowContext.episerver.loggedIn && (!bookingFlowContext.episerver.hasMoreThanOneProfile || bookingFlowContext.episerver.activeProfile);
        return /*#__PURE__*/ (0, $54dlf.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($ca3MY))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                    ref: topOfContainerRef
                }),
                /*#__PURE__*/ (0, $54dlf.jsx)((0, $b4612543a06d8fdc$export$88de96835c56525a), {
                    bookingFlowContext: bookingFlowContext,
                    lang: appConfig.localization.dialog,
                    takeUserToStep: takeUserToStep,
                    currentQuoteSessionKey: currentQuoteSessionKey,
                    setError: setError
                }),
                bookingFlowContext.activeStep === bookingFlowContext.availableSteps.onlineBooking.index && /*#__PURE__*/ (0, $54dlf.jsx)((0, $59fb50fb2c8e26e9$export$2e2bcd8739ae039), {}),
                bookingFlowContext.activeStep === bookingFlowContext.availableSteps.login.index && /*#__PURE__*/ (0, $54dlf.jsx)((0, $59fb50fb2c8e26e9$export$2e2bcd8739ae039), {}),
                bookingFlowContext.activeStep === bookingFlowContext.availableSteps.createAccount.index && ((useMockedLogin || loggedInWithActiveProfile) && !forceLogin ? /*#__PURE__*/ (0, $54dlf.jsx)((0, $dlTon.default), {}) : /*#__PURE__*/ (0, $54dlf.jsx)((0, $59fb50fb2c8e26e9$export$2e2bcd8739ae039), {})),
                !pending && bookingFlowContext.activeStep === bookingFlowContext.availableSteps.addVehicle.index && ((useMockedLogin || loggedInWithActiveProfile) && !forceLogin ? /*#__PURE__*/ (0, $54dlf.jsx)((0, $01596d8bca3ec658$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $54dlf.jsx)((0, $59fb50fb2c8e26e9$export$2e2bcd8739ae039), {})),
                bookingFlowContext.activeStep === bookingFlowContext.availableSteps.documentUpload.index && ((useMockedLogin || loggedInWithActiveProfile) && !forceLogin ? /*#__PURE__*/ (0, $54dlf.jsx)((0, $6c78f3709fac6b6d$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $54dlf.jsx)((0, $59fb50fb2c8e26e9$export$2e2bcd8739ae039), {})),
                bookingFlowContext.activeStep === bookingFlowContext.availableSteps.orderOverview.index && ((useMockedLogin || loggedInWithActiveProfile) && !forceLogin ? /*#__PURE__*/ (0, $54dlf.jsx)((0, $7b1738e81741b9cb$export$2e2bcd8739ae039), {
                    currentQuoteSessionKey: currentQuoteSessionKey,
                    setCurrentQuoteSessionKey: setCurrentQuoteSessionKey
                }) : /*#__PURE__*/ (0, $54dlf.jsx)((0, $59fb50fb2c8e26e9$export$2e2bcd8739ae039), {})),
                bookingFlowContext.activeStep === bookingFlowContext.availableSteps.orderConfirmation.index && ((useMockedLogin || loggedInWithActiveProfile) && !forceLogin ? /*#__PURE__*/ (0, $54dlf.jsx)((0, $127a1a552a1070b9$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $54dlf.jsx)((0, $59fb50fb2c8e26e9$export$2e2bcd8739ae039), {})),
                /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                    className: "facilitypage__lockedpmc hidden",
                    children: /*#__PURE__*/ (0, $54dlf.jsxs)("section", {
                        className: "facilitypage__lockedpmc__inner",
                        children: [
                            /*#__PURE__*/ (0, $54dlf.jsxs)("header", {
                                children: [
                                    /*#__PURE__*/ (0, $54dlf.jsx)("h3", {
                                        className: "facilitypage__lockedpmc__heading",
                                        children: "Locked Product"
                                    }),
                                    /*#__PURE__*/ (0, $54dlf.jsx)("button", {
                                        className: "facilitypage__lockedpmc__close",
                                        "aria-label": "Close"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $54dlf.jsxs)("main", {
                                children: [
                                    /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                                        className: "facilitypage__lockedpmc__description_container",
                                        children: /*#__PURE__*/ (0, $54dlf.jsx)("h4", {
                                            className: "facilitypage__lockedpmc__description",
                                            children: "Enter your unlock code to continue"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $54dlf.jsx)("div", {
                                        className: "main popup__form-content",
                                        "data-app-container": "true"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    };
    function init() {
        (0, (/*@__PURE__*/$parcel$interopDefault($bUNms))).render(/*#__PURE__*/ (0, $54dlf.jsx)((0, $8oRQh.BookingFlowContextProvider), {
            appConfig: appConfig,
            children: /*#__PURE__*/ (0, $54dlf.jsx)(App, {})
        }), appContainer);
    }
    return {
        init: init
    };
}
(0, $jQtCH.default).add("booking-flow-page", $d41b026deaa7b4e1$var$bookingFlowPage);




//# sourceMappingURL=bookingflow.js.map
